import * as React from 'react';
import React__default, { useRef, useEffect, useMemo as useMemo$1, useCallback as useCallback$1, useReducer, createContext, useContext, useState, useLayoutEffect } from 'react';
import { noI18nI18n, ButtonKind, ButtonType, SpsIcon, SpinnerSize, Position, ZStratum, SpsOptionListOption, DropdownKind, SPS_ACTION_DEFAULTS, ClickableTagKind, TagKind, SpsIconSize, SelectMode, TooltipKind, TooltipShowTrigger, TOOLTIP_HIDE_DELAY_MS_DEFAULT, FeedbackBlockKind, FeedbackBlockIcons, GrowlerKind, GrowlerIcon, GROWLER_VISIBLE_DURATION_MS, GROWLER_FADEOUT_DURATION_MS, SpsInsightTileKind, SpsInsightTileIcons, KeyValueListTitleColor, SortDirection, ModalKind, ModalSize, DEFAULT_PAGE_SIZE_OPTIONS, SteppedProgressBarColor, StdButtonKind, SpsTaskStatus, TASK_QUEUE_NOTIFICATION_DURATION_MS, SpsTaskStatusIcons, SpsFilterTileKind, RingSize, WizardSubstepConditions } from '@spscommerce/ds-shared';
import { values as values$3, code, deepFreeze, setPath, diff, DiffChange, getPath, debounce, flatten, crumblePath, traversePath, forEachNestedObject, lockToAnimationFrames, constrain } from '@spscommerce/utils';
import require$$0 from 'crypto';
import * as moment$6 from 'moment-timezone';
import moment__default from 'moment-timezone';
import * as ReactDOM from 'react-dom';
import { createPortal, unstable_batchedUpdates } from 'react-dom';
import { PositioningService, Position as Position$1 } from '@spscommerce/positioning';
import { colors } from '@spscommerce/ds-colors';

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var propTypes$1H = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e$1=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n$1=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r$1=b?Symbol.for("react.memo"):60115,t$1=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e$1:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n$1:case t$1:case r$1:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n$1;reactIs_production_min.Fragment=e$1;reactIs_production_min.Lazy=t$1;reactIs_production_min.Memo=r$1;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n$1};reactIs_production_min.isFragment=function(a){return z(a)===e$1};reactIs_production_min.isLazy=function(a){return z(a)===t$1};
reactIs_production_min.isMemo=function(a){return z(a)===r$1};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$1||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n$1||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject$2(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject$2(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$2.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$3(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$1.exports;
var assign$2 = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign$2({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$1H.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$1H.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes$1H.exports;

function deprecated(type) {
    return type;
}
function enumValue(e) {
    return propTypes$1H.exports.oneOf(values$3(e));
}
function fun() {
    return propTypes$1H.exports.func;
}
function impl() {
    return propTypes$1H.exports.object;
}
function ref() {
    return propTypes$1H.exports.object;
}
var nodeOrRenderFn = propTypes$1H.exports.oneOfType([propTypes$1H.exports.node, propTypes$1H.exports.func]);
var spsGlobalPropTypes = {
    children: propTypes$1H.exports.oneOfType([propTypes$1H.exports.arrayOf(propTypes$1H.exports.node), propTypes$1H.exports.node]),
    className: propTypes$1H.exports.string,
    "data-testid": propTypes$1H.exports.string,
    unsafelyReplaceClassName: propTypes$1H.exports.string,
};

var I18nContext = React.createContext(noI18nI18n);

var __assign$1W = (undefined && undefined.__assign) || function () {
    __assign$1W = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1W.apply(this, arguments);
};
var __rest$1x = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1C = {
    disabled: "boolean",
    href: "string",
    icon: "SpsIcon",
    kind: "ButtonKind",
    spinning: "boolean",
    spinningTitle: "string",
    type: "ButtonType",
};
var propTypes$1G = __assign$1W(__assign$1W({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, href: propTypes$1H.exports.string, icon: enumValue(SpsIcon), kind: enumValue(ButtonKind), spinning: propTypes$1H.exports.bool, spinningTitle: propTypes$1H.exports.string, type: enumValue(ButtonType) });
function SpsButton(props) {
    var children = props.children, className = props.className, href = props.href, icon = props.icon, _a = props.kind, kind = _a === void 0 ? ButtonKind.DEFAULT : _a, spinning = props.spinning, spinningTitle = props.spinningTitle, _b = props.type, type = _b === void 0 ? ButtonType.BUTTON : _b, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1x(props, ["children", "className", "href", "icon", "kind", "spinning", "spinningTitle", "type", "unsafelyReplaceClassName"]);
    var disabled = props.disabled;
    if (spinning) {
        disabled = true;
    }
    var t = React.useContext(I18nContext).t;
    var classes = clsx(unsafelyReplaceClassName || "sps-button", "sps-button--" + kind, disabled && "sps-button--disabled", spinning && "sps-button--spinning", className);
    var iconElement = icon && React.createElement("i", { className: clsx("sps-icon", "sps-icon-" + icon), "aria-hidden": "true" });
    var spinner = (React.createElement("div", { className: "sps-spinner" }, spinningTitle || t("design-system:button.spinningTitle")));
    return (React.createElement("div", { className: classes }, href ? (React.createElement("a", __assign$1W({}, rest, { href: href, className: "sps-button__clickable-element" }),
        iconElement,
        children,
        spinner)) : (React.createElement("button", __assign$1W({}, rest, { 
        /**
         * eslint wants type to be ONLY a string or a ternary with strings for both
         * branches, but this is a generic button component. we NEED it to be a prop.
         */
        /* eslint-disable-next-line react/button-has-type */
        type: type, className: "sps-button__clickable-element", disabled: disabled }),
        iconElement,
        children,
        spinner))));
}
Object.assign(SpsButton, {
    props: propsDoc$1C,
    propTypes: propTypes$1G,
    displayName: "SpsButton",
});

var __assign$1V = (undefined && undefined.__assign) || function () {
    __assign$1V = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1V.apply(this, arguments);
};
var __rest$1w = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var spsFormProps = {
    formMeta: "SpsFormSetMeta<any>",
    onSubmit: "React.FormEventHandler",
};
var spsFormPropTypes = __assign$1V(__assign$1V({}, spsGlobalPropTypes), { formArray: impl(), formGroup: impl(), formMeta: impl(), onSubmit: fun() });
var SpsForm = React.forwardRef(function (props, ref) {
    var children = props.children, onSubmit = props.onSubmit, formArray = props.formArray, formGroup = props.formGroup, formMeta = props.formMeta, rest = __rest$1w(props, ["children", "onSubmit", "formArray", "formGroup", "formMeta"]);
    var form = formGroup || formArray;
    function handleSubmit(event) {
        event.preventDefault();
        if (form) {
            form.markAsDirty();
        }
        if (formMeta) {
            formMeta.markAsDirty();
            formMeta.markAsBlurred();
        }
        onSubmit(event);
    }
    return (React.createElement("form", __assign$1V({ ref: ref, onSubmit: handleSubmit }, rest), children));
});
Object.assign(SpsForm, {
    props: spsFormProps,
    propTypes: spsFormPropTypes,
    displayName: "SpsForm",
});

function contentOf(nodeOrRenderFn) {
    return typeof nodeOrRenderFn === "function"
        ? nodeOrRenderFn()
        : nodeOrRenderFn;
}

var __assign$1U = (undefined && undefined.__assign) || function () {
    __assign$1U = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1U.apply(this, arguments);
};
var __rest$1v = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1B = __assign$1U(__assign$1U({}, spsFormProps), { controlsDisabled: "boolean", footerLinks: "ReactNodeOrRenderFn", formMeta: "SpsFormArrayMeta<any> | SpsFormGroupMeta<any>", isOpen: "boolean", onClear: "() => void", onSubmit: "React.FormEventHandler" });
var propTypes$1F = __assign$1U(__assign$1U(__assign$1U({}, spsGlobalPropTypes), spsFormPropTypes), { controlsDisabled: propTypes$1H.exports.bool, footerLinks: nodeOrRenderFn, formArray: impl(), formGroup: impl(), formMeta: propTypes$1H.exports.oneOfType([
        impl(), impl(),
    ]), isOpen: propTypes$1H.exports.bool, onClear: fun(), onSubmit: fun() });
function SpsAdvancedSearch(props) {
    var children = props.children, className = props.className, controlsDisabled = props.controlsDisabled, footerLinks = props.footerLinks, formArray = props.formArray, formGroup = props.formGroup, formMeta = props.formMeta, isOpen = props.isOpen, onClear = props.onClear, onSubmit = props.onSubmit, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1v(props, ["children", "className", "controlsDisabled", "footerLinks", "formArray", "formGroup", "formMeta", "isOpen", "onClear", "onSubmit", "unsafelyReplaceClassName"]);
    var t = React.useContext(I18nContext).t;
    function handleClear() {
        if (onClear) {
            onClear();
        }
    }
    var toolbarClass = clsx(unsafelyReplaceClassName || "sps-advanced-search", isOpen && "sps-advanced-search--open", className);
    return (React.createElement("div", __assign$1U({ className: toolbarClass }, rest),
        React.createElement(SpsForm, { onSubmit: onSubmit, formArray: formArray, formGroup: formGroup, formMeta: formMeta },
            React.createElement("div", { className: "sps-advanced-search__form" }, children),
            React.createElement("div", { className: "sps-advanced-search__footer" },
                footerLinks && React.createElement("div", { id: "footer_links" }, contentOf(footerLinks)),
                React.createElement("div", { className: "sps-advanced-search__footer-controls" },
                    React.createElement(SpsButton, { kind: ButtonKind.DEFAULT, type: ButtonType.BUTTON, className: "mr-2", onClick: handleClear, disabled: controlsDisabled }, t("design-system:advancedSearch.clear")),
                    React.createElement(SpsButton, { kind: ButtonKind.KEY, type: ButtonType.SUBMIT, disabled: controlsDisabled }, t("design-system:advancedSearch.search")))))));
}
Object.assign(SpsAdvancedSearch, {
    props: propsDoc$1B,
    propTypes: propTypes$1F,
    displayName: "SpsAdvancedSearch",
});

var __makeTemplateObject$W = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsAdvancedSearchExamples = {
    basic: {
        label: "Basic Usage",
        examples: {
            basic: {
                react: code(templateObject_1$W || (templateObject_1$W = __makeTemplateObject$W(["\n                    function Component(props) {\n                        const [toolbarSearchText, setToolbarSearchText] = React.useState(\"\");\n                        const [advSearch, patchAdvSearch] = usePatchReducer({\n                            isOpen: true,\n                            enteredFields: 0,\n                        });\n\n                        const initValue = {\n                            sender: \"\",\n                            receiver: \"\",\n                            doctype: \"\",\n                            status: \"\",\n                        };\n                        const { formValue, formMeta, updateForm } = useSpsForm(initValue);\n\n                        React.useEffect(() => {\n                            // Simulate that someone has entered a search term\n                            updateForm({\n                                ...formValue,\n                                receiver: \"Walmart\"\n                            });\n                            patchAdvSearch({ enteredFields: 1 });\n                        }, []);\n\n                        function handleToolbarSearchChange(event) {\n                            setToolbarSearchText(event.target.value);\n                        }\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            patchAdvSearch({ isOpen });\n                        }\n\n                        function handleAdvancedSearchSubmit() {\n                            patchAdvSearch({ enteredFields: diff(initValue, formValue).length });\n                        }\n\n                        function handleAdvancedSearchClear() {\n                            updateForm(initValue);\n                            patchAdvSearch({ enteredFields: 0 });\n                        }\n\n                        return <>\n                            <SpsListToolbar advancedSearch={advSearch}\n                                onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                            >\n                                <SpsListToolbarSearch>\n                                    <SpsTextInput value={toolbarSearchText}\n                                        onChange={handleToolbarSearchChange}\n                                        disabled={advSearch.isOpen}\n                                        title=\"Search\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON}\n                                        icon={SpsIcon.SEARCH}\n                                        disabled={advSearch.isOpen}\n                                    />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                            <SpsAdvancedSearch {...advSearch}\n                                formMeta={formMeta}\n                                onSubmit={handleAdvancedSearchSubmit}\n                                onClear={handleAdvancedSearchClear}\n                            >\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.sender}>Sender</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.sender}\n                                            value={formValue.sender}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.receiver}>Receiver</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.receiver}\n                                            value={formValue.receiver}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.doctype}>Document Type</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.doctype}\n                                            value={formValue.doctype}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.status}>Status</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.status}\n                                            value={formValue.status}\n                                        />\n                                    </div>\n                                </div>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "], ["\n                    function Component(props) {\n                        const [toolbarSearchText, setToolbarSearchText] = React.useState(\"\");\n                        const [advSearch, patchAdvSearch] = usePatchReducer({\n                            isOpen: true,\n                            enteredFields: 0,\n                        });\n\n                        const initValue = {\n                            sender: \"\",\n                            receiver: \"\",\n                            doctype: \"\",\n                            status: \"\",\n                        };\n                        const { formValue, formMeta, updateForm } = useSpsForm(initValue);\n\n                        React.useEffect(() => {\n                            // Simulate that someone has entered a search term\n                            updateForm({\n                                ...formValue,\n                                receiver: \"Walmart\"\n                            });\n                            patchAdvSearch({ enteredFields: 1 });\n                        }, []);\n\n                        function handleToolbarSearchChange(event) {\n                            setToolbarSearchText(event.target.value);\n                        }\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            patchAdvSearch({ isOpen });\n                        }\n\n                        function handleAdvancedSearchSubmit() {\n                            patchAdvSearch({ enteredFields: diff(initValue, formValue).length });\n                        }\n\n                        function handleAdvancedSearchClear() {\n                            updateForm(initValue);\n                            patchAdvSearch({ enteredFields: 0 });\n                        }\n\n                        return <>\n                            <SpsListToolbar advancedSearch={advSearch}\n                                onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                            >\n                                <SpsListToolbarSearch>\n                                    <SpsTextInput value={toolbarSearchText}\n                                        onChange={handleToolbarSearchChange}\n                                        disabled={advSearch.isOpen}\n                                        title=\"Search\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON}\n                                        icon={SpsIcon.SEARCH}\n                                        disabled={advSearch.isOpen}\n                                    />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                            <SpsAdvancedSearch {...advSearch}\n                                formMeta={formMeta}\n                                onSubmit={handleAdvancedSearchSubmit}\n                                onClear={handleAdvancedSearchClear}\n                            >\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.sender}>Sender</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.sender}\n                                            value={formValue.sender}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.receiver}>Receiver</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.receiver}\n                                            value={formValue.receiver}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.doctype}>Document Type</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.doctype}\n                                            value={formValue.doctype}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.status}>Status</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.status}\n                                            value={formValue.status}\n                                        />\n                                    </div>\n                                </div>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    b_disabledButtons: {
        label: "Disabling the Clear/Search Buttons",
        examples: {
            disabledButtons: {
                react: code(templateObject_2$Q || (templateObject_2$Q = __makeTemplateObject$W(["\n                    function Component() {\n                        const [advSearch, setAdvSearch] = React.useState({\n                            isOpen: true,\n                            controlsDisabled: true,\n                        });\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            setAdvSearch({ isOpen });\n                        }\n\n                        return <>\n                            <SpsListToolbar advancedSearch={advSearch}\n                                onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                            >\n                                <SpsListToolbarSearch>\n                                    <i>quick search goes here</i>\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                            <SpsAdvancedSearch {...advSearch}>\n                                <i>insert form here</i>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [advSearch, setAdvSearch] = React.useState({\n                            isOpen: true,\n                            controlsDisabled: true,\n                        });\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            setAdvSearch({ isOpen });\n                        }\n\n                        return <>\n                            <SpsListToolbar advancedSearch={advSearch}\n                                onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                            >\n                                <SpsListToolbarSearch>\n                                    <i>quick search goes here</i>\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                            <SpsAdvancedSearch {...advSearch}>\n                                <i>insert form here</i>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    c_footerLink: {
        label: "Footer Link",
        description: code(templateObject_3$H || (templateObject_3$H = __makeTemplateObject$W(["\n            <p>Some applications have a need to add a link button to the footer\n            as directed by the product design team.</p>\n        "], ["\n            <p>Some applications have a need to add a link button to the footer\n            as directed by the product design team.</p>\n        "]))),
        examples: {
            footerLink: {
                react: code(templateObject_4$z || (templateObject_4$z = __makeTemplateObject$W(["\n                    function Component(props) {\n                        const [advSearch, setAdvSearch] = React.useState({\n                            isOpen: true\n                        });\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            setAdvSearch({ isOpen });\n                        }\n\n                        return <>\n                            <SpsListToolbar advancedSearch={advSearch}\n                                onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                            >\n                                <SpsListToolbarSearch>\n                                    <i>quick search goes here</i>\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                            <SpsAdvancedSearch {...advSearch}\n                                footerLinks={\n                                    <SpsButton kind={ButtonKind.LINK} icon={SpsIcon.GEAR}>\n                                        Advanced Search Defaults\n                                    </SpsButton>\n                                }\n                            >\n                                <i>insert form here</i>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "], ["\n                    function Component(props) {\n                        const [advSearch, setAdvSearch] = React.useState({\n                            isOpen: true\n                        });\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            setAdvSearch({ isOpen });\n                        }\n\n                        return <>\n                            <SpsListToolbar advancedSearch={advSearch}\n                                onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                            >\n                                <SpsListToolbarSearch>\n                                    <i>quick search goes here</i>\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                            <SpsAdvancedSearch {...advSearch}\n                                footerLinks={\n                                    <SpsButton kind={ButtonKind.LINK} icon={SpsIcon.GEAR}>\n                                        Advanced Search Defaults\n                                    </SpsButton>\n                                }\n                            >\n                                <i>insert form here</i>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    d_withTitle: {
        label: "Title Bar With No List Toolbar Search",
        description: code(templateObject_5$q || (templateObject_5$q = __makeTemplateObject$W(["\n            <p>If you do not provide a search within the List Toolbar, then it will\n            act as a title bar and the Advanced Search will not be togglable.</p>\n        "], ["\n            <p>If you do not provide a search within the List Toolbar, then it will\n            act as a title bar and the Advanced Search will not be togglable.</p>\n        "]))),
        examples: {
            withTitle: {
                react: code(templateObject_6$k || (templateObject_6$k = __makeTemplateObject$W(["\n                    function Component(props) {\n                        const [advSearch, patchAdvSearch] = usePatchReducer({\n                            isOpen: true,\n                        });\n\n                        return <>\n                            <SpsListToolbar title=\"Advanced Search\"\n                                advancedSearch={advSearch}\n                            />\n                            <SpsAdvancedSearch isOpen={advSearch.isOpen}>\n                                <i>insert form here</i>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "], ["\n                    function Component(props) {\n                        const [advSearch, patchAdvSearch] = usePatchReducer({\n                            isOpen: true,\n                        });\n\n                        return <>\n                            <SpsListToolbar title=\"Advanced Search\"\n                                advancedSearch={advSearch}\n                            />\n                            <SpsAdvancedSearch isOpen={advSearch.isOpen}>\n                                <i>insert form here</i>\n                            </SpsAdvancedSearch>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$W, templateObject_2$Q, templateObject_3$H, templateObject_4$z, templateObject_5$q, templateObject_6$k;

var random$1 = {exports: {}};

var crypto = require$$0;

if (crypto.randomFillSync) {
  // We reuse buffers with the same size to avoid memory fragmentations
  // for better performance
  var buffers = { };
  random$1.exports = function (bytes) {
    var buffer = buffers[bytes];
    if (!buffer) {
      // `Buffer.allocUnsafe()` faster because it don’t clean memory.
      // We do not need it, since we will fill memory with new bytes anyway.
      buffer = Buffer.allocUnsafe(bytes);
      if (bytes <= 255) buffers[bytes] = buffer;
    }
    return crypto.randomFillSync(buffer)
  };
} else {
  random$1.exports = crypto.randomBytes;
}

// This alphabet uses a-z A-Z 0-9 _- symbols.
// Despite the fact the source code is quite long, its entropy
// is low and there are lots of duplicates - just what compressors
// like GZIP and Brotli likes the best.

/**
 * URL safe symbols.
 *
 * @name url
 * @type {string}
 *
 * @example
 * const url = require('nanoid/url')
 * generate(url, 10) //=> "Uakgb_J5m9"
 */

// This alphabet uses a-z A-Z 0-9 _- symbols.
// Symbols are generated for smaller size.
// -_zyxwvutsrqponmlkjihgfedcba9876543210ZYXWVUTSRQPONMLKJIHGFEDCBA
var url$1 = '-_';
var i = 36;
while (i--) {
  // 36 is radix. Number.prototype.toString(36) returns number
  // in Base36 representation. Base36 is like hex, but it uses 0–9 and a-z.
  url$1 += i.toString(36);
  i > 9 && (url$1 += i.toString(36).toUpperCase());
}

var random = random$1.exports;
var url = url$1;

/**
 * Generate secure URL-friendly unique ID.
 *
 * By default, ID will have 21 symbols to have a collision probability similar
 * to UUID v4.
 *
 * @param {number} [size=21] The number of symbols in ID.
 *
 * @return {string} Random string.
 *
 * @example
 * const nanoid = require('nanoid')
 * model.id = nanoid() //=> "Uakgb_J5m9g-0JDMbcJqL"
 *
 * @name nanoid
 * @function
 */
var nanoid = function (size) {
  size = size || 21;
  var bytes = random(size);
  var id = '';
  // Compact alternative for `for (var i = 0; i < size; i++)`
  while (size--) {
    // We can’t use bytes bigger than the alphabet. 63 is 00111111 bitmask.
    // This mask reduces random byte 0-255 to 0-63 values.
    // There is no need in `|| ''` and `* 1.6` hacks in here,
    // because bitmask trim bytes exact to alphabet size.
    id += url[bytes[size] & 63];
  }
  return id
};

var nanoid$1 = nanoid;

function useElementId(id) {
    return useRef(id || nanoid$1());
}

function useFormControlId(id, formControl) {
    var wrapperId = useElementId(id);
    var controlId = useRef(wrapperId.current + "_ctrl");
    useEffect(function () {
        if (formControl) {
            /* eslint-disable-next-line no-param-reassign */
            formControl.id = controlId.current;
            formControl.update();
        }
    }, [formControl]);
    return {
        wrapperId: wrapperId.current,
        controlId: controlId.current,
    };
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$2(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$1.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

var lodash_isplainobject = isPlainObject$2;

var OnBlurErrorKeys = new Set();
var AsTypingErrorKeys = new Set();
var PreventativeErrorKeys = new Set();

var __assign$1T = (undefined && undefined.__assign) || function () {
    __assign$1T = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1T.apply(this, arguments);
};
var __read$_ = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var moment$5 = moment$6.default || moment$6;
var FORMAT = "MM/DD/YYYY";
var FORMAT_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
var SYMBOL_DATE_PARSE_ERROR = Symbol("Date Parse Error");
function isoNumberifiedDate(date) {
    return date.year * 10000 + date.month * 100 + date.date;
}
var SimpleDateUtils = Object.freeze({
    createFrom: function (input) {
        var _a;
        if (!input) {
            return null;
        }
        if (typeof input === "string") {
            var match = FORMAT_PATTERN.exec(input);
            if (match) {
                var _b = __read$_(match, 4), m = _b[1], d = _b[2], y = _b[3];
                return Object.freeze({
                    year: Number(y),
                    month: Number(m),
                    date: Number(d),
                });
            }
            return Object.freeze((_a = {},
                _a[SYMBOL_DATE_PARSE_ERROR] = true,
                _a.year = undefined,
                _a.month = undefined,
                _a.date = undefined,
                _a));
        }
        return Object.freeze({
            year: input.year(),
            month: input.month() + 1,
            date: input.date(),
        });
    },
    createRangeFrom: function (input) {
        if (!input) {
            return null;
        }
        return input.split(/[^\d]*-[^\d]*/).map(SimpleDateUtils.createFrom);
    },
    isValid: function (date) {
        return date
            && typeof date === "object"
            && typeof date.year === "number"
            && typeof date.month === "number"
            && typeof date.date === "number"
            && SimpleDateUtils.toMoment(date).isValid();
    },
    nullifyInvalidDate: function (value) {
        return SimpleDateUtils.isValid(value)
            ? value
            : null;
    },
    toMoment: function (date) {
        if (!date) {
            return null;
        }
        return moment$5(__assign$1T(__assign$1T({}, date), { 
            // month is zero-indexed for moment whereas SimpleDate is designed for humans
            month: date.month - 1 }));
    },
    toString: function (date) {
        var dateMoment = SimpleDateUtils.toMoment(date);
        return dateMoment ? dateMoment.format(FORMAT) : "";
    },
    toStringRange: function (dateRange) {
        if (!dateRange) {
            return "";
        }
        return dateRange.map(SimpleDateUtils.toString).join("-");
    },
    create: function () {
        var d = new Date();
        return Object.freeze({
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            date: d.getDate(),
        });
    },
    isSameDate: function (d1, d2) {
        return d1 && d2
            && d1.year === d2.year
            && d1.month === d2.month
            && d1.date === d2.date;
    },
    isSameMonth: function (d1, d2) {
        return d1 && d2
            && d1.year === d2.year
            && d1.month === d2.month;
    },
    isAfter: function (date, referenceDate) {
        if (!date || !referenceDate) {
            return null;
        }
        return isoNumberifiedDate(date) > isoNumberifiedDate(referenceDate);
    },
    isBefore: function (date, referenceDate) {
        if (!date || !referenceDate) {
            return null;
        }
        return isoNumberifiedDate(date) < isoNumberifiedDate(referenceDate);
    },
    isInRange: function (date, range, inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        if (!date || !range || !range[0] || !range[1]) {
            return null;
        }
        var dateNum = isoNumberifiedDate(date);
        var _a = __read$_(range.map(isoNumberifiedDate), 2), start = _a[0], end = _a[1];
        return (date
            && start
            && end
            && ((inclusive && dateNum >= start && dateNum <= end)
                || (!inclusive && dateNum > start && dateNum < end)));
    },
    prevMonth: function (date) {
        return Object.freeze({
            year: date.month === 1 ? date.year - 1 : date.year,
            month: date.month - 1 || 12,
            date: date.date,
        });
    },
    nextMonth: function (date) {
        return Object.freeze({
            year: date.month === 12 ? date.year + 1 : date.year,
            month: date.month + 1 > 12 ? 1 : date.month + 1,
            date: date.date,
        });
    },
    createRangeFromPreset: function (preset) {
        if (typeof preset.definition === "function") {
            return preset.definition();
        }
        var end = moment$5();
        var start = end.clone().subtract(moment$5.duration(preset.definition));
        return [SimpleDateUtils.createFrom(start), SimpleDateUtils.createFrom(end)];
    },
});

var date = function dateValidator(value) {
    if (Array.isArray(value)) {
        var startErrs = date(value[0]);
        var endErrs = date(value[1]);
        return startErrs || endErrs;
    }
    if (value && value.hasOwnProperty("year")) {
        if (value[SYMBOL_DATE_PARSE_ERROR]) {
            return { dateFormat: FORMAT };
        }
        if (!SimpleDateUtils.isValid(value)) {
            return { dateValidity: true };
        }
    }
    return null;
};
OnBlurErrorKeys.add("dateFormat");
OnBlurErrorKeys.add("dateValidity");
var dateRange = function dateRangeValidator(value) {
    if (Array.isArray(value)) {
        var dateValidatorResult = date(value);
        if (dateValidatorResult) {
            return dateValidatorResult;
        }
        if (value && SimpleDateUtils.isBefore(value[1], value[0])) {
            return { dateRangeOrder: true };
        }
    }
    return null;
};
OnBlurErrorKeys.add("dateRangeOrder");
var dateConstraint = function dateConstraintValidatorFactory(_a) {
    var minDate = _a.minDate, maxDate = _a.maxDate;
    function validateDate(dateToValidate) {
        var minExceeded = SimpleDateUtils.isBefore(dateToValidate, minDate);
        var maxExceeded = SimpleDateUtils.isAfter(dateToValidate, maxDate);
        var errorDetails = {
            minExceeded: minExceeded
                ? SimpleDateUtils.toString(minDate)
                : null,
            maxExceeded: maxExceeded
                ? SimpleDateUtils.toString(maxDate)
                : null,
        };
        return minExceeded || maxExceeded
            ? { dateConstraint: errorDetails }
            : null;
    }
    return function dateConstraintValidator(value) {
        if (!value) {
            return null;
        }
        if (Array.isArray(value)) {
            var startErrs = validateDate(value[0]);
            var endErrs = validateDate(value[1]);
            return startErrs || endErrs;
        }
        if (value.hasOwnProperty("year")) {
            return validateDate(value);
        }
        return null;
    };
};
OnBlurErrorKeys.add("dateConstraint");

var dateValidators = /*#__PURE__*/Object.freeze({
	__proto__: null,
	date: date,
	dateRange: dateRange,
	dateConstraint: dateConstraint
});

var __assign$1S = (undefined && undefined.__assign) || function () {
    __assign$1S = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1S.apply(this, arguments);
};
var min$2 = function minValidatorFactory(minimumValue) {
    return function minValidator(value) {
        return Number(value) >= minimumValue
            ? null
            : { min: minimumValue };
    };
};
OnBlurErrorKeys.add("min");
var max$1 = function maxValidatorFactory(maximumValue) {
    return function (value) { return (Number(value) <= maximumValue
        ? null
        : { max: maximumValue }); };
};
AsTypingErrorKeys.add("max");
var required = function requiredValidator(value) {
    return typeof value === "undefined" || value === null || value === "" || Number.isNaN(value) || (value === null || value === void 0 ? void 0 : value.length) === 0
        ? { required: true }
        : null;
};
AsTypingErrorKeys.add("required");
var minLength = function minLengthValidatorFactory(minimumLength) {
    return function minLengthValidator(value) {
        return value.length >= minimumLength
            ? null
            : { minLength: minimumLength };
    };
};
OnBlurErrorKeys.add("minLength");
var maxLength = function maxLengthValidatorFactory(maximumLength) {
    return function maxLengthValidator(value) {
        return value.length <= maximumLength
            ? null
            : { maxLength: maximumLength };
    };
};
PreventativeErrorKeys.add("maxLength");
var pattern = function patternValidatorFactory(validationPattern) {
    var regex = validationPattern instanceof RegExp
        ? validationPattern
        : new RegExp(validationPattern);
    return function patternValidator(value) {
        return regex.test(value)
            ? null
            : { pattern: validationPattern };
    };
};
OnBlurErrorKeys.add("pattern");
var alpha = function alphaValidator(value) {
    /*
     * TODO: change regex to /^\p{L}*$/u once IE11 support
     * is dropped, to match letters in all languages
     */
    return /^[A-Za-z]*$/.test(value)
        ? null
        : { alpha: true };
};
PreventativeErrorKeys.add("alpha");
var numeric = function numericValidator(value) {
    return /^[0-9,. ]*$/.test(value)
        ? null
        : { numeric: true };
};
PreventativeErrorKeys.add("numeric");
var nonNumeric = function nonNumericValidator(value) {
    return /^[^0-9]*$/.test(value)
        ? null
        : { nonNumeric: true };
};
PreventativeErrorKeys.add("nonNumeric");
var SpsValidators = Object.freeze(__assign$1S(__assign$1S({}, dateValidators), { min: min$2, max: max$1, required: required, minLength: minLength, maxLength: maxLength, pattern: pattern, alpha: alpha, numeric: numeric, nonNumeric: nonNumeric, OnBlurErrorKeys: OnBlurErrorKeys }));

function validate(value, validators) {
    if (validators === void 0) { validators = []; }
    var reduced = validators.reduce(function (errs, validator) { return Object.assign(errs, validator(value) || {}); }, {});
    return Object.keys(reduced).length ? reduced : null;
}

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read$Z = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$5 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values$a = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Base class for all form metadata structures: controls, groups, and arrays
var SpsFormMetaBase = /** @class */ (function () {
    function SpsFormMetaBase(path, update) {
        this.path = path;
        this.update = update;
        this.validators = [];
        this.errors = null;
        this.revealAllErrors = false;
        this.preventativeErrors = [];
    }
    SpsFormMetaBase.prototype.setValidators = function (newValidators) {
        this.validators = newValidators;
        this.update(null);
        return this;
    };
    SpsFormMetaBase.prototype.validate = function (newValue) {
        if (this.validators && this.validators.length > 0) {
            this.errors = validate(newValue, this.validators);
            this.update(null);
            if (this.isFocused() && this.onFocus) {
                this.onFocus();
            }
        }
        else if (this.errors) {
            this.errors = null;
            this.update(null);
        }
        return this;
    };
    SpsFormMetaBase.prototype.isValid = function () {
        return !this.errors || this.isPristine();
    };
    SpsFormMetaBase.prototype.isVisibilyInvalid = function () {
        return this.errors && (this.revealAllErrors ||
            (!this.isPristine()
                && Object.keys(this.errors).some(function (key) { return AsTypingErrorKeys.has(key); })));
    };
    SpsFormMetaBase.prototype.hasError = function (errorKey) {
        return this.errors && Object.prototype.hasOwnProperty.call(this.errors, errorKey);
    };
    SpsFormMetaBase.prototype.hasPreventativeError = function (errorKey) {
        return this.preventativeErrors.includes(errorKey);
    };
    SpsFormMetaBase.prototype.hasPreventativeErrors = function () {
        return this.preventativeErrors.length > 0;
    };
    SpsFormMetaBase.prototype.isRequired = function () {
        return this.validators && this.validators.indexOf(SpsValidators.required) > -1;
    };
    SpsFormMetaBase.prototype.onFocus = function () { }; // eslint-disable-line class-methods-use-this
    SpsFormMetaBase.prototype.onBlur = function () { }; // eslint-disable-line class-methods-use-this
    return SpsFormMetaBase;
}());
// Metadata for an individual control such as a text input or checkbox
var SpsFormFieldMeta = /** @class */ (function (_super) {
    __extends(SpsFormFieldMeta, _super);
    function SpsFormFieldMeta() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = nanoid$1();
        _this.focused = false;
        _this.pristine = true;
        return _this;
    }
    SpsFormFieldMeta.prototype.setValue = function (newValue) {
        this.revealAllErrors = false;
        this.preventativeErrors = [];
        if (this.validators && this.validators.length > 0) {
            var errors = validate(newValue, this.validators);
            if (errors) {
                var currentPreventativeErrors = Object.keys(errors)
                    .filter(function (key) { return PreventativeErrorKeys.has(key); });
                if (currentPreventativeErrors.length > 0) {
                    this.preventativeErrors = Object.keys(errors);
                    return;
                }
            }
        }
        this.update(this.path, newValue);
    };
    SpsFormFieldMeta.prototype.isPristine = function () {
        return this.pristine;
    };
    SpsFormFieldMeta.prototype.markAsPristine = function () {
        this.pristine = true;
        this.revealAllErrors = false;
        this.update(null);
        return this;
    };
    SpsFormFieldMeta.prototype.markAsDirty = function () {
        this.pristine = false;
        this.update(null);
        return this;
    };
    SpsFormFieldMeta.prototype.isFocused = function () {
        return this.focused;
    };
    SpsFormFieldMeta.prototype.markAsFocused = function () {
        this.focused = true;
        this.update(null);
        if (this.onFocus) {
            this.onFocus();
        }
        return this;
    };
    SpsFormFieldMeta.prototype.markAsBlurred = function () {
        this.update(this.path, null, true);
        if (this.onBlur) {
            this.onBlur();
        }
        this.preventativeErrors = [];
        return this;
    };
    return SpsFormFieldMeta;
}(SpsFormMetaBase));
/*
 * Base class for form metadata structures that contain other form metadata
 * structures: arrays and groups, which have "fields" that can be other
 * form arrays or form groups, or form controls (i.e. any SpsFormMetaBase)
 */
var SpsFormSetMeta = /** @class */ (function (_super) {
    __extends(SpsFormSetMeta, _super);
    function SpsFormSetMeta(inferValOrPath, pathOrUpdate, updateWhenInferring) {
        var _this = this;
        var path = (updateWhenInferring ? pathOrUpdate : inferValOrPath);
        var update = updateWhenInferring || pathOrUpdate;
        _this = _super.call(this, path, update) || this;
        if (updateWhenInferring) {
            _this.inferMembers(inferValOrPath);
        }
        return _this;
    }
    SpsFormSetMeta.prototype.inferSpsControl = function (valueOrControl, key) {
        return inferSpsControl(valueOrControl, __spreadArray$5(__spreadArray$5([], __read$Z(this.path), false), [key], false), this.update);
    };
    SpsFormSetMeta.prototype.rollup = function (methodName) {
        var _this = this;
        return Object.keys(this.fields).reduce(function (acc, key) { return acc && (!_this.fields[key][methodName] || _this.fields[key][methodName]()); }, true);
    };
    SpsFormSetMeta.prototype.isFocused = function () {
        return _super.prototype.isFocused.call(this) || this.rollup("isFocused");
    };
    SpsFormSetMeta.prototype.isValid = function () {
        return _super.prototype.isValid.call(this) && this.rollup("isValid");
    };
    SpsFormSetMeta.prototype.contentsAreValid = function () {
        /*
         * The distinction between "isValid" and "contentsAreValid" is that a form group
         * or form array can have a validator attached, which means the group/array in and
         * of itself has a validation status and associated errors. That is "isValid" for
         * a group/array, the same as for a control.
         */
        return this.rollup("isValid") && this.rollup("contentsAreValid");
    };
    SpsFormSetMeta.prototype.isPristine = function () {
        return _super.prototype.isPristine.call(this) && this.rollup("isPristine");
    };
    SpsFormSetMeta.prototype.markAsPristine = function () {
        var e_1, _a;
        _super.prototype.markAsPristine.call(this);
        try {
            for (var _b = __values$a(Object.keys(this.fields)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                this.fields[key].markAsPristine();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this;
    };
    SpsFormSetMeta.prototype.markAsDirty = function () {
        var e_2, _a;
        _super.prototype.markAsDirty.call(this);
        try {
            for (var _b = __values$a(Object.keys(this.fields)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                this.fields[key].markAsDirty();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return this;
    };
    SpsFormSetMeta.prototype.markAsBlurred = function () {
        var e_3, _a;
        _super.prototype.markAsBlurred.call(this);
        try {
            for (var _b = __values$a(Object.keys(this.fields)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                this.fields[key].markAsBlurred();
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return this;
    };
    return SpsFormSetMeta;
}(SpsFormFieldMeta));
/*
 * Ultimately the difference between SpsFormGroupMeta and SpsFormArrayMeta is merely the type
 * of their `fields` property: an object or an array.
 */
var SpsFormGroupMeta = /** @class */ (function (_super) {
    __extends(SpsFormGroupMeta, _super);
    function SpsFormGroupMeta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpsFormGroupMeta.prototype.inferMembers = function (inferFromValue) {
        var e_4, _a;
        this.fields = {};
        try {
            for (var _b = __values$a(Object.keys(inferFromValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                this.fields[key] = this.inferSpsControl(inferFromValue[key], key);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    return SpsFormGroupMeta;
}(SpsFormSetMeta));
var SpsFormArrayMeta = /** @class */ (function (_super) {
    __extends(SpsFormArrayMeta, _super);
    function SpsFormArrayMeta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpsFormArrayMeta.prototype.inferMembers = function (inferFromValue) {
        var _this = this;
        this.fields = (inferFromValue.map(function (item, i) { return _this.inferSpsControl(item, String(i)); }));
    };
    return SpsFormArrayMeta;
}(SpsFormSetMeta));
function inferSpsControl(valueOrControl, path, update) {
    if (valueOrControl instanceof SpsFormMetaBase) {
        valueOrControl.path = path;
        valueOrControl.update = update;
        return valueOrControl;
    }
    if (Array.isArray(valueOrControl)) {
        return new SpsFormArrayMeta(valueOrControl, path, update);
    }
    if (lodash_isplainobject(valueOrControl)) {
        return new SpsFormGroupMeta(valueOrControl, path, update);
    }
    return new SpsFormFieldMeta(path, update);
}
function getMember$1(obj, path) {
    if (path.length === 0) {
        return obj;
    }
    return getMember$1(obj.fields[path[0]], path.slice(1, path.length));
}
function getMembers(obj, path) {
    if (path.length === 0) {
        return [obj];
    }
    var nextPath = path[0];
    path = path.slice(1, path.length);
    if (nextPath === "*") {
        var fieldsArray = Array.isArray(obj.fields)
            ? obj.fields
            : Object.keys(obj.fields).map(function (k) { return obj.fields[k]; });
        if (path.length === 0) {
            return fieldsArray;
        }
        return fieldsArray.reduce(function (arr, member) { return __spreadArray$5(__spreadArray$5([], __read$Z(arr), false), __read$Z(getMembers(member, path)), false); }, []);
    }
    return getMembers(obj.fields[nextPath], path);
}
function validatorMapForEach(formMeta, validatorMap, fn) {
    var e_5, _a, e_6, _b;
    try {
        for (var _c = __values$a(Object.keys(validatorMap)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var path = _d.value;
            var validators = validatorMap[path];
            try {
                for (var _e = (e_6 = void 0, __values$a(getMembers(formMeta, path.split(".")))), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var control = _f.value;
                    fn(control, validators);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_5) throw e_5.error; }
    }
}
function updateValidators(value, formMeta, validatorMap, runValidators) {
    if (runValidators === void 0) { runValidators = false; }
    validatorMapForEach(formMeta, validatorMap, function (control, validators) {
        control.validators = typeof validators === "function"
            ? validators(value)
            : validators;
        if (runValidators) {
            control.errors = validate(getPath(value, control.path), control.validators);
        }
    });
}
function cloneFormValue(value, path) {
    var next = path[0];
    path = path.slice(1);
    if (Array.isArray(value)) {
        return value.map(function (x, i) { return (i === Number(next)
            ? cloneFormValue(x, path)
            : x); });
    }
    if (lodash_isplainobject(value)) {
        return Object.keys(value)
            .reduce(function (acc, key) {
            var _a;
            return Object.assign(acc, (_a = {},
                _a[key] = key === next
                    ? cloneFormValue(value[key], path)
                    : value[key],
                _a));
        }, {});
    }
    return value;
}
function checkFormObject(value) {
    if (typeof value !== "object"
        || value === null
        || Array.isArray(value)) {
        throw new TypeError("The initial value of useSpsForm() hook must be an object.");
    }
}
function useSpsForm(value, validatorMap) {
    checkFormObject(value);
    /*
     * Do the work of instantiating `formMeta` the first time the hook is run and ONLY
     * the first time. Thereafter we will keep it up to date as we go.
     */
    var formMeta = useMemo$1(function () {
        deepFreeze(value);
        var controlSet = inferSpsControl(value, [], update);
        if (validatorMap) {
            updateValidators(value, controlSet, validatorMap, true);
        }
        return controlSet;
    }, []);
    /*
     * Stores a timeout id, used for aggregating `updateForm` calls
     * into a single `useReducer` dispatch per cycle
     */
    var scheduledDispatch = useRef();
    // A stable identity for `reducer` is important to avoid constant re-render thrashing
    var reducer = useCallback$1(function (currentState, action) {
        var e_7, _a, e_8, _b, e_9, _c;
        var newValue;
        scheduledDispatch.current = null;
        if (action) {
            if (action.path) {
                if (action.markAsBlurred) {
                    var control = getMember$1(currentState.formMeta, action.path);
                    control.focused = false;
                    control.revealAllErrors = true;
                }
                else {
                    /*
                     * This branch is used when an SpsFormFieldMeta's value is updated by
                     * its associated component, i.e. when the user interacts with it
                     */
                    newValue = cloneFormValue(currentState.formValue, action.path);
                    setPath(newValue, action.path, action.value);
                }
            }
            else {
                newValue = action.value;
            }
        }
        if (newValue) {
            deepFreeze(newValue);
            var valueDiff = diff(currentState.formValue, newValue);
            try {
                for (var valueDiff_1 = __values$a(valueDiff), valueDiff_1_1 = valueDiff_1.next(); !valueDiff_1_1.done; valueDiff_1_1 = valueDiff_1.next()) {
                    var _d = valueDiff_1_1.value, dType = _d.type, key = _d.key, parentPath = _d.parentPath, _e = __read$Z(_d.objects, 2), oldSubValue = _e[0], newSubValue = _e[1];
                    var meta = getMember$1(currentState.formMeta, parentPath);
                    /*
                     * I don't expect anyone to have symbol properties on their form value;
                     * this is mainly for TypeScript to understand that `key` is a number or string
                     * within this block. And if someone does have a symbol-keyed property, I
                     * don't know what would be going on there and we'll err on the side of not
                     * touching it.
                     */
                    if (typeof key !== "symbol") {
                        /*
                         * Update `formMeta` in sync with new fields
                         * added or fields removed within the value
                         */
                        switch (dType) {
                            case DiffChange.ADDITION:
                                meta.fields[key] = inferSpsControl(newSubValue[key], __spreadArray$5(__spreadArray$5([], __read$Z(parentPath), false), [key], false), update);
                                break;
                            case DiffChange.DELETION:
                                if (Array.isArray(meta.fields)) {
                                    meta.fields.splice(Number(key), 1);
                                }
                                else {
                                    delete meta.fields[key];
                                }
                                break;
                            case DiffChange.ALTERATION:
                                if (!oldSubValue[key]
                                    && newSubValue[key]
                                    && !(meta.fields[key] instanceof SpsFormSetMeta)) {
                                    var newControl = inferSpsControl(newSubValue[key], __spreadArray$5(__spreadArray$5([], __read$Z(parentPath), false), [key], false), update);
                                    if (newControl instanceof SpsFormFieldMeta
                                        && meta.fields[key] instanceof SpsFormFieldMeta) {
                                        newControl.id = meta.fields[key].id;
                                        newControl.focused = meta.fields[key].focused;
                                        newControl.pristine = meta.fields[key].pristine;
                                    }
                                    meta.fields[key] = newControl;
                                }
                                break;
                            default:
                        }
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (valueDiff_1_1 && !valueDiff_1_1.done && (_a = valueDiff_1.return)) _a.call(valueDiff_1);
                }
                finally { if (e_7) throw e_7.error; }
            }
            if (validatorMap) {
                /**
                 * The changes may alter the results of dynamic validator configurations
                 * (i.e. cases where they are defined as a function that returns conditionally
                 * different lists of validators). As well, any items added during the
                 * previous step may be included in a wildcard validator config, and therefore
                 * need their validators added.
                 */
                updateValidators(newValue, currentState.formMeta, validatorMap);
                var alreadyValidated_1 = new Set();
                validatorMapForEach(currentState.formMeta, validatorMap, function (control, validators) {
                    /**
                     * For any control with dynamic validators, its list of validators might
                     * have changed. So re-run validation and keep track of these so we don't
                     * needlessly run them again in the next step.
                     */
                    if (typeof validators === "function") {
                        control.validate(getPath(newValue, control.path));
                        alreadyValidated_1.add(control);
                    }
                });
                try {
                    /**
                     * Targeted validation of changes, excluding things that were already
                     * validated in the previous step
                     */
                    for (var valueDiff_2 = __values$a(valueDiff), valueDiff_2_1 = valueDiff_2.next(); !valueDiff_2_1.done; valueDiff_2_1 = valueDiff_2.next()) {
                        var _f = valueDiff_2_1.value, dType = _f.type, key = _f.key, parentPath = _f.parentPath, _g = __read$Z(_f.objects, 2), newSubValue = _g[1];
                        if (typeof key !== "symbol") {
                            /**
                             * Revalidate each group/array that contains the added,
                             * removed, or altered value
                             */
                            var meta = currentState.formMeta;
                            var subValue = newValue;
                            try {
                                for (var _h = (e_9 = void 0, __values$a(parentPath)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                    var pathPiece = _j.value;
                                    meta = meta.fields[pathPiece];
                                    subValue = subValue[pathPiece];
                                    if (!alreadyValidated_1.has(meta)) {
                                        meta.validate(subValue);
                                    }
                                }
                            }
                            catch (e_9_1) { e_9 = { error: e_9_1 }; }
                            finally {
                                try {
                                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                                }
                                finally { if (e_9) throw e_9.error; }
                            }
                            if (dType === DiffChange.ADDITION || dType === DiffChange.ALTERATION) {
                                // Validate the thing that was added or altered
                                var childMeta = meta.fields[key];
                                if (!alreadyValidated_1.has(childMeta)) {
                                    meta.fields[key].validate(newSubValue[key]);
                                }
                            }
                        }
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (valueDiff_2_1 && !valueDiff_2_1.done && (_b = valueDiff_2.return)) _b.call(valueDiff_2);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
            }
        }
        return {
            formValue: newValue || currentState.formValue,
            formMeta: currentState.formMeta,
            updateForm: currentState.updateForm,
        };
    }, []);
    var _a = __read$Z(useReducer(reducer, { formValue: value, formMeta: formMeta, updateForm: updateForm }), 2), state = _a[0], dispatch = _a[1];
    function update(path, newValue, markAsBlurred) {
        if (markAsBlurred === void 0) { markAsBlurred = false; }
        if (path) {
            dispatch({ path: path, value: newValue, markAsBlurred: markAsBlurred });
        }
        else {
            updateForm();
        }
    }
    function updateForm(newValue) {
        if (newValue) {
            /*
             * For multiple updateForm calls with a new value in the same cycle,
             * use the most recent. (Or have a call with a new value supercede
             * previous calls that did not have a new value.)
             */
            if (scheduledDispatch.current) {
                window.clearTimeout(scheduledDispatch.current);
            }
            var sd = window.setTimeout(dispatch, 0, { value: newValue });
            scheduledDispatch.current = sd;
        }
        else if (!scheduledDispatch.current) {
            /*
             * All updateForm calls *without* a value are the same, so no need
             * to do any superceding; if there's a dispatch scheduled already,
             * then great, that's what we needed. Otherwise get one set up.
             */
            var sd = window.setTimeout(dispatch, 0, {});
            scheduledDispatch.current = sd;
        }
    }
    return state;
}

var __assign$1R = (undefined && undefined.__assign) || function () {
    __assign$1R = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1R.apply(this, arguments);
};
var __rest$1u = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var spsFormComponentWrapperPropTypes = __assign$1R(__assign$1R({}, spsGlobalPropTypes), { focusInputOnClick: propTypes$1H.exports.bool, formMeta: impl(), formControl: impl(), inputRef: ref() });
var SpsFormComponentWrapper = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, focusInputOnClick = props.focusInputOnClick, formControl = props.formControl, formMeta = props.formMeta, inputRefProp = props.inputRef, onClick = props.onClick, rest = __rest$1u(props, ["className", "children", "focusInputOnClick", "formControl", "formMeta", "inputRef", "onClick"]);
    var fallbackRef = React.useRef();
    var rootRef = ref || fallbackRef;
    var inputRef = inputRefProp || rootRef;
    function doFocusInputOnClick() {
        if (inputRef && inputRef !== ref && inputRef.current) {
            inputRef.current.focus();
        }
    }
    function focusInput() {
        if (inputRef && inputRef !== ref && inputRef.current) {
            if (formMeta && formMeta instanceof SpsFormFieldMeta) {
                formMeta.markAsFocused();
            }
        }
    }
    function blurInput() {
        if (inputRef && inputRef !== ref && inputRef.current) {
            if (formMeta && formMeta instanceof SpsFormFieldMeta) {
                formMeta.markAsBlurred();
            }
        }
    }
    var classes = clsx("sps-form-group", ((formControl && formControl.isRequired())
        || (formMeta && formMeta.isRequired())) && "sps-form-group--required", ((formControl && !formControl.isValid())
        || (formMeta && formMeta.isVisibilyInvalid())) && "sps-form-group--error", ((formMeta && formMeta.hasPreventativeErrors())) && "sps-form-group--preventative-error", className);
    function handleOnClick(event) {
        if (focusInputOnClick) {
            doFocusInputOnClick();
        }
        if (onClick) {
            onClick(event);
        }
    }
    return (React.createElement("div", __assign$1R({}, rest, { className: classes, ref: ref, tabIndex: -1, onClick: handleOnClick, onFocus: focusInput, onBlur: blurInput }), children));
});
Object.assign(SpsFormComponentWrapper, {
    spsFormComponentWrapperPropTypes: spsFormComponentWrapperPropTypes,
    displayName: "SpsFormComponentWrapper",
});

function t(t){return "object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return (!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return !1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}function compute(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p);}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else {F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)));}C.push({el:k,top:F,left:G});}return C}

function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions$1(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView$1(target, options) {
  var targetIsDetached = !target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(targetIsDetached ? [] : compute(target, options));
  }

  if (targetIsDetached) {
    return;
  }

  var computeOptions = getOptions$1(options);
  return defaultBehavior(compute(target, computeOptions), computeOptions.behavior);
}

var scrollIntoViewImport = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': scrollIntoView$1
});

var __assign$1Q = (undefined && undefined.__assign) || function () {
    __assign$1Q = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1Q.apply(this, arguments);
};
var __rest$1t = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1A = {
    alt: "string",
    size: "SpinnerSize",
    title: "string",
};
var propTypes$1E = __assign$1Q(__assign$1Q({}, spsGlobalPropTypes), { alt: propTypes$1H.exports.string, size: enumValue(SpinnerSize), title: propTypes$1H.exports.string });
function SpsSpinner(props) {
    var alt = props.alt, className = props.className, _a = props.size, size = _a === void 0 ? SpinnerSize.MEDIUM : _a, testId = props["data-testid"], title = props.title, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1t(props, ["alt", "className", "size", "data-testid", "title", "unsafelyReplaceClassName"]);
    var t = React.useContext(I18nContext).t;
    var altText = alt || title || t("design-system:spinner.defaultAltText");
    var spinnerClasses = clsx(unsafelyReplaceClassName || "sps-spinner", "sps-spinner--" + size, className);
    return (React.createElement("i", __assign$1Q({ className: spinnerClasses, "data-testid": testId, title: altText }, rest)));
}
Object.assign(SpsSpinner, {
    props: propsDoc$1A,
    propTypes: propTypes$1E,
    displayName: "SpsSpinner",
});

var __read$Y = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var NAVBAR_HEIGHT = 60;
function px$1(num) {
    return typeof num === "undefined"
        ? "inherit"
        : num + "px";
}
function flipPosition(position) {
    switch (position) {
        case Position.TOP_LEFT:
            return Position.BOTTOM_LEFT;
        case Position.TOP_MIDDLE:
            return Position.BOTTOM_MIDDLE;
        case Position.TOP_RIGHT:
            return Position.BOTTOM_RIGHT;
        case Position.RIGHT_TOP:
            return Position.LEFT_TOP;
        case Position.RIGHT_MIDDLE:
            return Position.LEFT_MIDDLE;
        case Position.RIGHT_BOTTOM:
            return Position.LEFT_BOTTOM;
        case Position.BOTTOM_RIGHT:
            return Position.TOP_RIGHT;
        case Position.BOTTOM_MIDDLE:
            return Position.TOP_MIDDLE;
        case Position.BOTTOM_LEFT:
            return Position.TOP_LEFT;
        case Position.LEFT_BOTTOM:
            return Position.RIGHT_BOTTOM;
        case Position.LEFT_MIDDLE:
            return Position.RIGHT_MIDDLE;
        case Position.LEFT_TOP:
            return Position.RIGHT_TOP;
        // no default
    }
}
function calculatePosition(position, containerBounds, targetBounds, subjectBounds, resultantWidth, offsets, parentElementRef, fixed) {
    var portalContextElement = parentElementRef && parentElementRef.current;
    var yOffset = portalContextElement
        ? portalContextElement.scrollTop
        : window.pageYOffset;
    var scrollY = fixed
        ? 0
        : yOffset;
    var xOffset = portalContextElement
        ? portalContextElement.scrollLeft
        : window.pageXOffset;
    var scrollX = fixed
        ? 0
        : xOffset;
    var _a = __read$Y(position.split(" "), 2), positionA = _a[0], positionB = _a[1];
    var top;
    var right;
    var bottom;
    var left;
    switch (positionA) {
        case "top":
            bottom = containerBounds.height - targetBounds.top - scrollY - offsets[0];
            break;
        case "left":
            right = containerBounds.width - targetBounds.left - scrollX - offsets[0];
            break;
        case "right":
            left = targetBounds.right + scrollX - offsets[0];
            break;
        case "bottom":
            top = targetBounds.bottom + scrollY - offsets[0];
            break;
        default:
            throw new Error("Invalid position " + position);
    }
    switch (positionB) {
        case "left":
            left = targetBounds.left + scrollX + offsets[1];
            break;
        case "top":
            top = targetBounds.top + scrollY + offsets[1];
            break;
        case "middle":
            if (positionA === "top"
                || positionA === "bottom") {
                left = targetBounds.left
                    + scrollX
                    + (targetBounds.width / 2)
                    - (resultantWidth / 2)
                    + offsets[1];
            }
            else if (positionA === "left"
                || positionA === "right") {
                top = targetBounds.top
                    + scrollY
                    + (targetBounds.height / 2)
                    - (subjectBounds.height / 2)
                    + offsets[1];
            }
            break;
        case "bottom":
            bottom = containerBounds.height - targetBounds.bottom - scrollY + offsets[1];
            break;
        case "right":
            right = containerBounds.width - targetBounds.right - scrollX + offsets[1];
            break;
        default:
            throw new Error("Invalid position " + position);
    }
    return [top,
        right,
        bottom,
        left];
}
function getPosition(subjectRef, targetRef, position, _a) {
    var altPosition = _a.altPosition, _b = _a.setMinWidth, setMinWidth = _b === void 0 ? false : _b, _c = _a.setWidth, setWidth = _c === void 0 ? false : _c, parentElementRef = _a.parentElementRef, _d = _a.fixed, fixed = _d === void 0 ? false : _d, _e = _a.offsets, offsets = _e === void 0 ? [0, 0] : _e;
    if (subjectRef.current && targetRef.current) {
        var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var viewportWidth = document.documentElement.getBoundingClientRect().width;
        var container = parentElementRef && parentElementRef.current
            ? parentElementRef.current : document.documentElement;
        var containerBounds = fixed
            ? {
                width: viewportWidth,
                height: viewportHeight,
                top: 0,
                left: 0,
                bottom: viewportHeight,
                right: viewportWidth,
            }
            : container.getBoundingClientRect();
        var subjectBounds = subjectRef.current.getBoundingClientRect();
        var targetBounds = targetRef.current.getBoundingClientRect();
        var _f = __read$Y(position.split(" "), 1), primaryPosition = _f[0];
        var positionToUse = position;
        if (altPosition && ((primaryPosition === "top" && targetBounds.top - subjectBounds.height < NAVBAR_HEIGHT)
            || (primaryPosition === "right" && targetBounds.right + subjectBounds.width > viewportWidth)
            || (primaryPosition === "bottom" && targetBounds.bottom + subjectBounds.height > viewportHeight)
            || (primaryPosition === "left" && targetBounds.left - subjectBounds.width < 0))) {
            positionToUse = altPosition;
        }
        var restrainedWidth = setMinWidth
            ? Math.max(targetBounds.width, subjectBounds.width)
            : subjectBounds.width;
        var resultantWidth = setWidth
            ? targetBounds.width
            : restrainedWidth;
        var _g = __read$Y(calculatePosition(positionToUse, containerBounds, targetBounds, subjectBounds, resultantWidth, offsets, parentElementRef, fixed), 4), top_1 = _g[0], right = _g[1], bottom = _g[2], left = _g[3];
        var styles = {
            top: px$1(top_1),
            right: px$1(right),
            bottom: px$1(bottom),
            left: px$1(left),
        };
        if (fixed) {
            styles.position = "fixed";
            styles.zIndex = ZStratum.BAR;
        }
        if (setMinWidth) {
            styles.minWidth = targetBounds.width + "px";
        }
        if (setWidth) {
            styles.width = targetBounds.width + "px";
        }
        return [styles, positionToUse === altPosition];
    }
    return [{}, false];
}

var __values$9 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var PortalContext = createContext(null);
function usePortal(id, classes) {
    if (classes === void 0) { classes = []; }
    var context = useContext(PortalContext);
    return useMemo$1(function () { return function (jsx) {
        var e_1, _a;
        var contextualParentElement = context
            && context.parentElementRef
            && context.parentElementRef.current;
        var parent = contextualParentElement || document.body;
        var target;
        var curNode = parent.lastElementChild;
        while (curNode !== parent.firstElementChild) {
            if (curNode.hasAttribute("data-portalid") && curNode.getAttribute("data-portalid") === id) {
                target = curNode;
                break;
            }
            curNode = curNode.previousElementSibling;
        }
        if (!target) {
            target = document.createElement("div");
            target.setAttribute("data-portalid", id);
            try {
                for (var classes_1 = __values$9(classes), classes_1_1 = classes_1.next(); !classes_1_1.done; classes_1_1 = classes_1.next()) {
                    var className = classes_1_1.value;
                    target.classList.add(className);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (classes_1_1 && !classes_1_1.done && (_a = classes_1.return)) _a.call(classes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            parent.appendChild(target);
        }
        else if (target.nextElementSibling) {
            parent.removeChild(target);
            parent.appendChild(target);
        }
        return createPortal(jsx, target);
    }; }, [context]);
}

var __assign$1P = (undefined && undefined.__assign) || function () {
    __assign$1P = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1P.apply(this, arguments);
};
var spsOptionListPassthroughProps = {
    docs: {
        options: "Eventually<any[]> | (filter?: string) => Eventually<any[]>",
        captionKey: "string",
        disabledOptions: "any[]",
        comparisonKey: "string",
        tall: "boolean",
        textKey: "string",
        valueKey: "string",
        zeroState: "string",
    },
    propTypes: {
        captionKey: propTypes$1H.exports.string,
        comparisonKey: propTypes$1H.exports.string,
        disabledOptions: propTypes$1H.exports.arrayOf(propTypes$1H.exports.any),
        options: propTypes$1H.exports.oneOfType([
            propTypes$1H.exports.array,
            propTypes$1H.exports.instanceOf(Promise),
            fun(),
        ]).isRequired,
        tall: propTypes$1H.exports.bool,
        textKey: propTypes$1H.exports.string,
        valueKey: propTypes$1H.exports.string,
        zeroState: propTypes$1H.exports.string,
    },
};
var searchableOptionListProps = {
    hideInlineSearch: propTypes$1H.exports.bool,
    onSearchChange: fun(),
    search: propTypes$1H.exports.string,
    searchDebounce: propTypes$1H.exports.number,
    searchPlaceholder: propTypes$1H.exports.string,
    searchInputRef: ref(),
};
var propTypes$1D = __assign$1P(__assign$1P(__assign$1P(__assign$1P({}, spsGlobalPropTypes), spsOptionListPassthroughProps.propTypes), searchableOptionListProps), { attachTo: ref().isRequired, conformWidth: propTypes$1H.exports.bool, id: propTypes$1H.exports.string.isRequired, isOpen: propTypes$1H.exports.bool, keepOpen: propTypes$1H.exports.bool, keyDown: impl(), nullOption: propTypes$1H.exports.string, offsets: propTypes$1H.exports.arrayOf(propTypes$1H.exports.number), onOptionListChanged: fun(), onOptionSelected: fun(), onPositionFlip: fun(), onSelfToggle: fun(), optionRole: propTypes$1H.exports.string, positionOverride: propTypes$1H.exports.arrayOf(enumValue(Position)), selectedOption: propTypes$1H.exports.any, specialAction: fun(), ignoreWidthStyles: propTypes$1H.exports.bool, loading: propTypes$1H.exports.bool, filterByTextAndCaptionKey: propTypes$1H.exports.bool });

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values$8 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read$X = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function updateOptions(props, searchState, searchStatePatch, setOptionList, setAnyOptionHasIcon, promiseRef) {
    return __awaiter(this, void 0, void 0, function () {
        var options, areOptionsPromise, result, _a, newOpts, newOpts_1, newOpts_1_1, opt;
        var e_1, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    options = typeof props.options === "function"
                        ? props.options(searchState.value)
                        : props.options || [];
                    areOptionsPromise = options instanceof Promise;
                    searchStatePatch({ pending: areOptionsPromise });
                    // eslint-disable-next-line no-param-reassign
                    promiseRef.current = areOptionsPromise ? options : null;
                    if (!areOptionsPromise) return [3 /*break*/, 2];
                    return [4 /*yield*/, options];
                case 1:
                    _a = (_c.sent()) || [];
                    return [3 /*break*/, 3];
                case 2:
                    _a = options || [];
                    _c.label = 3;
                case 3:
                    result = _a;
                    if (areOptionsPromise && promiseRef.current !== options) {
                        return [2 /*return*/];
                    }
                    newOpts = Array.from(result)
                        .filter(Boolean)
                        .map(function (thing) { return new SpsOptionListOption(thing, typeof thing === "function"
                        ? {
                            textKey: "label",
                            captionKey: "caption",
                        }
                        : {
                            textKey: props.textKey,
                            captionKey: props.captionKey,
                        }); });
                    if (props.nullOption) {
                        newOpts.unshift(new SpsOptionListOption(null, { text: props.nullOption }));
                    }
                    if (searchState.value) {
                        searchStatePatch({ replacementPattern: new RegExp(searchState.value, "ig") });
                        newOpts = newOpts.filter(function (o) {
                            var regEx = new RegExp(searchState.value, "i");
                            if (props.filterByTextAndCaptionKey) {
                                return regEx.test(o.text) || regEx.test(o.caption);
                            }
                            return regEx.test(o.text);
                        });
                    }
                    else {
                        searchStatePatch({ replacementPattern: null });
                    }
                    if (props.disabledOptions) {
                        try {
                            for (newOpts_1 = __values$8(newOpts), newOpts_1_1 = newOpts_1.next(); !newOpts_1_1.done; newOpts_1_1 = newOpts_1.next()) {
                                opt = newOpts_1_1.value;
                                if (props.disabledOptions.includes(opt.value)) {
                                    opt.disabled = true;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (newOpts_1_1 && !newOpts_1_1.done && (_b = newOpts_1.return)) _b.call(newOpts_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    setOptionList(Object.freeze(newOpts));
                    if (props.onOptionListChanged) {
                        props.onOptionListChanged(newOpts.length);
                    }
                    setAnyOptionHasIcon(newOpts.some(function (o) { return o.value && !!o.value.icon; }));
                    searchStatePatch({ pending: false });
                    return [2 /*return*/];
            }
        });
    });
}
function useOptionListOptions(props, searchState, searchStatePatch) {
    var _a = __read$X(React.useState(Object.freeze([])), 2), optionList = _a[0], setOptionList = _a[1];
    var _b = __read$X(React.useState(false), 2), anyOptionHasIcon = _b[0], setAnyOptionHasIcon = _b[1];
    var promiseRef = React.useRef(null);
    var update = React.useMemo(function () { return (typeof props.options === "function"
        ? debounce(updateOptions, typeof props.searchDebounce !== "undefined" ? props.searchDebounce : 500)
        : updateOptions); }, [props.options, props.disabledOptions]);
    React.useEffect(function () {
        void update(props, searchState, searchStatePatch, setOptionList, setAnyOptionHasIcon, promiseRef);
    }, [props.options,
        searchState.value,
        props.disabledOptions]);
    return [optionList, anyOptionHasIcon];
}

var FauxChangeEvent = /** @class */ (function () {
    function FauxChangeEvent(target, eventInit) {
        this.target = target;
        this.isPgStoppedInternal = false;
        this.currentTarget = target;
        this.nativeEvent = new CustomEvent("change", eventInit);
        Object.defineProperty(this.nativeEvent, "target", {
            value: target,
            writable: false,
            configurable: false,
            enumerable: true,
        });
    }
    Object.defineProperty(FauxChangeEvent.prototype, "bubbles", {
        get: function () {
            return this.nativeEvent.bubbles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FauxChangeEvent.prototype, "cancelable", {
        get: function () {
            return this.nativeEvent.cancelable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FauxChangeEvent.prototype, "defaultPrevented", {
        get: function () {
            return this.nativeEvent.defaultPrevented;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FauxChangeEvent.prototype, "eventPhase", {
        get: function () {
            return this.nativeEvent.eventPhase;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FauxChangeEvent.prototype, "isTrusted", {
        get: function () {
            return this.nativeEvent.isTrusted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FauxChangeEvent.prototype, "timeStamp", {
        get: function () {
            return this.nativeEvent.timeStamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FauxChangeEvent.prototype, "type", {
        get: function () {
            return this.nativeEvent.type;
        },
        enumerable: false,
        configurable: true
    });
    FauxChangeEvent.prototype.preventDefault = function () {
        this.nativeEvent.preventDefault();
    };
    FauxChangeEvent.prototype.isDefaultPrevented = function () {
        return this.defaultPrevented;
    };
    FauxChangeEvent.prototype.stopPropagation = function () {
        this.nativeEvent.stopPropagation();
        this.isPgStoppedInternal = true;
    };
    FauxChangeEvent.prototype.isPropagationStopped = function () {
        return this.isPgStoppedInternal;
    };
    /* eslint-disable class-methods-use-this */
    FauxChangeEvent.prototype.persist = function () {
        throw new Error("This is not a real React ChangeEvent. React does not permit the creation of SyntheticEvents in userland.");
    };
    return FauxChangeEvent;
}());

var __assign$1O = (undefined && undefined.__assign) || function () {
    __assign$1O = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1O.apply(this, arguments);
};
function patchReducer(state, patch) {
    return __assign$1O(__assign$1O({}, state), patch);
}
function usePatchReducer(initState) {
    return useReducer(patchReducer, initState);
}

var __read$W = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function useOptionListSearch(_a) {
    var hideInlineSearch = _a.hideInlineSearch, options = _a.options, onSearchChange = _a.onSearchChange, _b = _a.search, search = _b === void 0 ? "" : _b, _c = _a.searchPlaceholder, searchPlaceholder = _c === void 0 ? "Search…" : _c, searchInputRef = _a.searchInputRef;
    var _d = __read$W(usePatchReducer({
        isAsync: typeof options === "function",
        pending: false,
        value: search,
        replacementPattern: null,
    }), 2), searchState = _d[0], searchStatePatch = _d[1];
    var handleInputChange = React.useCallback(function (event) {
        searchStatePatch({ value: event.target.value });
        if (onSearchChange) {
            onSearchChange(event);
        }
    }, [onSearchChange]);
    var handleInputClick = React.useCallback(function (event) {
        event.nativeEvent.stopImmediatePropagation();
        event.stopPropagation();
    }, []);
    var handleClearClick = React.useCallback(function (event) {
        event.nativeEvent.stopImmediatePropagation();
        searchStatePatch({ value: "" });
        if (onSearchChange) {
            onSearchChange(new FauxChangeEvent(searchInputRef.current));
        }
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [onSearchChange]);
    var handleKeyDown = function (event) {
        if (!event) {
            return;
        }
        if (!["Tab",
            "Escape",
            "Enter",
            "Up",
            "ArrowUp",
            "Down",
            "ArrowDown"].includes(event.key)) {
            event.stopPropagation();
        }
    };
    React.useEffect(function () {
        searchStatePatch({ value: search });
    }, [search]);
    var searchElement = searchState.isAsync && !hideInlineSearch && (React.createElement("div", { className: "sps-option-list__search sps-form-group sps-text-input" },
        React.createElement("div", { className: "sps-form-control" },
            !searchState.value && React.createElement("i", { className: "sps-icon sps-icon-filter sps-text-input__icon" }),
            React.createElement("input", { type: "text", className: "sps-text-input__input", placeholder: searchPlaceholder, ref: searchInputRef, value: searchState.value, onChange: handleInputChange, onClick: handleInputClick, onKeyDown: handleKeyDown }),
            searchState.value && React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: handleClearClick }))));
    return [searchElement,
        searchState,
        searchStatePatch];
}

var __assign$1N = (undefined && undefined.__assign) || function () {
    __assign$1N = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1N.apply(this, arguments);
};
var __rest$1s = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$V = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var scrollIntoView = scrollIntoView$1 || scrollIntoViewImport;
var DIRECTIONAL_KEYS = ["Tab",
    "Escape",
    "Enter",
    "Up",
    "ArrowUp",
    "Down",
    "ArrowDown"];
var LETTER_KEYS = ["a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"];
function compareOptions(optionA, optionB, comparisonKey) {
    return comparisonKey
        ? (optionA && optionA[comparisonKey]) === (optionB && optionB[comparisonKey])
        : optionA === optionB;
}
function isOptionDisabled(disabledOptions, comparisonKey, option) {
    return comparisonKey
        ? !!(disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.find(function (opt) { var _a; return opt[comparisonKey] && opt[comparisonKey] === ((_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a[comparisonKey]); }))
        : false;
}
var SpsOptionList = React.forwardRef(function (props, ref) {
    props.captionKey; var comparisonKey = props.comparisonKey, disabledOptions = props.disabledOptions; props.options; var tall = props.tall; props.textKey; props.valueKey; var zeroState = props.zeroState; props.hideInlineSearch; props.onSearchChange; props.search; props.searchDebounce; props.searchPlaceholder; var attachTo = props.attachTo, className = props.className, conformWidth = props.conformWidth, id = props.id, ignoreWidthStyles = props.ignoreWidthStyles, isOpenProp = props.isOpen, keepOpen = props.keepOpen, keyDown = props.keyDown; props.nullOption; props.onOptionListChanged; var onOptionSelected = props.onOptionSelected, onPositionFlip = props.onPositionFlip, onSelfToggle = props.onSelfToggle, optionRole = props.optionRole, positionOverride = props.positionOverride, selectedOption = props.selectedOption, specialAction = props.specialAction, unsafelyReplaceClassName = props.unsafelyReplaceClassName, loading = props.loading; props.filterByTextAndCaptionKey; var testId = props["data-testid"], rest = __rest$1s(props, ["captionKey", "comparisonKey", "disabledOptions", "options", "tall", "textKey", "valueKey", "zeroState", "hideInlineSearch", "onSearchChange", "search", "searchDebounce", "searchPlaceholder", "attachTo", "className", "conformWidth", "id", "ignoreWidthStyles", "isOpen", "keepOpen", "keyDown", "nullOption", "onOptionListChanged", "onOptionSelected", "onPositionFlip", "onSelfToggle", "optionRole", "positionOverride", "selectedOption", "specialAction", "unsafelyReplaceClassName", "loading", "filterByTextAndCaptionKey", "data-testid"]);
    var specialActionOption = React.useMemo(function () { return (specialAction
        ? new SpsOptionListOption(specialAction, {
            textKey: "label",
            captionKey: "caption",
        })
        : null); }, [specialAction]);
    var _a = __read$V(React.useState(-1), 2), highlightedOptionIndex = _a[0], setHighlightedOptionIndex = _a[1];
    var _b = __read$V(React.useState(isOpenProp), 2), isOpen = _b[0], setIsOpen = _b[1];
    var rootRef = ref || React.useRef(null);
    var optionsRef = React.useRef(null);
    var highlightedOptionRef = React.useRef(null);
    var portal = usePortal("sps-option-list-portal");
    var portalContext = React.useContext(PortalContext);
    var _c = __read$V(positionOverride
        || [Position.BOTTOM_LEFT, Position.TOP_LEFT], 2), primePosition = _c[0], altPosition = _c[1];
    var _d = __read$V(isOpen
        ? getPosition(rootRef, attachTo, primePosition, __assign$1N({ altPosition: altPosition, setMinWidth: !ignoreWidthStyles, setWidth: !ignoreWidthStyles && conformWidth }, portalContext))
        : [{}, false], 2), posStyle = _d[0], openingUpward = _d[1];
    var searchInputRef = React.useRef(null);
    var _e = __read$V(useOptionListSearch(__assign$1N(__assign$1N({}, props), { searchInputRef: searchInputRef })), 3), searchElement = _e[0], searchState = _e[1], searchStatePatch = _e[2];
    var _f = __read$V(useOptionListOptions(props, searchState, searchStatePatch), 2), optionList = _f[0], anyOptionHasIcon = _f[1];
    // Clear selected option on search
    React.useEffect(function () {
        setHighlightedOptionIndex(-1);
    }, [searchState]);
    var classes = clsx(unsafelyReplaceClassName || "sps-option-list", "z-stratum-dropdown", isOpen && "sps-option-list--open", searchState.isAsync && "sps-option-list--searchable", openingUpward && "sps-option-list--opens-upward", specialAction && specialAction.label && "sps-option-list--has-special-action", className);
    var optionsClasses = clsx(unsafelyReplaceClassName || "sps-option-list__options", tall && "sps-option-list__options--tall");
    var openSelf = React.useCallback(function () {
        if (!isOpen) {
            setIsOpen(true);
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
            setHighlightedOptionIndex(-1);
            if (onSelfToggle) {
                onSelfToggle(true);
            }
        }
    }, [isOpen, onSelfToggle]);
    var closeSelf = React.useCallback(function () {
        if (isOpen) {
            setIsOpen(false);
            setHighlightedOptionIndex(-1);
            if (onSelfToggle) {
                onSelfToggle(false);
            }
        }
    }, [isOpen, onSelfToggle]);
    var selectOption = React.useCallback(function (option, isDisabled) {
        if (isDisabled) {
            return;
        }
        if (option && !option.disabled) {
            if (typeof option.value === "function") {
                (option.value)();
            }
            else if (typeof onOptionSelected === "function") {
                onOptionSelected(option.value);
            }
            if (!keepOpen) {
                closeSelf();
            }
        }
    }, [onOptionSelected, closeSelf]);
    var handleOptionClick = React.useCallback(function (event, option, isDisabled) {
        event.stopPropagation();
        selectOption(option, isDisabled);
    }, [selectOption]);
    var disabledOptionsRef = React.useRef(disabledOptions || []);
    disabledOptionsRef.current = disabledOptions || [];
    var handleArrowKeyDown = React.useCallback(function (event) {
        switch (event.key) {
            case "Tab":
            case "Escape":
                closeSelf();
                break;
            case "Enter":
                if (highlightedOptionIndex > -1) {
                    var highlightedOption = optionList[highlightedOptionIndex]
                        || specialActionOption;
                    event.preventDefault();
                    var isDisabled = !!highlightedOption
                        && isOptionDisabled(disabledOptionsRef.current, comparisonKey, highlightedOption);
                    if (!isDisabled
                        && highlightedOption
                        && typeof onOptionSelected === "function"
                        && typeof highlightedOption.value === "function") {
                        (highlightedOption.value)();
                    }
                    else if (highlightedOption) {
                        selectOption(highlightedOption, isDisabled);
                    }
                }
                break;
            case "Up":
            case "ArrowUp": {
                var newHighlightIndex = highlightedOptionIndex;
                if (openingUpward) {
                    if (highlightedOptionIndex <= -1) {
                        // From no highlight, go up to the last option
                        newHighlightIndex = optionList.length - 1;
                    }
                    else if (highlightedOptionIndex === 0) {
                        /**
                         * From the first option, if there's a special action to go up
                         * to, go up to it. Otherwise do not go up, we're at the top
                         */
                        if (specialAction) {
                            newHighlightIndex = optionList.length;
                        }
                    }
                    else if (highlightedOptionIndex < optionList.length) {
                        /**
                         * From an option lower than the 0th (index > 0) and not at
                         * the special action (index === length of option list), go up one
                         */
                        newHighlightIndex = highlightedOptionIndex - 1;
                    }
                }
                else if (highlightedOptionIndex > -1) {
                    /**
                     * When opening downward (default) the very top is "no highlight",
                     * when index === -1,  and indices get larger as you go downward.
                     * So just go up one
                     */
                    newHighlightIndex = highlightedOptionIndex - 1;
                }
                if (newHighlightIndex !== highlightedOptionIndex) {
                    event.preventDefault();
                    setHighlightedOptionIndex(newHighlightIndex);
                }
                break;
            }
            case "Down":
            case "ArrowDown": {
                openSelf();
                var newHighlightIndex = highlightedOptionIndex;
                if (openingUpward) {
                    if (highlightedOptionIndex !== -1) {
                        if (highlightedOptionIndex >= optionList.length) {
                            // From the special action, go down to the first option
                            newHighlightIndex = 0;
                        }
                        else if (highlightedOptionIndex === optionList.length - 1) {
                            // From the last option, go to "no highlight" (index === -1)
                            newHighlightIndex = -1;
                        }
                        else {
                            // Otherwise, go down one
                            newHighlightIndex = highlightedOptionIndex + 1;
                        }
                    }
                }
                else if (highlightedOptionIndex < optionList.length - 1 + Number(!!specialAction)) {
                    newHighlightIndex = highlightedOptionIndex + 1;
                }
                if (newHighlightIndex !== highlightedOptionIndex) {
                    event.preventDefault();
                    setHighlightedOptionIndex(newHighlightIndex);
                }
                break;
            }
            default:
                openSelf();
        }
    }, [
        closeSelf,
        openSelf,
        highlightedOptionIndex,
        selectOption,
        onOptionSelected,
        openingUpward,
        optionList,
    ]);
    var handleLetterKeyDown = React.useCallback(function (event) {
        var newIndex = optionList.findIndex(function (item) {
            // handle options as objects
            if (item.textKey) {
                var key = item.textKey;
                return item.value[key].toLowerCase().charAt([0]) === event.key.toLocaleLowerCase();
            }
            // handle options as strings
            return item.value.toLowerCase().charAt([0]) === event.key.toLocaleLowerCase();
        });
        if (newIndex > -1) {
            setHighlightedOptionIndex(newIndex);
        }
    }, [optionList]);
    var handleKeyDown = React.useCallback(function (event) {
        if (!event) {
            return;
        }
        if (DIRECTIONAL_KEYS.includes(event.key)) {
            handleArrowKeyDown(event);
        }
        else if (LETTER_KEYS.includes(event.key)) {
            handleLetterKeyDown(event);
        }
    }, [
        closeSelf,
        openSelf,
        highlightedOptionIndex,
        selectOption,
        onOptionSelected,
        openingUpward,
        optionList,
    ]);
    React.useEffect(function () {
        if (portalContext !== null) {
            if (document.getElementsByClassName("sps-modal__body").length > 0) {
                var scrollListener_1 = function () {
                    onSelfToggle(false);
                };
                var modalBody_1 = document.getElementsByClassName("sps-modal__body")[0];
                modalBody_1.addEventListener("scroll", scrollListener_1);
                return function () {
                    modalBody_1.removeEventListener("scroll", scrollListener_1);
                };
            }
        }
    }, []);
    React.useEffect(function () {
        if (highlightedOptionRef.current) {
            scrollIntoView(highlightedOptionRef.current, {
                scrollMode: "if-needed",
                block: "nearest",
                inline: "nearest",
            });
        }
    }, [highlightedOptionIndex]);
    React.useEffect(function () {
        setIsOpen(isOpenProp);
        if (!isOpenProp) {
            setHighlightedOptionIndex(-1);
        }
        else if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isOpenProp]);
    React.useEffect(function () {
        handleKeyDown(keyDown);
    }, [keyDown]);
    React.useEffect(function () {
        if (!isOpen && optionsRef.current) {
            searchStatePatch({ value: "" });
            optionsRef.current.scrollTop = 0;
        }
        if (isOpen && onPositionFlip) {
            onPositionFlip(openingUpward);
        }
    }, [isOpen]);
    return portal(React.createElement("div", __assign$1N({ className: classes, id: id, "aria-activedescendant": highlightedOptionIndex > -1
            ? id + "-option-" + highlightedOptionIndex
            : null, tabIndex: -1, ref: rootRef, style: posStyle, onMouseLeave: function () { return setHighlightedOptionIndex(-1); }, "data-testid": testId }, rest),
        searchElement,
        React.createElement("div", { className: optionsClasses, ref: optionsRef, "data-testid": testId + "-options" },
            !loading && !searchState.pending && zeroState
                && (searchState.value || !searchState.isAsync)
                && optionList.length === 0 && React.createElement("div", { className: "sps-option-list__zero-state" }, zeroState),
            (loading || searchState.pending) && React.createElement("div", { className: "sps-option-list__loading" },
                React.createElement(SpsSpinner, null)),
            !loading && !searchState.pending && optionList.map(function (option, i) {
                var identifier = id + "-option-" + i;
                var comparisonResult = compareOptions(option.value, selectedOption, comparisonKey);
                var isOptionDisabledResult = isOptionDisabled(disabledOptionsRef.current, comparisonKey, option);
                return (React.createElement("a", { key: identifier, id: identifier, role: optionRole, "aria-selected": comparisonResult, href: option.href, className: clsx("sps-option-list__option", option.caption && "sps-option-list__option--has-caption", option.disabled && "sps-option-list__option--disabled", option.bold && "sps-option-list__option--bold", (comparisonResult || isOptionDisabledResult) && "sps-option-list__option--selected", highlightedOptionIndex === i && "sps-option-list__option--highlighted"), onClick: function (event) { return handleOptionClick(event, option, isOptionDisabledResult); }, onMouseOver: function () { return setHighlightedOptionIndex(i); }, tabIndex: -1, ref: highlightedOptionIndex === i ? highlightedOptionRef : null, "data-testid": testId + "-option-" + i },
                    option.value && option.value.icon
                        && (React.createElement("i", { className: clsx("sps-icon", "sps-option-list__option-icon", "sps-icon-" + String(option.value.icon)) })),
                    (!option.value || (!option.value.icon && anyOptionHasIcon))
                        && React.createElement("span", { className: "sps-option-list__option-icon-spacer" }),
                    React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: option.getHtml(searchState.replacementPattern),
                        } }),
                    option.caption
                        && (React.createElement("div", { className: "sps-option-list__option-caption" },
                            React.createElement("span", { dangerouslySetInnerHTML: {
                                    __html: option.caption.replace(searchState.replacementPattern, "<u>$&</u>"),
                                } })))));
            })),
        specialActionOption && specialAction.label
            && (React.createElement("a", { className: clsx("sps-option-list__option", "sps-option-list__special-action", highlightedOptionIndex === optionList.length && "sps-option-list__option--highlighted"), href: specialActionOption.href, onClick: function (event) { return handleOptionClick(event, specialActionOption); }, onMouseOver: function () { return setHighlightedOptionIndex(optionList.length); } },
                specialAction.icon
                    && (React.createElement("i", { className: clsx("sps-icon", "sps-option-list__option-icon", "sps-icon-" + String(specialAction.icon)) })),
                !specialAction.icon && anyOptionHasIcon
                    && React.createElement("span", { className: "sps-option-list__option-icon-spacer" }),
                React.createElement("span", null, specialAction.label)))));
});
Object.assign(SpsOptionList, {
    propTypes: propTypes$1D,
    displayName: "SpsOptionList",
});

var __values$7 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function selectChildren(children, groups) {
    var e_1, _a;
    if (children === void 0) { children = []; }
    if (groups === void 0) { groups = []; }
    var childrenArray = Array.isArray(children) ? flatten(children) : [children];
    var normGroups = groups
        .map(function (s) { return (Array.isArray(s) ? s : [s]); });
    var nodeLists = (new Array(normGroups.length + 1)).fill(null)
        .map(function () { return []; });
    var _loop_1 = function (node) {
        var e_2, _b;
        var nodeSelected = false;
        for (var i = 0; i < normGroups.length; i += 1) {
            var _loop_2 = function (type, props) {
                if (node.type === type) {
                    var propsMatch = Object.keys(props)
                        .every(function (prop) { return props[prop] === node.props[prop]; });
                    if (propsMatch) {
                        nodeSelected = true;
                        nodeLists[i].push(node);
                        return "break";
                    }
                }
            };
            try {
                for (var _c = (e_2 = void 0, __values$7(normGroups[i])), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var _e = _d.value, type = _e.type, _f = _e.props, props = _f === void 0 ? {} : _f;
                    var state_1 = _loop_2(type, props);
                    if (state_1 === "break")
                        break;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        if (!nodeSelected) {
            nodeLists[nodeLists.length - 1].push(node);
        }
    };
    try {
        for (var childrenArray_1 = __values$7(childrenArray), childrenArray_1_1 = childrenArray_1.next(); !childrenArray_1_1.done; childrenArray_1_1 = childrenArray_1.next()) {
            var node = childrenArray_1_1.value;
            _loop_1(node);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (childrenArray_1_1 && !childrenArray_1_1.done && (_a = childrenArray_1.return)) _a.call(childrenArray_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return nodeLists;
}

var __read$U = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function useCheckDeprecatedProps(componentName, propsDoc, props) {
    var deprecatedProps = Object.entries(propsDoc)
        .filter(function (_a) {
        var _b = __read$U(_a, 2), value = _b[1];
        return typeof value !== "string" && value.deprecated;
    })
        .map(function (_a) {
        var _b = __read$U(_a, 1), key = _b[0];
        return key;
    });
    var propValues = deprecatedProps.map(function (p) { return props[p]; });
    React.useEffect(function () {
        if (propValues.find(function (value) { return typeof value !== "undefined"; })) {
            console.warn("The following prop(s) of " + componentName + " are deprecated: " + deprecatedProps.join(", "));
        }
    }, propValues);
}

function useDidUpdateEffect(cb, deps) {
    var didMount = useRef(false);
    useEffect(function () {
        if (didMount.current) {
            return cb();
        }
        didMount.current = true;
    }, deps);
}

var __read$T = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$4 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function useDocumentEventListener(eventName, listenerFactory, deps) {
    var listener = React.useRef(listenerFactory.apply(void 0, __spreadArray$4([], __read$T(deps), false)));
    React.useEffect(function () {
        document.addEventListener(eventName, listener.current);
        return function () { return document.removeEventListener(eventName, listener.current); };
    }, []);
    React.useEffect(function () {
        document.removeEventListener(eventName, listener.current);
        listener.current = listenerFactory.apply(void 0, __spreadArray$4([], __read$T(deps), false));
        document.addEventListener(eventName, listener.current);
    }, deps);
}

var __read$S = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function documentClickHandlerFactory(rootRef, popupRef, doHidePopup) {
    return function documentClickHandler(event) {
        if (!rootRef.current.contains(event.target)
            && !popupRef.current.contains(event.target)) {
            doHidePopup();
        }
    };
}
function useInputPopup(rootRef, popupRef) {
    var suppressPopup = React.useRef(false);
    var _a = __read$S(React.useState(false), 2), showPopup = _a[0], setShowPopup = _a[1];
    function doShowPopup() {
        if (suppressPopup.current) {
            suppressPopup.current = false;
        }
        else {
            setShowPopup(true);
        }
    }
    var doHidePopup = React.useCallback(function (suppressNextShow) {
        if (suppressNextShow === void 0) { suppressNextShow = false; }
        setShowPopup(false);
        suppressPopup.current = suppressNextShow;
    }, [setShowPopup]);
    useDocumentEventListener("click", documentClickHandlerFactory, [rootRef,
        popupRef,
        doHidePopup]);
    return {
        showPopup: showPopup,
        doShowPopup: doShowPopup,
        doHidePopup: doHidePopup,
    };
}

var __assign$1M = (undefined && undefined.__assign) || function () {
    __assign$1M = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1M.apply(this, arguments);
};
var __rest$1r = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$R = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1z = {
    debounce: "number",
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<string>",
    icon: "SpsIcon",
    onChange: "React.ChangeEventHandler",
    placeholder: "string",
    suggestions: {
        type: "\n            Eventually<Iterable<string>>\n            | ((filter?: string) => Eventually<Iterable<string>>)\n        ",
        required: true,
    },
    tallOptionList: "boolean",
    value: "string",
    zeroState: "string",
    loading: "boolean",
};
var propTypes$1C = __assign$1M(__assign$1M({}, spsGlobalPropTypes), { debounce: propTypes$1H.exports.number, disabled: propTypes$1H.exports.bool, formControl: impl(), formMeta: impl(), icon: enumValue(SpsIcon), onChange: fun(), placeholder: propTypes$1H.exports.string, suggestions: propTypes$1H.exports.oneOfType([
        propTypes$1H.exports.arrayOf(propTypes$1H.exports.string),
        propTypes$1H.exports.instanceOf(Promise),
        fun(),
    ]).isRequired, tallOptionList: propTypes$1H.exports.bool, value: propTypes$1H.exports.string, zeroState: propTypes$1H.exports.string, loading: propTypes$1H.exports.bool });
function SpsAutocomplete(_a) {
    var className = _a.className, _b = _a.debounce, debounce = _b === void 0 ? 0 : _b, disabled = _a.disabled, formControl = _a.formControl, formMeta = _a.formMeta, onChange = _a.onChange, icon = _a.icon, id = _a.id, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, suggestions = _a.suggestions, unsafelyReplaceClassName = _a.unsafelyReplaceClassName, tallOptionList = _a.tallOptionList, _d = _a.value, value = _d === void 0 ? "" : _d, zeroState = _a.zeroState, loading = _a.loading, rest = __rest$1r(_a, ["className", "debounce", "disabled", "formControl", "formMeta", "onChange", "icon", "id", "placeholder", "suggestions", "unsafelyReplaceClassName", "tallOptionList", "value", "zeroState", "loading"]);
    var meta = formMeta || formControl;
    var _e = useFormControlId(id, meta), wrapperId = _e.wrapperId, controlId = _e.controlId;
    var _f = __read$R(usePatchReducer({
        keyDown: null,
        opensUpward: false,
    }), 2), state = _f[0], patchState = _f[1];
    var rootRef = React.useRef();
    var textInput = React.useRef();
    var optionListRef = React.useRef();
    var _g = useInputPopup(rootRef, optionListRef), showPopup = _g.showPopup, doShowPopup = _g.doShowPopup, doHidePopup = _g.doHidePopup;
    function setAndPropagateValue(newValue, event) {
        if (meta) {
            meta.setValue(newValue);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(event || new FauxChangeEvent({ value: newValue }));
        }
    }
    function clear(event) {
        textInput.current.value = "";
        setAndPropagateValue("");
        event.stopPropagation();
    }
    function handleChange(event) {
        setAndPropagateValue(event.target.value, event);
    }
    function handleKeyDown(event) {
        if (!disabled) {
            if (["Up",
                "ArrowUp",
                "Down",
                "ArrowDown",
                "Enter"].indexOf(event.key) > -1) {
                event.preventDefault();
                event.persist();
            }
            event.stopPropagation();
            patchState({ keyDown: event });
        }
        if (event.key === "Tab") {
            doHidePopup();
        }
    }
    function handleSelfToggle(olIsOpen) {
        if (olIsOpen) {
            doShowPopup();
        }
        else {
            doHidePopup();
        }
    }
    function handlePositionFlip(opensUpward) {
        patchState({ opensUpward: opensUpward });
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-autocomplete", showPopup && "sps-autocomplete--open", showPopup && "z-stratum-dropdown", state.opensUpward && "sps-autocomplete--opens-upward", disabled && "sps-form-control--disabled", className);
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formControl: formControl, formMeta: formMeta, inputRef: textInput, ref: rootRef, focusInputOnClick: true, onClick: function (event) { return event.nativeEvent.stopImmediatePropagation(); } },
        React.createElement("div", { className: "sps-text-input" },
            React.createElement("div", { className: "sps-form-control" },
                icon && React.createElement("i", { className: clsx("sps-text-input__icon", "sps-icon", "sps-icon-" + icon) }),
                React.createElement("input", __assign$1M({ type: "text", ref: textInput, value: value, className: "sps-text-input__input", placeholder: placeholder, onFocus: doShowPopup, onClick: doShowPopup, onChange: handleChange, onKeyDown: handleKeyDown, disabled: disabled, id: controlId }, rest)),
                value && !disabled && (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: function (event) { return clear(event); } })))),
        React.createElement(SpsOptionList, { id: wrapperId + "_options", ref: optionListRef, attachTo: rootRef, isOpen: showPopup, options: suggestions, hideInlineSearch: true, keyDown: state.keyDown, onOptionSelected: setAndPropagateValue, onPositionFlip: handlePositionFlip, onSelfToggle: handleSelfToggle, offsets: [1, 0], search: value, searchDebounce: debounce, tall: tallOptionList, zeroState: zeroState, loading: loading })));
}
Object.assign(SpsAutocomplete, {
    props: propsDoc$1z,
    propTypes: propTypes$1C,
    displayName: "SpsAutocomplete",
});

var __makeTemplateObject$V = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsAutocompleteExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$V || (templateObject_1$V = __makeTemplateObject$V(["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colors}\n                                value={color}\n                                onChange={handleChange}\n                                placeholder=\"Enter a color\"\n                            />\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colors}\n                                value={color}\n                                onChange={handleChange}\n                                placeholder=\"Enter a color\"\n                            />\n                        );\n                    }\n                "]))),
            },
            disabled: {
                jsx: code(templateObject_2$P || (templateObject_2$P = __makeTemplateObject$V(["\n                    <SpsAutocomplete suggestions={[\"red\", \"blue\", \"green\"]} value=\"yellow\" disabled id=\"disabledAutocomplete\"/>\n                "], ["\n                    <SpsAutocomplete suggestions={[\"red\", \"blue\", \"green\"]} value=\"yellow\" disabled id=\"disabledAutocomplete\"/>\n                "]))),
            },
            form: {
                react: code(templateObject_3$G || (templateObject_3$G = __makeTemplateObject$V(["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ color: colors[0] });\n\n                        return (\n                            <SpsForm formMeta={formMeta}>\n                                <div className=\"sps-row\">\n                                    <div className=\"col-4\">\n                                        <SpsLabel for={formMeta.fields.color}>Color</SpsLabel>\n                                        <SpsAutocomplete id=\"formHookAutocomplete\" suggestions={colors}\n                                            formMeta={formMeta.fields.color}\n                                            value={formValue.color}\n                                        />\n                                    </div>\n                                    <div className=\"col-8\">\n                                        <br/>\n                                        <p>Color: {formValue.color}</p>\n                                    </div>\n                                </div>\n                            </SpsForm>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ color: colors[0] });\n\n                        return (\n                            <SpsForm formMeta={formMeta}>\n                                <div className=\"sps-row\">\n                                    <div className=\"col-4\">\n                                        <SpsLabel for={formMeta.fields.color}>Color</SpsLabel>\n                                        <SpsAutocomplete id=\"formHookAutocomplete\" suggestions={colors}\n                                            formMeta={formMeta.fields.color}\n                                            value={formValue.color}\n                                        />\n                                    </div>\n                                    <div className=\"col-8\">\n                                        <br/>\n                                        <p>Color: {formValue.color}</p>\n                                    </div>\n                                </div>\n                            </SpsForm>\n                        )\n                    }\n                "]))),
            },
        },
    },
    b_async: {
        label: "Async Autocomplete",
        examples: {
            func: {
                react: code(templateObject_4$y || (templateObject_4$y = __makeTemplateObject$V(["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        function colorSearch(search) {\n                            return [\"red\", \"blue\", \"green\"];\n                        }\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colorSearch} value={color} onChange={handleChange} placeholder=\"Enter a color\"/>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        function colorSearch(search) {\n                            return [\"red\", \"blue\", \"green\"];\n                        }\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colorSearch} value={color} onChange={handleChange} placeholder=\"Enter a color\"/>\n                        );\n                    }\n                "]))),
            },
            debounce: {
                react: code(templateObject_5$p || (templateObject_5$p = __makeTemplateObject$V(["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        function colorSearch(search) {\n                            return [\"red\", \"blue\", \"green\"];\n                        }\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colorSearch} debounce={1000} value={color} onChange={handleChange} placeholder=\"Enter a color\"/>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        function colorSearch(search) {\n                            return [\"red\", \"blue\", \"green\"];\n                        }\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colorSearch} debounce={1000} value={color} onChange={handleChange} placeholder=\"Enter a color\"/>\n                        );\n                    }\n                "]))),
            },
            promise: {
                react: code(templateObject_6$j || (templateObject_6$j = __makeTemplateObject$V(["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        function colorSearch(search) {\n                            return new Promise((resolve, reject) => {\n                                resolve([\"red\", \"blue\", \"green\"]);\n                            });\n                        }\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colorSearch} value={color} onChange={handleChange} placeholder=\"Enter a color\"/>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const [color, setColor] = React.useState();\n                        function colorSearch(search) {\n                            return new Promise((resolve, reject) => {\n                                resolve([\"red\", \"blue\", \"green\"]);\n                            });\n                        }\n\n                        function handleChange(event) {\n                            setColor(event.target.value);\n                        }\n\n                        return (\n                            <SpsAutocomplete suggestions={colorSearch} value={color} onChange={handleChange} placeholder=\"Enter a color\"/>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$V, templateObject_2$P, templateObject_3$G, templateObject_4$y, templateObject_5$p, templateObject_6$j;

var __assign$1L = (undefined && undefined.__assign) || function () {
    __assign$1L = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1L.apply(this, arguments);
};
var __rest$1q = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$Q = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1y = {
    alignLeft: "boolean",
    disabled: "boolean",
    icon: "SpsIcon",
    kind: "DropdownKind",
    label: "string",
    options: "Array<SpsActionMethod | [SpsActionDescriptor, () => void]>",
    spinning: "boolean",
    spinningTitle: "string",
    tallOptionList: "boolean",
    onOpen: "() => void",
    onClose: "() => void",
    loading: "boolean",
};
var propTypes$1B = __assign$1L(__assign$1L({}, spsGlobalPropTypes), { alignLeft: propTypes$1H.exports.bool, disabled: propTypes$1H.exports.bool, icon: enumValue(SpsIcon), kind: enumValue(DropdownKind), label: propTypes$1H.exports.string, 
    // eslint thinks there is a space between the name and open paren below for some reason
    // eslint-disable-next-line no-spaced-func
    options: propTypes$1H.exports.arrayOf(propTypes$1H.exports.oneOfType([propTypes$1H.exports.func, propTypes$1H.exports.any])).isRequired, spinning: propTypes$1H.exports.bool, spinningTitle: propTypes$1H.exports.string, tallOptionList: propTypes$1H.exports.bool, onOpen: fun(), onClose: fun(), loading: propTypes$1H.exports.bool });
function SpsDropdown(props) {
    var alignLeft = props.alignLeft, className = props.className, disabled = props.disabled, iconProp = props.icon, idProp = props.id, kindProp = props.kind, label = props.label, _a = props.options, optionsProp = _a === void 0 ? [] : _a, tabIndex = props.tabIndex, spinning = props.spinning, spinningTitle = props.spinningTitle, tallOptionList = props.tallOptionList, unsafelyReplaceClassName = props.unsafelyReplaceClassName, onOpen = props.onOpen, onClose = props.onClose, loading = props.loading, rest = __rest$1q(props, ["alignLeft", "className", "disabled", "icon", "id", "kind", "label", "options", "tabIndex", "spinning", "spinningTitle", "tallOptionList", "unsafelyReplaceClassName", "onOpen", "onClose", "loading"]);
    var t = React.useContext(I18nContext).t;
    var id = useElementId(idProp);
    var _b = __read$Q(React.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read$Q(React.useState(false), 2), opensUpward = _c[0], setOpensUpward = _c[1];
    var _d = __read$Q(React.useState(null), 2), keyDown = _d[0], setKeyDown = _d[1];
    var options = optionsProp.map(function (o) { return (typeof o === "function"
        ? o
        : Object.assign(o[1], __assign$1L(__assign$1L({}, SPS_ACTION_DEFAULTS), o[0]))); });
    var buttonId = id.current + "-button";
    var menuId = id.current + "-menu";
    var icon;
    var kind;
    if (label) {
        kind = kindProp || DropdownKind.DEFAULT;
        icon = iconProp;
    }
    else {
        kind = DropdownKind.ICON;
        icon = iconProp || SpsIcon.ELLIPSES;
    }
    var dropdownRef = React.useRef(null);
    React.useEffect(function () {
        if (isOpen && onOpen) {
            onOpen();
        }
        else if (!isOpen && onClose) {
            onClose();
        }
    }, [isOpen]);
    function handleDocumentClick() {
        setIsOpen(false);
    }
    function handleButtonClick(event) {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        event.preventDefault();
        if (!disabled && !spinning) {
            setIsOpen(!isOpen);
        }
    }
    function handleSelfToggle(olIsOpen) {
        setIsOpen(olIsOpen);
    }
    function handleOptionSelected() {
        setIsOpen(false);
    }
    function handleKeyDown(event) {
        if (!disabled) {
            if (["Up",
                "ArrowUp",
                "Down",
                "ArrowDown"].indexOf(event.key) > -1) {
                event.preventDefault();
            }
            event.persist();
            setKeyDown(event);
        }
    }
    function handleDropdownOpened(event) {
        if (event.detail !== id.current) {
            setIsOpen(false);
        }
    }
    React.useEffect(function () {
        document.addEventListener("click", handleDocumentClick);
        document.addEventListener("DropdownOpened", handleDropdownOpened);
        return function () {
            document.removeEventListener("click", handleDocumentClick);
            document.removeEventListener("DropdownOpened", handleDropdownOpened);
        };
    }, []);
    React.useEffect(function () {
        if (isOpen) {
            var event_1 = document.createEvent("CustomEvent");
            event_1.initCustomEvent("DropdownOpened", false, false, id.current);
            document.dispatchEvent(event_1);
        }
    }, [isOpen]);
    var classes = clsx(unsafelyReplaceClassName || "sps-dropdown", isOpen && "sps-dropdown--open", isOpen && "z-stratum-dropdown", opensUpward && "sps-dropdown--opens-upward", !label && "sps-dropdown--no-label", disabled && "disabled", className);
    var buttonClasses = clsx("sps-button", "sps-button--" + kind, disabled && "sps-button--disabled", spinning && "sps-button--spinning");
    var positionOverride = kind === DropdownKind.ICON && !alignLeft
        ? [Position.BOTTOM_RIGHT, Position.TOP_RIGHT]
        : null;
    return (React.createElement("div", __assign$1L({}, rest, { id: id.current, className: classes, onKeyDown: handleKeyDown }),
        React.createElement(SpsOptionList, { positionOverride: positionOverride, isOpen: isOpen, "aria-labelledby": buttonId, keyDown: keyDown, onOptionSelected: handleOptionSelected, id: menuId, attachTo: dropdownRef, onPositionFlip: setOpensUpward, onSelfToggle: handleSelfToggle, options: options, offsets: [0, 0], tall: tallOptionList, optionRole: "option", loading: loading }),
        React.createElement("div", { onClick: handleButtonClick, className: buttonClasses, ref: dropdownRef },
            React.createElement("button", { type: "button", id: buttonId, "aria-haspopup": "true", "aria-controls": menuId, "aria-expanded": isOpen ? true : null, tabIndex: tabIndex, disabled: disabled, onClick: handleButtonClick },
                React.createElement("i", { className: clsx("sps-icon", "sps-icon-" + icon) }),
                label && React.createElement("span", null, label),
                spinning && (React.createElement("div", { className: "sps-spinner", key: 1 }, spinningTitle || t("design-system:button.spinningTitle")))))));
}
Object.assign(SpsDropdown, {
    props: propsDoc$1y,
    propTypes: propTypes$1B,
    displayName: "SpsDropdown",
});

var __assign$1K = (undefined && undefined.__assign) || function () {
    __assign$1K = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1K.apply(this, arguments);
};
var __rest$1p = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$P = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1x = {};
var propTypes$1A = __assign$1K({}, spsGlobalPropTypes);
function SpsButtonGroup(props) {
    var children = props.children, className = props.className, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1p(props, ["children", "className", "unsafelyReplaceClassName"]);
    var _a = __read$P(selectChildren(children, [
        { type: SpsButton, props: { kind: ButtonKind.LINK } }, [{ type: SpsButton, props: { kind: ButtonKind.ICON } }, { type: SpsDropdown }],
    ]), 3), links = _a[0], iconButtons = _a[1], others = _a[2];
    var linkAndIconOrOther = links.length > 0 && (iconButtons.length > 0 || others.length > 0);
    var iconAndOther = iconButtons.length > 0 && others.length > 0;
    var classes = clsx(unsafelyReplaceClassName || "sps-button-group", className);
    return (React.createElement("div", __assign$1K({ className: classes }, rest),
        links.length > 0 && links,
        linkAndIconOrOther && React.createElement("div", { className: "sps-vertical-rule" }),
        iconButtons.length > 0 && iconButtons,
        iconAndOther && React.createElement("div", { className: "sps-vertical-rule" }),
        others.length > 0 && others));
}
Object.assign(SpsButtonGroup, {
    props: propsDoc$1x,
    propTypes: propTypes$1A,
    displayName: "SpsButtonGroup",
});

var __makeTemplateObject$U = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsButtonExamples = {
    basic: {
        label: "Basic Buttons",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("span", { className: "sps-body-14 mt-4" },
                "The most common type of button that can be used in most cases. Example: Basic Buttons in a ",
                React.createElement(NavigateTo, { to: "Modal" }, "Modal"),
                "."));
        },
        examples: {
            basic: {
                description: "Without Icons",
                jsx: code(templateObject_1$U || (templateObject_1$U = __makeTemplateObject$U(["\n                    <>\n                        <SpsButton className=\"mr-1 mb-1\">Default</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.KEY}>Key</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.CONFIRM}>Confirm</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.DELETE}>Delete</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" disabled>Disabled</SpsButton>\n                    </>\n                "], ["\n                    <>\n                        <SpsButton className=\"mr-1 mb-1\">Default</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.KEY}>Key</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.CONFIRM}>Confirm</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.DELETE}>Delete</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" disabled>Disabled</SpsButton>\n                    </>\n                "]))),
            },
            buttonsWithIcons: {
                description: "With Icons",
                jsx: code(templateObject_2$O || (templateObject_2$O = __makeTemplateObject$U(["\n                    <>\n                        <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.DOWNLOAD_CLOUD}>\n                            Default\n                        </SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.KEY} kind={ButtonKind.KEY}>\n                            Key\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            kind={ButtonKind.CONFIRM}\n                        >\n                            Confirm\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.TRASH}\n                            kind={ButtonKind.DELETE}\n                        >\n                            Delete\n                        </SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.DOWNLOAD_CLOUD} disabled>\n                            Disabled\n                        </SpsButton>\n                    </>\n                "], ["\n                    <>\n                        <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.DOWNLOAD_CLOUD}>\n                            Default\n                        </SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.KEY} kind={ButtonKind.KEY}>\n                            Key\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            kind={ButtonKind.CONFIRM}\n                        >\n                            Confirm\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.TRASH}\n                            kind={ButtonKind.DELETE}\n                        >\n                            Delete\n                        </SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.DOWNLOAD_CLOUD} disabled>\n                            Disabled\n                        </SpsButton>\n                    </>\n                "]))),
            },
            spinning: {
                description: "Spinning",
                jsx: code(templateObject_3$F || (templateObject_3$F = __makeTemplateObject$U(["\n                    <>\n                        <SpsButton className=\"mr-1 mb-1\" spinning>Default</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" spinning kind={ButtonKind.KEY}>Key</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" spinning kind={ButtonKind.CONFIRM}>Confirm</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" spinning kind={ButtonKind.DELETE}>Delete</SpsButton>\n                    </>\n                "], ["\n                    <>\n                        <SpsButton className=\"mr-1 mb-1\" spinning>Default</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" spinning kind={ButtonKind.KEY}>Key</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" spinning kind={ButtonKind.CONFIRM}>Confirm</SpsButton>\n                        <SpsButton className=\"mr-1 mb-1\" spinning kind={ButtonKind.DELETE}>Delete</SpsButton>\n                    </>\n                "]))),
            },
        },
    },
    dropDown: {
        label: "Dropdown Buttons",
        description: "Use these for actions that need to select an option to proceed. Example: Download button with options related to the file format (PDF, PPT, etc.).",
        examples: {
            basic: {
                description: "Without Icons",
                jsx: code(templateObject_4$x || (templateObject_4$x = __makeTemplateObject$U(["\n                    <>\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            label=\"Default\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            disabled\n                            label=\"Disabled\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                    </>\n                "], ["\n                    <>\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            label=\"Default\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            disabled\n                            label=\"Disabled\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                    </>\n                "]))),
            },
            withIcon: {
                description: "With Icons",
                jsx: code(templateObject_5$o || (templateObject_5$o = __makeTemplateObject$U(["\n                    <>\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            label=\"Default\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.TRASH}\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            disabled\n                            label=\"Disabled\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                    </>\n                "], ["\n                    <>\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            label=\"Default\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.TRASH}\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                            disabled\n                            label=\"Disabled\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                    </>\n                "]))),
            },
            spinning: {
                description: "Spinning",
                jsx: code(templateObject_6$i || (templateObject_6$i = __makeTemplateObject$U(["\n                    <>\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            label=\"Default\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                    </>\n                "], ["\n                    <>\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            label=\"Default\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                        <SpsDropdown\n                            spinning\n                            className=\"mr-1 mb-1\"\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                            options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                        />\n                    </>\n                "]))),
            },
        },
    },
    split: {
        label: "Split Buttons",
        description: "Use when there is 1 primary action and other related actions can be taken.",
        examples: {
            basic: {
                description: "Without Icons",
                jsx: code(templateObject_7$e || (templateObject_7$e = __makeTemplateObject$U(["\n                <>\n                    <SpsSplitButton className=\"mr-1 mb-1\" label=\"Default\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" kind={ButtonKind.KEY} label=\"Key\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" kind={ButtonKind.CONFIRM} label=\"Confirm\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" kind={ButtonKind.DELETE} label=\"Delete\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" disabled label=\"Disabled\" />\n                </>\n                "], ["\n                <>\n                    <SpsSplitButton className=\"mr-1 mb-1\" label=\"Default\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" kind={ButtonKind.KEY} label=\"Key\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" kind={ButtonKind.CONFIRM} label=\"Confirm\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" kind={ButtonKind.DELETE} label=\"Delete\" />\n                    <SpsSplitButton className=\"mr-1 mb-1\" disabled label=\"Disabled\" />\n                </>\n                "]))),
            },
            withIcon: {
                description: "With Icons",
                jsx: code(templateObject_8$d || (templateObject_8$d = __makeTemplateObject$U(["\n                    <>\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            label=\"Default\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            disabled\n                            label=\"Disabled\"\n                        />\n                    </>\n                "], ["\n                    <>\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            label=\"Default\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            kind={ButtonKind.KEY}\n                            label=\"Key\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            kind={ButtonKind.CONFIRM}\n                            label=\"Confirm\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            kind={ButtonKind.DELETE}\n                            label=\"Delete\"\n                        />\n                        <SpsSplitButton\n                            className=\"mr-1 mb-1\"\n                            icon={SpsIcon.PLUS_SIGN}\n                            disabled\n                            label=\"Disabled\"\n                        />\n                    </>\n                "]))),
            },
        },
    },
    iconButtons: {
        label: "Icon Buttons",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("span", { className: "sps-body-14 mt-4" },
                "Use these for quick actions that can clearly be articulated by the use of an icon. Example: A Print button in the",
                " ",
                React.createElement(NavigateTo, { to: "List Action Bar" }, "List Action Bar"),
                ". ",
                React.createElement("br", null),
                " Do not use an icon that that doesn\u2019t have a universally understood meaning; instead use a Basic Button or a Basic Button with an icon. ",
                React.createElement("br", null),
                " ",
                React.createElement("a", { href: "#style-and-layout/icons" }, "View All Icons")));
        },
        examples: {
            basic: {
                description: "Standard Icon Buttons",
                jsx: code(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PENCIL} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.X} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.TRASH} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.GEAR} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PLUS_SIGN} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.MINUS} />\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PENCIL} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.X} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.TRASH} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.GEAR} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PLUS_SIGN} />\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.MINUS} />\n                </>\n                "]))),
            },
            dropdown: {
                description: function (_a) {
                    var NavigateTo = _a.NavigateTo;
                    return (React.createElement(React.Fragment, null,
                        React.createElement("h5", null, "Dropdown Icon Button"),
                        React.createElement("span", { className: "sps-body-14 mt-4" },
                            "Use these when there are several options available for action. Example: Dropdown Icon Button in a",
                            " ",
                            React.createElement(NavigateTo, { to: "Content Row" }, "Content Row"),
                            ".")));
                },
                jsx: code(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject$U(["\n                    <SpsDropdown\n                        className=\"mr-1 mb-1\"\n                        kind={ButtonKind.ICON}\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                    />\n                "], ["\n                    <SpsDropdown\n                        className=\"mr-1 mb-1\"\n                        kind={ButtonKind.ICON}\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                    />\n                "]))),
            },
            spin: {
                description: "Spinner",
                jsx: code(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject$U(["\n                    <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.DOWNLOAD_CLOUD} spinning kind={ButtonKind.ICON} />\n                "], ["\n                    <SpsButton className=\"mr-1 mb-1\" icon={SpsIcon.DOWNLOAD_CLOUD} spinning kind={ButtonKind.ICON} />\n                "]))),
            },
        },
    },
    textButtons: {
        label: "Text Buttons",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("span", { className: "sps-body-14 mt-4" },
                "Use for less important actions, or ones that aren't taken as frequently. They should not appear inline with other copy. Example: Advanced Search button in the",
                " ",
                React.createElement(NavigateTo, { to: "List Toolbar" }, "List Toolbar"),
                "."));
        },
        examples: {
            basic: {
                description: "Without Icons",
                jsx: code(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Default</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1 red200\" kind={ButtonKind.LINK}>Delete</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1 gray500\" kind={ButtonKind.LINK} disabled>Disabled</SpsButton>\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Default</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1 red200\" kind={ButtonKind.LINK}>Delete</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1 gray500\" kind={ButtonKind.LINK} disabled>Disabled</SpsButton>\n                </>\n                "]))),
            },
            icon: {
                description: "With Icons",
                jsx: code(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject$U(["\n                    <>\n                        <SpsButton\n                            className=\"mr-2 mb-1\"\n                            kind={ButtonKind.LINK}\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                        >\n                            Default\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-2 mb-1 red200\"\n                            kind={ButtonKind.LINK}\n                            icon={SpsIcon.TRASH}\n                        >\n                            Delete\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-2 mb-1 gray500\"\n                            kind={ButtonKind.LINK}\n                            icon={SpsIcon.GEAR}\n                            disabled\n                        >\n                            Disabled\n                        </SpsButton>\n                    </>\n                "], ["\n                    <>\n                        <SpsButton\n                            className=\"mr-2 mb-1\"\n                            kind={ButtonKind.LINK}\n                            icon={SpsIcon.DOWNLOAD_CLOUD}\n                        >\n                            Default\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-2 mb-1 red200\"\n                            kind={ButtonKind.LINK}\n                            icon={SpsIcon.TRASH}\n                        >\n                            Delete\n                        </SpsButton>\n                        <SpsButton\n                            className=\"mr-2 mb-1 gray500\"\n                            kind={ButtonKind.LINK}\n                            icon={SpsIcon.GEAR}\n                            disabled\n                        >\n                            Disabled\n                        </SpsButton>\n                    </>\n                "]))),
            },
            spin: {
                description: "Spinner",
                jsx: code(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject$U(["\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK} spinning>Default</SpsButton>\n                "], ["\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK} spinning>Default</SpsButton>\n                "]))),
            },
        },
    },
    submitButtons: {
        label: "Submit Buttons",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("span", { className: "sps-body-14 mt-4" },
                "Used to submit a form. There can be a number of visual variations, for example a",
                " ",
                React.createElement(NavigateTo, { to: "Modal" }, "Modal"),
                " uses Basic Button (Key) as its Submit Button."));
        },
        examples: {
            basic: {
                react: code(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject$U(["\n                    function DemoComponent() {\n                        const { formMeta, formValue, updateForm } = useSpsForm({});\n\n                        function alertOnSubmit() {\n                            window.alert(\"Form submitted\");\n                        }\n\n                        return (\n                            <>\n                                <SpsForm formMeta={formMeta} onSubmit={alertOnSubmit}>\n                                    {/* Use only one Submit button in your form */}\n                                    <SpsButton\n                                        className=\"mr-2 mb-1\"\n                                        type={ButtonType.SUBMIT}\n                                        kind={ButtonKind.KEY}\n                                    >\n                                        Key\n                                    </SpsButton>\n                                    <SpsButton\n                                        className=\"mr-2 mb-1\"\n                                        type={ButtonType.SUBMIT}\n                                        kind={ButtonKind.CONFIRM}\n                                    >\n                                        Confirm\n                                    </SpsButton>\n                                </SpsForm>\n                            </>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formMeta, formValue, updateForm } = useSpsForm({});\n\n                        function alertOnSubmit() {\n                            window.alert(\"Form submitted\");\n                        }\n\n                        return (\n                            <>\n                                <SpsForm formMeta={formMeta} onSubmit={alertOnSubmit}>\n                                    {/* Use only one Submit button in your form */}\n                                    <SpsButton\n                                        className=\"mr-2 mb-1\"\n                                        type={ButtonType.SUBMIT}\n                                        kind={ButtonKind.KEY}\n                                    >\n                                        Key\n                                    </SpsButton>\n                                    <SpsButton\n                                        className=\"mr-2 mb-1\"\n                                        type={ButtonType.SUBMIT}\n                                        kind={ButtonKind.CONFIRM}\n                                    >\n                                        Confirm\n                                    </SpsButton>\n                                </SpsForm>\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    linkButtons: {
        label: "Button as Link",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("span", { className: "sps-body-14 mt-4" },
                "Used to link to another page, such as an external website. They may open in the same window or in a new one. It should only be used when a",
                " ",
                React.createElement(NavigateTo, { to: "Text Button" }, "Text Button"),
                " doesn't provide enough visual emphasis."));
        },
        examples: {
            basic: {
                jsx: code(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject$U(["\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.DEFAULT} href=\"https://google.com\">Button Text</SpsButton>\n                "], ["\n                    <SpsButton className=\"mr-1 mb-1\" kind={ButtonKind.DEFAULT} href=\"https://google.com\">Button Text</SpsButton>\n                "]))),
            },
        },
    },
    groupButtons: {
        label: "Button Groups",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("span", { className: "sps-body-14 mt-4" },
                "Use button groups when there are a number of actions that can be taken in a view. When there are multiple button types in a group, they are separated using dividers. Example: Button groups in",
                " ",
                React.createElement(NavigateTo, { to: "List Action Bar" }, "List Action Bar"),
                "."));
        },
        examples: {
            basic: {
                description: "Basic Button Groups",
                jsx: code(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Cancel</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Save</SpsButton>\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Cancel</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Save</SpsButton>\n                </>\n                "]))),
            },
            icon: {
                description: "Icon Button Groups",
                jsx: code(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PENCIL}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.TRASH}/>\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PENCIL}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.TRASH}/>\n                </>\n                "]))),
            },
            textIcon: {
                description: "Text Buttons + Icon Buttons Group",
                jsx: code(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Text Button</SpsButton>\n                    <SpsVr/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER}/>\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Text Button</SpsButton>\n                    <SpsVr/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER}/>\n                </>\n                "]))),
            },
            textBasic: {
                description: "Text Buttons + Basic Buttons Group",
                jsx: code(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Text Button</SpsButton>\n                    <SpsVr/>\n                    <SpsButton className=\"ml-2 mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.CONFIRM}>Button</SpsButton>\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Text Button</SpsButton>\n                    <SpsVr/>\n                    <SpsButton className=\"ml-2 mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.CONFIRM}>Button</SpsButton>\n                </>\n                "]))),
            },
            iconBasic: {
                description: "Icon Buttons + Basic Buttons Group",
                jsx: code(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER}/>\n                    <SpsVr/>\n                    <SpsButton className=\"ml-2 mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.CONFIRM}>Button</SpsButton>\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER}/>\n                    <SpsVr/>\n                    <SpsButton className=\"ml-2 mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.CONFIRM}>Button</SpsButton>\n                </>\n                "]))),
            },
            textIconBasic: {
                description: "Text Buttons + Icon Buttons + Basic Buttons Group",
                jsx: code(templateObject_22$1 || (templateObject_22$1 = __makeTemplateObject$U(["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Text Button</SpsButton>\n                    <SpsVr/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER}/>\n                    <SpsVr/>\n                    <SpsButton className=\"ml-2 mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.CONFIRM}>Button</SpsButton>\n                </>\n                "], ["\n                <>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.LINK}>Text Button</SpsButton>\n                    <SpsVr/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD}/>\n                    <SpsButton className=\"mb-1\" kind={ButtonKind.ICON} icon={SpsIcon.PRINTER}/>\n                    <SpsVr/>\n                    <SpsButton className=\"ml-2 mr-2 mb-1\" kind={ButtonKind.DEFAULT}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.KEY}>Button</SpsButton>\n                    <SpsButton className=\"mr-2 mb-1\" kind={ButtonKind.CONFIRM}>Button</SpsButton>\n                </>\n                "]))),
            },
        },
    },
};
var templateObject_1$U, templateObject_2$O, templateObject_3$F, templateObject_4$x, templateObject_5$o, templateObject_6$i, templateObject_7$e, templateObject_8$d, templateObject_9$9, templateObject_10$7, templateObject_11$6, templateObject_12$3, templateObject_13$3, templateObject_14$3, templateObject_15$2, templateObject_16$2, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21$1, templateObject_22$1;

var __makeTemplateObject$T = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsCardExamples = {
    general: {
        label: 'General Usage',
        description: function (_a) {
            var Link = _a.Link, NavigateTo = _a.NavigateTo;
            return (React.createElement(React.Fragment, null,
                React.createElement("h5", null, "Sizing and Layout"),
                React.createElement("p", null,
                    "All varieties of Cards should be placed on the SPS Grid (i.e. the width of a Card should span a specific number of grid columns). They should never be set to a custom width. See the ",
                    React.createElement(Link, { to: "/style-and-layout/grid" }, "SPS Grid"),
                    " and",
                    ' ',
                    React.createElement(Link, { to: "/style-and-layout/page-types" }, "Page Layouts"),
                    " sections for more guidance on appropriate usage."),
                React.createElement("p", null, "The height of a Card should typically be based on the content inside of it, but in specific cases a fixed height can be set. For these cases, content will scroll vertically inside of the container."),
                React.createElement("h5", null, "Text Content"),
                React.createElement("p", null,
                    "The only text content that can exist outside of a Card is the",
                    ' ',
                    React.createElement(NavigateTo, { to: "page-title" }, "Page Title"),
                    " component"),
                React.createElement("p", null,
                    "All other content should exist inside of a Card and should adhere to the SPS Design System ",
                    React.createElement(Link, { to: "/style-and-layout/typography" }, "Typography"),
                    " rules."),
                React.createElement("h5", null, "Nesting"),
                React.createElement("p", null, "Avoid nesting Cards inside of other Cards when possible. If nesting is necessary, avoid nesting more than one level deep (i.e. limit nesting to a Card inside of a Card).")));
        },
    },
    basic: {
        label: 'Basic card',
        description: function () { return (React.createElement("p", null, "Basic Cards can include any type of general content, such as body copy, description lists, or more complex content such as forms.")); },
        examples: {
            basic: {
                jsx: code(templateObject_1$T || (templateObject_1$T = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <p>Business is changing... changing at the speed of information.</p>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <p>Business is changing... changing at the speed of information.</p>\n                    </SpsCardV2>\n                "]))),
            },
            sections: {
                jsx: code(templateObject_2$N || (templateObject_2$N = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <section>\n                            <h3>Description</h3>\n                            <p>\n                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt\n                                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco\n                                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in\n                                voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat\n                                non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                            </p>\n                        </section>\n                        <section>\n                            <h3>Usage Guidelines</h3>\n                            <p>\n                                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque\n                                laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi\n                                architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit\n                                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione\n                                voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n                                consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et\n                                dolore magnam aliquam quaerat voluptatem.\n                            </p>\n                        </section>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <section>\n                            <h3>Description</h3>\n                            <p>\n                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt\n                                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco\n                                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in\n                                voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat\n                                non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                            </p>\n                        </section>\n                        <section>\n                            <h3>Usage Guidelines</h3>\n                            <p>\n                                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque\n                                laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi\n                                architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit\n                                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione\n                                voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n                                consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et\n                                dolore magnam aliquam quaerat voluptatem.\n                            </p>\n                        </section>\n                    </SpsCardV2>\n                "]))),
            },
            nestedSections: {
                jsx: code(templateObject_3$E || (templateObject_3$E = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <section>\n                            <p>Card Header</p>\n                        </section>\n                        <section className=\"d-flex\">\n                            <section>\n                                <p>Section 1</p>\n                            </section>\n                            <section>\n                                <p>Section 2</p>\n                            </section>\n                            <section>\n                                <p>Section 3</p>\n                            </section>\n                        </section>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <section>\n                            <p>Card Header</p>\n                        </section>\n                        <section className=\"d-flex\">\n                            <section>\n                                <p>Section 1</p>\n                            </section>\n                            <section>\n                                <p>Section 2</p>\n                            </section>\n                            <section>\n                                <p>Section 3</p>\n                            </section>\n                        </section>\n                    </SpsCardV2>\n                "]))),
            },
        },
    },
    headers: {
        label: 'Card + Header',
        description: function () { return (React.createElement("p", null, "Headers can be attached to a Card to display a title (that describes the content inside the card) or add actions (buttons or links) that relate directly to the content inside of the card. Content is restricted to the left side (for titles) and right side (for actions) of the Header.")); },
        examples: {
            title: {
                jsx: code(templateObject_4$w || (templateObject_4$w = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <SpsCardV2Header className=\"sfg-row\">\n                            <div className=\"sfg-col-6\">\n                                <SpsCardV2Title>\n                                    <SpsI icon={SpsIcon.LIGHTBULB} />\n                                    Jabberwocky\n                                </SpsCardV2Title>\n                            </div>\n                            <div className=\"sfg-col-6 text-right\">\n                                <SpsButton\n                                    className=\"mr-2\"\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Redefine\n                                </SpsButton>\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.PRINTER}\n                                />\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.DOWNLOAD_CLOUD}\n                                />\n                                <SpsButton\n                                    className=\"ml-2\"\n                                >\n                                    Innovate\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Header>\n                        <p>Whoever adapts first wins. In order to compete, we innovate; in order to innovate, we redefine; and how do we redefine? With a new definition!</p>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <SpsCardV2Header className=\"sfg-row\">\n                            <div className=\"sfg-col-6\">\n                                <SpsCardV2Title>\n                                    <SpsI icon={SpsIcon.LIGHTBULB} />\n                                    Jabberwocky\n                                </SpsCardV2Title>\n                            </div>\n                            <div className=\"sfg-col-6 text-right\">\n                                <SpsButton\n                                    className=\"mr-2\"\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Redefine\n                                </SpsButton>\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.PRINTER}\n                                />\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.DOWNLOAD_CLOUD}\n                                />\n                                <SpsButton\n                                    className=\"ml-2\"\n                                >\n                                    Innovate\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Header>\n                        <p>Whoever adapts first wins. In order to compete, we innovate; in order to innovate, we redefine; and how do we redefine? With a new definition!</p>\n                    </SpsCardV2>\n                "]))),
            },
        },
    },
    footers: {
        label: 'Card + Footer',
        description: function () { return (React.createElement("p", null, "Footers can be attached to a Card to add secondary actions (buttons or links) that relate directly to the content inside of it, or other types of general content that may be applicable. Content can be placed in the middle or either side of the Footer.")); },
        examples: {
            basicFooter: {
                jsx: code(templateObject_5$n || (templateObject_5$n = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <p>Imagine a new way to do business that's faster than a cheetah. More powerful than... another cheetah! A way of doing business more magnificent than... a fish! Or a whale!</p>\n                        <SpsCardV2Footer className=\"sfg-row\">\n                            <div className=\"sfg-col-4\">\n                                <SpsButton\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Manage Settings\n                                </SpsButton>\n                            </div>\n                            <div className=\"sfg-col-4\">\n                                Whales are not fish, but mammals like a Cheetah.\n                            </div>\n                            <div className=\"sfg-col-4 text-right\">\n                                <SpsButton>\n                                    Buy This\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Footer>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <p>Imagine a new way to do business that's faster than a cheetah. More powerful than... another cheetah! A way of doing business more magnificent than... a fish! Or a whale!</p>\n                        <SpsCardV2Footer className=\"sfg-row\">\n                            <div className=\"sfg-col-4\">\n                                <SpsButton\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Manage Settings\n                                </SpsButton>\n                            </div>\n                            <div className=\"sfg-col-4\">\n                                Whales are not fish, but mammals like a Cheetah.\n                            </div>\n                            <div className=\"sfg-col-4 text-right\">\n                                <SpsButton>\n                                    Buy This\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Footer>\n                    </SpsCardV2>\n                "]))),
            },
        },
    },
    tabbed: {
        label: 'Card + Tabs',
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Use Tabs to combine multiple cards with unique but related content. Tabs can include optional details such as icons or tags."),
            React.createElement("p", null,
                React.createElement("code", null, "<Item>"),
                " comes from the ",
                React.createElement("code", null, "@react-stately/collections"),
                "package, which is a peer dependency of our React components."))); },
        examples: {
            tabsOnly: {
                jsx: code(templateObject_6$h || (templateObject_6$h = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <SpsTabsV2>\n                            <Item\n                                key=\"tab1\"\n                                title=\"Trust\"\n                            >\n                                <p>So, what is it? What is it exactly that's going to revolutionize the way we do business?</p>\n                            </Item>\n                            <Item key=\"tab2\" title={\n                                <>\n                                    <span>Reliability</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 2.</p>\n                            </Item>\n                            <Item key=\"tab3\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>The Future</span>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 3.</p>\n                            </Item>\n                            <Item key=\"tab4\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>Bold</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 4.</p>\n                            </Item>\n                        </SpsTabsV2>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <SpsTabsV2>\n                            <Item\n                                key=\"tab1\"\n                                title=\"Trust\"\n                            >\n                                <p>So, what is it? What is it exactly that's going to revolutionize the way we do business?</p>\n                            </Item>\n                            <Item key=\"tab2\" title={\n                                <>\n                                    <span>Reliability</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 2.</p>\n                            </Item>\n                            <Item key=\"tab3\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>The Future</span>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 3.</p>\n                            </Item>\n                            <Item key=\"tab4\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>Bold</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 4.</p>\n                            </Item>\n                        </SpsTabsV2>\n                    </SpsCardV2>\n                "]))),
            },
            activeTabInput: {
                jsx: code(templateObject_7$d || (templateObject_7$d = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <SpsTabsV2 disabledKeys={[\"tab2\", \"tab3\"]}>\n                            <Item key=\"tab1\" title=\"Tab 1\">\n                                <p>Card with disabled tabs, pane 1.</p>\n                            </Item>\n                            <Item key=\"tab2\" title=\"Tab 2\">\n                            <p>Card with disabled tabs, pane 2.</p>\n                            </Item>\n                            <Item key=\"tab3\" title=\"Tab 3\">\n                                <p>Card with disabled tabs, pane 3.</p>\n                            </Item>\n                        </SpsTabsV2>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <SpsTabsV2 disabledKeys={[\"tab2\", \"tab3\"]}>\n                            <Item key=\"tab1\" title=\"Tab 1\">\n                                <p>Card with disabled tabs, pane 1.</p>\n                            </Item>\n                            <Item key=\"tab2\" title=\"Tab 2\">\n                            <p>Card with disabled tabs, pane 2.</p>\n                            </Item>\n                            <Item key=\"tab3\" title=\"Tab 3\">\n                                <p>Card with disabled tabs, pane 3.</p>\n                            </Item>\n                        </SpsTabsV2>\n                    </SpsCardV2>\n                "]))),
            },
        },
    },
    everything: {
        label: 'Card + Header + Footer + Tabs',
        description: function () { return (React.createElement("p", null, "Headers, Footers, and Tabs can be attached to Cards in any combination.")); },
        examples: {
            everything: {
                jsx: code(templateObject_8$c || (templateObject_8$c = __makeTemplateObject$T(["\n                    <SpsCardV2>\n                        <SpsCardV2Header className=\"sfg-row\">\n                            <div className=\"sfg-col-6\">\n                                <SpsCardV2Title>\n                                    <SpsI className=\"gray500\" icon={SpsIcon.STATUS_OK} />\n                                    Panel_With_Cap\n                                </SpsCardV2Title>\n                            </div>\n                            <div className=\"sfg-col-6 text-right\">\n                                <SpsButton\n                                    className=\"mr-2\"\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Redefine\n                                </SpsButton>\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.PRINTER}\n                                />\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.DOWNLOAD_CLOUD}\n                                />\n                                <SpsButton\n                                    className=\"ml-2\"\n                                >\n                                    Innovate\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Header>\n                        <SpsTabsV2>\n                            <Item key=\"tab1\" title=\"Trust\">\n                                <p>Simple... it's Jabberwocky.</p>\n                                <p>The game is changing right now.</p>\n                                <p>Coming in 2012.</p>\n                            </Item>\n                            <Item key=\"tab2\" title={\n                                <>\n                                    <span>Reliability</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 2.</p>\n                            </Item>\n                            <Item key=\"tab3\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>The Future</span>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 3.</p>\n                            </Item>\n                            <Item key=\"tab4\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>Bold</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 4.</p>\n                            </Item>\n                        </SpsTabsV2>\n                        <SpsCardV2Footer>\n                            <div className=\"text-right\">\n                                <SpsButton\n                                    className=\"mr-2\"\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Redefine\n                                </SpsButton>\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.PRINTER}\n                                />\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.DOWNLOAD_CLOUD}\n                                />\n                                <SpsButton\n                                    className=\"ml-2\"\n                                >\n                                    Innovate\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Footer>\n                    </SpsCardV2>\n                "], ["\n                    <SpsCardV2>\n                        <SpsCardV2Header className=\"sfg-row\">\n                            <div className=\"sfg-col-6\">\n                                <SpsCardV2Title>\n                                    <SpsI className=\"gray500\" icon={SpsIcon.STATUS_OK} />\n                                    Panel_With_Cap\n                                </SpsCardV2Title>\n                            </div>\n                            <div className=\"sfg-col-6 text-right\">\n                                <SpsButton\n                                    className=\"mr-2\"\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Redefine\n                                </SpsButton>\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.PRINTER}\n                                />\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.DOWNLOAD_CLOUD}\n                                />\n                                <SpsButton\n                                    className=\"ml-2\"\n                                >\n                                    Innovate\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Header>\n                        <SpsTabsV2>\n                            <Item key=\"tab1\" title=\"Trust\">\n                                <p>Simple... it's Jabberwocky.</p>\n                                <p>The game is changing right now.</p>\n                                <p>Coming in 2012.</p>\n                            </Item>\n                            <Item key=\"tab2\" title={\n                                <>\n                                    <span>Reliability</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 2.</p>\n                            </Item>\n                            <Item key=\"tab3\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>The Future</span>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 3.</p>\n                            </Item>\n                            <Item key=\"tab4\" title={\n                                <>\n                                    <SpsI icon={SpsIcon.HEART} />\n                                    <span>Bold</span>\n                                    <SpsTag kind={TagKind.KEY}>00</SpsTag>\n                                </>\n                            }>\n                                <p>Card with tabs, pane 4.</p>\n                            </Item>\n                        </SpsTabsV2>\n                        <SpsCardV2Footer>\n                            <div className=\"text-right\">\n                                <SpsButton\n                                    className=\"mr-2\"\n                                    kind={ButtonKind.LINK}\n                                >\n                                    Redefine\n                                </SpsButton>\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.PRINTER}\n                                />\n                                <SpsButton\n                                    kind={ButtonKind.ICON}\n                                    icon={SpsIcon.DOWNLOAD_CLOUD}\n                                />\n                                <SpsButton\n                                    className=\"ml-2\"\n                                >\n                                    Innovate\n                                </SpsButton>\n                            </div>\n                        </SpsCardV2Footer>\n                    </SpsCardV2>\n                "]))),
            },
        },
    },
};
var templateObject_1$T, templateObject_2$N, templateObject_3$E, templateObject_4$w, templateObject_5$n, templateObject_6$h, templateObject_7$d, templateObject_8$c;

var __assign$1J = (undefined && undefined.__assign) || function () {
    __assign$1J = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1J.apply(this, arguments);
};
var __rest$1o = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$O = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1w = {
    checked: "boolean",
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<boolean>",
    indeterminate: "boolean",
    inline: "boolean",
    label: "string",
    onChange: "ChangeEventHandler",
};
var propTypes$1z = __assign$1J(__assign$1J({}, spsGlobalPropTypes), { checked: propTypes$1H.exports.bool, disabled: propTypes$1H.exports.bool, formControl: impl(), formMeta: impl(), indeterminate: propTypes$1H.exports.bool, inline: propTypes$1H.exports.bool, label: propTypes$1H.exports.string, onChange: fun() });
function SpsCheckbox(_a) {
    var checkedProp = _a.checked, className = _a.className, disabled = _a.disabled, formControl = _a.formControl, formMeta = _a.formMeta, id = _a.id, indeterminateProp = _a.indeterminate, inline = _a.inline, label = _a.label, onChange = _a.onChange, testId = _a["data-testid"], unsafelyReplaceClassName = _a.unsafelyReplaceClassName, rest = __rest$1o(_a, ["checked", "className", "disabled", "formControl", "formMeta", "id", "indeterminate", "inline", "label", "onChange", "data-testid", "unsafelyReplaceClassName"]);
    var meta = formMeta || formControl;
    var inputElement = React.useRef();
    var _b = __read$O(React.useState(checkedProp), 2), checked = _b[0], setChecked = _b[1];
    var _c = __read$O(React.useState(indeterminateProp), 2), indeterminate = _c[0], setIndeterminate = _c[1];
    var _d = useFormControlId(id, meta), wrapperId = _d.wrapperId, controlId = _d.controlId;
    React.useEffect(function () { return setChecked(checkedProp); }, [checkedProp]);
    React.useEffect(function () { return setIndeterminate(indeterminateProp); }, [indeterminateProp]);
    React.useEffect(function () {
        inputElement.current.indeterminate = indeterminate;
    }, [indeterminate]);
    var classes = clsx(unsafelyReplaceClassName || "sps-checkbox", "sps-checkable", inline && "sps-checkable--inline", !label && "sps-checkable--no-label", className);
    function handleChange(event) {
        setChecked(event.target.checked);
        setIndeterminate(false);
        if (meta) {
            meta.setValue(event.target.checked);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(event);
        }
        inputElement.current.focus();
    }
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formControl: formControl, formMeta: formMeta, inputRef: inputElement, "data-testid": testId },
        React.createElement("input", __assign$1J({ type: "checkbox", ref: inputElement, className: "sps-checkable__input", id: controlId, checked: checked, disabled: disabled, "data-testId": testId + "__checkbox-input", onChange: handleChange }, rest)),
        React.createElement("label", { className: "sps-checkable__label", htmlFor: controlId }, label || "")));
}
Object.assign(SpsCheckbox, {
    props: propsDoc$1w,
    propTypes: propTypes$1z,
    displayName: "SpsCheckbox",
});

var __makeTemplateObject$S = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsCheckboxExamples = {
    labels: {
        label: "Labels",
        description: code(templateObject_1$S || (templateObject_1$S = __makeTemplateObject$S(["\n            <p>An individual checkbox should be labeled with its own <code>label</code> prop,\n            not the <code>&lt;SpsLabel&gt;</code> component.</p>\n        "], ["\n            <p>An individual checkbox should be labeled with its own <code>label</code> prop,\n            not the <code>&lt;SpsLabel&gt;</code> component.</p>\n        "]))),
        examples: {
            label: {
                react: code(templateObject_2$M || (templateObject_2$M = __makeTemplateObject$S(["\n                function DemoComponent() {\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        red: true,\n                        blue: false,\n                        green: false,\n                    })\n\n                    return <>\n                        <SpsCheckbox\n                            name=\"red\"\n                            label=\"Red\"\n                            checked={formValue.red}\n                            formMeta={formMeta.fields.red}\n                        />\n                        <SpsCheckbox\n                            name=\"blue\"\n                            label=\"Blue\"\n                            checked={formValue.blue}\n                            formMeta={formMeta.fields.blue}\n                        />\n                        <SpsCheckbox\n                            name=\"green\"\n                            label=\"Green\"\n                            checked={formValue.green}\n                            formMeta={formMeta.fields.green}\n                            indeterminate\n                        />\n                    </>\n                  }\n                "], ["\n                function DemoComponent() {\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        red: true,\n                        blue: false,\n                        green: false,\n                    })\n\n                    return <>\n                        <SpsCheckbox\n                            name=\"red\"\n                            label=\"Red\"\n                            checked={formValue.red}\n                            formMeta={formMeta.fields.red}\n                        />\n                        <SpsCheckbox\n                            name=\"blue\"\n                            label=\"Blue\"\n                            checked={formValue.blue}\n                            formMeta={formMeta.fields.blue}\n                        />\n                        <SpsCheckbox\n                            name=\"green\"\n                            label=\"Green\"\n                            checked={formValue.green}\n                            formMeta={formMeta.fields.green}\n                            indeterminate\n                        />\n                    </>\n                  }\n                "]))),
            },
        },
    },
    b_disabled: {
        label: "Disabled",
        examples: {
            disabled: {
                react: code(templateObject_3$D || (templateObject_3$D = __makeTemplateObject$S(["\n                function DemoComponent() {\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        red: true,\n                        blue: false,\n                        green: false,\n                    })\n\n                    return <>\n                        <SpsCheckbox\n                            name=\"red\"\n                            label=\"Red\"\n                            checked={formValue.red}\n                            formMeta={formMeta.fields.red}\n                            disabled\n                        />\n                        <SpsCheckbox\n                            name=\"blue\"\n                            label=\"Blue\"\n                            checked={formValue.blue}\n                            formMeta={formMeta.fields.blue}\n                            disabled\n                        />\n                        <SpsCheckbox\n                            name=\"green\"\n                            label=\"Green\"\n                            checked={formValue.green}\n                            formMeta={formMeta.fields.green}\n                            indeterminate\n                            disabled\n                        />\n                    </>\n                  }\n                "], ["\n                function DemoComponent() {\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        red: true,\n                        blue: false,\n                        green: false,\n                    })\n\n                    return <>\n                        <SpsCheckbox\n                            name=\"red\"\n                            label=\"Red\"\n                            checked={formValue.red}\n                            formMeta={formMeta.fields.red}\n                            disabled\n                        />\n                        <SpsCheckbox\n                            name=\"blue\"\n                            label=\"Blue\"\n                            checked={formValue.blue}\n                            formMeta={formMeta.fields.blue}\n                            disabled\n                        />\n                        <SpsCheckbox\n                            name=\"green\"\n                            label=\"Green\"\n                            checked={formValue.green}\n                            formMeta={formMeta.fields.green}\n                            indeterminate\n                            disabled\n                        />\n                    </>\n                  }\n                "]))),
            },
        },
    },
    c_noLabels: {
        label: "No Label",
        description: code(templateObject_4$v || (templateObject_4$v = __makeTemplateObject$S(["\n            <p>Checkboxes without labels are used in table rows and Summary List Rows\n            to allow those rows to be selected and deselected. They are not normally\n            used elsewhere and doing so should be done with utmost caution. Any checkbox\n            without a label should visually have an obvious purpose and should always have\n            an <code>aria-label</code> describing what it's for to screen reader users.</p>\n        "], ["\n            <p>Checkboxes without labels are used in table rows and Summary List Rows\n            to allow those rows to be selected and deselected. They are not normally\n            used elsewhere and doing so should be done with utmost caution. Any checkbox\n            without a label should visually have an obvious purpose and should always have\n            an <code>aria-label</code> describing what it's for to screen reader users.</p>\n        "]))),
        examples: {
            noLabels: {
                react: code(templateObject_5$m || (templateObject_5$m = __makeTemplateObject$S(["\n                    function Component() {\n                        const [rowIsSelected, setRowIsSelected] = React.useState(true);\n\n                        function handleSelectionChange(event) {\n                            setRowIsSelected(event.target.checked);\n                        }\n\n                        return (\n                            <SpsSummaryListRow selected={rowIsSelected}>\n                                <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                    <SpsCheckbox aria-label=\"Row Selected\" checked={rowIsSelected} onChange={handleSelectionChange}/>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn>\n                                    <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                    <div className=\"d-inline-block align-middle\">\n                                        <div className=\"fs-18\">\n                                            <a href=\"#\">Heading</a>\n                                        </div>\n                                        <div className=\"fs-14\">Sub Heading</div>\n                                    </div>\n                                </SpsSummaryListColumn>\n                            </SpsSummaryListRow>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const [rowIsSelected, setRowIsSelected] = React.useState(true);\n\n                        function handleSelectionChange(event) {\n                            setRowIsSelected(event.target.checked);\n                        }\n\n                        return (\n                            <SpsSummaryListRow selected={rowIsSelected}>\n                                <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                    <SpsCheckbox aria-label=\"Row Selected\" checked={rowIsSelected} onChange={handleSelectionChange}/>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn>\n                                    <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                    <div className=\"d-inline-block align-middle\">\n                                        <div className=\"fs-18\">\n                                            <a href=\"#\">Heading</a>\n                                        </div>\n                                        <div className=\"fs-14\">Sub Heading</div>\n                                    </div>\n                                </SpsSummaryListColumn>\n                            </SpsSummaryListRow>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$S, templateObject_2$M, templateObject_3$D, templateObject_4$v, templateObject_5$m;

var __assign$1I = (undefined && undefined.__assign) || function () {
    __assign$1I = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1I.apply(this, arguments);
};
var __rest$1n = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1v = {
    disabled: "boolean",
    href: "string",
    kind: "ClickableTagKind",
    onAdd: "() => void",
    onRemove: "() => void",
};
var propTypes$1y = __assign$1I(__assign$1I({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, href: propTypes$1H.exports.string, kind: enumValue(ClickableTagKind), onAdd: fun(), onRemove: fun() });
function SpsClickableTag(props) {
    var children = props.children, className = props.className, disabled = props.disabled, href = props.href, _a = props.kind, kind = _a === void 0 ? ClickableTagKind.BLUE : _a, onAdd = props.onAdd, onRemove = props.onRemove, onClick = props.onClick, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1n(props, ["children", "className", "disabled", "href", "kind", "onAdd", "onRemove", "onClick", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-clickable-tag", "sps-clickable-tag--" + kind, className, disabled && "sps-clickable-tag--disabled", (onAdd || onRemove) && "sps-clickable-tag--icon");
    var labelClasses = clsx("sps-clickable-tag__label", (href || onClick) && "sps-clickable-tag__label--link");
    var title = React.Children.toArray(children)
        .filter(function (c) { return typeof c === "string"; })
        .join("");
    function emitEvent(event) {
        if (onAdd) {
            onAdd();
        }
        else if (onRemove) {
            onRemove();
        }
        event.stopPropagation();
    }
    React.useEffect(function () {
        if (onRemove && onAdd) {
            throw new Error("Clickable tag should have onRemove or onAdd, not both");
        }
    }, [onAdd, onRemove]);
    function handleClick(event) {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    }
    return (React.createElement("div", __assign$1I({ className: classes, "data-testid": testId }, rest),
        React.createElement("span", { className: labelClasses, title: title, onClick: handleClick },
            href && React.createElement("a", { href: href }, children),
            !href && children),
        (onAdd || onRemove) && !disabled && (React.createElement("div", { className: "sps-clickable-tag__icon", onClick: disabled ? null : emitEvent, "aria-label": onAdd ? "Add" : "Remove" },
            React.createElement("i", { "aria-hidden": "true", className: "sps-icon sps-icon-" + (onAdd ? SpsIcon.PLUS_SIGN : SpsIcon.X), "data-testid": testId + "__icon" })))));
}
Object.assign(SpsClickableTag, {
    props: propsDoc$1v,
    propTypes: propTypes$1y,
    displayName: "SpsClickableTag",
});

var __makeTemplateObject$R = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsClickableTagExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$R || (templateObject_1$R = __makeTemplateObject$R(["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    import { ClickableTagKind } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsClickableTag className=\"mt-1 ml-1\">Blue</SpsClickableTag>\n                          <SpsClickableTag className=\"mt-1 ml-1\" kind={ClickableTagKind.GRAY}>\n                            Gray\n                          </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "], ["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    import { ClickableTagKind } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsClickableTag className=\"mt-1 ml-1\">Blue</SpsClickableTag>\n                          <SpsClickableTag className=\"mt-1 ml-1\" kind={ClickableTagKind.GRAY}>\n                            Gray\n                          </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "]))),
            },
            disabled: {
                react: code(templateObject_2$L || (templateObject_2$L = __makeTemplateObject$R(["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <SpsClickableTag className=\"mt-1 ml-1\" disabled>\n                          Disabled\n                        </SpsClickableTag>\n                      );\n                    }\n                "], ["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <SpsClickableTag className=\"mt-1 ml-1\" disabled>\n                          Disabled\n                        </SpsClickableTag>\n                      );\n                    }\n                "]))),
            },
        },
    },
    button: {
        label: "Button",
        examples: {
            Remove: {
                react: code(templateObject_3$C || (templateObject_3$C = __makeTemplateObject$R(["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsClickableTag\n                            className=\"mt-1 ml-1\"\n                            onRemove={() => console.log(\"removed\")}\n                          >\n                            One\n                          </SpsClickableTag>\n                          <SpsClickableTag\n                            className=\"mt-1 ml-1\"\n                            onRemove={() => console.log(\"removed\")}\n                          >\n                            Two\n                          </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "], ["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsClickableTag\n                            className=\"mt-1 ml-1\"\n                            onRemove={() => console.log(\"removed\")}\n                          >\n                            One\n                          </SpsClickableTag>\n                          <SpsClickableTag\n                            className=\"mt-1 ml-1\"\n                            onRemove={() => console.log(\"removed\")}\n                          >\n                            Two\n                          </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "]))),
            },
            Add: {
                react: code(templateObject_4$u || (templateObject_4$u = __makeTemplateObject$R(["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsClickableTag className=\"mt-1 ml-1\" onAdd={() => console.log(\"added\")}>\n                            One\n                          </SpsClickableTag>\n                          <SpsClickableTag className=\"mt-1 ml-1\" onAdd={() => console.log(\"added\")}>\n                            Two\n                          </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "], ["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsClickableTag className=\"mt-1 ml-1\" onAdd={() => console.log(\"added\")}>\n                            One\n                          </SpsClickableTag>\n                          <SpsClickableTag className=\"mt-1 ml-1\" onAdd={() => console.log(\"added\")}>\n                            Two\n                          </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "]))),
            },
        },
    },
    link: {
        label: "Link",
        examples: {
            basic: {
                react: code(templateObject_5$l || (templateObject_5$l = __makeTemplateObject$R(["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    import { ClickableTagKind } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                        return (\n                            <>\n                                <SpsClickableTag\n                                    className=\"mt-1 ml-1\"\n                                    href=\"https://google.com\"\n                                >\n                                    Link\n                                </SpsClickableTag>\n                                <SpsClickableTag\n                                    className=\"mt-1 ml-1\"\n                                    onClick={() => window.alert(\"hi\")}\n                                    kind={ClickableTagKind.GRAY}\n                                >\n                                    Link\n                                </SpsClickableTag>\n                            </>\n                        )\n                    }\n                "], ["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    import { ClickableTagKind } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                        return (\n                            <>\n                                <SpsClickableTag\n                                    className=\"mt-1 ml-1\"\n                                    href=\"https://google.com\"\n                                >\n                                    Link\n                                </SpsClickableTag>\n                                <SpsClickableTag\n                                    className=\"mt-1 ml-1\"\n                                    onClick={() => window.alert(\"hi\")}\n                                    kind={ClickableTagKind.GRAY}\n                                >\n                                    Link\n                                </SpsClickableTag>\n                            </>\n                        )\n                    }\n                "]))),
            },
            button: {
                react: code(templateObject_6$g || (templateObject_6$g = __makeTemplateObject$R(["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <>\n                            <SpsClickableTag\n                                className=\"mt-1 ml-1\"\n                                href=\"https://google.com\"\n                                onRemove={() => console.log(\"removed\")}\n                            >\n                                Remove\n                            </SpsClickableTag>\n                            <SpsClickableTag\n                                className=\"mt-1 ml-1\"\n                                onClick={() => window.alert(\"hi\")}\n                                onAdd={() => console.log(\"added\")}\n                            >\n                                Add\n                            </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "], ["\n                    import { SpsClickableTag } from \"@spscommerce/ds-react\";\n                    function Component() {\n                      return (\n                        <>\n                            <SpsClickableTag\n                                className=\"mt-1 ml-1\"\n                                href=\"https://google.com\"\n                                onRemove={() => console.log(\"removed\")}\n                            >\n                                Remove\n                            </SpsClickableTag>\n                            <SpsClickableTag\n                                className=\"mt-1 ml-1\"\n                                onClick={() => window.alert(\"hi\")}\n                                onAdd={() => console.log(\"added\")}\n                            >\n                                Add\n                            </SpsClickableTag>\n                        </>\n                      );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$R, templateObject_2$L, templateObject_3$C, templateObject_4$u, templateObject_5$l, templateObject_6$g;

var _global = {exports: {}};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$3 = _global.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global$3; // eslint-disable-line no-undef

var _core = {exports: {}};

var core$3 = _core.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core$3; // eslint-disable-line no-undef

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding
var aFunction = _aFunction;
var _ctx = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _objectDp = {};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$4 = _isObject;
var _anObject = function (it) {
  if (!isObject$4(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var isObject$3 = _isObject;
var document$2 = _global.exports.document;
// typeof document.createElement is 'object' in old IE
var is$1 = isObject$3(document$2) && isObject$3(document$2.createElement);
var _domCreate = function (it) {
  return is$1 ? document$2.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject$2 = _isObject;
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!isObject$2(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject$2(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject$2(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject$2(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var anObject$3 = _anObject;
var IE8_DOM_DEFINE = _ie8DomDefine;
var toPrimitive = _toPrimitive;
var dP$2 = Object.defineProperty;

_objectDp.f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject$3(O);
  P = toPrimitive(P, true);
  anObject$3(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP$2(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var dP$1 = _objectDp;
var createDesc = _propertyDesc;
var _hide = _descriptors ? function (object, key, value) {
  return dP$1.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$2 = _global.exports;
var core$2 = _core.exports;
var ctx = _ctx;
var hide = _hide;
var has$1 = _has;
var PROTOTYPE$1 = 'prototype';

var $export$7 = function (type, name, source) {
  var IS_FORCED = type & $export$7.F;
  var IS_GLOBAL = type & $export$7.G;
  var IS_STATIC = type & $export$7.S;
  var IS_PROTO = type & $export$7.P;
  var IS_BIND = type & $export$7.B;
  var IS_WRAP = type & $export$7.W;
  var exports = IS_GLOBAL ? core$2 : core$2[name] || (core$2[name] = {});
  var expProto = exports[PROTOTYPE$1];
  var target = IS_GLOBAL ? global$2 : IS_STATIC ? global$2[name] : (global$2[name] || {})[PROTOTYPE$1];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has$1(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global$2)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE$1] = C[PROTOTYPE$1];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$7.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export$7.F = 1;   // forced
$export$7.G = 2;   // global
$export$7.S = 4;   // static
$export$7.P = 8;   // proto
$export$7.B = 16;  // bind
$export$7.W = 32;  // wrap
$export$7.U = 64;  // safe
$export$7.R = 128; // real proto method for `library`
var _export = $export$7;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = _cof;
// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject$1 = _iobject;
var defined$1 = _defined;
var _toIobject = function (it) {
  return IObject$1(defined$1(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor$1 = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor$1 : ceil)(it);
};

// 7.1.15 ToLength
var toInteger$1 = _toInteger;
var min$1 = Math.min;
var _toLength = function (it) {
  return it > 0 ? min$1(toInteger$1(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var toInteger = _toInteger;
var max = Math.max;
var min = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes
var toIObject$2 = _toIobject;
var toLength = _toLength;
var toAbsoluteIndex = _toAbsoluteIndex;
var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject$2($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared = {exports: {}};

var core$1 = _core.exports;
var global$1 = _global.exports;
var SHARED = '__core-js_shared__';
var store = global$1[SHARED] || (global$1[SHARED] = {});

(_shared.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core$1.version,
  mode: 'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared.exports('keys');
var uid = _uid;
var _sharedKey = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

var has = _has;
var toIObject$1 = _toIobject;
var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO$1 = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = toIObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$1) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys$1 = _objectKeysInternal;
var enumBugKeys$1 = _enumBugKeys;

var _objectKeys = Object.keys || function keys(O) {
  return $keys$1(O, enumBugKeys$1);
};

var _objectGops = {};

_objectGops.f = Object.getOwnPropertySymbols;

var _objectPie = {};

_objectPie.f = {}.propertyIsEnumerable;

// 7.1.13 ToObject(argument)
var defined = _defined;
var _toObject = function (it) {
  return Object(defined(it));
};

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS$1 = _descriptors;
var getKeys$2 = _objectKeys;
var gOPS = _objectGops;
var pIE = _objectPie;
var toObject$1 = _toObject;
var IObject = _iobject;
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject$1(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys$2(S).concat(getSymbols(S)) : getKeys$2(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)
var $export$6 = _export;

$export$6($export$6.S + $export$6.F, 'Object', { assign: _objectAssign });

var assign$1 = _core.exports.Object.assign;

var assign = assign$1;

function _extends$1() {
  _extends$1 = assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function areInputsEqual$1(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = useRef(true);
  var committed = useRef(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual$1(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  useEffect(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;

var dP = _objectDp;
var anObject$2 = _anObject;
var getKeys$1 = _objectKeys;

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$2(O);
  var keys = getKeys$1(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$1 = _global.exports.document;
var _html = document$1 && document$1.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject$1 = _anObject;
var dPs = _objectDps;
var enumBugKeys = _enumBugKeys;
var IE_PROTO = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject$1(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

var $export$5 = _export;
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export$5($export$5.S, 'Object', { create: _objectCreate });

var $Object = _core.exports.Object;
var create$1 = function create(P, D) {
  return $Object.create(P, D);
};

var create = create$1;

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject$1 = _isObject;
var anObject = _anObject;
var check = function (O, proto) {
  anObject(O);
  if (!isObject$1(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export$4 = _export;
$export$4($export$4.S, 'Object', { setPrototypeOf: _setProto.set });

var setPrototypeOf$1 = _core.exports.Object.setPrototypeOf;

var setPrototypeOf = setPrototypeOf$1;

function _setPrototypeOf(o, p) {
  _setPrototypeOf = setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var isProduction$1 = process.env.NODE_ENV === 'production';
var prefix$1 = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction$1) {
        throw new Error(prefix$1);
    }
    throw new Error(prefix$1 + ": " + (message || ''));
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$1(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore$1(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore$1)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$2(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators$1(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning$2('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

var ReactReduxContext = /*#__PURE__*/React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = useMemo$1(function () {
    var subscription = createSubscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = useMemo$1(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$1(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var _excluded$2 = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect$1(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, _excluded$2);

  if (process.env.NODE_ENV !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production' && !reactIs$1.exports.isValidElementType(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? useMemo$1 : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = useMemo$1(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = useMemo$1(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && reactIs$1.exports.isContextConsumer( /*#__PURE__*/React__default.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (process.env.NODE_ENV !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = useMemo$1(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = useMemo$1(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = useMemo$1(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = useMemo$1(function () {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = useMemo$1(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React__default.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React__default.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = React__default.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/React__default.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$1(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    warning$1(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      warning$1("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

var _excluded$1 = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, _excluded$1);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, _excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = /*#__PURE__*/createConnect();

// with standard React renderers (ReactDOM, React Native)

setBatch(unstable_batchedUpdates);

var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing$1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing$1 : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing$1 : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing$1 : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse$1 = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : invariant(false) : void 0;
  return result;
};

var getWindowScroll$1 = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll$1();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse$1(styles.marginTop),
    right: parse$1(styles.marginRight),
    bottom: parse$1(styles.marginBottom),
    left: parse$1(styles.marginLeft)
  };
  var padding = {
    top: parse$1(styles.paddingTop),
    right: parse$1(styles.paddingRight),
    bottom: parse$1(styles.paddingBottom),
    left: parse$1(styles.paddingLeft)
  };
  var border = {
    top: parse$1(styles.borderTopWidth),
    right: parse$1(styles.borderRightWidth),
    bottom: parse$1(styles.borderBottomWidth),
    left: parse$1(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual$3(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual$3(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

var DESCRIPTORS = _descriptors;
var getKeys = _objectKeys;
var toIObject = _toIobject;
var isEnum = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries
var $export$3 = _export;
var $values = _objectToArray(false);

$export$3($export$3.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var values$2 = _core.exports.Object.values;

var values$1 = values$2;

// most Object methods by ES6 should accept primitives
var $export$2 = _export;
var core = _core.exports;
var fails = _fails;
var _objectSap = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export$2($export$2.S + $export$2.F * fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)
var toObject = _toObject;
var $keys = _objectKeys;

_objectSap('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

var keys$1 = _core.exports.Object.keys;

var keys = keys$1;

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export$1 = _export;

$export$1($export$1.S, 'Date', { now: function () { return new Date().getTime(); } });

var now$1 = _core.exports.Date.now;

var now = now$1;

var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

var rafSchd$1 = rafSchd;

// 20.1.2.3 Number.isInteger(number)
var isObject = _isObject;
var floor = Math.floor;
var _isInteger = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

// 20.1.2.3 Number.isInteger(number)
var $export = _export;

$export($export.S, 'Number', { isInteger: _isInteger });

var isInteger$1 = _core.exports.Number.isInteger;

var isInteger = isInteger$1;

var isProduction = process.env.NODE_ENV === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
var warning = function warning(message) {
  var _console;

  if (isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console).warn.apply(_console, getFormattedMessage(message));
};

function printFatalError(error) {
  var _console;

  if (process.env.NODE_ENV === 'production') {
    return;
  }

  (_console = console).error.apply(_console, getFormattedMessage("\n        An error has occurred while a drag is occurring.\n        Any existing drag will be cancelled.\n\n        > " + error.message + "\n        "));

  console.error('raw', error);
}

function shouldRecover(error) {
  return error.message.indexOf('Invariant failed') !== -1;
}

var ErrorBoundary = function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.onError = void 0;

    _this.setOnError = function (fn) {
      _this.onError = fn;
    };

    _this.onFatalError = function (error) {
      printFatalError(error);

      if (_this.onError) {
        _this.onError();
      } else {
        process.env.NODE_ENV !== "production" ? warning('Could not find recovering function') : void 0;
      }

      if (shouldRecover(error)) {
        _this.setState({});
      }
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('error', this.onFatalError);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('error', this.onFatalError);
  };

  _proto.componentDidCatch = function componentDidCatch(error) {
    this.onFatalError(error);

    if (!shouldRecover(error)) {
      throw error;
    }
  };

  _proto.render = function render() {
    return this.props.children(this.setOnError);
  };

  return ErrorBoundary;
}(React__default.Component);

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var isEqual$1 = function isEqual(first, second) {
  return first.top === second.top && first.right === second.right && first.bottom === second.bottom && first.left === second.left;
};
var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return _extends$1({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = _extends$1({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = _extends$1({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});
var start = function start(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};
var finish = function finish(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};

var whatIsDraggedOver = (function (impact) {
  var merge = impact.merge,
      destination = impact.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (merge) {
    return merge.combine.droppableId;
  }

  return null;
});

function values(map) {
  return values$1(map);
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}

var toDroppableMap = memoizeOne(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = memoizeOne(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = memoizeOne(function (droppables) {
  return values(droppables);
});
var toDraggableList = memoizeOne(function (draggables) {
  return values(draggables);
});

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPositionInFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (point) {
    return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
  };
});

var getDroppableOver = (function (_ref) {
  var target = _ref.target,
      droppables = _ref.droppables;
  var maybe = find(toDroppableList(droppables), function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    var active = droppable.subject.active;

    if (!active) {
      return false;
    }

    return isPositionInFrame(active)(target);
  });
  return maybe ? maybe.descriptor.id : null;
});

var getDraggablesInsideDroppable = memoizeOne(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

var withDroppableScroll = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.value);
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isUserMovingForward = (function (axis, direction) {
  return axis === vertical ? direction.vertical === 'down' : direction.horizontal === 'right';
});

var didStartDisplaced = (function (draggableId, onLift) {
  return Boolean(onLift.wasDisplaced[draggableId]);
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      onLift = _ref.onLift,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced[combineWith]);

  if (didStartDisplaced(combineWith, onLift)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var getWhenEntered = function getWhenEntered(id, current, oldMerge) {
  if (!oldMerge) {
    return current;
  }

  if (id !== oldMerge.combine.draggableId) {
    return current;
  }

  return oldMerge.whenEntered;
};

var isCombiningWith = function isCombiningWith(_ref) {
  var id = _ref.id,
      currentCenter = _ref.currentCenter,
      axis = _ref.axis,
      borderBox = _ref.borderBox,
      displaceBy = _ref.displaceBy,
      currentUserDirection = _ref.currentUserDirection,
      oldMerge = _ref.oldMerge;
  var start = borderBox[axis.start] + displaceBy[axis.line];
  var end = borderBox[axis.end] + displaceBy[axis.line];
  var size = borderBox[axis.size];
  var twoThirdsOfSize = size * 0.666;
  var whenEntered = getWhenEntered(id, currentUserDirection, oldMerge);
  var isMovingForward = isUserMovingForward(axis, whenEntered);
  var targetCenter = currentCenter[axis.line];

  if (isMovingForward) {
    return isWithin(start, start + twoThirdsOfSize)(targetCenter);
  }

  return isWithin(end - twoThirdsOfSize, end)(targetCenter);
};

var getCombineImpact = (function (_ref2) {
  var currentCenter = _ref2.pageBorderBoxCenterWithDroppableScrollChange,
      previousImpact = _ref2.previousImpact,
      destination = _ref2.destination,
      insideDestinationWithoutDraggable = _ref2.insideDestinationWithoutDraggable,
      userDirection = _ref2.userDirection,
      onLift = _ref2.onLift;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var map = previousImpact.movement.map;
  var canBeDisplacedBy = previousImpact.movement.displacedBy;
  var oldMerge = previousImpact.merge;
  var target = find(insideDestinationWithoutDraggable, function (child) {
    var id = child.descriptor.id;
    var displaceBy = getCombinedItemDisplacement({
      displaced: map,
      onLift: onLift,
      combineWith: id,
      displacedBy: canBeDisplacedBy
    });
    return isCombiningWith({
      id: id,
      currentCenter: currentCenter,
      axis: axis,
      borderBox: child.page.borderBox,
      displaceBy: displaceBy,
      currentUserDirection: userDirection,
      oldMerge: oldMerge
    });
  });

  if (!target) {
    return null;
  }

  var merge = {
    whenEntered: getWhenEntered(target.descriptor.id, userDirection, oldMerge),
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };

  var withMerge = _extends$1({}, previousImpact, {
    destination: null,
    merge: merge
  });

  return withMerge;
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(_extends$1({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(_extends$1({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(_extends$1({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(forceShouldAnimate, isVisible, previous) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!isVisible) {
    return false;
  }

  if (!previous) {
    return true;
  }

  return previous.shouldAnimate;
};

var getTarget = function getTarget(draggable, onLift) {
  var marginBox = draggable.page.marginBox;

  if (!didStartDisplaced(draggable.descriptor.id, onLift)) {
    return marginBox;
  }

  var expandBy = {
    top: onLift.displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: onLift.displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
};

var getDisplacement = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var id = draggable.descriptor.id;
  var map = previousImpact.movement.map;
  var target = getTarget(draggable, onLift);
  var isVisible = isPartiallyVisible({
    target: target,
    destination: destination,
    viewport: viewport,
    withDroppableDisplacement: true
  });
  var shouldAnimate = getShouldAnimate(forceShouldAnimate, isVisible, map[id]);
  var displacement = {
    draggableId: id,
    isVisible: isVisible,
    shouldAnimate: shouldAnimate
  };
  return displacement;
});

var getDisplacementMap = memoizeOne(function (displaced) {
  return displaced.reduce(function (map, displacement) {
    map[displacement.draggableId] = displacement;
    return map;
  }, {});
});

var getDisplacedBy = memoizeOne(function (axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getReorderImpact = (function (_ref) {
  var currentCenter = _ref.pageBorderBoxCenterWithDroppableScrollChange,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestinationWithoutDraggable = _ref.insideDestinationWithoutDraggable,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      userDirection = _ref.userDirection,
      onLift = _ref.onLift;
  var axis = destination.axis;
  var isMovingForward = isUserMovingForward(destination.axis, userDirection);
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var targetCenter = currentCenter[axis.line];
  var displacement = displacedBy.value;
  var displaced = insideDestinationWithoutDraggable.filter(function (child) {
    var borderBox = child.page.borderBox;
    var start = borderBox[axis.start];
    var end = borderBox[axis.end];
    var didStartDisplaced$1 = didStartDisplaced(child.descriptor.id, onLift);

    if (isMovingForward) {
      if (didStartDisplaced$1) {
        return targetCenter < start;
      }

      return targetCenter < start + displacement;
    }

    if (didStartDisplaced$1) {
      return targetCenter <= end - displacement;
    }

    return targetCenter <= end;
  }).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      previousImpact: previousImpact,
      viewport: viewport.frame,
      onLift: onLift
    });
  });
  var newIndex = insideDestinationWithoutDraggable.length - displaced.length;
  var movement = {
    displacedBy: displacedBy,
    displaced: displaced,
    map: getDisplacementMap(displaced)
  };
  var impact = {
    movement: movement,
    destination: {
      droppableId: destination.descriptor.id,
      index: newIndex
    },
    merge: null
  };
  return impact;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var noMovement = {
  displaced: [],
  map: {},
  displacedBy: noDisplacedBy
};
var noImpact = {
  movement: noMovement,
  destination: null,
  merge: null
};

var removeDraggableFromList = memoizeOne(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var getDragImpact = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      userDirection = _ref.userDirection,
      onLift = _ref.onLift;
  var destinationId = getDroppableOver({
    target: pageBorderBoxCenter,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var insideDestinationWithoutDraggable = removeDraggableFromList(draggable, insideDestination);
  var pageBorderBoxCenterWithDroppableScrollChange = withDroppableScroll(destination, pageBorderBoxCenter);
  var withMerge = getCombineImpact({
    pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
    previousImpact: previousImpact,
    destination: destination,
    insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
    userDirection: userDirection,
    onLift: onLift
  });

  if (withMerge) {
    return withMerge;
  }

  return getReorderImpact({
    pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
    destination: destination,
    draggable: draggable,
    insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
    previousImpact: previousImpact,
    viewport: viewport,
    userDirection: userDirection,
    onLift: onLift
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getHomeOnLift = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var originallyDisplaced = insideHome.slice(draggable.descriptor.index + 1);
  var wasDisplaced = originallyDisplaced.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var onLift = {
    displacedBy: displacedBy,
    wasDisplaced: wasDisplaced
  };
  var displaced = originallyDisplaced.map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: home,
      previousImpact: noImpact,
      viewport: viewport.frame,
      forceShouldAnimate: false,
      onLift: onLift
    });
  });
  var movement = {
    displaced: displaced,
    map: getDisplacementMap(displaced),
    displacedBy: displacedBy
  };
  var impact = {
    movement: movement,
    destination: getHomeLocation(draggable.descriptor),
    merge: null
  };
  return {
    impact: impact,
    onLift: onLift
  };
});

var getDragPositions = (function (_ref) {
  var oldInitial = _ref.initial,
      oldCurrent = _ref.current,
      oldClientBorderBoxCenter = _ref.oldClientBorderBoxCenter,
      newClientBorderBoxCenter = _ref.newClientBorderBoxCenter,
      viewport = _ref.viewport;
  var shift = subtract(newClientBorderBoxCenter, oldClientBorderBoxCenter);

  var initial = function () {
    var client = {
      selection: add(oldInitial.client.selection, shift),
      borderBoxCenter: newClientBorderBoxCenter,
      offset: origin
    };
    var page = {
      selection: add(client.selection, viewport.scroll.initial),
      borderBoxCenter: add(client.selection, viewport.scroll.initial)
    };
    return {
      client: client,
      page: page
    };
  }();

  var current = function () {
    var reverse = negate(shift);
    var offset = add(oldCurrent.client.offset, reverse);
    var client = {
      selection: add(initial.client.selection, offset),
      borderBoxCenter: add(initial.client.borderBoxCenter, offset),
      offset: offset
    };
    var page = {
      selection: add(client.selection, viewport.scroll.current),
      borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current)
    };
    !isEqual(oldCurrent.client.borderBoxCenter, client.borderBoxCenter) ? process.env.NODE_ENV !== "production" ? invariant(false, "\n        Incorrect new client center position.\n        Expected (" + oldCurrent.client.borderBoxCenter.x + ", " + oldCurrent.client.borderBoxCenter.y + ")\n        to equal (" + client.borderBoxCenter.x + ", " + client.borderBoxCenter.y + ")\n      ") : invariant(false) : void 0;
    return {
      client: client,
      page: page
    };
  }();

  return {
    current: current,
    initial: initial
  };
});

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = _extends$1({}, draggable, {
    placeholder: _extends$1({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var adjustExistingForAdditionsAndRemovals = (function (_ref) {
  var existing = _ref.existing,
      droppables = _ref.droppables,
      addedDraggables = _ref.additions,
      removedDraggables = _ref.removals,
      viewport = _ref.viewport;
  var shifted = {};
  toDroppableList(droppables).forEach(function (droppable) {
    var axis = droppable.axis;
    var original = getDraggablesInsideDroppable(droppable.descriptor.id, existing);
    var toShift = {};

    var addShift = function addShift(id, shift) {
      var previous = toShift[id];

      if (!previous) {
        toShift[id] = shift;
        return;
      }

      toShift[id] = {
        indexChange: previous.indexChange + shift.indexChange,
        offset: add(previous.offset, shift.offset)
      };
    };

    var removals = toDraggableMap(removedDraggables.map(function (id) {
      var item = existing[id];
      !item ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not find removed draggable \"" + id + "\"") : invariant(false) : void 0;
      return item;
    }).filter(function (draggable) {
      return draggable.descriptor.droppableId === droppable.descriptor.id;
    }));
    var withRemovals = original.filter(function (item, index) {
      var isBeingRemoved = Boolean(removals[item.descriptor.id]);

      if (!isBeingRemoved) {
        return true;
      }

      var offset = negate(patch(axis.line, item.displaceBy[axis.line]));
      original.slice(index).forEach(function (sibling) {
        if (removals[sibling.descriptor.id]) {
          return;
        }

        addShift(sibling.descriptor.id, {
          indexChange: -1,
          offset: offset
        });
      });
      return false;
    });
    var additions = addedDraggables.filter(function (draggable) {
      return draggable.descriptor.droppableId === droppable.descriptor.id;
    });
    var withAdditions = withRemovals.slice(0);
    additions.forEach(function (item) {
      withAdditions.splice(item.descriptor.index, 0, item);
    });
    var additionMap = toDraggableMap(additions);
    withAdditions.forEach(function (item, index) {
      var wasAdded = Boolean(additionMap[item.descriptor.id]);

      if (!wasAdded) {
        return;
      }

      var offset = patch(axis.line, item.client.marginBox[axis.size]);
      withAdditions.slice(index).forEach(function (sibling) {
        if (additionMap[sibling.descriptor.id]) {
          return;
        }

        addShift(sibling.descriptor.id, {
          indexChange: 1,
          offset: offset
        });
      });
    });
    withAdditions.forEach(function (item) {
      if (additionMap[item.descriptor.id]) {
        return;
      }

      var shift = toShift[item.descriptor.id];

      if (!shift) {
        return;
      }

      var moved = offsetDraggable({
        draggable: item,
        offset: shift.offset,
        initialWindowScroll: viewport.scroll.initial
      });
      var index = item.descriptor.index + shift.indexChange;

      var updated = _extends$1({}, moved, {
        descriptor: _extends$1({}, item.descriptor, {
          index: index
        })
      });

      shifted[moved.descriptor.id] = updated;
    });
  });

  var map = _extends$1({}, existing, shifted);

  return map;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = modified.frame;
    !frame ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var adjustAdditionsForCollapsedHome = (function (_ref) {
  var additions = _ref.additions,
      dragging = _ref.dragging,
      home = _ref.home,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, dragging.displaceBy);
  return additions.map(function (draggable) {
    if (draggable.descriptor.droppableId !== home.descriptor.id) {
      return draggable;
    }

    if (draggable.descriptor.index < dragging.descriptor.index) {
      return draggable;
    }

    return offsetDraggable({
      draggable: draggable,
      offset: displacedBy.point,
      initialWindowScroll: viewport.scroll.initial
    });
  });
});

var updateDraggables = (function (_ref) {
  var updatedDroppables = _ref.updatedDroppables,
      criticalId = _ref.criticalId,
      unmodifiedExisting = _ref.existing,
      unmodifiedAdditions = _ref.additions,
      removals = _ref.removals,
      viewport = _ref.viewport;
  var existing = adjustExistingForAdditionsAndRemovals({
    droppables: updatedDroppables,
    existing: unmodifiedExisting,
    additions: unmodifiedAdditions,
    removals: removals,
    viewport: viewport
  });
  var dragging = existing[criticalId];
  var home = updatedDroppables[dragging.descriptor.droppableId];
  var scrolledAdditions = adjustAdditionsForScrollChanges({
    additions: unmodifiedAdditions,
    updatedDroppables: updatedDroppables,
    viewport: viewport
  });
  var additions = adjustAdditionsForCollapsedHome({
    additions: scrolledAdditions,
    dragging: dragging,
    home: home,
    viewport: viewport
  });

  var map = _extends$1({}, existing, toDraggableMap(additions));

  removals.forEach(function (id) {
    delete map[id];
  });
  return map;
});

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;
  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return _extends$1({}, frame, {
    scroll: _extends$1({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not add placeholder space to home list') : invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot add placeholder size to a subject when it already has one') : invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return _extends$1({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return _extends$1({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot remove placeholder form subject when there was none') : invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return _extends$1({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends$1({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected Droppable to have a frame') : invariant(false) : void 0;
  return frame;
});

var throwIfSpacingChange = function throwIfSpacingChange(old, fresh) {
  if (process.env.NODE_ENV !== 'production') {
    var getMessage = function getMessage(spacingType) {
      return "Cannot change the " + spacingType + " of a Droppable during a drag";
    };

    !isEqual$1(old.margin, fresh.margin) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('margin')) : invariant(false) : void 0;
    !isEqual$1(old.border, fresh.border) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('border')) : invariant(false) : void 0;
    !isEqual$1(old.padding, fresh.padding) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('padding')) : invariant(false) : void 0;
  }
};

var adjustBorderBoxSize = function adjustBorderBoxSize(axis, old, fresh) {
  return {
    top: old.top,
    left: old.left,
    right: old.left + fresh.width,
    bottom: old.top + fresh.height
  };
};

var updateDroppables = (function (_ref) {
  var modified = _ref.modified,
      existing = _ref.existing,
      viewport = _ref.viewport;

  if (!modified.length) {
    return existing;
  }

  var adjusted = modified.map(function (provided) {
    var raw = existing[provided.descriptor.id];
    !raw ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not locate droppable in existing droppables') : invariant(false) : void 0;
    var hasPlaceholder = Boolean(raw.subject.withPlaceholder);
    var dimension = hasPlaceholder ? removePlaceholder(raw) : raw;
    var oldClient = dimension.client;
    var newClient = provided.client;
    var oldScrollable = getFrame(dimension);
    var newScrollable = getFrame(provided);

    if (process.env.NODE_ENV !== 'production') {
      throwIfSpacingChange(dimension.client, provided.client);
      throwIfSpacingChange(oldScrollable.frameClient, newScrollable.frameClient);
      var isFrameEqual = oldScrollable.frameClient.borderBox.height === newScrollable.frameClient.borderBox.height && oldScrollable.frameClient.borderBox.width === newScrollable.frameClient.borderBox.width;
      !isFrameEqual ? process.env.NODE_ENV !== "production" ? invariant(false, 'The width and height of your Droppable scroll container cannot change when adding or removing Draggables during a drag') : invariant(false) : void 0;
    }

    var client = createBox({
      borderBox: adjustBorderBoxSize(dimension.axis, oldClient.borderBox, newClient.borderBox),
      margin: oldClient.margin,
      border: oldClient.border,
      padding: oldClient.padding
    });
    var closest = {
      client: oldScrollable.frameClient,
      page: withScroll(oldScrollable.frameClient, viewport.scroll.initial),
      shouldClipSubject: oldScrollable.shouldClipSubject,
      scrollSize: newScrollable.scrollSize,
      scroll: oldScrollable.scroll.initial
    };
    var withSizeChanged = getDroppableDimension({
      descriptor: provided.descriptor,
      isEnabled: provided.isEnabled,
      isCombineEnabled: provided.isCombineEnabled,
      isFixedOnPage: provided.isFixedOnPage,
      direction: provided.axis.direction,
      client: client,
      page: withScroll(client, viewport.scroll.initial),
      closest: closest
    });
    var scrolled = scrollDroppable(withSizeChanged, newScrollable.scroll.current);
    return scrolled;
  });

  var result = _extends$1({}, existing, toDroppableMap(adjusted));

  return result;
});

var withNoAnimatedDisplacement = (function (impact) {
  var displaced = impact.movement.displaced;

  if (!displaced.length) {
    return impact;
  }

  var withoutAnimation = displaced.map(function (displacement) {
    if (!displacement.isVisible) {
      return displacement;
    }

    if (!displacement.shouldAnimate) {
      return displacement;
    }

    return _extends$1({}, displacement, {
      shouldAnimate: false
    });
  });

  var result = _extends$1({}, impact, {
    movement: _extends$1({}, impact.movement, {
      displaced: withoutAnimation,
      map: getDisplacementMap(withoutAnimation)
    })
  });

  return result;
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return _extends$1({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});
var publishWhileDragging = (function (_ref) {
  var _extends2, _extends3;

  var state = _ref.state,
      published = _ref.published;
  start();
  var updatedDroppables = updateDroppables({
    modified: published.modified,
    existing: state.dimensions.droppables,
    viewport: state.viewport
  });
  var draggables = updateDraggables({
    updatedDroppables: updatedDroppables,
    criticalId: state.critical.draggable.id,
    existing: state.dimensions.draggables,
    additions: published.additions,
    removals: published.removals,
    viewport: state.viewport
  });
  var critical = {
    draggable: draggables[state.critical.draggable.id].descriptor,
    droppable: updatedDroppables[state.critical.droppable.id].descriptor
  };
  var original = state.dimensions.draggables[critical.draggable.id];
  var updated = draggables[critical.draggable.id];
  var droppables = recomputePlaceholders({
    draggable: updated,
    draggables: draggables,
    droppables: updatedDroppables,
    previousImpact: state.impact,
    impact: state.impact
  });
  var dimensions = {
    draggables: draggables,
    droppables: droppables
  };

  var _getDragPositions = getDragPositions({
    initial: state.initial,
    current: state.current,
    oldClientBorderBoxCenter: original.client.borderBox.center,
    newClientBorderBoxCenter: updated.client.borderBox.center,
    viewport: state.viewport
  }),
      initial = _getDragPositions.initial,
      current = _getDragPositions.current;

  var _getHomeOnLift = getHomeOnLift({
    draggable: updated,
    home: dimensions.droppables[critical.droppable.id],
    draggables: dimensions.draggables,
    viewport: state.viewport
  }),
      homeImpact = _getHomeOnLift.impact,
      onLift = _getHomeOnLift.onLift;

  var impact = withNoAnimatedDisplacement(getDragImpact({
    pageBorderBoxCenter: current.page.borderBoxCenter,
    draggable: updated,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: homeImpact,
    viewport: state.viewport,
    userDirection: state.userDirection,
    onLift: onLift
  }));
  var isOrphaned = Boolean(state.movementMode === 'SNAP' && !whatIsDraggedOver(impact));
  !!isOrphaned ? process.env.NODE_ENV !== "production" ? invariant(false, 'Dragging item no longer has a valid merge/destination after a dynamic update. This is not supported') : invariant(false) : void 0;
  finish();

  var draggingState = _extends$1({
    phase: 'DRAGGING'
  }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.critical = critical, _extends2.current = current, _extends2.initial = initial, _extends2.impact = impact, _extends2.dimensions = dimensions, _extends2.onLift = onLift, _extends2.onLiftImpact = homeImpact, _extends2.forceShouldAnimate = false, _extends2));

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = _extends$1({
    phase: 'DROP_PENDING'
  }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));

  return dropPending;
});

var forward = {
  vertical: 'down',
  horizontal: 'right'
};
var backward = {
  vertical: 'up',
  horizontal: 'left'
};

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      destination = _ref.destination,
      originalInsideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  if (previousImpact.merge) {
    return null;
  }

  var location = previousImpact.destination;
  !location ? process.env.NODE_ENV !== "production" ? invariant(false, 'Need a previous location to move from into a combine') : invariant(false) : void 0;
  var currentIndex = location.index;

  var currentInsideDestination = function () {
    var shallow = originalInsideDestination.slice();

    if (isInHomeList) {
      shallow.splice(draggable.descriptor.index, 1);
    }

    shallow.splice(location.index, 0, draggable);
    return shallow;
  }();

  var targetIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (targetIndex < 0) {
    return null;
  }

  if (targetIndex > currentInsideDestination.length - 1) {
    return null;
  }

  var target = currentInsideDestination[targetIndex];
  !(target !== draggable) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot combine with self') : invariant(false) : void 0;
  var merge = {
    whenEntered: isMovingForward ? forward : backward,
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };
  var impact = {
    movement: previousImpact.movement,
    destination: null,
    merge: merge
  };
  return impact;
});

var addClosest = function addClosest(add, displaced) {
  var added = {
    draggableId: add.descriptor.id,
    isVisible: true,
    shouldAnimate: true
  };
  return [added].concat(displaced);
};
var removeClosest = function removeClosest(displaced) {
  return displaced.slice(1);
};

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      initialInside = _ref.insideDestination,
      location = _ref.location;
  var insideDestination = initialInside.slice();
  var currentIndex = location.index;
  var isInForeignList = !isInHomeList;

  if (isInForeignList) {
    insideDestination.splice(location.index, 0, draggable);
  }

  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (proposedIndex < 0) {
    return null;
  }

  if (proposedIndex > insideDestination.length - 1) {
    return null;
  }

  return {
    proposedIndex: proposedIndex,
    modifyDisplacement: true
  };
});

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      draggables = _ref.draggables,
      merge = _ref.merge,
      onLift = _ref.onLift;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var movement = previousImpact.movement;
  var combineId = merge.combine.draggableId;
  var combine = draggables[combineId];
  var combineIndex = combine.descriptor.index;
  var wasDisplacedAtStart = didStartDisplaced(combineId, onLift);

  if (wasDisplacedAtStart) {
    var hasDisplacedFromStart = !movement.map[combineId];

    if (hasDisplacedFromStart) {
      if (isMovingForward) {
        return {
          proposedIndex: combineIndex,
          modifyDisplacement: false
        };
      }

      return {
        proposedIndex: combineIndex - 1,
        modifyDisplacement: true
      };
    }

    if (isMovingForward) {
      return {
        proposedIndex: combineIndex,
        modifyDisplacement: true
      };
    }

    return {
      proposedIndex: combineIndex - 1,
      modifyDisplacement: false
    };
  }

  var isDisplaced = Boolean(movement.map[combineId]);

  if (isDisplaced) {
    if (isMovingForward) {
      return {
        proposedIndex: combineIndex + 1,
        modifyDisplacement: true
      };
    }

    return {
      proposedIndex: combineIndex,
      modifyDisplacement: false
    };
  }

  if (isMovingForward) {
    return {
      proposedIndex: combineIndex + 1,
      modifyDisplacement: false
    };
  }

  return {
    proposedIndex: combineIndex,
    modifyDisplacement: true
  };
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      onLift = _ref.onLift;

  var instruction = function () {
    if (previousImpact.destination) {
      return fromReorder({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        location: previousImpact.destination,
        insideDestination: insideDestination
      });
    }

    if (previousImpact.merge) {
      return fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        previousImpact: previousImpact,
        draggables: draggables,
        merge: previousImpact.merge,
        onLift: onLift
      });
    }
    return null;
  }();

  if (instruction == null) {
    return null;
  }

  var proposedIndex = instruction.proposedIndex,
      modifyDisplacement = instruction.modifyDisplacement;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);

  var displaced = function () {
    var lastDisplaced = previousImpact.movement.displaced;

    if (!modifyDisplacement) {
      return lastDisplaced;
    }

    if (isMovingForward) {
      return removeClosest(lastDisplaced);
    }

    var withoutDraggable = removeDraggableFromList(draggable, insideDestination);
    var atProposedIndex = withoutDraggable[proposedIndex];
    return addClosest(atProposedIndex, lastDisplaced);
  }();

  return {
    movement: {
      displacedBy: displacedBy,
      displaced: displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
});

var whenCombining = (function (_ref) {
  var combine = _ref.combine,
      onLift = _ref.onLift,
      movement = _ref.movement,
      draggables = _ref.draggables;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: movement.map,
    onLift: onLift,
    combineWith: combineWith,
    displacedBy: movement.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var movement = _ref.movement,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      onLift = _ref.onLift;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = movement.displaced,
      displacedBy = movement.displacedBy;

  if (displaced.length) {
    var closestAfter = draggables[displaced[0].draggableId];

    if (didStartDisplaced(closestAfter.descriptor.id, onLift)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closestAfter.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closestAfter.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartDisplaced(last.descriptor.id, onLift)) {
    var page = offset(last.page, negate(onLift.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      onLift = _ref.onLift;
  var merge = impact.merge;
  var destination = impact.destination;
  var original = draggable.page.borderBox.center;

  if (!droppable) {
    return original;
  }

  if (destination) {
    return whenReordering({
      movement: impact.movement,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      onLift: onLift
    });
  }

  if (merge) {
    return whenCombining({
      movement: impact.movement,
      combine: merge.combine,
      draggables: draggables,
      onLift: onLift
    });
  }

  return original;
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

var withNewDisplacement = (function (impact, displaced) {
  return _extends$1({}, impact, {
    movement: _extends$1({}, impact.movement, {
      displaced: displaced,
      map: getDisplacementMap(displaced)
    })
  });
});

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange,
      onLift = _ref.onLift;
  var displaced = impact.movement.displaced;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var updated = displaced.map(function (entry) {
    if (entry.isVisible) {
      return entry;
    }

    var draggable = draggables[entry.draggableId];
    var withScrolledViewport = getDisplacement({
      draggable: draggable,
      destination: destination,
      previousImpact: impact,
      viewport: scrolledViewport.frame,
      onLift: onLift,
      forceShouldAnimate: false
    });

    if (withScrolledViewport.isVisible) {
      return withScrolledViewport;
    }

    var withScrolledDroppable = getDisplacement({
      draggable: draggable,
      destination: scrolledDroppable,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift: onLift,
      forceShouldAnimate: false
    });

    if (withScrolledDroppable.isVisible) {
      return withScrolledDroppable;
    }

    return entry;
  });
  return withNewDisplacement(impact, updated);
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      onLift = _ref.onLift;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isInHomeList: isInHomeList,
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    onLift: onLift
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    onLift: onLift
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance,
    onLift: onLift
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot get clipped area from droppable') : invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, onLift) {
  var original = draggable.page.borderBox.center;
  return didStartDisplaced(draggable.descriptor.id, onLift) ? subtract(original, onLift.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, onLift) {
  var original = draggable.page.borderBox;
  return didStartDisplaced(draggable.descriptor.id, onLift) ? offsetByPosition(original, negate(onLift.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      onLift = _ref.onLift;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, onLift),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, onLift)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, onLift)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      movement: noMovement,
      destination: {
        droppableId: destination.descriptor.id,
        index: 0
      },
      merge: null
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      onLift: onLift
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] < moveRelativeTo.page.borderBox.center[destination.axis.line]);
  var targetIndex = insideDestination.indexOf(moveRelativeTo);
  !(targetIndex !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find target in list') : invariant(false) : void 0;

  var proposedIndex = function () {
    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return targetIndex;
    }

    if (isGoingBeforeTarget) {
      return targetIndex;
    }

    return targetIndex + 1;
  }();

  var displaced = removeDraggableFromList(draggable, insideDestination).slice(proposedIndex).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      viewport: viewport.frame,
      previousImpact: previousImpact,
      onLift: onLift
    });
  });
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var impact = {
    movement: {
      displacedBy: displacedBy,
      displaced: displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
  return impact;
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    onLift: onLift
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    onLift: onLift
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    onLift: onLift
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var getDroppableOver$1 = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver$1(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    onLift: state.onLift
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    previousImpact: state.impact,
    viewport: state.viewport,
    onLift: state.onLift
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

var getVertical = function getVertical(previous, diff) {
  if (diff === 0) {
    return previous;
  }

  return diff > 0 ? 'down' : 'up';
};

var getHorizontal = function getHorizontal(previous, diff) {
  if (diff === 0) {
    return previous;
  }

  return diff > 0 ? 'right' : 'left';
};

var getUserDirection = (function (previous, oldPageBorderBoxCenter, newPageBorderBoxCenter) {
  var diff = subtract(newPageBorderBoxCenter, oldPageBorderBoxCenter);
  return {
    horizontal: getHorizontal(previous.horizontal, diff.x),
    vertical: getVertical(previous.vertical, diff.y)
  };
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var currentWindowScroll = viewport.scroll.current;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, currentWindowScroll),
    borderBoxCenter: add(client.borderBoxCenter, currentWindowScroll)
  };
  var current = {
    client: client,
    page: page
  };
  var userDirection = getUserDirection(state.userDirection, state.current.page.borderBoxCenter, current.page.borderBoxCenter);

  if (state.phase === 'COLLECTING') {
    return _extends$1({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current,
      userDirection: userDirection
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageBorderBoxCenter: page.borderBoxCenter,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    userDirection: userDirection,
    onLift: state.onLift
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = _extends$1({}, state, {
    current: current,
    userDirection: userDirection,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      onLift = _ref.onLift,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var updated = impact.movement.displaced.map(function (entry) {
    return getDisplacement({
      draggable: draggables[entry.draggableId],
      destination: destination,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift: onLift,
      forceShouldAnimate: forceShouldAnimate
    });
  });
  return withNewDisplacement(impact, updated);
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    onLift: onLift
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ? process.env.NODE_ENV !== "production" ? invariant(false, 'Must be over a destination in SNAP movement mode') : invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    onLift: state.onLift
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    onLift: state.onLift
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'CLEAN') {
    return _extends$1({}, idle, {
      shouldFlush: action.payload.shouldFlush
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'INITIAL_PUBLISH must come after a IDLE phase') : invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getHomeOnLift = getHomeOnLift({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getHomeOnLift.impact,
        onLift = _getHomeOnLift.onLift;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      onLift: onLift,
      onLiftImpact: impact,
      viewport: viewport,
      userDirection: forward,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    var _extends2;

    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Collection cannot start from phase " + state.phase) : invariant(false) : void 0;

    var _result = _extends$1({
      phase: 'COLLECTING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant(false) : void 0;
    return publishWhileDragging({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    if (state.phase === 'COLLECTING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        offset = _action$payload2.offset;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, offset);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant(false) : void 0;

    var updated = _extends$1({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant(false) : void 0;

    var _updated = _extends$1({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot move by window in phase " + state.phase) : invariant(false) : void 0;
    !state.isWindowScrollAllowed ? process.env.NODE_ENV !== "production" ? invariant(false, 'Window scrolling is currently not supported for fixed lists. Aborting drag') : invariant(false) : void 0;
    var newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, newScroll)) {
      return state;
    }

    var _viewport = scrollViewport(state.viewport, newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = _extends$1({}, state.viewport, {
      scroll: _extends$1({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return _extends$1({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " received while not in DRAGGING phase") : invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var _extends3;

    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : invariant(false) : void 0;

    var newState = _extends$1({
      phase: 'DROP_PENDING'
    }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot animate drop from phase " + state.phase) : invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      dimensions: state.dimensions,
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _action$payload6 = action.payload,
        _completed = _action$payload6.completed,
        shouldFlush = _action$payload6.shouldFlush;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: shouldFlush
    };
  }

  return state;
});

var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging$1 = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var clean$1 = function clean(args) {
  if (args === void 0) {
    args = {
      shouldFlush: false
    };
  }

  return {
    type: 'CLEAN',
    payload: args
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed,
            shouldFlush: true
          }));
        }

        !(getState().phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Incorrect phase to start a drag') : invariant(false) : void 0;
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'CLEAN' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    onLift: onLift,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  var merge = impact.merge;

  if (merge && didStartDisplaced(merge.combine.draggableId, onLift)) {
    return subtract(offset, onLift.displacedBy.point);
  }

  return offset;
});

var getDropImpact = (function (_ref) {
  var reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      onLiftImpact = _ref.onLiftImpact,
      onLift = _ref.onLift;
  var didDropInsideDroppable = reason === 'DROP' && Boolean(whatIsDraggedOver(lastImpact));

  if (!didDropInsideDroppable) {
    var impact = recompute({
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      draggables: draggables,
      onLift: onLift,
      forceShouldAnimate: true
    });
    return {
      impact: impact,
      didDropInsideDroppable: didDropInsideDroppable
    };
  }

  if (lastImpact.destination) {
    return {
      impact: lastImpact,
      didDropInsideDroppable: didDropInsideDroppable
    };
  }

  var withoutMovement = _extends$1({}, lastImpact, {
    movement: noMovement
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: didDropInsideDroppable
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ? process.env.NODE_ENV !== "production" ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot drop in phase: " + state.phase) : invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        onLift: state.onLift,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var draggable = dimensions.draggables[state.critical.draggable.id];
      var destination = didDropInsideDroppable ? impact.destination : null;
      var combine = didDropInsideDroppable && impact.merge ? impact.merge.combine : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        onLift: state.onLift
      });
      var completed = {
        critical: state.critical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed,
          shouldFlush: false
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      process.env.NODE_ENV !== "production" ? warning('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
      process.env.NODE_ENV !== "production" ? warning("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find timer') : invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = impact.destination;
    var combine = impact.merge ? impact.merge.combine : null;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = _extends$1({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only flush responders while dragging') : invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = _extends$1({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'CLEAN') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed,
        shouldFlush: false
      }));
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'CLEAN' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'CLEAN';
};

var shouldCancelPending = function shouldCancelPending(action) {
  return action.type === 'COLLECTION_STARTING';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldEnd(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (shouldCancelPending(action)) {
          autoScroller.cancelPending();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers = process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return createStore$1(reducer, composeEnhancers(applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, pendingDrop, autoScroll(autoScroller), responders(getResponders, announce))));
});

var clean$2 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
var createPublisher = (function (_ref) {
  var getEntries = _ref.getEntries,
      callbacks = _ref.callbacks;

  var advancedUsageWarning = function () {
    if (process.env.NODE_ENV === 'production') {
      return function () {};
    }

    var hasAnnounced = false;
    return function () {
      if (hasAnnounced) {
        return;
      }

      hasAnnounced = true;
      process.env.NODE_ENV !== "production" ? warning("\n        Advanced usage warning: you are adding or removing a dimension during a drag\n        This an advanced feature.\n\n        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/changes-while-dragging.md\n      ") : void 0;
    };
  }();

  var staging = clean$2();
  var frameId = null;

  var collect = function collect() {
    advancedUsageWarning();

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      callbacks.collectionStarting();
      var critical = callbacks.getCritical();
      start();
      var entries = getEntries();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;

      var added = keys(additions).map(function (id) {
        return entries.draggables[id].getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });

      var updated = keys(modified).map(function (id) {
        var entry = entries.droppables[id];
        !entry ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find dynamically added droppable in cache') : invariant(false) : void 0;
        var isHome = entry.descriptor.id === critical.droppable.id;
        var options = {
          withoutPlaceholder: !isHome
        };
        return entry.callbacks.recollect(options);
      });

      var result = {
        additions: added,
        removals: keys(removals),
        modified: updated
      };
      staging = clean$2();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(descriptor) {
    staging.additions[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;

    if (staging.removals[descriptor.id]) {
      delete staging.removals[descriptor.id];
    }

    collect();
  };

  var remove = function remove(descriptor) {
    staging.removals[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$2();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
});

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find document.documentElement') : invariant(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      entries = _ref.entries;
  start();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = values(entries.droppables).filter(function (entry) {
    return entry.descriptor.type === home.type;
  }).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = values(entries.draggables).filter(function (entry) {
    return entry.descriptor.type === critical.draggable.type;
  }).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

var throwIfAddOrRemoveOfWrongType = function throwIfAddOrRemoveOfWrongType(collection, descriptor) {
  !(collection.critical.draggable.type === descriptor.type) ? process.env.NODE_ENV !== "production" ? invariant(false, "We have detected that you have added a Draggable during a drag.\n      This is not of the same type as the dragging item\n\n      Dragging type: " + collection.critical.draggable.type + ".\n      Added type: " + descriptor.type + "\n\n      We are not allowing this as you can run into problems if your change\n      has shifted the positioning of other Droppables, or has changed the size of the page") : invariant(false) : void 0;
};

var createDimensionMarshal = (function (callbacks) {
  var entries = {
    droppables: {},
    draggables: {}
  };
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting,
      getCritical: function getCritical() {
        !collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot get critical when there is no collection') : invariant(false) : void 0;
        return collection.critical;
      }
    },
    getEntries: function getEntries() {
      return entries;
    }
  });

  var registerDraggable = function registerDraggable(descriptor, getDimension) {
    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;

    if (!collection) {
      return;
    }

    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.add(descriptor);
  };

  var updateDraggable = function updateDraggable(published, descriptor, getDimension) {
    var existing = entries.draggables[published.id];
    !existing ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot update draggable registration as no published registration was found') : invariant(false) : void 0;

    if (existing.descriptor === published) {
      delete entries.draggables[published.id];
    } else {
      process.env.NODE_ENV !== "production" ? warning("\n        Detected incorrect usage of 'key' on '<Draggable draggableId=\"" + published.id + "\"$ />\n\n        Your 'key' should be:\n        - Unique for each Draggable in a list\n        - Not be based on the index of the Draggable\n\n        Usually you want your 'key' to just be the 'draggableId'\n\n        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md#keys-for-a-list-of-draggable-\n      ") : void 0;
    }

    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;
  };

  var unregisterDraggable = function unregisterDraggable(descriptor) {
    var entry = entries.draggables[descriptor.id];
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot unregister Draggable with id:\n      " + descriptor.id + " as it is not registered") : invariant(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.draggables[descriptor.id];

    if (!collection) {
      return;
    }

    !(collection.critical.draggable.id !== descriptor.id) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot remove the dragging item during a drag') : invariant(false) : void 0;
    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.remove(descriptor);
  };

  var registerDroppable = function registerDroppable(descriptor, droppableCallbacks) {
    var id = descriptor.id;
    entries.droppables[id] = {
      descriptor: descriptor,
      callbacks: droppableCallbacks
    };
    !!collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot add a Droppable during a drag') : invariant(false) : void 0;
  };

  var unregisterDroppable = function unregisterDroppable(descriptor) {
    var entry = entries.droppables[descriptor.id];
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot unregister Droppable with id " + descriptor.id + " as as it is not registered") : invariant(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.droppables[descriptor.id];
    !!collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot add a Droppable during a drag') : invariant(false) : void 0;
  };

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !entries.droppables[id] ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    !entries.droppables[id] ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    !entries.droppables[id] ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableScroll({
      id: id,
      offset: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    var entry = entries.droppables[id];
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot scroll Droppable " + id + " as it is not registered") : invariant(false) : void 0;

    if (!collection) {
      return;
    }

    entry.callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    values(entries.droppables).filter(function (entry) {
      return entry.descriptor.type === home.type;
    }).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection = null;
  };

  var startPublishing = function startPublishing(request) {
    !!collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : invariant(false) : void 0;
    var entry = entries.draggables[request.draggableId];
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find critical draggable entry') : invariant(false) : void 0;
    var home = entries.droppables[entry.descriptor.droppableId];
    !home ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find critical droppable entry') : invariant(false) : void 0;
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    collection = {
      critical: critical
    };
    return getInitialPublish({
      critical: critical,
      entries: entries,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    registerDraggable: registerDraggable,
    updateDraggable: updateDraggable,
    unregisterDraggable: unregisterDraggable,
    registerDroppable: registerDroppable,
    unregisterDroppable: unregisterDroppable,
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = memoizeOne(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant(false, 'Invalid result') : invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
    process.env.NODE_ENV !== "production" ? warning("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;

  var now$1 = now();

  var runTime = now$1 - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$3 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$3({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd$1(scrollWindow);
  var scheduleDroppableScroll = rafSchd$1(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fluid scroll if not dragging') : invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var cancelPending = function cancelPending() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot cancel pending fluid scroll when not started') : invariant(false) : void 0;
    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
  };

  var start$1 = function start$1(state) {
    start();
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start auto scrolling when already started') : invariant(false) : void 0;

    var dragStartTime = now();

    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    cancelPending();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    cancelPending: cancelPending,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    cancelPending: fluidScroller.cancelPending,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix = 'data-react-beautiful-dnd';
var dragHandle = prefix + "-drag-handle";
var draggable = prefix + "-draggable";
var droppable = prefix + "-droppable";

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (uniqueContext) {
  var getSelector = makeGetSelector(uniqueContext);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find the head to append a style to') : invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl() {
  var el = document.createElement('style');
  el.type = 'text/css';
  return el;
};

function useStyleMarshal(uniqueId) {
  var uniqueContext = useMemo(function () {
    return "" + uniqueId;
  }, [uniqueId]);
  var styles = useMemo(function () {
    return getStyles$1(uniqueContext);
  }, [uniqueContext]);
  var alwaysRef = useRef(null);
  var dynamicRef = useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function (proposed) {
    var el = dynamicRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ? process.env.NODE_ENV !== "production" ? invariant(false, 'style elements already mounted') : invariant(false) : void 0;
    var always = createStyleEl();
    var dynamic = createStyleEl();
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix + "-always", uniqueContext);
    dynamic.setAttribute(prefix + "-dynamic", uniqueContext);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot unmount ref as it is not set') : invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, uniqueContext]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting,
      styleContext: uniqueContext
    };
  }, [dragging, dropping, resting, uniqueContext]);
  return marshal;
}

var StoreContext = React__default.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find document.body') : invariant(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};
var getId = function getId(uniqueId) {
  return "react-beautiful-dnd-announcement-" + uniqueId;
};
function useAnnouncer(uniqueId) {
  var id = useMemo(function () {
    return getId(uniqueId);
  }, [uniqueId]);
  var ref = useRef(null);
  useEffect(function () {
    !!ref.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Announcement node already mounted') : invariant(false) : void 0;
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('role', 'log');
    el.setAttribute('aria-atomic', 'true');

    assign(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function () {
      var toBeRemoved = ref.current;
      !toBeRemoved ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot unmount announcement node') : invariant(false) : void 0;
      getBodyElement().removeChild(toBeRemoved);
      ref.current = null;
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

    process.env.NODE_ENV !== "production" ? warning("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var AppContext = React__default.createContext(null);

var peerDependencies = {
	react: "^16.8.5"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Unable to parse React version " + value) : invariant(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
    process.env.NODE_ENV !== "production" ? warning("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
    process.env.NODE_ENV !== "production" ? warning("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
    process.env.NODE_ENV !== "production" ? warning("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
});

function useStartupValidation() {
  useEffect(function () {
    if (process.env.NODE_ENV === 'production') {
      return;
    }

    checkReactVersion(peerDependencies.react, React__default.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = useRef(current);
  useEffect(function () {
    ref.current = current;
  });
  return ref;
}

var createResponders = function createResponders(props) {
  return {
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find store from lazy ref') : invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var uniqueId = props.uniqueId,
      setOnError = props.setOnError;
  var lazyStoreRef = useRef(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(uniqueId);
  var styleMarshal = useStyleMarshal(uniqueId);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var callbacks = useMemo(function () {
    return bindActionCreators$1({
      publishWhileDragging: publishWhileDragging$1,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var dimensionMarshal = useMemo(function () {
    return createDimensionMarshal(callbacks);
  }, [callbacks]);
  var autoScroller = useMemo(function () {
    return createAutoScroller(_extends$1({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators$1({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var store = useMemo(function () {
    return createStore({
      dimensionMarshal: dimensionMarshal,
      styleMarshal: styleMarshal,
      announce: announce,
      autoScroller: autoScroller,
      getResponders: getResponders
    });
  }, [announce, autoScroller, dimensionMarshal, getResponders, styleMarshal]);

  if (process.env.NODE_ENV !== 'production') {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(clean$1({
        shouldFlush: true
      }));
    }
  }, []);
  setOnError(tryResetStore);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function () {
    return {
      marshal: dimensionMarshal,
      style: styleMarshal.styleContext,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed
    };
  }, [dimensionMarshal, getCanLift, getIsMovementAllowed, styleMarshal.styleContext]);
  useEffect(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return React__default.createElement(AppContext.Provider, {
    value: appContext
  }, React__default.createElement(Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var instanceCount = 0;
function DragDropContext(props) {
  var uniqueId = useMemo(function () {
    return instanceCount++;
  }, []);
  return React__default.createElement(ErrorBoundary, null, function (setOnError) {
    return React__default.createElement(App, _extends$1({
      setOnError: setOnError,
      uniqueId: uniqueId
    }, props), props.children);
  });
}

var isEqual$2 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$2('scroll');
var isAuto = isEqual$2('auto');
var isVisible$1 = isEqual$2('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

  process.env.NODE_ENV !== "production" ? warning("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

function withoutPlaceholder(placeholder, fn) {
  if (!placeholder) {
    return fn();
  }

  var last = placeholder.style.display;
  placeholder.style.display = 'none';
  var result = fn();
  placeholder.style.display = last;
  return result;
}

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = useContext(Context);
  !result ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find required context') : invariant(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppableDimensionPublisher(args) {
  var whileDraggingRef = useRef(null);
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type
    };
  }, [args.droppableId, args.type]);
  var publishedDescriptorRef = useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function () {
    return memoizeOne(function (x, y) {
      !whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only update scroll when dragging') : invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function () {
    return rafSchd$1(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find scroll options while scrolling') : invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot collect a droppable while a drag is occurring') : invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot collect without a droppable ref') : invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });

    if (env.closestScrollable) {
      env.closestScrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (process.env.NODE_ENV !== 'production') {
        checkForNestedScrollContainers(env.closestScrollable);
      }
    }

    return dimension;
  }, [descriptor, onClosestScroll, previousRef]);
  var recollect = useCallback(function (options) {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : invariant(false) : void 0;
    var previous = previousRef.current;

    var execute = function execute() {
      return getDimension({
        ref: dragging.ref,
        descriptor: dragging.descriptor,
        env: dragging.env,
        windowScroll: origin,
        direction: previous.direction,
        isDropDisabled: previous.isDropDisabled,
        isCombineEnabled: previous.isCombineEnabled,
        shouldClipSubject: !previous.ignoreContainerClipping
      });
    };

    if (!options.withoutPlaceholder) {
      return execute();
    }

    return withoutPlaceholder(previous.getPlaceholderRef(), execute);
  }, [previousRef]);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop drag when no active drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot scroll when there is no drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      recollect: recollect,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, recollect, scroll]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = descriptor;
    marshal.registerDroppable(descriptor, callbacks);
    return function () {
      if (whileDraggingRef.current) {
        process.env.NODE_ENV !== "production" ? warning('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      marshal.unregisterDroppable(descriptor);
    };
  }, [callbacks, descriptor, dragStopped, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: transitions.placeholder
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      styleContext = props.styleContext;

  var _useState = useState(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  useEffect(function () {
    if (!isAnimatingOpenOnMount) {
      return noop;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop;
    }

    if (animateOpenTimerRef.current) {
      return noop;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return React__default.createElement(props.placeholder.tagName, {
    style: style,
    'data-react-beautiful-dnd-placeholder': styleContext,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = React__default.memo(Placeholder);

var DroppableContext = React__default.createContext(null);

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ? process.env.NODE_ENV !== "production" ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant(false) : void 0;
}

function checkOwnProps(props) {
  !props.droppableId ? process.env.NODE_ENV !== "production" ? invariant(false, 'A Droppable requires a droppableId prop') : invariant(false) : void 0;
  !(typeof props.isDropDisabled === 'boolean') ? process.env.NODE_ENV !== "production" ? invariant(false, 'isDropDisabled must be a boolean') : invariant(false) : void 0;
  !(typeof props.isCombineEnabled === 'boolean') ? process.env.NODE_ENV !== "production" ? invariant(false, 'isCombineEnabled must be a boolean') : invariant(false) : void 0;
  !(typeof props.ignoreContainerClipping === 'boolean') ? process.env.NODE_ENV !== "production" ? invariant(false, 'ignoreContainerClipping must be a boolean') : invariant(false) : void 0;
}

function checkPlaceholderRef(props, placeholderEl) {
  if (!props.placeholder) {
    return;
  }

  if (placeholderEl) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning("\n    Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n    DroppableProvided > placeholder could not be found.\n\n    Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n  ") : void 0;
}

function useValidation(_ref) {
  var props = _ref.props,
      getDroppableRef = _ref.getDroppableRef,
      getPlaceholderRef = _ref.getPlaceholderRef;
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      checkOwnProps(props);
      checkIsValidInnerRef(getDroppableRef());
      checkPlaceholderRef(props, getPlaceholderRef());
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  _inheritsLoose(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(React__default.PureComponent);

function Droppable(props) {
  var appContext = useContext(AppContext);
  !appContext ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find app context') : invariant(false) : void 0;
  var styleContext = appContext.style,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = useRef(null);
  var placeholderRef = useRef(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      updateViewportMaxScroll = props.updateViewportMaxScroll;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppableDimensionPublisher({
    droppableId: droppableId,
    type: type,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var placeholder = React__default.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return React__default.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      styleContext: styleContext,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-react-beautiful-dnd-droppable': styleContext
      }
    };
  }, [placeholder, setDroppableRef, styleContext]);
  var droppableContext = useMemo(function () {
    return {
      droppableId: droppableId,
      type: type
    };
  }, [droppableId, type]);
  useValidation({
    props: props,
    getDroppableRef: function getDroppableRef() {
      return droppableRef.current;
    },
    getPlaceholderRef: function getPlaceholderRef() {
      return placeholderRef.current;
    }
  });
  return React__default.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot));
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps = function makeMapStateToProps() {
  var idle = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null
    }
  };

  var idleWithoutAnimation = _extends$1({}, idle, {
    shouldAnimatePlaceholder: false
  });

  var getMapProps = memoizeOne(function (id, isDraggingOver, dragging, snapshot) {
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: snapshot
      };
    }

    if (!isDraggingOver) {
      return idle;
    }

    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot
    };
  });
  var getSnapshot = memoizeOne(function (id, isDraggingOver, dragging) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;
    var draggingOverWith = isDraggingOver ? draggableId : null;
    var draggingFromThisWith = isHome ? draggableId : null;
    return {
      isDraggingOver: isDraggingOver,
      draggingOverWith: draggingOverWith,
      draggingFromThisWith: draggingFromThisWith
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idle;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      var snapshot = getSnapshot(id, isDraggingOver, dragging);
      return getMapProps(id, isDraggingOver, dragging, snapshot);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idle;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      var _snapshot = getSnapshot(id, whatIsDraggedOverFromResult(completed.result) === id, _dragging);

      return getMapProps(id, whatIsDraggedOver(completed.impact) === id, _dragging, _snapshot);
    }

    if (state.phase === 'IDLE' && !state.completed && state.shouldFlush) {
      return idleWithoutAnimation;
    }

    if (state.phase === 'IDLE' && state.completed) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idle;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.merge);

      if (state.shouldFlush) {
        return idleWithoutAnimation;
      }

      if (wasOver) {
        return wasCombining ? idle : idleWithoutAnimation;
      }

      return idle;
    }

    return idle;
  };

  return selector;
};
var mapDispatchToProps = {
  updateViewportMaxScroll: updateViewportMaxScroll
};
var defaultProps = {
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false
};
var ConnectedDroppable = connect(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

var createEventMarshal = (function () {
  var isMouseDownHandled = false;

  var handle = function handle() {
    !!isMouseDownHandled ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot handle mouse down as it is already handled') : invariant(false) : void 0;
    isMouseDownHandled = true;
  };

  var isHandled = function isHandled() {
    return isMouseDownHandled;
  };

  var reset = function reset() {
    isMouseDownHandled = false;
  };

  return {
    handle: handle,
    isHandled: isHandled,
    reset: reset
  };
});

var getOptions = function getOptions(shared, fromBinding) {
  return _extends$1({}, shared, fromBinding);
};

var bindEvents = function bindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
  });
};
var unbindEvents = function unbindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.removeEventListener(binding.eventName, binding.fn, options);
  });
};

var createScheduler = (function (callbacks) {
  var memoizedMove = memoizeOne(function (x, y) {
    var point = {
      x: x,
      y: y
    };
    callbacks.onMove(point);
  });
  var move = rafSchd$1(function (point) {
    return memoizedMove(point.x, point.y);
  });
  var moveUp = rafSchd$1(callbacks.onMoveUp);
  var moveDown = rafSchd$1(callbacks.onMoveDown);
  var moveRight = rafSchd$1(callbacks.onMoveRight);
  var moveLeft = rafSchd$1(callbacks.onMoveLeft);
  var windowScrollMove = rafSchd$1(callbacks.onWindowScroll);

  var cancel = function cancel() {
    move.cancel();
    moveUp.cancel();
    moveDown.cancel();
    moveRight.cancel();
    moveLeft.cancel();
    windowScrollMove.cancel();
  };

  return {
    move: move,
    moveUp: moveUp,
    moveDown: moveDown,
    moveRight: moveRight,
    moveLeft: moveLeft,
    windowScrollMove: windowScrollMove,
    cancel: cancel
  };
});

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var sharedOptions = {
  capture: true
};
var createPostDragEventPreventer = (function (getWindow) {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    bindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    unbindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var pointerEvents = [{
    eventName: 'click',
    fn: function fn(event) {
      event.preventDefault();
      unbind();
    }
  }, {
    eventName: 'mousedown',
    fn: unbind
  }, {
    eventName: 'touchstart',
    fn: unbind
  }];

  var preventNext = function preventNext() {
    if (isBound) {
      unbind();
    }

    bind();
  };

  var preventer = {
    preventNext: preventNext,
    abort: unbind
  };
  return preventer;
});

var sloppyClickThreshold = 5;
var isSloppyClickThresholdExceeded = (function (original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
});

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var primaryButton = 0;

var noop$1 = function noop() {};

var mouseDownMarshal = createEventMarshal();
function useMouseSensor(args) {
  var canStartCapturing = args.canStartCapturing,
      getWindow = args.getWindow,
      callbacks = args.callbacks,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd;
  var pendingRef = useRef(null);
  var isDraggingRef = useRef(false);
  var unbindWindowEventsRef = useRef(noop$1);
  var getIsCapturing = useCallback(function () {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var schedule = useMemo(function () {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not recreate scheduler while capturing') : invariant(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var postDragEventPreventer = useMemo(function () {
    return createPostDragEventPreventer(getWindow);
  }, [getWindow]);
  var stop = useCallback(function () {
    if (!getIsCapturing()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    var shouldBlockClick = isDraggingRef.current;
    mouseDownMarshal.reset();

    if (shouldBlockClick) {
      postDragEventPreventer.preventNext();
    }

    pendingRef.current = null;
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsCapturing, onCaptureEnd, postDragEventPreventer, schedule]);
  var cancel = useCallback(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var startDragging = useCallback(function () {
    !!isDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start a drag while dragging') : invariant(false) : void 0;
    var pending = pendingRef.current;
    !pending ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start a drag without a pending drag') : invariant(false) : void 0;
    pendingRef.current = null;
    isDraggingRef.current = true;
    callbacks.onLift({
      clientSelection: pending,
      movementMode: 'FLUID'
    });
  }, [callbacks]);
  var windowBindings = useMemo(function () {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not recreate window bindings while capturing') : invariant(false) : void 0;
    var bindings = [{
      eventName: 'mousemove',
      fn: function fn(event) {
        var button = event.button,
            clientX = event.clientX,
            clientY = event.clientY;

        if (button !== primaryButton) {
          return;
        }

        var point = {
          x: clientX,
          y: clientY
        };

        if (isDraggingRef.current) {
          event.preventDefault();
          schedule.move(point);
          return;
        }

        var pending = pendingRef.current;

        if (!pending) {
          stop();
          process.env.NODE_ENV !== "production" ? invariant(false, 'Expected there to be an active or pending drag when window mousemove event is received') : invariant(false);
        }

        if (!isSloppyClickThresholdExceeded(pending, point)) {
          return;
        }

        event.preventDefault();
        startDragging();
      }
    }, {
      eventName: 'mouseup',
      fn: function fn(event) {
        var wasDragging = isDraggingRef.current;
        stop();

        if (wasDragging) {
          event.preventDefault();
          callbacks.onDrop();
        }
      }
    }, {
      eventName: 'mousedown',
      fn: function fn(event) {
        if (isDraggingRef.current) {
          event.preventDefault();
        }

        cancel();
      }
    }, {
      eventName: 'keydown',
      fn: function fn(event) {
        if (pendingRef.current) {
          stop();
          return;
        }

        if (event.keyCode === escape) {
          event.preventDefault();
          cancel();
          return;
        }

        preventStandardKeyEvents(event);
      }
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'scroll',
      options: {
        passive: true,
        capture: false
      },
      fn: function fn(event) {
        if (event.currentTarget !== getWindow()) {
          return;
        }

        if (pendingRef.current) {
          stop();
          return;
        }

        schedule.windowScrollMove();
      }
    }, {
      eventName: 'webkitmouseforcedown',
      fn: function fn() {
        cancel();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [getIsCapturing, cancel, startDragging, schedule, stop, callbacks, getWindow]);
  var bindWindowEvents = useCallback(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startPendingDrag = useCallback(function (point) {
    !!pendingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected there to be no pending drag') : invariant(false) : void 0;
    pendingRef.current = point;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, stop]);
  var onMouseDown = useCallback(function (event) {
    if (mouseDownMarshal.isHandled()) {
      return;
    }

    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not be able to perform a mouse down while a drag or pending drag is occurring') : invariant(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    if (event.button !== primaryButton) {
      return;
    }

    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }

    mouseDownMarshal.handle();
    event.preventDefault();
    var point = {
      x: event.clientX,
      y: event.clientY
    };
    startPendingDrag(point);
  }, [canStartCapturing, getIsCapturing, startPendingDrag]);
  return onMouseDown;
}

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

var isAnInteractiveElement = function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
};

var shouldAllowDraggingFromTarget = (function (event, canDragInteractiveElements) {
  if (canDragInteractiveElements) {
    return true;
  }

  var target = event.target,
      currentTarget = event.currentTarget;

  if (!isElement(target) || !isElement(currentTarget)) {
    return true;
  }

  return !isAnInteractiveElement(currentTarget, target);
});

var getBorderBoxCenterPosition = (function (el) {
  return getRect(el.getBoundingClientRect()).center;
});

var _scrollJumpKeys;
var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function noop$2() {}

function useKeyboardSensor(args) {
  var canStartCapturing = args.canStartCapturing,
      getWindow = args.getWindow,
      callbacks = args.callbacks,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd,
      getDraggableRef = args.getDraggableRef;
  var isDraggingRef = useRef(false);
  var unbindWindowEventsRef = useRef(noop$2);
  var getIsDragging = useCallback(function () {
    return isDraggingRef.current;
  }, []);
  var schedule = useMemo(function () {
    !!getIsDragging() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not recreate scheduler while capturing') : invariant(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsDragging]);
  var stop = useCallback(function () {
    if (!getIsDragging()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsDragging, onCaptureEnd, schedule]);
  var cancel = useCallback(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = useMemo(function () {
    !!getIsDragging() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not recreate window bindings when dragging') : invariant(false) : void 0;
    return [{
      eventName: 'mousedown',
      fn: cancel
    }, {
      eventName: 'mouseup',
      fn: cancel
    }, {
      eventName: 'click',
      fn: cancel
    }, {
      eventName: 'touchstart',
      fn: cancel
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'wheel',
      fn: cancel,
      options: {
        passive: true
      }
    }, {
      eventName: 'scroll',
      options: {
        capture: false
      },
      fn: function fn(event) {
        if (event.currentTarget !== getWindow()) {
          return;
        }

        callbacks.onWindowScroll();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
  }, [callbacks, cancel, getIsDragging, getWindow]);
  var bindWindowEvents = useCallback(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startDragging = useCallback(function () {
    !!isDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start a drag while dragging') : invariant(false) : void 0;
    var ref = getDraggableRef();
    !ref ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start a keyboard drag without a draggable ref') : invariant(false) : void 0;
    isDraggingRef.current = true;
    onCaptureStart(stop);
    bindWindowEvents();
    var center = getBorderBoxCenterPosition(ref);
    callbacks.onLift({
      clientSelection: center,
      movementMode: 'SNAP'
    });
  }, [bindWindowEvents, callbacks, getDraggableRef, onCaptureStart, stop]);
  var onKeyDown = useCallback(function (event) {
    if (!getIsDragging()) {
      if (event.defaultPrevented) {
        return;
      }

      if (!canStartCapturing(event)) {
        return;
      }

      if (event.keyCode !== space) {
        return;
      }

      event.preventDefault();
      startDragging();
      return;
    }

    if (event.keyCode === escape) {
      event.preventDefault();
      cancel();
      return;
    }

    if (event.keyCode === space) {
      event.preventDefault();
      stop();
      callbacks.onDrop();
      return;
    }

    if (event.keyCode === arrowDown) {
      event.preventDefault();
      schedule.moveDown();
      return;
    }

    if (event.keyCode === arrowUp) {
      event.preventDefault();
      schedule.moveUp();
      return;
    }

    if (event.keyCode === arrowRight) {
      event.preventDefault();
      schedule.moveRight();
      return;
    }

    if (event.keyCode === arrowLeft) {
      event.preventDefault();
      schedule.moveLeft();
      return;
    }

    if (scrollJumpKeys[event.keyCode]) {
      event.preventDefault();
      return;
    }

    preventStandardKeyEvents(event);
  }, [callbacks, canStartCapturing, cancel, getIsDragging, schedule, startDragging, stop]);
  return onKeyDown;
}

var timeForLongPress = 120;
var forcePressThreshold = 0.15;
var touchStartMarshal = createEventMarshal();

var noop$3 = function noop() {};

function useTouchSensor(args) {
  var callbacks = args.callbacks,
      getWindow = args.getWindow,
      canStartCapturing = args.canStartCapturing,
      getShouldRespectForcePress = args.getShouldRespectForcePress,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd;
  var pendingRef = useRef(null);
  var isDraggingRef = useRef(false);
  var hasMovedRef = useRef(false);
  var unbindWindowEventsRef = useRef(noop$3);
  var getIsCapturing = useCallback(function () {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var postDragClickPreventer = useMemo(function () {
    return createPostDragEventPreventer(getWindow);
  }, [getWindow]);
  var schedule = useMemo(function () {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not recreate scheduler while capturing') : invariant(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var stop = useCallback(function () {
    if (!getIsCapturing()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    touchStartMarshal.reset();
    hasMovedRef.current = false;
    onCaptureEnd();

    if (isDraggingRef.current) {
      postDragClickPreventer.preventNext();
      isDraggingRef.current = false;
      return;
    }

    var pending = pendingRef.current;
    !pending ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected a pending drag') : invariant(false) : void 0;
    clearTimeout(pending.longPressTimerId);
    pendingRef.current = null;
  }, [getIsCapturing, onCaptureEnd, postDragClickPreventer, schedule]);
  var cancel = useCallback(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = useMemo(function () {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not recreate window bindings while capturing') : invariant(false) : void 0;
    var bindings = [{
      eventName: 'touchmove',
      options: {
        passive: false,
        capture: false
      },
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        if (!hasMovedRef.current) {
          hasMovedRef.current = true;
        }

        var touch = event.touches[0];

        if (!touch) {
          return;
        }

        var point = {
          x: touch.clientX,
          y: touch.clientY
        };
        event.preventDefault();
        schedule.move(point);
      }
    }, {
      eventName: 'touchend',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        event.preventDefault();
        stop();
        callbacks.onDrop();
      }
    }, {
      eventName: 'touchcancel',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        event.preventDefault();
        cancel();
      }
    }, {
      eventName: 'touchstart',
      fn: cancel
    }, {
      eventName: 'orientationchange',
      fn: cancel
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'scroll',
      options: {
        passive: true,
        capture: false
      },
      fn: function fn() {
        if (pendingRef.current) {
          stop();
          return;
        }

        schedule.windowScrollMove();
      }
    }, {
      eventName: 'contextmenu',
      fn: function fn(event) {
        event.preventDefault();
      }
    }, {
      eventName: 'keydown',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          cancel();
          return;
        }

        if (event.keyCode === escape) {
          event.preventDefault();
        }

        cancel();
      }
    }, {
      eventName: 'touchforcechange',
      fn: function fn(event) {
        var touch = event.touches[0];
        var isForcePress = touch.force >= forcePressThreshold;

        if (!isForcePress) {
          return;
        }

        var shouldRespect = getShouldRespectForcePress();

        if (pendingRef.current) {
          if (shouldRespect) {
            cancel();
          }

          return;
        }

        if (shouldRespect) {
          if (hasMovedRef.current) {
            event.preventDefault();
            return;
          }

          cancel();
          return;
        }

        event.preventDefault();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [callbacks, cancel, getIsCapturing, getShouldRespectForcePress, schedule, stop]);
  var bindWindowEvents = useCallback(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startDragging = useCallback(function () {
    var pending = pendingRef.current;
    !pending ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start a drag without a pending drag') : invariant(false) : void 0;
    isDraggingRef.current = true;
    pendingRef.current = null;
    hasMovedRef.current = false;
    callbacks.onLift({
      clientSelection: pending.point,
      movementMode: 'FLUID'
    });
  }, [callbacks]);
  var startPendingDrag = useCallback(function (event) {
    !!pendingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected there to be no pending drag') : invariant(false) : void 0;
    var touch = event.touches[0];
    var clientX = touch.clientX,
        clientY = touch.clientY;
    var point = {
      x: clientX,
      y: clientY
    };
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    var pending = {
      point: point,
      longPressTimerId: longPressTimerId
    };
    pendingRef.current = pending;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, startDragging, stop]);

  var onTouchStart = function onTouchStart(event) {
    if (touchStartMarshal.isHandled()) {
      return;
    }

    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not be able to perform a touch start while a drag or pending drag is occurring') : invariant(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    touchStartMarshal.handle();
    startPendingDrag(event);
  };

  useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: noop$3,
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
  return onTouchStart;
}

function isSvgElement(el) {
  return Boolean(getWindowFromEl(el).SVGElement) && el instanceof getWindowFromEl(el).SVGElement;
}

var selector = "[" + dragHandle + "]";

var throwIfSVG = function throwIfSVG(el) {
  !!isSvgElement(el) ? process.env.NODE_ENV !== "production" ? invariant(false, "A drag handle cannot be an SVGElement: it has inconsistent focus support.\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/dragging-svgs.md") : invariant(false) : void 0;
};

var getDragHandleRef = function getDragHandleRef(draggableRef) {
  if (draggableRef.hasAttribute(dragHandle)) {
    throwIfSVG(draggableRef);
    return draggableRef;
  }

  var el = draggableRef.querySelector(selector);
  throwIfSVG(draggableRef);
  !el ? process.env.NODE_ENV !== "production" ? invariant(false, "\n      Cannot find drag handle element inside of Draggable.\n      Please be sure to apply the {...provided.dragHandleProps} to your Draggable\n\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md\n    ") : invariant(false) : void 0;
  !isHtmlElement(el) ? process.env.NODE_ENV !== "production" ? invariant(false, 'A drag handle must be a HTMLElement') : invariant(false) : void 0;
  return el;
};

function useValidation$1(_ref) {
  var isEnabled = _ref.isEnabled,
      getDraggableRef = _ref.getDraggableRef;
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (!isEnabled) {
        return;
      }

      var draggableRef = getDraggableRef();
      !draggableRef ? process.env.NODE_ENV !== "production" ? invariant(false, 'Drag handle was unable to find draggable ref') : invariant(false) : void 0;
      getDragHandleRef(draggableRef);
    }
  }, [getDraggableRef, isEnabled]);
}

var retainingFocusFor = null;
var listenerOptions = {
  capture: true
};

var clearRetentionOnFocusChange = function () {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    window.addEventListener('focus', onWindowFocusChange, listenerOptions);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    window.removeEventListener('focus', onWindowFocusChange, listenerOptions);
  };

  var onWindowFocusChange = function onWindowFocusChange() {
    unbind();
    retainingFocusFor = null;
  };

  var result = function result() {
    return bind();
  };

  result.cancel = function () {
    return unbind();
  };

  return result;
}();

var retain = function retain(id) {
  retainingFocusFor = id;
  clearRetentionOnFocusChange();
};

var tryRestoreFocus = function tryRestoreFocus(id, draggableRef) {
  if (!retainingFocusFor) {
    return;
  }

  if (id !== retainingFocusFor) {
    return;
  }

  retainingFocusFor = null;
  clearRetentionOnFocusChange.cancel();
  var dragHandleRef = getDragHandleRef(draggableRef);

  if (!dragHandleRef) {
    process.env.NODE_ENV !== "production" ? warning('Could not find drag handle in the DOM to focus on it') : void 0;
    return;
  }

  dragHandleRef.focus();
};

var retainer = {
  retain: retain,
  tryRestoreFocus: tryRestoreFocus
};

function noop$4() {}

function useFocusRetainer(args) {
  var isFocusedRef = useRef(false);
  var lastArgsRef = usePrevious(args);
  var getDraggableRef = args.getDraggableRef;
  var onFocus = useCallback(function () {
    isFocusedRef.current = true;
  }, []);
  var onBlur = useCallback(function () {
    isFocusedRef.current = false;
  }, []);
  useIsomorphicLayoutEffect(function () {
    var first = lastArgsRef.current;

    if (!first.isEnabled) {
      return noop$4;
    }

    var draggable = getDraggableRef();
    !draggable ? process.env.NODE_ENV !== "production" ? invariant(false, 'Drag handle could not obtain draggable ref') : invariant(false) : void 0;
    var dragHandle = getDragHandleRef(draggable);
    retainer.tryRestoreFocus(first.draggableId, dragHandle);
    return function () {
      var last = lastArgsRef.current;

      var shouldRetainFocus = function () {
        if (!last.isEnabled) {
          return false;
        }

        if (!isFocusedRef.current) {
          return false;
        }

        return last.isDragging || last.isDropAnimating;
      }();

      if (shouldRetainFocus) {
        retainer.retain(last.draggableId);
      }
    };
  }, [getDraggableRef, lastArgsRef]);
  var lastDraggableRef = useRef(null);
  useIsomorphicLayoutEffect(function () {
    if (!lastDraggableRef.current) {
      return;
    }

    var draggableRef = getDraggableRef();

    if (!draggableRef) {
      return;
    }

    if (draggableRef === lastDraggableRef.current) {
      return;
    }

    if (isFocusedRef.current && lastArgsRef.current.isEnabled) {
      getDragHandleRef(draggableRef).focus();
    }
  });
  useIsomorphicLayoutEffect(function () {
    lastDraggableRef.current = getDraggableRef();
  });
  return {
    onBlur: onBlur,
    onFocus: onFocus
  };
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function useDragHandle(args) {
  var capturingRef = useRef(null);
  var onCaptureStart = useCallback(function (abort) {
    !!capturingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start capturing while something else is') : invariant(false) : void 0;
    capturingRef.current = {
      abort: abort
    };
  }, []);
  var onCaptureEnd = useCallback(function () {
    !capturingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop capturing while nothing is capturing') : invariant(false) : void 0;
    capturingRef.current = null;
  }, []);
  var abortCapture = useCallback(function () {
    !capturingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot abort capture when there is none') : invariant(false) : void 0;
    capturingRef.current.abort();
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      canLift = _useRequiredContext.canLift,
      styleContext = _useRequiredContext.style;

  var isDragging = args.isDragging,
      isEnabled = args.isEnabled,
      draggableId = args.draggableId,
      callbacks = args.callbacks,
      getDraggableRef = args.getDraggableRef,
      getShouldRespectForcePress = args.getShouldRespectForcePress,
      canDragInteractiveElements = args.canDragInteractiveElements;
  var lastArgsRef = usePrevious(args);
  useValidation$1({
    isEnabled: isEnabled,
    getDraggableRef: getDraggableRef
  });
  var getWindow = useCallback(function () {
    return getWindowFromEl(getDraggableRef());
  }, [getDraggableRef]);
  var canStartCapturing = useCallback(function (event) {
    if (!isEnabled) {
      return false;
    }

    if (capturingRef.current) {
      return false;
    }

    if (!canLift(draggableId)) {
      return false;
    }

    return shouldAllowDraggingFromTarget(event, canDragInteractiveElements);
  }, [canDragInteractiveElements, canLift, draggableId, isEnabled]);

  var _useFocusRetainer = useFocusRetainer(args),
      onBlur = _useFocusRetainer.onBlur,
      onFocus = _useFocusRetainer.onFocus;

  var mouseArgs = useMemo(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd,
      getShouldRespectForcePress: getShouldRespectForcePress
    };
  }, [callbacks, getDraggableRef, getWindow, canStartCapturing, onCaptureStart, onCaptureEnd, getShouldRespectForcePress]);
  var onMouseDown = useMouseSensor(mouseArgs);
  var keyboardArgs = useMemo(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd
    };
  }, [callbacks, canStartCapturing, getDraggableRef, getWindow, onCaptureEnd, onCaptureStart]);
  var onKeyDown = useKeyboardSensor(keyboardArgs);
  var touchArgs = useMemo(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      getShouldRespectForcePress: getShouldRespectForcePress,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd
    };
  }, [callbacks, getDraggableRef, getWindow, canStartCapturing, getShouldRespectForcePress, onCaptureStart, onCaptureEnd]);
  var onTouchStart = useTouchSensor(touchArgs);
  useIsomorphicLayoutEffect(function () {
    return function () {
      if (!capturingRef.current) {
        return;
      }

      abortCapture();

      if (lastArgsRef.current.isDragging) {
        lastArgsRef.current.callbacks.onCancel();
      }
    };
  }, []);

  if (!isEnabled && capturingRef.current) {
    abortCapture();

    if (lastArgsRef.current.isDragging) {
      process.env.NODE_ENV !== "production" ? warning('You have disabled dragging on a Draggable while it was dragging. The drag has been cancelled') : void 0;
      callbacks.onCancel();
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (!isDragging && capturingRef.current) {
      abortCapture();
    }
  }, [abortCapture, isDragging]);
  var props = useMemo(function () {
    if (!isEnabled) {
      return null;
    }

    return {
      onMouseDown: onMouseDown,
      onKeyDown: onKeyDown,
      onTouchStart: onTouchStart,
      onFocus: onFocus,
      onBlur: onBlur,
      tabIndex: 0,
      'data-react-beautiful-dnd-drag-handle': styleContext,
      'aria-roledescription': 'Draggable item. Press space bar to lift',
      draggable: false,
      onDragStart: preventHtml5Dnd
    };
  }, [isEnabled, onBlur, onFocus, onKeyDown, onMouseDown, onTouchStart, styleContext]);
  return props;
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggableDimensionPublisher(args) {
  var draggableId = args.draggableId,
      index = args.index,
      getDraggableRef = args.getDraggableRef;
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var droppableContext = useRequiredContext(DroppableContext);
  var droppableId = droppableContext.droppableId,
      type = droppableContext.type;
  var descriptor = useMemo(function () {
    var result = {
      id: draggableId,
      droppableId: droppableId,
      type: type,
      index: index
    };
    return result;
  }, [draggableId, droppableId, index, type]);
  var publishedDescriptorRef = useRef(descriptor);
  var makeDimension = useCallback(function (windowScroll) {
    var latest = publishedDescriptorRef.current;
    var el = getDraggableRef();
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot get dimension when no ref is set') : invariant(false) : void 0;
    return getDimension$1(latest, el, windowScroll);
  }, [getDraggableRef]);
  useIsomorphicLayoutEffect(function () {
    marshal.registerDraggable(publishedDescriptorRef.current, makeDimension);
    return function () {
      return marshal.unregisterDraggable(publishedDescriptorRef.current);
    };
  }, [makeDimension, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (publishedDescriptorRef.current === descriptor) {
      return;
    }

    var previous = publishedDescriptorRef.current;
    publishedDescriptorRef.current = descriptor;
    marshal.updateDraggable(previous, descriptor, makeDimension);
  }, [descriptor, makeDimension, marshal]);
}

function checkOwnProps$1(props) {
  !isInteger(props.index) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Draggable requires an integer index prop') : invariant(false) : void 0;
  !props.draggableId ? process.env.NODE_ENV !== "production" ? invariant(false, 'Draggable requires a draggableId') : invariant(false) : void 0;
  !(typeof props.isDragDisabled === 'boolean') ? process.env.NODE_ENV !== "production" ? invariant(false, 'isDragDisabled must be a boolean') : invariant(false) : void 0;
}

function checkForOutdatedProps(props) {
  if (Object.prototype.hasOwnProperty.call(props, 'shouldRespectForceTouch')) {
    process.env.NODE_ENV !== "production" ? warning('shouldRespectForceTouch has been renamed to shouldRespectForcePress') : void 0;
  }
}

function useValidation$2(props, getRef) {
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      checkOwnProps$1(props);
      checkForOutdatedProps(props);
      checkIsValidInnerRef(getRef());
    }
  });
}

function Draggable(props) {
  var ref = useRef(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);
  var appContext = useRequiredContext(AppContext);
  useValidation$2(props, getRef);
  var children = props.children,
      draggableId = props.draggableId,
      isDragDisabled = props.isDragDisabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.disableInteractiveElementBlocking,
      index = props.index,
      mapped = props.mapped,
      moveUpAction = props.moveUp,
      moveAction = props.move,
      dropAction = props.drop,
      moveDownAction = props.moveDown,
      moveRightAction = props.moveRight,
      moveLeftAction = props.moveLeft,
      moveByWindowScrollAction = props.moveByWindowScroll,
      liftAction = props.lift,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  var forPublisher = useMemo(function () {
    return {
      draggableId: draggableId,
      index: index,
      getDraggableRef: getRef
    };
  }, [draggableId, getRef, index]);
  useDraggableDimensionPublisher(forPublisher);
  var onLift = useCallback(function (options) {
    start();
    var el = ref.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
    !!isDragDisabled ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot lift a Draggable when it is disabled') : invariant(false) : void 0;
    var clientSelection = options.clientSelection,
        movementMode = options.movementMode;
    liftAction({
      id: draggableId,
      clientSelection: clientSelection,
      movementMode: movementMode
    });
    finish();
  }, [draggableId, isDragDisabled, liftAction]);
  var getShouldRespectForcePress = useCallback(function () {
    return shouldRespectForcePress;
  }, [shouldRespectForcePress]);
  var callbacks = useMemo(function () {
    return {
      onLift: onLift,
      onMove: function onMove(clientSelection) {
        return moveAction({
          client: clientSelection
        });
      },
      onDrop: function onDrop() {
        return dropAction({
          reason: 'DROP'
        });
      },
      onCancel: function onCancel() {
        return dropAction({
          reason: 'CANCEL'
        });
      },
      onMoveUp: moveUpAction,
      onMoveDown: moveDownAction,
      onMoveRight: moveRightAction,
      onMoveLeft: moveLeftAction,
      onWindowScroll: function onWindowScroll() {
        return moveByWindowScrollAction({
          newScroll: getWindowScroll()
        });
      }
    };
  }, [dropAction, moveAction, moveByWindowScrollAction, moveDownAction, moveLeftAction, moveRightAction, moveUpAction, onLift]);
  var isDragging = mapped.type === 'DRAGGING';
  var isDropAnimating = mapped.type === 'DRAGGING' && Boolean(mapped.dropping);
  var dragHandleArgs = useMemo(function () {
    return {
      draggableId: draggableId,
      isDragging: isDragging,
      isDropAnimating: isDropAnimating,
      isEnabled: !isDragDisabled,
      callbacks: callbacks,
      getDraggableRef: getRef,
      canDragInteractiveElements: canDragInteractiveElements,
      getShouldRespectForcePress: getShouldRespectForcePress
    };
  }, [callbacks, canDragInteractiveElements, draggableId, getRef, getShouldRespectForcePress, isDragDisabled, isDragging, isDropAnimating]);
  var dragHandleProps = useDragHandle(dragHandleArgs);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-react-beautiful-dnd-draggable': appContext.style,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [appContext.style, dragHandleProps, mapped, onMoveEnd, setRef]);
  return children(provided, mapped.snapshot);
}

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.merge ? impact.merge.combine.draggableId : null;
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var getDraggingSnapshot = memoizeOne(function (mode, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getSecondarySnapshot = memoizeOne(function (combineTargetFor) {
    return {
      isDragging: false,
      isDropAnimating: false,
      dropAnimation: null,
      mode: null,
      draggingOver: null,
      combineTargetFor: combineTargetFor,
      combineWith: null
    };
  });
  var defaultMapProps = {
    mapped: {
      type: 'SECONDARY',
      offset: origin,
      combineTargetFor: null,
      shouldAnimateDisplacement: true,
      snapshot: getSecondarySnapshot(null)
    }
  };
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getDraggingProps = memoizeOne(function (offset, mode, dimension, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getDraggingSnapshot(mode, draggingOver, combineWith, null)
      }
    };
  });
  var getSecondaryProps = memoizeOne(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getSecondarySnapshot(combineTargetFor)
      }
    };
  });

  var getSecondaryMovement = function getSecondaryMovement(ownId, draggingId, impact) {
    var map = impact.movement.map;
    var displacement = map[ownId];
    var movement = impact.movement;
    var merge = impact.merge;
    var isCombinedWith = Boolean(merge && merge.combine.draggableId === ownId);
    var displacedBy = movement.displacedBy.point;
    var offset = memoizedOffset(displacedBy.x, displacedBy.y);

    if (isCombinedWith) {
      return getSecondaryProps(displacement ? offset : origin, draggingId, displacement ? displacement.shouldAnimate : true);
    }

    if (!displacement) {
      return null;
    }

    if (!displacement.isVisible) {
      return null;
    }

    return getSecondaryProps(offset, null, displacement.shouldAnimate);
  };

  var draggingSelector = function draggingSelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var mode = state.movementMode;
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getDraggingProps(memoizedOffset(offset.x, offset.y), mode, dimension, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var _mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: _mode,
          forceShouldAnimate: null,
          snapshot: getDraggingSnapshot(_mode, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  var secondarySelector = function secondarySelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getSecondaryMovement(ownProps.draggableId, state.critical.draggable.id, state.impact);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getSecondaryMovement(ownProps.draggableId, completed.result.draggableId, completed.impact);
    }

    return null;
  };

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || defaultMapProps;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  lift: lift,
  move: move,
  moveUp: moveUp,
  moveDown: moveDown,
  moveLeft: moveLeft,
  moveRight: moveRight,
  moveByWindowScroll: moveByWindowScroll,
  drop: drop,
  dropAnimationFinished: dropAnimationFinished
};
var defaultProps$1 = {
  isDragDisabled: false,
  disableInteractiveElementBlocking: false,
  shouldRespectForcePress: false
};
var ConnectedDraggable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);
ConnectedDraggable.defaultProps = defaultProps$1;

var __assign$1H = (undefined && undefined.__assign) || function () {
    __assign$1H = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1H.apply(this, arguments);
};
var __rest$1m = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1u = {
    content: "ReactNodeLike",
    icon: "SpsIcon",
    title: "string",
};
var propTypes$1x = __assign$1H(__assign$1H({}, spsGlobalPropTypes), { content: propTypes$1H.exports.node, icon: enumValue(SpsIcon), title: propTypes$1H.exports.string });
function SpsCardHeader(props) {
    var content = props.content, className = props.className, icon = props.icon, title = props.title; props["data-testid"]; var unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1m(props, ["content", "className", "icon", "title", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-card__header", className);
    return (React.createElement("div", __assign$1H({ className: classes, title: title }, rest),
        React.createElement("div", { className: "sps-card__title" },
            " ",
            icon && React.createElement("i", { "aria-hidden": "true", className: "sps-icon sps-icon-" + icon }),
            " ",
            title),
        React.createElement("div", { className: "sps-card__header-content" }, content)));
}
Object.assign(SpsCardHeader, {
    props: propsDoc$1u,
    propTypes: propTypes$1x,
    displayName: "SpsCardHeader",
});

var __assign$1G = (undefined && undefined.__assign) || function () {
    __assign$1G = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1G.apply(this, arguments);
};
var __rest$1l = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1t = {
    icon: "SpsIcon",
    kind: "TagKind",
};
var propTypes$1w = __assign$1G(__assign$1G({}, spsGlobalPropTypes), { icon: enumValue(SpsIcon), kind: enumValue(TagKind) });
function SpsTag(props) {
    var children = props.children, className = props.className, icon = props.icon, _a = props.kind, kind = _a === void 0 ? TagKind.DEFAULT : _a, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1l(props, ["children", "className", "icon", "kind", "data-testid", "unsafelyReplaceClassName"]);
    var title = React.Children.toArray(children)
        .filter(function (c) { return typeof c === "string"; })
        .join("");
    var classes = clsx(unsafelyReplaceClassName || "sps-tag", "sps-tag--" + kind, className);
    return (React.createElement("span", __assign$1G({ className: classes, "data-testid": testId + "__tag", title: title }, rest),
        icon && (React.createElement("i", { "aria-hidden": "true", className: "sps-icon sps-icon-" + icon, "data-testid": testId + "__icon" })),
        children));
}
Object.assign(SpsTag, {
    props: propsDoc$1t,
    propTypes: propTypes$1w,
    displayName: "SpsTag",
});

var __assign$1F = (undefined && undefined.__assign) || function () {
    __assign$1F = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1F.apply(this, arguments);
};
var __rest$1k = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1s = {
    activateTab: "Function",
    active: "boolean",
    icon: "SpsIcon",
    label: "string",
    index: "number",
    tag: "string",
    tagKind: "TagKind",
    tagIcon: "SpsIcon",
};
var propTypes$1v = __assign$1F(__assign$1F({}, spsGlobalPropTypes), { activateTab: propTypes$1H.exports.func, active: propTypes$1H.exports.bool, icon: enumValue(SpsIcon), label: propTypes$1H.exports.string, index: propTypes$1H.exports.number, tag: propTypes$1H.exports.string, tagKind: enumValue(TagKind), tagIcon: enumValue(SpsIcon) });
function SpsCardTabbedPane(props) {
    var _this = this;
    var activateTab = props.activateTab, active = props.active, children = props.children, className = props.className, label = props.label, icon = props.icon, id = props.id, index = props.index, tag = props.tag, tagKind = props.tagKind, tagIcon = props.tagIcon; props["data-testid"]; var unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1k(props, ["activateTab", "active", "children", "className", "label", "icon", "id", "index", "tag", "tagKind", "tagIcon", "data-testid", "unsafelyReplaceClassName"]);
    var onAnchorClick = function () {
        activateTab(_this, index, children);
    };
    var handleKeyDown = function (event) {
        if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            event.stopPropagation();
            activateTab(_this, index, children);
        }
    };
    var classes = clsx(unsafelyReplaceClassName || "sps-nav__item", "sps-nav__link", active && "active", className);
    return (React.createElement("a", __assign$1F({ className: classes, onClick: onAnchorClick, "data-toggle": "tab", id: id, role: "tab", "aria-controls": id }, rest, { tabIndex: 0, onKeyDown: handleKeyDown }),
        icon && React.createElement("i", { className: "sps-icon sps-icon-" + icon }),
        React.createElement("span", null, label),
        tag && React.createElement(SpsTag, { kind: tagKind || TagKind.KEY, icon: tagIcon }, tag)));
}
Object.assign(SpsCardTabbedPane, {
    props: propsDoc$1s,
    propTypes: propTypes$1v,
    displayName: "SpsCardTabbedPane",
});

var __assign$1E = (undefined && undefined.__assign) || function () {
    __assign$1E = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1E.apply(this, arguments);
};
var __read$N = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values$6 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * A react hook for tabs
 * @param children
 * @param activeTab
 * @param isTabbedCard
 */
function useTab(children, activeTab, isTabbedCard) {
    // STATE: Currently active tab state
    var _a = __read$N(React.useState({
        index: 0,
        content: null,
    }), 2), currentlyActiveTab = _a[0], setCurrentlyActiveTab = _a[1];
    // CALLBACK: Memoized callback that sets the active tab
    var activateTab = React.useCallback(function (event, index, content) {
        setCurrentlyActiveTab({ index: index, content: content });
    }, []);
    // EFFECT: Set up the initial tab state
    React.useEffect(function () {
        /**
         * Set the initially displayed tab content
         * @param childrenArr an array of children representing tabs
         */
        function setInitialTabContent(initialChildrenArray) {
            var e_1, _a;
            try {
                for (var initialChildrenArray_1 = __values$6(initialChildrenArray), initialChildrenArray_1_1 = initialChildrenArray_1.next(); !initialChildrenArray_1_1.done; initialChildrenArray_1_1 = initialChildrenArray_1.next()) {
                    var child = initialChildrenArray_1_1.value;
                    var firstTab = child.props;
                    setCurrentlyActiveTab(__assign$1E(__assign$1E({}, currentlyActiveTab), { content: firstTab.children }));
                    break;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (initialChildrenArray_1_1 && !initialChildrenArray_1_1.done && (_a = initialChildrenArray_1.return)) _a.call(initialChildrenArray_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        /**
         * Set the currently active tab by id
         * @param childrenArr an array of children representing tabs
         * @param activeTabId the id to set as active
         */
        function setActiveTabById(availableChildrenArray, activeTabId) {
            for (var index = 0; index <= availableChildrenArray.length; index += 1) {
                var child = availableChildrenArray[index];
                if (child
                    && child.props
                    && ((child.props.id && child.props.id === activeTabId)
                        || (child.props.label && child.props.label === activeTabId))) {
                    setCurrentlyActiveTab({
                        content: child.props.children,
                        index: index,
                    });
                    break;
                }
            }
        }
        var childrenAsArray = React.Children.toArray(children);
        if (isTabbedCard && activeTab) {
            setActiveTabById(childrenAsArray, activeTab);
        }
        else if (isTabbedCard) {
            setInitialTabContent(childrenAsArray);
        }
    }, [activeTab, children]);
    return [currentlyActiveTab, activateTab];
}

var __assign$1D = (undefined && undefined.__assign) || function () {
    __assign$1D = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1D.apply(this, arguments);
};
var __rest$1j = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$M = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1r = {
    activeTab: 'string',
    footer: 'ReactNodeOrRenderFn',
    headerContent: 'ReactNodeOrRenderFn',
    headerIcon: 'SpsIcon',
    headerTitle: 'string',
};
var propTypes$1u = __assign$1D(__assign$1D({}, spsGlobalPropTypes), { activeTab: propTypes$1H.exports.string, footer: nodeOrRenderFn, headerContent: nodeOrRenderFn, headerIcon: enumValue(SpsIcon), headerTitle: propTypes$1H.exports.string });
function SpsCard(props) {
    React.useEffect(function () {
        console.log([
            "App developers: There's a new card component! Update for improved performance,",
            "fewer bugs, and increased flexibility. Reach out to the design system help Slack",
            "channel if you have any questions!",
        ].join(" "));
    }, []);
    var activeTab = props.activeTab, children = props.children, className = props.className, footer = props.footer, headerContent = props.headerContent, headerIcon = props.headerIcon, headerTitle = props.headerTitle, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1j(props, ["activeTab", "children", "className", "footer", "headerContent", "headerIcon", "headerTitle", 'data-testid', "unsafelyReplaceClassName"]);
    // This used to be a prop but now we derive it
    var isTabbedCard = React.Children.toArray(children).some(function (child) { return React.isValidElement(child) && child.type === SpsCardTabbedPane; });
    var _a = __read$M(useTab(children, activeTab, isTabbedCard), 2), currentlyActiveTab = _a[0], setCurrentlyActiveTab = _a[1];
    var classes = clsx(unsafelyReplaceClassName || 'sps-card', className);
    return (React.createElement("div", __assign$1D({}, rest, { className: classes, "data-testid": testId + "__card" }),
        (headerTitle || headerContent) && (React.createElement(SpsCardHeader, { title: headerTitle, content: contentOf(headerContent), icon: headerIcon, "data-testid": testId + "__header" })),
        isTabbedCard === true ? (React.createElement(React.Fragment, null,
            React.createElement("nav", { className: "sps-nav sps-nav--tabs", role: "tablist", "data-testid": testId + "__tabs" }, React.Children.map(children, function (child, index) {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, {
                        active: index === currentlyActiveTab.index,
                        index: index,
                        activateTab: setCurrentlyActiveTab,
                        'data-testid': testId + "__tab",
                    });
                }
            })),
            React.createElement("div", { className: "sps-card__body", "data-testid": testId + "__body--tab-active" }, currentlyActiveTab.content))) : (React.createElement("div", { className: "sps-card__body", "data-testid": testId + "__body" }, children)),
        footer && (React.createElement("div", { className: "sps-card__footer", "data-testid": testId + "__footer" }, contentOf(footer)))));
}
Object.assign(SpsCard, {
    props: propsDoc$1r,
    propTypes: propTypes$1u,
    displayName: 'SpsCard',
});

var __assign$1C = (undefined && undefined.__assign) || function () {
    __assign$1C = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1C.apply(this, arguments);
};
var __rest$1i = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1q = {
    index: "number",
    key: "string",
    columnId: "string",
    name: "string",
    value: "string",
    onDelete: "(columnValue: string) => void",
    mandatory: "boolean",
};
var propTypes$1t = __assign$1C(__assign$1C({}, spsGlobalPropTypes), { index: propTypes$1H.exports.number, key: propTypes$1H.exports.string, columnId: propTypes$1H.exports.string, name: propTypes$1H.exports.string, value: propTypes$1H.exports.string, onDelete: fun(), mandatory: propTypes$1H.exports.bool });
function SpsColumnChooserColumn(props) {
    var index = props.index; props.key; var columnId = props.columnId, name = props.name, value = props.value, onDelete = props.onDelete, mandatory = props.mandatory, rest = __rest$1i(props, ["index", "key", "columnId", "name", "value", "onDelete", "mandatory"]);
    var t = React.useContext(I18nContext).t;
    return (React.createElement(ConnectedDraggable, __assign$1C({ key: columnId, draggableId: columnId, index: index || 0 }, rest), function (provided) { return (React.createElement("div", __assign$1C({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { className: "sps-content-row" }),
        React.createElement("div", { className: "sps-content-row__col-group", "data-col-value": value },
            React.createElement("div", { className: "sps-content-row__col sps-column-chooser__grab-col" },
                React.createElement("i", { className: "sps-column-chooser__drag-handle" })),
            React.createElement("div", { className: "sps-content-row__col--borderless" },
                React.createElement("div", { className: "sps-body-12" }, name)),
            React.createElement("div", { className: "sps-content-row__col sps-column-chooser__delete-col" }, !mandatory && (React.createElement(SpsButton, { "aria-label": t("design-system:columnChooser.removeButton", {
                    elementName: name,
                }), kind: ButtonKind.ICON, icon: SpsIcon.X, onClick: function () {
                    if (onDelete) {
                        onDelete(value);
                    }
                } })))))); }));
}
Object.assign(SpsColumnChooserColumn, {
    props: propsDoc$1q,
    propTypes: propTypes$1t,
    displayName: "SpsColumnChooserColumn",
});

var __assign$1B = (undefined && undefined.__assign) || function () {
    __assign$1B = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1B.apply(this, arguments);
};
var __rest$1h = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$L = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$3 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// TODO: Put English strings into i18n system
var propsDoc$1p = {
    maxSelectedColumns: "number",
    unselectedColumns: "ColumnProps[]",
    selectedColumns: "ColumnProps[]",
    onApplyChanges: "(selectedColumns: ColumnProps[]) => void",
};
var propTypes$1s = __assign$1B(__assign$1B({}, spsGlobalPropTypes), { maxSelectedColumns: propTypes$1H.exports.number, unselectedColumns: propTypes$1H.exports.array, selectedColumns: propTypes$1H.exports.array, onApplyChanges: fun() });
function SpsColumnChooser(props) {
    var unselectedColumns = props.unselectedColumns, selectedColumns = props.selectedColumns, maxSelectedColumns = props.maxSelectedColumns, onApplyChanges = props.onApplyChanges, className = props.className; props.unsafelyReplaceClassName; var rest = __rest$1h(props, ["unselectedColumns", "selectedColumns", "maxSelectedColumns", "onApplyChanges", "className", "unsafelyReplaceClassName"]);
    var _a = __read$L(usePatchReducer({
        isVisible: false,
        unselectedColumns: __spreadArray$3([], __read$L(unselectedColumns.map(function (column) { return (__assign$1B(__assign$1B({}, column), { label: column.name, columnId: nanoid$1() })); })), false),
        selectedColumns: __spreadArray$3([], __read$L(selectedColumns.map(function (column) { return (__assign$1B(__assign$1B({}, column), { columnId: nanoid$1() })); })), false),
        searchSelectedColumn: null,
    }), 2), state = _a[0], patchState = _a[1];
    function onSelectBoxChange(event) {
        if (event.target.value) {
            var selected_1 = __spreadArray$3([], __read$L(state.selectedColumns), false);
            var unselected_1 = [];
            state.unselectedColumns.forEach(function (column) {
                if (event.target.value === column.name) {
                    selected_1.push({
                        columnId: nanoid$1(),
                        name: column.name,
                        value: column.value,
                    });
                }
                else {
                    unselected_1.push(column);
                }
            });
            patchState({
                selectedColumns: selected_1,
                unselectedColumns: unselected_1,
                searchSelectedColumn: null,
            });
        }
        patchState({ searchSelectedColumn: null });
    }
    function removeColumn(columnValue) {
        var selected = [];
        var unselected = __spreadArray$3([], __read$L(state.unselectedColumns), false);
        state.selectedColumns.forEach(function (column) {
            if (columnValue === column.value) {
                unselected.push({
                    columnId: nanoid$1(),
                    name: column.name,
                    value: column.value,
                });
            }
            else {
                selected.push(column);
            }
        });
        patchState({ selectedColumns: selected, unselectedColumns: unselected });
    }
    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }
        var selected = __spreadArray$3([], __read$L(state.selectedColumns), false);
        var _a = __read$L(selected.splice(result.source.index, 1), 1), removed = _a[0];
        selected.splice(result.destination.index, 0, removed);
        patchState({ selectedColumns: selected });
    }
    function applyChanges() {
        patchState({ isVisible: false });
        var selectedColumnsCopy = state.selectedColumns.map(function (column) {
            var selectedColumn = __assign$1B({}, column);
            if (selectedColumn.columnId) {
                delete selectedColumn.columnId;
            }
            return selectedColumn;
        });
        onApplyChanges(selectedColumnsCopy);
    }
    function onVisibilityToggle() {
        patchState({ isVisible: !state.isVisible });
    }
    var classes = clsx(state.isVisible && "sps-button--open", className);
    return (React.createElement("div", __assign$1B({ className: "sps-column-chooser z-stratum-dropdown" }, rest),
        React.createElement(SpsButton, { className: classes, "aria-label": (state.isVisible ? "Close" : "Open") + " Column Chooser", kind: ButtonKind.ICON, icon: SpsIcon.TABLE, onClick: onVisibilityToggle, "data-testid": "button" }),
        state.isVisible && (React.createElement(SpsCard, { "data-testid": "open", footer: function () { return (React.createElement(SpsButton, { "aria-label": "Apply Changes", kind: ButtonKind.LINK, onClick: applyChanges }, "Apply Changes")); } },
            React.createElement("div", { className: "sps-column-chooser__search-container" },
                React.createElement(SpsAutocomplete, { suggestions: state.unselectedColumns.map(function (c) { return c.name; }), disabled: (maxSelectedColumns
                        && state.selectedColumns.length >= maxSelectedColumns)
                        || state.selectedColumns.length >= 8, value: state.searchSelectedColumn ? state.searchSelectedColumn.name : "", onChange: onSelectBoxChange, placeholder: "Find Columns to Add" })),
            React.createElement("div", { className: "sps-column-chooser__selected-title" }, "Selected"),
            React.createElement(DragDropContext, { onDragEnd: onDragEnd },
                React.createElement(ConnectedDroppable, { droppableId: "column-chooser" }, function (provided) { return (React.createElement("div", __assign$1B({}, provided.droppableProps, { ref: provided.innerRef }),
                    state.selectedColumns.map(function (item, index) { return (React.createElement(SpsColumnChooserColumn, { index: index, key: item.columnId, columnId: item.columnId, name: item.name, value: item.value, onDelete: removeColumn, mandatory: item.mandatory })); }),
                    provided.placeholder)); }))))));
}
Object.assign(SpsColumnChooser, {
    props: propsDoc$1p,
    propTypes: propTypes$1s,
    displayName: "SpsColumnChooser",
});

var __makeTemplateObject$Q = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsColumnChooserExamples = {
    basic: {
        label: "Basic",
        description: "Column chooser component",
        examples: {
            basic: {
                react: code(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject$Q(["\n                    function DemoComponent() {\n                        const unselectedCols = [\n                            { name: \"Red Fish\", value: \"Red\" },\n                            { name: \"Blue Fish\", value: \"Blue\" }\n                        ];\n                        const selectedCols = [\n                            { name: \"One Fish\", value: \"One\" },\n                            { name: \"Two Fish\", value: \"Two\" }\n                        ]\n                        return (\n                            <SpsColumnChooser\n                                unselectedColumns={unselectedCols}\n                                selectedColumns={selectedCols}\n                                onApplyChanges={(selectedColumns) => {console.log(selectedColumns)}}\n                            />\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const unselectedCols = [\n                            { name: \"Red Fish\", value: \"Red\" },\n                            { name: \"Blue Fish\", value: \"Blue\" }\n                        ];\n                        const selectedCols = [\n                            { name: \"One Fish\", value: \"One\" },\n                            { name: \"Two Fish\", value: \"Two\" }\n                        ]\n                        return (\n                            <SpsColumnChooser\n                                unselectedColumns={unselectedCols}\n                                selectedColumns={selectedCols}\n                                onApplyChanges={(selectedColumns) => {console.log(selectedColumns)}}\n                            />\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$Q;

var __assign$1A = (undefined && undefined.__assign) || function () {
    __assign$1A = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1A.apply(this, arguments);
};
var __rest$1g = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1o = {
    icon: { type: "SpsIcon", required: true },
    size: "SpsIconSize",
};
var propTypes$1r = __assign$1A(__assign$1A({}, spsGlobalPropTypes), { icon: enumValue(SpsIcon).isRequired, size: enumValue(SpsIconSize) });
function SpsI(props) {
    var className = props.className, testId = props["data-testid"], icon = props.icon, _a = props.size, size = _a === void 0 ? SpsIconSize.MEDIUM : _a, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1g(props, ["className", "data-testid", "icon", "size", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-icon", "sps-icon-" + icon, "sps-icon--" + size, className);
    return React.createElement("i", __assign$1A({ className: classes, "aria-hidden": "true", "data-testid": testId }, rest));
}
Object.assign(SpsI, {
    props: propsDoc$1o,
    propTypes: propTypes$1r,
    displayName: "SpsI",
});
Object.assign(SpsI, {
    props: propsDoc$1o,
    propTypes: propTypes$1r,
    displayName: "SpsI",
});

var __assign$1z = (undefined && undefined.__assign) || function () {
    __assign$1z = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1z.apply(this, arguments);
};
var __rest$1f = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1n = {
    borderless: "boolean",
    lean: "boolean",
    leaner: { type: "boolean", deprecated: true },
    widthPx: "number",
    widthRem: "number",
};
var propTypes$1q = __assign$1z(__assign$1z({}, spsGlobalPropTypes), { borderless: propTypes$1H.exports.bool, lean: propTypes$1H.exports.bool, leaner: propTypes$1H.exports.bool, widthPx: propTypes$1H.exports.number, widthRem: propTypes$1H.exports.number });
function SpsContentRowCol(props) {
    var borderless = props.borderless, children = props.children; props.className; var lean = props.lean, leaner = props.leaner, style = props.style, unsafelyReplaceClassName = props.unsafelyReplaceClassName, widthPx = props.widthPx, widthRem = props.widthRem, rest = __rest$1f(props, ["borderless", "children", "className", "lean", "leaner", "style", "unsafelyReplaceClassName", "widthPx", "widthRem"]);
    React.useEffect(function () {
        if (leaner) {
            console.log([
                "The 'leaner' prop on SpsContentRowCol is deprecated. The padding for Content",
                "Rows has been updated so the old 'lean' padding is the default, and the",
                "'leaner' padding is enabled with 'lean'. This column will be displayed as",
                "a new 'lean' column, but you should change the prop you're passing as well.",
            ].join(" "));
        }
    }, [leaner]);
    var classes = clsx(unsafelyReplaceClassName || "sps-content-row__col", borderless && "sps-content-row__col--borderless", (lean || leaner) && "sps-content-row__col--lean");
    var width = widthPx ? widthPx / 16 : widthRem;
    var inlineStyles = width
        ? __assign$1z(__assign$1z({}, style), { width: width + "rem" }) : style;
    return (React.createElement("div", __assign$1z({}, rest, { className: classes, style: inlineStyles }), children));
}
Object.assign(SpsContentRowCol, {
    props: propsDoc$1n,
    propTypes: propTypes$1q,
    displayName: "SpsContentRowCol",
});

var __assign$1y = (undefined && undefined.__assign) || function () {
    __assign$1y = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1y.apply(this, arguments);
};
var __rest$1e = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1m = {};
var propTypes$1p = __assign$1y({}, spsGlobalPropTypes);
function SpsContentRowExpansion(props) {
    var children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1e(props, ["children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-content-row__expansion", className);
    return (React.createElement("div", __assign$1y({ className: classes }, rest, { "data-testid": testId + "__expansion" }), children));
}
Object.assign(SpsContentRowExpansion, {
    props: propsDoc$1m,
    propTypes: propTypes$1p,
    displayName: "SpsContentRowExpansion",
});

var __assign$1x = (undefined && undefined.__assign) || function () {
    __assign$1x = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1x.apply(this, arguments);
};
var __rest$1d = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$K = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1l = {
    alternateLayout: "boolean",
    initiallyExpanded: "boolean",
    cardSpacing: "boolean",
    expanded: "boolean",
    onBeforeCollapsed: "() => boolean",
    onBeforeExpanded: "() => boolean",
    onSelectionChange: "ChangeEventHandler",
    onCollapsed: "() => void",
    onExpanded: "() => void",
    selectable: "boolean",
    selected: "boolean",
};
var propTypes$1o = __assign$1x(__assign$1x({}, spsGlobalPropTypes), { alternateLayout: propTypes$1H.exports.bool, cardSpacing: propTypes$1H.exports.bool, expanded: propTypes$1H.exports.bool, initiallyExpanded: propTypes$1H.exports.bool, onBeforeCollapsed: fun(), onBeforeExpanded: fun(), onSelectionChange: fun(), onCollapsed: fun(), onExpanded: fun(), selectable: propTypes$1H.exports.bool, selected: propTypes$1H.exports.bool });
function SpsContentRow(props) {
    var _a = props.alternateLayout, alternateLayout = _a === void 0 ? false : _a, children = props.children, className = props.className, expanded = props.expanded, onBeforeCollapsed = props.onBeforeCollapsed, onBeforeExpanded = props.onBeforeExpanded, onSelectionChange = props.onSelectionChange, onCollapsed = props.onCollapsed, onExpanded = props.onExpanded, _b = props.initiallyExpanded, initiallyExpanded = _b === void 0 ? false : _b, _c = props.cardSpacing, cardSpacing = _c === void 0 ? false : _c, _d = props.selectable, selectable = _d === void 0 ? false : _d, selected = props.selected, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$1d(props, ["alternateLayout", "children", "className", "expanded", "onBeforeCollapsed", "onBeforeExpanded", "onSelectionChange", "onCollapsed", "onExpanded", "initiallyExpanded", "cardSpacing", "selectable", "selected", "unsafelyReplaceClassName"]);
    var t = React.useContext(I18nContext).t;
    var _e = __read$K(React.useState(initiallyExpanded), 2), localIsExpanded = _e[0], setLocalIsExpanded = _e[1];
    var isExpanded = typeof expanded === "boolean" ? expanded : localIsExpanded;
    function handleToggle(event) {
        event.stopPropagation();
        if (isExpanded && (!onBeforeCollapsed || onBeforeCollapsed())) {
            setLocalIsExpanded(false);
            if (onCollapsed) {
                onCollapsed();
            }
        }
        else if (!isExpanded && (!onBeforeExpanded || onBeforeExpanded())) {
            setLocalIsExpanded(true);
            if (onExpanded) {
                onExpanded();
            }
        }
    }
    var ContentRowCheckBox = function () { return (React.createElement(SpsCheckbox, { checked: selected, onChange: onSelectionChange })); };
    var ExpandoThingy = function () { return (React.createElement("button", { type: "button", className: "sps-content-row__expand-btn", onClick: handleToggle, "aria-label": t("design-system:contentRow." + (isExpanded ? "collapse" : "expand")) },
        React.createElement(SpsI, { icon: isExpanded ? SpsIcon.MINUS_CIRCLE : SpsIcon.PLUS_CIRCLE }))); };
    var classes = clsx(unsafelyReplaceClassName || "sps-content-row", isExpanded && "sps-content-row--expanded", cardSpacing && "sps-content-row--card-spaced", selected && "sps-content-row--selected", alternateLayout && "sps-content-row--alternate-layout", className);
    var _f = __read$K(selectChildren(children, [
        { type: SpsContentRowCol }, { type: SpsContentRowExpansion },
    ]), 2), columns = _f[0], _g = __read$K(_f[1], 1), expansion = _g[0];
    return (React.createElement("div", __assign$1x({ className: classes }, rest),
        React.createElement("div", { className: "sps-content-row__col-group" },
            selectable && !alternateLayout && (React.createElement(SpsContentRowCol, { widthPx: 46 }, ContentRowCheckBox())),
            expansion && !alternateLayout && (React.createElement(SpsContentRowCol, { widthPx: 44 }, ExpandoThingy())),
            expansion && selectable && alternateLayout && (React.createElement(SpsContentRowCol, { widthPx: 46 },
                React.createElement("section", null, ContentRowCheckBox()),
                React.createElement("section", null, ExpandoThingy()))),
            columns),
        expansion));
}
Object.assign(SpsContentRow, {
    props: propsDoc$1l,
    propTypes: propTypes$1o,
    displayName: "SpsContentRow",
});

var __makeTemplateObject$P = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsContentRowExamples = {
    basic: {
        label: "Content rows",
        examples: {
            basic: {
                react: code(templateObject_1$P || (templateObject_1$P = __makeTemplateObject$P(["\n                    function DemoComponent() {\n                        return (\n                            <SpsContentRow>\n                                <SpsContentRowCol>\n                                    <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                    <a href=\"#\" className=\"fs-14\">3532379</a>\n                                </SpsContentRowCol>\n                                <SpsContentRowCol widthPx={150}>\n                                    May 23, 2018 @ 4:38 PM\n                                </SpsContentRowCol>\n                            </SpsContentRow>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        return (\n                            <SpsContentRow>\n                                <SpsContentRowCol>\n                                    <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                    <a href=\"#\" className=\"fs-14\">3532379</a>\n                                </SpsContentRowCol>\n                                <SpsContentRowCol widthPx={150}>\n                                    May 23, 2018 @ 4:38 PM\n                                </SpsContentRowCol>\n                            </SpsContentRow>\n                        )\n                    }\n                "]))),
            },
            withCheckbox: {
                react: code(templateObject_2$K || (templateObject_2$K = __makeTemplateObject$P(["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            selected: false\n                        });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            selected: false\n                        });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "]))),
            },
            withCheckboxAndFavorite: {
                react: code(templateObject_3$B || (templateObject_3$B = __makeTemplateObject$P(["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol style={{ width: \"2.9rem\" }}>\n                                        <SpsI\n                                            className=\"blue200\"\n                                            icon={SpsIcon.STAR}\n                                        />\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol style={{ width: \"2.9rem\" }}>\n                                        <SpsI\n                                            className=\"blue200\"\n                                            icon={SpsIcon.STAR}\n                                        />\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
    expandable: {
        label: "Expandable content rows",
        examples: {
            basic: {
                react: code(templateObject_4$t || (templateObject_4$t = __makeTemplateObject$P(["\n                function DemoComponent() {\n                    return (\n                      <>\n                        <SpsContentRow>\n                          <SpsContentRowCol>\n                            <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                            <a href=\"#\" className=\"fs-14\">3532379</a>\n                          </SpsContentRowCol>\n                          <SpsContentRowCol widthPx={150}>\n                            May 23, 2018 @ 4:38 PM\n                          </SpsContentRowCol>\n                          <SpsContentRowExpansion>\n                            <SpsCard>\n                              <br />\n                              <br />\n                              <br />\n                              <br />\n                              Additional content\n                              <br />\n                              <br />\n                              <br />\n                              <br />\n                            </SpsCard>\n                          </SpsContentRowExpansion>\n                        </SpsContentRow>\n                      </>\n                    )\n                  }\n                "], ["\n                function DemoComponent() {\n                    return (\n                      <>\n                        <SpsContentRow>\n                          <SpsContentRowCol>\n                            <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                            <a href=\"#\" className=\"fs-14\">3532379</a>\n                          </SpsContentRowCol>\n                          <SpsContentRowCol widthPx={150}>\n                            May 23, 2018 @ 4:38 PM\n                          </SpsContentRowCol>\n                          <SpsContentRowExpansion>\n                            <SpsCard>\n                              <br />\n                              <br />\n                              <br />\n                              <br />\n                              Additional content\n                              <br />\n                              <br />\n                              <br />\n                              <br />\n                            </SpsCard>\n                          </SpsContentRowExpansion>\n                        </SpsContentRow>\n                      </>\n                    )\n                  }\n                "]))),
            },
            expandableWithCheckbox: {
                react: code(templateObject_5$k || (templateObject_5$k = __makeTemplateObject$P(["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "]))),
            },
            expandableWithCheckboxAlternate: {
                react: code(templateObject_6$f || (templateObject_6$f = __makeTemplateObject$P(["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                    alternateLayout\n                                >\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsKeyValueList inline>\n                                            <SpsKeyValueListItem itemKey=\"partner\">\n                                                Bass Pro\n                                            </SpsKeyValueListItem>\n                                            <SpsKeyValueListItem itemKey=\"status\">\n                                                Open\n                                            </SpsKeyValueListItem>\n                                            <SpsKeyValueListItem itemKey=\"source id\">\n                                                12345\n                                            </SpsKeyValueListItem>\n                                        </SpsKeyValueList>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsKeyValueList inline>\n                                            <SpsKeyValueListItem itemKey=\"document tag\">\n                                                1234\n                                            </SpsKeyValueListItem>\n                                        </SpsKeyValueList>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                    alternateLayout\n                                >\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsKeyValueList inline>\n                                            <SpsKeyValueListItem itemKey=\"partner\">\n                                                Bass Pro\n                                            </SpsKeyValueListItem>\n                                            <SpsKeyValueListItem itemKey=\"status\">\n                                                Open\n                                            </SpsKeyValueListItem>\n                                            <SpsKeyValueListItem itemKey=\"source id\">\n                                                12345\n                                            </SpsKeyValueListItem>\n                                        </SpsKeyValueList>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsKeyValueList inline>\n                                            <SpsKeyValueListItem itemKey=\"document tag\">\n                                                1234\n                                            </SpsKeyValueListItem>\n                                        </SpsKeyValueList>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "]))),
            },
            expandableWithCheckboxAndFavorite: {
                react: code(templateObject_7$c || (templateObject_7$c = __makeTemplateObject$P(["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol style={{ width: \"2.9rem\" }}>\n                                        <SpsI\n                                            className=\"blue200\"\n                                            icon={SpsIcon.STAR}\n                                        />\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                >\n                                    <SpsContentRowCol style={{ width: \"2.9rem\" }}>\n                                        <SpsI\n                                            className=\"blue200\"\n                                            icon={SpsIcon.STAR}\n                                        />\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "]))),
            },
            expandableWithCheckboxAndFavoriteAlternate: {
                react: code(templateObject_8$b || (templateObject_8$b = __makeTemplateObject$P(["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                    alternateLayout\n                                >\n                                    <SpsContentRowCol style={{ width: \"2.9rem\" }}>\n                                        <SpsI\n                                            className=\"gray300\"\n                                            icon={SpsIcon.STAR}\n                                        />\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({ selected: false });\n\n                        function selectRow() {\n                            updateForm({ selected: !formValue.selected })\n                        }\n\n                        return (\n                            <>\n                                <SpsContentRow\n                                    selectable\n                                    selected={formValue.selected}\n                                    onSelect={selectRow}\n                                    alternateLayout\n                                >\n                                    <SpsContentRowCol style={{ width: \"2.9rem\" }}>\n                                        <SpsI\n                                            className=\"gray300\"\n                                            icon={SpsIcon.STAR}\n                                        />\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />\n                                        <a href=\"#\" className=\"fs-14\">3532379</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        May 23, 2018 @ 4:38 PM\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
    sortable: {
        label: "Sortable Content Rows",
        examples: {
            basic: {
                react: code(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject$P(["\n                function DemoComponent() {\n                    const [sort, setSort] = React.useState([{ key: 'id', direction: SortDirection.DESCENDING }]);\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        selected: null\n                    });\n                \n                    function selectRow(id) {\n                        updateForm({ selected: formValue.selected !== id ? id : null });\n                    }\n\n                    const items = React.useMemo(() => [\n                        {\n                            id: '9712323',\n                            type: '850',\n                            status: 'processing',\n                            timestamp: 'July 21, 2021 @ 4:40 PM'\n                        },\n                        {\n                            id: '8712378',\n                            type: '810',\n                            status: 'success',\n                            timestamp: 'May 24, 2021 @ 4:39 PM'\n                        },\n                        {\n                            id: '8912389',\n                            type: '850',\n                            status: 'success',\n                            timestamp: 'May 23, 2021 @ 4:38 PM'\n                        }\n                    ].sort((a, b) => {\n                        if (!sort.length) {\n                            return 0;\n                        }\n\n                        const [{ key, direction }] = sort;\n                        if (a[key] < b[key]) {\n                            return direction === SortDirection.ASCENDING ? -1 : 1;\n                        } else if (a[key] > b[key]) {\n                            return direction === SortDirection.ASCENDING ? 1 : -1;\n                        } else {\n                            return 0;\n                        }\n                    }), [sort]);\n\n                    return (\n                      <>\n                        <SpsSortingHeader sort={sort} onSortChange={setSort} className=\"mb-2\">\n                            <SpsSortingHeaderCell sortDisabled widthRem={2.9} />\n                            <SpsSortingHeaderCell sortDisabled widthRem={2.9} />\n                            <SpsSortingHeaderCell sortKey='id'>ID</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='type'>Type</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='timestamp' widthPx={150}>Timestamp</SpsSortingHeaderCell>\n                        </SpsSortingHeader>\n\n                        {items.map(item => {\n                            return (\n                                <SpsContentRow\n                                    key={item.id}\n                                    selectable\n                                    selected={formValue.selected === item.id}\n                                    onSelect={() => selectRow(item.id)}\n                                >\n                                    <SpsContentRowCol>\n                                        {item.status === 'processing' && <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />}\n                                        {item.status === 'success' && <SpsI icon={SpsIcon.STATUS_OK} size={SpsIconSize.LARGE} className=\"mr-2\" />}\n                                        <a href=\"#\" className=\"fs-14\">{item.id}</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <a href=\"#\" className=\"fs-14\">{item.type}</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        {item.timestamp}\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            );\n                        })}\n                      </>\n                    )\n                  }\n                "], ["\n                function DemoComponent() {\n                    const [sort, setSort] = React.useState([{ key: 'id', direction: SortDirection.DESCENDING }]);\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        selected: null\n                    });\n                \n                    function selectRow(id) {\n                        updateForm({ selected: formValue.selected !== id ? id : null });\n                    }\n\n                    const items = React.useMemo(() => [\n                        {\n                            id: '9712323',\n                            type: '850',\n                            status: 'processing',\n                            timestamp: 'July 21, 2021 @ 4:40 PM'\n                        },\n                        {\n                            id: '8712378',\n                            type: '810',\n                            status: 'success',\n                            timestamp: 'May 24, 2021 @ 4:39 PM'\n                        },\n                        {\n                            id: '8912389',\n                            type: '850',\n                            status: 'success',\n                            timestamp: 'May 23, 2021 @ 4:38 PM'\n                        }\n                    ].sort((a, b) => {\n                        if (!sort.length) {\n                            return 0;\n                        }\n\n                        const [{ key, direction }] = sort;\n                        if (a[key] < b[key]) {\n                            return direction === SortDirection.ASCENDING ? -1 : 1;\n                        } else if (a[key] > b[key]) {\n                            return direction === SortDirection.ASCENDING ? 1 : -1;\n                        } else {\n                            return 0;\n                        }\n                    }), [sort]);\n\n                    return (\n                      <>\n                        <SpsSortingHeader sort={sort} onSortChange={setSort} className=\"mb-2\">\n                            <SpsSortingHeaderCell sortDisabled widthRem={2.9} />\n                            <SpsSortingHeaderCell sortDisabled widthRem={2.9} />\n                            <SpsSortingHeaderCell sortKey='id'>ID</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='type'>Type</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='timestamp' widthPx={150}>Timestamp</SpsSortingHeaderCell>\n                        </SpsSortingHeader>\n\n                        {items.map(item => {\n                            return (\n                                <SpsContentRow\n                                    key={item.id}\n                                    selectable\n                                    selected={formValue.selected === item.id}\n                                    onSelect={() => selectRow(item.id)}\n                                >\n                                    <SpsContentRowCol>\n                                        {item.status === 'processing' && <SpsI icon={SpsIcon.STATUS_IN_PROCESS} size={SpsIconSize.LARGE} className=\"mr-2\" />}\n                                        {item.status === 'success' && <SpsI icon={SpsIcon.STATUS_OK} size={SpsIconSize.LARGE} className=\"mr-2\" />}\n                                        <a href=\"#\" className=\"fs-14\">{item.id}</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol>\n                                        <a href=\"#\" className=\"fs-14\">{item.type}</a>\n                                    </SpsContentRowCol>\n                                    <SpsContentRowCol widthPx={150}>\n                                        {item.timestamp}\n                                    </SpsContentRowCol>\n                                    <SpsContentRowExpansion>\n                                        <SpsCard>\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        Additional content\n                                        <br />\n                                        <br />\n                                        <br />\n                                        <br />\n                                        </SpsCard>\n                                    </SpsContentRowExpansion>\n                                </SpsContentRow>\n                            );\n                        })}\n                      </>\n                    )\n                  }\n                "]))),
            },
        },
    },
};
var templateObject_1$P, templateObject_2$K, templateObject_3$B, templateObject_4$t, templateObject_5$k, templateObject_6$f, templateObject_7$c, templateObject_8$b, templateObject_9$8;

var __assign$1w = (undefined && undefined.__assign) || function () {
    __assign$1w = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1w.apply(this, arguments);
};
var __rest$1c = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$J = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var moment$4 = moment$6.default || moment$6;
function newWeekArray$1() {
    return new Array(7);
}
function generateWeeks$1(date) {
    var baseDate = {
        year: date.year(),
        month: date.month(),
    };
    var weekdayArrayIndex = date.weekday();
    var daysInMonth = date.daysInMonth();
    var weeksInMonth = Math.ceil((daysInMonth + weekdayArrayIndex) / 7);
    var newWeeks = new Array(weeksInMonth).fill(true)
        .map(newWeekArray$1);
    for (var dateIndex = 0; dateIndex < daysInMonth; dateIndex += 1) {
        var offsetDay = dateIndex + weekdayArrayIndex;
        var week = newWeeks[Math.floor(offsetDay / 7)];
        var dayOfWeekIndex = offsetDay % 7;
        week[dayOfWeekIndex] = Object.freeze(__assign$1w({ date: dateIndex + 1 }, baseDate));
        if (dayOfWeekIndex === 6) {
            Object.freeze(week);
        }
    }
    return newWeeks;
}
function parse(value) {
    return moment$4(value + " 00:00:00");
}
function weekOfMonth$1(date) {
    return Math.floor((date.clone().date(1)
        .day() + date.date() - 1) / 7);
}
var propsDoc$1k = {
    disabled: "boolean",
    format: "string",
    maxDate: "string",
    minDate: "string",
    onChange: "(newValue: Moment) => void",
    onClickOutside: "(event: MouseEvent) => void",
    placeholder: "string",
    value: "string",
};
var propTypes$1n = __assign$1w(__assign$1w({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, format: propTypes$1H.exports.string, maxDate: propTypes$1H.exports.string, minDate: propTypes$1H.exports.string, onChange: fun(), onClickOutside: fun(), placeholder: propTypes$1H.exports.string, value: propTypes$1H.exports.string });
function SpsDatepicker(props) {
    var className = props.className, disabled = props.disabled, _a = props.format, format = _a === void 0 ? moment$4.localeData().longDateFormat("MM/DD/YYYY") || "MM/DD/YYYY" : _a, maxDate = props.maxDate, minDate = props.minDate, onChange = props.onChange, onClickOutside = props.onClickOutside, _b = props.placeholder, placeholder = _b === void 0 ? "MM/DD/YYYY" : _b, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, value = props.value, id = props.id, rest = __rest$1c(props, ["className", "disabled", "format", "maxDate", "minDate", "onChange", "onClickOutside", "placeholder", "data-testid", "unsafelyReplaceClassName", "value", "id"]);
    var calendarRef = React.useRef();
    var inputRef = React.useRef();
    var _c = __read$J(usePatchReducer({
        isOpen: false,
        weekdayNames: [],
        view: null,
        weeks: [],
        currentValue: undefined,
        isInitialValue: true,
        keyboardFocusDay: null,
        text: "",
        minDateMoment: minDate ? moment$4(minDate) : {},
        maxDateMoment: maxDate ? moment$4(maxDate) : {},
    }), 2), state = _c[0], patchState = _c[1];
    function setCalendarView(displayMoment) {
        var theMoment = displayMoment;
        if (!displayMoment || !displayMoment.isValid()) {
            if (moment$4.isMoment(state.currentValue) && state.currentValue.isValid()) {
                theMoment = state.currentValue.clone();
            }
            else if (minDate) {
                theMoment = state.minDateMoment.clone();
            }
            else if (maxDate) {
                theMoment = state.maxDateMoment.clone();
            }
            else {
                theMoment = moment$4();
            }
        }
        var newView = theMoment.set({
            date: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        patchState({
            view: newView,
            weeks: generateWeeks$1(newView),
        });
    }
    function handleClickOutside(event) {
        if (calendarRef
            && calendarRef.current
            && !calendarRef.current.contains(event.target)) {
            if (inputRef.current && inputRef.current.contains(event.target)) {
                return;
            }
            if (onClickOutside) {
                onClickOutside(event);
            }
            patchState({ isOpen: false });
        }
    }
    React.useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        patchState({ weekdayNames: Object.freeze(moment$4.weekdaysShort()) });
        setCalendarView(null);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    React.useEffect(function () {
        if (value) {
            var parsed = parse(value);
            inputRef.current.value = value;
            patchState({
                currentValue: parsed,
                view: parsed,
                keyboardFocusDay: parsed,
            });
        }
    }, [value]);
    React.useEffect(function () {
        if (moment$4.isMoment(state.view)) {
            patchState({ weeks: generateWeeks$1(state.view) });
        }
    }, [state.view]);
    function viewPreviousMonth() {
        setCalendarView(state.view.subtract(1, "month"));
    }
    function viewNextMonth() {
        setCalendarView(state.view.add(1, "month"));
    }
    React.useEffect(function () {
        if (moment$4.isMoment(state.keyboardFocusDay)) {
            if (state.keyboardFocusDay.isBefore(state.view, "month")) {
                viewPreviousMonth();
            }
            else if (state.keyboardFocusDay.isAfter(state.view, "month")) {
                viewNextMonth();
            }
        }
    }, [state.keyboardFocusDay]);
    React.useEffect(function () {
        if (!state.isOpen) {
            PositioningService.release(calendarRef.current);
        }
    }, [state.isOpen]);
    React.useEffect(function () {
        if (moment$4.isMoment(state.currentValue)) {
            setCalendarView(null);
        }
        if (onChange && typeof onChange === "function" && !state.isInitialValue) {
            onChange(state.currentValue);
        }
    }, [state.currentValue]);
    function show() {
        if (!state.isOpen) {
            patchState({ isOpen: true });
            PositioningService.position(calendarRef.current, {
                relativeTo: inputRef.current,
                position: Position$1.BOTTOM_LEFT,
                offsets: [0, 1],
            });
        }
    }
    function handleTextInputClick(event) {
        event.stopPropagation();
        show();
    }
    function handleTextInputChange(event) {
        var parsed = parse(event.target.value);
        var newValue = parsed && parsed.isValid() ? parsed : {};
        patchState({
            currentValue: newValue,
            isInitialValue: false,
            text: event.target.value,
        });
    }
    function handleClearClick(event) {
        event.stopPropagation();
        patchState({
            currentValue: null,
            isInitialValue: false,
        });
        setCalendarView(moment$4());
        inputRef.current.value = "";
        show();
        inputRef.current.focus();
    }
    function dateIsDisabled(date) {
        return ((date && (minDate && state.minDateMoment.isAfter(date, "day")))
            || (maxDate && state.maxDateMoment.isBefore(date, "day")));
    }
    function updateText(newValue) {
        inputRef.current.value = moment$4.isMoment(newValue) ? newValue.format(format) : "";
    }
    function selectDate(date) {
        if (date && !dateIsDisabled(date)) {
            var val = void 0;
            if (state.currentValue && moment$4.isMoment(date)) {
                val = date.clone();
            }
            else if (state.currentValue && moment$4.isMoment(state.currentValue)) {
                val = state.currentValue.clone().set(date);
            }
            else {
                val = moment$4(date);
            }
            updateText(val);
            patchState({
                isOpen: false,
                currentValue: val,
                isInitialValue: false,
                keyboardFocusDay: null,
            });
            inputRef.current.focus();
        }
    }
    function dateIsSelected(date) {
        return (date
            && moment$4.isMoment(state.currentValue)
            && state.currentValue.isValid()
            && state.currentValue.isSame(date, "day"));
    }
    function dateIsFocused(date) {
        return (date
            && moment$4.isMoment(state.keyboardFocusDay)
            && state.keyboardFocusDay.isSame(date, "day"));
    }
    function onKeyDown(event) {
        switch (event.key) {
            case "Up":
            case "ArrowUp":
                if (state.keyboardFocusDay) {
                    event.preventDefault();
                    var newFocusDay = weekOfMonth$1(state.keyboardFocusDay) === 0
                        ? null
                        : moment$4.max(state.keyboardFocusDay.clone().subtract(1, "week"), state.keyboardFocusDay.date(1));
                    patchState({ keyboardFocusDay: newFocusDay });
                    if (!newFocusDay) {
                        inputRef.current.focus();
                    }
                }
                break;
            case "Down":
            case "ArrowDown":
                event.preventDefault();
                if (!state.isOpen) {
                    show();
                }
                if (moment$4.isMoment(state.keyboardFocusDay)) {
                    var newFocusDay = moment$4.min(state.keyboardFocusDay.clone().add(1, "week"), state.keyboardFocusDay.date(state.keyboardFocusDay.daysInMonth()));
                    patchState({ keyboardFocusDay: newFocusDay });
                }
                else if (moment$4.isMoment(state.view)) {
                    patchState({ keyboardFocusDay: state.view.clone() });
                }
                break;
            case "Left":
            case "ArrowLeft":
                if (state.keyboardFocusDay) {
                    event.preventDefault();
                    var newFocusDay = void 0;
                    if (state.keyboardFocusDay.day() === 0 || state.keyboardFocusDay.date() === 1) {
                        var week = weekOfMonth$1(state.keyboardFocusDay);
                        newFocusDay = week
                            ? moment$4.min(state.keyboardFocusDay.clone().add(week, "weeks"), state.keyboardFocusDay.date(state.keyboardFocusDay.daysInMonth()))
                            : state.keyboardFocusDay
                                .subtract(1, "month")
                                .date(1)
                                .day(6);
                    }
                    else {
                        newFocusDay = state.keyboardFocusDay.clone().subtract(1, "day");
                    }
                    patchState({ keyboardFocusDay: newFocusDay });
                }
                break;
            case "Right":
            case "ArrowRight":
                if (state.keyboardFocusDay) {
                    event.preventDefault();
                    var newFocusDay = void 0;
                    if (state.keyboardFocusDay.day() === 6
                        || state.keyboardFocusDay.date() === state.keyboardFocusDay.daysInMonth()) {
                        var week = weekOfMonth$1(state.keyboardFocusDay);
                        newFocusDay = week
                            ? moment$4.min(state.keyboardFocusDay
                                .clone()
                                .add(week, "weeks")
                                .day(0), state.keyboardFocusDay
                                .date(state.keyboardFocusDay.daysInMonth())
                                .day(0))
                            : state.keyboardFocusDay.add(1, "month").date(1);
                    }
                    else {
                        newFocusDay = state.keyboardFocusDay.clone().add(1, "day");
                    }
                    patchState({ keyboardFocusDay: newFocusDay });
                }
                break;
            case "Enter":
                if (state.keyboardFocusDay) {
                    selectDate(state.keyboardFocusDay);
                }
                break;
            case "Esc":
            case "Escape":
                if (state.keyboardFocusDay) {
                    patchState({ keyboardFocusDay: null });
                    inputRef.current.focus();
                }
                else {
                    patchState({ isOpen: false });
                }
                break;
            case "Tab":
                patchState({ isOpen: false });
                break;
            default:
                if (!state.isOpen) {
                    show();
                }
        }
        if (state.keyboardFocusDay) {
            if (minDate && state.minDateMoment.isAfter(state.keyboardFocusDay)) {
                patchState({ keyboardFocusDay: state.minDateMoment.clone() });
            }
            else if (maxDate && state.maxDateMoment.isBefore(state.keyboardFocusDay)) {
                patchState({ keyboardFocusDay: state.maxDateMoment.clone() });
            }
        }
    }
    function renderCalendar() {
        var calendar = [];
        for (var i = 0; i < state.weeks.length; i += 1) {
            var children = [];
            var week = state.weeks[i];
            var _loop_1 = function (j) {
                var date = week[j];
                children.push(React.createElement("td", { key: j, className: clsx("sps-datepicker__calendar-cell", {
                        "sps-datepicker__calendar-day": date,
                        "sps-datepicker__calendar-day--selected": dateIsSelected(date),
                        "sps-datepicker__calendar-day--disabled": dateIsDisabled(date),
                        "sps-datepicker__calendar-day--focus": dateIsFocused(date),
                    }), onClick: function () { return selectDate(date); } }, date ? date.date : ""));
            };
            for (var j = 0; j < week.length; j += 1) {
                _loop_1(j);
            }
            calendar.push(React.createElement("tr", { key: i }, children));
        }
        return calendar;
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-datepicker", state.isOpen && "open", state.isOpen && "z-stratum-dropdown", className);
    return (React.createElement("div", __assign$1w({ className: classes, "data-testid": testId + "__datePicker", id: id }, rest),
        React.createElement("div", { className: "sps-datepicker__dropdown", ref: calendarRef, tabIndex: -1 },
            React.createElement("div", { className: "sps-datepicker__calendar" },
                React.createElement("div", { className: "sps-datepicker__calendar-head" },
                    React.createElement("a", { className: "sps-datepicker__button sps-datepicker__button-previous-month", onClick: viewPreviousMonth },
                        React.createElement("i", { className: "sps-icon sps-icon-chevron-left" })),
                    React.createElement("span", { className: "sps-datepicker__calendar-head-label" },
                        React.createElement("span", { className: "sps-datepicker__calendar-head-label-month" }, moment$4.isMoment(state.view) ? state.view.format("MMMM") : ""),
                        React.createElement("span", { className: "sps-datepicker__calendar-head-label-year" }, moment$4.isMoment(state.view) ? state.view.year() : "")),
                    React.createElement("a", { className: "sps-datepicker__button sps-datepicker__button-next-month", onClick: viewNextMonth },
                        React.createElement("i", { className: "sps-icon sps-icon-chevron-right" }))),
                React.createElement("div", { className: "sps-datepicker__calendar-body" },
                    React.createElement("table", null,
                        React.createElement("thead", null,
                            React.createElement("tr", null, state.weekdayNames.map(function (dayName, i) { return React.createElement("th", { key: i }, dayName); }))),
                        React.createElement("tbody", null, renderCalendar().map(function (e) { return e; })))))),
        React.createElement("div", { className: "sps-datepicker__inputs" },
            React.createElement("span", { className: "sps-datepicker__input" },
                React.createElement("span", { className: clsx("sps-form-control", { disabled: disabled }) },
                    React.createElement("input", { type: "text", ref: inputRef, className: "sps-datepicker__text-input", defaultValue: state.text, onKeyDown: onKeyDown, disabled: disabled, onClick: handleTextInputClick, onChange: handleTextInputChange, placeholder: placeholder })),
                React.createElement("i", { className: "sps-icon sps-icon-calendar" }),
                !disabled && (inputRef && inputRef.current && inputRef.current.value) && (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: handleClearClick }))))));
}
Object.assign(SpsDatepicker, {
    props: propsDoc$1k,
    propTypes: propTypes$1n,
    displayName: "SpsDatepicker",
});

var __makeTemplateObject$O = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsDatepickerExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$O || (templateObject_1$O = __makeTemplateObject$O(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            date: { year: 2018, month: 10, date: 31 },\n                        }, {\n                            \"date\": [SpsValidators.date]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.date}>Date</SpsLabel>\n                                    <SpsDatepickerV2\n                                        value={formValue.date}\n                                        formMeta={formMeta.fields.date}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            date: { year: 2018, month: 10, date: 31 },\n                        }, {\n                            \"date\": [SpsValidators.date]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.date}>Date</SpsLabel>\n                                    <SpsDatepickerV2\n                                        value={formValue.date}\n                                        formMeta={formMeta.fields.date}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
    constraints: {
        label: "Constraints",
        examples: {
            basic: {
                react: code(templateObject_2$J || (templateObject_2$J = __makeTemplateObject$O(["\n                    function Component() {\n                        const constraints = React.useRef({\n                            minDate: { year: 2021, month: 4, date: 5 },\n                            maxDate: { year: 2021, month: 4, date: 15 }\n                        })\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            date: null,\n                        }, {\n                            \"date\": [SpsValidators.date, SpsValidators.dateConstraint(constraints.current)]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.date}>Date</SpsLabel>\n                                    <SpsDatepickerV2\n                                        value={formValue.date}\n                                        formMeta={formMeta.fields.date}\n                                        {...constraints.current}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const constraints = React.useRef({\n                            minDate: { year: 2021, month: 4, date: 5 },\n                            maxDate: { year: 2021, month: 4, date: 15 }\n                        })\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            date: null,\n                        }, {\n                            \"date\": [SpsValidators.date, SpsValidators.dateConstraint(constraints.current)]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.date}>Date</SpsLabel>\n                                    <SpsDatepickerV2\n                                        value={formValue.date}\n                                        formMeta={formMeta.fields.date}\n                                        {...constraints.current}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
    disabled: {
        label: "Disabled",
        examples: {
            disabled: {
                react: code(templateObject_3$A || (templateObject_3$A = __makeTemplateObject$O(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            date: { year: 2018, month: 10, date: 31 },\n                        }, {\n                            \"date\": [SpsValidators.date]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.date}>Date</SpsLabel>\n                                    <SpsDatepickerV2\n                                        value={formValue.date}\n                                        formMeta={formMeta.fields.date}\n                                        disabled\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            date: { year: 2018, month: 10, date: 31 },\n                        }, {\n                            \"date\": [SpsValidators.date]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.date}>Date</SpsLabel>\n                                    <SpsDatepickerV2\n                                        value={formValue.date}\n                                        formMeta={formMeta.fields.date}\n                                        disabled\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$O, templateObject_2$J, templateObject_3$A;

var __assign$1v = (undefined && undefined.__assign) || function () {
    __assign$1v = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1v.apply(this, arguments);
};
var __rest$1b = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$I = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1j = {
    placeholder: 'string',
    disabled: 'boolean',
    format: 'string',
    minDate: 'string',
    maxDate: 'string',
    availablePresets: 'Array<Duration>',
    onChange: '(newValue: MomentRange) => void',
    value: 'MomentRange',
    preset: 'Duration',
};
var propTypes$1m = __assign$1v(__assign$1v({}, spsGlobalPropTypes), { placeholder: propTypes$1H.exports.string, disabled: propTypes$1H.exports.bool, format: propTypes$1H.exports.string, minDate: propTypes$1H.exports.string, maxDate: propTypes$1H.exports.string, availablePresets: propTypes$1H.exports.array, onChange: fun(), value: impl(), preset: impl() });
function weekOfMonth(mmt) {
    return Math.floor((mmt.clone().date(1).day() + mmt.date() - 1) / 7);
}
var moment$3 = moment$6.default || moment$6; // required for rollup to work without a TypeScript error
var defaultPresets = [
    { days: 1 },
    { days: 7 },
    { days: 30 },
    { days: 60 },
    { days: 90 },
    { years: 1 },
].map(moment$3.duration);
var _positioningService = new PositioningService();
var idNum = 0;
function SpsDateRangePicker(props) {
    props.className; var _a = props.placeholder, placeholder = _a === void 0 ? 'MM/DD/YYYY - MM/DD/YYYY' : _a, disabled = props.disabled, _b = props.format, format = _b === void 0 ? moment$3.localeData().longDateFormat('MM/DD/YYYY') || 'MM/DD/YYYY' : _b, maxDate = props.maxDate, minDate = props.minDate, availablePresets = props.availablePresets, preset = props.preset, onChange = props.onChange, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, value = props.value, rest = __rest$1b(props, ["className", "placeholder", "disabled", "format", "maxDate", "minDate", "availablePresets", "preset", "onChange", 'data-testid', "unsafelyReplaceClassName", "value"]);
    var _c = __read$I(React.useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var _d = __read$I(React.useState(), 2), currentValue = _d[0], setCurrentValue = _d[1];
    var _e = __read$I(React.useState(), 2), view = _e[0], setView = _e[1];
    var _f = __read$I(React.useState(''), 2), text = _f[0], setText = _f[1];
    var _g = __read$I(React.useState(null), 2), presets = _g[0], setPreset = _g[1];
    var _h = __read$I(React.useState(undefined), 2), selectedPreset = _h[0], setSelectedPreset = _h[1];
    var _j = __read$I(React.useState(null), 2), mouseoverRange = _j[0], setMouseoverRange = _j[1];
    var _k = __read$I(React.useState(SelectMode.START), 2), selectMode = _k[0], setSelectMode = _k[1];
    var _l = __read$I(React.useState(), 2), keyboardFocusDay = _l[0], setKeyboardFocusDay = _l[1];
    var _m = __read$I(React.useState(minDate ? moment$3(minDate) : {}), 2), minDateMoment = _m[0], setMinDateMoment = _m[1];
    var _o = __read$I(React.useState(maxDate ? moment$3(maxDate) : {}), 2), maxDateMoment = _o[0], setMaxDateMoment = _o[1];
    var _p = __read$I(React.useState(true), 2), isInitialValue = _p[0], setIsInitialValue = _p[1];
    var _q = __read$I(React.useState(null), 2), months = _q[0], setMonths = _q[1];
    var inputElement = React.useRef(null);
    var calendar = React.useRef(null);
    var dateRange = React.useRef(null);
    var weekDayNames = Object.freeze(moment$3.weekdaysShort());
    var leftAligned = false;
    var _idNum = idNum++;
    var textRef = React.useRef();
    React.useEffect(function () {
        textRef.current = currentValue; // Write it to the ref
        updateText();
    }, [currentValue]);
    var clearMouseoverRange = function (event) {
        if (!event || (event.target instanceof HTMLElement && event.target.tagName !== 'TD')) {
            setMouseoverRange(null);
        }
    };
    var updateText = function (optionalValue) {
        if (optionalValue) {
            setText([
                optionalValue.start ? optionalValue.start.format(format) : '',
                optionalValue.end ? optionalValue.end.format(format) : '',
            ].join(' - '));
        }
        else {
            setText(currentValue
                ? [
                    currentValue.start ? currentValue.start.format(format) : '',
                    currentValue.end ? currentValue.end.format(format) : '',
                ].join(' - ')
                : '');
        }
    };
    var close = function () {
        var currValue = currentValue || textRef.current;
        setIsOpen(false);
        _positioningService.release(calendar.current);
        if (currValue && !currValue.end) {
            currValue.end = currValue.start.clone().endOf('day');
            setCurrentValue(currValue);
            setIsInitialValue(false);
            setSelectMode(SelectMode.START);
            clearMouseoverRange();
        }
    };
    var onOutsideClick = function (event) {
        if (event && document.body.contains((event.target))) {
            if (!dateRange.current.contains(event.target)) {
                close();
            }
        }
    };
    var newWeekArray = function () { return new Array(7); };
    var generateWeeks = function (date) {
        var baseDate = {
            year: date.year(),
            month: date.month(),
        };
        var weekdayArrayIndex = date.weekday();
        var daysInMonth = date.daysInMonth();
        var weeksInMonth = Math.ceil((daysInMonth + weekdayArrayIndex) / 7);
        var weeks = (new Array(weeksInMonth)).fill(true).map(newWeekArray);
        for (var dateIndex = 0; dateIndex < daysInMonth; dateIndex++) {
            var offsetDay = dateIndex + weekdayArrayIndex;
            var week = weeks[Math.floor(offsetDay / 7)];
            var dayOfWeekIndex = offsetDay % 7;
            week[dayOfWeekIndex] = Object.freeze(__assign$1v({ date: dateIndex + 1 }, baseDate));
            if (dayOfWeekIndex === 6) {
                Object.freeze(week);
            }
        }
        return Object.freeze(weeks);
    };
    var generateMonths = function (newView) {
        setMonths([generateWeeks(newView ? newView.start : view.start), generateWeeks(newView ? newView.end : view.end)]);
    };
    var setCalendarView = function (displayMoment) {
        if (currentValue) {
            if (currentValue.end && currentValue.end.isValid()) {
                displayMoment = currentValue.end.clone();
            }
            else {
                return;
            }
        }
        else if (maxDate) {
            displayMoment = maxDateMoment.clone();
        }
        else {
            displayMoment = moment$3();
        }
        displayMoment.startOf('month');
        var viewStart = displayMoment.clone().subtract(1, 'month');
        var newView = { start: viewStart, end: displayMoment };
        setView(newView);
        generateMonths(newView);
    };
    var onViewportIntersection = function (event) {
        if (event.target === calendar.current && event.intersectionRatio < 1) {
            leftAligned = event.intersectionRect.left <= 0
                && event.boundingClientRect.width > (event.rootBounds.right - event.boundingClientRect.right);
            _positioningService.reposition(calendar.current, {
                position: leftAligned ? Position$1.BOTTOM_LEFT : Position$1.BOTTOM_RIGHT,
            });
        }
    };
    var dateIsDisabled = function (date) { return date
        && (minDate && minDateMoment.isAfter(date, 'day'))
        || (maxDate && maxDateMoment.isBefore(date, 'day')); };
    var updatePresets = function () {
        if (availablePresets) {
            var psts = availablePresets;
            var today_1 = moment$3();
            var todayIsAllowed_1 = !dateIsDisabled(today_1);
            var t = psts.filter(function (pst) { return todayIsAllowed_1 && !dateIsDisabled(today_1.subtract(pst)); });
            setPreset(t);
        }
        else {
            setPreset(defaultPresets);
        }
    };
    React.useEffect(function () {
        _positioningService.on('viewportIntersection', onViewportIntersection);
        document.addEventListener('mousedown', onOutsideClick);
        setCalendarView();
        updatePresets();
        return function () {
            document.removeEventListener('mousedown', onOutsideClick);
        };
    }, []);
    var matchPreset = function (newPreset) {
        if (presets && newPreset) {
            var match = presets.find(function (pst) { return pst.asMilliseconds() === moment$3.duration(newPreset).asMilliseconds(); });
            return match;
        }
        return undefined;
    };
    var updateFromPreset = function (newPreset) {
        var matchedPreset = matchPreset(newPreset);
        var newValue;
        if (matchedPreset) {
            setSelectedPreset(matchedPreset);
            var today = moment$3();
            newValue = {
                preset: matchedPreset,
                start: today.clone().subtract(matchedPreset).add(1, 'day').startOf('day'),
                end: today.endOf('day'),
            };
            setCurrentValue(newValue);
        }
        else {
            setCurrentValue(undefined);
            setSelectedPreset(undefined);
        }
        setIsInitialValue(false);
    };
    React.useEffect(function () {
        if (value !== currentValue) {
            setIsInitialValue(true);
            setCurrentValue(value);
            setView(value);
            if (value && value.preset) {
                setSelectedPreset(value.preset);
            }
            else {
                setSelectedPreset(undefined);
            }
        }
    }, [value]);
    React.useEffect(function () {
        setCalendarView();
        if (onChange && typeof onChange === 'function' && !isInitialValue) {
            onChange(currentValue);
        }
    }, [currentValue]);
    React.useEffect(function () {
        setMinDateMoment(moment$3(minDate).add(1, 'day'));
    }, [minDate]);
    React.useEffect(function () {
        updatePresets();
    }, [minDate, maxDate]);
    React.useEffect(function () {
        setMaxDateMoment(moment$3(maxDate).add(1, 'day'));
    }, [maxDate]);
    React.useEffect(function () {
        setTimeout(function () {
            if (selectedPreset) {
                updateFromPreset(selectedPreset);
            }
            if (preset) {
                setSelectedPreset(moment$3.duration(preset));
                updateFromPreset(moment$3.duration(preset));
            }
        }, 0);
    }, [presets]);
    var open = function () {
        if (!isOpen) {
            if (!view) {
                setCalendarView();
            }
            setIsOpen(true);
            _positioningService.position(calendar.current, {
                relativeTo: inputElement.current,
                position: Position$1.BOTTOM_LEFT,
                offsets: [0, 1],
            });
        }
    };
    var parse = function (input) {
        var _a;
        if (input) {
            var split = input.split('-');
            var startStr = void 0;
            var endStr = void 0;
            var start = void 0;
            var end = void 0;
            if (split.length > 2) {
                var prev = void 0;
                for (var i = 0; i <= Math.ceil(input.length / 2); i++) {
                    var sub = input.substr(i, input.length - 2 * i);
                    if (sub.indexOf('-') === -1) {
                        startStr = input.substring(0, i + prev.indexOf('-') - 1);
                        endStr = input.substring(i + prev.indexOf('-'));
                        break;
                    }
                    prev = sub;
                }
            }
            else {
                _a = __read$I(split, 2), startStr = _a[0], endStr = _a[1];
                var startDateStr = startStr ? startStr.trim().split('/') : [];
                start = moment$3({ year: parseInt(startDateStr[2], 10), month: parseInt(startDateStr[0], 10) - 1, day: parseInt(startDateStr[1], 10) });
                var endDateStr = endStr ? endStr.trim().split('/') : [];
                end = moment$3({ year: parseInt(endDateStr[2], 10), month: parseInt(endDateStr[0], 10) - 1, day: parseInt(endDateStr[1], 10) });
            }
            return {
                start: start,
                end: end,
            };
        }
    };
    var onTextChanged = function (e) {
        var val = e.target.value;
        var range = parse(val);
        if (range && range.start.isValid() && range.end.isValid()) {
            setCurrentValue(range);
        }
        setIsInitialValue(false);
        setText(e.target.value);
    };
    var getPresetText = function (pst) {
        if (pst.asDays() === 1) {
            return 'Today'; // today is a special snowflake
        }
        return "Last " + pst.humanize().replace('a ', '');
    };
    var dateIsSelected = function (date) { return date
        && currentValue && ((currentValue.start && currentValue.start.isSame(date, 'day'))
        || (currentValue.end && currentValue.end.isSame(date, 'day'))
        || (currentValue.start
            && currentValue.end
            && currentValue.start.isBefore(date, 'day')
            && currentValue.end.isAfter(date, 'day'))); };
    var dateIsFocused = function (date) { return date && keyboardFocusDay && moment$3.isMoment(keyboardFocusDay) && keyboardFocusDay.isSame(date, 'day'); };
    var dateIsSelectionStart = function (date) { return date
        && currentValue
        && currentValue.start && currentValue.start.isSame(date, 'day')
        && currentValue.end && !currentValue.end.isSame(date, 'day'); };
    var dateIsSelectionMiddle = function (date) { return date
        && currentValue
        && currentValue.start && currentValue.start.isBefore(date, 'day')
        && currentValue.end && currentValue.end.isAfter(date, 'day'); };
    var dateIsSelectionEnd = function (date) { return date
        && currentValue
        && currentValue.start && !currentValue.start.isSame(date, 'day')
        && currentValue.end && currentValue.end.isSame(date, 'day'); };
    var dateIsWithinPendingSelection = function (date) { return date
        && mouseoverRange
        && mouseoverRange.start.isBefore(date, 'day')
        && mouseoverRange.end.isAfter(date, 'day'); };
    var datepickerPrevButtonIsDisabled = function () { return minDate && view && view.start && view.start.isSame(minDateMoment, 'month'); };
    var datepickerNextButtonIsDisabled = function () { return minDate && view && view.start && view.start.isSame(minDateMoment, 'month'); };
    var datepickerInputWrapperIsDisabled = function () { return currentValue && currentValue.start && currentValue.end && !disabled; };
    var onDatepickerMouseDown = function (event) {
        event.preventDefault();
    };
    var selectDate = function (date) {
        if (date && !dateIsDisabled(date)) {
            var start = currentValue && currentValue.start;
            var end = currentValue && currentValue.end;
            var simpleDate = { year: date.year(), month: date.month(), date: date.date() };
            date = date.clone();
            setSelectedPreset(undefined);
            var newValue = void 0;
            if (selectMode === SelectMode.START) {
                newValue = {
                    start: start ? start.set(simpleDate) : date,
                    end: null,
                };
                setSelectMode(SelectMode.END);
            }
            else if (!start || date.isBefore(start)) {
                newValue = {
                    start: start ? start.set(simpleDate) : date,
                    end: null,
                };
            }
            else {
                newValue = {
                    start: start,
                    end: (end ? end.set(simpleDate) : date).endOf('day'),
                };
                setSelectMode(SelectMode.START);
                clearMouseoverRange();
                setKeyboardFocusDay(null);
                inputElement.current.focus();
                close();
            }
            setIsInitialValue(false);
            setCurrentValue(newValue);
        }
    };
    var onCalendarClick = function (event) {
        if (event && event.target) {
            try {
                var date = JSON.parse(event.target.getAttribute('data-date'));
                selectDate(moment$3(date));
            }
            catch (ignore) { }
        }
    };
    var focusCalendar = function () {
        calendar.current.focus();
        setKeyboardFocusDay(view.start.clone());
    };
    var updateMouseoverRange = function (pendingSelectionEndDate) {
        if (currentValue && currentValue.start && currentValue.end === null) {
            setMouseoverRange({
                start: currentValue.start.clone(),
                end: pendingSelectionEndDate,
            });
        }
    };
    var onCalendarMouseover = function (event) {
        try {
            var date = JSON.parse(event.target.getAttribute('data-date'));
            updateMouseoverRange(moment$3(date));
        }
        catch (ignore) { }
    };
    var onNewPresetSelected = function (event, range) {
        setSelectedPreset(range);
        updateFromPreset(range);
        setSelectMode(SelectMode.START);
        inputElement.current.focus();
    };
    var clear = function () {
        setCurrentValue(undefined);
        setSelectedPreset(undefined);
        setIsInitialValue(false);
        setText('');
        setSelectMode(SelectMode.START);
        setTimeout(function () { return inputElement.current.focus(); }, 0);
    };
    var viewNextMonth = function () {
        if (!maxDate || view.end.isBefore(maxDateMoment, 'month')) {
            view.start.add(1, 'month');
            view.end.add(1, 'month');
            generateMonths();
        }
    };
    var viewPreviousMonth = function () {
        if (!minDate || view.start.isAfter(minDateMoment, 'month')) {
            view.start.subtract(1, 'month');
            view.end.subtract(1, 'month');
            generateMonths();
        }
    };
    var renderCalendar = function (month) {
        var cal = [];
        var attr = {};
        for (var i = 0; i < month.length; i++) {
            var children = [];
            var week = month[i];
            for (var j = 0; j < week.length; j++) {
                var date = week[j];
                var dateClass = clsx('sps-datepicker__calendar-cell', {
                    'sps-datepicker__calendar-day': date,
                    'sps-datepicker__calendar-day--disabled': dateIsDisabled(date),
                    'sps-datepicker__calendar-day--focus': dateIsFocused(date),
                    'sps-datepicker__calendar-day--selected': dateIsSelected(date),
                    'sps-datepicker__calendar-day--selection-start': dateIsSelectionStart(date),
                    'sps-datepicker__calendar-day--selection-middle': dateIsSelectionMiddle(date),
                    'sps-datepicker__calendar-day--selection-end': dateIsSelectionEnd(date),
                    'sps-datepicker__calendar-day--pending-selection': dateIsWithinPendingSelection(date),
                });
                attr['data-date'] = JSON.stringify(date);
                children.push(React.createElement("td", __assign$1v({ key: j }, attr, { className: dateClass }), date && (date.date)));
            }
            cal.push(React.createElement("tr", { key: i }, children));
        }
        return cal;
    };
    var onKeyDown = function (event) {
        var newKeyboardFocusDay;
        switch (event.key) {
            case 'Down':
            case 'ArrowDown':
                event.preventDefault();
                if (!isOpen) {
                    open();
                }
                if (keyboardFocusDay) {
                    newKeyboardFocusDay = moment$3.min(keyboardFocusDay.clone().add(1, 'week'), keyboardFocusDay.date(keyboardFocusDay.daysInMonth()));
                    setKeyboardFocusDay(newKeyboardFocusDay);
                }
                else {
                    focusCalendar();
                }
                updateMouseoverRange(newKeyboardFocusDay);
                break;
            case 'Up':
            case 'ArrowUp':
                if (keyboardFocusDay) {
                    event.preventDefault();
                    if (weekOfMonth(keyboardFocusDay) === 0) {
                        newKeyboardFocusDay = null;
                        setKeyboardFocusDay(null);
                        inputElement.current.focus();
                    }
                    else {
                        newKeyboardFocusDay = moment$3.max(keyboardFocusDay.clone().subtract(1, 'week'), keyboardFocusDay.date(1));
                        setKeyboardFocusDay(newKeyboardFocusDay);
                    }
                }
                updateMouseoverRange(newKeyboardFocusDay);
                break;
            case 'Left':
            case 'ArrowLeft':
                if (keyboardFocusDay) {
                    event.preventDefault();
                    if (keyboardFocusDay.day() === 0 || keyboardFocusDay.date() === 1) {
                        var week = weekOfMonth(keyboardFocusDay);
                        keyboardFocusDay.subtract(1, 'month').date(1).day(6);
                        if (week) {
                            newKeyboardFocusDay = moment$3.min(keyboardFocusDay.clone().add(week, 'weeks'), keyboardFocusDay.date(keyboardFocusDay.daysInMonth()));
                            setKeyboardFocusDay(newKeyboardFocusDay);
                        }
                    }
                    else {
                        newKeyboardFocusDay = keyboardFocusDay.subtract(1, 'day');
                        setKeyboardFocusDay(newKeyboardFocusDay);
                    }
                }
                updateMouseoverRange(newKeyboardFocusDay);
                break;
            case 'Right':
            case 'ArrowRight':
                if (keyboardFocusDay) {
                    event.preventDefault();
                    if (keyboardFocusDay.day() === 6 || keyboardFocusDay.date() === keyboardFocusDay.daysInMonth()) {
                        var week = weekOfMonth(keyboardFocusDay);
                        keyboardFocusDay.add(1, 'month').date(1);
                        if (week) {
                            newKeyboardFocusDay = moment$3.min(keyboardFocusDay.clone().add(week, 'weeks').day(0), keyboardFocusDay.date(keyboardFocusDay.daysInMonth()).day(0));
                            setKeyboardFocusDay(newKeyboardFocusDay);
                        }
                    }
                    else {
                        newKeyboardFocusDay = keyboardFocusDay.add(1, 'day');
                        setKeyboardFocusDay(newKeyboardFocusDay);
                    }
                }
                updateMouseoverRange(newKeyboardFocusDay);
                break;
            case 'Enter':
                if (keyboardFocusDay) {
                    selectDate(keyboardFocusDay);
                }
                break;
            case 'Esc':
            case 'Escape':
                if (keyboardFocusDay && moment$3.isMoment(keyboardFocusDay)) {
                    setKeyboardFocusDay(null);
                    inputElement.current.focus();
                }
                else {
                    close();
                }
                if (selectMode === SelectMode.END) {
                    setSelectMode(SelectMode.START);
                }
                break;
        }
        if (keyboardFocusDay && moment$3.isMoment(keyboardFocusDay)) {
            if (keyboardFocusDay.isBefore(view.start, 'month')) {
                viewPreviousMonth();
            }
            else if (keyboardFocusDay.isAfter(view.end, 'month')) {
                viewNextMonth();
            }
        }
    };
    var datepickerClasses = clsx(unsafelyReplaceClassName || 'sps-datepicker', 'sps-date-range-picker', isOpen && 'open', isOpen && 'z-stratum-dropdown');
    var prevButtonClasses = clsx('sps-datepicker__button', 'sps-datepicker__button-previous-month', datepickerPrevButtonIsDisabled && 'sps-datepicker__button--disabled');
    var nextButtonClasses = clsx('sps-datepicker__button', 'sps-datepicker__button-next-month', datepickerNextButtonIsDisabled && 'sps-datepicker__button--disabled');
    var inputWrapperClasses = clsx('sps-form-control', datepickerInputWrapperIsDisabled() && 'sps-datepicker__input--clearable', disabled && 'disabled');
    return (React.createElement("div", __assign$1v({ className: datepickerClasses, onKeyDown: onKeyDown }, rest, { "data-testid": testId + "__datepicker", ref: dateRange }),
        React.createElement("div", { className: "sps-datepicker__dropdown", ref: calendar, tabIndex: -1, "data-testid": testId + "__datepicker__dropdown" },
            presets && presets.length > 0 && (React.createElement("div", { className: "sps-datepicker__presets", "data-testid": testId + "__datepicker__presets" },
                React.createElement("fieldset", null,
                    React.createElement("legend", { className: "sps-datepicker__presets-label" }, "Ranges"),
                    React.createElement("div", { className: "sps-custom-control sps-custom-radio sps-custom-control--no-error" },
                        React.createElement("input", { type: "radio", id: "sps-date-range-picker-" + _idNum + "__range-custom", className: "sps-custom-control__input", checked: selectedPreset === undefined, name: "sps-date-range-picker-" + _idNum + "__range", onChange: onNewPresetSelected }),
                        React.createElement("label", { className: "sps-custom-control__label", htmlFor: "sps-date-range-picker-" + _idNum + "__range-custom" }, "Custom")),
                    presets.map(function (range, i) { return (React.createElement("div", { key: i, className: "sps-custom-control sps-custom-radio sps-custom-control--no-error" },
                        React.createElement("input", { type: "radio", id: "sps-date-range-picker-" + _idNum + "__range-" + i, key: i, name: "sps-date-range-picker-" + _idNum + "__range", onChange: function (e) { onNewPresetSelected(e, range); }, value: range, checked: selectedPreset === range, className: "sps-custom-control__input" }),
                        React.createElement("label", { className: "sps-custom-control__label", htmlFor: "sps-date-range-picker-" + _idNum + "__range-" + i }, getPresetText(range)))); })))),
            React.createElement("div", { className: "sps-datepicker__calendar", "data-testid": testId + "__datepicker__calendar" },
                React.createElement("div", { className: "sps-datepicker__calendar-head" },
                    React.createElement("a", { className: prevButtonClasses, "aria-label": "prev", onClick: viewPreviousMonth, onMouseDown: onDatepickerMouseDown },
                        React.createElement("i", { className: "sps-icon sps-icon-chevron-left" })),
                    React.createElement("span", { className: "sps-datepicker__calendar-head-label sps-datepicker__calendar-head-label--rangepicker" },
                        React.createElement("span", { className: "sps-datepicker__calendar-head-label-month" }, view && view.start && view.start.format('MMMM')),
                        React.createElement("span", { className: "sps-datepicker__calendar-head-label-year" }, view && view.start && view.start.year())),
                    React.createElement("span", { className: "sps-datepicker__calendar-head-label sps-datepicker__calendar-head-label--rangepicker" },
                        React.createElement("span", { className: "sps-datepicker__calendar-head-label-month" }, view && view.end && view.end.format('MMMM')),
                        React.createElement("span", { className: "sps-datepicker__calendar-head-label-year" }, view && view.end && view.end.year())),
                    React.createElement("a", { className: nextButtonClasses, onClick: viewNextMonth, onMouseDown: onDatepickerMouseDown },
                        React.createElement("i", { className: "sps-icon sps-icon-chevron-right" }))),
                React.createElement("div", { className: "sps-datepicker__calendar-body", onClick: onCalendarClick, onMouseOver: onCalendarMouseover, onMouseOut: clearMouseoverRange }, months && months.map(function (month, i) { return (React.createElement("table", { key: i },
                    React.createElement("thead", null,
                        React.createElement("tr", null, weekDayNames.map(function (dayName, j) { return (React.createElement("th", { key: j }, dayName)); }))),
                    React.createElement("tbody", null, renderCalendar(month)))); })))),
        React.createElement("div", { className: "sps-datepicker__inputs", "data-testid": testId + "__datepicker__inputs" },
            React.createElement("span", { className: "sps-datepicker__input" },
                React.createElement("span", { className: inputWrapperClasses, "data-testid": testId + "__datepicker__input-wrapper" },
                    currentValue && currentValue.preset && (React.createElement("span", { className: "sps-tag sps-tag--info" }, getPresetText(currentValue.preset))),
                    React.createElement("input", { ref: inputElement, style: {
                            opacity: (currentValue && currentValue.preset) ? 0 : 1,
                        }, type: "text", className: "sps-datepicker__text-input", disabled: disabled, value: text, onClick: open, onFocus: open, onChange: onTextChanged, placeholder: placeholder, "data-testid": testId + "__datepicker__input" })),
                React.createElement("i", { className: "sps-icon sps-icon-calendar" }),
                (currentValue && currentValue.start && currentValue.end && !disabled) ? (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: clear })) : ''))));
}
Object.assign(SpsDateRangePicker, {
    props: propsDoc$1j,
    propTypes: propTypes$1m,
    displayName: 'SpsDateRangePicker',
});

var __makeTemplateObject$N = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsDateRangePickerExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$N || (templateObject_1$N = __makeTemplateObject$N(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            dateRange: [\n                                { year: 2021, month: 4, date: 10 },\n                                { year: 2021, month: 4, date: 18 }\n                            ]\n                        }, {\n                            \"dateRange\": [SpsValidators.dateRange]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                                    <SpsDateRangePickerV2\n                                        value={formValue.dateRange}\n                                        formMeta={formMeta.fields.dateRange}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            dateRange: [\n                                { year: 2021, month: 4, date: 10 },\n                                { year: 2021, month: 4, date: 18 }\n                            ]\n                        }, {\n                            \"dateRange\": [SpsValidators.dateRange]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                                    <SpsDateRangePickerV2\n                                        value={formValue.dateRange}\n                                        formMeta={formMeta.fields.dateRange}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
    constraints: {
        label: "Constraints",
        examples: {
            basic: {
                react: code(templateObject_2$I || (templateObject_2$I = __makeTemplateObject$N(["\n                    function Component() {\n                        const constraints = React.useRef({\n                            minDate: { year: 2021, month: 4, date: 5 },\n                            maxDate: { year: 2021, month: 4, date: 15 }\n                        })\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            dateRange: null,\n                        }, {\n                            \"dateRange\": [SpsValidators.dateRange, SpsValidators.dateConstraint(constraints.current)]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                                    <SpsDateRangePickerV2\n                                        value={formValue.dateRange}\n                                        formMeta={formMeta.fields.dateRange}\n                                        {...constraints.current}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const constraints = React.useRef({\n                            minDate: { year: 2021, month: 4, date: 5 },\n                            maxDate: { year: 2021, month: 4, date: 15 }\n                        })\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            dateRange: null,\n                        }, {\n                            \"dateRange\": [SpsValidators.dateRange, SpsValidators.dateConstraint(constraints.current)]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                                    <SpsDateRangePickerV2\n                                        value={formValue.dateRange}\n                                        formMeta={formMeta.fields.dateRange}\n                                        {...constraints.current}\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
    disabled: {
        label: "Disabled",
        examples: {
            disabled: {
                react: code(templateObject_3$z || (templateObject_3$z = __makeTemplateObject$N(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            dateRange: [\n                                { year: 2021, month: 4, date: 10 },\n                                { year: 2021, month: 4, date: 18 }\n                            ]\n                        }, {\n                            \"dateRange\": [SpsValidators.dateRange]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                                    <SpsDateRangePickerV2\n                                        value={formValue.dateRange}\n                                        formMeta={formMeta.fields.dateRange}\n                                        disabled\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            dateRange: [\n                                { year: 2021, month: 4, date: 10 },\n                                { year: 2021, month: 4, date: 18 }\n                            ]\n                        }, {\n                            \"dateRange\": [SpsValidators.dateRange]\n                        });\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\">\n                                    <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                                    <SpsDateRangePickerV2\n                                        value={formValue.dateRange}\n                                        formMeta={formMeta.fields.dateRange}\n                                        disabled\n                                    />\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
    presets: {
        label: "Custom Presets",
        description: "The definition of a preset can be either an ISO 8601 duration string, or a function that returns a SimpleDateRange.",
        examples: {
            presets: {
                react: code(templateObject_4$s || (templateObject_4$s = __makeTemplateObject$N(["\n                    function Component() {\n                        const presets = React.useRef([\n                          {\n                            label: \"Yesterday\",\n                            definition: () => {\n                              const yesterday = SimpleDateUtils.createFrom(\n                                moment().subtract(1, \"day\")\n                              )\n                              return [yesterday, yesterday]\n                            },\n                          },\n                          {\n                            label: \"Last 45 days\",\n                            definition: \"P45D\",\n                          },\n                        ])\n                        const { formValue, formMeta, updateForm } = useSpsForm(\n                          {\n                            dateRange: SimpleDateUtils.createRangeFromPreset(presets.current[0]),\n                          },\n                          {\n                            dateRange: [SpsValidators.dateRange],\n                          }\n                        )\n\n                        return (\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-3\">\n                              <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                              <SpsDateRangePickerV2\n                                presets={presets.current}\n                                value={formValue.dateRange}\n                                formMeta={formMeta.fields.dateRange}\n                              />\n                            </div>\n                          </div>\n                        )\n                      }\n                "], ["\n                    function Component() {\n                        const presets = React.useRef([\n                          {\n                            label: \"Yesterday\",\n                            definition: () => {\n                              const yesterday = SimpleDateUtils.createFrom(\n                                moment().subtract(1, \"day\")\n                              )\n                              return [yesterday, yesterday]\n                            },\n                          },\n                          {\n                            label: \"Last 45 days\",\n                            definition: \"P45D\",\n                          },\n                        ])\n                        const { formValue, formMeta, updateForm } = useSpsForm(\n                          {\n                            dateRange: SimpleDateUtils.createRangeFromPreset(presets.current[0]),\n                          },\n                          {\n                            dateRange: [SpsValidators.dateRange],\n                          }\n                        )\n\n                        return (\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-3\">\n                              <SpsLabel for={formMeta.fields.dateRange}>Date</SpsLabel>\n                              <SpsDateRangePickerV2\n                                presets={presets.current}\n                                value={formValue.dateRange}\n                                formMeta={formMeta.fields.dateRange}\n                              />\n                            </div>\n                          </div>\n                        )\n                      }\n                "]))),
            },
        },
    },
};
var templateObject_1$N, templateObject_2$I, templateObject_3$z, templateObject_4$s;

var moment$2 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
}(moment$2));

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));
}());

(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment$2.exports) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));
}());

var __assign$1u = (undefined && undefined.__assign) || function () {
    __assign$1u = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1u.apply(this, arguments);
};
var __rest$1a = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var currentLocale = moment__default.locale();
var currentlyLoadedLocales = moment__default.locales();
if (currentlyLoadedLocales.indexOf("en-US") === -1) {
    moment__default.defineLocale("en-US", {
        parentLocale: "en",
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY @ LT",
            LLLL: "dddd MMMM D, YYYY @ LT",
        },
    });
}
/**
 * TODO: check about these longDateFormat objects that are missing
 * properties on the moment.LongDateFormatSpec interface
 */
if (currentlyLoadedLocales.indexOf("en-US24") === -1) {
    moment__default.defineLocale("en-US24", {
        parentLocale: "en-US",
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
        },
    });
}
if (currentlyLoadedLocales.indexOf("en-PH") === -1) {
    // using tl-ph.js as a primary reference
    moment__default.defineLocale("en-PH", {
        parentLocale: "en-GB",
    });
    moment__default.updateLocale("en-PH", {
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
        },
    });
}
if (currentlyLoadedLocales.indexOf("en-IN") === -1) {
    // using pa-IN.js as a primary reference
    moment__default.defineLocale("en-IN", {
        parentLocale: "en-GB",
    });
    moment__default.updateLocale("en-IN", {
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            ll: "D-MMM-YYYY",
        },
    });
}
if (currentlyLoadedLocales.indexOf("en-SG") === -1) {
    moment__default.defineLocale("en-SG", {
        parentLocale: "en-IN",
    });
    moment__default.updateLocale("en-SG", {
        longDateFormat: {
            ll: "D MMM YYYY",
        },
    });
}
if (currentlyLoadedLocales.indexOf("en-HK") === -1) {
    moment__default.defineLocale("en-HK", {
        parentLocale: "en-GB",
    });
}
moment__default.locale(currentLocale);
var formatMaps = {
    ISO_8601: "ISO_8601",
    ISO_8601_UTC: "ISO_8601_UTC",
    SHORT_TIME: "LT",
    SHORT_TIME_ZONE: "LT z",
    LONG_TIME: "LTS",
    LONG_TIME_ZONE: "LTS z",
    NUM_DATE: "L",
    SHORT_DATE: "ll",
    LONG_DATE: "LL",
    SHORT_DATETIME: "lll",
    SHORT_DATETIME_ZONE: "lll z",
    LONG_DATETIME: "LLL",
    LONG_DATETIME_ZONE: "LLL z",
    SHORT_FULLDATETIME: "llll",
    SHORT_FULLDATETIME_ZONE: "llll z",
    LONG_FULLDATETIME: "LLLL",
    LONG_FULLDATETIME_ZONE: "LLLL z", // Monday February 29, 2016 3:03 PM CST
};
var propsDoc$1i = {
    currentUser: "any",
    dateToFormat: "string | Date",
    format: "string",
    locale: "string",
    relative: "boolean",
    relativeHrs: "number",
    tz: "string",
};
var propTypes$1l = __assign$1u(__assign$1u({}, spsGlobalPropTypes), { currentUser: propTypes$1H.exports.any, dateToFormat: propTypes$1H.exports.oneOfType([
        propTypes$1H.exports.string, propTypes$1H.exports.instanceOf(Date),
    ]), format: propTypes$1H.exports.string, locale: propTypes$1H.exports.string, relative: propTypes$1H.exports.bool, relativeHrs: propTypes$1H.exports.number, tz: propTypes$1H.exports.string });
/*
 * determine if relative formatting should be used
 * based on a diff of relativeHrs
 * TODO: this has only been teste with dates in the past
 */
function showRelative(dateToCheck, relative, relativeHrs) {
    if (!relativeHrs && !relative) {
        return false;
    }
    if (relative) {
        return true;
    }
    var targetDate = moment__default(dateToCheck);
    var diff = moment__default().diff(targetDate, "hours");
    return diff < relativeHrs;
}
// use moment and available props to determine how to format date
function getDate(_a) {
    var _b = _a.locale, locale = _b === void 0 ? window.navigator.language : _b, _c = _a.tz, tz = _c === void 0 ? moment__default.tz.guess() : _c, dateToFormat = _a.dateToFormat, format = _a.format, currentUser = _a.currentUser, relative = _a.relative, relativeHrs = _a.relativeHrs, children = _a.children;
    var theTimezone = tz;
    var theLocale = locale;
    if (currentUser && currentUser.preferences) {
        theTimezone = theTimezone || currentUser.preferences.timezone;
        theLocale = theLocale || currentUser.preferences.locale;
    }
    var formatString = format
        ? formatMaps[format]
        : "lll";
    var date = dateToFormat || String(children);
    var momentDate = moment__default(date);
    momentDate.locale(theLocale);
    // check to see if date is valid
    if (!momentDate.isValid()) {
        throw new Error("invalid date");
    }
    momentDate.tz(theTimezone);
    if (showRelative(date, relative, relativeHrs)) {
        return momentDate.fromNow();
    }
    return momentDate.format(formatString);
}
function SpsDateTime(props) {
    var dateToFormat = props.dateToFormat, locale = props.locale, tz = props.tz, format = props.format, currentUser = props.currentUser, relative = props.relative, relativeHrs = props.relativeHrs, children = props.children, rest = __rest$1a(props, ["dateToFormat", "locale", "tz", "format", "currentUser", "relative", "relativeHrs", "children"]);
    return (React.createElement("span", __assign$1u({ className: "sps-datetime" }, rest), getDate({
        locale: locale,
        tz: tz,
        dateToFormat: dateToFormat,
        format: format,
        currentUser: currentUser,
        relative: relative,
        relativeHrs: relativeHrs,
        children: children,
    })));
}
Object.assign(SpsDateTime, {
    props: propsDoc$1i,
    propTypes: propTypes$1l,
    displayName: "SpsDateTime",
});

var __makeTemplateObject$M = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsDatetimeExamples = {
    basic: {
        label: "Datetime Component",
        description: "<p>Formats dates</p>",
        examples: {
            basicAttribute: {
                jsx: code(templateObject_1$M || (templateObject_1$M = __makeTemplateObject$M(["\n                    <SpsDateTime dateToFormat=\"2018-09-11T16:32:52.822000Z\" />\n                "], ["\n                    <SpsDateTime dateToFormat=\"2018-09-11T16:32:52.822000Z\" />\n                "]))),
            },
            basicChild: {
                jsx: code(templateObject_2$H || (templateObject_2$H = __makeTemplateObject$M(["\n                    <SpsDateTime>2018-09-11T16:32:52.822000Z</SpsDateTime>\n                "], ["\n                    <SpsDateTime>2018-09-11T16:32:52.822000Z</SpsDateTime>\n                "]))),
            },
        },
    },
};
var templateObject_1$M, templateObject_2$H;

var __assign$1t = (undefined && undefined.__assign) || function () {
    __assign$1t = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1t.apply(this, arguments);
};
var __rest$19 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1h = {
    compact: "boolean",
    wideTerms: "boolean",
    widerTerms: "boolean",
};
var propTypes$1k = __assign$1t(__assign$1t({}, spsGlobalPropTypes), { compact: propTypes$1H.exports.bool, wideTerms: propTypes$1H.exports.bool, widerTerms: propTypes$1H.exports.bool });
function SpsDescriptionList(props) {
    var children = props.children, className = props.className, _a = props.compact, compact = _a === void 0 ? false : _a, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, _b = props.wideTerms, wideTerms = _b === void 0 ? false : _b, _c = props.widerTerms, widerTerms = _c === void 0 ? false : _c, rest = __rest$19(props, ["children", "className", "compact", "data-testid", "unsafelyReplaceClassName", "wideTerms", "widerTerms"]);
    /** holy shit this is awful. TODO: fix this garbage */
    var childrenWithProps = React.Children.map(children, function (child, index) {
        if (!(child.type.toString() === React.Fragment.toString())) {
            var rowIndex = parseInt("" + index / 2, 10) + 1;
            return React.cloneElement(child, {
                style: __assign$1t(__assign$1t({}, child.props.style), { msGridRow: rowIndex }),
            });
        }
        // During dynamic dt and dt creation they will be received in Fragment.
        var nestedChildrens = child.props.children;
        var fragmentChildrens = React.Children.map(nestedChildrens, function (chld) { return React.cloneElement(chld, {
            style: __assign$1t(__assign$1t({}, chld.props.style), { msGridRow: index + 1 }),
        }); });
        return fragmentChildrens;
    });
    var classes = clsx(unsafelyReplaceClassName || "sps-description-list", compact && "sps-description-list--compact", wideTerms && "sps-description-list--wide-terms", widerTerms && "sps-description-list--wider-terms", className);
    return (React.createElement("dl", __assign$1t({ className: classes, "data-testid": "" + testId }, rest), childrenWithProps));
}
Object.assign(SpsDescriptionList, {
    props: propsDoc$1h,
    propTypes: propTypes$1k,
    displayName: "SpsDescriptionList / SpsDl",
});
function SpsDl(p) {
    return SpsDescriptionList(p);
}
Object.assign(SpsDl, {
    props: propsDoc$1h,
    propTypes: propTypes$1k,
    displayName: "SpsDescriptionList / SpsDl",
});

var __assign$1s = (undefined && undefined.__assign) || function () {
    __assign$1s = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1s.apply(this, arguments);
};
var __rest$18 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1g = {};
var propTypes$1j = __assign$1s({}, spsGlobalPropTypes);
function SpsDescriptionListDefinition(props) {
    var children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$18(props, ["children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-description-list__definition", className);
    return (React.createElement("dd", __assign$1s({ className: classes, "data-testid": "" + testId }, rest), children));
}
Object.assign(SpsDescriptionListDefinition, {
    props: propsDoc$1g,
    propTypes: propTypes$1j,
    displayName: "SpsDescriptionListDefinition / SpsDd",
});
function SpsDd(p) {
    return SpsDescriptionListDefinition(p);
}
Object.assign(SpsDd, {
    props: propsDoc$1g,
    propTypes: propTypes$1j,
    displayName: "SpsDescriptionListDefinition / SpsDd",
});

var __assign$1r = (undefined && undefined.__assign) || function () {
    __assign$1r = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1r.apply(this, arguments);
};
var __read$H = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values$5 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var TooltipVisibility;
(function (TooltipVisibility) {
    TooltipVisibility["VISIBLE"] = "visible";
    TooltipVisibility["DEFER_VISIBLE"] = "defer_visible";
    TooltipVisibility["HIDDEN"] = "hidden";
    TooltipVisibility["DELAYED_HIDDEN"] = "delayed_hidden";
})(TooltipVisibility || (TooltipVisibility = {}));
function toggleTooltipState(state) {
    return state === TooltipVisibility.VISIBLE
        ? TooltipVisibility.HIDDEN
        : TooltipVisibility.VISIBLE;
}
var CARET_SPACING_PX = 13;
var openTips = new Map();
var propsDoc$1f = {
    for: { type: "React.MutableRefObject<any> | string", required: true },
    hideDelay: "number",
    isShown: "TooltipVisibility",
    kind: "TooltipKind",
    offsets: "[number, number]",
    onDeferred: "() => void",
    position: "Position",
    altPosition: "Position",
    showOn: "TooltipShowTrigger",
    title: "string | ReactNode",
};
var propTypes$1i = __assign$1r(__assign$1r({}, spsGlobalPropTypes), { for: propTypes$1H.exports.oneOfType([ref(), propTypes$1H.exports.string]).isRequired, hideDelay: propTypes$1H.exports.number, isShown: enumValue(TooltipVisibility), kind: enumValue(TooltipKind), offsets: propTypes$1H.exports.arrayOf(propTypes$1H.exports.number), onDeferred: fun(), position: enumValue(Position), altPosition: enumValue(Position), showOn: enumValue(TooltipShowTrigger), title: propTypes$1H.exports.string || propTypes$1H.exports.node });
function SpsTooltip(_a) {
    var children = _a.children, className = _a.className, forProp = _a.for, testId = _a["data-testid"], _b = _a.hideDelay, hideDelay = _b === void 0 ? TOOLTIP_HIDE_DELAY_MS_DEFAULT : _b, isShown = _a.isShown, _c = _a.kind, kind = _c === void 0 ? TooltipKind.DEFAULT : _c, _d = _a.offsets, offsets = _d === void 0 ? [0, 0] : _d, onDeferred = _a.onDeferred, _e = _a.position, position = _e === void 0 ? Position.TOP_MIDDLE : _e, _f = _a.altPosition, altPosition = _f === void 0 ? flipPosition(position) : _f, _g = _a.showOn, showOn = _g === void 0 ? TooltipShowTrigger.MOUSEOVER : _g, style = _a.style, title = _a.title, unsafelyReplaceClassName = _a.unsafelyReplaceClassName;
    var iref = React.useRef({
        instanceKey: Symbol("ds-react:tooltip:instance-key"),
        prevIsShown: isShown,
        hideTimer: null,
    });
    var _h = __read$H(React.useState(false), 2), shown = _h[0], setShown = _h[1];
    var rootElement = React.useRef(null);
    var forElementRef = typeof forProp === "string" ? React.useRef(document.getElementById(forProp)) : forProp;
    var clearHideDelay = React.useCallback(function () {
        if (iref.current.hideTimer) {
            window.clearTimeout(iref.current.hideTimer);
            iref.current.hideTimer = null;
        }
    }, []);
    var hide = React.useCallback(function () {
        clearHideDelay();
        setShown(false);
    }, []);
    var show = React.useCallback(function (defer) {
        var e_1, _a;
        if (defer === void 0) { defer = false; }
        /*
         * If defer is true, the tooltip will only open if no other tooltip is already active.
         * We explicitly check its value rather than truthiness because when used as an event
         * listener, the argument will be an Event object.
         */
        if (defer === true && openTips.size > 0) {
            if (onDeferred) {
                onDeferred();
            }
            return false;
        }
        if (rootElement.current.textContent === "") {
            console.warn("SpsTooltip is empty; aborting show");
            return false;
        }
        clearHideDelay();
        try {
            for (var _b = __values$5(openTips.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var openTipHide = _c.value;
                openTipHide();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        setShown(true);
        return true;
    }, []);
    var toggle = React.useCallback(function (event) {
        if (event) {
            event.stopPropagation();
        }
        // tslint:disable-next-line:no-shadowed-variable
        setShown(function (currentShown) {
            if (currentShown) {
                hide();
                return false;
            }
            return show();
        });
    }, []);
    var documentListener = React.useCallback(function (event) {
        if (rootElement.current && !rootElement.current.contains(event.target)) {
            hide();
        }
    }, []);
    var delayedHide = React.useCallback(function () {
        clearHideDelay();
        iref.current.hideTimer = window.setTimeout(hide, hideDelay);
    }, []);
    React.useEffect(function () {
        if (typeof forProp === "string") {
            forElementRef.current = document.getElementById(forProp);
        }
        if (shown) {
            openTips.set(iref.current.instanceKey, hide);
        }
        else if (openTips.has(iref.current.instanceKey)) {
            openTips.delete(iref.current.instanceKey);
        }
        if (showOn === TooltipShowTrigger.MANUAL) {
            if (isShown !== iref.current.prevIsShown) {
                switch (isShown) {
                    case TooltipVisibility.VISIBLE:
                        show();
                        break;
                    case TooltipVisibility.DEFER_VISIBLE:
                        show(true);
                        break;
                    case TooltipVisibility.HIDDEN:
                        hide();
                        break;
                    case TooltipVisibility.DELAYED_HIDDEN:
                        delayedHide();
                        break;
                    // no default
                }
            }
            iref.current.prevIsShown = isShown;
        }
    }, [shown, isShown]);
    React.useEffect(function () {
        if (forElementRef.current) {
            switch (showOn) {
                case TooltipShowTrigger.MOUSEOVER:
                    forElementRef.current.addEventListener("mouseenter", show);
                    forElementRef.current.addEventListener("mouseleave", delayedHide);
                    break;
                case TooltipShowTrigger.CLICK:
                    forElementRef.current.addEventListener("click", toggle);
                    document.addEventListener("click", documentListener);
                    break;
                case TooltipShowTrigger.MANUAL:
                    break;
                // no default
            }
        }
    }, [forElementRef]);
    React.useEffect(function () {
        if (rootElement.current.textContent === "" && shown) {
            if (iref.current.hideTimer) {
                clearTimeout(iref.current.hideTimer);
                iref.current.hideTimer = null;
            }
            setShown(false);
        }
    }, [children, shown]);
    React.useEffect(function () { return function () {
        if (openTips.has(iref.current.instanceKey)) {
            openTips.delete(iref.current.instanceKey);
        }
        if (forElementRef.current) {
            forElementRef.current.removeEventListener("mouseenter", show);
            forElementRef.current.removeEventListener("mouseleave", delayedHide);
            forElementRef.current.removeEventListener("click", toggle);
            document.removeEventListener("click", documentListener);
        }
    }; }, []);
    var portal = usePortal("sps-tooltip-portal");
    var portalContext = React.useContext(PortalContext);
    var _j = __read$H(shown
        ? getPosition(rootElement, forElementRef, position, __assign$1r({ altPosition: altPosition, setMinWidth: false, offsets: [offsets[0] - CARET_SPACING_PX, offsets[1]] }, portalContext))
        : [{}, false], 2), posStyle = _j[0], altPositionUsed = _j[1];
    var classes = clsx(unsafelyReplaceClassName || "sps-tooltip", "z-stratum-tip", "sps-tooltip--" + kind, "sps-tooltip--pos-" + (altPositionUsed ? altPosition : position).replace(" ", "-"), shown && "sps-tooltip--shown", className);
    return portal(React.createElement("div", { role: "tooltip", className: classes, "data-testid": testId, ref: rootElement, style: __assign$1r(__assign$1r({}, style), posStyle), onMouseEnter: showOn === TooltipShowTrigger.MOUSEOVER ? clearHideDelay : null, onMouseLeave: showOn === TooltipShowTrigger.MOUSEOVER ? delayedHide : null },
        title && (typeof title === "string" ? React.createElement("span", { className: "sps-tooltip__title d-block" }, title) : title),
        React.createElement("span", { className: "sps-tooltip__body d-block" }, children),
        React.createElement("span", { className: "sps-tooltip__caret" })));
}
Object.assign(SpsTooltip, {
    props: propsDoc$1f,
    propTypes: propTypes$1i,
    displayName: "SpsTooltip",
});

var __assign$1q = (undefined && undefined.__assign) || function () {
    __assign$1q = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1q.apply(this, arguments);
};
var __rest$17 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$G = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1e = {
    error: "boolean",
    errors: "ReactNodeOrRenderFn",
    help: "ReactNodeOrRenderFn",
    labelFor: "SpsFormFieldMeta<any>",
    required: "boolean",
};
var propTypes$1h = __assign$1q(__assign$1q({}, spsGlobalPropTypes), { error: propTypes$1H.exports.bool, errors: nodeOrRenderFn, help: nodeOrRenderFn, labelFor: propTypes$1H.exports.oneOfType([
        impl(), impl(),
    ]), required: propTypes$1H.exports.bool });
function SpsDescriptionListTerm(props) {
    var children = props.children, className = props.className, error = props.error, errors = props.errors, help = props.help, formControl = props.labelFor, required = props.required, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$17(props, ["children", "className", "error", "errors", "help", "labelFor", "required", "data-testid", "unsafelyReplaceClassName"]);
    function shouldShowErrorState() {
        return formControl && !formControl.isPristine() && !formControl.isValid();
    }
    var dtElement = React.useRef();
    var _a = __read$G(React.useState(), 2), tipKind = _a[0], setTipKind = _a[1];
    var _b = __read$G(React.useState(TooltipVisibility.HIDDEN), 2), showTip = _b[0], setShowTip = _b[1];
    React.useEffect(function () {
        setTipKind(shouldShowErrorState() ? TooltipKind.ERROR : TooltipKind.HELP);
    });
    if (formControl) {
        formControl.onFocus = function () { return setShowTip(TooltipVisibility.VISIBLE); };
        formControl.onBlur = function () { return setShowTip(TooltipVisibility.HIDDEN); };
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-description-list__term", (required || (formControl && formControl.isRequired())) && "sps-description-list__term--required", (error || shouldShowErrorState()) && "sps-description-list__term--error", className);
    function toggle() {
        setShowTip(showTip === TooltipVisibility.VISIBLE
            ? TooltipVisibility.HIDDEN : TooltipVisibility.VISIBLE);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("dt", __assign$1q({ className: classes, "data-testid": "" + testId, ref: dtElement, onMouseEnter: function () { return setShowTip(TooltipVisibility.VISIBLE); }, onMouseLeave: function () { return setShowTip(TooltipVisibility.DELAYED_HIDDEN); }, onClick: toggle }, rest), children),
        React.createElement(SpsTooltip, { kind: tipKind, for: dtElement, showOn: TooltipShowTrigger.MANUAL, isShown: showTip }, contentOf(tipKind === TooltipKind.ERROR ? errors : help))));
}
Object.assign(SpsDescriptionListTerm, {
    props: propsDoc$1e,
    propTypes: propTypes$1h,
    displayName: "SpsDescriptionListTerm / SpsDt",
});
function SpsDt(p) {
    return SpsDescriptionListTerm(p);
}
Object.assign(SpsDt, {
    props: propsDoc$1e,
    propTypes: propTypes$1h,
    displayName: "SpsDescriptionListTerm / SpsDt",
});

var __makeTemplateObject$L = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsDescriptionListExamples = {
    basic: {
        label: "Basic Description List",
        examples: {
            basic: {
                jsx: code(templateObject_1$L || (templateObject_1$L = __makeTemplateObject$L(["\n                    <SpsDl>\n                        <SpsDt>Term 1</SpsDt>\n                        <SpsDd>Definition</SpsDd>\n                        <SpsDt>Term</SpsDt>\n                        <SpsDd>Definition</SpsDd>\n                        <SpsDt>\n                            Term that wraps to the next line cause it's got so dang much text in it.\n                        </SpsDt>\n                        <SpsDd>Definition</SpsDd>\n                        <SpsDt>Term</SpsDt>\n                        <SpsDd>\n                            Definition that has a LOOOOOOOOOOT of text in it.\n                            Definition that has a LOOOOOOOOOOT of text in it.\n                        </SpsDd>\n                    </SpsDl>\n                "], ["\n                    <SpsDl>\n                        <SpsDt>Term 1</SpsDt>\n                        <SpsDd>Definition</SpsDd>\n                        <SpsDt>Term</SpsDt>\n                        <SpsDd>Definition</SpsDd>\n                        <SpsDt>\n                            Term that wraps to the next line cause it's got so dang much text in it.\n                        </SpsDt>\n                        <SpsDd>Definition</SpsDd>\n                        <SpsDt>Term</SpsDt>\n                        <SpsDd>\n                            Definition that has a LOOOOOOOOOOT of text in it.\n                            Definition that has a LOOOOOOOOOOT of text in it.\n                        </SpsDd>\n                    </SpsDl>\n                "]))),
            },
            dynamic: {
                react: code(templateObject_2$G || (templateObject_2$G = __makeTemplateObject$L(["\n                    function DemoComponent() {\n                        const list = [\n                            { term: \"Term 1\", definition: \"Definition 1\" },\n                            { term: \"Term 2\", definition: \"Definition 2\" },\n                            { term: \"Term 3\", definition: \"Definition 3\" },\n                        ];\n\n                        return (\n                            <SpsDl>\n                                {list.map((item, i) => (\n                                    <React.Fragment>\n                                        <SpsDt>{item.term}</SpsDt>\n                                        <SpsDd>{item.definition}</SpsDd>\n                                    </React.Fragment>\n                                ))}\n                            </SpsDl>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const list = [\n                            { term: \"Term 1\", definition: \"Definition 1\" },\n                            { term: \"Term 2\", definition: \"Definition 2\" },\n                            { term: \"Term 3\", definition: \"Definition 3\" },\n                        ];\n\n                        return (\n                            <SpsDl>\n                                {list.map((item, i) => (\n                                    <React.Fragment>\n                                        <SpsDt>{item.term}</SpsDt>\n                                        <SpsDd>{item.definition}</SpsDd>\n                                    </React.Fragment>\n                                ))}\n                            </SpsDl>\n                        );\n                    }\n                "]))),
            },
        },
    },
    b_advanced: {
        label: "Advanced Description List",
        examples: {
            advanced: {
                react: code(templateObject_3$y || (templateObject_3$y = __makeTemplateObject$L(["\n                function DemoComponent() {\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        firstName: \"\",\n                        lastName: \"\",\n                        title: \"\",\n                        accomplishments: \"\"\n                      }, {\n                        \"lastName\": [SpsValidators.required]\n                      })\n\n                    React.useEffect(() => {\n                      // Make the error state visible for this demo\n                      formMeta.fields.lastName.markAsDirty()\n                    }, [])\n\n                    return (\n                      <SpsCard>\n                        <SpsForm formMeta={formMeta}>\n                          <SpsDl>\n                            <SpsDt id=\"firstNameLabel\" labelFor={formMeta.fields.firstName}>\n                              First Name\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextInput\n                                aria-labelledby=\"firstNameLabel\"\n                                value={formValue.firstName}\n                                formMeta={formMeta.fields.firstName}\n                              />\n                            </SpsDd>\n                            <SpsDt\n                              id=\"lastNameLabel\"\n                              labelFor={formMeta.fields.lastName}\n                              errors={() =>\n                                formMeta.fields.lastName.hasError(\"required\") &&\n                                \"Please enter a last name.\"\n                              }\n                            >\n                              Last Name\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextInput\n                                aria-labelledby=\"lastNameLabel\"\n                                value={formValue.lastName}\n                                formMeta={formMeta.fields.lastName}\n                              />\n                            </SpsDd>\n                            <SpsDt id=\"titleLabel\" labelFor={formMeta.fields.title}>\n                              Title\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextInput\n                                aria-labelledby=\"titleLabel\"\n                                value={formValue.title}\n                                formMeta={formMeta.fields.title}\n                              />\n                            </SpsDd>\n                            <SpsDt\n                              id=\"accomplishmentsLabel\"\n                              labelFor={formMeta.fields.accomplishments}\n                              help=\"If they haven't achieved anything, make stuff up.\"\n                            >\n                              Top 5 Greatest Accomplishments\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextarea\n                                rows={3}\n                                value={formValue.accomplishments}\n                                formMeta={formMeta.fields.accomplishments}\n                                aria-labelledby=\"accomplishmentsLabel\"\n                              />\n                            </SpsDd>\n                          </SpsDl>\n                        </SpsForm>\n                      </SpsCard>\n                    )\n                  }\n                "], ["\n                function DemoComponent() {\n                    const { formValue, formMeta, updateForm } = useSpsForm({\n                        firstName: \"\",\n                        lastName: \"\",\n                        title: \"\",\n                        accomplishments: \"\"\n                      }, {\n                        \"lastName\": [SpsValidators.required]\n                      })\n\n                    React.useEffect(() => {\n                      // Make the error state visible for this demo\n                      formMeta.fields.lastName.markAsDirty()\n                    }, [])\n\n                    return (\n                      <SpsCard>\n                        <SpsForm formMeta={formMeta}>\n                          <SpsDl>\n                            <SpsDt id=\"firstNameLabel\" labelFor={formMeta.fields.firstName}>\n                              First Name\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextInput\n                                aria-labelledby=\"firstNameLabel\"\n                                value={formValue.firstName}\n                                formMeta={formMeta.fields.firstName}\n                              />\n                            </SpsDd>\n                            <SpsDt\n                              id=\"lastNameLabel\"\n                              labelFor={formMeta.fields.lastName}\n                              errors={() =>\n                                formMeta.fields.lastName.hasError(\"required\") &&\n                                \"Please enter a last name.\"\n                              }\n                            >\n                              Last Name\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextInput\n                                aria-labelledby=\"lastNameLabel\"\n                                value={formValue.lastName}\n                                formMeta={formMeta.fields.lastName}\n                              />\n                            </SpsDd>\n                            <SpsDt id=\"titleLabel\" labelFor={formMeta.fields.title}>\n                              Title\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextInput\n                                aria-labelledby=\"titleLabel\"\n                                value={formValue.title}\n                                formMeta={formMeta.fields.title}\n                              />\n                            </SpsDd>\n                            <SpsDt\n                              id=\"accomplishmentsLabel\"\n                              labelFor={formMeta.fields.accomplishments}\n                              help=\"If they haven't achieved anything, make stuff up.\"\n                            >\n                              Top 5 Greatest Accomplishments\n                            </SpsDt>\n                            <SpsDd>\n                              <SpsTextarea\n                                rows={3}\n                                value={formValue.accomplishments}\n                                formMeta={formMeta.fields.accomplishments}\n                                aria-labelledby=\"accomplishmentsLabel\"\n                              />\n                            </SpsDd>\n                          </SpsDl>\n                        </SpsForm>\n                      </SpsCard>\n                    )\n                  }\n                "]))),
            },
        },
    },
    c_compact: {
        label: "Compact Description List",
        examples: {
            compact: {
                jsx: code(templateObject_4$r || (templateObject_4$r = __makeTemplateObject$L(["\n                    <SpsDl compact>\n                      <SpsDt>Term 1</SpsDt>\n                      <SpsDd>Definition</SpsDd>\n                      <SpsDt>Term</SpsDt>\n                      <SpsDd>Definition</SpsDd>\n                      <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>\n                      <SpsDd>Definition</SpsDd>\n                      <SpsDt>Term</SpsDt>\n                      <SpsDd>Definition that has a LOOOOOOOOOOT of text in it. Definition that has a LOOOOOOOOOOT of text in it.\n                      </SpsDd>\n                    </SpsDl>\n                "], ["\n                    <SpsDl compact>\n                      <SpsDt>Term 1</SpsDt>\n                      <SpsDd>Definition</SpsDd>\n                      <SpsDt>Term</SpsDt>\n                      <SpsDd>Definition</SpsDd>\n                      <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>\n                      <SpsDd>Definition</SpsDd>\n                      <SpsDt>Term</SpsDt>\n                      <SpsDd>Definition that has a LOOOOOOOOOOT of text in it. Definition that has a LOOOOOOOOOOT of text in it.\n                      </SpsDd>\n                    </SpsDl>\n                "]))),
            },
        },
    },
    d_columnWidths: {
        label: "Alternate Column Widths",
        examples: {
            wideTerms: {
                jsx: code(templateObject_5$j || (templateObject_5$j = __makeTemplateObject$L(["\n                    <SpsDl wideTerms>\n                     <SpsDt>Term 1</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                    </SpsDl>\n                "], ["\n                    <SpsDl wideTerms>\n                     <SpsDt>Term 1</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                    </SpsDl>\n                "]))),
            },
            widerTerms: {
                jsx: code(templateObject_6$e || (templateObject_6$e = __makeTemplateObject$L(["\n                    <SpsDl widerTerms>\n                     <SpsDt>Term 1</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                    </SpsDl>\n                "], ["\n                    <SpsDl widerTerms>\n                     <SpsDt>Term 1</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                     <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>\n                     <SpsDd>Definition</SpsDd>\n                    </SpsDl>\n                "]))),
            },
        },
    },
};
var templateObject_1$L, templateObject_2$G, templateObject_3$y, templateObject_4$r, templateObject_5$j, templateObject_6$e;

var __makeTemplateObject$K = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsDropdownExamples = {
    labelled: {
        label: "Labelled",
        examples: {
            default: {
                description: "<h3> Default Dropdown</h3>",
                react: code(templateObject_1$K || (templateObject_1$K = __makeTemplateObject$K(["\n                function SpsDropdownBasicDefault(props) {\n                    const [action, updateAction] = useSpsAction({\n                        label: \"Option B\"\n                    }, () => console.log(\"Option B\"));\n                    return (\n                        <SpsDropdown id=\"regular\" label=\"Dropdown\" options={[\n                            [{ label: \"Option A\" }, () => console.log(\"Option A\")],\n                            action,\n                        ]}/>\n                    );\n                }\n            "], ["\n                function SpsDropdownBasicDefault(props) {\n                    const [action, updateAction] = useSpsAction({\n                        label: \"Option B\"\n                    }, () => console.log(\"Option B\"));\n                    return (\n                        <SpsDropdown id=\"regular\" label=\"Dropdown\" options={[\n                            [{ label: \"Option A\" }, () => console.log(\"Option A\")],\n                            action,\n                        ]}/>\n                    );\n                }\n            "]))),
            },
            key: {
                description: "<h3> Key Dropdown</h3>",
                react: code(templateObject_2$F || (templateObject_2$F = __makeTemplateObject$K(["\n                function SpsDropdownBasicKey(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"key\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownBasicKey(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"key\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
            confirm: {
                description: "<h3> Confirm Dropdown</h3>",
                react: code(templateObject_3$x || (templateObject_3$x = __makeTemplateObject$K(["\n                function SpsDropdownBasicConfirm(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"confirm\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownBasicConfirm(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"confirm\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
            delete: {
                description: "<h3> Delete Dropdown</h3>",
                react: code(templateObject_4$q || (templateObject_4$q = __makeTemplateObject$K(["\n                function SpsDropdownBasicDelete(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"delete\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownBasicDelete(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"delete\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
        },
    },
    withIcon: {
        label: "Labelled With Icon",
        examples: {
            default: {
                description: "<h3> Default Dropdown With Icon</h3>",
                react: code(templateObject_5$i || (templateObject_5$i = __makeTemplateObject$K(["\n                function SpsDropdownWithIconDefault(props) {\n                    const [action, updateAction] = useSpsAction(\n                      {\n                        label: \"Option B\"\n                      },\n                      () => console.log(\"Option B\")\n                    );\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        icon=\"drill\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], action]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownWithIconDefault(props) {\n                    const [action, updateAction] = useSpsAction(\n                      {\n                        label: \"Option B\"\n                      },\n                      () => console.log(\"Option B\")\n                    );\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        icon=\"drill\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], action]}\n                      />\n                    );\n                  }\n            "]))),
            },
            key: {
                description: "<h3>Key Dropdown With Icon</h3>",
                react: code(templateObject_6$d || (templateObject_6$d = __makeTemplateObject$K(["\n                function SpsDropdownWithIconKey(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"key\"\n                        icon=\"key\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownWithIconKey(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"key\"\n                        icon=\"key\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
            confirm: {
                description: "<h3> Confirm Dropdown With Icon</h3>",
                react: code(templateObject_7$b || (templateObject_7$b = __makeTemplateObject$K(["\n                function SpsDropdownWithIconConfirm(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"confirm\"\n                        icon=\"rocket\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownWithIconConfirm(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"confirm\"\n                        icon=\"rocket\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
            delete: {
                description: "<h3> Delete Dropdown With Icon</h3>",
                react: code(templateObject_8$a || (templateObject_8$a = __makeTemplateObject$K(["\n                function SpsDropdownWithIconDelete(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"delete\"\n                        icon=\"trash\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownWithIconDelete(props) {\n                    return (\n                      <SpsDropdown\n                        label=\"Dropdown\"\n                        kind=\"delete\"\n                        icon=\"trash\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
        },
    },
    withIconButton: {
        label: " Icon Button Dropdown",
        examples: {
            default: {
                description: "<h3> Default Icon Button Dropdown</h3>",
                react: code(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject$K(["\n                function SpsDropdownBasicIcon(props) {\n                    return (\n                      <SpsDropdown\n                        kind=\"icon\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownBasicIcon(props) {\n                    return (\n                      <SpsDropdown\n                        kind=\"icon\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
            custom: {
                description: "<h3>Custom Icon</h3>",
                react: code(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject$K(["\n                function SpsDropdownIconCustomIcon(props) {\n                    return (\n                      <SpsDropdown\n                        kind=\"icon\"\n                        icon=\"gear\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownIconCustomIcon(props) {\n                    return (\n                      <SpsDropdown\n                        kind=\"icon\"\n                        icon=\"gear\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
        },
    },
    disabled: {
        label: "Disabled",
        examples: {
            labelled: {
                description: "<h3> Disabled Labelled Dropdown</h3>",
                react: code(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject$K(["\n                function SpsDropdownDisabled(props) {\n                    return (\n                      <SpsDropdown\n                        id=\"disabled\"\n                        label=\"Dropdown\"\n                        icon=\"drill\"\n                        disabled\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownDisabled(props) {\n                    return (\n                      <SpsDropdown\n                        id=\"disabled\"\n                        label=\"Dropdown\"\n                        icon=\"drill\"\n                        disabled\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
            iconButton: {
                description: "<h3>Disabled Icon Button Dropdown</h3>",
                react: code(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject$K(["\n                function SpsDropdownIconCustomIcon(props) {\n                    return (\n                      <SpsDropdown disabled\n                        kind=\"icon\"\n                        icon=\"gear\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "], ["\n                function SpsDropdownIconCustomIcon(props) {\n                    return (\n                      <SpsDropdown disabled\n                        kind=\"icon\"\n                        icon=\"gear\"\n                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")]]}\n                      />\n                    );\n                  }\n            "]))),
            },
        },
    },
    spinning: {
        label: "Spinning",
        examples: {
            default: {
                description: "<h3>Spinning Dropdown</h3>",
                jsx: code(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject$K(["\n                        <SpsDropdown label=\"Dropdown\" options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")],]} spinning />\n                "], ["\n                        <SpsDropdown label=\"Dropdown\" options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")],]} spinning />\n                "]))),
            },
        },
    },
    checkbox: {
        label: "Checkbox",
        examples: {
            default: {
                description: "<h3>Dropdown With Checkbox</h3>",
                react: code(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject$K(["\n                function DemoComponent() {\n                  const [checked, setChecked] = React.useState(false)\n                  const onChange = (x) => setChecked(!checked)\n                  const options = [\n                    [\n                      { label: \"Select All Results\", icon: SpsIcon.FILE_SIZE },\n                      () => {},\n                    ],\n                    [\n                      { label: \"Select This Page\", icon: SpsIcon.FILE_SOLID },\n                      () => {},\n                    ],\n                    [{ label: \"Select None\", icon: SpsIcon.BAN }, () => {}],\n                    [{ label: \"Select All Favorites\", icon: SpsIcon.STAR }, () => {}],\n                    [\n                      { label: \"Select All by Tag\u2026\", icon: SpsIcon.ITEM_TAG },\n                      () => {},\n                    ],\n                  ]\n                  const items = [\n                    {\n                      spine: 2,\n                      title: \"Seven Samurai\",\n                      year: 1954,\n                    },\n                    {\n                      spine: 29,\n                      title: \"Picnic at Hanging Rock\",\n                      year: 1975,\n                    },\n                    {\n                      spine: 62,\n                      title: \"The Passion of Joan of Arc\",\n                      year: 1928,\n                    },\n                  ]\n\n                  return (\n                    <SpsTable selectable={true}>\n                      <SpsTableHead>\n                        <SpsTableRow>\n                          <SpsTableHeader controlCell={true}>\n                            <SpsCheckboxDropdown\n                              checked={checked}\n                              onChange={onChange}\n                              options={options}\n                            />\n                          </SpsTableHeader>\n                          <SpsTableHeader>Spine</SpsTableHeader>\n                          <SpsTableHeader>Title</SpsTableHeader>\n                          <SpsTableHeader>Year</SpsTableHeader>\n                        </SpsTableRow>\n                      </SpsTableHead>\n                      <SpsTableBody>\n                        {items.map((row, index) => {\n                          return (\n                            <SpsTableRow key={index}>\n                              <SpsTableCell>\n                                <SpsCheckbox />\n                              </SpsTableCell>\n                              <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                              <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                              <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                            </SpsTableRow>\n                          )\n                        })}\n                      </SpsTableBody>\n                    </SpsTable>\n                  )\n                }\n              "], ["\n                function DemoComponent() {\n                  const [checked, setChecked] = React.useState(false)\n                  const onChange = (x) => setChecked(!checked)\n                  const options = [\n                    [\n                      { label: \"Select All Results\", icon: SpsIcon.FILE_SIZE },\n                      () => {},\n                    ],\n                    [\n                      { label: \"Select This Page\", icon: SpsIcon.FILE_SOLID },\n                      () => {},\n                    ],\n                    [{ label: \"Select None\", icon: SpsIcon.BAN }, () => {}],\n                    [{ label: \"Select All Favorites\", icon: SpsIcon.STAR }, () => {}],\n                    [\n                      { label: \"Select All by Tag\u2026\", icon: SpsIcon.ITEM_TAG },\n                      () => {},\n                    ],\n                  ]\n                  const items = [\n                    {\n                      spine: 2,\n                      title: \"Seven Samurai\",\n                      year: 1954,\n                    },\n                    {\n                      spine: 29,\n                      title: \"Picnic at Hanging Rock\",\n                      year: 1975,\n                    },\n                    {\n                      spine: 62,\n                      title: \"The Passion of Joan of Arc\",\n                      year: 1928,\n                    },\n                  ]\n\n                  return (\n                    <SpsTable selectable={true}>\n                      <SpsTableHead>\n                        <SpsTableRow>\n                          <SpsTableHeader controlCell={true}>\n                            <SpsCheckboxDropdown\n                              checked={checked}\n                              onChange={onChange}\n                              options={options}\n                            />\n                          </SpsTableHeader>\n                          <SpsTableHeader>Spine</SpsTableHeader>\n                          <SpsTableHeader>Title</SpsTableHeader>\n                          <SpsTableHeader>Year</SpsTableHeader>\n                        </SpsTableRow>\n                      </SpsTableHead>\n                      <SpsTableBody>\n                        {items.map((row, index) => {\n                          return (\n                            <SpsTableRow key={index}>\n                              <SpsTableCell>\n                                <SpsCheckbox />\n                              </SpsTableCell>\n                              <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                              <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                              <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                            </SpsTableRow>\n                          )\n                        })}\n                      </SpsTableBody>\n                    </SpsTable>\n                  )\n                }\n              "]))),
            },
        },
    },
};
var templateObject_1$K, templateObject_2$F, templateObject_3$x, templateObject_4$q, templateObject_5$i, templateObject_6$d, templateObject_7$b, templateObject_8$a, templateObject_9$7, templateObject_10$6, templateObject_11$5, templateObject_12$2, templateObject_13$2, templateObject_14$2;

var __assign$1p = (undefined && undefined.__assign) || function () {
    __assign$1p = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1p.apply(this, arguments);
};
var __rest$16 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1d = {
    checked: "boolean",
    onChange: "ChangeEventHandler",
    indeterminate: "boolean",
    disabled: "boolean",
    options: "Array<SpsActionMethod | [SpsActionDescriptor, () => void]>",
};
var propTypes$1g = __assign$1p(__assign$1p({}, spsGlobalPropTypes), { checked: propTypes$1H.exports.bool, onChange: fun(), indeterminate: propTypes$1H.exports.bool, 
    // the type arg to PropTypes.arrayOf<T>() here confuses eslint greatly
    /* eslint-disable */
    options: propTypes$1H.exports.arrayOf(propTypes$1H.exports.oneOfType([propTypes$1H.exports.func, propTypes$1H.exports.any])).isRequired, 
    /* eslint-enable */
    disabled: propTypes$1H.exports.bool });
function SpsCheckboxDropdown(props) {
    var options = props.options, className = props.className, checked = props.checked, onChange = props.onChange, indeterminate = props.indeterminate, disabled = props.disabled, rest = __rest$16(props, ["options", "className", "checked", "onChange", "indeterminate", "disabled"]);
    var classes = clsx("sps-checkbox-dropdown", className);
    return (React.createElement("span", __assign$1p({ className: classes }, rest),
        React.createElement(SpsCheckbox, { indeterminate: indeterminate, checked: checked, disabled: disabled, onChange: onChange, inline: true }),
        React.createElement(SpsDropdown, { disabled: disabled, options: options, icon: SpsIcon.CHEVRON_DOWN })));
}
Object.assign(SpsCheckboxDropdown, {
    props: propsDoc$1d,
    propTypes: propTypes$1g,
    displayName: "SpsCheckboxDropdown",
});

var __assign$1o = (undefined && undefined.__assign) || function () {
    __assign$1o = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1o.apply(this, arguments);
};
var __rest$15 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1c = {
    kind: "FeedbackBlockKind",
};
var propTypes$1f = __assign$1o(__assign$1o({}, spsGlobalPropTypes), { kind: enumValue(FeedbackBlockKind) });
function SpsFeedbackBlock(props) {
    var children = props.children, className = props.className, _a = props.kind, kind = _a === void 0 ? FeedbackBlockKind.TIP : _a, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$15(props, ["children", "className", "kind", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-feedback-block", "sps-feedback-block--" + kind, className);
    return (React.createElement("div", __assign$1o({ className: classes, role: "alert", "data-testid": testId }, rest),
        React.createElement("i", { className: clsx("sps-icon", "sps-icon-" + FeedbackBlockIcons[kind]), "aria-hidden": "true" }),
        React.createElement("span", { className: "sps-feedback-block__content", "data-testid": testId + "__text" }, children)));
}
Object.assign(SpsFeedbackBlock, {
    props: propsDoc$1c,
    propTypes: propTypes$1f,
    displayName: "SpsFeedbackBlock",
});

var __makeTemplateObject$J = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsFeedbackBlockExamples = {
    standard: {
        label: "Standard Size",
        description: "Use Standard Size Feedback Blocks for the majority of cases. If a smaller or more subtle solution is needed, use the Micro Size Feedback Block.",
        examples: {
            error: {
                description: "Error",
                jsx: code(templateObject_1$J || (templateObject_1$J = __makeTemplateObject$J(["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.ERROR}>\n                        We are experiencing difficulties communicating to the server. Please try again later.\n                    </SpsFeedbackBlock>\n                "], ["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.ERROR}>\n                        We are experiencing difficulties communicating to the server. Please try again later.\n                    </SpsFeedbackBlock>\n                "]))),
            },
            info: {
                description: "Information",
                jsx: code(templateObject_2$E || (templateObject_2$E = __makeTemplateObject$J(["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.INFO}>\n                        FYI - This page has been updated. Click refresh to see the most recent version.\n                    </SpsFeedbackBlock>\n                "], ["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.INFO}>\n                        FYI - This page has been updated. Click refresh to see the most recent version.\n                    </SpsFeedbackBlock>\n                "]))),
            },
            proTip: {
                description: "Pro Tip",
                jsx: code(templateObject_3$w || (templateObject_3$w = __makeTemplateObject$J(["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.TIP}>\n                        Please Note: Click the Receive button above to check for new transactions from QuickBooks.\n                    </SpsFeedbackBlock>\n                "], ["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.TIP}>\n                        Please Note: Click the Receive button above to check for new transactions from QuickBooks.\n                    </SpsFeedbackBlock>\n                "]))),
            },
            success: {
                description: "Success",
                jsx: code(templateObject_4$p || (templateObject_4$p = __makeTemplateObject$J(["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.SUCCESS}>\n                        All items have been uploaded and are ready for export.\n                    </SpsFeedbackBlock>\n                "], ["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.SUCCESS}>\n                        All items have been uploaded and are ready for export.\n                    </SpsFeedbackBlock>\n                "]))),
            },
            warning: {
                description: "Warning",
                jsx: code(templateObject_5$h || (templateObject_5$h = __makeTemplateObject$J(["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.WARNING}>\n                        Warning! This order is missing a shipment date and is in jeopardy of being past due.\n                    </SpsFeedbackBlock>\n                "], ["\n                    <SpsFeedbackBlock kind={FeedbackBlockKind.WARNING}>\n                        Warning! This order is missing a shipment date and is in jeopardy of being past due.\n                    </SpsFeedbackBlock>\n                "]))),
            },
        },
    },
    micro: {
        label: "Micro Size",
        description: "Use Micro Size Feedback Blocks when a Standard Size Feedback Block is too large or too visually overwhelming.",
        examples: {
            error: {
                description: "Error",
                jsx: code(templateObject_6$c || (templateObject_6$c = __makeTemplateObject$J(["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.ERROR}\n                        message=\"We are experiencing difficulties communicating to the server. Please try again later.\"\n                    />\n                "], ["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.ERROR}\n                        message=\"We are experiencing difficulties communicating to the server. Please try again later.\"\n                    />\n                "]))),
            },
            info: {
                description: "Information",
                jsx: code(templateObject_7$a || (templateObject_7$a = __makeTemplateObject$J(["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.INFO}\n                        message=\"Refresh the page to see the most recent version.\"\n                    />\n                "], ["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.INFO}\n                        message=\"Refresh the page to see the most recent version.\"\n                    />\n                "]))),
            },
            proTip: {
                description: "Pro Tip",
                jsx: code(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject$J(["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.TIP}\n                        message=\"Tip: Click the Receive button to check for new transactions.\"\n                    />\n                "], ["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.TIP}\n                        message=\"Tip: Click the Receive button to check for new transactions.\"\n                    />\n                "]))),
            },
            success: {
                description: "Success",
                jsx: code(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject$J(["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.SUCCESS}\n                        message=\"All items have been uploaded and are ready for export.\"\n                    />\n                "], ["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.SUCCESS}\n                        message=\"All items have been uploaded and are ready for export.\"\n                    />\n                "]))),
            },
            warning: {
                description: "Warning",
                jsx: code(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject$J(["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.WARNING}\n                        message=\"This order is missing a shipment date.\"\n                    />\n                "], ["\n                    <SpsMicroBlock\n                        kind={FeedbackBlockKind.WARNING}\n                        message=\"This order is missing a shipment date.\"\n                    />\n                "]))),
            },
        },
    },
};
var templateObject_1$J, templateObject_2$E, templateObject_3$w, templateObject_4$p, templateObject_5$h, templateObject_6$c, templateObject_7$a, templateObject_8$9, templateObject_9$6, templateObject_10$5;

var __assign$1n = (undefined && undefined.__assign) || function () {
    __assign$1n = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1n.apply(this, arguments);
};
var __read$F = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1b = {
    errors: "ReactNodeOrRenderFn",
    formMeta: "SpsFormSetMeta<any>",
    legend: "string",
    optional: "boolean",
    enabled: "boolean",
    onToggled: "(isEnabled: boolean) => void",
    tooltip: "string",
};
var propTypes$1e = __assign$1n(__assign$1n({}, spsGlobalPropTypes), { errors: nodeOrRenderFn, formArray: impl(), formGroup: impl(), formMeta: impl(), legend: propTypes$1H.exports.string, optional: propTypes$1H.exports.bool, enabled: propTypes$1H.exports.bool, onToggled: fun(), tooltip: propTypes$1H.exports.string });
function SpsFieldset(_a) {
    var children = _a.children, className = _a.className, errors = _a.errors, formArray = _a.formArray, formGroup = _a.formGroup, formMeta = _a.formMeta, legend = _a.legend, unsafelyReplaceClassName = _a.unsafelyReplaceClassName, _b = _a.optional, optional = _b === void 0 ? false : _b, enabled = _a.enabled, onToggled = _a.onToggled, tooltip = _a.tooltip;
    var formControlSet = formGroup || formArray;
    var legendElement = React.useRef(null);
    var infoCircleElement = React.useRef(null);
    var _c = __read$F(React.useState(TooltipVisibility.HIDDEN), 2), showTip = _c[0], setShowTip = _c[1];
    var _d = __read$F(React.useState(false), 2), wasFocused = _d[0], setWasFocused = _d[1];
    var _e = __read$F(React.useState(false), 2), isChecked = _e[0], setisChecked = _e[1];
    React.useEffect(function () {
        setisChecked(enabled);
    }, [enabled]);
    React.useEffect(function () {
        if (typeof onToggled === "function") {
            onToggled(isChecked);
        }
    }, [isChecked]);
    React.useEffect(function () {
        if (formControlSet || formMeta) {
            var isFocused = (formControlSet && formControlSet.isFocused())
                || (formMeta && formMeta.isFocused());
            if (!wasFocused && isFocused) {
                setShowTip(TooltipVisibility.VISIBLE);
            }
            else if (wasFocused && !isFocused) {
                setShowTip(TooltipVisibility.HIDDEN);
            }
            setWasFocused(isFocused);
        }
    });
    var fieldsetClasses = clsx(unsafelyReplaceClassName || "sps-fieldset", ((formControlSet && !formControlSet.isPristine() && formControlSet.invalid)
        || (formMeta && (!formMeta.isValid() || !formMeta.contentsAreValid()))) && "sps-fieldset--error", className, optional && !isChecked && "sps-fieldset--collapsed");
    function toggleTooltip() {
        setShowTip(showTip === TooltipVisibility.VISIBLE
            ? TooltipVisibility.HIDDEN : TooltipVisibility.VISIBLE);
    }
    return (React.createElement("div", { className: "sps-fieldset-container" },
        React.createElement("fieldset", { className: fieldsetClasses },
            React.createElement("legend", { className: "sps-fieldset__legend", ref: legendElement, onMouseEnter: function () { return setShowTip(TooltipVisibility.VISIBLE); }, onMouseLeave: function () { return setShowTip(TooltipVisibility.DELAYED_HIDDEN); }, onClick: toggleTooltip },
                optional && (React.createElement(SpsCheckbox, { checked: isChecked, className: "d-inline-flex", onChange: function () {
                        setisChecked(!isChecked);
                    } })),
                legend,
                tooltip && (React.createElement("span", { className: "sps-fieldset__legend-icon", ref: infoCircleElement },
                    React.createElement(SpsI, { icon: SpsIcon.INFO_CIRCLE })))),
            tooltip && (React.createElement(SpsTooltip, { for: infoCircleElement }, tooltip)),
            React.createElement(SpsTooltip, { for: legendElement, kind: TooltipKind.ERROR, showOn: TooltipShowTrigger.MANUAL, isShown: showTip }, contentOf(errors)),
            children)));
}
Object.assign(SpsFieldset, {
    props: propsDoc$1b,
    propTypes: propTypes$1e,
    displayName: "SpsFieldset",
});

var __makeTemplateObject$I = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsFieldsetExamples = {
    basic: {
        label: "Basic Fieldsets",
        description: "info about basic fieldsets",
        examples: {
            basic: {
                react: code(templateObject_1$I || (templateObject_1$I = __makeTemplateObject$I(["\n                    function DemoComponent() {\n                        const RADIO_OPTIONS = [\n                            { value: \"a\", label: \"Option A\" },\n                            { value: \"b\", label: \"Option B\" }\n                        ];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            myFieldset: {\n                                foo: \"\",\n                                bar: \"\",\n                                baz: RADIO_OPTIONS[0].value\n                            }\n                        });\n\n                        return <>\n                            <SpsFieldset formMeta={formMeta.fields.myFieldset} legend=\"Fieldset Legend\" tooltip=\"Add a Tooltip\">\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.myFieldset.fields.foo}\n                                            value={formValue.myFieldset.foo}\n                                        ></SpsTextInput>\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.bar}>Bar</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.myFieldset.fields.bar}\n                                            value={formValue.myFieldset.bar}\n                                        ></SpsTextInput>\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.baz}>Baz</SpsLabel>\n                                        {RADIO_OPTIONS.map(option => (\n                                            <SpsRadioButton key={option.value} name=\"baz\"\n                                                label={option.label} value={option.value}\n                                                formMeta={formMeta.fields.myFieldset.fields.baz}\n                                                checked={formValue.myFieldset.baz === option.value}\n                                            />\n                                        ))}\n                                    </div>\n                                </div>\n                            </SpsFieldset>\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const RADIO_OPTIONS = [\n                            { value: \"a\", label: \"Option A\" },\n                            { value: \"b\", label: \"Option B\" }\n                        ];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            myFieldset: {\n                                foo: \"\",\n                                bar: \"\",\n                                baz: RADIO_OPTIONS[0].value\n                            }\n                        });\n\n                        return <>\n                            <SpsFieldset formMeta={formMeta.fields.myFieldset} legend=\"Fieldset Legend\" tooltip=\"Add a Tooltip\">\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.myFieldset.fields.foo}\n                                            value={formValue.myFieldset.foo}\n                                        ></SpsTextInput>\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.bar}>Bar</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.myFieldset.fields.bar}\n                                            value={formValue.myFieldset.bar}\n                                        ></SpsTextInput>\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.baz}>Baz</SpsLabel>\n                                        {RADIO_OPTIONS.map(option => (\n                                            <SpsRadioButton key={option.value} name=\"baz\"\n                                                label={option.label} value={option.value}\n                                                formMeta={formMeta.fields.myFieldset.fields.baz}\n                                                checked={formValue.myFieldset.baz === option.value}\n                                            />\n                                        ))}\n                                    </div>\n                                </div>\n                            </SpsFieldset>\n                        </>\n                    }\n                "]))),
            },
        },
    },
    b_nested: {
        label: "Nested Fieldsets",
        description: "info about nested fieldsets",
        examples: {
            nested: {
                react: code(templateObject_2$D || (templateObject_2$D = __makeTemplateObject$I(["\n                    function DemoComponent() {\n                        const RADIO_OPTIONS = [\n                            { value: \"a\", label: \"Option A\" },\n                            { value: \"b\", label: \"Option B\" }\n                        ];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            topFieldset: {\n                                foo: \"\",\n                                fsNested: {\n                                    bar: RADIO_OPTIONS[1].value,\n                                    fsNested2: {\n                                        baz: \"\"\n                                    }\n                                }\n                            }\n                        });\n\n                        return <>\n                            <SpsFieldset formMeta={formMeta.fields.topFieldset} legend=\"Fieldset Legend\">\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.topFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.topFieldset.fields.foo}\n                                            value={formValue.topFieldset.foo}\n                                            placeholder=\"Enter a thing\"\n                                        ></SpsTextInput>\n                                    </div>\n                                </div>\n                                <SpsFieldset formMeta={formMeta.fields.topFieldset.fields.fsNested} legend=\"Nested Fieldset\">\n                                    <div className=\"sfg-row\">\n                                        <div className=\"sfg-col-4\">\n                                            <SpsLabel for={formMeta.fields.topFieldset.fields.fsNested.fields.bar}>Bar</SpsLabel>\n                                            {RADIO_OPTIONS.map(option => (\n                                                <SpsRadioButton key={option.value} name=\"fsRadio\"\n                                                    label={option.label} value={option.value}\n                                                    formMeta={formMeta.fields.topFieldset.fields.fsNested.fields.bar}\n                                                    checked={formValue.topFieldset.fsNested.bar === option.value}\n                                                />\n                                            ))}\n                                        </div>\n                                    </div>\n                                    <SpsFieldset formMeta={formMeta.fields.topFieldset.fields.fsNested.fields.fsNested2} legend=\"Doubly Nested Fieldset\">\n                                        <div className=\"sfg-row\">\n                                            <div className=\"sfg-col-4\">\n                                                <SpsLabel for={formMeta.fields.topFieldset.fields.fsNested.fields.fsNested2.fields.baz}>Baz</SpsLabel>\n                                                <SpsTextInput formMeta={formMeta.fields.topFieldset.fields.fsNested.fields.fsNested2.fields.baz}\n                                                    value={formValue.topFieldset.fsNested.baz}\n                                                    placeholder=\"Enter a thing\"\n                                                ></SpsTextInput>\n                                            </div>\n                                        </div>\n                                    </SpsFieldset>\n                                </SpsFieldset>\n                            </SpsFieldset>\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const RADIO_OPTIONS = [\n                            { value: \"a\", label: \"Option A\" },\n                            { value: \"b\", label: \"Option B\" }\n                        ];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            topFieldset: {\n                                foo: \"\",\n                                fsNested: {\n                                    bar: RADIO_OPTIONS[1].value,\n                                    fsNested2: {\n                                        baz: \"\"\n                                    }\n                                }\n                            }\n                        });\n\n                        return <>\n                            <SpsFieldset formMeta={formMeta.fields.topFieldset} legend=\"Fieldset Legend\">\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.topFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.topFieldset.fields.foo}\n                                            value={formValue.topFieldset.foo}\n                                            placeholder=\"Enter a thing\"\n                                        ></SpsTextInput>\n                                    </div>\n                                </div>\n                                <SpsFieldset formMeta={formMeta.fields.topFieldset.fields.fsNested} legend=\"Nested Fieldset\">\n                                    <div className=\"sfg-row\">\n                                        <div className=\"sfg-col-4\">\n                                            <SpsLabel for={formMeta.fields.topFieldset.fields.fsNested.fields.bar}>Bar</SpsLabel>\n                                            {RADIO_OPTIONS.map(option => (\n                                                <SpsRadioButton key={option.value} name=\"fsRadio\"\n                                                    label={option.label} value={option.value}\n                                                    formMeta={formMeta.fields.topFieldset.fields.fsNested.fields.bar}\n                                                    checked={formValue.topFieldset.fsNested.bar === option.value}\n                                                />\n                                            ))}\n                                        </div>\n                                    </div>\n                                    <SpsFieldset formMeta={formMeta.fields.topFieldset.fields.fsNested.fields.fsNested2} legend=\"Doubly Nested Fieldset\">\n                                        <div className=\"sfg-row\">\n                                            <div className=\"sfg-col-4\">\n                                                <SpsLabel for={formMeta.fields.topFieldset.fields.fsNested.fields.fsNested2.fields.baz}>Baz</SpsLabel>\n                                                <SpsTextInput formMeta={formMeta.fields.topFieldset.fields.fsNested.fields.fsNested2.fields.baz}\n                                                    value={formValue.topFieldset.fsNested.baz}\n                                                    placeholder=\"Enter a thing\"\n                                                ></SpsTextInput>\n                                            </div>\n                                        </div>\n                                    </SpsFieldset>\n                                </SpsFieldset>\n                            </SpsFieldset>\n                        </>\n                    }\n                "]))),
            },
        },
    },
    c_optional: {
        label: "Optional Fieldsets",
        description: "info about optional fieldsets",
        examples: {
            optional: {
                react: code(templateObject_3$v || (templateObject_3$v = __makeTemplateObject$I(["\n                    function DemoComponent() {\n                        const initValue = {\n                            optionalFieldset: {\n                                foo: \"\",\n                                bar: \"\",\n                            }\n                        };\n                        const { formValue, formMeta, updateForm } = useSpsForm(initValue);\n\n                        function handleToggle(isChecked) {\n                            console.log(isChecked ? \"optional fieldset visible\" : \"optional fieldset not visible\");\n                        }\n\n                        return <>\n                            <SpsFieldset legend=\"Fieldset Legend\" formMeta={formMeta.fields.optionalFieldset} optional enabled={false} onToggled={handleToggle}>\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.optionalFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.optionalFieldset.fields.foo}\n                                            value={formValue.optionalFieldset.foo}\n                                            placeholder=\"Enter a thing\"\n                                        ></SpsTextInput>\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.optionalFieldset.fields.bar}>Bar</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.optionalFieldset.fields.bar}\n                                            value={formValue.optionalFieldset.bar}\n                                            placeholder=\"Enter a thing\"\n                                        ></SpsTextInput>\n                                    </div>\n                                </div>\n                            </SpsFieldset>\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const initValue = {\n                            optionalFieldset: {\n                                foo: \"\",\n                                bar: \"\",\n                            }\n                        };\n                        const { formValue, formMeta, updateForm } = useSpsForm(initValue);\n\n                        function handleToggle(isChecked) {\n                            console.log(isChecked ? \"optional fieldset visible\" : \"optional fieldset not visible\");\n                        }\n\n                        return <>\n                            <SpsFieldset legend=\"Fieldset Legend\" formMeta={formMeta.fields.optionalFieldset} optional enabled={false} onToggled={handleToggle}>\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.optionalFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.optionalFieldset.fields.foo}\n                                            value={formValue.optionalFieldset.foo}\n                                            placeholder=\"Enter a thing\"\n                                        ></SpsTextInput>\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.optionalFieldset.fields.bar}>Bar</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.optionalFieldset.fields.bar}\n                                            value={formValue.optionalFieldset.bar}\n                                            placeholder=\"Enter a thing\"\n                                        ></SpsTextInput>\n                                    </div>\n                                </div>\n                            </SpsFieldset>\n                        </>\n                    }\n                "]))),
            },
        },
    },
    d_validationOnField: {
        label: "Validation on Field",
        description: "info about validation on fields",
        examples: {
            validationOnField: {
                react: code(templateObject_4$o || (templateObject_4$o = __makeTemplateObject$I(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            myFieldset: {\n                                foo: \"\",\n                            }\n                        }, {\n                            \"myFieldset.foo\": [SpsValidators.required]\n                        })\n\n                        React.useEffect(() => {\n                            formMeta.markAsDirty();\n                        }, [])\n\n                        return <>\n                            <SpsFieldset formMeta={formMeta.fields.myFieldset} legend=\"Fieldset Legend\">\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.myFieldset.fields.foo}\n                                            value={formValue.myFieldset.foo}\n                                        ></SpsTextInput>\n                                    </div>\n                                </div>\n                            </SpsFieldset>\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            myFieldset: {\n                                foo: \"\",\n                            }\n                        }, {\n                            \"myFieldset.foo\": [SpsValidators.required]\n                        })\n\n                        React.useEffect(() => {\n                            formMeta.markAsDirty();\n                        }, [])\n\n                        return <>\n                            <SpsFieldset formMeta={formMeta.fields.myFieldset} legend=\"Fieldset Legend\">\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.myFieldset.fields.foo}>Foo</SpsLabel>\n                                        <SpsTextInput formMeta={formMeta.fields.myFieldset.fields.foo}\n                                            value={formValue.myFieldset.foo}\n                                        ></SpsTextInput>\n                                    </div>\n                                </div>\n                            </SpsFieldset>\n                        </>\n                    }\n                "]))),
            },
        },
    },
    e_topFieldset: {
        label: "Validation on Fieldset",
        description: "info about validation on fieldsets",
        examples: {
            validationOnFieldset: {
                react: code(templateObject_5$g || (templateObject_5$g = __makeTemplateObject$I(["\n                    function DemoComponent() {\n                        function mustSelectAColorValidator(value) {\n                            if (value.radio === \"b\") {\n                                if (value.colors.filter(Boolean).length === 0) {\n                                    return {\n                                        mustSelectAColor: true\n                                    };\n                                }\n                            }\n                            return null;\n                        };\n\n                        const COLOR_OPTIONS = [\"Red\", \"Orange\", \"Yellow\", \"Green\", \"Blue\", \"Indigo\", \"Violet\"];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            topFieldset: {\n                                text: \"\",\n                                nestedFieldset: {\n                                    radio: \"b\",\n                                    colors: COLOR_OPTIONS.map(() => false)\n                                }\n                            }\n                        }, {\n                            \"topFieldset.nestedFieldset\": [mustSelectAColorValidator]\n                        });\n\n                        React.useEffect(() => {\n                            formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio.markAsDirty();\n                        }, [])\n\n                        return (\n                            <SpsForm formMeta={formMeta}>\n                                <SpsFieldset formMeta={formMeta.fields.topFieldset} legend=\"Fieldset Legend\">\n                                    <div className=\"sfg-row\">\n                                        <div className=\"sfg-col-4\">\n                                            <SpsLabel for={formMeta.fields.topFieldset.fields.text}>Input</SpsLabel>\n                                            <SpsTextInput formMeta={formMeta.fields.topFieldset.fields.text}\n                                                value={formValue.topFieldset.text}\n                                                placeholder=\"Enter a thing\"\n                                            ></SpsTextInput>\n                                        </div>\n                                    </div>\n                                    <SpsFieldset formMeta={formMeta.fields.topFieldset.fields.nestedFieldset}\n                                        legend=\"Nested Fieldset\"\n                                        errors={() => formMeta.fields.topFieldset.fields.nestedFieldset.hasError(\"mustSelectAColor\")\n                                            && \"If you choose Option B, you must select at least one color.\"}\n                                    >\n                                        <div className=\"sfg-row\">\n                                            <div className=\"sfg-col-4\">\n                                                <SpsLabel for={formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio}>Radio</SpsLabel>\n                                                <SpsRadioButton name=\"radio\" label=\"Option A\" value=\"a\"\n                                                    formMeta={formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio}\n                                                    checked={formValue.topFieldset.nestedFieldset.radio === \"a\"}\n                                                />\n                                                <SpsRadioButton name=\"radio\" label=\"Option B\" value=\"b\"\n                                                    formMeta={formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio}\n                                                    checked={formValue.topFieldset.nestedFieldset.radio === \"b\"}\n                                                />\n                                            </div>\n                                            <div className=\"sfg-col-8\">\n                                                <SpsLabel for={formMeta.fields.topFieldset.fields.nestedFieldset.fields.colors}>Colors</SpsLabel>\n                                                {COLOR_OPTIONS.map((color, index) =>\n                                                    <SpsCheckbox key={index} name=\"colors\" label={color}\n                                                        formMeta={formMeta.fields.topFieldset.fields.nestedFieldset.fields.colors[index]}\n                                                        checked={formValue.topFieldset.nestedFieldset.colors[index]}\n                                                    />\n                                                )}\n                                            </div>\n                                        </div>\n                                    </SpsFieldset>\n                                </SpsFieldset>\n                            </SpsForm>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        function mustSelectAColorValidator(value) {\n                            if (value.radio === \"b\") {\n                                if (value.colors.filter(Boolean).length === 0) {\n                                    return {\n                                        mustSelectAColor: true\n                                    };\n                                }\n                            }\n                            return null;\n                        };\n\n                        const COLOR_OPTIONS = [\"Red\", \"Orange\", \"Yellow\", \"Green\", \"Blue\", \"Indigo\", \"Violet\"];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            topFieldset: {\n                                text: \"\",\n                                nestedFieldset: {\n                                    radio: \"b\",\n                                    colors: COLOR_OPTIONS.map(() => false)\n                                }\n                            }\n                        }, {\n                            \"topFieldset.nestedFieldset\": [mustSelectAColorValidator]\n                        });\n\n                        React.useEffect(() => {\n                            formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio.markAsDirty();\n                        }, [])\n\n                        return (\n                            <SpsForm formMeta={formMeta}>\n                                <SpsFieldset formMeta={formMeta.fields.topFieldset} legend=\"Fieldset Legend\">\n                                    <div className=\"sfg-row\">\n                                        <div className=\"sfg-col-4\">\n                                            <SpsLabel for={formMeta.fields.topFieldset.fields.text}>Input</SpsLabel>\n                                            <SpsTextInput formMeta={formMeta.fields.topFieldset.fields.text}\n                                                value={formValue.topFieldset.text}\n                                                placeholder=\"Enter a thing\"\n                                            ></SpsTextInput>\n                                        </div>\n                                    </div>\n                                    <SpsFieldset formMeta={formMeta.fields.topFieldset.fields.nestedFieldset}\n                                        legend=\"Nested Fieldset\"\n                                        errors={() => formMeta.fields.topFieldset.fields.nestedFieldset.hasError(\"mustSelectAColor\")\n                                            && \"If you choose Option B, you must select at least one color.\"}\n                                    >\n                                        <div className=\"sfg-row\">\n                                            <div className=\"sfg-col-4\">\n                                                <SpsLabel for={formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio}>Radio</SpsLabel>\n                                                <SpsRadioButton name=\"radio\" label=\"Option A\" value=\"a\"\n                                                    formMeta={formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio}\n                                                    checked={formValue.topFieldset.nestedFieldset.radio === \"a\"}\n                                                />\n                                                <SpsRadioButton name=\"radio\" label=\"Option B\" value=\"b\"\n                                                    formMeta={formMeta.fields.topFieldset.fields.nestedFieldset.fields.radio}\n                                                    checked={formValue.topFieldset.nestedFieldset.radio === \"b\"}\n                                                />\n                                            </div>\n                                            <div className=\"sfg-col-8\">\n                                                <SpsLabel for={formMeta.fields.topFieldset.fields.nestedFieldset.fields.colors}>Colors</SpsLabel>\n                                                {COLOR_OPTIONS.map((color, index) =>\n                                                    <SpsCheckbox key={index} name=\"colors\" label={color}\n                                                        formMeta={formMeta.fields.topFieldset.fields.nestedFieldset.fields.colors[index]}\n                                                        checked={formValue.topFieldset.nestedFieldset.colors[index]}\n                                                    />\n                                                )}\n                                            </div>\n                                        </div>\n                                    </SpsFieldset>\n                                </SpsFieldset>\n                            </SpsForm>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$I, templateObject_2$D, templateObject_3$v, templateObject_4$o, templateObject_5$g;

var __assign$1m = (undefined && undefined.__assign) || function () {
    __assign$1m = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1m.apply(this, arguments);
};
var __rest$14 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$1a = {};
var propTypes$1d = __assign$1m({}, spsGlobalPropTypes);
function SpsFocusedTaskActions(props) {
    var children = props.children, className = props.className, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$14(props, ["children", "className", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-list-action-bar-container", "z-stratum-bar", className);
    return (React.createElement("div", __assign$1m({ className: classes }, rest),
        React.createElement("div", { className: "sps-list-action-bar" },
            React.createElement("div", { className: "sps-list-action-bar__actions" }, children))));
}
Object.assign(SpsFocusedTaskActions, {
    props: propsDoc$1a,
    propTypes: propTypes$1d,
    displayName: "SpsFocusedTaskActions",
});

var __assign$1l = (undefined && undefined.__assign) || function () {
    __assign$1l = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1l.apply(this, arguments);
};
var __rest$13 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$E = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$19 = {
    fullWidth: "boolean",
    isOpen: "boolean",
    onClose: "() => void",
};
var propTypes$1c = __assign$1l(__assign$1l({}, spsGlobalPropTypes), { fullWidth: propTypes$1H.exports.bool, isOpen: propTypes$1H.exports.bool, onClose: fun() });
function SpsFocusedTask(props) {
    var children = props.children, className = props.className, fullWidth = props.fullWidth, isOpen = props.isOpen, onClose = props.onClose; props.title; var testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$13(props, ["children", "className", "fullWidth", "isOpen", "onClose", "title", "data-testid", "unsafelyReplaceClassName"]);
    var rootRef = React.useRef();
    var t = React.useContext(I18nContext).t;
    React.useEffect(function () {
        document.body.style.overflow = isOpen ? "hidden" : null;
    }, [isOpen]);
    React.useEffect(function () { return function () {
        document.body.style.overflow = null;
    }; }, []);
    var classes = clsx(unsafelyReplaceClassName || "sps-focused-task", "z-stratum-dialog", fullWidth && "sps-focused-task--full-width", isOpen && "sps-focused-task--open", className);
    var _a = __read$E(selectChildren(children, [
        { type: SpsFocusedTaskActions },
    ]), 2), actions = _a[0], content = _a[1];
    return (React.createElement("div", __assign$1l({ className: classes, ref: rootRef, "data-testid": testId }, rest),
        React.createElement("div", { className: "sps-focused-task__title" },
            React.createElement(SpsButton, { className: "sps-focused-task__close-btn", kind: ButtonKind.ICON, icon: SpsIcon.X, onClick: onClose, title: t("design-system:focusedTask.close") })),
        React.createElement("div", { className: "sps-focused-task__body" },
            React.createElement(PortalContext.Provider, { value: { parentElementRef: rootRef } }, isOpen && content)),
        actions));
}
Object.assign(SpsFocusedTask, {
    props: propsDoc$19,
    propTypes: propTypes$1c,
    displayName: "SpsFocusedTask",
});

var __makeTemplateObject$H = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsFocusedTaskExamples = {
    basic: {
        examples: {
            basic: {
                react: code(templateObject_1$H || (templateObject_1$H = __makeTemplateObject$H(["\n                    function SpsFocusedTaskBasic() {\n                        const [showFocusedTask, setShowFocusedTask] = React.useState(false);\n\n                        function onClose() {\n                            setShowFocusedTask(false);\n                            console.log(\"onClose called\");\n                        }\n\n                        function onFormSubmit() {\n                            setShowFocusedTask(false);\n                        }\n\n                        return (\n                          <>\n                            <SpsButton onClick={() => setShowFocusedTask(true)}>\n                              Open Focused Task\n                            </SpsButton>\n                            <SpsFocusedTask isOpen={showFocusedTask} onClose={onClose}>\n                              <h2>Focused Task</h2>\n                              <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\"></div>\n                                <div className=\"sfg-col-6\">\n                                  <SpsCard>\n                                    <i>pretend there's a form here</i>\n                                  </SpsCard>\n                                </div>\n                                <div className=\"sfg-col-3\"></div>\n                              </div>\n                              <SpsFocusedTaskActions>\n                                <SpsButton kind=\"confirm\" onClick={onFormSubmit}>\n                                  Submit\n                                </SpsButton>\n                              </SpsFocusedTaskActions>\n                            </SpsFocusedTask>\n                          </>\n                        );\n                    }\n                "], ["\n                    function SpsFocusedTaskBasic() {\n                        const [showFocusedTask, setShowFocusedTask] = React.useState(false);\n\n                        function onClose() {\n                            setShowFocusedTask(false);\n                            console.log(\"onClose called\");\n                        }\n\n                        function onFormSubmit() {\n                            setShowFocusedTask(false);\n                        }\n\n                        return (\n                          <>\n                            <SpsButton onClick={() => setShowFocusedTask(true)}>\n                              Open Focused Task\n                            </SpsButton>\n                            <SpsFocusedTask isOpen={showFocusedTask} onClose={onClose}>\n                              <h2>Focused Task</h2>\n                              <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\"></div>\n                                <div className=\"sfg-col-6\">\n                                  <SpsCard>\n                                    <i>pretend there's a form here</i>\n                                  </SpsCard>\n                                </div>\n                                <div className=\"sfg-col-3\"></div>\n                              </div>\n                              <SpsFocusedTaskActions>\n                                <SpsButton kind=\"confirm\" onClick={onFormSubmit}>\n                                  Submit\n                                </SpsButton>\n                              </SpsFocusedTaskActions>\n                            </SpsFocusedTask>\n                          </>\n                        );\n                    }\n                "]))),
            },
            fullWidth: {
                react: code(templateObject_2$C || (templateObject_2$C = __makeTemplateObject$H(["\n                    function SpsFocusedTaskFullWidth() {\n                        const [showFocusedTask, setShowFocusedTask] = React.useState(false);\n\n                        function onClose() {\n                            setShowFocusedTask(false);\n                            console.log(\"onClose called\");\n                        }\n\n                        function onFormSubmit() {\n                            setShowFocusedTask(false);\n                        }\n\n                        return (\n                        <>\n                            <SpsButton onClick={() => setShowFocusedTask(true)}>\n                            Open Focused Task\n                            </SpsButton>\n                            <SpsFocusedTask fullWidth isOpen={showFocusedTask} onClose={onClose}>\n                            <h2>Focused Task</h2>\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\"></div>\n                                <div className=\"sfg-col-6\">\n                                <SpsCard>\n                                    <i>pretend there's a form here</i>\n                                </SpsCard>\n                                </div>\n                                <div className=\"sfg-col-3\"></div>\n                            </div>\n                            <SpsFocusedTaskActions>\n                                <SpsButton kind=\"confirm\" onClick={onFormSubmit}>\n                                Submit\n                                </SpsButton>\n                            </SpsFocusedTaskActions>\n                            </SpsFocusedTask>\n                        </>\n                        );\n                    }\n                "], ["\n                    function SpsFocusedTaskFullWidth() {\n                        const [showFocusedTask, setShowFocusedTask] = React.useState(false);\n\n                        function onClose() {\n                            setShowFocusedTask(false);\n                            console.log(\"onClose called\");\n                        }\n\n                        function onFormSubmit() {\n                            setShowFocusedTask(false);\n                        }\n\n                        return (\n                        <>\n                            <SpsButton onClick={() => setShowFocusedTask(true)}>\n                            Open Focused Task\n                            </SpsButton>\n                            <SpsFocusedTask fullWidth isOpen={showFocusedTask} onClose={onClose}>\n                            <h2>Focused Task</h2>\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-3\"></div>\n                                <div className=\"sfg-col-6\">\n                                <SpsCard>\n                                    <i>pretend there's a form here</i>\n                                </SpsCard>\n                                </div>\n                                <div className=\"sfg-col-3\"></div>\n                            </div>\n                            <SpsFocusedTaskActions>\n                                <SpsButton kind=\"confirm\" onClick={onFormSubmit}>\n                                Submit\n                                </SpsButton>\n                            </SpsFocusedTaskActions>\n                            </SpsFocusedTask>\n                        </>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$H, templateObject_2$C;

var __read$D = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function getMember(controlSet, path) {
    var _a = __read$D(crumblePath(path)), name = _a[0], rest = _a.slice(1);
    return rest.length
        ? controlSet.members[name].get(rest)
        : controlSet.members[name];
}

var __assign$1k = (undefined && undefined.__assign) || function () {
    __assign$1k = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1k.apply(this, arguments);
};
var __read$C = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$2 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values$4 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function formArray(members, config) {
    if (members === void 0) { members = []; }
    if (config === void 0) { config = {}; }
    return __assign$1k(__assign$1k({ validators: [] }, config), { _type: "Array", members: __spreadArray$2([], __read$C(members), false), errors: null, invalid: false, isValid: function () {
            var t = this;
            return !t.invalid && t.members.every(function (member) { return member.isValid(); });
        }, isRequired: function () {
            var t = this;
            return t.validators && t.validators.indexOf(SpsValidators.required) > -1;
        }, hasError: function (errorKey) {
            var t = this;
            return t.errors && Object.prototype.hasOwnProperty.call(t.errors, errorKey);
        }, length: members.length, setInitValue: function (newValue) {
            var e_1, _a;
            try {
                for (var _b = __values$4(this.members.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read$C(_c.value, 2), i = _d[0], member = _d[1];
                    member.setInitValue(newValue[i]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return this;
        }, getValue: function () {
            return this.members.map(function (member) { return member.getValue(); });
        }, setValue: function (newValue) {
            var e_2, _a;
            if (newValue === void 0) { newValue = []; }
            try {
                for (var _b = __values$4(this.members.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read$C(_c.value, 2), i = _d[0], member = _d[1];
                    member.setValue(newValue[i]);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return this;
        }, update: function () {
            return this;
        }, isFocused: function () {
            return this.members.some(function (member) { return member.isFocused(); });
        }, focus: function () {
            var t = this;
            if (t.members.length) {
                t.members[0].focus();
            }
            return this;
        }, blur: function () {
            var e_3, _a;
            try {
                for (var _b = __values$4(this.members), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var member = _c.value;
                    member.blur();
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return this;
        }, isPristine: function () {
            return this.members.every(function (member) { return member.isPristine(); });
        }, markAsPristine: function () {
            var e_4, _a;
            try {
                for (var _b = __values$4(this.members), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var member = _c.value;
                    member.markAsPristine();
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return this;
        }, markAsDirty: function () {
            var e_5, _a;
            try {
                for (var _b = __values$4(this.members), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var member = _c.value;
                    member.markAsDirty();
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            return this;
        }, reset: function (value) {
            var e_6, _a;
            var t = this;
            t.members = __spreadArray$2([], __read$C(members), false);
            t.length = members.length;
            try {
                for (var _b = __values$4(t.members.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read$C(_c.value, 2), i = _d[0], member = _d[1];
                    if (value && i < value.length) {
                        member.reset(value[i]);
                    }
                    else {
                        member.reset();
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
            t.update();
            return this;
        }, get: function (path) {
            return getMember(this, path);
        }, at: function (index) {
            return this.members[index];
        }, push: function (control) {
            var t = this;
            t.members.push(control);
            t.length = t.members.length;
            t.update();
            return this;
        }, insert: function (index, control) {
            var t = this;
            t.members.splice(index, null, control);
            t.length = t.members.length;
            t.update();
            return this;
        }, removeAt: function (index) {
            var t = this;
            t.members.splice(index, 1);
            t.length = t.members.length;
            t.update();
            return this;
        }, setControl: function (index, control) {
            var t = this;
            t.members[index] = control;
            t.update();
            return this;
        } });
}

var __assign$1j = (undefined && undefined.__assign) || function () {
    __assign$1j = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1j.apply(this, arguments);
};
function formControl(initValue, config) {
    if (config === void 0) { config = {}; }
    return __assign$1j(__assign$1j({ validators: [], id: nanoid$1() }, config), { _type: "Control", initValue: initValue, setInitValue: function (newValue) {
            this.value = newValue;
            this.initValue = newValue;
            return this;
        }, value: initValue, getValue: function () {
            return this.value;
        }, setValue: function (newValue) {
            this.value = newValue;
            this.update();
            return this;
        }, errors: null, invalid: false, isValid: function () {
            return !this.invalid;
        }, hasError: function (errorKey) {
            return this.errors && Object.prototype.hasOwnProperty.call(this.errors, errorKey);
        }, focused: false, isFocused: function () {
            return this.focused;
        }, pristine: true, isPristine: function () {
            return this.pristine;
        }, isRequired: function () {
            return this.validators && this.validators.indexOf(SpsValidators.required) > -1;
        }, update: function () {
            return this;
        }, focus: function () {
            this.focused = true;
            this.update();
            if (this.onFocus) {
                this.onFocus();
            }
            return this;
        }, blur: function () {
            this.focused = false;
            this.update();
            if (this.onBlur) {
                this.onBlur();
            }
            return this;
        }, markAsPristine: function () {
            this.pristine = true;
            this.update();
            return this;
        }, markAsDirty: function () {
            this.pristine = false;
            this.update();
            return this;
        }, reset: function (value) {
            if (value === void 0) { value = this.initValue; }
            this.value = value;
            this.pristine = true;
            this.update();
            return this;
        } });
}

var __assign$1i = (undefined && undefined.__assign) || function () {
    __assign$1i = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1i.apply(this, arguments);
};
var __values$3 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function formGroup(members, config) {
    if (members === void 0) { members = {}; }
    if (config === void 0) { config = {}; }
    return __assign$1i(__assign$1i({ validators: [] }, config), { _type: "Group", members: __assign$1i({}, members), errors: null, invalid: false, isValid: function () {
            var _this = this;
            return !this.invalid
                && Object.keys(this.members).every(function (key) { return _this.members[key].isValid(); });
        }, hasError: function (errorKey) {
            return this.errors && Object.prototype.hasOwnProperty.call(this.errors, errorKey);
        }, setInitValue: function (newValue) {
            var e_1, _a;
            if (newValue === void 0) { newValue = {}; }
            try {
                for (var _b = __values$3(Object.keys(this.members)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this.members[key].setInitValue(newValue[key]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return this;
        }, getValue: function () {
            var _this = this;
            return Object.keys(this.members)
                .reduce(function (partial, key) {
                var _a;
                return Object.assign(partial, (_a = {},
                    _a[key] = _this.members[key].getValue(),
                    _a));
            }, {});
        }, setValue: function (newValue) {
            var e_2, _a;
            if (newValue === void 0) { newValue = {}; }
            try {
                for (var _b = __values$3(Object.keys(this.members)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this.members[key].setValue(newValue[key]);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return this;
        }, update: function () {
            return this;
        }, isFocused: function () {
            var _this = this;
            return Object.keys(this.members).some(function (key) { return _this.members[key].isFocused(); });
        }, focus: function () {
            var keys = Object.keys(this.members);
            if (keys.length) {
                this.members[keys[0]].focus();
            }
            return this;
        }, blur: function () {
            var e_3, _a;
            try {
                for (var _b = __values$3(Object.keys(this.members)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this.members[key].blur();
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return this;
        }, isPristine: function () {
            var _this = this;
            return Object.keys(this.members).every(function (key) { return _this.members[key].isPristine(); });
        }, markAsPristine: function () {
            var e_4, _a;
            try {
                for (var _b = __values$3(Object.keys(this.members)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this.members[key].markAsPristine();
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return this;
        }, markAsDirty: function () {
            var e_5, _a;
            try {
                for (var _b = __values$3(Object.keys(this.members)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this.members[key].markAsDirty();
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            return this;
        }, reset: function (value) {
            var e_6, _a;
            this.members = __assign$1i({}, members);
            try {
                for (var _b = __values$3(Object.keys(this.members)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    if (value && Object.prototype.hasOwnProperty.call(value, key)) {
                        this.members[key].reset(value[key]);
                    }
                    else {
                        this.members[key].reset();
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
            this.update();
            return this;
        }, get: function (path) {
            return getMember(this, path);
        }, addControl: function (name, control) {
            if (this.contains(name)) {
                throw new Error("Form group already contains a control called \"" + name + "\".");
            }
            this.members[name] = control;
            this.update();
            return this;
        }, removeControl: function (name) {
            delete this.members[name];
            this.update();
            return this;
        }, setControl: function (name, control) {
            this.members[name] = control;
            this.update();
            return this;
        }, contains: function (name) {
            return Object.keys(this.members).indexOf(name) > -1;
        } });
}

var __assign$1h = (undefined && undefined.__assign) || function () {
    __assign$1h = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1h.apply(this, arguments);
};
var __read$B = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values$2 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function useForm(controls, initValue) {
    if (initValue) {
        controls.setInitValue(initValue);
    }
    var _a = __read$B(useState(), 2), scheduledDispatch = _a[0], setScheduledDispatch = _a[1];
    var _b = __read$B(useState([]), 2), updatedPaths = _b[0], setUpdatedPaths = _b[1];
    var _c = __read$B(useReducer(function (state) {
        var e_1, _a, e_2, _b;
        try {
            for (var updatedPaths_1 = __values$2(updatedPaths), updatedPaths_1_1 = updatedPaths_1.next(); !updatedPaths_1_1.done; updatedPaths_1_1 = updatedPaths_1.next()) {
                var path = updatedPaths_1_1.value;
                try {
                    for (var _c = (e_2 = void 0, __values$2(traversePath(state, path))), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var object = _d.value;
                        if (object.validators && object.validators.length) {
                            object.errors = validate(object.getValue(), object.validators);
                            object.invalid = !!object.errors && !object.pristine;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (updatedPaths_1_1 && !updatedPaths_1_1.done && (_a = updatedPaths_1.return)) _a.call(updatedPaths_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        setScheduledDispatch(null);
        setUpdatedPaths([]);
        return __assign$1h({}, state);
    }, controls), 2), form = _c[0], dispatch = _c[1];
    forEachNestedObject(form, function (path, object) {
        /* eslint-disable-next-line no-underscore-dangle */
        if (object._type) {
            /* eslint-disable-next-line no-param-reassign */
            object.update = function update() {
                updatedPaths.push(path);
                setUpdatedPaths(updatedPaths);
                if (!scheduledDispatch) {
                    setScheduledDispatch(window.setTimeout(dispatch, 0));
                }
                return this;
            };
        }
    });
    return form;
}

var __read$A = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function useServerSideValidation(formControl, initialState) {
    if (initialState === void 0) { initialState = null; }
    var _a = __read$A(useState(initialState), 2), status = _a[0], setStatus = _a[1];
    var validatiorFn = useRef(function () { return null; });
    useEffect(function () {
        var newFn = function () { return status; };
        var index = formControl.validators.indexOf(validatiorFn.current);
        if (index === -1) {
            formControl.validators.push(newFn);
        }
        else {
            /* eslint-disable-next-line no-param-reassign */
            formControl.validators[index] = newFn;
        }
        formControl.update();
        validatiorFn.current = newFn;
    }, [status]);
    return [status, setStatus];
}

var __makeTemplateObject$G = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsFormExamples = {
    a_basic: {
        label: "Basic Usage",
        description: "",
        examples: {
            basic: {
                react: code(templateObject_1$G || (templateObject_1$G = __makeTemplateObject$G(["\n                    function DemoComponent() {\n                        const COLOR_OPTIONS = [\"red\", \"blue\", \"green\"];\n                        const initValue = {\n                            name: \"Foo\",\n                            color: COLOR_OPTIONS[0],\n                        };\n                        const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                            \"name\": value => value.color === COLOR_OPTIONS[0] ? [SpsValidators.required] : []\n                        });\n\n                        function handleSubmit() {\n                            console.log(\"submit\", formValue);\n                        }\n                        function reset() {\n                            updateForm(initValue);\n                        }\n\n                        return <>\n                            <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-8\">\n                                        <SpsLabel for={formMeta.fields.name}>Name</SpsLabel>\n                                        <SpsTextInput\n                                            value={formValue.name}\n                                            formMeta={formMeta.fields.name}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.color}>Color</SpsLabel>\n                                        {COLOR_OPTIONS.map(color =>\n                                            <SpsRadioButton key={color} name={color} value={color} label={color}\n                                                checked={color === formValue.color}\n                                                formMeta={formMeta.fields.color}\n                                            />\n                                        )}\n                                    </div>\n                                </div>\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-12\">\n                                        <SpsButton className=\"mr-1\" onClick={reset}>Reset</SpsButton>\n                                        <SpsButton type={ButtonType.SUBMIT} kind={ButtonKind.CONFIRM}>Submit</SpsButton>\n                                    </div>\n                                </div>\n                            </SpsForm>\n                            <br/>\n                            {JSON.stringify(formValue)}\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const COLOR_OPTIONS = [\"red\", \"blue\", \"green\"];\n                        const initValue = {\n                            name: \"Foo\",\n                            color: COLOR_OPTIONS[0],\n                        };\n                        const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                            \"name\": value => value.color === COLOR_OPTIONS[0] ? [SpsValidators.required] : []\n                        });\n\n                        function handleSubmit() {\n                            console.log(\"submit\", formValue);\n                        }\n                        function reset() {\n                            updateForm(initValue);\n                        }\n\n                        return <>\n                            <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-8\">\n                                        <SpsLabel for={formMeta.fields.name}>Name</SpsLabel>\n                                        <SpsTextInput\n                                            value={formValue.name}\n                                            formMeta={formMeta.fields.name}\n                                        />\n                                    </div>\n                                    <div className=\"sfg-col-4\">\n                                        <SpsLabel for={formMeta.fields.color}>Color</SpsLabel>\n                                        {COLOR_OPTIONS.map(color =>\n                                            <SpsRadioButton key={color} name={color} value={color} label={color}\n                                                checked={color === formValue.color}\n                                                formMeta={formMeta.fields.color}\n                                            />\n                                        )}\n                                    </div>\n                                </div>\n                                <div className=\"sfg-row\">\n                                    <div className=\"sfg-col-12\">\n                                        <SpsButton className=\"mr-1\" onClick={reset}>Reset</SpsButton>\n                                        <SpsButton type={ButtonType.SUBMIT} kind={ButtonKind.CONFIRM}>Submit</SpsButton>\n                                    </div>\n                                </div>\n                            </SpsForm>\n                            <br/>\n                            {JSON.stringify(formValue)}\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    b_array: {
        label: "Form Array",
        description: "",
        examples: {
            array: {
                react: code(templateObject_2$B || (templateObject_2$B = __makeTemplateObject$G(["\n                function DemoComponent() {\n                    const initValue = {\n                      itemList: [\"foo\"],\n                    }\n                    const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                      \"itemList.*\": [SpsValidators.required],\n                    })\n\n                    function handleSubmit() {\n                      console.log(\"submit\", formValue)\n                    }\n                    function reset() {\n                      updateForm(initValue)\n                    }\n\n                    function addItem() {\n                      updateForm({\n                        ...formValue,\n                        itemList: [...formValue.itemList, \"\"],\n                      })\n                    }\n                    function removeItem(index) {\n                      updateForm({\n                        ...formValue,\n                        itemList: formValue.itemList.filter((_, i) => index !== i),\n                      })\n                    }\n\n                    return (\n                      <>\n                        <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>\n                          {formValue.itemList.map((item, index) => (\n                            <div className=\"sfg-row\" key={index}>\n                              <div className=\"sfg-col-4\">\n                                <SpsLabel for={formMeta.fields.itemList.fields[index]}>\n                                  Item\n                                </SpsLabel>\n                                <SpsTextInput\n                                  value={item}\n                                  formMeta={formMeta.fields.itemList.fields[index]}\n                                />\n                              </div>\n                              <div className=\"sfg-col-1\">\n                                <SpsButton\n                                  kind={ButtonKind.ICON}\n                                  icon={SpsIcon.TRASH}\n                                  className=\"sps-label-spacing\"\n                                  onClick={() => removeItem(index)}\n                                />\n                              </div>\n                            </div>\n                          ))}\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton\n                                className=\"mr-1\"\n                                kind={ButtonKind.KEY}\n                                icon={SpsIcon.PLUS_SIGN}\n                                onClick={addItem}\n                              >\n                                Add Item\n                              </SpsButton>\n                              <SpsButton className=\"mr-1\" onClick={reset}>\n                                Reset\n                              </SpsButton>\n                              <SpsButton\n                                type={ButtonType.SUBMIT}\n                                kind={ButtonKind.CONFIRM}\n                              >\n                                Submit\n                              </SpsButton>\n                            </div>\n                          </div>\n                        </SpsForm>\n                        <br />\n                        {JSON.stringify(formValue)}\n                      </>\n                    )\n                  }\n                "], ["\n                function DemoComponent() {\n                    const initValue = {\n                      itemList: [\"foo\"],\n                    }\n                    const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                      \"itemList.*\": [SpsValidators.required],\n                    })\n\n                    function handleSubmit() {\n                      console.log(\"submit\", formValue)\n                    }\n                    function reset() {\n                      updateForm(initValue)\n                    }\n\n                    function addItem() {\n                      updateForm({\n                        ...formValue,\n                        itemList: [...formValue.itemList, \"\"],\n                      })\n                    }\n                    function removeItem(index) {\n                      updateForm({\n                        ...formValue,\n                        itemList: formValue.itemList.filter((_, i) => index !== i),\n                      })\n                    }\n\n                    return (\n                      <>\n                        <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>\n                          {formValue.itemList.map((item, index) => (\n                            <div className=\"sfg-row\" key={index}>\n                              <div className=\"sfg-col-4\">\n                                <SpsLabel for={formMeta.fields.itemList.fields[index]}>\n                                  Item\n                                </SpsLabel>\n                                <SpsTextInput\n                                  value={item}\n                                  formMeta={formMeta.fields.itemList.fields[index]}\n                                />\n                              </div>\n                              <div className=\"sfg-col-1\">\n                                <SpsButton\n                                  kind={ButtonKind.ICON}\n                                  icon={SpsIcon.TRASH}\n                                  className=\"sps-label-spacing\"\n                                  onClick={() => removeItem(index)}\n                                />\n                              </div>\n                            </div>\n                          ))}\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton\n                                className=\"mr-1\"\n                                kind={ButtonKind.KEY}\n                                icon={SpsIcon.PLUS_SIGN}\n                                onClick={addItem}\n                              >\n                                Add Item\n                              </SpsButton>\n                              <SpsButton className=\"mr-1\" onClick={reset}>\n                                Reset\n                              </SpsButton>\n                              <SpsButton\n                                type={ButtonType.SUBMIT}\n                                kind={ButtonKind.CONFIRM}\n                              >\n                                Submit\n                              </SpsButton>\n                            </div>\n                          </div>\n                        </SpsForm>\n                        <br />\n                        {JSON.stringify(formValue)}\n                      </>\n                    )\n                  }\n                "]))),
            },
        },
    },
    c_dynamic_group: {
        label: "Dynamic Group",
        description: "",
        examples: {
            basic: {
                react: code(templateObject_3$u || (templateObject_3$u = __makeTemplateObject$G(["\n                function DemoComponent() {\n                    const initValue = {\n                      name: \"Foo\",\n                    }\n                    const { formValue, formMeta, updateForm } = useSpsForm(initValue)\n\n                    function handleFieldsetToggle(enabled) {\n                      if (enabled) {\n                        updateForm({\n                          ...formValue,\n                          other_stuff: {\n                            tagline: \"\",\n                            description: \"\",\n                          },\n                        })\n                      } else {\n                        updateForm(omit(formValue, \"other_stuff\"))\n                      }\n                    }\n\n                    function handleSubmit() {\n                      console.log(\"submit\", formValue)\n                    }\n                    function reset() {\n                      updateForm(initValue)\n                    }\n\n                    return (\n                      <>\n                        <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-8\">\n                              <SpsLabel for={formMeta.fields.name}>Name</SpsLabel>\n                              <SpsTextInput\n                                value={formValue.name}\n                                formMeta={formMeta.fields.name}\n                              />\n                            </div>\n                            <div className=\"sfg-col-4\"></div>\n                          </div>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsFieldset\n                                optional\n                                enabled={formMeta.fields.other_stuff}\n                                formMeta={formMeta.fields.other_stuff}\n                                onToggled={handleFieldsetToggle}\n                                legend=\"Other Stuff\"\n                              >\n                                {formMeta.fields.other_stuff && (\n                                  <>\n                                    <div className=\"sfg-row\">\n                                      <div className=\"sfg-col-12\">\n                                        <SpsLabel\n                                          for={formMeta.fields.other_stuff.fields.tagline}\n                                        >\n                                          Tagline\n                                        </SpsLabel>\n                                        <SpsTextInput\n                                          value={formValue.other_stuff.tagline}\n                                          formMeta={formMeta.fields.other_stuff.fields.tagline}\n                                        />\n                                      </div>\n                                    </div>\n                                    <div className=\"sfg-row\">\n                                      <div className=\"sfg-col-12\">\n                                        <SpsLabel\n                                          for={formMeta.fields.other_stuff.fields.description}\n                                        >\n                                          Description\n                                        </SpsLabel>\n                                        <SpsTextInput\n                                          value={formValue.other_stuff.description}\n                                          formMeta={\n                                            formMeta.fields.other_stuff.fields.description\n                                          }\n                                        />\n                                      </div>\n                                    </div>\n                                  </>\n                                )}\n                              </SpsFieldset>\n                            </div>\n                          </div>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton className=\"mr-1\" onClick={reset}>\n                                Reset\n                              </SpsButton>\n                              <SpsButton\n                                type={ButtonType.SUBMIT}\n                                kind={ButtonKind.CONFIRM}\n                              >\n                                Submit\n                              </SpsButton>\n                            </div>\n                          </div>\n                        </SpsForm>\n                        <br />\n                        {JSON.stringify(formValue)}\n                      </>\n                    )\n                  }\n                "], ["\n                function DemoComponent() {\n                    const initValue = {\n                      name: \"Foo\",\n                    }\n                    const { formValue, formMeta, updateForm } = useSpsForm(initValue)\n\n                    function handleFieldsetToggle(enabled) {\n                      if (enabled) {\n                        updateForm({\n                          ...formValue,\n                          other_stuff: {\n                            tagline: \"\",\n                            description: \"\",\n                          },\n                        })\n                      } else {\n                        updateForm(omit(formValue, \"other_stuff\"))\n                      }\n                    }\n\n                    function handleSubmit() {\n                      console.log(\"submit\", formValue)\n                    }\n                    function reset() {\n                      updateForm(initValue)\n                    }\n\n                    return (\n                      <>\n                        <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-8\">\n                              <SpsLabel for={formMeta.fields.name}>Name</SpsLabel>\n                              <SpsTextInput\n                                value={formValue.name}\n                                formMeta={formMeta.fields.name}\n                              />\n                            </div>\n                            <div className=\"sfg-col-4\"></div>\n                          </div>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsFieldset\n                                optional\n                                enabled={formMeta.fields.other_stuff}\n                                formMeta={formMeta.fields.other_stuff}\n                                onToggled={handleFieldsetToggle}\n                                legend=\"Other Stuff\"\n                              >\n                                {formMeta.fields.other_stuff && (\n                                  <>\n                                    <div className=\"sfg-row\">\n                                      <div className=\"sfg-col-12\">\n                                        <SpsLabel\n                                          for={formMeta.fields.other_stuff.fields.tagline}\n                                        >\n                                          Tagline\n                                        </SpsLabel>\n                                        <SpsTextInput\n                                          value={formValue.other_stuff.tagline}\n                                          formMeta={formMeta.fields.other_stuff.fields.tagline}\n                                        />\n                                      </div>\n                                    </div>\n                                    <div className=\"sfg-row\">\n                                      <div className=\"sfg-col-12\">\n                                        <SpsLabel\n                                          for={formMeta.fields.other_stuff.fields.description}\n                                        >\n                                          Description\n                                        </SpsLabel>\n                                        <SpsTextInput\n                                          value={formValue.other_stuff.description}\n                                          formMeta={\n                                            formMeta.fields.other_stuff.fields.description\n                                          }\n                                        />\n                                      </div>\n                                    </div>\n                                  </>\n                                )}\n                              </SpsFieldset>\n                            </div>\n                          </div>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton className=\"mr-1\" onClick={reset}>\n                                Reset\n                              </SpsButton>\n                              <SpsButton\n                                type={ButtonType.SUBMIT}\n                                kind={ButtonKind.CONFIRM}\n                              >\n                                Submit\n                              </SpsButton>\n                            </div>\n                          </div>\n                        </SpsForm>\n                        <br />\n                        {JSON.stringify(formValue)}\n                      </>\n                    )\n                  }\n                "]))),
            },
        },
    },
    preventative_validators: {
        label: "Preventative validators",
        examples: {
            basic: {
                react: code(templateObject_4$n || (templateObject_4$n = __makeTemplateObject$G(["\n          function DemoComponent() {\n            const initValue = {\n                maxLength: \"\",\n                alpha: \"\",\n                numeric: \"\",\n                nonNumeric: \"\"\n            };\n\n            const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                \"maxLength\": [SpsValidators.maxLength(5)],\n                \"alpha\": [SpsValidators.alpha],\n                \"numeric\": [SpsValidators.numeric],\n                \"nonNumeric\": [SpsValidators.nonNumeric]\n            });\n          \n            function handleSubmit() {\n                console.log(\"submit\", formValue);\n            }\n\n            function reset() {\n                updateForm(initValue);\n                formMeta.markAsPristine();\n            }\n          \n            return <>\n                <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>                \n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.maxLength}\n                            >\n                              MaxLength\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.maxLength}\n                                formMeta={formMeta.fields.maxLength}\n                            />\n                        </div>\n                    </div>\n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.alpha}                        \n                            >\n                              Alpha\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.alpha}\n                                formMeta={formMeta.fields.alpha}\n                            />\n                        </div>\n                    </div>\n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.numeric}\n                            >\n                              Numeric\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.numeric}\n                                formMeta={formMeta.fields.numeric}\n                            />\n                        </div>\n                    </div>\n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.nonNumeric}\n                            >\n                              nonNumeric\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.nonNumeric}\n                                formMeta={formMeta.fields.nonNumeric}\n                            />\n                        </div>\n                    </div>\n          \n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-12\">\n                            <SpsButton className=\"mr-1\" onClick={reset}>Reset</SpsButton>\n                            <SpsButton type={ButtonType.SUBMIT} kind={ButtonKind.CONFIRM}>Submit</SpsButton>\n                        </div>\n                    </div>\n                </SpsForm>\n            </>;\n          }\n      "], ["\n          function DemoComponent() {\n            const initValue = {\n                maxLength: \"\",\n                alpha: \"\",\n                numeric: \"\",\n                nonNumeric: \"\"\n            };\n\n            const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                \"maxLength\": [SpsValidators.maxLength(5)],\n                \"alpha\": [SpsValidators.alpha],\n                \"numeric\": [SpsValidators.numeric],\n                \"nonNumeric\": [SpsValidators.nonNumeric]\n            });\n          \n            function handleSubmit() {\n                console.log(\"submit\", formValue);\n            }\n\n            function reset() {\n                updateForm(initValue);\n                formMeta.markAsPristine();\n            }\n          \n            return <>\n                <SpsForm formMeta={formMeta} onSubmit={handleSubmit}>                \n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.maxLength}\n                            >\n                              MaxLength\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.maxLength}\n                                formMeta={formMeta.fields.maxLength}\n                            />\n                        </div>\n                    </div>\n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.alpha}                        \n                            >\n                              Alpha\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.alpha}\n                                formMeta={formMeta.fields.alpha}\n                            />\n                        </div>\n                    </div>\n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.numeric}\n                            >\n                              Numeric\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.numeric}\n                                formMeta={formMeta.fields.numeric}\n                            />\n                        </div>\n                    </div>\n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.nonNumeric}\n                            >\n                              nonNumeric\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.nonNumeric}\n                                formMeta={formMeta.fields.nonNumeric}\n                            />\n                        </div>\n                    </div>\n          \n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-12\">\n                            <SpsButton className=\"mr-1\" onClick={reset}>Reset</SpsButton>\n                            <SpsButton type={ButtonType.SUBMIT} kind={ButtonKind.CONFIRM}>Submit</SpsButton>\n                        </div>\n                    </div>\n                </SpsForm>\n            </>;\n          }\n      "]))),
            },
            custom_text: {
                description: function () { return React.createElement("p", null, "Using custom text in the tooltip"); },
                react: code(templateObject_5$f || (templateObject_5$f = __makeTemplateObject$G(["\n          function DemoComponent() {\n            const initValue = {\n                maxLength: \"\"\n            };\n\n            const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                \"maxLength\": [SpsValidators.maxLength(5)]\n            });\n          \n            return <>\n                <SpsForm formMeta={formMeta} >                \n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.maxLength}\n                            errors={() => formMeta.fields.maxLength.hasPreventativeError(\"maxLength\")\n                              && \"This field accepts a maximum of 5 characters.\"}\n                            >\n                              MaxLength\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.maxLength}\n                                formMeta={formMeta.fields.maxLength}\n                            />\n                        </div>\n                    </div>\n                </SpsForm>\n            </>;\n          }\n      "], ["\n          function DemoComponent() {\n            const initValue = {\n                maxLength: \"\"\n            };\n\n            const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                \"maxLength\": [SpsValidators.maxLength(5)]\n            });\n          \n            return <>\n                <SpsForm formMeta={formMeta} >                \n                    <div className=\"sfg-row\">\n                        <div className=\"sfg-col-8\">\n                            <SpsLabel\n                            for={formMeta.fields.maxLength}\n                            errors={() => formMeta.fields.maxLength.hasPreventativeError(\"maxLength\")\n                              && \"This field accepts a maximum of 5 characters.\"}\n                            >\n                              MaxLength\n                            </SpsLabel>\n                            <SpsTextInput\n                                value={formValue.maxLength}\n                                formMeta={formMeta.fields.maxLength}\n                            />\n                        </div>\n                    </div>\n                </SpsForm>\n            </>;\n          }\n      "]))),
            },
        },
    },
};
var templateObject_1$G, templateObject_2$B, templateObject_3$u, templateObject_4$n, templateObject_5$f;

var __makeTemplateObject$F = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsAddRemoveFormRowExamples = {
    ideal: {
        label: "Ideal",
        examples: {
            ideal: {
                react: code(templateObject_1$F || (templateObject_1$F = __makeTemplateObject$F(["\n                function DemoComponent() {\n                    const initValue = {\n                      names: [\"Foo\"],\n                    }\n                    const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                      \"names.*\": [SpsValidators.required]\n                    });\n\n                    function addName() {\n                      updateForm({ names: [...formValue.names, \"\"] })\n                    }\n\n                    function removeName(index) {\n                      updateForm({\n                        names: formValue.names.filter((_, i) => i !== index),\n                      })\n                    }\n\n                    function reset() {\n                      updateForm(initValue)\n                    }\n\n                    return (\n                      <>\n                        <SpsForm formMeta={formMeta}>\n                          {formMeta.fields.names.fields.map((meta, i) => (\n                            <div className=\"sfg-row\" key={i}>\n                              <div className=\"sfg-col-6\">\n                                <SpsLabel for={meta}>Name</SpsLabel>\n                                <div className=\"d-flex align-items-center\">\n                                  <SpsTextInput\n                                    value={formValue.names[i]}\n                                    formMeta={meta}\n                                    className=\"flex-grow-1 mr-2\"\n                                  />\n                                  <SpsButton kind={ButtonKind.ICON}\n                                    icon={SpsIcon.X}\n                                    onClick={() => removeName(i)}\n                                  />\n                                </div>\n                              </div>\n                            </div>\n                          ))}\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton\n                                kind={ButtonKind.LINK}\n                                icon={SpsIcon.PLUS_SIGN}\n                                onClick={addName}\n                              >\n                                Add Another\n                              </SpsButton>\n                            </div>\n                          </div>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton onClick={reset}>Reset</SpsButton>\n                            </div>\n                          </div>\n                        </SpsForm>\n                        <br />\n                        {JSON.stringify(formValue)}\n                      </>\n                    )\n                  }\n                "], ["\n                function DemoComponent() {\n                    const initValue = {\n                      names: [\"Foo\"],\n                    }\n                    const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                      \"names.*\": [SpsValidators.required]\n                    });\n\n                    function addName() {\n                      updateForm({ names: [...formValue.names, \"\"] })\n                    }\n\n                    function removeName(index) {\n                      updateForm({\n                        names: formValue.names.filter((_, i) => i !== index),\n                      })\n                    }\n\n                    function reset() {\n                      updateForm(initValue)\n                    }\n\n                    return (\n                      <>\n                        <SpsForm formMeta={formMeta}>\n                          {formMeta.fields.names.fields.map((meta, i) => (\n                            <div className=\"sfg-row\" key={i}>\n                              <div className=\"sfg-col-6\">\n                                <SpsLabel for={meta}>Name</SpsLabel>\n                                <div className=\"d-flex align-items-center\">\n                                  <SpsTextInput\n                                    value={formValue.names[i]}\n                                    formMeta={meta}\n                                    className=\"flex-grow-1 mr-2\"\n                                  />\n                                  <SpsButton kind={ButtonKind.ICON}\n                                    icon={SpsIcon.X}\n                                    onClick={() => removeName(i)}\n                                  />\n                                </div>\n                              </div>\n                            </div>\n                          ))}\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton\n                                kind={ButtonKind.LINK}\n                                icon={SpsIcon.PLUS_SIGN}\n                                onClick={addName}\n                              >\n                                Add Another\n                              </SpsButton>\n                            </div>\n                          </div>\n                          <div className=\"sfg-row\">\n                            <div className=\"sfg-col-12\">\n                              <SpsButton onClick={reset}>Reset</SpsButton>\n                            </div>\n                          </div>\n                        </SpsForm>\n                        <br />\n                        {JSON.stringify(formValue)}\n                      </>\n                    )\n                  }\n                "]))),
            },
        },
    },
    alternate: {
        label: "Alternate",
        examples: {
            alternate: {
                react: code(templateObject_2$A || (templateObject_2$A = __makeTemplateObject$F(["\n              function DemoComponent() {\n                const initValue = {\n                  names: [\"Foo\"],\n                }\n                const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                  \"names.*\": [SpsValidators.required]\n                })\n\n                function addName() {\n                  updateForm({ names: [...formValue.names, \"\"] })\n                }\n\n                function removeName(index) {\n                  updateForm({\n                    names: formValue.names.filter((_, i) => i !== index),\n                  })\n                }\n\n                function reset() {\n                  updateForm(initValue)\n                }\n\n                return (\n                  <>\n                    <SpsForm formMeta={formMeta}>\n                      {formMeta.fields.names.fields.map((meta, i) => (\n                        <div className=\"sfg-row\" key={i}>\n                          <div className=\"sfg-col-6\">\n                            <SpsLabel for={meta}>Name</SpsLabel>\n                            <div className=\"d-flex align-items-center\">\n                              <SpsTextInput\n                                value={formValue.names[i]}\n                                formMeta={meta}\n                                className=\"flex-grow-1 mr-2\"\n                              />\n                              <SpsIconButtonPanel>\n                                <SpsButton\n                                  kind={ButtonKind.ICON}\n                                  icon={SpsIcon.X}\n                                  onClick={() => removeName(i)}\n                                  disabled={formMeta.fields.names.fields.length === 1}\n                                />\n                                <SpsButton\n                                  kind={ButtonKind.ICON}\n                                  icon={SpsIcon.PLUS_SIGN}\n                                  onClick={addName}\n                                  disabled={i < formMeta.fields.names.fields.length - 1}\n                                />\n                              </SpsIconButtonPanel>\n                            </div>\n                          </div>\n                        </div>\n                      ))}\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-12\">\n                          <SpsButton onClick={reset}>Reset</SpsButton>\n                        </div>\n                      </div>\n                    </SpsForm>\n                    <br />\n                    {JSON.stringify(formValue)}\n                  </>\n                )\n              }\n              "], ["\n              function DemoComponent() {\n                const initValue = {\n                  names: [\"Foo\"],\n                }\n                const { formValue, formMeta, updateForm } = useSpsForm(initValue, {\n                  \"names.*\": [SpsValidators.required]\n                })\n\n                function addName() {\n                  updateForm({ names: [...formValue.names, \"\"] })\n                }\n\n                function removeName(index) {\n                  updateForm({\n                    names: formValue.names.filter((_, i) => i !== index),\n                  })\n                }\n\n                function reset() {\n                  updateForm(initValue)\n                }\n\n                return (\n                  <>\n                    <SpsForm formMeta={formMeta}>\n                      {formMeta.fields.names.fields.map((meta, i) => (\n                        <div className=\"sfg-row\" key={i}>\n                          <div className=\"sfg-col-6\">\n                            <SpsLabel for={meta}>Name</SpsLabel>\n                            <div className=\"d-flex align-items-center\">\n                              <SpsTextInput\n                                value={formValue.names[i]}\n                                formMeta={meta}\n                                className=\"flex-grow-1 mr-2\"\n                              />\n                              <SpsIconButtonPanel>\n                                <SpsButton\n                                  kind={ButtonKind.ICON}\n                                  icon={SpsIcon.X}\n                                  onClick={() => removeName(i)}\n                                  disabled={formMeta.fields.names.fields.length === 1}\n                                />\n                                <SpsButton\n                                  kind={ButtonKind.ICON}\n                                  icon={SpsIcon.PLUS_SIGN}\n                                  onClick={addName}\n                                  disabled={i < formMeta.fields.names.fields.length - 1}\n                                />\n                              </SpsIconButtonPanel>\n                            </div>\n                          </div>\n                        </div>\n                      ))}\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-12\">\n                          <SpsButton onClick={reset}>Reset</SpsButton>\n                        </div>\n                      </div>\n                    </SpsForm>\n                    <br />\n                    {JSON.stringify(formValue)}\n                  </>\n                )\n              }\n              "]))),
            },
        },
    },
};
var templateObject_1$F, templateObject_2$A;

var __assign$1g = (undefined && undefined.__assign) || function () {
    __assign$1g = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1g.apply(this, arguments);
};
var __rest$12 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$z = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values$1 = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var propsDoc$18 = {
    imgSrc: "string",
    kind: "GrowlerKind",
    onClose: "() => void",
    persist: "boolean",
    title: "string",
};
var propTypes$1b = __assign$1g(__assign$1g({}, spsGlobalPropTypes), { imgSrc: propTypes$1H.exports.string, kind: enumValue(GrowlerKind), onClose: fun(), persist: propTypes$1H.exports.bool, title: propTypes$1H.exports.string });
function SpsGrowler(props) {
    var children = props.children, className = props.className, imgSrc = props.imgSrc, _a = props.kind, kind = _a === void 0 ? GrowlerKind.INFO : _a, onClose = props.onClose, persist = props.persist, title = props.title, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$12(props, ["children", "className", "imgSrc", "kind", "onClose", "persist", "title", "unsafelyReplaceClassName"]);
    var closeCallback = React.useRef(onClose);
    React.useEffect(function () {
        closeCallback.current = onClose;
    }, [onClose]);
    var t = React.useContext(I18nContext).t;
    var _b = __read$z(React.useState(true), 2), shown = _b[0], setShown = _b[1];
    var _c = __read$z(React.useState(false), 2), fade = _c[0], setFade = _c[1];
    function createTimers() {
        return [
            window.setTimeout(function () { return setFade(true); }, GROWLER_VISIBLE_DURATION_MS),
            window.setTimeout(function () {
                setShown(false);
                if (closeCallback.current) {
                    closeCallback.current();
                }
            }, GROWLER_VISIBLE_DURATION_MS + GROWLER_FADEOUT_DURATION_MS),
        ];
    }
    var timers = React.useRef([]);
    function startTimers() {
        if (!persist) {
            timers.current = createTimers();
        }
    }
    function clearTimers() {
        var e_1, _a;
        try {
            for (var _b = __values$1(timers.current), _c = _b.next(); !_c.done; _c = _b.next()) {
                var timer = _c.value;
                window.clearTimeout(timer);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        timers.current = [];
    }
    function cancelTimers() {
        clearTimers();
        setShown(true);
        setFade(false);
    }
    function close() {
        cancelTimers();
        setFade(false);
        setShown(false);
        if (onClose) {
            onClose();
        }
    }
    var iconOrSpinnerClass = kind === GrowlerKind.PROGRESS
        ? "sps-spinner"
        : clsx("sps-icon", "sps-icon-" + GrowlerIcon.get(kind));
    var classes = clsx(unsafelyReplaceClassName || "sps-growler", shown && "show", fade && "fade", "sps-growler--" + kind, className);
    React.useEffect(function () {
        startTimers();
        return function () {
            clearTimers();
        };
    }, []);
    var portal = usePortal("sps-growler-display-area", ["sps-growler-area", "z-stratum-dialog"]);
    return portal(React.createElement("div", __assign$1g({ role: "alert", className: classes, onMouseEnter: cancelTimers, onMouseLeave: startTimers }, rest),
        React.createElement("div", { className: "sps-growler__icon-box" },
            imgSrc && React.createElement("img", { src: imgSrc, alt: "" }),
            !imgSrc && React.createElement("i", { className: iconOrSpinnerClass, "aria-hidden": "true" })),
        React.createElement("div", { className: "sps-growler__message-box" },
            React.createElement("div", { className: "sps-growler__message-box-text" },
                title && React.createElement("span", { className: "sps-growler__message-box-title d-block" }, title),
                React.createElement("div", { className: "sps-growler__message-box-subtitle" }, children)),
            React.createElement("button", { type: "button", className: "sps-growler__close-button", "aria-hidden": "true", onClick: close },
                React.createElement("i", { className: "sps-icon sps-icon-x", title: t("design-system:growler.dismiss") })))));
}
Object.assign(SpsGrowler, {
    props: propsDoc$18,
    propTypes: propTypes$1b,
    displayName: "SpsGrowler",
});

var __makeTemplateObject$E = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsGrowlerExamples = {
    writingGuidelines: {
        label: "Writing Guidelines",
        customSection: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Use the following guidelines to write an effective Growler message."),
            React.createElement("ul", null,
                React.createElement("li", null,
                    "Write all messages in sentence case.",
                    React.createElement("ul", null,
                        React.createElement("li", null, "Capitalize the first word of the message."),
                        React.createElement("li", null, "Add punctuation, such as a period, at the end of the message."))),
                React.createElement("li", null, "Keep messages as succinct as possible while also providing sufficient information to the customer."),
                React.createElement("li", null, "If you can clearly convey your message in a single statement, use only the Primary Message."),
                React.createElement("li", null, "If the message requires additional details, such as further information or instructions, use both the Primary and Secondary Messages.")),
            React.createElement("p", null,
                "For more examples of effective feedback message writing, refer to",
                " ",
                React.createElement("a", { href: "https://atlassian.design/content/messaging-guidelines", target: "_blank", rel: "noreferrer" }, "Atlassian's Messaging Guidelines"),
                "."))); },
    },
    error: {
        label: "Error",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Acceptable message: Document ABC123 has not been sent. Check the form and try sending it again."),
            React.createElement("p", null, "Unacceptable message: Can't send your document.\""))); },
        examples: {
            primary: {
                description: "Primary Message Only",
                react: code(templateObject_1$E || (templateObject_1$E = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerError() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.ERROR}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Document ABC123 has not been sent.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerError() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.ERROR}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Document ABC123 has not been sent.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
            primaryAndSecondary: {
                description: "Primary and Secondary Messages",
                react: code(templateObject_2$z || (templateObject_2$z = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerError() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.ERROR}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Document ABC123 has not been sent.\"\n                                    >\n                                        Check the form and try sending it again.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerError() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.ERROR}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Document ABC123 has not been sent.\"\n                                    >\n                                        Check the form and try sending it again.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    information: {
        label: "Information",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Acceptable message: System maintenance notice. We'll be offline tonight from 9-11pm CST."),
            React.createElement("p", null, "Unacceptable message: No access tonight."))); },
        examples: {
            primary: {
                react: code(templateObject_3$t || (templateObject_3$t = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerInfo() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.INFO}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"System maintenance tonight from 9-11pm CST.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerInfo() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.INFO}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"System maintenance tonight from 9-11pm CST.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
            primaryAndSecondary: {
                react: code(templateObject_4$m || (templateObject_4$m = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerInfo() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.INFO}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"System maintenance notice\"\n                                    >\n                                        We'll be offline tonight from 9-11pm CST.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerInfo() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.INFO}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"System maintenance notice\"\n                                    >\n                                        We'll be offline tonight from 9-11pm CST.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    progress: {
        label: "Progress",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Acceptable message: Export in progress."),
            React.createElement("p", null, "Unacceptable message: Please wait."))); },
        examples: {
            primary: {
                description: "Primary Message Only",
                react: code(templateObject_5$e || (templateObject_5$e = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerProgress() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.PROGRESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Export in progress.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerProgress() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.PROGRESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Export in progress.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
            primaryAndSecondary: {
                description: "Primary and Secondary Messages",
                react: code(templateObject_6$b || (templateObject_6$b = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerProgress() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.PROGRESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Export in progress\"\n                                    >\n                                        We'll let you know when it's done.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerProgress() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.PROGRESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Export in progress\"\n                                    >\n                                        We'll let you know when it's done.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    success: {
        label: "Success",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Acceptable message: Message sent. Our support team will respond to your message within 24 hours."),
            React.createElement("p", null, "Unacceptable message: Submitted."))); },
        examples: {
            primary: {
                react: code(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerSuccess() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.SUCCESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Message sent.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerSuccess() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.SUCCESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Message sent.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
            primaryAndSecondary: {
                react: code(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerSuccess() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.SUCCESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Message sent.\"\n                                    >\n                                        Our support team will respond to your message within 24 hours.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerSuccess() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.SUCCESS}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"Message sent.\"\n                                    >\n                                        Our support team will respond to your message within 24 hours.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    warning: {
        label: "Warning",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Accpetable message: No internet connection detected."),
            React.createElement("p", null, "Unacceptable message: Warning: There is a problem."))); },
        examples: {
            primary: {
                description: "Primary Message Only",
                react: code(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerWarning() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.WARNING}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"No internet connection detected.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerWarning() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.WARNING}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"No internet connection detected.\"\n                                    />\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
            primaryAndSecondary: {
                react: code(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject$E(["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerWarning() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.WARNING}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"No internet connection detected\"\n                                    >\n                                        Check your connection and try again.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, SpsGrowler } from \"@spscommerce/ds-react\";\n                    import { ButtonKind, GrowlerKind } from \"@spscommerce/ds-shared\";\n\n                    function SpsGrowlerWarning() {\n                        const [growl, setGrowl] = React.useState(false);\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={() => setGrowl(true)} disabled={growl}>\n                                    Show Growler\n                                </SpsButton>\n                                {growl && (\n                                    <SpsGrowler\n                                        kind={GrowlerKind.WARNING}\n                                        onClose={() => {\n                                            console.log(\"Growler closed.\");\n                                            setGrowl(false);\n                                        }}\n                                        title=\"No internet connection detected\"\n                                    >\n                                        Check your connection and try again.\n                                    </SpsGrowler>\n                                )}\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    hook: {
        label: "Hooks",
        description: function () { return (React.createElement("p", null,
            "If you use the useGrowlers hook, you should ideally invoke it and place",
            " ",
            React.createElement("code", null, "growlers()"),
            " at the top level of your app, and pass down",
            " ",
            React.createElement("code", null, "createGrowler"),
            ".")); },
        examples: {
            hook: {
                react: code(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject$E(["\n                    import { SpsButton, useGrowlers } from \"@spscommerce/ds-react\";\n                    import { GrowlerKind } from \"@spscommerce/ds-shared\";\n                    function SpsGrowlerHook() {\n                        const [growlers, createGrowler] = useGrowlers();\n\n                        function handleButtonClick() {\n                            createGrowler({\n                                kind: \"success\",\n                                title: \"Success!\",\n                                content: () => (\n                                    <a href=\"#\" title=\"Content can also be a string.\">\n                                        Look, I can put JSX in here!\n                                    </a>\n                                ),\n                                onClose() {\n                                    console.log(\"Growler closed.\");\n                                },\n                            });\n                        }\n\n                        return (\n                            <>\n                                <SpsButton onClick={handleButtonClick}>Add a growler</SpsButton>\n                                {growlers()}\n                            </>\n                        );\n                    }\n                "], ["\n                    import { SpsButton, useGrowlers } from \"@spscommerce/ds-react\";\n                    import { GrowlerKind } from \"@spscommerce/ds-shared\";\n                    function SpsGrowlerHook() {\n                        const [growlers, createGrowler] = useGrowlers();\n\n                        function handleButtonClick() {\n                            createGrowler({\n                                kind: \"success\",\n                                title: \"Success!\",\n                                content: () => (\n                                    <a href=\"#\" title=\"Content can also be a string.\">\n                                        Look, I can put JSX in here!\n                                    </a>\n                                ),\n                                onClose() {\n                                    console.log(\"Growler closed.\");\n                                },\n                            });\n                        }\n\n                        return (\n                            <>\n                                <SpsButton onClick={handleButtonClick}>Add a growler</SpsButton>\n                                {growlers()}\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$E, templateObject_2$z, templateObject_3$t, templateObject_4$m, templateObject_5$e, templateObject_6$b, templateObject_7$9, templateObject_8$8, templateObject_9$5, templateObject_10$4, templateObject_11$4;

var __assign$1f = (undefined && undefined.__assign) || function () {
    __assign$1f = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1f.apply(this, arguments);
};
var __rest$11 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$y = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$17 = {
    disabled: "boolean",
    min: "number",
    max: "number",
    step: "number",
    onValueChange: "(newValue: number) => void",
};
var propTypes$1a = __assign$1f({ disabled: propTypes$1H.exports.bool, min: propTypes$1H.exports.number, max: propTypes$1H.exports.number, step: propTypes$1H.exports.number, onValueChange: fun() }, spsGlobalPropTypes);
function SpsIncrementor(props) {
    var disabled = props.disabled, min = props.min, max = props.max, _a = props.step, step = _a === void 0 ? 1 : _a, onValueChange = props.onValueChange, unsafelyReplaceClassName = props.unsafelyReplaceClassName, className = props.className, testId = props["data-testid"], rest = __rest$11(props, ["disabled", "min", "max", "step", "onValueChange", "unsafelyReplaceClassName", "className", "data-testid"]);
    var _b = __read$y(React.useState(min || 0), 2), value = _b[0], setValue = _b[1];
    var _c = __read$y(React.useState(false), 2), hasError = _c[0], setHasError = _c[1];
    React.useEffect(function () {
        if (onValueChange && typeof onValueChange === "function") {
            onValueChange(value);
        }
        if ((min && value >= min) || (max && value <= max)) {
            if (hasError) {
                setHasError(false);
            }
        }
        else if (min || max) {
            setHasError(true);
        }
    }, [value]);
    var minus = function () {
        if (value <= min) {
            return false;
        }
        if (value > max) {
            setValue(max);
        }
        else {
            setValue(function (v) { return v - step; });
        }
        return true;
    };
    var plus = function () {
        if (value >= max) {
            return false;
        }
        if (value < min) {
            setValue(min);
        }
        else {
            setValue(function (v) { return v + step; });
        }
        return true;
    };
    var onInputChange = function (e) {
        if (e.target.value !== "") {
            setValue(parseInt(e.target.value, 10));
        }
    };
    var classes = unsafelyReplaceClassName
        || clsx("sps-incrementor sps-input-group sps-input-group__append", className);
    return (React.createElement("div", __assign$1f({ className: classes }, rest, { "data-testid": testId }),
        React.createElement("div", { className: "sps-button sps-button--icon" },
            React.createElement("button", { type: "button", "data-testid": testId + "__minus", onClick: minus, disabled: disabled, "aria-label": "Subtract " + step },
                React.createElement("i", { className: "sps-icon sps-icon-minus", "aria-hidden": "true" }))),
        React.createElement("div", { className: "sps-text-input" },
            React.createElement("input", { type: "text", className: clsx("sps-form-control", hasError && "sps-input--error"), value: value, onChange: onInputChange, disabled: disabled, "data-testid": testId + "__input" })),
        React.createElement("div", { className: "sps-button sps-button--icon" },
            React.createElement("button", { type: "button", "data-testid": testId + "__plus", onClick: plus, disabled: disabled, "aria-label": "Add " + step },
                React.createElement("i", { className: "sps-icon sps-icon-plus-sign", "aria-hidden": "true" })))));
}
Object.assign(SpsIncrementor, {
    props: propsDoc$17,
    propTypes: propTypes$1a,
    displayName: "SpsIncrementor",
});

var __makeTemplateObject$D = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsIncrementorExamples = {
    stepExample: {
        label: "Incrementor",
        description: "info about incrementor",
        examples: {
            stacked: {
                react: code(templateObject_1$D || (templateObject_1$D = __makeTemplateObject$D(["\n                    function Component () {\n                        const [value, setValue] = React.useState(\"\");\n                        const handleChange = val => {\n                            setValue(val);\n                        };\n                        return (\n                            <React.Fragment>\n                                <SpsIncrementor\n                                    min={0}\n                                    max={10}\n                                    step={2}\n                                    id=\"basicIncrementor\"\n                                    onValueChange={handleChange}\n                                />\n                                    Value: {value}\n                            </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component () {\n                        const [value, setValue] = React.useState(\"\");\n                        const handleChange = val => {\n                            setValue(val);\n                        };\n                        return (\n                            <React.Fragment>\n                                <SpsIncrementor\n                                    min={0}\n                                    max={10}\n                                    step={2}\n                                    id=\"basicIncrementor\"\n                                    onValueChange={handleChange}\n                                />\n                                    Value: {value}\n                            </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$D;

var __assign$1e = (undefined && undefined.__assign) || function () {
    __assign$1e = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1e.apply(this, arguments);
};
__assign$1e({}, spsGlobalPropTypes);
function SpsInsights(props) {
    var children = props.children;
    return React.createElement("div", { className: "insight-tile-wrapper" }, children);
}

var __assign$1d = (undefined && undefined.__assign) || function () {
    __assign$1d = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1d.apply(this, arguments);
};
var __rest$10 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$x = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$16 = {
    horizontal: "boolean",
    icon: "SpsIcon",
    kind: "SpsInsightTileKind",
    title: "string",
    metric: "number | string",
    partnerCount: "number",
    totalPartners: "number",
};
var propTypes$19 = __assign$1d(__assign$1d({}, spsGlobalPropTypes), { horizontal: propTypes$1H.exports.bool, icon: enumValue(SpsIcon), kind: enumValue(SpsInsightTileKind), title: propTypes$1H.exports.string, metric: propTypes$1H.exports.number || propTypes$1H.exports.string, partnerCount: propTypes$1H.exports.number, totalPartners: propTypes$1H.exports.number });
function SpsInsightTile(props) {
    var children = props.children, className = props.className, _a = props.horizontal, horizontal = _a === void 0 ? false : _a, icon = props.icon, _b = props.kind, kind = _b === void 0 ? "general" : _b, title = props.title, metric = props.metric, partnerCount = props.partnerCount, totalPartners = props.totalPartners, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$10(props, ["children", "className", "horizontal", "icon", "kind", "title", "metric", "partnerCount", "totalPartners", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-insight-tile", "sps-insight-tile--" + kind, className, horizontal && "sps-insight-tile--horizontal", children && "sps-insight-tile--has-detail");
    var t = React.useContext(I18nContext).t;
    var _c = __read$x((partnerCount
        ? t("design-system:insightTile.partnerCount", {
            count: partnerCount,
            total: totalPartners,
        })
        : "").split("|"), 3), count = _c[0], ofText = _c[1], total = _c[2];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", __assign$1d({ className: classes }, rest),
            React.createElement("div", { className: "sps-insight-tile__body" },
                icon ? (React.createElement("i", { className: "sps-icon sps-icon-" + icon })) : (React.createElement("i", { className: "sps-icon sps-icon-" + SpsInsightTileIcons[kind] })),
                metric && React.createElement("div", { className: "sps-insight-tile__metric-count" }, metric),
                title && (React.createElement("div", { className: "sps-insight-tile__description" },
                    React.createElement("div", { className: "sps-insight-tile__title", 
                        /*
                         * Both Chrome & FF ignore -webkit-box-orient
                         * in the actual CSS for some reason
                         * Also the TS types don't think -webkit-box-orient
                         * is a real CSS property
                         */
                        style: { "-webkit-box-orient": "vertical" } }, title),
                    React.createElement("div", { className: "sps-insight-tile__detail" }, children)))),
            partnerCount && (React.createElement("div", { className: "sps-insight-tile__partner-count" },
                partnerCount === totalPartners ? (React.createElement("div", null, t("design-system:insightTile.all"))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, count),
                    React.createElement("div", null, ofText),
                    React.createElement("div", null, total))),
                React.createElement("div", { className: "sps-insight-tile__partners-text" }, t("design-system:insightTile.partners")))))));
}
Object.assign(SpsInsightTile, {
    props: propsDoc$16,
    propTypes: propTypes$19,
    displayName: "SpsInsightTile",
});

var __makeTemplateObject$C = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsInsightTileExamples = {
    basic: {
        label: "Basic Insight Tiles",
        examples: {
            basic: {
                jsx: code(templateObject_1$C || (templateObject_1$C = __makeTemplateObject$C(["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                    </SpsInsights>\n                "], ["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        />\n                    </SpsInsights>\n                "]))),
            },
        },
    },
    details: {
        label: "With Details",
        examples: {
            details: {
                jsx: code(templateObject_2$y || (templateObject_2$y = __makeTemplateObject$C(["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                    </SpsInsights>\n                "], ["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                    </SpsInsights>\n                "]))),
            },
        },
    },
    partnerCount: {
        label: "Partner Count",
        examples: {
            partnerCount: {
                jsx: code(templateObject_3$s || (templateObject_3$s = __makeTemplateObject$C(["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"250\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"122\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"207\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"12\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"94\"\n                            totalPartners=\"250\"\n                        />\n                    </SpsInsights>\n                "], ["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"250\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"122\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"207\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"12\"\n                            totalPartners=\"250\"\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"94\"\n                            totalPartners=\"250\"\n                        />\n                    </SpsInsights>\n                "]))),
            },
        },
    },
    clickHandler: {
        label: "Adding a click handler",
        examples: {
            clickHandler: {
                jsx: code(templateObject_4$l || (templateObject_4$l = __makeTemplateObject$C(["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            onClick={() => console.log(\"insight tile 1 clicked!\")}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            onClick={() => console.log(\"insight tile 2 clicked!\")}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            onClick={() => console.log(\"insight tile 3 clicked!\")}\n                        />\n                    </SpsInsights>\n                "], ["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            onClick={() => console.log(\"insight tile 1 clicked!\")}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            onClick={() => console.log(\"insight tile 2 clicked!\")}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            onClick={() => console.log(\"insight tile 3 clicked!\")}\n                        />\n                    </SpsInsights>\n                "]))),
            },
        },
    },
    alternateIcons: {
        label: "Using alternate icons",
        examples: {
            alternateIcons: {
                jsx: code(templateObject_5$d || (templateObject_5$d = __makeTemplateObject$C(["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.USER}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.ASTERISK}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.DOLLAR_SIGN}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.FOLDER_OPEN}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.BAN}\n                        />\n                    </SpsInsights>\n                "], ["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.USER}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.ASTERISK}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.DOLLAR_SIGN}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.FOLDER_OPEN}\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            icon={SpsIcon.BAN}\n                        />\n                    </SpsInsights>\n                "]))),
            },
        },
    },
    horizontal: {
        label: "Horizontal",
        examples: {
            horizontal: {
                jsx: code(templateObject_6$a || (templateObject_6$a = __makeTemplateObject$C(["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                    </SpsInsights>\n                "], ["\n                    <SpsInsights>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.GENERAL}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.PROCESSING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.SUCCESS}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.WARNING}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        />\n                        <SpsInsightTile\n                            kind={SpsInsightCardKind.ERROR}\n                            metric=\"1234\"\n                            title=\"Insight Tile Title\"\n                            partnerCount=\"100\"\n                            totalPartners=\"200\"\n                            horizontal\n                        >\n                            <span className=\"gray600 font-weight-bold\">Detail:</span> 792 units\n                        </SpsInsightTile>\n                    </SpsInsights>\n                "]))),
            },
        },
    },
};
var templateObject_1$C, templateObject_2$y, templateObject_3$s, templateObject_4$l, templateObject_5$d, templateObject_6$a;

var __assign$1c = (undefined && undefined.__assign) || function () {
    __assign$1c = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1c.apply(this, arguments);
};
var __rest$$ = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$15 = {
    inline: "boolean",
};
var propTypes$18 = __assign$1c(__assign$1c({}, spsGlobalPropTypes), { inline: propTypes$1H.exports.bool });
function SpsKeyValueList(props) {
    var children = props.children, className = props.className, inline = props.inline, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$$(props, ["children", "className", "inline", "data-testid", "unsafelyReplaceClassName"]);
    var keyValueListClass = clsx(unsafelyReplaceClassName || "sps-key-value-list", inline && "sps-key-value-list--inline", className);
    return (React.createElement("div", __assign$1c({ className: keyValueListClass, "data-testid": "" + testId }, rest), children));
}
Object.assign(SpsKeyValueList, {
    props: propsDoc$15,
    propTypes: propTypes$18,
    displayName: "SpsKeyValueList",
});

var __assign$1b = (undefined && undefined.__assign) || function () {
    __assign$1b = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1b.apply(this, arguments);
};
var __rest$_ = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$14 = {
    itemKey: { type: "string | nodeOrRenderFn", required: true },
    titleColor: "KeyValueListTitleColor",
};
var propTypes$17 = __assign$1b(__assign$1b({}, spsGlobalPropTypes), { itemKey: propTypes$1H.exports.string.isRequired || nodeOrRenderFn.isRequired, titleColor: enumValue(KeyValueListTitleColor) });
function SpsKeyValueListItem(props) {
    var children = props.children, className = props.className, itemKey = props.itemKey, _a = props.titleColor, titleColor = _a === void 0 ? KeyValueListTitleColor.LIGHT : _a, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$_(props, ["children", "className", "itemKey", "titleColor", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-key-value-list__item", "sps-key-value-list__item--" + titleColor, className);
    return (React.createElement("div", __assign$1b({ className: classes, "data-testid": "" + testId }, rest),
        React.createElement("span", { className: "sps-key-value-list__key", "data-testid": testId + "__key" }, itemKey),
        React.createElement("span", { className: "sps-key-value-list__value", "data-testid": testId + "__value" }, children)));
}
Object.assign(SpsKeyValueListItem, {
    props: propsDoc$14,
    propTypes: propTypes$17,
    displayName: "SpsKeyValueListItem",
});

var __makeTemplateObject$B = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsKeyValueListExamples = {
    stacked: {
        label: "Stacked",
        examples: {
            stacked: {
                jsx: code(templateObject_1$B || (templateObject_1$B = __makeTemplateObject$B(["\n                    <SpsKeyValueList>\n                        <SpsKeyValueListItem itemKey=\"Buying From\">\n                            75 Companies\n                            <span className=\"font-weight-light d-block\">38 of 75 Operational</span>\n                        </SpsKeyValueListItem>\n                        <SpsKeyValueListItem itemKey=\"Some Other Key\">Its Value</SpsKeyValueListItem>\n                    </SpsKeyValueList>\n                "], ["\n                    <SpsKeyValueList>\n                        <SpsKeyValueListItem itemKey=\"Buying From\">\n                            75 Companies\n                            <span className=\"font-weight-light d-block\">38 of 75 Operational</span>\n                        </SpsKeyValueListItem>\n                        <SpsKeyValueListItem itemKey=\"Some Other Key\">Its Value</SpsKeyValueListItem>\n                    </SpsKeyValueList>\n                "]))),
            },
        },
    },
    inline: {
        label: "Inline",
        examples: {
            inline: {
                jsx: code(templateObject_2$x || (templateObject_2$x = __makeTemplateObject$B(["\n                    <SpsKeyValueList inline>\n                        <SpsKeyValueListItem itemKey=\"Title\">Sub copy goes here</SpsKeyValueListItem>\n                        <SpsKeyValueListItem itemKey=\"Long Title\">Sub copy</SpsKeyValueListItem>\n                        <SpsKeyValueListItem itemKey=\"Tags\">\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Tag</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Another Tag</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Taggart McTaggerson</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Taggle Rock</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">A Tag On Titan</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">br\u00F6ther may i have some t\u00E4gs</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Tag Me Up, Tag Me Down</SpsTag>\n                        </SpsKeyValueListItem>\n                    </SpsKeyValueList>\n                "], ["\n                    <SpsKeyValueList inline>\n                        <SpsKeyValueListItem itemKey=\"Title\">Sub copy goes here</SpsKeyValueListItem>\n                        <SpsKeyValueListItem itemKey=\"Long Title\">Sub copy</SpsKeyValueListItem>\n                        <SpsKeyValueListItem itemKey=\"Tags\">\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Tag</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Another Tag</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Taggart McTaggerson</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Taggle Rock</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">A Tag On Titan</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">br\u00F6ther may i have some t\u00E4gs</SpsTag>\n                            <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">Tag Me Up, Tag Me Down</SpsTag>\n                        </SpsKeyValueListItem>\n                    </SpsKeyValueList>\n                "]))),
            },
        },
    },
};
var templateObject_1$B, templateObject_2$x;

var __assign$1a = (undefined && undefined.__assign) || function () {
    __assign$1a = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1a.apply(this, arguments);
};
var __rest$Z = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$w = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var propsDoc$13 = {
    for: { type: "SpsFormMetaBase<any>", required: true },
    description: "string",
    stronglySuggested: "boolean",
    help: "ReactNodeOrRenderFn",
    helpIcon: "SpsIcon",
    helpIconColor: "string",
    errors: "ReactNodeOrRenderFn",
};
var propTypes$16 = __assign$1a(__assign$1a({}, spsGlobalPropTypes), { description: propTypes$1H.exports.string, for: propTypes$1H.exports.oneOfType([
        impl(), impl(),
    ]).isRequired, stronglySuggested: propTypes$1H.exports.bool, help: nodeOrRenderFn, helpIcon: enumValue(SpsIcon), helpIconColor: propTypes$1H.exports.string, errors: nodeOrRenderFn });
function SpsLabel(_a) {
    var children = _a.children, className = _a.className, description = _a.description, forProp = _a.for, stronglySuggested = _a.stronglySuggested, help = _a.help, _b = _a.helpIcon, helpIcon = _b === void 0 ? SpsIcon.QUESTION_CIRCLE : _b, _c = _a.helpIconColor, helpIconColor = _c === void 0 ? "blue200" : _c, errors = _a.errors, unsafelyReplaceClassName = _a.unsafelyReplaceClassName, testId = _a["data-testid"], rest = __rest$Z(_a, ["children", "className", "description", "for", "stronglySuggested", "help", "helpIcon", "helpIconColor", "errors", "unsafelyReplaceClassName", "data-testid"]);
    var t = React.useContext(I18nContext).t;
    var errorIcon = React.useRef();
    var suggestedIcon = React.useRef();
    var helpIconRef = React.useRef();
    var labelRef = React.useRef();
    var _d = __read$w(React.useState(TooltipVisibility.HIDDEN), 2), showHelpTip = _d[0], setShowHelpTip = _d[1];
    var _e = __read$w(React.useState(TooltipVisibility.HIDDEN), 2), showErrorTip = _e[0], setShowErrorTip = _e[1];
    var _f = __read$w(React.useState(TooltipVisibility.HIDDEN), 2), showSuggestedTip = _f[0], setShowSuggestedTip = _f[1];
    var _g = __read$w(React.useState(TooltipVisibility.HIDDEN), 2), showPreventativeErrorTip = _g[0], setShowPreventativeErrorTip = _g[1];
    function hideTooltips() {
        setShowHelpTip(TooltipVisibility.HIDDEN);
        setShowErrorTip(TooltipVisibility.HIDDEN);
        setShowSuggestedTip(TooltipVisibility.HIDDEN);
        setShowPreventativeErrorTip(TooltipVisibility.HIDDEN);
    }
    function delayedHideTooltips() {
        setShowHelpTip(TooltipVisibility.DELAYED_HIDDEN);
        setShowErrorTip(TooltipVisibility.DELAYED_HIDDEN);
        setShowSuggestedTip(TooltipVisibility.DELAYED_HIDDEN);
    }
    function handleSuggestedIconClick(event) {
        event.preventDefault();
        hideTooltips();
        setShowSuggestedTip(toggleTooltipState(showSuggestedTip));
    }
    function getPriorityTooltip() {
        if (forProp && ((forProp instanceof SpsFormMetaBase && forProp.isVisibilyInvalid())
            || (!(forProp instanceof SpsFormMetaBase) && !forProp.isValid()))) {
            return [showErrorTip, setShowErrorTip];
        }
        if (forProp && ((forProp instanceof SpsFormMetaBase && forProp.hasPreventativeErrors()))) {
            return [showPreventativeErrorTip, setShowPreventativeErrorTip];
        }
        if (help) {
            return [showHelpTip, setShowHelpTip];
        }
        if (stronglySuggested) {
            return [showSuggestedTip, setShowSuggestedTip];
        }
        return [TooltipVisibility.HIDDEN, function () { }];
    }
    function handleLabelClick() {
        hideTooltips();
        var _a = __read$w(getPriorityTooltip(), 2), showPriorityTooltip = _a[0], setShowPriorityTooltip = _a[1];
        setShowPriorityTooltip(toggleTooltipState(showPriorityTooltip));
    }
    function doShowPriorityTooltip() {
        hideTooltips();
        var _a = __read$w(getPriorityTooltip(), 2), setShowPriorityTooltip = _a[1];
        setShowPriorityTooltip(TooltipVisibility.VISIBLE);
    }
    function handleHelpClick() {
        hideTooltips();
        setShowHelpTip(toggleTooltipState(showHelpTip));
    }
    React.useEffect(function () {
        if (forProp) {
            /* eslint-disable no-param-reassign */
            forProp.onFocus = doShowPriorityTooltip;
            forProp.onBlur = hideTooltips;
            /* eslint-enable no-param-reassign */
        }
    }, [forProp]);
    var classes = clsx(unsafelyReplaceClassName || "sps-form-group__label", className);
    var _h = __read$w(forProp instanceof SpsFormMetaBase
        ? [forProp, undefined]
        : [undefined, forProp], 2), formMeta = _h[0], formControl = _h[1];
    function builtinValidationErrors() {
        var e_1, _a;
        if (formMeta) {
            try {
                for (var _b = __values([
                    "dateFormat",
                    "dateRangeOrder",
                    "dateValidity",
                    "required",
                ]), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var errType = _c.value;
                    if (formMeta.hasError(errType)) {
                        return t("design-system:label.errors." + errType, { context: formMeta.errors[errType] });
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (formMeta.hasError("dateConstraint")) {
                var errorMetadata = formMeta.errors.dateConstraint;
                var whichExceeded = errorMetadata.minExceeded
                    ? "min"
                    : "max";
                return t("design-system:label.errors.dateConstraint." + whichExceeded, { context: formMeta.errors.dateConstraint });
            }
        }
        return null;
    }
    function builtinPreventativeErrors() {
        var e_2, _a;
        if (formMeta) {
            try {
                for (var PreventativeErrorKeys_1 = __values(PreventativeErrorKeys), PreventativeErrorKeys_1_1 = PreventativeErrorKeys_1.next(); !PreventativeErrorKeys_1_1.done; PreventativeErrorKeys_1_1 = PreventativeErrorKeys_1.next()) {
                    var errType = PreventativeErrorKeys_1_1.value;
                    if (formMeta.hasPreventativeError(errType)) {
                        return t("design-system:label.preventativeErrors." + errType);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (PreventativeErrorKeys_1_1 && !PreventativeErrorKeys_1_1.done && (_a = PreventativeErrorKeys_1.return)) _a.call(PreventativeErrorKeys_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return null;
    }
    React.useEffect(function () {
        if (formMeta === null || formMeta === void 0 ? void 0 : formMeta.hasPreventativeErrors()) {
            setShowPreventativeErrorTip(TooltipVisibility.VISIBLE);
        }
    }, [formMeta === null || formMeta === void 0 ? void 0 : formMeta.hasPreventativeErrors()]);
    return (React.createElement(SpsFormComponentWrapper, { formMeta: formMeta, formControl: formControl },
        React.createElement("label", __assign$1a({ htmlFor: forProp && "id" in forProp ? forProp.id : undefined, className: classes, "data-testid": testId }, rest),
            React.createElement("i", { ref: suggestedIcon, "data-testid": testId + "__suggested-icon", className: clsx("sps-icon", "sps-icon-exclamation-triangle", "orange200", "sps-form-group__label-suggested-icon", !stronglySuggested && "d-none"), onClick: handleSuggestedIconClick, onMouseEnter: function () {
                    hideTooltips();
                    setShowSuggestedTip(TooltipVisibility.VISIBLE);
                }, onMouseLeave: delayedHideTooltips }),
            React.createElement("i", { ref: errorIcon, "data-testid": testId + "__error-icon", className: clsx("sps-icon", "sps-icon-exclamation-circle", "sps-form-group__label--error-icon"), onClick: handleLabelClick, onMouseEnter: doShowPriorityTooltip, onMouseLeave: delayedHideTooltips }),
            React.createElement("span", { ref: labelRef, className: "sps-form-group__label-content" }, children),
            React.createElement("i", { ref: helpIconRef, "data-testid": testId + "__help-icon", className: clsx("sps-icon", "sps-icon-" + helpIcon, helpIconColor, !help && "d-none"), onClick: handleHelpClick, onMouseEnter: function () {
                    hideTooltips();
                    setShowHelpTip(TooltipVisibility.VISIBLE);
                }, onMouseLeave: delayedHideTooltips })),
        React.createElement(SpsTooltip, { kind: TooltipKind.DEFAULT, for: helpIconRef, showOn: TooltipShowTrigger.MANUAL, isShown: showHelpTip, altPosition: Position.TOP_MIDDLE }, contentOf(help)),
        React.createElement(SpsTooltip, { kind: TooltipKind.ERROR, for: errorIcon, showOn: TooltipShowTrigger.MANUAL, isShown: showErrorTip, altPosition: Position.LEFT_MIDDLE }, contentOf(errors) || builtinValidationErrors()),
        (formMeta === null || formMeta === void 0 ? void 0 : formMeta.hasPreventativeErrors()) && React.createElement(SpsTooltip, { kind: TooltipKind.WARNING, for: labelRef, showOn: TooltipShowTrigger.MANUAL, isShown: showPreventativeErrorTip, altPosition: Position.LEFT_MIDDLE }, contentOf(errors) || builtinPreventativeErrors()),
        React.createElement(SpsTooltip, { kind: TooltipKind.DEFAULT, for: suggestedIcon, position: Position.TOP_LEFT, altPosition: Position.TOP_LEFT, offsets: [13, 20], showOn: TooltipShowTrigger.MANUAL, isShown: showSuggestedTip }, t("design-system:label.stronglySuggested")),
        description && (React.createElement("div", { className: "sps-form-control__description", "data-testid": testId + "__description" }, description))));
}
Object.assign(SpsLabel, {
    props: propsDoc$13,
    propTypes: propTypes$16,
    displayName: "SpsLabel",
});

var __makeTemplateObject$A = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsLabelExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$A || (templateObject_1$A = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}>\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput value={formValue.companyName}\n                                formMeta={formMeta.fields.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}>\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput value={formValue.companyName}\n                                formMeta={formMeta.fields.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    b_suggested: {
        label: "Strongly Suggested",
        examples: {
            basic: {
                react: code(templateObject_2$w || (templateObject_2$w = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName} stronglySuggested>\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput value={formValue.companyName}\n                                formMeta={formMeta.fields.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName} stronglySuggested>\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput value={formValue.companyName}\n                                formMeta={formMeta.fields.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    c_required: {
        label: "Required",
        examples: {
            basic: {
                react: code(templateObject_3$r || (templateObject_3$r = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        }, {\n                            \"companyName\": [SpsValidators.required]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                errors={() => formMeta.fields.companyName.hasError(\"required\")\n                                    && \"Please enter a company name.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        }, {\n                            \"companyName\": [SpsValidators.required]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                errors={() => formMeta.fields.companyName.hasError(\"required\")\n                                    && \"Please enter a company name.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    d_help: {
        label: "Help Information",
        examples: {
            a_defaultIcon: {
                description: "<p>Default icon</p>",
                react: code(templateObject_4$k || (templateObject_4$k = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                help=\"Pretend there's something helpful written here.\"\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                help=\"Pretend there's something helpful written here.\"\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
            b_customIcon: {
                description: "<p>Custom icon</p>",
                react: code(templateObject_5$c || (templateObject_5$c = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                help=\"Pretend there's something helpful written here.\"\n                                helpIcon={SpsIcon.EXCHANGE} helpIconColor=\"red200\"\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                help=\"Pretend there's something helpful written here.\"\n                                helpIcon={SpsIcon.EXCHANGE} helpIconColor=\"red200\"\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    e_validation: {
        label: "Validation",
        examples: {
            basic: {
                react: code(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"Target\"\n                        }, {\n                            \"companyName\": [SpsValidators.minLength(7)]\n                        });\n\n                        React.useEffect(() => {\n                            // Make validation error visible for the purpose of this demo\n                            formMeta.markAsDirty();\n                        }, []);\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                errors={() => formMeta.fields.companyName.hasError(\"minLength\")\n                                    && \"Company Name must be at least 7 characters.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"Target\"\n                        }, {\n                            \"companyName\": [SpsValidators.minLength(7)]\n                        });\n\n                        React.useEffect(() => {\n                            // Make validation error visible for the purpose of this demo\n                            formMeta.markAsDirty();\n                        }, []);\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                errors={() => formMeta.fields.companyName.hasError(\"minLength\")\n                                    && \"Company Name must be at least 7 characters.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    f_combinations: {
        label: "Combinations",
        examples: {
            a_combo1: {
                react: code(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"Target\"\n                        }, {\n                            \"companyName\": [SpsValidators.minLength(7)]\n                        });\n\n                        React.useEffect(() => {\n                            // Make validation error visible for the purpose of this demo\n                            formMeta.markAsDirty();\n                        }, []);\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                stronglySuggested\n                                errors={() => formMeta.fields.companyName.hasError(\"minLength\")\n                                    && \"Company Name must be at least 7 characters.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"Target\"\n                        }, {\n                            \"companyName\": [SpsValidators.minLength(7)]\n                        });\n\n                        React.useEffect(() => {\n                            // Make validation error visible for the purpose of this demo\n                            formMeta.markAsDirty();\n                        }, []);\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                stronglySuggested\n                                errors={() => formMeta.fields.companyName.hasError(\"minLength\")\n                                    && \"Company Name must be at least 7 characters.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
            b_combo2: {
                react: code(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject$A(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        }, {\n                            \"companyName\": [SpsValidators.required]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                help=\"Pretend there's something helpful written here.\"\n                                errors={() => formMeta.fields.companyName.hasError(\"required\")\n                                    && \"Please enter a company name.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            companyName: \"\"\n                        }, {\n                            \"companyName\": [SpsValidators.required]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.companyName}\n                                help=\"Pretend there's something helpful written here.\"\n                                errors={() => formMeta.fields.companyName.hasError(\"required\")\n                                    && \"Please enter a company name.\"}\n                            >\n                                Company Name\n                            </SpsLabel>\n                            <SpsTextInput formMeta={formMeta.fields.companyName}\n                                value={formValue.companyName}\n                            ></SpsTextInput>\n                        </>;\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$A, templateObject_2$w, templateObject_3$r, templateObject_4$k, templateObject_5$c, templateObject_6$9, templateObject_7$8, templateObject_8$7;

var __assign$19 = (undefined && undefined.__assign) || function () {
    __assign$19 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$19.apply(this, arguments);
};
var __rest$Y = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$12 = {
    clearSelected: { type: "() => void", required: true },
    itemsSelected: { type: "string | number", required: true },
};
var propTypes$15 = __assign$19(__assign$19({}, spsGlobalPropTypes), { clearSelected: fun().isRequired, itemsSelected: propTypes$1H.exports.oneOfType([propTypes$1H.exports.string, propTypes$1H.exports.number]) });
function SpsListActionBar(props) {
    var itemsSelected = props.itemsSelected, clearSelected = props.clearSelected, children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$Y(props, ["itemsSelected", "clearSelected", "children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var t = React.useContext(I18nContext).t;
    var handleClearClick = function () {
        if (typeof clearSelected === "function") {
            clearSelected();
        }
    };
    var classes = clsx(unsafelyReplaceClassName || "sps-list-action-bar-container", "z-stratum-bar", className);
    return ((!!itemsSelected && (React.createElement("div", __assign$19({ className: classes }, rest, { "data-testid": testId }),
        React.createElement("div", { className: "sps-list-action-bar" },
            React.createElement("div", { className: "sps-list-action-bar__details" },
                React.createElement("span", { className: "sps-tag sps-tag--info", "data-testid": testId + "__badge" }, itemsSelected),
                t("design-system:listActionBar.itemsSelected")),
            React.createElement("div", { className: "sps-list-action-bar__actions" },
                React.createElement(PortalContext.Provider, { value: { fixed: true } }, children)),
            React.createElement("div", { className: "sps-list-action-bar__clear" },
                React.createElement(SpsButton, { kind: ButtonKind.LINK, icon: SpsIcon.X, onClick: handleClearClick, "data-testid": testId + "__clear-button" }, t("design-system:listActionBar.clearSelected"))))))));
}
Object.assign(SpsListActionBar, {
    props: propsDoc$12,
    propTypes: propTypes$15,
    displayName: "SpsListActionBar",
});

var getScrollParent = function (node) {
    var regex = /(auto|scroll)/;
    var parents = function (_node, ps) {
        if (_node.parentNode === null) {
            return ps;
        }
        return parents(_node.parentNode, ps.concat([_node]));
    };
    var style = function (_node, prop) { return getComputedStyle(_node, null).getPropertyValue(prop); };
    var overflow = function (_node) { return style(_node, "overflow") + style(_node, "overflow-y"); };
    var scroll = function (_node) { return regex.test(overflow(_node)); };
    /* eslint-disable consistent-return */
    var scrollParent = function (_node) {
        if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
            return;
        }
        var ps = parents(_node.parentNode, []);
        for (var i = 0; i < ps.length; i += 1) {
            if (scroll(ps[i])) {
                return ps[i];
            }
        }
        return null;
    };
    return scrollParent(node);
    /* eslint-enable consistent-return */
};

/* eslint-disable no-param-reassign */
var usePinnedCellStyle = function (isPinned, elementRef) {
    React.useLayoutEffect(function () {
        if (isPinned && elementRef.current) {
            var offset = 0;
            var isLeftPinned = true;
            var previousTh = elementRef.current.previousElementSibling;
            /*
             * First we have to determine whether the column
             * is pinned on the left or right side of the table
             */
            while (previousTh !== null) {
                if (!previousTh.classList.contains("sps-table__cell--pinned")) {
                    isLeftPinned = false;
                    break;
                }
                previousTh = previousTh.previousElementSibling;
            }
            if (isLeftPinned) {
                /*
                 * if it's on the left side we have to calculate
                 * the offset for the "left" css property
                 * by iterating over its siblings (on the left side)
                 */
                previousTh = elementRef.current.previousElementSibling;
                while (previousTh !== null) {
                    offset += previousTh.clientWidth;
                    previousTh = previousTh.previousElementSibling;
                }
                elementRef.current.style.left = offset + "px";
            }
            else {
                /*
                 * if it's on the right side we have to calculate the offset for
                 * the "right" css property by iterating over its siblings
                 * (on the right side)
                 */
                var nextTh = elementRef.current.nextElementSibling;
                while (nextTh !== null) {
                    offset += nextTh.clientWidth;
                    nextTh = nextTh.nextElementSibling;
                }
                elementRef.current.style.right = offset + "px";
            }
        }
    });
};
var usePinnedTableBackgroundStyle = function (containerRef) {
    React.useLayoutEffect(function () {
        if (containerRef.current) {
            var pinnedThs = containerRef.current.querySelectorAll("table > thead > tr:first-child > .sps-table__cell--pinned");
            if (pinnedThs.length > 0) {
                var leftPinnedThs_1 = [];
                var rightPinnedThs_1 = [];
                pinnedThs.forEach(function (th) {
                    var isLeftPinned = true;
                    var previousSibling = th.previousElementSibling;
                    while (previousSibling !== null) {
                        if (!previousSibling.classList.contains("sps-table__cell--pinned")) {
                            isLeftPinned = false;
                            break;
                        }
                        previousSibling = previousSibling.previousElementSibling;
                    }
                    if (isLeftPinned) {
                        leftPinnedThs_1.push(th);
                    }
                    else {
                        rightPinnedThs_1.push(th);
                    }
                });
                var leftPinnedWidth = leftPinnedThs_1.reduce(function (acc, th) { return acc + th.clientWidth; }, 0);
                var rightPinnedWidth = rightPinnedThs_1.reduce(function (acc, th) { return acc + th.clientWidth; }, 0);
                containerRef.current.style.backgroundPosition = leftPinnedWidth + "px 0, calc(100% - " + rightPinnedWidth + "px) 0, " + leftPinnedWidth + "px 0, calc(100% - " + rightPinnedWidth + "px) 0";
            }
        }
    });
};
var usePinnedTableHeadStyle = function (containerRef) {
    React.useLayoutEffect(function () {
        var container = containerRef.current;
        var headElement = container === null || container === void 0 ? void 0 : container.querySelector("thead");
        var table = container === null || container === void 0 ? void 0 : container.querySelector("table");
        var tableBodyFirstRow = table === null || table === void 0 ? void 0 : table.querySelector("tbody>tr");
        var tableBodyFirstRowCells = tableBodyFirstRow === null || tableBodyFirstRow === void 0 ? void 0 : tableBodyFirstRow.querySelectorAll("td");
        var tableHeadCells = headElement === null || headElement === void 0 ? void 0 : headElement.querySelectorAll("th");
        var navBarContainer = document.body.querySelector(".sps-navbar-container");
        var placeholder = container === null || container === void 0 ? void 0 : container.querySelector(".placeholder-head");
        var scrollableParent = null;
        var resetAppliedStyles = function () {
            if (headElement) {
                headElement.style.position = null;
                headElement.style.top = null;
                headElement.style.overflow = null;
                headElement.style.maxWidth = null;
                headElement.style.width = null;
                headElement.style.minWidth = null;
            }
            if (placeholder) {
                placeholder.style.width = null;
                placeholder.style.height = null;
            }
            if (tableBodyFirstRowCells) {
                Array.from(tableBodyFirstRowCells).forEach(function (cell, idx) {
                    tableHeadCells[idx].style.minWidth = null;
                    tableHeadCells[idx].style.width = null;
                    tableHeadCells[idx].style.maxWidth = null;
                    cell.style.minWidth = null;
                    cell.style.width = null;
                    cell.style.maxWidth = null;
                });
            }
        };
        var adjustHorizontalScroll = function () {
            headElement.scrollLeft = container.scrollLeft;
        };
        var adjustHeadPosition = function () {
            var topPosition = null;
            if (scrollableParent === window) {
                topPosition = navBarContainer ? navBarContainer.getBoundingClientRect().height : 0;
            }
            else if (scrollableParent instanceof HTMLElement) {
                topPosition = scrollableParent.getBoundingClientRect().top;
            }
            var containerHorizontalScroll = container.scrollLeft;
            var headRect = headElement.getBoundingClientRect();
            var containerRect = container.getBoundingClientRect();
            if (headRect.top <= topPosition
                && topPosition <= containerRect.bottom - headRect.height
                && containerRect.top <= topPosition) {
                headElement.style.position = "fixed";
                headElement.style.top = topPosition + "px";
                headElement.style.overflow = "hidden";
                var headElementWidth = containerRect.width + "px";
                headElement.style.maxWidth = headElementWidth;
                headElement.style.width = headElementWidth;
                headElement.style.minWidth = headElementWidth;
                if (tableBodyFirstRowCells) {
                    Array.from(tableBodyFirstRowCells).forEach(function (cell, idx) {
                        var cellWidth = cell.getBoundingClientRect().width;
                        var headerWidth = tableHeadCells[idx].getBoundingClientRect().width;
                        var width = Math.max(cellWidth, headerWidth) + "px";
                        tableHeadCells[idx].style.minWidth = width;
                        tableHeadCells[idx].style.width = width;
                        tableHeadCells[idx].style.maxWidth = width;
                        cell.style.minWidth = width;
                        cell.style.width = width;
                        cell.style.maxWidth = width;
                    });
                }
                if (!placeholder) {
                    placeholder = document.createElement("div");
                    placeholder.style.width = headRect.width + "px";
                    placeholder.style.height = headRect.height + "px";
                    placeholder.className = "placeholder-head";
                    container.insertBefore(placeholder, table);
                }
            }
            else if (placeholder) {
                container.removeChild(placeholder);
                placeholder = null;
                resetAppliedStyles();
            }
            container.scrollLeft = containerHorizontalScroll;
            adjustHorizontalScroll();
        };
        var adjustElements = function () {
            resetAppliedStyles();
            adjustHeadPosition();
            adjustHorizontalScroll();
        };
        if (headElement && headElement.classList.contains("sps-table__head--pinned")) {
            scrollableParent = getScrollParent(container) || window;
            scrollableParent.addEventListener("scroll", adjustHeadPosition);
            window.addEventListener("resize", adjustElements);
            container.addEventListener("scroll", adjustHorizontalScroll);
            adjustElements();
        }
        return function () {
            if (scrollableParent) {
                scrollableParent.removeEventListener("scroll", adjustHeadPosition);
                window.removeEventListener("resize", adjustElements);
            }
            if (container) {
                container.removeEventListener("scroll", adjustHorizontalScroll);
            }
        };
    });
};

var __assign$18 = (undefined && undefined.__assign) || function () {
    __assign$18 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$18.apply(this, arguments);
};
var __rest$X = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$v = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$11 = {
    controlCell: "boolean",
    currentSort: "Array<SortedColumn>",
    onSortChange: "SortChangeHandler",
    sortKey: "string",
};
var propTypes$14 = __assign$18(__assign$18({}, spsGlobalPropTypes), { controlCell: propTypes$1H.exports.bool, currentSort: propTypes$1H.exports.arrayOf(impl()), onSortChange: fun(), sortKey: propTypes$1H.exports.string, pinned: propTypes$1H.exports.bool });
function SpsTableHeader(props) {
    var children = props.children, className = props.className, controlCell = props.controlCell, currentSort = props.currentSort, onSortChange = props.onSortChange, sortKey = props.sortKey, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, pinned = props.pinned, rest = __rest$X(props, ["children", "className", "controlCell", "currentSort", "onSortChange", "sortKey", "data-testid", "unsafelyReplaceClassName", "pinned"]);
    var _a = __read$v(React.useState(), 2), sort = _a[0], setSort = _a[1];
    React.useEffect(function () {
        setSort(currentSort && currentSort[0].key === sortKey ? currentSort[0].direction : undefined);
    }, [currentSort]);
    var flipSort = function () {
        if (sortKey && !controlCell) {
            var curSort = sort === SortDirection.ASCENDING
                ? SortDirection.DESCENDING
                : SortDirection.ASCENDING;
            setSort(curSort);
            onSortChange([{ key: sortKey, direction: curSort }]);
        }
    };
    var handleKeyEvent = function (event) {
        if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            flipSort();
        }
    };
    var classes = clsx(unsafelyReplaceClassName || "sps-table__header", controlCell && "sps-table__header--control", !sortKey && "sps-table__header--sort-disabled", sort === SortDirection.ASCENDING && "sps-table__header--sorted-asc", sort === SortDirection.DESCENDING && "sps-table__header--sorted-desc", pinned && "sps-table__cell--pinned", className);
    var tableHeaderRef = React.useRef(null);
    usePinnedCellStyle(pinned, tableHeaderRef);
    return (React.createElement("th", __assign$18({ className: classes, ref: tableHeaderRef, role: "columnheader", "aria-sort": sort || "none", "data-testid": testId + "__header" }, rest),
        React.createElement("span", { className: "sps-table__header-cell-body", "data-testid": testId + "__header-cell-body", onClick: flipSort, tabIndex: sortKey ? 0 : null, onKeyDown: handleKeyEvent }, children)));
}
Object.assign(SpsTableHeader, {
    props: propsDoc$11,
    propTypes: propTypes$14,
    displayName: "SpsTableHeader",
});
function SpsTh(props) {
    return React.createElement(SpsTableHeader, __assign$18({}, props));
}
Object.assign(SpsTh, {
    props: propsDoc$11,
    propTypes: propTypes$14,
    displayName: "SpsTh",
});

var __assign$17 = (undefined && undefined.__assign) || function () {
    __assign$17 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$17.apply(this, arguments);
};
var __rest$W = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$10 = {
    currentSort: "Array<SortedColumn>",
    onSortChange: "SortChangeHandler",
};
var propTypes$13 = __assign$17(__assign$17({}, spsGlobalPropTypes), { currentSort: propTypes$1H.exports.arrayOf(impl()), onSortChange: fun() });
function SpsTableRow(props) {
    var children = props.children, className = props.className, currentSort = props.currentSort, onSortChange = props.onSortChange, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$W(props, ["children", "className", "currentSort", "onSortChange", "data-testid", "unsafelyReplaceClassName"]);
    var newProps = {
        onSortChange: onSortChange,
        currentSort: currentSort,
    };
    var classes = clsx(unsafelyReplaceClassName || "sps-table__row", className);
    return (React.createElement("tr", __assign$17({ className: classes, role: "row", "data-testid": testId + "__row" }, rest), React.Children.map(children, function (child) {
        if (child && (child.type === SpsTableHeader || child.type === SpsTh)) {
            return React.cloneElement(child, newProps);
        }
        return child;
    })));
}
Object.assign(SpsTableRow, {
    props: propsDoc$10,
    propTypes: propTypes$13,
    displayName: "SpsTableRow",
});
function SpsTr(props) {
    return React.createElement(SpsTableRow, __assign$17({}, props));
}
Object.assign(SpsTr, {
    props: propsDoc$10,
    propTypes: propTypes$13,
    displayName: "SpsTr",
});

var __assign$16 = (undefined && undefined.__assign) || function () {
    __assign$16 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$16.apply(this, arguments);
};
var __rest$V = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$$ = {
    currentSort: "Array<SortedColumn>",
    onSortChange: "SortChangeHandler",
};
var propTypes$12 = __assign$16(__assign$16({}, spsGlobalPropTypes), { onSortChange: fun(), currentSort: propTypes$1H.exports.arrayOf(impl()), pinned: propTypes$1H.exports.bool });
function SpsTableHead(props) {
    var children = props.children, className = props.className, currentSort = props.currentSort, onSortChange = props.onSortChange, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, pinned = props.pinned, rest = __rest$V(props, ["children", "className", "currentSort", "onSortChange", "data-testid", "unsafelyReplaceClassName", "pinned"]);
    var newProps = {
        onSortChange: onSortChange,
        currentSort: currentSort,
    };
    var classes = clsx(unsafelyReplaceClassName || "sps-table__head", pinned && "sps-table__head--pinned", className);
    return (React.createElement("thead", __assign$16({ className: classes, "data-testid": testId + "__head" }, rest), React.Children.map(children, function (child) {
        if (child && (child.type === SpsTableRow || child.type === SpsTr)) {
            return React.cloneElement(child, newProps);
        }
        return child;
    })));
}
Object.assign(SpsTableHead, {
    props: propsDoc$$,
    propTypes: propTypes$12,
    displayName: "SpsTableHead",
});
function SpsThead(props) {
    return React.createElement(SpsTableHead, __assign$16({}, props));
}
Object.assign(SpsThead, {
    props: propsDoc$$,
    propTypes: propTypes$12,
    displayName: "SpsThead",
});

var __assign$15 = (undefined && undefined.__assign) || function () {
    __assign$15 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$15.apply(this, arguments);
};
var __rest$U = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$u = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$_ = {
    sort: "SortedColumn",
    onSortChange: "SortChangeHandler",
    selectable: "boolean",
};
var propTypes$11 = __assign$15(__assign$15({}, spsGlobalPropTypes), { onSortChange: fun(), sort: propTypes$1H.exports.arrayOf(impl()), selectable: propTypes$1H.exports.bool });
function SpsTable(props) {
    var children = props.children, className = props.className, onSortChange = props.onSortChange, sort = props.sort, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$U(props, ["children", "className", "onSortChange", "sort", "data-testid", "unsafelyReplaceClassName"]);
    var _a = __read$u(React.useState(sort), 2), currentSort = _a[0], setSort = _a[1];
    var updateSortingDisplay = function (newSort) {
        var sortedColumn = newSort && newSort[0];
        React.Children.map(children, function (child) { return React.Children.map(child.props.children, function (c) { return React.Children.map(c.props.children, function (c2) {
            if (sortedColumn
                && (c2.props.sortKey && c2.props.sortKey === sortedColumn.key)) {
                setSort([sortedColumn]);
            }
        }); }); });
    };
    var sortChange = function (newSort) {
        setSort(newSort);
        onSortChange(newSort);
        updateSortingDisplay(newSort);
    };
    var newProps = {
        onSortChange: sortChange,
        currentSort: currentSort,
    };
    var classes = clsx(unsafelyReplaceClassName || "sps-table-container", className);
    var containerRef = React.useRef(null);
    usePinnedTableBackgroundStyle(containerRef);
    usePinnedTableHeadStyle(containerRef);
    return (React.createElement("div", { ref: containerRef, className: classes },
        React.createElement("table", __assign$15({ className: "sps-table", role: "table", "data-testid": "" + testId }, rest), React.Children.map(children, function (child) {
            if (child.type === SpsTableHead || child.type === SpsThead) {
                return React.cloneElement(child, newProps);
            }
            return child;
        }))));
}
Object.assign(SpsTable, {
    props: propsDoc$_,
    propTypes: propTypes$11,
    displayName: "SpsTable",
});

var __assign$14 = (undefined && undefined.__assign) || function () {
    __assign$14 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$14.apply(this, arguments);
};
var __rest$T = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$Z = {};
var propTypes$10 = __assign$14({}, spsGlobalPropTypes);
function SpsTableBody(props) {
    var children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$T(props, ["children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-table__body", className);
    return (React.createElement("tbody", __assign$14({ className: classes, "data-testid": testId + "__body" }, rest), children));
}
Object.assign(SpsTableBody, {
    props: propsDoc$Z,
    propTypes: propTypes$10,
    displayName: "SpsTableBody",
});
function SpsTbody(props) {
    return React.createElement(SpsTableBody, __assign$14({}, props));
}
Object.assign(SpsTbody, {
    props: propsDoc$Z,
    propTypes: propTypes$10,
    displayName: "SpsTbody",
});

var __assign$13 = (undefined && undefined.__assign) || function () {
    __assign$13 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$13.apply(this, arguments);
};
var __rest$S = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$Y = {
    buttonCell: "boolean",
    controlCell: "boolean",
    wrap: "SpsTableCellWrapWidth",
};
var propTypes$$ = __assign$13(__assign$13({}, spsGlobalPropTypes), { buttonCell: propTypes$1H.exports.bool, controlCell: propTypes$1H.exports.bool, wrap: propTypes$1H.exports.oneOf([200,
        300,
        400,
        500,
        600]), pinned: propTypes$1H.exports.bool });
function SpsTableCell(props) {
    var buttonCell = props.buttonCell, children = props.children, className = props.className, controlCell = props.controlCell, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, wrap = props.wrap, pinned = props.pinned, rest = __rest$S(props, ["buttonCell", "children", "className", "controlCell", "data-testid", "unsafelyReplaceClassName", "wrap", "pinned"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-table__cell", buttonCell && "sps-table__cell--button-cell", controlCell && "sps-table__cell--control", wrap && "sps-table__cell--text-wrap-" + wrap, pinned && "sps-table__cell--pinned", className);
    var tableCellRef = React.useRef(null);
    usePinnedCellStyle(pinned, tableCellRef);
    return (React.createElement("td", __assign$13({ className: classes, ref: tableCellRef, role: "cell", "data-testid": testId + "__cell" }, rest), children));
}
Object.assign(SpsTableCell, {
    props: propsDoc$Y,
    propTypes: propTypes$$,
    displayName: "SpsTableCell",
});
function SpsTd(props) {
    return React.createElement(SpsTableCell, __assign$13({}, props));
}
Object.assign(SpsTd, {
    props: propsDoc$Y,
    propTypes: propTypes$$,
    displayName: "SpsTd",
});

var __assign$12 = (undefined && undefined.__assign) || function () {
    __assign$12 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$12.apply(this, arguments);
};
var __rest$R = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$t = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$X = {};
var propTypes$_ = __assign$12({}, spsGlobalPropTypes);
var CSS_BLOCK$3 = "sps-icon-button-panel";
function SpsIconButtonPanel(_a) {
    var children = _a.children, className = _a.className, rest = __rest$R(_a, ["children", "className"]);
    var classes = clsx(CSS_BLOCK$3, className);
    var _b = __read$t(selectChildren(children, [
        { type: SpsButton, props: { kind: ButtonKind.ICON } },
    ]), 1), iconButtons = _b[0];
    return (React.createElement("div", __assign$12({ className: classes }, rest), iconButtons));
}
Object.assign(SpsIconButtonPanel, {
    props: propsDoc$X,
    propTypes: propTypes$_,
    displayName: "SpsIconButtonPanel",
});

var __makeTemplateObject$z = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsTableExamples = {
    generalUsage: {
        label: "General Usage",
        customSection: function () { return (React.createElement("section", { id: "table-general-usage" },
            React.createElement("div", { className: "flex-color-header" },
                React.createElement("h4", null, "General Usage"),
                React.createElement(SpsButton, { onClick: function () {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }, kind: ButtonKind.LINK }, "Back to Top")),
            React.createElement("h5", null, "Use Tables:"),
            React.createElement("ul", { className: "sps-body-14" },
                React.createElement("li", null, "Each record has more than 6 points of data"),
                React.createElement("li", null, "When more records need to be shown in the vertical space"),
                React.createElement("li", null, "When sorting options need to be precise (needs better explanation)."),
                React.createElement("li", null, "When tabular views are the expected/conventional view of thet data being displayed (one example: if the data is to be exported into a spreadsheet view).")),
            React.createElement("h5", null, "Avoid Tables:"),
            React.createElement("ul", { className: "sps-body-14" },
                React.createElement("li", null, "When large images need to be included amongst the data.")),
            React.createElement("div", null, "For additional help deciding which option best suits the data being displayed, refer to the List Usage Matrix."))); },
    },
    basic: {
        label: "Standard Tables",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sps-body-14" }, "Tables display tabular data in columns and rows with a header row used to identify the type of content in each column. The most common style of content displayed in tables is text (Small Body Copy), but additional elements such as tags and icons can be used when necessary."),
                React.createElement("br", null),
                React.createElement("div", { className: "sps-body-14" },
                    "Tables can be used in conjunction with the",
                    " ",
                    React.createElement(NavigateTo, { to: "List Toolbar" }, "List Toolbar"),
                    " and",
                    " ",
                    React.createElement(NavigateTo, { to: "Pagination" }, "Pagination"),
                    " components for extended capabilities.")));
        },
        examples: {
            basic: {
                react: code(templateObject_1$z || (templateObject_1$z = __makeTemplateObject$z(["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                                spine: 2,\n                                title: \"Seven Samurai\",\n                                year: 1954,\n                                director: \"Akira Kurosawa\",\n                                countries: [\"Japan\"],\n                                price: \"$39.96\"\n                            },\n                            {\n                                spine: 29,\n                                title: \"Picnic at Hanging Rock\",\n                                year: 1975,\n                                director: \"Peter Weir\",\n                                countries: [\"Australia\"],\n                                price: \"$39.95\"\n                            },\n                            {\n                                spine: 62,\n                                title: \"The Passion of Joan of Arc\",\n                                year: 1928,\n                                director: \"Carl Theodor Dreyer\",\n                                countries: [\"France\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 484,\n                                title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                                year: 1975,\n                                director: \"Chantal Akerman\",\n                                countries: [\"France\", \"Belgium\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 701,\n                                title: \"Persona\",\n                                year: 1966,\n                                director: \"Ingmar Bergman\",\n                                countries: [\"Sweden\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 740,\n                                title: \"The Bitter Tears of Petra von Kant\",\n                                year: 1972,\n                                director: \"Rainer Werner Fassbinder\",\n                                countries: [\"West Germany\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 782,\n                                title: \"The Apu Trilogy\",\n                                year: 1959,\n                                director: \"Satyajit Ray\",\n                                countries: [\"India\"],\n                                price: \"$79.96\"\n                            },\n                            {\n                                spine: 888,\n                                title: \"Stalker\",\n                                year: 1979,\n                                director: \"Andrei Tarkovsky\",\n                                countries: [\"Soviet Union\"],\n                                price: \"$31.96\"\n                            }\n                        ];\n\n                        return (\n                            <>\n                            <h5>Building Standard Tables</h5>\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader>Spine#</SpsTableHeader>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader>Countries</SpsTableHeader>\n                                        <SpsTableHeader className=\"text-right\">Price</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                                <SpsTableCell className=\"text-right\">{row[\"price\"]}</SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                            </>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                                spine: 2,\n                                title: \"Seven Samurai\",\n                                year: 1954,\n                                director: \"Akira Kurosawa\",\n                                countries: [\"Japan\"],\n                                price: \"$39.96\"\n                            },\n                            {\n                                spine: 29,\n                                title: \"Picnic at Hanging Rock\",\n                                year: 1975,\n                                director: \"Peter Weir\",\n                                countries: [\"Australia\"],\n                                price: \"$39.95\"\n                            },\n                            {\n                                spine: 62,\n                                title: \"The Passion of Joan of Arc\",\n                                year: 1928,\n                                director: \"Carl Theodor Dreyer\",\n                                countries: [\"France\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 484,\n                                title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                                year: 1975,\n                                director: \"Chantal Akerman\",\n                                countries: [\"France\", \"Belgium\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 701,\n                                title: \"Persona\",\n                                year: 1966,\n                                director: \"Ingmar Bergman\",\n                                countries: [\"Sweden\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 740,\n                                title: \"The Bitter Tears of Petra von Kant\",\n                                year: 1972,\n                                director: \"Rainer Werner Fassbinder\",\n                                countries: [\"West Germany\"],\n                                price: \"$31.96\"\n                            },\n                            {\n                                spine: 782,\n                                title: \"The Apu Trilogy\",\n                                year: 1959,\n                                director: \"Satyajit Ray\",\n                                countries: [\"India\"],\n                                price: \"$79.96\"\n                            },\n                            {\n                                spine: 888,\n                                title: \"Stalker\",\n                                year: 1979,\n                                director: \"Andrei Tarkovsky\",\n                                countries: [\"Soviet Union\"],\n                                price: \"$31.96\"\n                            }\n                        ];\n\n                        return (\n                            <>\n                            <h5>Building Standard Tables</h5>\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader>Spine#</SpsTableHeader>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader>Countries</SpsTableHeader>\n                                        <SpsTableHeader className=\"text-right\">Price</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                                <SpsTableCell className=\"text-right\">{row[\"price\"]}</SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    sorting: {
        label: "Sorting",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sps-body-14" },
                "The ability to sort the records in a table by a specific column is a common feature. Sorting options are alphabetical (A-Z or Z-A) for columns containing standard text and numerically (highest-to-lowest or lowest-to-highest) for columns containing numerical values.",
                " "),
            React.createElement("br", null),
            React.createElement("div", { className: "sps-body-14" }, "Sorting is applied on a column-by-column basis and should only be applied to columns that present a practical value when sorted alphabetically or numercally (i.e., not every column in a table requires sorting)."))); },
        examples: {
            sorting: {
                react: code(templateObject_2$v || (templateObject_2$v = __makeTemplateObject$z(["\n                  function DemoComponent() {\n                    const items = [\n                      {\n                        spine: 2,\n                        title: \"Seven Samurai\",\n                        year: 1954,\n                        director: \"Akira Kurosawa\",\n                        runtime: 207,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"Japan\",\n                        languages: \"Japanese\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 29,\n                        title: \"Picnic at Hanging Rock\",\n                        year: 1975,\n                        director: \"Peter Weir\",\n                        runtime: 107,\n                        aspect_ratio: \"1.78:1\",\n                        countries: \"Australia\",\n                        languages: \"English\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 62,\n                        title: \"The Passion of Joan of Arc\",\n                        year: 1928,\n                        director: \"Carl Theodor Dreyer\",\n                        runtime: 81,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"France\",\n                        languages: \"French\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 484,\n                        title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                        year: 1975,\n                        director: \"Chantal Akerman\",\n                        runtime: 201,\n                        aspect_ratio: \"1.66:1\",\n                        countries: \"France, Belgium\",\n                        languages: \"French\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 701,\n                        title: \"Persona\",\n                        year: 1966,\n                        director: \"Ingmar Bergman\",\n                        runtime: 83,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Sweden\",\n                        languages: \"Swedish\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 740,\n                        title: \"The Bitter Tears of Petra von Kant\",\n                        year: 1972,\n                        director: \"Rainer Werner Fassbinder\",\n                        runtime: 125,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"West Germany\",\n                        languages: \"German\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 782,\n                        title: \"The Apu Trilogy\",\n                        year: 1959,\n                        director: \"Satyajit Ray\",\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"India\",\n                        languages: \"Bengali\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 888,\n                        title: \"Stalker\",\n                        year: 1979,\n                        director: \"Andrei Tarkovsky\",\n                        runtime: 161,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Soviet Union\",\n                        languages: \"Russian\",\n                        price: \"$31.96\"\n                      }\n                    ]\n\n                    const initialSort = [{ key: \"title\", direction: SortDirection.ASCENDING }]\n\n                    const [itemsSorted, setItemsSorted] = React.useState(items)\n\n                    function ignoreArticles(value) {\n                      return typeof value === \"string\"\n                        ? value.replace(/^(The|A) /, \"\")\n                        : value\n                    }\n\n                    function sortItems([newSort]) {\n                      const { key, direction } = newSort;\n                      itemsSorted.sort((a, b) =>\n                        (direction === SortDirection.ASCENDING ? 1 : -1)\n                        * (ignoreArticles(a[key]) >= ignoreArticles(b[key]) ? 1 : -1)\n                      )\n                      setItemsSorted([...itemsSorted])\n                    }\n\n                    React.useEffect(() => {\n                      sortItems(initialSort)\n                    }, [])\n\n                    return (\n                      <SpsTable\n                        sort={initialSort}\n                        onSortChange={sortItems}\n                      >\n                        <SpsTableHead>\n                          <SpsTableRow>\n                            <SpsTableHeader sortKey=\"spine\">Spine #</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"title\">Title</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"year\">Year</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"director\">Director</SpsTableHeader>\n                            <SpsTableHeader>Countries</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"price\" className=\"text-right\">\n                              Price\n                            </SpsTableHeader>\n                          </SpsTableRow>\n                        </SpsTableHead>\n                        <SpsTableBody>\n                          {itemsSorted.map((row, i) => {\n                            return (\n                              <SpsTableRow key={i}>\n                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                <SpsTableCell className=\"text-right\">\n                                  {row[\"price\"]}\n                                </SpsTableCell>\n                              </SpsTableRow>\n                            )\n                          })}\n                        </SpsTableBody>\n                      </SpsTable>\n                    )\n                  }\n                "], ["\n                  function DemoComponent() {\n                    const items = [\n                      {\n                        spine: 2,\n                        title: \"Seven Samurai\",\n                        year: 1954,\n                        director: \"Akira Kurosawa\",\n                        runtime: 207,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"Japan\",\n                        languages: \"Japanese\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 29,\n                        title: \"Picnic at Hanging Rock\",\n                        year: 1975,\n                        director: \"Peter Weir\",\n                        runtime: 107,\n                        aspect_ratio: \"1.78:1\",\n                        countries: \"Australia\",\n                        languages: \"English\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 62,\n                        title: \"The Passion of Joan of Arc\",\n                        year: 1928,\n                        director: \"Carl Theodor Dreyer\",\n                        runtime: 81,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"France\",\n                        languages: \"French\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 484,\n                        title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                        year: 1975,\n                        director: \"Chantal Akerman\",\n                        runtime: 201,\n                        aspect_ratio: \"1.66:1\",\n                        countries: \"France, Belgium\",\n                        languages: \"French\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 701,\n                        title: \"Persona\",\n                        year: 1966,\n                        director: \"Ingmar Bergman\",\n                        runtime: 83,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Sweden\",\n                        languages: \"Swedish\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 740,\n                        title: \"The Bitter Tears of Petra von Kant\",\n                        year: 1972,\n                        director: \"Rainer Werner Fassbinder\",\n                        runtime: 125,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"West Germany\",\n                        languages: \"German\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 782,\n                        title: \"The Apu Trilogy\",\n                        year: 1959,\n                        director: \"Satyajit Ray\",\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"India\",\n                        languages: \"Bengali\",\n                        price: \"$31.96\"\n                      },\n                      {\n                        spine: 888,\n                        title: \"Stalker\",\n                        year: 1979,\n                        director: \"Andrei Tarkovsky\",\n                        runtime: 161,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Soviet Union\",\n                        languages: \"Russian\",\n                        price: \"$31.96\"\n                      }\n                    ]\n\n                    const initialSort = [{ key: \"title\", direction: SortDirection.ASCENDING }]\n\n                    const [itemsSorted, setItemsSorted] = React.useState(items)\n\n                    function ignoreArticles(value) {\n                      return typeof value === \"string\"\n                        ? value.replace(/^(The|A) /, \"\")\n                        : value\n                    }\n\n                    function sortItems([newSort]) {\n                      const { key, direction } = newSort;\n                      itemsSorted.sort((a, b) =>\n                        (direction === SortDirection.ASCENDING ? 1 : -1)\n                        * (ignoreArticles(a[key]) >= ignoreArticles(b[key]) ? 1 : -1)\n                      )\n                      setItemsSorted([...itemsSorted])\n                    }\n\n                    React.useEffect(() => {\n                      sortItems(initialSort)\n                    }, [])\n\n                    return (\n                      <SpsTable\n                        sort={initialSort}\n                        onSortChange={sortItems}\n                      >\n                        <SpsTableHead>\n                          <SpsTableRow>\n                            <SpsTableHeader sortKey=\"spine\">Spine #</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"title\">Title</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"year\">Year</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"director\">Director</SpsTableHeader>\n                            <SpsTableHeader>Countries</SpsTableHeader>\n                            <SpsTableHeader sortKey=\"price\" className=\"text-right\">\n                              Price\n                            </SpsTableHeader>\n                          </SpsTableRow>\n                        </SpsTableHead>\n                        <SpsTableBody>\n                          {itemsSorted.map((row, i) => {\n                            return (\n                              <SpsTableRow key={i}>\n                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                <SpsTableCell className=\"text-right\">\n                                  {row[\"price\"]}\n                                </SpsTableCell>\n                              </SpsTableRow>\n                            )\n                          })}\n                        </SpsTableBody>\n                      </SpsTable>\n                    )\n                  }\n                "]))),
            },
        },
    },
    wrap: {
        label: "Wrapping Content",
        description: function () { return (React.createElement("div", { className: "sps-body-14" }, "Cells in a column can be set to a fixed width to allow text wrapping when it benefits the readability of the content in that cell. This should be limited to content that is generally longer than a short phrase such as longer sentences or short paragraphs. Including long-form text such as paragraphs, however, should be avoided if possible.")); },
        examples: {
            wrapping: {
                react: code(templateObject_3$q || (templateObject_3$q = __makeTemplateObject$z(["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                              title: \"Seven Samurai\",\n                              year: 1954,\n                              director: \"Akira Kurosawa\",\n                              summary:\n                                \"One of the most thrilling movie epics of all time, Seven Samurai (Shichinin no samurai) tells the story of a sixteenth-century village whose desperate inhabitants hire the eponymous warriors to protect them from invading bandits. This three-hour ride from Akira Kurosawa\u2014featuring legendary actors Toshiro Mifune and Takashi Shimura\u2014seamlessly weaves philosophy and entertainment, delicate human emotions and relentless action, into a rich, evocative, and unforgettable tale of courage and hope.\"\n                            },\n                            {\n                              title: \"Picnic at Hanging Rock\",\n                              year: 1975,\n                              director: \"Peter Weir\",\n                              summary:\n                                \"This sensual and striking chronicle of a disappearance and its aftermath put director Peter Weir on the map and helped usher in a new era of Australian cinema. Based on an acclaimed 1967 novel by Joan Lindsay, Picnic at Hanging Rock is set at the turn of the twentieth century and concerns a small group of students from an all- female college who vanish, along with a chaperone, while on a St. Valentine\u2019s Day outing. Less a mystery than a journey into the mystic, as well as an inquiry into issues of class and sexual repression in Australian society, Weir\u2019s gorgeous, disquieting film is a work of poetic horror whose secrets haunt viewers to this day.\"\n                            },\n                            {\n                              title: \"The Passion of Joan of Arc\",\n                              year: 1928,\n                              director: \"Carl Theodor Dreyer\",\n                              summary:\n                                \"Spiritual rapture and institutional hypocrisy come to stark, vivid life in one of the most transcendent masterpieces of the silent era. Chronicling the trial of Joan of Arc in the hours leading up to her execution, Danish master Carl Theodor Dreyer depicts her torment with startling immediacy, employing an array of techniques\u2014expressionistic lighting, interconnected sets, painfully intimate close-ups\u2014to immerse viewers in her subjective experience. Anchoring Dreyer\u2019s audacious formal experimentation is a legendary performance by Ren\u00E9e Falconetti, whose haunted face channels both the agony and the ecstasy of martyrdom.\"\n                            },\n                            {\n                              title: \"Persona\",\n                              year: 1966,\n                              director: \"Ingmar Bergman\",\n                              summary:\n                                \"By the midsixties, Ingmar Bergman had already conjured many of the cinema\u2019s most unforgettable images. But with the radical Persona, he attained new levels of visual poetry. In the first of a series of legendary performances for Bergman, Liv Ullmann plays a stage actor who has inexplicably gone mute; an equally mesmerizing Bibi Andersson is the garrulous young nurse caring for her in a remote island cottage. While isolated together there, the women undergo a mysterious spiritual and emotional transference. Performed with astonishing nuance and shot in stark contrast and soft light by Sven Nykvist, the influential Persona is a penetrating, dreamlike work of profound psychological depth.\"\n                            },\n                            {\n                              title: \"The Bitter Tears of Petra von Kant\",\n                              year: 1972,\n                              director: \"Rainer Werner Fassbinder\",\n                              summary:\n                                \"In the early 1970s, Rainer Werner Fassbinder discovered the American melodramas of Douglas Sirk and was inspired by them to begin working in a new, more intensely emotional register. One of the first and best-loved films of this period in his career is The Bitter Tears of Petra von Kant, which balances a realistic depiction of tormented romance with staging that remains true to the director\u2019s roots in experimental theater. This unforgettable, unforgiving dissection of the imbalanced relationship between a haughty fashion designer (Margit Carstensen) and a beautiful but icy ingenue (Hanna Schygulla)\u2014based, in a sly gender reversal, on the writer-director\u2019s own desperate obsession with a young actor\u2014is a true Fassbinder affair, featuring exquisitely claustrophobic cinematography by Michael Ballhaus and full-throttle performances by an all-female cast.\"\n                            },\n                            {\n                              title: \"The Apu Trilogy\",\n                              year: 1959,\n                              director: \"Satyajit Ray\",\n                              summary:\n                                \"Two decades after its original negatives were burned in a fire, Satyajit Ray\u2019s breathtaking milestone of world cinema rises from the ashes in a meticulously reconstructed new restoration. The Apu Trilogy brought India into the golden age of international art-house film, following one indelible character, a free-spirited child in rural Bengal who matures into an adolescent urban student and finally a sensitive man of the world. These delicate masterworks\u2014Pather Panchali (Song of the Little Road), Aparajito (The Unvanquished), and Apur Sansar (The World of Apu)\u2014based on two books by Bibhutibhusan Banerjee, were shot over the course of five years, and each stands on its own as a tender, visually radiant journey. They are among the most achingly beautiful, richly humane movies ever made\u2014essential works for any film lover.\",\n                            },\n                            {\n                              title: \"Stalker\",\n                              year: 1979,\n                              director: \"Andrei Tarkovsky\",\n                              summary:\n                                \"Andrei Tarkovsky\u2019s final Soviet feature is a metaphys\u00ADical journey through an enigmatic postapocalyptic landscape, and a rarefied cinematic experience like no other. A hired guide\u2014the Stalker\u2014leads a writer and a professor into the heart of the Zone, the restricted site of a long-ago disaster, where the three men eventually zero in on the Room, a place rumored to fulfill one\u2019s most deeply held desires. Adapting a science-fiction novel by Arkady and Boris Strugatsky, Tarkovsky created an immersive world with a wealth of material detail and a sense of organic atmosphere. A religious allegory, a reflection of contemporaneous political anxieties, a meditation on film itself\u2014Stalker envelops the viewer by opening up a multitude of possible meanings.\"\n                            }\n                          ];\n\n                        return (\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader>Summary</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell wrap={400}>{row[\"summary\"]}</SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                              title: \"Seven Samurai\",\n                              year: 1954,\n                              director: \"Akira Kurosawa\",\n                              summary:\n                                \"One of the most thrilling movie epics of all time, Seven Samurai (Shichinin no samurai) tells the story of a sixteenth-century village whose desperate inhabitants hire the eponymous warriors to protect them from invading bandits. This three-hour ride from Akira Kurosawa\u2014featuring legendary actors Toshiro Mifune and Takashi Shimura\u2014seamlessly weaves philosophy and entertainment, delicate human emotions and relentless action, into a rich, evocative, and unforgettable tale of courage and hope.\"\n                            },\n                            {\n                              title: \"Picnic at Hanging Rock\",\n                              year: 1975,\n                              director: \"Peter Weir\",\n                              summary:\n                                \"This sensual and striking chronicle of a disappearance and its aftermath put director Peter Weir on the map and helped usher in a new era of Australian cinema. Based on an acclaimed 1967 novel by Joan Lindsay, Picnic at Hanging Rock is set at the turn of the twentieth century and concerns a small group of students from an all- female college who vanish, along with a chaperone, while on a St. Valentine\u2019s Day outing. Less a mystery than a journey into the mystic, as well as an inquiry into issues of class and sexual repression in Australian society, Weir\u2019s gorgeous, disquieting film is a work of poetic horror whose secrets haunt viewers to this day.\"\n                            },\n                            {\n                              title: \"The Passion of Joan of Arc\",\n                              year: 1928,\n                              director: \"Carl Theodor Dreyer\",\n                              summary:\n                                \"Spiritual rapture and institutional hypocrisy come to stark, vivid life in one of the most transcendent masterpieces of the silent era. Chronicling the trial of Joan of Arc in the hours leading up to her execution, Danish master Carl Theodor Dreyer depicts her torment with startling immediacy, employing an array of techniques\u2014expressionistic lighting, interconnected sets, painfully intimate close-ups\u2014to immerse viewers in her subjective experience. Anchoring Dreyer\u2019s audacious formal experimentation is a legendary performance by Ren\u00E9e Falconetti, whose haunted face channels both the agony and the ecstasy of martyrdom.\"\n                            },\n                            {\n                              title: \"Persona\",\n                              year: 1966,\n                              director: \"Ingmar Bergman\",\n                              summary:\n                                \"By the midsixties, Ingmar Bergman had already conjured many of the cinema\u2019s most unforgettable images. But with the radical Persona, he attained new levels of visual poetry. In the first of a series of legendary performances for Bergman, Liv Ullmann plays a stage actor who has inexplicably gone mute; an equally mesmerizing Bibi Andersson is the garrulous young nurse caring for her in a remote island cottage. While isolated together there, the women undergo a mysterious spiritual and emotional transference. Performed with astonishing nuance and shot in stark contrast and soft light by Sven Nykvist, the influential Persona is a penetrating, dreamlike work of profound psychological depth.\"\n                            },\n                            {\n                              title: \"The Bitter Tears of Petra von Kant\",\n                              year: 1972,\n                              director: \"Rainer Werner Fassbinder\",\n                              summary:\n                                \"In the early 1970s, Rainer Werner Fassbinder discovered the American melodramas of Douglas Sirk and was inspired by them to begin working in a new, more intensely emotional register. One of the first and best-loved films of this period in his career is The Bitter Tears of Petra von Kant, which balances a realistic depiction of tormented romance with staging that remains true to the director\u2019s roots in experimental theater. This unforgettable, unforgiving dissection of the imbalanced relationship between a haughty fashion designer (Margit Carstensen) and a beautiful but icy ingenue (Hanna Schygulla)\u2014based, in a sly gender reversal, on the writer-director\u2019s own desperate obsession with a young actor\u2014is a true Fassbinder affair, featuring exquisitely claustrophobic cinematography by Michael Ballhaus and full-throttle performances by an all-female cast.\"\n                            },\n                            {\n                              title: \"The Apu Trilogy\",\n                              year: 1959,\n                              director: \"Satyajit Ray\",\n                              summary:\n                                \"Two decades after its original negatives were burned in a fire, Satyajit Ray\u2019s breathtaking milestone of world cinema rises from the ashes in a meticulously reconstructed new restoration. The Apu Trilogy brought India into the golden age of international art-house film, following one indelible character, a free-spirited child in rural Bengal who matures into an adolescent urban student and finally a sensitive man of the world. These delicate masterworks\u2014Pather Panchali (Song of the Little Road), Aparajito (The Unvanquished), and Apur Sansar (The World of Apu)\u2014based on two books by Bibhutibhusan Banerjee, were shot over the course of five years, and each stands on its own as a tender, visually radiant journey. They are among the most achingly beautiful, richly humane movies ever made\u2014essential works for any film lover.\",\n                            },\n                            {\n                              title: \"Stalker\",\n                              year: 1979,\n                              director: \"Andrei Tarkovsky\",\n                              summary:\n                                \"Andrei Tarkovsky\u2019s final Soviet feature is a metaphys\u00ADical journey through an enigmatic postapocalyptic landscape, and a rarefied cinematic experience like no other. A hired guide\u2014the Stalker\u2014leads a writer and a professor into the heart of the Zone, the restricted site of a long-ago disaster, where the three men eventually zero in on the Room, a place rumored to fulfill one\u2019s most deeply held desires. Adapting a science-fiction novel by Arkady and Boris Strugatsky, Tarkovsky created an immersive world with a wealth of material detail and a sense of organic atmosphere. A religious allegory, a reflection of contemporaneous political anxieties, a meditation on film itself\u2014Stalker envelops the viewer by opening up a multitude of possible meanings.\"\n                            }\n                          ];\n\n                        return (\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader>Summary</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell wrap={400}>{row[\"summary\"]}</SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                        );\n                    }\n                "]))),
            },
        },
    },
    horizontalScroll: {
        label: "Horizontal Scrolling",
        description: function () { return (React.createElement("div", { className: "sps-body-14" }, "Some table may require more content than will fit on the page horizontally. Horizontal scrolling allows users to scroll left and right inside the table to view all existing content.")); },
        examples: {
            scroll: {
                react: code(templateObject_4$j || (templateObject_4$j = __makeTemplateObject$z(["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                              spine: 2,\n                              title: \"Seven Samurai\",\n                              year: 1954,\n                              director: \"Akira Kurosawa\",\n                              runtime: 207,\n                              aspect_ratio: \"1.33:1\",\n                              countries: \"Japan\",\n                              languages: \"Japanese\",\n                              summary:\n                                \"One of the most thrilling movie epics of all time, Seven Samurai (Shichinin no samurai) tells the story of a sixteenth-century village whose desperate inhabitants hire the eponymous warriors to protect them from invading bandits. This three-hour ride from Akira Kurosawa\u2014featuring legendary actors Toshiro Mifune and Takashi Shimura\u2014seamlessly weaves philosophy and entertainment, delicate human emotions and relentless action, into a rich, evocative, and unforgettable tale of courage and hope.\",\n                              price: \"$39.96\"\n                            },\n                            {\n                              spine: 29,\n                              title: \"Picnic at Hanging Rock\",\n                              year: 1975,\n                              director: \"Peter Weir\",\n                              runtime: 107,\n                              aspect_ratio: \"1.78:1\",\n                              countries: \"Australia\",\n                              languages: \"English\",\n                              summary:\n                                \"This sensual and striking chronicle of a disappearance and its aftermath put director Peter Weir on the map and helped usher in a new era of Australian cinema. Based on an acclaimed 1967 novel by Joan Lindsay, Picnic at Hanging Rock is set at the turn of the twentieth century and concerns a small group of students from an all- female college who vanish, along with a chaperone, while on a St. Valentine\u2019s Day outing. Less a mystery than a journey into the mystic, as well as an inquiry into issues of class and sexual repression in Australian society, Weir\u2019s gorgeous, disquieting film is a work of poetic horror whose secrets haunt viewers to this day.\",\n                              price: \"$39.95\"\n                            },\n                            {\n                              spine: 62,\n                              title: \"The Passion of Joan of Arc\",\n                              year: 1928,\n                              director: \"Carl Theodor Dreyer\",\n                              runtime: 81,\n                              aspect_ratio: \"1.33:1\",\n                              countries: \"France\",\n                              languages: \"French\",\n                              summary:\n                                \"Spiritual rapture and institutional hypocrisy come to stark, vivid life in one of the most transcendent masterpieces of the silent era. Chronicling the trial of Joan of Arc in the hours leading up to her execution, Danish master Carl Theodor Dreyer depicts her torment with startling immediacy, employing an array of techniques\u2014expressionistic lighting, interconnected sets, painfully intimate close-ups\u2014to immerse viewers in her subjective experience. Anchoring Dreyer\u2019s audacious formal experimentation is a legendary performance by Ren\u00E9e Falconetti, whose haunted face channels both the agony and the ecstasy of martyrdom.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 484,\n                              title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                              year: 1975,\n                              director: \"Chantal Akerman\",\n                              runtime: 201,\n                              aspect_ratio: \"1.66:1\",\n                              countries: \"France, Belgium\",\n                              languages: \"French\",\n                              summary:\n                                \"A singular work in film history, Chantal Akerman\u2019s Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles meticulously details, with a sense of impending doom, the daily routine of a middle-aged widow, whose chores include making the beds, cooking dinner for her son, and turning the occasional trick. In its enormous spareness, Akerman\u2019s film seems simple, but it encompasses an entire world. Whether seen as an exacting character study or as one of cinema\u2019s most hypnotic and complete depictions of space and time, Jeanne Dielman is an astonishing, compelling movie experiment, one that has been analyzed and argued over for decades.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 701,\n                              title: \"Persona\",\n                              year: 1966,\n                              director: \"Ingmar Bergman\",\n                              runtime: 83,\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"Sweden\",\n                              languages: \"Swedish\",\n                              summary:\n                                \"By the midsixties, Ingmar Bergman had already conjured many of the cinema\u2019s most unforgettable images. But with the radical Persona, he attained new levels of visual poetry. In the first of a series of legendary performances for Bergman, Liv Ullmann plays a stage actor who has inexplicably gone mute; an equally mesmerizing Bibi Andersson is the garrulous young nurse caring for her in a remote island cottage. While isolated together there, the women undergo a mysterious spiritual and emotional transference. Performed with astonishing nuance and shot in stark contrast and soft light by Sven Nykvist, the influential Persona is a penetrating, dreamlike work of profound psychological depth.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 740,\n                              title: \"The Bitter Tears of Petra von Kant\",\n                              year: 1972,\n                              director: \"Rainer Werner Fassbinder\",\n                              runtime: 125,\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"West Germany\",\n                              languages: \"German\",\n                              summary:\n                                \"In the early 1970s, Rainer Werner Fassbinder discovered the American melodramas of Douglas Sirk and was inspired by them to begin working in a new, more intensely emotional register. One of the first and best-loved films of this period in his career is The Bitter Tears of Petra von Kant, which balances a realistic depiction of tormented romance with staging that remains true to the director\u2019s roots in experimental theater. This unforgettable, unforgiving dissection of the imbalanced relationship between a haughty fashion designer (Margit Carstensen) and a beautiful but icy ingenue (Hanna Schygulla)\u2014based, in a sly gender reversal, on the writer-director\u2019s own desperate obsession with a young actor\u2014is a true Fassbinder affair, featuring exquisitely claustrophobic cinematography by Michael Ballhaus and full-throttle performances by an all-female cast.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 782,\n                              title: \"The Apu Trilogy\",\n                              year: 1959,\n                              director: \"Satyajit Ray\",\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"India\",\n                              languages: \"Bengali\",\n                              summary:\n                                \"Two decades after its original negatives were burned in a fire, Satyajit Ray\u2019s breathtaking milestone of world cinema rises from the ashes in a meticulously reconstructed new restoration. The Apu Trilogy brought India into the golden age of international art-house film, following one indelible character, a free-spirited child in rural Bengal who matures into an adolescent urban student and finally a sensitive man of the world. These delicate masterworks\u2014Pather Panchali (Song of the Little Road), Aparajito (The Unvanquished), and Apur Sansar (The World of Apu)\u2014based on two books by Bibhutibhusan Banerjee, were shot over the course of five years, and each stands on its own as a tender, visually radiant journey. They are among the most achingly beautiful, richly humane movies ever made\u2014essential works for any film lover.\",\n                              price: \"$79.96\"\n                            },\n                            {\n                              spine: 888,\n                              title: \"Stalker\",\n                              year: 1979,\n                              director: \"Andrei Tarkovsky\",\n                              runtime: 161,\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"Soviet Union\",\n                              languages: \"Russian\",\n                              summary:\n                                \"Andrei Tarkovsky\u2019s final Soviet feature is a metaphys\u00ADical journey through an enigmatic postapocalyptic landscape, and a rarefied cinematic experience like no other. A hired guide\u2014the Stalker\u2014leads a writer and a professor into the heart of the Zone, the restricted site of a long-ago disaster, where the three men eventually zero in on the Room, a place rumored to fulfill one\u2019s most deeply held desires. Adapting a science-fiction novel by Arkady and Boris Strugatsky, Tarkovsky created an immersive world with a wealth of material detail and a sense of organic atmosphere. A religious allegory, a reflection of contemporaneous political anxieties, a meditation on film itself\u2014Stalker envelops the viewer by opening up a multitude of possible meanings.\",\n                              price: \"$31.96\"\n                            }\n                          ];\n\n                        return (\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader>Spine#</SpsTableHeader>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader>Runtime</SpsTableHeader>\n                                        <SpsTableHeader>Aspect Ratio</SpsTableHeader>\n                                        <SpsTableHeader>Countries</SpsTableHeader>\n                                        <SpsTableHeader>Languages</SpsTableHeader>\n                                        <SpsTableHeader className=\"text-right\">Price</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"runtime\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"aspect_ratio\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"languages\"]}</SpsTableCell>\n                                                <SpsTableCell className=\"text-right\">{row[\"price\"]}</SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                              spine: 2,\n                              title: \"Seven Samurai\",\n                              year: 1954,\n                              director: \"Akira Kurosawa\",\n                              runtime: 207,\n                              aspect_ratio: \"1.33:1\",\n                              countries: \"Japan\",\n                              languages: \"Japanese\",\n                              summary:\n                                \"One of the most thrilling movie epics of all time, Seven Samurai (Shichinin no samurai) tells the story of a sixteenth-century village whose desperate inhabitants hire the eponymous warriors to protect them from invading bandits. This three-hour ride from Akira Kurosawa\u2014featuring legendary actors Toshiro Mifune and Takashi Shimura\u2014seamlessly weaves philosophy and entertainment, delicate human emotions and relentless action, into a rich, evocative, and unforgettable tale of courage and hope.\",\n                              price: \"$39.96\"\n                            },\n                            {\n                              spine: 29,\n                              title: \"Picnic at Hanging Rock\",\n                              year: 1975,\n                              director: \"Peter Weir\",\n                              runtime: 107,\n                              aspect_ratio: \"1.78:1\",\n                              countries: \"Australia\",\n                              languages: \"English\",\n                              summary:\n                                \"This sensual and striking chronicle of a disappearance and its aftermath put director Peter Weir on the map and helped usher in a new era of Australian cinema. Based on an acclaimed 1967 novel by Joan Lindsay, Picnic at Hanging Rock is set at the turn of the twentieth century and concerns a small group of students from an all- female college who vanish, along with a chaperone, while on a St. Valentine\u2019s Day outing. Less a mystery than a journey into the mystic, as well as an inquiry into issues of class and sexual repression in Australian society, Weir\u2019s gorgeous, disquieting film is a work of poetic horror whose secrets haunt viewers to this day.\",\n                              price: \"$39.95\"\n                            },\n                            {\n                              spine: 62,\n                              title: \"The Passion of Joan of Arc\",\n                              year: 1928,\n                              director: \"Carl Theodor Dreyer\",\n                              runtime: 81,\n                              aspect_ratio: \"1.33:1\",\n                              countries: \"France\",\n                              languages: \"French\",\n                              summary:\n                                \"Spiritual rapture and institutional hypocrisy come to stark, vivid life in one of the most transcendent masterpieces of the silent era. Chronicling the trial of Joan of Arc in the hours leading up to her execution, Danish master Carl Theodor Dreyer depicts her torment with startling immediacy, employing an array of techniques\u2014expressionistic lighting, interconnected sets, painfully intimate close-ups\u2014to immerse viewers in her subjective experience. Anchoring Dreyer\u2019s audacious formal experimentation is a legendary performance by Ren\u00E9e Falconetti, whose haunted face channels both the agony and the ecstasy of martyrdom.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 484,\n                              title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                              year: 1975,\n                              director: \"Chantal Akerman\",\n                              runtime: 201,\n                              aspect_ratio: \"1.66:1\",\n                              countries: \"France, Belgium\",\n                              languages: \"French\",\n                              summary:\n                                \"A singular work in film history, Chantal Akerman\u2019s Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles meticulously details, with a sense of impending doom, the daily routine of a middle-aged widow, whose chores include making the beds, cooking dinner for her son, and turning the occasional trick. In its enormous spareness, Akerman\u2019s film seems simple, but it encompasses an entire world. Whether seen as an exacting character study or as one of cinema\u2019s most hypnotic and complete depictions of space and time, Jeanne Dielman is an astonishing, compelling movie experiment, one that has been analyzed and argued over for decades.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 701,\n                              title: \"Persona\",\n                              year: 1966,\n                              director: \"Ingmar Bergman\",\n                              runtime: 83,\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"Sweden\",\n                              languages: \"Swedish\",\n                              summary:\n                                \"By the midsixties, Ingmar Bergman had already conjured many of the cinema\u2019s most unforgettable images. But with the radical Persona, he attained new levels of visual poetry. In the first of a series of legendary performances for Bergman, Liv Ullmann plays a stage actor who has inexplicably gone mute; an equally mesmerizing Bibi Andersson is the garrulous young nurse caring for her in a remote island cottage. While isolated together there, the women undergo a mysterious spiritual and emotional transference. Performed with astonishing nuance and shot in stark contrast and soft light by Sven Nykvist, the influential Persona is a penetrating, dreamlike work of profound psychological depth.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 740,\n                              title: \"The Bitter Tears of Petra von Kant\",\n                              year: 1972,\n                              director: \"Rainer Werner Fassbinder\",\n                              runtime: 125,\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"West Germany\",\n                              languages: \"German\",\n                              summary:\n                                \"In the early 1970s, Rainer Werner Fassbinder discovered the American melodramas of Douglas Sirk and was inspired by them to begin working in a new, more intensely emotional register. One of the first and best-loved films of this period in his career is The Bitter Tears of Petra von Kant, which balances a realistic depiction of tormented romance with staging that remains true to the director\u2019s roots in experimental theater. This unforgettable, unforgiving dissection of the imbalanced relationship between a haughty fashion designer (Margit Carstensen) and a beautiful but icy ingenue (Hanna Schygulla)\u2014based, in a sly gender reversal, on the writer-director\u2019s own desperate obsession with a young actor\u2014is a true Fassbinder affair, featuring exquisitely claustrophobic cinematography by Michael Ballhaus and full-throttle performances by an all-female cast.\",\n                              price: \"$31.96\"\n                            },\n                            {\n                              spine: 782,\n                              title: \"The Apu Trilogy\",\n                              year: 1959,\n                              director: \"Satyajit Ray\",\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"India\",\n                              languages: \"Bengali\",\n                              summary:\n                                \"Two decades after its original negatives were burned in a fire, Satyajit Ray\u2019s breathtaking milestone of world cinema rises from the ashes in a meticulously reconstructed new restoration. The Apu Trilogy brought India into the golden age of international art-house film, following one indelible character, a free-spirited child in rural Bengal who matures into an adolescent urban student and finally a sensitive man of the world. These delicate masterworks\u2014Pather Panchali (Song of the Little Road), Aparajito (The Unvanquished), and Apur Sansar (The World of Apu)\u2014based on two books by Bibhutibhusan Banerjee, were shot over the course of five years, and each stands on its own as a tender, visually radiant journey. They are among the most achingly beautiful, richly humane movies ever made\u2014essential works for any film lover.\",\n                              price: \"$79.96\"\n                            },\n                            {\n                              spine: 888,\n                              title: \"Stalker\",\n                              year: 1979,\n                              director: \"Andrei Tarkovsky\",\n                              runtime: 161,\n                              aspect_ratio: \"1.37:1\",\n                              countries: \"Soviet Union\",\n                              languages: \"Russian\",\n                              summary:\n                                \"Andrei Tarkovsky\u2019s final Soviet feature is a metaphys\u00ADical journey through an enigmatic postapocalyptic landscape, and a rarefied cinematic experience like no other. A hired guide\u2014the Stalker\u2014leads a writer and a professor into the heart of the Zone, the restricted site of a long-ago disaster, where the three men eventually zero in on the Room, a place rumored to fulfill one\u2019s most deeply held desires. Adapting a science-fiction novel by Arkady and Boris Strugatsky, Tarkovsky created an immersive world with a wealth of material detail and a sense of organic atmosphere. A religious allegory, a reflection of contemporaneous political anxieties, a meditation on film itself\u2014Stalker envelops the viewer by opening up a multitude of possible meanings.\",\n                              price: \"$31.96\"\n                            }\n                          ];\n\n                        return (\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader>Spine#</SpsTableHeader>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader>Runtime</SpsTableHeader>\n                                        <SpsTableHeader>Aspect Ratio</SpsTableHeader>\n                                        <SpsTableHeader>Countries</SpsTableHeader>\n                                        <SpsTableHeader>Languages</SpsTableHeader>\n                                        <SpsTableHeader className=\"text-right\">Price</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"runtime\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"aspect_ratio\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"languages\"]}</SpsTableCell>\n                                                <SpsTableCell className=\"text-right\">{row[\"price\"]}</SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                        );\n                    }\n                "]))),
            },
        },
    },
    selectableRows: {
        label: "Selectable Rows",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("div", { className: "sps-body-14" },
                "Selectable rows include a checkbox column that allows the user to select individual or multiple rows on which to perform actions such as edit, delete, or a variety of other options. Selectable rows are to be used in conjunction with Action Buttons (See Controls and Buttons below) and the",
                " ",
                React.createElement(NavigateTo, { to: "list-action-bar" }, "List Action Bar"),
                "."));
        },
        examples: {
            controls: {
                react: code(templateObject_5$b || (templateObject_5$b = __makeTemplateObject$z(["\n                  function DemoComponent() {\n                    const items = [\n                      {\n                        title: \"Seven Samurai\",\n                        year: 1954,\n                        director: \"Akira Kurosawa\",\n                        countries: \"Japan\",\n                      },\n                      {\n                        title: \"Picnic at Hanging Rock\",\n                        year: 1975,\n                        director: \"Peter Weir\",\n                        countries: \"Australia\",\n                      },\n                      {\n                        title: \"The Passion of Joan of Arc\",\n                        year: 1928,\n                        director: \"Carl Theodor Dreyer\",\n                        countries: \"France\",\n                      },\n                      {\n                        title: \"Persona\",\n                        year: 1966,\n                        director: \"Ingmar Bergman\",\n                        countries: \"Sweden\",\n                      },\n                      {\n                        title: \"The Bitter Tears of Petra von Kant\",\n                        year: 1972,\n                        director: \"Rainer Werner Fassbinder\",\n                        countries: \"West Germany\",\n                      },\n                      {\n                        title: \"The Apu Trilogy\",\n                        year: 1959,\n                        director: \"Satyajit Ray\",\n                        countries: \"India\",\n                      },\n                      {\n                        title: \"Stalker\",\n                        year: 1979,\n                        director: \"Andrei Tarkovsky\",\n                        countries: \"Soviet Union\",\n                      },\n                    ];\n\n                    return (\n                      <SpsTable>\n                        <SpsTableHead>\n                          <SpsTableRow>\n                            <SpsTableHeader ></SpsTableHeader>\n                            <SpsTableHeader >Title</SpsTableHeader>\n                            <SpsTableHeader>Year</SpsTableHeader>\n                            <SpsTableHeader >Director</SpsTableHeader>\n                            <SpsTableHeader>Countries</SpsTableHeader>\n                          </SpsTableRow>\n                        </SpsTableHead>\n                        <SpsTableBody>\n                          {items.map((row, index) => {\n                            return (\n                              <SpsTableRow key={index}>\n                                <SpsTableCell><SpsCheckbox/></SpsTableCell>\n                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                              </SpsTableRow>\n                            );\n                          })}\n                        </SpsTableBody>\n                      </SpsTable>\n                    );\n                  }\n                "], ["\n                  function DemoComponent() {\n                    const items = [\n                      {\n                        title: \"Seven Samurai\",\n                        year: 1954,\n                        director: \"Akira Kurosawa\",\n                        countries: \"Japan\",\n                      },\n                      {\n                        title: \"Picnic at Hanging Rock\",\n                        year: 1975,\n                        director: \"Peter Weir\",\n                        countries: \"Australia\",\n                      },\n                      {\n                        title: \"The Passion of Joan of Arc\",\n                        year: 1928,\n                        director: \"Carl Theodor Dreyer\",\n                        countries: \"France\",\n                      },\n                      {\n                        title: \"Persona\",\n                        year: 1966,\n                        director: \"Ingmar Bergman\",\n                        countries: \"Sweden\",\n                      },\n                      {\n                        title: \"The Bitter Tears of Petra von Kant\",\n                        year: 1972,\n                        director: \"Rainer Werner Fassbinder\",\n                        countries: \"West Germany\",\n                      },\n                      {\n                        title: \"The Apu Trilogy\",\n                        year: 1959,\n                        director: \"Satyajit Ray\",\n                        countries: \"India\",\n                      },\n                      {\n                        title: \"Stalker\",\n                        year: 1979,\n                        director: \"Andrei Tarkovsky\",\n                        countries: \"Soviet Union\",\n                      },\n                    ];\n\n                    return (\n                      <SpsTable>\n                        <SpsTableHead>\n                          <SpsTableRow>\n                            <SpsTableHeader ></SpsTableHeader>\n                            <SpsTableHeader >Title</SpsTableHeader>\n                            <SpsTableHeader>Year</SpsTableHeader>\n                            <SpsTableHeader >Director</SpsTableHeader>\n                            <SpsTableHeader>Countries</SpsTableHeader>\n                          </SpsTableRow>\n                        </SpsTableHead>\n                        <SpsTableBody>\n                          {items.map((row, index) => {\n                            return (\n                              <SpsTableRow key={index}>\n                                <SpsTableCell><SpsCheckbox/></SpsTableCell>\n                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                              </SpsTableRow>\n                            );\n                          })}\n                        </SpsTableBody>\n                      </SpsTable>\n                    );\n                  }\n                "]))),
            },
        },
    },
    controlsAndButtons: {
        label: "Controls (Toggles & Buttons)",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sps-body-14" }, "Controls are used to take action on listed records. Controls are represented in tables or by Toggles or Buttons."),
            React.createElement("br", null),
            React.createElement("h5", null, "Toggles"),
            React.createElement("div", { className: "sps-body-14" },
                "Toggles are used to apply an immediate change of state to a record in a table. Toggles can appear as either traditional toggles (the switch) or as an icon such as a star or heart to distinguish that record apart from others (e.g. as a favorite). For more information on this pattern visit the Toggles page. Toggles always occupy the left-most columns of a table (unless checkboxes are required).",
                " "),
            React.createElement("br", null),
            React.createElement("h5", null, "Buttons"),
            React.createElement("div", { className: "sps-body-14" }, "Buttons can be used to perform specific actions on a record in a table. Buttons in tables are represented by the Icon Button style. Multiple buttons can be included in each row, however when more than two different actions are required consider using the ellipses button with a dropdown menu to conserve space. Buttons always occupy the right-most column in the table."),
            React.createElement("br", null),
            React.createElement("i", { className: "sps-body-14" }, "Note: Standard Buttons and Text Buttons can be used in table rows if necessary, but when possible opt to use the Icon Button style."))); },
        examples: {
            controls: {
                react: code(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject$z(["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                              title: \"Seven Samurai\",\n                              year: 1954,\n                              director: \"Akira Kurosawa\"\n                            },\n                            {\n                              title: \"Picnic at Hanging Rock\",\n                              year: 1975,\n                              director: \"Peter Weir\"\n                            },\n                            {\n                              title: \"The Passion of Joan of Arc\",\n                              year: 1928,\n                              director: \"Carl Theodor Dreyer\"\n                            },\n                            {\n                              title: \"Persona\",\n                              year: 1966,\n                              director: \"Ingmar Bergman\"\n                            },\n                            {\n                              title: \"The Bitter Tears of Petra von Kant\",\n                              year: 1972,\n                              director: \"Rainer Werner Fassbinder\"\n                            },\n                            {\n                              title: \"The Apu Trilogy\",\n                              year: 1959,\n                              director: \"Satyajit Ray\"\n                            },\n                            {\n                              title: \"Stalker\",\n                              year: 1979,\n                              director: \"Andrei Tarkovsky\"\n                            }\n                          ];\n\n                        return (\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader></SpsTableHeader>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader className=\"text-right\">Actions</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell><SpsToggle /></SpsTableCell>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell className=\"text-right\" buttonCell>\n                                                    <SpsButton kind=\"icon\" icon=\"ellipses\" />\n                                                </SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const items = [\n                            {\n                              title: \"Seven Samurai\",\n                              year: 1954,\n                              director: \"Akira Kurosawa\"\n                            },\n                            {\n                              title: \"Picnic at Hanging Rock\",\n                              year: 1975,\n                              director: \"Peter Weir\"\n                            },\n                            {\n                              title: \"The Passion of Joan of Arc\",\n                              year: 1928,\n                              director: \"Carl Theodor Dreyer\"\n                            },\n                            {\n                              title: \"Persona\",\n                              year: 1966,\n                              director: \"Ingmar Bergman\"\n                            },\n                            {\n                              title: \"The Bitter Tears of Petra von Kant\",\n                              year: 1972,\n                              director: \"Rainer Werner Fassbinder\"\n                            },\n                            {\n                              title: \"The Apu Trilogy\",\n                              year: 1959,\n                              director: \"Satyajit Ray\"\n                            },\n                            {\n                              title: \"Stalker\",\n                              year: 1979,\n                              director: \"Andrei Tarkovsky\"\n                            }\n                          ];\n\n                        return (\n                            <SpsTable>\n                                <SpsTableHead>\n                                    <SpsTableRow>\n                                        <SpsTableHeader></SpsTableHeader>\n                                        <SpsTableHeader>Title</SpsTableHeader>\n                                        <SpsTableHeader>Year</SpsTableHeader>\n                                        <SpsTableHeader>Director</SpsTableHeader>\n                                        <SpsTableHeader className=\"text-right\">Actions</SpsTableHeader>\n                                    </SpsTableRow>\n                                </SpsTableHead>\n                                <SpsTableBody>\n                                    {items.map((row, index) => {\n                                        return (\n                                            <SpsTableRow key={index}>\n                                                <SpsTableCell><SpsToggle /></SpsTableCell>\n                                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                                <SpsTableCell className=\"text-right\" buttonCell>\n                                                    <SpsButton kind=\"icon\" icon=\"ellipses\" />\n                                                </SpsTableCell>\n                                            </SpsTableRow>\n                                        );\n                                    })}\n                                </SpsTableBody>\n                            </SpsTable>\n                        );\n                    }\n                "]))),
            },
        },
    },
    pinnedColumns: {
        label: "Pinned Columns",
        description: "When certain columns existing in a Horizontal Scrolling table, certain columns on the left or right of the table may need to be pinned in place to maintain visibility while the user scrolls.",
        examples: {
            controls: {
                react: code(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject$z(["\n                  function DemoComponent() {\n                    const [allRowsChecked, setAllRowsChecked] = React.useState(false);\n\n                    const items = [\n                      {\n                        spine: 2,\n                        title: \"Seven Samurai\",\n                        year: 1954,\n                        director: \"Akira Kurosawa\",\n                        runtime: 207,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"Japan\",\n                        languages: \"Japanese\",\n                        price: 39.96,\n                      },\n                      {\n                        spine: 29,\n                        title: \"Picnic at Hanging Rock\",\n                        year: 1975,\n                        director: \"Peter Weir\",\n                        runtime: 107,\n                        aspect_ratio: \"1.78:1\",\n                        countries: \"Australia\",\n                        languages: \"English\",\n                        price: 39.95,\n                      },\n                      {\n                        spine: 62,\n                        title: \"The Passion of Joan of Arc\",\n                        year: 1928,\n                        director: \"Carl Theodor Dreyer\",\n                        runtime: 81,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"France\",\n                        languages: \"French\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 484,\n                        title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                        year: 1975,\n                        director: \"Chantal Akerman\",\n                        runtime: 201,\n                        aspect_ratio: \"1.66:1\",\n                        countries: \"France, Belgium\",\n                        languages: \"French\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 701,\n                        title: \"Persona\",\n                        year: 1966,\n                        director: \"Ingmar Bergman\",\n                        runtime: 83,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Sweden\",\n                        languages: \"Swedish\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 740,\n                        title: \"The Bitter Tears of Petra von Kant\",\n                        year: 1972,\n                        director: \"Rainer Werner Fassbinder\",\n                        runtime: 125,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"West Germany\",\n                        languages: \"German\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 782,\n                        title: \"The Apu Trilogy\",\n                        year: 1959,\n                        director: \"Satyajit Ray\",\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"India\",\n                        languages: \"Bengali\",\n                        price: 79.96,\n                      },\n                      {\n                        spine: 888,\n                        title: \"Stalker\",\n                        year: 1979,\n                        director: \"Andrei Tarkovsky\",\n                        runtime: 161,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Soviet Union\",\n                        languages: \"Russian\",\n                        price: 31.96,\n                      },                  \n                    ]\n                    return (\n                      <SpsTable selectable={true}>\n                        <SpsTableHead>\n                          <SpsTableRow>\n                            <SpsTableHeader pinned controlCell>\n                              <SpsCheckbox checked={allRowsChecked} onChange={() => setAllRowsChecked((prev) => !prev) } />\n                            </SpsTableHeader>\n                            <SpsTableHeader pinned controlCell>\n                              <SpsToggle />\n                            </SpsTableHeader>\n                            <SpsTableHeader>Spine #</SpsTableHeader>\n                            <SpsTableHeader>Title</SpsTableHeader>\n                            <SpsTableHeader>Director</SpsTableHeader>\n                            <SpsTableHeader>Year</SpsTableHeader>\n                            <SpsTableHeader>Countries</SpsTableHeader>\n                            <SpsTableHeader>Languages</SpsTableHeader>\n                            <SpsTableHeader>Run time</SpsTableHeader>\n                            <SpsTableHeader>Aspect Ratio</SpsTableHeader>\n                            <SpsTableHeader>Price</SpsTableHeader>\n                            <SpsTableHeader className=\"text-right\" pinned>\n                              Actions\n                            </SpsTableHeader>\n                          </SpsTableRow>\n                        </SpsTableHead>\n                        <SpsTableBody>\n                          {items.map((row, index) => {\n                            return (\n                              <SpsTableRow key={index}>\n                                <SpsTableCell controlCell pinned>\n                                  <SpsCheckbox checked={allRowsChecked} />\n                                </SpsTableCell>\n                                <SpsTableCell controlCell pinned>\n                                  <SpsToggle />\n                                </SpsTableCell>\n                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"languages\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"runtime\"] ? row[\"runtime\"] + \" minutes\" : \"\"}</SpsTableCell>\n                                <SpsTableCell>{row[\"aspect_ratio\"]}</SpsTableCell>\n                                <SpsTableCell>${row[\"price\"]}</SpsTableCell>\n                                <SpsTableCell className=\"text-right\" buttonCell pinned>\n                                  <SpsButton kind=\"icon\" icon=\"ellipses\" />\n                                </SpsTableCell>\n                              </SpsTableRow>\n                              )\n                          })}\n                        </SpsTableBody>\n                      </SpsTable>\n                    )\n                  }\n                "], ["\n                  function DemoComponent() {\n                    const [allRowsChecked, setAllRowsChecked] = React.useState(false);\n\n                    const items = [\n                      {\n                        spine: 2,\n                        title: \"Seven Samurai\",\n                        year: 1954,\n                        director: \"Akira Kurosawa\",\n                        runtime: 207,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"Japan\",\n                        languages: \"Japanese\",\n                        price: 39.96,\n                      },\n                      {\n                        spine: 29,\n                        title: \"Picnic at Hanging Rock\",\n                        year: 1975,\n                        director: \"Peter Weir\",\n                        runtime: 107,\n                        aspect_ratio: \"1.78:1\",\n                        countries: \"Australia\",\n                        languages: \"English\",\n                        price: 39.95,\n                      },\n                      {\n                        spine: 62,\n                        title: \"The Passion of Joan of Arc\",\n                        year: 1928,\n                        director: \"Carl Theodor Dreyer\",\n                        runtime: 81,\n                        aspect_ratio: \"1.33:1\",\n                        countries: \"France\",\n                        languages: \"French\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 484,\n                        title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                        year: 1975,\n                        director: \"Chantal Akerman\",\n                        runtime: 201,\n                        aspect_ratio: \"1.66:1\",\n                        countries: \"France, Belgium\",\n                        languages: \"French\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 701,\n                        title: \"Persona\",\n                        year: 1966,\n                        director: \"Ingmar Bergman\",\n                        runtime: 83,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Sweden\",\n                        languages: \"Swedish\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 740,\n                        title: \"The Bitter Tears of Petra von Kant\",\n                        year: 1972,\n                        director: \"Rainer Werner Fassbinder\",\n                        runtime: 125,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"West Germany\",\n                        languages: \"German\",\n                        price: 31.96,\n                      },\n                      {\n                        spine: 782,\n                        title: \"The Apu Trilogy\",\n                        year: 1959,\n                        director: \"Satyajit Ray\",\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"India\",\n                        languages: \"Bengali\",\n                        price: 79.96,\n                      },\n                      {\n                        spine: 888,\n                        title: \"Stalker\",\n                        year: 1979,\n                        director: \"Andrei Tarkovsky\",\n                        runtime: 161,\n                        aspect_ratio: \"1.37:1\",\n                        countries: \"Soviet Union\",\n                        languages: \"Russian\",\n                        price: 31.96,\n                      },                  \n                    ]\n                    return (\n                      <SpsTable selectable={true}>\n                        <SpsTableHead>\n                          <SpsTableRow>\n                            <SpsTableHeader pinned controlCell>\n                              <SpsCheckbox checked={allRowsChecked} onChange={() => setAllRowsChecked((prev) => !prev) } />\n                            </SpsTableHeader>\n                            <SpsTableHeader pinned controlCell>\n                              <SpsToggle />\n                            </SpsTableHeader>\n                            <SpsTableHeader>Spine #</SpsTableHeader>\n                            <SpsTableHeader>Title</SpsTableHeader>\n                            <SpsTableHeader>Director</SpsTableHeader>\n                            <SpsTableHeader>Year</SpsTableHeader>\n                            <SpsTableHeader>Countries</SpsTableHeader>\n                            <SpsTableHeader>Languages</SpsTableHeader>\n                            <SpsTableHeader>Run time</SpsTableHeader>\n                            <SpsTableHeader>Aspect Ratio</SpsTableHeader>\n                            <SpsTableHeader>Price</SpsTableHeader>\n                            <SpsTableHeader className=\"text-right\" pinned>\n                              Actions\n                            </SpsTableHeader>\n                          </SpsTableRow>\n                        </SpsTableHead>\n                        <SpsTableBody>\n                          {items.map((row, index) => {\n                            return (\n                              <SpsTableRow key={index}>\n                                <SpsTableCell controlCell pinned>\n                                  <SpsCheckbox checked={allRowsChecked} />\n                                </SpsTableCell>\n                                <SpsTableCell controlCell pinned>\n                                  <SpsToggle />\n                                </SpsTableCell>\n                                <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"languages\"]}</SpsTableCell>\n                                <SpsTableCell>{row[\"runtime\"] ? row[\"runtime\"] + \" minutes\" : \"\"}</SpsTableCell>\n                                <SpsTableCell>{row[\"aspect_ratio\"]}</SpsTableCell>\n                                <SpsTableCell>\\${row[\"price\"]}</SpsTableCell>\n                                <SpsTableCell className=\"text-right\" buttonCell pinned>\n                                  <SpsButton kind=\"icon\" icon=\"ellipses\" />\n                                </SpsTableCell>\n                              </SpsTableRow>\n                              )\n                          })}\n                        </SpsTableBody>\n                      </SpsTable>\n                    )\n                  }\n                "]))),
            },
        },
    },
    stickyHeaders: {
        label: "Sticky Headers",
        examples: {
            basic: {
                react: code(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject$z(["\n                    function DemoComponent() {\n                      const items = [\n                          {\n                            spine: 2,\n                            title: \"Seven Samurai\",\n                            year: 1954,\n                            director: \"Akira Kurosawa\",\n                            runtime: 207,\n                            aspect_ratio: \"1.33:1\",\n                            countries: \"Japan\",\n                            languages: \"Japanese\",\n                            price: \"$39.96\"\n                          },\n                          {\n                            spine: 29,\n                            title: \"Picnic at Hanging Rock\",\n                            year: 1975,\n                            director: \"Peter Weir\",\n                            runtime: 107,\n                            aspect_ratio: \"1.78:1\",\n                            countries: \"Australia\",\n                            languages: \"English\",\n                            price: \"$39.95\"\n                          },\n                          {\n                            spine: 62,\n                            title: \"The Passion of Joan of Arc\",\n                            year: 1928,\n                            director: \"Carl Theodor Dreyer\",\n                            runtime: 81,\n                            aspect_ratio: \"1.33:1\",\n                            countries: \"France\",\n                            languages: \"French\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 484,\n                            title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                            year: 1975,\n                            director: \"Chantal Akerman\",\n                            runtime: 201,\n                            aspect_ratio: \"1.66:1\",\n                            countries: \"France, Belgium\",\n                            languages: \"French\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 701,\n                            title: \"Persona\",\n                            year: 1966,\n                            director: \"Ingmar Bergman\",\n                            runtime: 83,\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"Sweden\",\n                            languages: \"Swedish\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 740,\n                            title: \"The Bitter Tears of Petra von Kant\",\n                            year: 1972,\n                            director: \"Rainer Werner Fassbinder\",\n                            runtime: 125,\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"West Germany\",\n                            languages: \"German\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 782,\n                            title: \"The Apu Trilogy\",\n                            year: 1959,\n                            director: \"Satyajit Ray\",\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"India\",\n                            languages: \"Bengali\",\n                            price: \"$79.96\"\n                          },\n                          {\n                            spine: 888,\n                            title: \"Stalker\",\n                            year: 1979,\n                            director: \"Andrei Tarkovsky\",\n                            runtime: 161,\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"Soviet Union\",\n                            languages: \"Russian\",\n                            price: \"$31.96\"\n                          }\n                        ];\n\n                      const [sort, setSort] = React.useState([{ key: \"title\", direction: SortDirection.ASCENDING }]);\n\n                      function ignoreArticles(value) {\n                        return typeof value === \"string\"\n                          ? value.replace(/^(The|A) /, \"\")\n                          : value\n                      }\n        \n                      const sortedItems = React.useMemo(() => {\n                        const [{key, direction}] = sort;\n                        return [...items].sort((a, b) =>\n                          (direction === SortDirection.ASCENDING ? 1 : -1)\n                          * (ignoreArticles(a[key]) >= ignoreArticles(b[key]) ? 1 : -1)\n                        );\n                      }, [sort]);\n\n                      return (\n                        <SpsTable sort={sort} onSortChange={setSort}>\n                            <SpsTableHead pinned>\n                                <SpsTableRow>\n                                    <SpsTableHeader sortKey=\"spine\">Spine#</SpsTableHeader>\n                                    <SpsTableHeader sortKey=\"title\">Title</SpsTableHeader>\n                                    <SpsTableHeader sortKey=\"year\">Year</SpsTableHeader>\n                                    <SpsTableHeader sortKey=\"director\">Director</SpsTableHeader>\n                                    <SpsTableHeader>Runtime</SpsTableHeader>\n                                    <SpsTableHeader>Aspect Ratio</SpsTableHeader>\n                                    <SpsTableHeader>Countries</SpsTableHeader>\n                                    <SpsTableHeader>Languages</SpsTableHeader>\n                                    <SpsTableHeader className=\"text-right\">Price</SpsTableHeader>\n                                </SpsTableRow>\n                            </SpsTableHead>\n                            <SpsTableBody>\n                                {sortedItems.map((row, index) => {\n                                    return (\n                                        <SpsTableRow key={index}>\n                                            <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"runtime\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"aspect_ratio\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"languages\"]}</SpsTableCell>\n                                            <SpsTableCell className=\"text-right\">{row[\"price\"]}</SpsTableCell>\n                                        </SpsTableRow>\n                                    );\n                                })}\n                            </SpsTableBody>\n                        </SpsTable>\n                      );\n                  }\n                "], ["\n                    function DemoComponent() {\n                      const items = [\n                          {\n                            spine: 2,\n                            title: \"Seven Samurai\",\n                            year: 1954,\n                            director: \"Akira Kurosawa\",\n                            runtime: 207,\n                            aspect_ratio: \"1.33:1\",\n                            countries: \"Japan\",\n                            languages: \"Japanese\",\n                            price: \"$39.96\"\n                          },\n                          {\n                            spine: 29,\n                            title: \"Picnic at Hanging Rock\",\n                            year: 1975,\n                            director: \"Peter Weir\",\n                            runtime: 107,\n                            aspect_ratio: \"1.78:1\",\n                            countries: \"Australia\",\n                            languages: \"English\",\n                            price: \"$39.95\"\n                          },\n                          {\n                            spine: 62,\n                            title: \"The Passion of Joan of Arc\",\n                            year: 1928,\n                            director: \"Carl Theodor Dreyer\",\n                            runtime: 81,\n                            aspect_ratio: \"1.33:1\",\n                            countries: \"France\",\n                            languages: \"French\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 484,\n                            title: \"Jeanne Dielman, 23, quai du Commerce, 1080 Bruxelles\",\n                            year: 1975,\n                            director: \"Chantal Akerman\",\n                            runtime: 201,\n                            aspect_ratio: \"1.66:1\",\n                            countries: \"France, Belgium\",\n                            languages: \"French\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 701,\n                            title: \"Persona\",\n                            year: 1966,\n                            director: \"Ingmar Bergman\",\n                            runtime: 83,\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"Sweden\",\n                            languages: \"Swedish\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 740,\n                            title: \"The Bitter Tears of Petra von Kant\",\n                            year: 1972,\n                            director: \"Rainer Werner Fassbinder\",\n                            runtime: 125,\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"West Germany\",\n                            languages: \"German\",\n                            price: \"$31.96\"\n                          },\n                          {\n                            spine: 782,\n                            title: \"The Apu Trilogy\",\n                            year: 1959,\n                            director: \"Satyajit Ray\",\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"India\",\n                            languages: \"Bengali\",\n                            price: \"$79.96\"\n                          },\n                          {\n                            spine: 888,\n                            title: \"Stalker\",\n                            year: 1979,\n                            director: \"Andrei Tarkovsky\",\n                            runtime: 161,\n                            aspect_ratio: \"1.37:1\",\n                            countries: \"Soviet Union\",\n                            languages: \"Russian\",\n                            price: \"$31.96\"\n                          }\n                        ];\n\n                      const [sort, setSort] = React.useState([{ key: \"title\", direction: SortDirection.ASCENDING }]);\n\n                      function ignoreArticles(value) {\n                        return typeof value === \"string\"\n                          ? value.replace(/^(The|A) /, \"\")\n                          : value\n                      }\n        \n                      const sortedItems = React.useMemo(() => {\n                        const [{key, direction}] = sort;\n                        return [...items].sort((a, b) =>\n                          (direction === SortDirection.ASCENDING ? 1 : -1)\n                          * (ignoreArticles(a[key]) >= ignoreArticles(b[key]) ? 1 : -1)\n                        );\n                      }, [sort]);\n\n                      return (\n                        <SpsTable sort={sort} onSortChange={setSort}>\n                            <SpsTableHead pinned>\n                                <SpsTableRow>\n                                    <SpsTableHeader sortKey=\"spine\">Spine#</SpsTableHeader>\n                                    <SpsTableHeader sortKey=\"title\">Title</SpsTableHeader>\n                                    <SpsTableHeader sortKey=\"year\">Year</SpsTableHeader>\n                                    <SpsTableHeader sortKey=\"director\">Director</SpsTableHeader>\n                                    <SpsTableHeader>Runtime</SpsTableHeader>\n                                    <SpsTableHeader>Aspect Ratio</SpsTableHeader>\n                                    <SpsTableHeader>Countries</SpsTableHeader>\n                                    <SpsTableHeader>Languages</SpsTableHeader>\n                                    <SpsTableHeader className=\"text-right\">Price</SpsTableHeader>\n                                </SpsTableRow>\n                            </SpsTableHead>\n                            <SpsTableBody>\n                                {sortedItems.map((row, index) => {\n                                    return (\n                                        <SpsTableRow key={index}>\n                                            <SpsTableCell>{row[\"spine\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"title\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"year\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"director\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"runtime\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"aspect_ratio\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"countries\"]}</SpsTableCell>\n                                            <SpsTableCell>{row[\"languages\"]}</SpsTableCell>\n                                            <SpsTableCell className=\"text-right\">{row[\"price\"]}</SpsTableCell>\n                                        </SpsTableRow>\n                                    );\n                                })}\n                            </SpsTableBody>\n                        </SpsTable>\n                      );\n                  }\n                "]))),
            },
        },
    },
};
var templateObject_1$z, templateObject_2$v, templateObject_3$q, templateObject_4$j, templateObject_5$b, templateObject_6$8, templateObject_7$7, templateObject_8$6;

var __makeTemplateObject$y = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsTagExamples = {
    basic: {
        label: "Basic Tag",
        examples: {
            basic: {
                react: code(templateObject_1$y || (templateObject_1$y = __makeTemplateObject$y(["\n                    import { SpsTag } from \"@spscommerce/ds-react\";\n                    import { TagKind } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsTag className=\"mr-1 mb-1\">Default</SpsTag>\n                          <SpsTag kind={TagKind.KEY} className=\"mr-1 mb-1\">\n                            Key\n                          </SpsTag>\n                          <SpsTag kind={TagKind.WARNING} className=\"mr-1 mb-1\">\n                            Warning\n                          </SpsTag>\n                          <SpsTag kind={TagKind.ERROR} className=\"mr-1 mb-1\">\n                            Error\n                          </SpsTag>\n                          <SpsTag kind={TagKind.PENDING} className=\"mr-1 mb-1\">\n                            Pending\n                          </SpsTag>\n                          <SpsTag kind={TagKind.SUCCESS} className=\"mr-1 mb-1\">\n                            Success\n                          </SpsTag>\n                          <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">\n                            Info\n                          </SpsTag>\n                        </>\n                      );\n                    }\n                "], ["\n                    import { SpsTag } from \"@spscommerce/ds-react\";\n                    import { TagKind } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsTag className=\"mr-1 mb-1\">Default</SpsTag>\n                          <SpsTag kind={TagKind.KEY} className=\"mr-1 mb-1\">\n                            Key\n                          </SpsTag>\n                          <SpsTag kind={TagKind.WARNING} className=\"mr-1 mb-1\">\n                            Warning\n                          </SpsTag>\n                          <SpsTag kind={TagKind.ERROR} className=\"mr-1 mb-1\">\n                            Error\n                          </SpsTag>\n                          <SpsTag kind={TagKind.PENDING} className=\"mr-1 mb-1\">\n                            Pending\n                          </SpsTag>\n                          <SpsTag kind={TagKind.SUCCESS} className=\"mr-1 mb-1\">\n                            Success\n                          </SpsTag>\n                          <SpsTag kind={TagKind.INFO} className=\"mr-1 mb-1\">\n                            Info\n                          </SpsTag>\n                        </>\n                      );\n                    }\n                "]))),
            },
        },
    },
    withIcon: {
        label: "Tag with icon",
        examples: {
            basic: {
                react: code(templateObject_2$u || (templateObject_2$u = __makeTemplateObject$y(["\n                    import { SpsTag } from \"@spscommerce/ds-react\";\n                    import { TagKind, SpsIcon } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsTag icon={SpsIcon.INFO_CIRCLE} className=\"mr-1 mb-1\">\n                            Default\n                          </SpsTag>\n                          <SpsTag icon={SpsIcon.CHECKMARK} kind={TagKind.KEY} className=\"mr-1 mb-1\">\n                            Key\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.EXCLAMATION_TRIANGLE}\n                            kind={TagKind.WARNING}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Warning\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.EXCLAMATION_CIRCLE}\n                            kind={TagKind.ERROR}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Error\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.ELLIPSES}\n                            kind={TagKind.PENDING}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Pending\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.CHECKMARK}\n                            kind={TagKind.SUCCESS}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Success\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.INFO_CIRCLE}\n                            kind={TagKind.INFO}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Info\n                          </SpsTag>\n                        </>\n                      );\n                    }\n                "], ["\n                    import { SpsTag } from \"@spscommerce/ds-react\";\n                    import { TagKind, SpsIcon } from \"@spscommerce/ds-shared\";\n                    function Component() {\n                      return (\n                        <>\n                          <SpsTag icon={SpsIcon.INFO_CIRCLE} className=\"mr-1 mb-1\">\n                            Default\n                          </SpsTag>\n                          <SpsTag icon={SpsIcon.CHECKMARK} kind={TagKind.KEY} className=\"mr-1 mb-1\">\n                            Key\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.EXCLAMATION_TRIANGLE}\n                            kind={TagKind.WARNING}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Warning\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.EXCLAMATION_CIRCLE}\n                            kind={TagKind.ERROR}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Error\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.ELLIPSES}\n                            kind={TagKind.PENDING}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Pending\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.CHECKMARK}\n                            kind={TagKind.SUCCESS}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Success\n                          </SpsTag>\n                          <SpsTag\n                            icon={SpsIcon.INFO_CIRCLE}\n                            kind={TagKind.INFO}\n                            className=\"mr-1 mb-1\"\n                          >\n                            Info\n                          </SpsTag>\n                        </>\n                      );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$y, templateObject_2$u;

var __makeTemplateObject$x = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsListActionBarExamples = {
    general: {
        label: "General Usage",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "The Action Bar is divided into three sections: Selection Counter, Action Buttons, and Clear Button. It spans the entire width of the browser window. The count in the Selection Counter persists across paginated views"),
                React.createElement("p", null,
                    "For more information on acceptable content varieties in the Action Buttons section, refer to the Button Groups section on the",
                    " ",
                    React.createElement(NavigateTo, { to: "button" }, "Buttons"),
                    " page"),
                React.createElement("img", { src: "assets/images/list-action-bar-example.svg", alt: "A List Action Bar with labels on each section", className: "w-100 mb-3" }),
                React.createElement(SpsTable, null,
                    React.createElement(SpsTableHead, null,
                        React.createElement(SpsTableHeader, null, "Order"),
                        React.createElement(SpsTableHeader, null, "Section"),
                        React.createElement(SpsTableHeader, null, "Content Varieties")),
                    React.createElement(SpsTableBody, null,
                        React.createElement(SpsTableRow, null,
                            React.createElement(SpsTableCell, null,
                                React.createElement("span", { className: "sps-tag sps-tag--info" }, "1")),
                            React.createElement(SpsTableCell, null, "Selection Counter"),
                            React.createElement(SpsTableCell, null)),
                        React.createElement(SpsTableRow, null,
                            React.createElement(SpsTableCell, null,
                                React.createElement("span", { className: "sps-tag sps-tag--info" }, "2")),
                            React.createElement(SpsTableCell, null, "Action Buttons"),
                            React.createElement(SpsTableCell, null)),
                        React.createElement(SpsTableRow, null,
                            React.createElement(SpsTableCell, null,
                                React.createElement("span", { className: "sps-tag sps-tag--info" }, "3")),
                            React.createElement(SpsTableCell, null, "Clear Button"),
                            React.createElement(SpsTableCell, null,
                                React.createElement(SpsTag, { className: "mr-1" }, "Basic Buttons"),
                                React.createElement(SpsTag, { className: "mr-1" }, "Icon Buttons"),
                                React.createElement(SpsTag, { className: "mr-1" }, "Text Buttons")))))));
        },
    },
    actionBar: {
        label: "Action Bar",
        description: "This example makes use of the Text Buttons + Icon Buttons + Basic Buttons Group.",
        examples: {
            basic: {
                react: code(templateObject_1$x || (templateObject_1$x = __makeTemplateObject$x(["\n                    function SpsActionBarExample() {\n                        const [itemsSelected, setItemsSelected] = React.useState(0);\n\n                        function handleClear() {\n                            setItemsSelected(0);\n                        }\n\n                        function showExample() {\n                            setItemsSelected(3);\n                        }\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={showExample}>Show Action Bar</SpsButton>\n                                <SpsListActionBar itemsSelected={itemsSelected} clearSelected={handleClear}>\n                                    <SpsButton kind={ButtonKind.LINK}>Text Button</SpsButton>\n                                    <SpsVr style={{ marginLeft: \"15px\" }} />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.PRINTER} aria-label=\"Print\" />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD} aria-label=\"Download\" />\n                                    <SpsVr style={{ marginRight: \"15px\" }} />\n                                    <SpsButton className=\"mr-1\">Button</SpsButton>\n                                    <SpsButton kind={ButtonKind.KEY} className=\"mr-1\">Button</SpsButton>\n                                    <SpsButton kind={ButtonKind.CONFIRM} className=\"mr-1\">Button</SpsButton>\n                                </SpsListActionBar>\n                            </>\n                        )\n                    }\n                "], ["\n                    function SpsActionBarExample() {\n                        const [itemsSelected, setItemsSelected] = React.useState(0);\n\n                        function handleClear() {\n                            setItemsSelected(0);\n                        }\n\n                        function showExample() {\n                            setItemsSelected(3);\n                        }\n\n                        return (\n                            <>\n                                <SpsButton kind={ButtonKind.LINK} onClick={showExample}>Show Action Bar</SpsButton>\n                                <SpsListActionBar itemsSelected={itemsSelected} clearSelected={handleClear}>\n                                    <SpsButton kind={ButtonKind.LINK}>Text Button</SpsButton>\n                                    <SpsVr style={{ marginLeft: \"15px\" }} />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.PRINTER} aria-label=\"Print\" />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD} aria-label=\"Download\" />\n                                    <SpsVr style={{ marginRight: \"15px\" }} />\n                                    <SpsButton className=\"mr-1\">Button</SpsButton>\n                                    <SpsButton kind={ButtonKind.KEY} className=\"mr-1\">Button</SpsButton>\n                                    <SpsButton kind={ButtonKind.CONFIRM} className=\"mr-1\">Button</SpsButton>\n                                </SpsListActionBar>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$x;

var __assign$11 = (undefined && undefined.__assign) || function () {
    __assign$11 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$11.apply(this, arguments);
};
var __rest$Q = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$s = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propTypes$Z = __assign$11(__assign$11({}, spsGlobalPropTypes), { tabs: propTypes$1H.exports.arrayOf(impl()).isRequired, activeTab: impl(), onTabChange: fun() });
function SpsTabs(props) {
    var tabs = props.tabs, activeTab = props.activeTab, onTabChange = props.onTabChange, className = props.className, unsafelyReplaceClassName = props.unsafelyReplaceClassName, testId = props["data-testid"], rest = __rest$Q(props, ["tabs", "activeTab", "onTabChange", "className", "unsafelyReplaceClassName", "data-testid"]);
    var _a = __read$s(React.useState(null), 2), activeTabState = _a[0], setActiveTabState = _a[1];
    React.useEffect(function () {
        if (tabs.length) {
            if (activeTab) {
                var obj = tabs.find(function (tab) { return tab.label === activeTab.label; });
                setActiveTabState(obj);
            }
            else {
                setActiveTabState(tabs[0]);
            }
        }
    }, []);
    var onTabClick = function (event, tab) {
        event.preventDefault();
        setActiveTabState(tab);
        if (typeof onTabChange === "function") {
            onTabChange(tab);
        }
    };
    var classes = clsx(unsafelyReplaceClassName || "sps-tabs", className);
    return (React.createElement("div", { className: classes },
        React.createElement("nav", __assign$11({ className: "sps-nav sps-nav--tabs", "data-testid": testId }, rest), tabs.map(function (tab) { return (React.createElement("a", { key: tab.label, id: tab.id, className: clsx("sps-nav__item", "sps-nav__link", tab === activeTabState && "active"), role: "tab", "data-toggle": "tab", href: tab.controlsId ? "#" + tab.controlsId : null, "aria-controls": tab.controlsId, "aria-selected": tab === activeTab, onClick: function (e) {
                onTabClick(e, tab);
            }, "data-testid": testId + "__tab-link" },
            tab.icon && React.createElement("i", { className: "sps-icon sps-icon-" + tab.icon }),
            React.createElement("span", null, tab.label),
            tab.tag && React.createElement("span", { className: "sps-tag sps-tag--key" }, tab.tag))); }))));
}
Object.assign(SpsTabs, {
    propTypes: propTypes$Z,
    displayName: "SpsTabs",
});

var __assign$10 = (undefined && undefined.__assign) || function () {
    __assign$10 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$10.apply(this, arguments);
};
var __rest$P = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$r = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$W = {
    formMeta: "SpsFormSetMeta<any>",
    stacked: "boolean",
};
var propTypes$Y = __assign$10(__assign$10({}, spsGlobalPropTypes), { formArray: impl(), formGroup: impl(), formMeta: impl(), stacked: propTypes$1H.exports.bool });
function SpsInputGroup(_a) {
    var children = _a.children, className = _a.className, formArray = _a.formArray, formGroup = _a.formGroup, formMeta = _a.formMeta, stacked = _a.stacked, testId = _a["data-testid"], unsafelyReplaceClassName = _a.unsafelyReplaceClassName, rest = __rest$P(_a, ["children", "className", "formArray", "formGroup", "formMeta", "stacked", "data-testid", "unsafelyReplaceClassName"]);
    var formControlSet = formGroup || formArray;
    var eitherMetaObject = formControlSet || formMeta;
    var _b = __read$r(React.useState(false), 2), wasFocused = _b[0], setWasFocused = _b[1];
    React.useEffect(function () {
        if (eitherMetaObject) {
            var isFocused = eitherMetaObject.isFocused();
            if (!wasFocused && isFocused && eitherMetaObject.onFocus) {
                eitherMetaObject.onFocus();
            }
            else if (wasFocused && !isFocused && eitherMetaObject.onBlur) {
                eitherMetaObject.onBlur();
            }
            setWasFocused(isFocused);
        }
    });
    var classes = clsx(unsafelyReplaceClassName || "sps-form-group", ((formControlSet && formControlSet.invalid)
        || (formMeta && (!formMeta.isValid() || !formMeta.contentsAreValid()))) && "sps-form-group--error", className);
    return (React.createElement("div", __assign$10({ className: classes, "data-testid": testId }, rest),
        React.createElement("div", { className: clsx("sps-input-group", stacked && "sps-input-group--stacked") }, children)));
}
Object.assign(SpsInputGroup, {
    props: propsDoc$W,
    propTypes: propTypes$Y,
    displayName: "SpsInputGroup",
});

var __assign$$ = (undefined && undefined.__assign) || function () {
    __assign$$ = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$$.apply(this, arguments);
};
var propsDoc$V = {
    onSubmit: "FormEventHandler",
};
var propTypes$X = __assign$$(__assign$$({}, spsGlobalPropTypes), { onSubmit: fun() });
function SpsListToolbarSearch(props) {
    var children = props.children, onSubmit = props.onSubmit;
    function handleSubmit(event) {
        event.preventDefault();
        if (onSubmit) {
            onSubmit(event);
        }
    }
    return (React.createElement("form", { onSubmit: handleSubmit, className: "sps-list-toolbar__search-form", noValidate: true },
        React.createElement(SpsInputGroup, { className: "sps-list-toolbar__search-field" }, children)));
}
Object.assign(SpsListToolbarSearch, {
    props: propsDoc$V,
    propTypes: propTypes$X,
    displayName: "SpsListToolbarSearch",
});

var __assign$_ = (undefined && undefined.__assign) || function () {
    __assign$_ = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$_.apply(this, arguments);
};
var propsDoc$U = {};
var propTypes$W = __assign$_({}, spsGlobalPropTypes);
function SpsListToolbarSearchInfo(props) {
    var children = props.children;
    return (React.createElement("div", null, children));
}
Object.assign(SpsListToolbarSearchInfo, {
    props: propsDoc$U,
    propTypes: propTypes$W,
    displayName: "SpsListToolbarSearchInfo",
});

var __assign$Z = (undefined && undefined.__assign) || function () {
    __assign$Z = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$Z.apply(this, arguments);
};
var __rest$O = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$q = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$T = {
    activeTab: "SpsTab",
    advancedSearch: "{ isOpen: boolean, enteredFields: number }",
    onToggleAdvancedSearch: "(boolean) => void",
    onTabChange: "(SpsTab) => void",
    title: "string",
    tabs: "Array<SpsTab>",
    onToolbarPinned: "(boolean) => void",
    selectable: "boolean",
    isSelected: "boolean",
    isIndeterminate: "boolean",
    onSelectionChange: "(boolean) => void",
};
var propTypes$V = __assign$Z(__assign$Z({}, spsGlobalPropTypes), { activeTab: impl(), advancedSearch: propTypes$1H.exports.shape({
        isOpen: propTypes$1H.exports.bool,
        enteredFields: propTypes$1H.exports.number,
    }), onToggleAdvancedSearch: fun(), onTabChange: fun(), title: propTypes$1H.exports.string, tabs: propTypes$1H.exports.arrayOf(impl()), onToolbarPinned: fun(), selectable: propTypes$1H.exports.bool, isSelected: propTypes$1H.exports.bool, isIndeterminate: propTypes$1H.exports.bool, onSelectionChange: fun() });
function SpsListToolbar(props) {
    var activeTab = props.activeTab, advancedSearch = props.advancedSearch, children = props.children, className = props.className, onToggleAdvancedSearch = props.onToggleAdvancedSearch, onTabChange = props.onTabChange, tabs = props.tabs, title = props.title, unsafelyReplaceClassName = props.unsafelyReplaceClassName, onToolbarPinned = props.onToolbarPinned, selectable = props.selectable, isSelected = props.isSelected, isIndeterminate = props.isIndeterminate, onSelectionChange = props.onSelectionChange, testId = props["data-testid"], rest = __rest$O(props, ["activeTab", "advancedSearch", "children", "className", "onToggleAdvancedSearch", "onTabChange", "tabs", "title", "unsafelyReplaceClassName", "onToolbarPinned", "selectable", "isSelected", "isIndeterminate", "onSelectionChange", "data-testid"]);
    var t = React.useContext(I18nContext).t;
    var unpinScrollY = null;
    var _a = __read$q(React.useState(false), 2), isPinned = _a[0], setIsPinned = _a[1];
    var rootElement = React.useRef();
    var wrapperElement = React.useRef();
    var onScroll = lockToAnimationFrames(function () {
        if (rootElement.current) {
            var rect = rootElement.current.getBoundingClientRect();
            if (rect && rect.height > 0 && rect.top <= 60) {
                if (typeof unpinScrollY === "number") {
                    if (window.scrollY < unpinScrollY) {
                        unpinScrollY = null;
                        setIsPinned(false);
                    }
                }
                else {
                    unpinScrollY = window.scrollY;
                    setIsPinned(true);
                    if (onToggleAdvancedSearch) {
                        onToggleAdvancedSearch(false);
                    }
                }
            }
        }
    });
    React.useEffect(function () {
        window.addEventListener("scroll", onScroll);
        return function () {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);
    var unpinnedStyles = React.useRef(null);
    React.useLayoutEffect(function () {
        if (isPinned && unpinnedStyles.current) {
            wrapperElement.current.style.height = unpinnedStyles.current.height;
            wrapperElement.current.style.width = unpinnedStyles.current.width;
            wrapperElement.current.style.marginBottom = unpinnedStyles.current.marginBottom;
        }
        else if (!isPinned) {
            wrapperElement.current.style.height = null;
            wrapperElement.current.style.width = null;
            wrapperElement.current.style.marginBottom = null;
            var rootComputedStyles = window.getComputedStyle(rootElement.current);
            unpinnedStyles.current = {
                height: rootComputedStyles.height,
                width: rootComputedStyles.width,
                marginBottom: rootComputedStyles.marginBottom,
            };
        }
    }, [isPinned]);
    function handleTabChange(tab) {
        if (onTabChange) {
            onTabChange(tab);
        }
    }
    function toggleAdvancedSearch() {
        if (onToggleAdvancedSearch) {
            onToggleAdvancedSearch(!advancedSearch.isOpen);
        }
    }
    function emitToolbarPinned(status) {
        if (onToolbarPinned) {
            onToolbarPinned(status);
        }
    }
    React.useEffect(function () {
        emitToolbarPinned(isPinned);
    }, [isPinned]);
    var classes = clsx(unsafelyReplaceClassName || "sps-list-toolbar", isPinned && "sps-list-toolbar--pinned", isPinned && "z-stratum-bar", advancedSearch && advancedSearch.isOpen && "sps-list-toolbar--advanced-search-open", className);
    var _b = __read$q(selectChildren(children, [
        { type: SpsListToolbarSearch }, { type: SpsListToolbarSearchInfo },
    ]), 3), listToolbarSearch = _b[0], listToolbarSearchInfo = _b[1], otherChildren = _b[2];
    return (React.createElement("div", { className: "sps-list-toolbar__wrapper", ref: wrapperElement },
        React.createElement("div", __assign$Z({ className: classes, "data-testid": testId, ref: rootElement }, rest),
            !!selectable && (React.createElement("div", { className: "sps-list-toolbar__selection-controls" },
                React.createElement(SpsCheckbox, { checked: isSelected, indeterminate: isIndeterminate, onChange: function () {
                        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(!isSelected);
                    } }))),
            tabs && (React.createElement(SpsTabs, { tabs: tabs, onTabChange: handleTabChange, activeTab: activeTab, "data-testid": testId + "__tabs" })),
            React.createElement("div", { className: "sps-list-toolbar__search-controls" },
                !title && listToolbarSearch,
                !title && listToolbarSearchInfo,
                listToolbarSearch.length > 0 && advancedSearch && (React.createElement("div", { className: "sps-list-toolbar__advanced-search-toggle", "data-testid": testId + "__advanced-search" },
                    React.createElement("div", { className: "sps-list-toolbar__advanced-search-toggle-button-wrapper" },
                        React.createElement(SpsButton, { kind: ButtonKind.LINK, onClick: toggleAdvancedSearch }, t("design-system:listToolbar.advancedSearchToggle"))),
                    advancedSearch.enteredFields > 0 && (React.createElement(SpsTag, { kind: TagKind.INFO },
                        React.createElement("span", null, advancedSearch.enteredFields))))),
                title && (React.createElement("div", { "data-testid": testId + "-title", className: "sps-list-toolbar__advanced-search-title" }, title))),
            isPinned ? (React.createElement("div", { className: "sps-list-toolbar__header-content" },
                React.createElement(PortalContext.Provider, { value: { fixed: true } }, otherChildren))) : (React.createElement("div", { className: "sps-list-toolbar__header-content" }, otherChildren)))));
}
Object.assign(SpsListToolbar, {
    props: propsDoc$T,
    propTypes: propTypes$V,
    displayName: "SpsListToolbar",
});

var __makeTemplateObject$w = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read$p = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function ContentOrderExample() {
    var _a = __read$p(React.useState(false), 2), showFocusedTask = _a[0], setShowFocusedTask = _a[1];
    function onClose() {
        setShowFocusedTask(false);
    }
    function onOpen() {
        setShowFocusedTask(true);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("p", null, "The List Bar is divided into a number of different sections. It spans the entire width of the corresponding list."),
        React.createElement(SpsButton, { kind: ButtonKind.LINK, onClick: onOpen }, "View Content Order Example"),
        React.createElement(SpsFocusedTask, { isOpen: showFocusedTask, onClose: onClose },
            React.createElement("h1", null, "Content Order"),
            React.createElement("img", { src: "assets/images/list-toolbar-example.svg", alt: "A List Toolbar with labels on each section", className: "w-100 mb-3" }),
            React.createElement(SpsTable, null,
                React.createElement(SpsTableHead, null,
                    React.createElement(SpsTableHeader, { style: { width: "80px" } }, "Order"),
                    React.createElement(SpsTableHeader, null, "Section"),
                    React.createElement(SpsTableHeader, null, "Notes")),
                React.createElement(SpsTableBody, null,
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "1")),
                        React.createElement(SpsTableCell, null, "Checkbox"),
                        React.createElement(SpsTableCell, null, "For Content Rows and Content Tiles only.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "2")),
                        React.createElement(SpsTableCell, null, "Search/Filter Box"),
                        React.createElement(SpsTableCell, null)),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "3")),
                        React.createElement(SpsTableCell, null, "Saved Search"),
                        React.createElement(SpsTableCell, null)),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "4")),
                        React.createElement(SpsTableCell, null, "Advanced Search"),
                        React.createElement(SpsTableCell, null, "For more information, visit the Advanced Search page.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "5")),
                        React.createElement(SpsTableCell, null, "Column Editor"),
                        React.createElement(SpsTableCell, { wrap: 500 }, "Use for Tables only. For more information, visit the Column Editor page.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "6")),
                        React.createElement(SpsTableCell, null, "List View Selector"),
                        React.createElement(SpsTableCell, null)),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "7")),
                        React.createElement(SpsTableCell, null, "Sorting"),
                        React.createElement(SpsTableCell, null)),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "8")),
                        React.createElement(SpsTableCell, null, "Buttons"),
                        React.createElement(SpsTableCell, { wrap: 500 }, "Buttons always appear in the rightmost section of the List Toolbar. For the ordering of Buttons, refer to the Button Groups section on the Buttons page.")))))));
}
var SpsListToolbarExamples = {
    general: {
        label: "General Usage",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("h5", null, "Use a List Toolbar:"),
            React.createElement("ul", null,
                React.createElement("li", null, "When list content needs to be searched, filtered, sorted, or otherwise interacted with.")),
            React.createElement("h5", null, "Avoid a List Toolbar:"),
            React.createElement("ul", null,
                React.createElement("li", null, "When no list is present."),
                React.createElement("li", null, "When there will always be a small number of elements in the list, or the list does not require searching, filtering, or other actions.")))); },
    },
    contentOrder: {
        label: "Content Order",
        description: React.createElement(ContentOrderExample, null),
    },
    checkbox: {
        label: "Checkbox",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("p", null,
                "Use a Checkbox in the List Toolbar when items in a",
                " ",
                React.createElement(NavigateTo, { to: "Content rows" }, "Content Row"),
                " or",
                " ",
                React.createElement(NavigateTo, { to: "Content tiles" }, "Content Tile"),
                " are selectable. The Checkbox selects all items in the list, and will cause the Action Bar to appear. Do not use this with a Table, as Tables have a built-in checkbox in the header row."));
        },
        examples: {
            checkbox: {
                react: code(templateObject_1$w || (templateObject_1$w = __makeTemplateObject$w(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n                        \n                        const [selectedColors, setSelectedColors] = React.useState([]);\n                        colors = ['Red', 'Blue', 'Green']\n\n                        const isIndeterminate = selectedColors.length > 0 && selectedColors.length < colors.length\n                        const isSelected = selectedColors.length > 0\n\n                        return (\n                            <>\n                                <SpsListToolbar\n                                    selectable\n                                    isIndeterminate={isIndeterminate}\n                                    isSelected={isSelected}\n                                    onSelectionChange={() => {\n                                        if (isIndeterminate || isSelected) {\n                                            setSelectedColors([])\n                                        } else {\n                                            setSelectedColors(colors);\n                                        }\n                                    }}\n                                >\n                                    <SpsListToolbarSearch onSubmit={handleSearch}>\n                                        <SpsTextInput\n                                            value={formValue.searchText}\n                                            formMeta={formMeta.fields.searchText}\n                                            icon={SpsIcon.FILTER}\n                                            placeholder=\"Filter fields\"\n                                        />\n                                    </SpsListToolbarSearch>\n                                </SpsListToolbar>\n                                {colors.map((color) => (\n                                    <SpsCheckbox \n                                        checked={selectedColors.includes(color)} \n                                        inline \n                                        label={color} \n                                        onChange={() => {\n                                            if (selectedColors.includes(color)) {\n                                                setSelectedColors(selectedColors.filter((c) => c !== color))\n                                            } else { \n                                                setSelectedColors([...selectedColors, color])\n                                            }\n                                        }}\n                                    />\n                                ))}\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n                        \n                        const [selectedColors, setSelectedColors] = React.useState([]);\n                        colors = ['Red', 'Blue', 'Green']\n\n                        const isIndeterminate = selectedColors.length > 0 && selectedColors.length < colors.length\n                        const isSelected = selectedColors.length > 0\n\n                        return (\n                            <>\n                                <SpsListToolbar\n                                    selectable\n                                    isIndeterminate={isIndeterminate}\n                                    isSelected={isSelected}\n                                    onSelectionChange={() => {\n                                        if (isIndeterminate || isSelected) {\n                                            setSelectedColors([])\n                                        } else {\n                                            setSelectedColors(colors);\n                                        }\n                                    }}\n                                >\n                                    <SpsListToolbarSearch onSubmit={handleSearch}>\n                                        <SpsTextInput\n                                            value={formValue.searchText}\n                                            formMeta={formMeta.fields.searchText}\n                                            icon={SpsIcon.FILTER}\n                                            placeholder=\"Filter fields\"\n                                        />\n                                    </SpsListToolbarSearch>\n                                </SpsListToolbar>\n                                {colors.map((color) => (\n                                    <SpsCheckbox \n                                        checked={selectedColors.includes(color)} \n                                        inline \n                                        label={color} \n                                        onChange={() => {\n                                            if (selectedColors.includes(color)) {\n                                                setSelectedColors(selectedColors.filter((c) => c !== color))\n                                            } else { \n                                                setSelectedColors([...selectedColors, color])\n                                            }\n                                        }}\n                                    />\n                                ))}\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
    searchAndFilter: {
        label: "Search + Filter Inputs",
        description: function () { return (React.createElement("p", null, "Use Search and Filter inputs to make it easier to quickly find list items.")); },
        examples: {
            search: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h5", null, "Search"),
                    React.createElement("p", null, "Use Search to find list item(s) starting from an empty list."))); },
                react: code(templateObject_2$t || (templateObject_2$t = __makeTemplateObject$w(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
            searchAndSelect: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h5", null, "Search + Select"),
                    React.createElement("p", null, "Use Select to search for list item(s) in a particular category."))); },
                react: code(templateObject_3$p || (templateObject_3$p = __makeTemplateObject$w(["\n                    function Component() {\n                        const filterKeys = [\"Document Type\", \"Sender Name\", \"Receiver Name\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                            filterOption: filterKeys[0],\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsSelect\n                                        options={filterKeys}\n                                        formMeta={formMeta.fields.filterOption}\n                                        value={formValue.filterOption}\n                                        notClearable\n                                    />\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const filterKeys = [\"Document Type\", \"Sender Name\", \"Receiver Name\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                            filterOption: filterKeys[0],\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsSelect\n                                        options={filterKeys}\n                                        formMeta={formMeta.fields.filterOption}\n                                        value={formValue.filterOption}\n                                        notClearable\n                                    />\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
            filter: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h5", null, "Filter"),
                    React.createElement("p", null, "Use Filter to find list item(s) starting from a populated list."))); },
                react: code(templateObject_4$i || (templateObject_4$i = __makeTemplateObject$w(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        icon={SpsIcon.FILTER}\n                                        placeholder=\"Filter fields\"\n                                    />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        icon={SpsIcon.FILTER}\n                                        placeholder=\"Filter fields\"\n                                    />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
            filterAndSelect: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h5", null, "Filter + Select"),
                    React.createElement("p", null, "Use Select to filter list item(s) in a particular category."))); },
                react: code(templateObject_5$a || (templateObject_5$a = __makeTemplateObject$w(["\n                    function Component() {\n                        const filterKeys = [\"Document Type\", \"Sender Name\", \"Receiver Name\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                            filterOption: filterKeys[0],\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsSelect\n                                        options={filterKeys}\n                                        formMeta={formMeta.fields.filterOption}\n                                        value={formValue.filterOption}\n                                        notClearable\n                                    />\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        icon={SpsIcon.FILTER}\n                                        placeholder=\"Filter fields\"\n                                    />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const filterKeys = [\"Document Type\", \"Sender Name\", \"Receiver Name\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                            filterOption: filterKeys[0],\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsSelect\n                                        options={filterKeys}\n                                        formMeta={formMeta.fields.filterOption}\n                                        value={formValue.filterOption}\n                                        notClearable\n                                    />\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        icon={SpsIcon.FILTER}\n                                        placeholder=\"Filter fields\"\n                                    />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
            searchInfo: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h5", null, "Search Info"),
                    React.createElement("p", null, "Use SpsListToolbarSearchInfo component to add additional information about your search."))); },
                react: code(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject$w(["\n                    function Component() {\n                        const filterKeys = [\"Key Item ID\", \"Document Type\", \"Sender Name\", \"Receiver Name\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                            filterOption: filterKeys[0],\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsSelect\n                                        options={filterKeys}\n                                        formMeta={formMeta.fields.filterOption}\n                                        value={formValue.filterOption}\n                                        notClearable\n                                    />\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        icon={SpsIcon.FILTER}\n                                        placeholder=\"Filter fields\"\n                                    />\n                                </SpsListToolbarSearch>\n                                <SpsListToolbarSearchInfo>\n                                  <div style={{ display: 'flex', alignItems: 'center'}}>\n                                    <span  style={{ marginRight: 5 }} >\n                                      Key Item ID = Vendor Part Number\n                                    </span>\n                                    <SpsI icon={SpsIcon.INFO_CIRCLE} className=\"blue200\"/>\n                                  </div>\n                                </SpsListToolbarSearchInfo>\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const filterKeys = [\"Key Item ID\", \"Document Type\", \"Sender Name\", \"Receiver Name\"];\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                            filterOption: filterKeys[0],\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsSelect\n                                        options={filterKeys}\n                                        formMeta={formMeta.fields.filterOption}\n                                        value={formValue.filterOption}\n                                        notClearable\n                                    />\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        icon={SpsIcon.FILTER}\n                                        placeholder=\"Filter fields\"\n                                    />\n                                </SpsListToolbarSearch>\n                                <SpsListToolbarSearchInfo>\n                                  <div style={{ display: 'flex', alignItems: 'center'}}>\n                                    <span  style={{ marginRight: 5 }} >\n                                      Key Item ID = Vendor Part Number\n                                    </span>\n                                    <SpsI icon={SpsIcon.INFO_CIRCLE} className=\"blue200\"/>\n                                  </div>\n                                </SpsListToolbarSearchInfo>\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
        },
    },
    /*
     * TODO: updates needed to the list toolbar component
     * savedSearch: {
     *     label: 'Saved Search',
     *     description: () => (
     *         <p>
     *             Use the Saved Search feature to enable users to repeat a
     *              frequently-executed search query.
     *              For more information, visit the Saved Search page.
     *         </p>
     *     ),
     *     examples: {
     *         savedSearch: {
     *             react: code`
     *                 function Component() {
     *                     const { formValue, formMeta, updateForm } = useSpsForm({
     *                         searchText: "",
     *                     });
     */
    /*
     *                     function handleSearch(event) {
     *                         console.log(event, formValue.searchText)
     *                     }
     */
    /*
     *                     return (
     *                         <SpsListToolbar>
     *                             <SpsListToolbarSearch onSubmit={handleSearch}>
     *                                 <SpsTextInput
     *                                     value={formValue.searchText}
     *                                     formMeta={formMeta.fields.searchText}
     *                                     placeholder="Search fields"
     *                                 />
     *                                 <SpsButton
     *                                      kind={ButtonKind.ICON}
     *                                      icon={SpsIcon.SEARCH}
     *                                      type="submit"
     *                                  />
     *                             </SpsListToolbarSearch>
     *                             <SpsDropdown
     *                                 label="Saved Searches"
     *                                 options={[
     *                                     [{ label: "Option A" }, () => console.log("Option A")],
     *                                 ]}
     *                             />
     *                         </SpsListToolbar>
     *                     )
     *                 }
     *             `,
     *         },
     *     },
     * },
     */
    advancedSearch: {
        label: "Advanced Search",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("p", null,
                "Include the Advanced Search feature when more complex options are required to narrow down search results. For more information, visit the",
                " ",
                React.createElement(NavigateTo, { to: "advanced-search" }, "Advanced Search"),
                " page."));
        },
        examples: {
            advancedSearch: {
                react: code(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject$w(["\n                    function Component() {\n                        const [advSearch, setAdvSearch] = React.useState({\n                            isOpen: false,\n                            controlsDisabled: true,\n                        });\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            setAdvSearch({ isOpen });\n                        }\n                    \n                        return (\n                            <>\n                                <SpsListToolbar advancedSearch={advSearch}\n                                    onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                                >\n                                    <SpsListToolbarSearch>\n                                        <SpsTextInput\n                                            value={formValue.searchText}\n                                            formMeta={formMeta.fields.searchText}\n                                            placeholder=\"Search fields\"\n                                        />\n                                        <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} />\n                                    </SpsListToolbarSearch>\n                                </SpsListToolbar>\n                                <SpsAdvancedSearch {...advSearch}>\n                                    <i>insert form here</i>\n                                </SpsAdvancedSearch>\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const [advSearch, setAdvSearch] = React.useState({\n                            isOpen: false,\n                            controlsDisabled: true,\n                        });\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleToggleAdvancedSearch(isOpen) {\n                            setAdvSearch({ isOpen });\n                        }\n                    \n                        return (\n                            <>\n                                <SpsListToolbar advancedSearch={advSearch}\n                                    onToggleAdvancedSearch={handleToggleAdvancedSearch}\n                                >\n                                    <SpsListToolbarSearch>\n                                        <SpsTextInput\n                                            value={formValue.searchText}\n                                            formMeta={formMeta.fields.searchText}\n                                            placeholder=\"Search fields\"\n                                        />\n                                        <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} />\n                                    </SpsListToolbarSearch>\n                                </SpsListToolbar>\n                                <SpsAdvancedSearch {...advSearch}>\n                                    <i>insert form here</i>\n                                </SpsAdvancedSearch>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
    columnEditor: {
        label: "Column Editor",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("p", null,
                "Use a Column Editor when tables require the ability to show or hide specific columns based on the user's preferences. The Column Editor should only be used for",
                " ",
                React.createElement(NavigateTo, { to: "tables" }, "Tables"),
                ", and not any other type of list view. For more information, visit the",
                " ",
                React.createElement(NavigateTo, { to: "column-chooser" }, "Column Editor"),
                " page."));
        },
        examples: {
            columnEditor: {
                react: code(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject$w(["\n                    function Component() {\n                        const unselectedCols = [\n                            { name: \"Title\" },\n                        ];\n                        const selectedCols = [\n                            { name: \"Documents\" },\n                            { name: \"Price\" },\n                        ]\n                        \n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                                <SpsColumnChooser\n                                    unselectedColumns={unselectedCols}\n                                    selectedColumns={selectedCols}\n                                    onApplyChanges={(selectedColumns) => {console.log(selectedColumns)}}\n                                />\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const unselectedCols = [\n                            { name: \"Title\" },\n                        ];\n                        const selectedCols = [\n                            { name: \"Documents\" },\n                            { name: \"Price\" },\n                        ]\n                        \n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                                <SpsColumnChooser\n                                    unselectedColumns={unselectedCols}\n                                    selectedColumns={selectedCols}\n                                    onApplyChanges={(selectedColumns) => {console.log(selectedColumns)}}\n                                />\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
        },
    },
    /*
     * TODO: add when list view selector is implemented
     * listViewSelector: {
     *     label: 'List View Selector',
     *     description: ({ NavigateTo }) => (
     *         <p>
     *             Use a List View Selector to change the visual display of the list between{' '}
     *             <NavigateTo to="tables">Tables</NavigateTo>,{' '}
     *             <NavigateTo to="content-rows">Content Rows</NavigateTo>,{' '}
     *             <NavigateTo to="cards">Cards</NavigateTo>.
     *         </p>
     *     ),
     *     examples: {
     *         listView: {
     *             react: code`
     *                 function Component() {
     *                     const { formValue, formMeta, updateForm } = useSpsForm({
     *                         searchText: "",
     *                     });
     */
    /*
     *                     function handleSearch(event) {
     *                         console.log(event, formValue.searchText)
     *                     }
     */
    /*
     *                     return (
     *                         <SpsListToolbar>
     *                             <SpsListToolbarSearch onSubmit={handleSearch}>
     *                                 <SpsTextInput
     *                                     value={formValue.searchText}
     *                                     formMeta={formMeta.fields.searchText}
     *                                     placeholder="Search fields"
     *                                 />
     *                                 <SpsButton
     *                                      kind={ButtonKind.ICON}
     *                                      icon={SpsIcon.SEARCH}
     *                                      type="submit"
     *                                  />
     *                             </SpsListToolbarSearch>
     *                             <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.LIST_TABLE} />
     *                             </SpsListToolbar>
     *                     )
     *                 }
     *             `,
     *         },
     *     },
     * },
     * TODO: add example when sorting feature is implemented
     * sorting: {
     *     label: 'Sorting',
     *     description: ({ NavigateTo }) => (
     *         <>
     *             <p>
     *                 Use the Sorting feature only when content is displayed in{' '}
     *                 <NavigateTo to="content-rows">Content Rows</NavigateTo> or{' '}
     *                 <NavigateTo to="cards">Cards</NavigateTo>.
     *             </p>
     *             <i>
     *                 Note: The <NavigateTo to="tables">Table</NavigateTo> component has its own
     *                 sorting options for each column.
     *             </i>
     *         </>
     *     ),
     *     examples: {
     *         sorting: {
     *             react: code`
     *                 function Component() {
     *                     const { formValue, formMeta, updateForm } = useSpsForm({
     *                         searchText: "",
     *                     });
     */
    /*
     *                     function handleSearch(event) {
     *                         console.log(event, formValue.searchText)
     *                     }
     */
    /*
     *                     return (
     *                         <SpsListToolbar>
     *                             <SpsListToolbarSearch onSubmit={handleSearch}>
     *                                 <SpsTextInput
     *                                     value={formValue.searchText}
     *                                     formMeta={formMeta.fields.searchText}
     *                                     placeholder="Search fields"
     *                                 />
     *                                 <SpsButton
     *                                      kind={ButtonKind.ICON}
     *                                      icon={SpsIcon.SEARCH}
     *                                      type="submit"
     *                                  />
     *                             </SpsListToolbarSearch>
     *                             <SpsButton
     *                                  className="gray500"
     *                                  kind={ButtonKind.LINK}
     *                                  icon={SpsIcon.ARROW_DOWN}>
     *                                  Order Type
     *                              </SpsButton>
     *                         </SpsListToolbar>
     *                     )
     *                 }
     *             `,
     *         },
     *     },
     * },
     */
    buttons: {
        label: "Buttons",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("p", null,
                "Use Buttons only for actions that do not affect existing list items, such as exporting the list or creating a new list item. For actions that are taken on list items, such as changing a status of a list item, refer to the",
                " ",
                React.createElement(NavigateTo, { to: "list-action-bar" }, "List Action Bar"),
                "."));
        },
        examples: {
            buttons: {
                react: code(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject$w(["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                                <SpsButton kind={ButtonKind.LINK}>Text Button</SpsButton>\n                                <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD} />\n                                <SpsButton>Button</SpsButton>\n                                <SpsButton kind={ButtonKind.KEY}>Button</SpsButton>\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        });\n\n                        function handleSearch(event) {\n                            console.log(event, formValue.searchText)\n                        }\n\n                        return (\n                            <SpsListToolbar>\n                                <SpsListToolbarSearch onSubmit={handleSearch}>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} type=\"submit\" />\n                                </SpsListToolbarSearch>\n                                <SpsButton kind={ButtonKind.LINK}>Text Button</SpsButton>\n                                <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.DOWNLOAD_CLOUD} />\n                                <SpsButton>Button</SpsButton>\n                                <SpsButton kind={ButtonKind.KEY}>Button</SpsButton>\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
        },
    },
    tabs: {
        label: "Tabs",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("p", null,
                "When tabs are included, they appear above the List Toolbar. Tab rules are outlined on the ",
                React.createElement(NavigateTo, { to: "cards" }, "Cards"),
                " page."));
        },
        examples: {
            tabs: {
                react: code(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject$w(["\n                    function Component() {\n                        const tabs = [\n                            {\n                                label: \"Good Tab\",\n                            },\n                            {\n                                label: \"Great Tab\",\n                            },\n                            {\n                                label: \"Best Tab\",\n                            },\n                        ];\n                        const activeTab = { label: \"Good Tab\" };\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        })\n                        const handleChange = e => {\n                            setSearchText(e.target.value);\n                        };\n\n                        function handleTabChange(tab) {\n                            console.log(tab);\n                        }\n\n                        return (\n                            <SpsListToolbar\n                                tabs={tabs}\n                                activeTab={activeTab}\n                                onTabChange={handleTabChange}\n                            >\n                                <SpsListToolbarSearch>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind=\"icon\" icon=\"search\" />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const tabs = [\n                            {\n                                label: \"Good Tab\",\n                            },\n                            {\n                                label: \"Great Tab\",\n                            },\n                            {\n                                label: \"Best Tab\",\n                            },\n                        ];\n                        const activeTab = { label: \"Good Tab\" };\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            searchText: \"\",\n                        })\n                        const handleChange = e => {\n                            setSearchText(e.target.value);\n                        };\n\n                        function handleTabChange(tab) {\n                            console.log(tab);\n                        }\n\n                        return (\n                            <SpsListToolbar\n                                tabs={tabs}\n                                activeTab={activeTab}\n                                onTabChange={handleTabChange}\n                            >\n                                <SpsListToolbarSearch>\n                                    <SpsTextInput\n                                        value={formValue.searchText}\n                                        formMeta={formMeta.fields.searchText}\n                                        placeholder=\"Search fields\"\n                                    />\n                                    <SpsButton kind=\"icon\" icon=\"search\" />\n                                </SpsListToolbarSearch>\n                            </SpsListToolbar>\n                        );\n                    }\n                "]))),
            },
        },
    },
    title: {
        label: "Title",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("p", null,
                "Use Titles when there is no Search or Filter input required for the list items, such as when the only search options are in an Advanced Search panel. For more information, visit the ",
                React.createElement(NavigateTo, { to: "advanced-search" }, "Advanced Search"),
                " ",
                "page."));
        },
        examples: {
            title: {
                react: code(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject$w(["\n                    function Component() {\n                        return (\n                            <SpsListToolbar title=\"Good List Title\">\n                                <SpsButton>Button</SpsButton>\n                            </SpsListToolbar>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                            <SpsListToolbar title=\"Good List Title\">\n                                <SpsButton>Button</SpsButton>\n                            </SpsListToolbar>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$w, templateObject_2$t, templateObject_3$p, templateObject_4$i, templateObject_5$a, templateObject_6$7, templateObject_7$6, templateObject_8$5, templateObject_9$4, templateObject_10$3, templateObject_11$3;

var __assign$Y = (undefined && undefined.__assign) || function () {
    __assign$Y = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$Y.apply(this, arguments);
};
var __rest$N = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$S = {
    kind: "FeedbackBlockKind",
    message: { type: "string", required: true },
};
var propTypes$U = __assign$Y(__assign$Y({}, spsGlobalPropTypes), { kind: enumValue(FeedbackBlockKind), message: propTypes$1H.exports.node.isRequired });
function SpsMicroBlock(props) {
    var className = props.className, _a = props.kind, kind = _a === void 0 ? FeedbackBlockKind.INFO : _a, message = props.message, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$N(props, ["className", "kind", "message", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-micro-block", "sps-micro-block--" + kind, className);
    return (React.createElement("div", __assign$Y({ className: classes, "data-testid": testId }, rest),
        React.createElement("i", { className: "sps-icon sps-icon-" + FeedbackBlockIcons[kind], "aria-hidden": "true", "data-testid": testId + "__icon" }),
        React.createElement("span", null, message)));
}
Object.assign(SpsMicroBlock, {
    props: propsDoc$S,
    propTypes: propTypes$U,
    displayName: "SpsMicroBlock",
});

var __makeTemplateObject$v = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsMicroBlockExamples = {
    infoBlock: {
        label: "Info Micro Block",
        examples: {
            infoBlock: {
                jsx: code(templateObject_1$v || (templateObject_1$v = __makeTemplateObject$v(["\n                    <SpsMicroBlock kind={FeedbackBlockKind.INFO} message=\"Hey, here's something neat.\"/>\n                "], ["\n                    <SpsMicroBlock kind={FeedbackBlockKind.INFO} message=\"Hey, here's something neat.\"/>\n                "]))),
            },
        },
    },
    successBlock: {
        label: "Success Micro Block",
        examples: {
            successBlock: {
                jsx: code(templateObject_2$s || (templateObject_2$s = __makeTemplateObject$v(["\n                    <SpsMicroBlock kind={FeedbackBlockKind.SUCCESS} message=\"That was amazing!\"/>\n                "], ["\n                    <SpsMicroBlock kind={FeedbackBlockKind.SUCCESS} message=\"That was amazing!\"/>\n                "]))),
            },
        },
    },
    warningBlock: {
        label: "Warning Micro Block",
        examples: {
            warningBlock: {
                jsx: code(templateObject_3$o || (templateObject_3$o = __makeTemplateObject$v(["\n                    <SpsMicroBlock kind={FeedbackBlockKind.WARNING} message=\"Watch yourself, Chester!\"/>\n                "], ["\n                    <SpsMicroBlock kind={FeedbackBlockKind.WARNING} message=\"Watch yourself, Chester!\"/>\n                "]))),
            },
        },
    },
    errorBlock: {
        label: "Error Micro Block",
        examples: {
            errorBlock: {
                jsx: code(templateObject_4$h || (templateObject_4$h = __makeTemplateObject$v(["\n                    <SpsMicroBlock kind={FeedbackBlockKind.ERROR} message=\"Uh oh, big problems.\"/>\n                "], ["\n                    <SpsMicroBlock kind={FeedbackBlockKind.ERROR} message=\"Uh oh, big problems.\"/>\n                "]))),
            },
        },
    },
    tipBlock: {
        label: "Tip Micro Block",
        examples: {
            tipBlock: {
                jsx: code(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject$v(["\n                    <SpsMicroBlock kind={FeedbackBlockKind.TIP} message=\"Pro Tip: Don't be a loser.\"/>\n                "], ["\n                    <SpsMicroBlock kind={FeedbackBlockKind.TIP} message=\"Pro Tip: Don't be a loser.\"/>\n                "]))),
            },
        },
    },
};
var templateObject_1$v, templateObject_2$s, templateObject_3$o, templateObject_4$h, templateObject_5$9;

var __assign$X = (undefined && undefined.__assign) || function () {
    __assign$X = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$X.apply(this, arguments);
};
var __rest$M = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$o = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$R = {
    kind: "ModalKind",
    size: "ModalSize",
    title: "string",
    onClose: "() => void",
    focusElementOnOpen: "React.MutableRefObject<HTMLElement>",
};
var propTypes$T = __assign$X(__assign$X({}, spsGlobalPropTypes), { kind: enumValue(ModalKind), size: enumValue(ModalSize), title: propTypes$1H.exports.string, onClose: fun(), focusElementOnOpen: ref() });
function SpsModalV2Footer(_a) {
    var children = _a.children;
    return React.createElement("div", { className: "sps-modal__footer" }, children);
}
Object.assign(SpsModalV2Footer, {
    props: {},
    propTypes: {},
    displayName: "SpsModalV2Footer",
});
function SpsModalV2(_a) {
    var children = _a.children, className = _a.className, idProp = _a.id, _b = _a.kind, kind = _b === void 0 ? ModalKind.GENERAL : _b, _c = _a.size, size = _c === void 0 ? ModalSize.SMALL : _c, onClose = _a.onClose, focusElementOnOpen = _a.focusElementOnOpen, title = _a.title, rest = __rest$M(_a, ["children", "className", "id", "kind", "size", "onClose", "focusElementOnOpen", "title"]);
    var id = useElementId(idProp);
    var classes = clsx("sps-modal", "z-stratum-dialog", "sps-modal--" + kind, "sps-modal--" + size, className);
    var t = React.useContext(I18nContext).t;
    var rootElement = React.useRef();
    var _d = __read$o(React.useState(false), 2), bodyIsReady = _d[0], setBodyIsReady = _d[1];
    React.useEffect(function () {
        var scrollbarWidth = window.innerWidth - document.body.clientWidth + "px";
        document.body.style.paddingRight = scrollbarWidth;
        document.body.style.overflow = "hidden";
        /* eslint-disable no-param-reassign */
        document.querySelectorAll(".z-stratum-bar").forEach(function (element) {
            element.tempPaddingRightHolder = element.style.paddingRight;
            element.style.paddingRight = scrollbarWidth;
        });
        setBodyIsReady(true);
        return function () {
            document.body.style.paddingRight = "initial";
            document.body.style.overflow = "auto";
            document.querySelectorAll(".z-stratum-bar").forEach(function (element) {
                element.style.paddingRight = element.tempPaddingRightHolder || "";
                delete element.tempPaddingRightHolder;
            });
        };
        /* eslint-enable no-param-reassign */
    }, []);
    React.useEffect(function () {
        if (focusElementOnOpen && focusElementOnOpen.current) {
            focusElementOnOpen.current.focus();
        }
        else if (rootElement.current) {
            rootElement.current.focus();
        }
    }, [focusElementOnOpen, bodyIsReady]);
    var handleKeydown = React.useCallback(function (event) {
        if (event && event.key === "Escape" && onClose) {
            onClose();
        }
        if (event && event.key === "Tab") {
            var focusableElements = rootElement.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            var firstFocusableElement = focusableElements[0];
            var lastFocusableElement = focusableElements[focusableElements.length - 1];
            if (focusableElements.length === 0) {
                event.preventDefault();
            }
            else if (event.shiftKey && event.target === firstFocusableElement) {
                event.preventDefault();
                lastFocusableElement.focus();
            }
            else if (!event.shiftKey && event.target === lastFocusableElement) {
                event.preventDefault();
                firstFocusableElement.focus();
            }
        }
    }, [onClose]);
    var _e = __read$o(selectChildren(children, [{ type: SpsModalV2Footer }]), 2), _f = __read$o(_e[0], 1), footer = _f[0], bodyContent = _e[1];
    return bodyIsReady
        ? (React.createElement("div", { id: id.current, role: "dialog", "aria-modal": true, "aria-labelledby": id.current + "-title", className: classes, onKeyDown: handleKeydown, tabIndex: -1, ref: rootElement },
            React.createElement("div", __assign$X({}, rest, { className: "sps-modal__dialog" }),
                React.createElement("div", { className: "sps-modal__titlebar" },
                    React.createElement("div", { className: "sps-modal__title", id: id.current + "-title" }, title || t("design-system:modal.defaultTitle." + kind)),
                    onClose && (React.createElement("div", { className: "sps-button sps-button--icon", onClick: onClose },
                        React.createElement("button", { "aria-label": t("design-system:modal.close"), type: "button" },
                            React.createElement("i", { className: "sps-icon sps-icon-x" }))))),
                React.createElement("div", { className: "sps-modal__body" },
                    React.createElement(PortalContext.Provider, { value: {
                            parentElementRef: rootElement,
                            fixed: true,
                        } }, bodyContent)),
                footer || (React.createElement("div", { className: "sps-modal__footer" },
                    React.createElement(SpsButton, { kind: kind === ModalKind.SERIOUS_WARNING
                            ? ButtonKind.DELETE
                            : ButtonKind.KEY, onClick: onClose }, t("design-system:modal.defaultButtonLabel")))))))
        : React.createElement(React.Fragment, null);
}
Object.assign(SpsModalV2, {
    props: propsDoc$R,
    propTypes: propTypes$T,
    displayName: "SpsModalV2",
});

var __makeTemplateObject$u = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsModalExamples = {
    generalUsage: {
        label: "General Usage",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement(React.Fragment, null,
                React.createElement("h5", { className: "mt-2" }, "Use a Modal:"),
                React.createElement("ul", null,
                    React.createElement("li", null, "When the user needs to confirm a basic decision, such as deleting a record."),
                    React.createElement("li", null, "When important information needs to be displayed to the user before continuing."),
                    React.createElement("li", null, "When a simple selection, such as a single form input, is required before proceeding.")),
                React.createElement("h5", null, "Avoid a Modal:"),
                React.createElement("ul", null,
                    React.createElement("li", null,
                        "When a complex form is required. Use a",
                        " ",
                        React.createElement(NavigateTo, { to: "Focused Task" }, "Focused Task View"),
                        " instead."),
                    React.createElement("li", null,
                        "When sharing non-critical or tertiary information. Use a",
                        " ",
                        React.createElement(NavigateTo, { to: "Growlers" }, "Growler"),
                        " instead."))));
        },
        examples: {
            noCloseButton: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h5", null, "Close Button"),
                    React.createElement("p", null, "Remove the Close Button in the upper right of the Modal if the user must choose the course of action before proceeding."))); },
                react: code(templateObject_1$u || (templateObject_1$u = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        function secondaryAction() {\n                            console.log(\"Secondary action invoked\");\n                            setShowModal(false);\n                        }\n                    \n                        function primaryAction() {\n                            console.log(\"Primary action invoked\");\n                            setShowModal(false);\n                        }\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                    <SpsModalV2Footer>\n                                        <SpsButton onClick={secondaryAction}>Secondary Action</SpsButton>\n                                        <SpsButton kind={ButtonKind.KEY} onClick={primaryAction}>Primary Action</SpsButton>\n                                    </SpsModalV2Footer>\n                                    </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        function secondaryAction() {\n                            console.log(\"Secondary action invoked\");\n                            setShowModal(false);\n                        }\n                    \n                        function primaryAction() {\n                            console.log(\"Primary action invoked\");\n                            setShowModal(false);\n                        }\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                    <SpsModalV2Footer>\n                                        <SpsButton onClick={secondaryAction}>Secondary Action</SpsButton>\n                                        <SpsButton kind={ButtonKind.KEY} onClick={primaryAction}>Primary Action</SpsButton>\n                                    </SpsModalV2Footer>\n                                    </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    sizing: {
        label: "Sizing",
        description: function () { return (React.createElement("p", null, "There are 3 sizes of Modal: Small (4 columns), Medium (6 columns), and Large (8 columns). Use the size that best fits the content that needs to be in the Modal, erring towards the smallest size whenever possible.")); },
    },
    default: {
        label: "Default",
        description: function () { return (React.createElement("p", null, "Use Default Modals to inform the user of something with a neutral meaning. Use these as the default option for Modals.")); },
        examples: {
            small: {
                description: "Small",
                react: code(templateObject_2$r || (templateObject_2$r = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Default Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Default Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            medium: {
                description: "Medium",
                react: code(templateObject_3$n || (templateObject_3$n = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Default Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Default Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            large: {
                description: "Large",
                react: code(templateObject_4$g || (templateObject_4$g = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Default Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Default Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    delete: {
        label: "Delete",
        description: function () { return (React.createElement("p", null, "Use Delete Modals to have the user confirm they want to continue with a destructive action. Be clear on what will happen if they continue.")); },
        examples: {
            small: {
                description: "Small",
                react: code(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Delete Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SERIOUS_WARNING}\n                                    title=\"Delete\"\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Delete Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SERIOUS_WARNING}\n                                    title=\"Delete\"\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            medium: {
                description: "Medium",
                react: code(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Delete Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SERIOUS_WARNING}\n                                    title=\"Delete\"\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Delete Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SERIOUS_WARNING}\n                                    title=\"Delete\"\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            large: {
                description: "Large",
                react: code(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Delete Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SERIOUS_WARNING}\n                                    title=\"Delete\"\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Delete Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SERIOUS_WARNING}\n                                    title=\"Delete\"\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    informational: {
        label: "Informational",
        description: function () { return (React.createElement("p", null, "Use Informational Modals to share impactful information with the user, such as telling them when an app will be down for maintenance.")); },
        examples: {
            small: {
                description: "Small",
                react: code(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Informational Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.INFO}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Informational Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.INFO}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            medium: {
                description: "Medium",
                react: code(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Informational Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.INFO}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Informational Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.INFO}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            large: {
                description: "Large",
                react: code(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Informational Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.INFO}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Informational Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.INFO}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    success: {
        label: "Success",
        description: function () { return (React.createElement("p", null, "Use Success Modals to confirm that an action has been completed successfully.")); },
        examples: {
            small: {
                description: "Small",
                react: code(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Success Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SUCCESS}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Success Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SUCCESS}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            medium: {
                description: "Medium",
                react: code(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Success Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SUCCESS}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Success Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SUCCESS}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            large: {
                description: "Large",
                react: code(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Success Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SUCCESS}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Success Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.SUCCESS}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    warning: {
        label: "Warning",
        description: function () { return (React.createElement("p", null, "Use Warning Modals to warn of problems that may occur as a result of taking an action. When writing the message, be clear about what will happen if the user continues on the path.")); },
        examples: {
            small: {
                description: "Small",
                react: code(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Warning Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.WARNING}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Small Warning Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.SMALL}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.WARNING}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            medium: {
                description: "Medium",
                react: code(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Warning Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.WARNING}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Medium Warning Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.MEDIUM}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.WARNING}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
            large: {
                description: "Large",
                react: code(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject$u(["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Warning Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.WARNING}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "], ["\n                    function Component() {\n                        const [showModal, setShowModal] = React.useState(false);\n\n                        return <>\n                            <SpsButton kind={ButtonKind.LINK} onClick={() => setShowModal(true)}>\n                                Show Large Warning Modal\n                            </SpsButton>\n                            {showModal && (\n                                <SpsModalV2\n                                    size={ModalSize.LARGE}\n                                    onClose={() => setShowModal(false)}\n                                    kind={ModalKind.WARNING}\n                                >\n                                    <div className=\"sps-text-semibold mb-1\">Optional Headline</div>\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>\n                                </SpsModalV2>\n                            )}\n                        </>;\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$u, templateObject_2$r, templateObject_3$n, templateObject_4$g, templateObject_5$8, templateObject_6$6, templateObject_7$5, templateObject_8$4, templateObject_9$3, templateObject_10$2, templateObject_11$2, templateObject_12$1, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16$1;

var __assign$W = (undefined && undefined.__assign) || function () {
    __assign$W = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$W.apply(this, arguments);
};
var __rest$L = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$n = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$1 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var propsDoc$Q = {
    captionKey: "string",
    debounce: "number",
    disabled: "boolean",
    disableSelected: "boolean",
    comparisonKey: "string",
    formMeta: "SpsFormFieldMeta<any[]>",
    hideSelected: "boolean",
    icon: "SpsIcon",
    onChange: "ChangeEventHandler",
    options: "Eventually<any[]> | (filter?: string) => Eventually<any[]>",
    placeholder: "string",
    tallOptionList: "boolean",
    textKey: "string",
    value: "any",
    zeroState: "string",
    loading: "boolean",
};
var propTypes$S = __assign$W(__assign$W({}, spsGlobalPropTypes), { action: fun(), captionKey: propTypes$1H.exports.string, debounce: propTypes$1H.exports.number, disabled: propTypes$1H.exports.bool, disableSelected: propTypes$1H.exports.bool, comparisonKey: propTypes$1H.exports.string, formControl: impl(), formMeta: impl(), hideSelected: propTypes$1H.exports.bool, icon: enumValue(SpsIcon), onChange: fun(), options: propTypes$1H.exports.oneOfType([
        propTypes$1H.exports.array,
        propTypes$1H.exports.instanceOf(Promise),
        fun(),
    ]).isRequired, placeholder: propTypes$1H.exports.string, tallOptionList: propTypes$1H.exports.bool, textKey: propTypes$1H.exports.string, value: propTypes$1H.exports.any, zeroState: propTypes$1H.exports.string, loading: propTypes$1H.exports.bool });
function SpsMultiSelect(_a) {
    var action = _a.action, captionKey = _a.captionKey, className = _a.className, debounce = _a.debounce, disabled = _a.disabled, _b = _a.disableSelected, disableSelected = _b === void 0 ? false : _b, comparisonKey = _a.comparisonKey, formControl = _a.formControl, formMeta = _a.formMeta, hideSelected = _a.hideSelected, id = _a.id, onChange = _a.onChange, options = _a.options, placeholder = _a.placeholder, tallOptionList = _a.tallOptionList, textKey = _a.textKey, unsafelyReplaceClassName = _a.unsafelyReplaceClassName, value = _a.value, _c = _a.zeroState, zeroState = _c === void 0 ? "There are no matching options." : _c, loading = _a.loading, icon = _a.icon, testId = _a["data-testid"], rest = __rest$L(_a, ["action", "captionKey", "className", "debounce", "disabled", "disableSelected", "comparisonKey", "formControl", "formMeta", "hideSelected", "id", "onChange", "options", "placeholder", "tallOptionList", "textKey", "unsafelyReplaceClassName", "value", "zeroState", "loading", "icon", "data-testid"]);
    var meta = formMeta || formControl;
    var _d = useFormControlId(id, meta), wrapperId = _d.wrapperId, controlId = _d.controlId;
    var _e = __read$n(usePatchReducer({
        keyDown: null,
        opensUpward: false,
        searchText: "",
        activeTagIndex: null,
        optionIds: "",
    }), 2), state = _e[0], patchState = _e[1];
    var rootElement = React.useRef();
    var inputVisual = React.useRef();
    var textInput = React.useRef();
    var optionListRef = React.useRef();
    var _f = useInputPopup(rootElement, optionListRef), showPopup = _f.showPopup, doShowPopup = _f.doShowPopup, doHidePopup = _f.doHidePopup;
    function open() {
        patchState({ activeTagIndex: null });
        doShowPopup();
    }
    function focusTextInput() {
        setTimeout(function () {
            textInput.current.focus();
        }, 0);
    }
    function updateValue(newValue) {
        patchState({ searchText: "" });
        if (meta) {
            meta.setValue(newValue);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(new FauxChangeEvent({ value: newValue }));
        }
    }
    function selectOption(option) {
        if (value.indexOf(option) === -1) {
            updateValue(__spreadArray$1(__spreadArray$1([], __read$n(value), false), [option], false));
        }
        focusTextInput();
    }
    function removeOptionByIndex(indexToRemove) {
        var newValue = value.filter(function (option, i) { return i !== indexToRemove; });
        updateValue(newValue);
    }
    function handleChange(event) {
        patchState({ searchText: event.target.value });
    }
    function handleKeyDown(event) {
        if (!disabled) {
            var cursorIsAtLeftOfTextInputAndThereIsAtLeastOneSelection = !hideSelected
                && !event.target.selectionStart
                && value
                && value.length;
            switch (event.key) {
                case "Backspace":
                    if (state.activeTagIndex !== null) {
                        removeOptionByIndex(state.activeTagIndex);
                        return;
                    }
                    if (cursorIsAtLeftOfTextInputAndThereIsAtLeastOneSelection) {
                        updateValue(value.slice(0, value.length - 1));
                        return;
                    }
                    break;
                case "Delete":
                    if (state.activeTagIndex !== null) {
                        removeOptionByIndex(state.activeTagIndex);
                        return;
                    }
                    break;
                case "Up":
                case "ArrowUp":
                case "Down":
                case "ArrowDown":
                    event.preventDefault();
                    break;
                case "Left":
                case "ArrowLeft":
                    if (cursorIsAtLeftOfTextInputAndThereIsAtLeastOneSelection) {
                        rootElement.current.focus();
                        if (state.activeTagIndex === null) {
                            patchState({ activeTagIndex: value.length - 1 });
                            doHidePopup();
                        }
                        else if (state.activeTagIndex > 0) {
                            patchState({ activeTagIndex: state.activeTagIndex - 1 });
                            doHidePopup();
                        }
                        return;
                    }
                    break;
                case "Right":
                case "ArrowRight":
                    if (state.activeTagIndex !== null) {
                        if (state.activeTagIndex === value.length - 1) {
                            patchState({ activeTagIndex: null });
                            doShowPopup();
                            textInput.current.focus();
                        }
                        else {
                            patchState({ activeTagIndex: state.activeTagIndex + 1 });
                        }
                        return;
                    }
                    break;
                case "Tab":
                    doHidePopup();
                    break;
            }
            event.persist();
            patchState({ keyDown: event });
        }
    }
    function handlePositionFlip(opensUpward) {
        patchState({ opensUpward: opensUpward });
    }
    function handleClearIconClick(event) {
        updateValue([]);
        event.stopPropagation();
    }
    function handleOptionListChanged(filteredListLength) {
        patchState({
            optionIds: (new Array(filteredListLength)).fill("")
                .map(function (s, i) { return wrapperId + "-options-option-" + i; })
                .join(","),
        });
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-multi-select", showPopup && "sps-multi-select--open", showPopup && "z-stratum-dropdown", state.opensUpward && "sps-multi-select--opens-upward", disabled && "sps-form-control--disabled", className);
    var tagIds = new Array(value.length).fill(0)
        .map(function (_, i) { return wrapperId + "_tag-" + i; });
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formControl: formControl, formMeta: formMeta, ref: rootElement, inputRef: textInput, focusInputOnClick: true, onKeyDown: handleKeyDown, role: "listbox", "aria-multiselectable": true, "aria-activedescendant": tagIds[state.activeTagIndex], "aria-owns": state.optionIds },
        React.createElement("div", { className: "sps-text-input", ref: inputVisual },
            React.createElement("div", { className: clsx("sps-form-control", value && !disabled && "sps-form-control--clearable") },
                icon && React.createElement("i", { className: clsx("sps-text-input__icon", "sps-icon", "sps-icon-" + icon) }),
                React.createElement("div", { className: "sps-multi-select__tags-and-input" },
                    hideSelected
                        ? null
                        : value.map(function (opt, i) { return (React.createElement(SpsClickableTag, { id: tagIds[i], role: "option", disabled: disabled, "aria-selected": "true", key: tagIds[i], onRemove: function () { return removeOptionByIndex(i); } }, textKey ? opt[textKey] : opt)); }),
                    React.createElement("input", __assign$W({ type: "text", ref: textInput, "data-testid": testId + "__option-list-input", value: state.searchText, className: "sps-text-input__input", placeholder: value.length === 0 ? placeholder : undefined, id: controlId, onClick: open, onChange: handleChange, onFocus: open, onKeyDown: handleKeyDown, disabled: disabled, role: "listbox", "aria-multiselectable": "true", "aria-owns": tagIds.join(" ") }, rest))),
                value.length !== 0 && !disabled ? (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: function (event) { return handleClearIconClick(event); } })) : null)),
        React.createElement(SpsOptionList, { id: wrapperId + "_options", ref: optionListRef, "data-testid": testId + "__option-list", attachTo: inputVisual, captionKey: captionKey, disabledOptions: disableSelected ? value : null, isOpen: showPopup, comparisonKey: comparisonKey, keepOpen: true, keyDown: state.keyDown, options: options, specialAction: action, onOptionSelected: selectOption, onPositionFlip: handlePositionFlip, hideInlineSearch: true, optionRole: "option", onOptionListChanged: handleOptionListChanged, searchDebounce: debounce, search: state.searchText, tall: tallOptionList, textKey: textKey, zeroState: zeroState, loading: loading })));
}
Object.assign(SpsMultiSelect, {
    props: propsDoc$Q,
    propTypes: propTypes$S,
    displayName: "SpsMultiSelect",
});

var __makeTemplateObject$t = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsMultiSelectExamples = {
    basic: {
        label: "Basic",
        description: "<p>Multi select component</p>",
        examples: {
            a_basic: {
                react: code(templateObject_1$t || (templateObject_1$t = __makeTemplateObject$t(["\n                    function Component() {\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            things: [ opts[0] ]\n                        })\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.things}>Things</SpsLabel>\n                            <SpsMultiSelect\n                                options={opts}\n                                formMeta={formMeta.fields.things}\n                                value={formValue.things}\n                            />\n                            <br />\n                            {JSON.stringify(formValue)}\n                        </>\n                    }\n                "], ["\n                    function Component() {\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            things: [ opts[0] ]\n                        })\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.things}>Things</SpsLabel>\n                            <SpsMultiSelect\n                                options={opts}\n                                formMeta={formMeta.fields.things}\n                                value={formValue.things}\n                            />\n                            <br />\n                            {JSON.stringify(formValue)}\n                        </>\n                    }\n                "]))),
            },
            b_disabled: {
                react: code(templateObject_2$q || (templateObject_2$q = __makeTemplateObject$t(["\n                    function Component() {\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            things: [ opts[0] ]\n                        })\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.things}>Things</SpsLabel>\n                            <SpsMultiSelect disabled\n                                options={opts}\n                                formMeta={formMeta.fields.things}\n                                value={formValue.things}\n                            />\n                            <br />\n                            {JSON.stringify(formValue)}\n                        </>\n                    }\n                "], ["\n                    function Component() {\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            things: [ opts[0] ]\n                        })\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.things}>Things</SpsLabel>\n                            <SpsMultiSelect disabled\n                                options={opts}\n                                formMeta={formMeta.fields.things}\n                                value={formValue.things}\n                            />\n                            <br />\n                            {JSON.stringify(formValue)}\n                        </>\n                    }\n                "]))),
            },
            c_externalTags: {
                react: code(templateObject_3$m || (templateObject_3$m = __makeTemplateObject$t(["\n                    function Component() {\n                        const [foo, setFoo] = React.useState([\"orp\"])\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        function handleChange(event) {\n                            setFoo(event.target.value)\n                        }\n                        function removeByIndex(i) {\n                            foo.splice(i, 1)\n                            setFoo([...foo])\n                        }\n                        return (\n                            <>\n                                <SpsMultiSelect\n                                    hideSelected\n                                    options={opts}\n                                    value={foo}\n                                    onChange={handleChange}\n                                />\n                                <br />\n                                {foo.map((opt, i) => (\n                                    <SpsClickableTag\n                                        className=\"mt-1 ml-1\"\n                                        key={i}\n                                        onRemove={() => removeByIndex(i)}\n                                    >\n                                        {opt}\n                                    </SpsClickableTag>\n                                ))}\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const [foo, setFoo] = React.useState([\"orp\"])\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        function handleChange(event) {\n                            setFoo(event.target.value)\n                        }\n                        function removeByIndex(i) {\n                            foo.splice(i, 1)\n                            setFoo([...foo])\n                        }\n                        return (\n                            <>\n                                <SpsMultiSelect\n                                    hideSelected\n                                    options={opts}\n                                    value={foo}\n                                    onChange={handleChange}\n                                />\n                                <br />\n                                {foo.map((opt, i) => (\n                                    <SpsClickableTag\n                                        className=\"mt-1 ml-1\"\n                                        key={i}\n                                        onRemove={() => removeByIndex(i)}\n                                    >\n                                        {opt}\n                                    </SpsClickableTag>\n                                ))}\n                            </>\n                        )\n                    }\n                "]))),
            },
            icon: {
                react: code(templateObject_4$f || (templateObject_4$f = __makeTemplateObject$t(["\n                    function Component() {\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            things: [ opts[0] ]\n                        })\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.things}>Things</SpsLabel>\n                            <SpsMultiSelect\n                                icon={SpsIcon.FILTER}\n                                options={opts}\n                                formMeta={formMeta.fields.things}\n                                value={formValue.things}\n                            />\n                            <br />\n                            {JSON.stringify(formValue)}\n                        </>\n                    }\n                "], ["\n                    function Component() {\n                        const [opts] = React.useState([\"foo\", \"bar\", \"baz\", \"orp\"])\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            things: [ opts[0] ]\n                        })\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.things}>Things</SpsLabel>\n                            <SpsMultiSelect\n                                icon={SpsIcon.FILTER}\n                                options={opts}\n                                formMeta={formMeta.fields.things}\n                                value={formValue.things}\n                            />\n                            <br />\n                            {JSON.stringify(formValue)}\n                        </>\n                    }\n                "]))),
            },
            objects: {
                react: code(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject$t(["\n                    function Component() {\n                        const [opts] = React.useState([\n                            { id: 1, name: \"Target\" },\n                            { id: 2, name: \"Cabela's\" },\n                            { id: 3, name: \"Best Buy\" },\n                        ])\n                        const [foo, setFoo] = React.useState([])\n                        function handleChange(event) {\n                            setFoo(event.target.value)\n                        }\n                        return (\n                            <>\n                                <SpsMultiSelect\n                                    options={opts}\n                                    textKey=\"name\"\n                                    value={foo}\n                                    onChange={handleChange}\n                                />\n                                <br />\n                                {JSON.stringify(foo)}\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const [opts] = React.useState([\n                            { id: 1, name: \"Target\" },\n                            { id: 2, name: \"Cabela's\" },\n                            { id: 3, name: \"Best Buy\" },\n                        ])\n                        const [foo, setFoo] = React.useState([])\n                        function handleChange(event) {\n                            setFoo(event.target.value)\n                        }\n                        return (\n                            <>\n                                <SpsMultiSelect\n                                    options={opts}\n                                    textKey=\"name\"\n                                    value={foo}\n                                    onChange={handleChange}\n                                />\n                                <br />\n                                {JSON.stringify(foo)}\n                            </>\n                        )\n                    }\n                "]))),
            },
            disabledOptions: {
                react: code(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject$t(["\n                    function Component() {\n                        const [opts] = React.useState([\n                            { id: 1, name: \"Target\", disabled: true },\n                            { id: 2, name: \"Cabela's\", disabled: true },\n                            { id: 3, name: \"Best Buy\" },\n                        ])\n                        const [foo, setFoo] = React.useState([])\n                        function handleChange(event) {\n                            setFoo(event.target.value)\n                        }\n                        return (\n                            <>\n                                <SpsMultiSelect\n                                    options={opts}\n                                    textKey=\"name\"\n                                    value={foo}\n                                    onChange={handleChange}\n                                />\n                                <br />\n                                {JSON.stringify(foo)}\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const [opts] = React.useState([\n                            { id: 1, name: \"Target\", disabled: true },\n                            { id: 2, name: \"Cabela's\", disabled: true },\n                            { id: 3, name: \"Best Buy\" },\n                        ])\n                        const [foo, setFoo] = React.useState([])\n                        function handleChange(event) {\n                            setFoo(event.target.value)\n                        }\n                        return (\n                            <>\n                                <SpsMultiSelect\n                                    options={opts}\n                                    textKey=\"name\"\n                                    value={foo}\n                                    onChange={handleChange}\n                                />\n                                <br />\n                                {JSON.stringify(foo)}\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$t, templateObject_2$q, templateObject_3$m, templateObject_4$f, templateObject_5$7, templateObject_6$5;

var __assign$V = (undefined && undefined.__assign) || function () {
    __assign$V = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$V.apply(this, arguments);
};
var __rest$K = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$P = {};
var propTypes$R = __assign$V({}, spsGlobalPropTypes);
function SpsPageTitle(props) {
    var children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$K(props, ["children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var icon;
    var otherChildren = [];
    React.Children.forEach(children, function (child) {
        if (React.isValidElement(child) && child.type === "i") {
            icon = child;
        }
        else {
            otherChildren.push(child);
        }
    });
    var classes = clsx(unsafelyReplaceClassName || "sps-page-title", className);
    return (React.createElement("div", __assign$V({ className: classes, "data-testid": "" + testId }, rest),
        icon,
        React.createElement("div", { className: "sps-page-title__text", "data-testid": testId + "__text" }, otherChildren)));
}
Object.assign(SpsPageTitle, {
    props: propsDoc$P,
    propTypes: propTypes$R,
    displayName: "SpsPageTitle",
});

var __assign$U = (undefined && undefined.__assign) || function () {
    __assign$U = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$U.apply(this, arguments);
};
var __rest$J = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$O = {};
var propTypes$Q = __assign$U({}, spsGlobalPropTypes);
function SpsPageSubtitle(props) {
    var children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$J(props, ["children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-page-title__subtitle", className);
    return (React.createElement("div", __assign$U({ className: classes, "data-testid": testId }, rest), children));
}
Object.assign(SpsPageSubtitle, {
    props: propsDoc$O,
    propTypes: propTypes$Q,
    displayName: "SpsPageSubtitle",
});

var __makeTemplateObject$s = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsPageTitleExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                jsx: code(templateObject_1$s || (templateObject_1$s = __makeTemplateObject$s(["\n                    <SpsPageTitle>\n                        Cabela's Purchase Order #123456789012\n                    </SpsPageTitle>\n                "], ["\n                    <SpsPageTitle>\n                        Cabela's Purchase Order #123456789012\n                    </SpsPageTitle>\n                "]))),
            },
        },
    },
    withIcon: {
        label: "With Icon",
        examples: {
            withIcon: {
                jsx: code(templateObject_2$p || (templateObject_2$p = __makeTemplateObject$s(["\n                    <SpsPageTitle>\n                        <i className=\"sps-icon sps-icon-exclamation-circle red200\" aria-hidden=\"true\"></i>\n                        Cabela's Purchase Order #123456789012\n                    </SpsPageTitle>\n                "], ["\n                    <SpsPageTitle>\n                        <i className=\"sps-icon sps-icon-exclamation-circle red200\" aria-hidden=\"true\"></i>\n                        Cabela's Purchase Order #123456789012\n                    </SpsPageTitle>\n                "]))),
            },
        },
    },
    withSubtitle: {
        label: "With Subtitle",
        examples: {
            withSubtitle: {
                jsx: code(templateObject_3$l || (templateObject_3$l = __makeTemplateObject$s(["\n                    <SpsPageTitle>\n                        Cabela's Purchase Order #123456789012\n                        <SpsPageSubtitle>Cabela's\n                            <i className=\"sps-icon sps-icon-outgoing\"></i>\n                            MacNeil Automotive Parts\n                        </SpsPageSubtitle>\n                    </SpsPageTitle>\n                "], ["\n                    <SpsPageTitle>\n                        Cabela's Purchase Order #123456789012\n                        <SpsPageSubtitle>Cabela's\n                            <i className=\"sps-icon sps-icon-outgoing\"></i>\n                            MacNeil Automotive Parts\n                        </SpsPageSubtitle>\n                    </SpsPageTitle>\n                "]))),
            },
        },
    },
    withSubtitleAndIcon: {
        label: "With Subtitle and Icon",
        examples: {
            withSubtitleAndIcon: {
                jsx: code(templateObject_4$e || (templateObject_4$e = __makeTemplateObject$s(["\n                    <SpsPageTitle>\n                        <i aria-hidden=\"true\" className=\"sps-icon sps-icon-exclamation-circle red200\"></i>\n                        Cabela's Purchase Order #123456789012\n                        <SpsPageSubtitle>\n                            Cabela's <i aria-hidden=\"true\" className=\"sps-icon sps-icon-outgoing\"></i>\n                            MacNeil Automotive Parts\n                        </SpsPageSubtitle>\n                    </SpsPageTitle>\n                "], ["\n                    <SpsPageTitle>\n                        <i aria-hidden=\"true\" className=\"sps-icon sps-icon-exclamation-circle red200\"></i>\n                        Cabela's Purchase Order #123456789012\n                        <SpsPageSubtitle>\n                            Cabela's <i aria-hidden=\"true\" className=\"sps-icon sps-icon-outgoing\"></i>\n                            MacNeil Automotive Parts\n                        </SpsPageSubtitle>\n                    </SpsPageTitle>\n                "]))),
            },
        },
    },
};
var templateObject_1$s, templateObject_2$p, templateObject_3$l, templateObject_4$e;

var __assign$T = (undefined && undefined.__assign) || function () {
    __assign$T = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$T.apply(this, arguments);
};
var __rest$I = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$m = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$N = {
    action: "SpsActionMethod",
    captionKey: "string",
    comparisonKey: "string",
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<any>",
    notClearable: "boolean",
    options: "Eventually<any[]> | (filter?: string) => Eventually<any[]>",
    onChange: "ChangeEventHandler",
    placeholder: "string",
    searchDebounce: "number",
    searchPlaceholder: "string",
    tallOptionList: "boolean",
    textKey: "string",
    valueKey: "string",
    value: "any",
    zeroState: "string",
    autoFixWidth: "boolean",
    loading: "boolean",
    filterByTextAndCaptionKey: "boolean",
};
var propTypes$P = __assign$T(__assign$T({}, spsGlobalPropTypes), { action: fun(), captionKey: propTypes$1H.exports.string, comparisonKey: propTypes$1H.exports.string, disabled: propTypes$1H.exports.bool, formControl: impl(), formMeta: impl(), notClearable: propTypes$1H.exports.bool, options: propTypes$1H.exports.oneOfType([
        propTypes$1H.exports.array,
        propTypes$1H.exports.instanceOf(Promise),
        fun(),
    ]).isRequired, onChange: fun(), placeholder: propTypes$1H.exports.string, searchDebounce: propTypes$1H.exports.number, searchPlaceholder: propTypes$1H.exports.string, tallOptionList: propTypes$1H.exports.bool, textKey: propTypes$1H.exports.string, valueKey: propTypes$1H.exports.string, value: propTypes$1H.exports.any, zeroState: propTypes$1H.exports.string, autoFixWidth: propTypes$1H.exports.bool, loading: propTypes$1H.exports.bool, filterByTextAndCaptionKey: propTypes$1H.exports.bool });
var SpsSelect = React.forwardRef(function (props, ref) {
    var action = props.action, _a = props.autoFixWidth, autoFixWidth = _a === void 0 ? false : _a, captionKey = props.captionKey, className = props.className, comparisonKey = props.comparisonKey, disabled = props.disabled, formControl = props.formControl, formMeta = props.formMeta, id = props.id, notClearable = props.notClearable, options = props.options, onChange = props.onChange, onClick = props.onClick, placeholder = props.placeholder, searchDebounce = props.searchDebounce, _b = props.searchPlaceholder, searchPlaceholder = _b === void 0 ? "Search…" : _b, tallOptionList = props.tallOptionList, textKey = props.textKey, valueKey = props.valueKey, unsafelyReplaceClassName = props.unsafelyReplaceClassName, valueProp = props.value, zeroState = props.zeroState, loading = props.loading, filterByTextAndCaptionKey = props.filterByTextAndCaptionKey, testId = props["data-testid"], rest = __rest$I(props, ["action", "autoFixWidth", "captionKey", "className", "comparisonKey", "disabled", "formControl", "formMeta", "id", "notClearable", "options", "onChange", "onClick", "placeholder", "searchDebounce", "searchPlaceholder", "tallOptionList", "textKey", "valueKey", "unsafelyReplaceClassName", "value", "zeroState", "loading", "filterByTextAndCaptionKey", "data-testid"]);
    var meta = formMeta || formControl;
    var _c = useFormControlId(id, meta), wrapperId = _c.wrapperId, controlId = _c.controlId;
    var optionsList = React.useRef(null);
    var rootElement = React.useRef(null);
    var controlButton = React.useRef(null);
    var t = React.useContext(I18nContext).t;
    var _d = __read$m(usePatchReducer({
        isOpen: false,
        value: valueProp,
        text: "",
        keyDown: null,
        opensUpward: false,
        optionIds: "",
    }), 2), state = _d[0], patchState = _d[1];
    function setValueAndText(newValue) {
        patchState({
            value: newValue,
            text: newValue && textKey ? newValue[textKey] : newValue,
        });
    }
    function updateValue(newValue) {
        setValueAndText(newValue);
        var actualValue = newValue && valueKey && typeof newValue === "object" ? newValue[valueKey] : newValue;
        if (meta) {
            meta.setValue(actualValue);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(new FauxChangeEvent({ value: actualValue }));
        }
    }
    React.useEffect(function () {
        setValueAndText(valueProp);
    }, [valueProp, textKey]);
    function handleClearIconClick() {
        updateValue(undefined);
    }
    function handleDocumentClick() {
        patchState({ isOpen: false });
    }
    function handleControlButtonClick(event) {
        event.nativeEvent.stopImmediatePropagation();
        if (!disabled) {
            patchState({ isOpen: !state.isOpen });
        }
    }
    function handleKeyDown(event) {
        if (!disabled) {
            // older browsers use "Spacebar" over " "
            if (["Up",
                "ArrowUp",
                "Down",
                "ArrowDown",
                " ",
                "Spacebar"].indexOf(event.key) > -1) {
                event.preventDefault();
            }
            event.persist();
            patchState({ keyDown: event });
        }
    }
    function handleSelfToggle(olIsOpen) {
        patchState({ isOpen: olIsOpen });
    }
    function handlePositionFlip(opensUpward) {
        patchState({ opensUpward: opensUpward });
    }
    function handleDropdownOpened(event) {
        if (event.detail !== wrapperId) {
            patchState({ isOpen: false });
        }
    }
    function handleOptionListChanged(filteredListLength) {
        patchState({
            optionIds: new Array(filteredListLength)
                .fill("")
                .map(function (s, i) { return wrapperId + "-options-option-" + i; })
                .join(","),
        });
    }
    React.useEffect(function () {
        document.addEventListener("click", handleDocumentClick);
        document.addEventListener("DropdownOpened", handleDropdownOpened);
        return function () {
            document.removeEventListener("click", handleDocumentClick);
            document.removeEventListener("DropdownOpened", handleDropdownOpened);
        };
    }, []);
    React.useLayoutEffect(function () {
        if (autoFixWidth && controlButton.current && optionsList.current) {
            optionsList.current.style.width = null;
            var optionsWrapperWidth = optionsList.current.getBoundingClientRect().width;
            var fixedWidth = optionsWrapperWidth + 6 + "px";
            optionsList.current.style.width = fixedWidth;
            controlButton.current.style.width = fixedWidth;
            controlButton.current.style.maxWidth = fixedWidth;
        }
    });
    useDidUpdateEffect(function () {
        if (state.isOpen) {
            var event_1 = document.createEvent("CustomEvent");
            event_1.initCustomEvent("DropdownOpened", false, false, wrapperId);
            document.dispatchEvent(event_1);
        }
        else {
            rootElement.current.focus();
        }
    }, [state.isOpen]);
    React.useImperativeHandle(ref, function () { return ({
        focus: function () {
            rootElement.current.focus();
        },
    }); });
    var classes = clsx(unsafelyReplaceClassName || "sps-select", state.isOpen && "sps-select--open", state.isOpen && "z-stratum-dropdown", state.opensUpward && "sps-select--opens-upward", className);
    var valueText = state.text || placeholder || t("design-system:select.defaultPlaceholder");
    return (React.createElement(SpsFormComponentWrapper, __assign$T({ id: wrapperId, className: classes, onKeyDown: handleKeyDown, formControl: formControl, formMeta: formMeta, ref: rootElement, role: "listbox", "aria-owns": state.optionIds, "data-testid": testId, onClick: onClick }, rest),
        React.createElement("div", { className: clsx("sps-select__dropctrl", disabled && "disabled"), id: controlId, tabIndex: 0, onClick: handleControlButtonClick, ref: controlButton, title: valueText, "data-testid": testId + "-dropctrl" },
            React.createElement("div", { className: "sps-select__dropctrl-content" },
                React.createElement("span", { className: clsx("sps-select__value", !state.text && "sps-select__value--placeholder"), "data-testid": testId + "-value" }, valueText),
                state.value && !notClearable && !disabled && (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-select__clear-btn", onClick: handleClearIconClick, "data-testid": testId + "-clear-value" })),
                React.createElement("i", { className: "sps-icon sps-icon-chevron-down" }))),
        React.createElement(SpsOptionList, { id: wrapperId + "-options", ref: optionsList, attachTo: controlButton, captionKey: captionKey, comparisonKey: comparisonKey, isOpen: state.isOpen, keyDown: state.keyDown, nullOption: state.value && !notClearable ? placeholder : null, options: options, onOptionSelected: updateValue, onPositionFlip: handlePositionFlip, onSelfToggle: handleSelfToggle, searchDebounce: searchDebounce, searchPlaceholder: searchPlaceholder, selectedOption: state.value, specialAction: action, tall: tallOptionList, textKey: textKey, filterByTextAndCaptionKey: filterByTextAndCaptionKey, optionRole: "option", valueKey: valueKey, onOptionListChanged: handleOptionListChanged, zeroState: zeroState, ignoreWidthStyles: autoFixWidth, loading: loading, "data-testid": testId + "-option-list" })));
});
Object.assign(SpsSelect, {
    props: propsDoc$N,
    propTypes: propTypes$P,
    displayName: "SpsSelect",
});

var __assign$S = (undefined && undefined.__assign) || function () {
    __assign$S = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$S.apply(this, arguments);
};
var __rest$H = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$l = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$M = {
    page: "number",
    numPages: "number",
    onPageChange: "(number) => void",
    disabled: "boolean",
};
var propTypes$O = __assign$S({ numPages: propTypes$1H.exports.number, onPageChange: fun(), page: propTypes$1H.exports.number, disabled: propTypes$1H.exports.bool }, spsGlobalPropTypes);
function SpsPageSelector(props) {
    var _a = props.numPages, numPages = _a === void 0 ? 0 : _a, onPageChange = props.onPageChange, _b = props.page, pageProp = _b === void 0 ? 1 : _b, unsafelyReplaceClassName = props.unsafelyReplaceClassName, className = props.className, testId = props["data-testid"], _c = props.disabled, disabled = _c === void 0 ? false : _c, rest = __rest$H(props, ["numPages", "onPageChange", "page", "unsafelyReplaceClassName", "className", "data-testid", "disabled"]);
    var t = React.useContext(I18nContext).t;
    var _d = __read$l(React.useState(pageProp), 2), inputPage = _d[0], setInputPage = _d[1];
    var _e = __read$l(React.useState(pageProp), 2), page = _e[0], setPage = _e[1];
    React.useEffect(function () {
        setPage(pageProp);
        setInputPage(pageProp);
    }, [pageProp]);
    function updatePage(newPage) {
        var constrainedPage = constrain(newPage, [1, numPages]);
        if (constrainedPage !== inputPage) {
            setPage(constrainedPage);
            setInputPage(constrainedPage);
            if (onPageChange && typeof onPageChange === "function") {
                onPageChange(constrainedPage);
            }
        }
    }
    var debouncedPageUpdate = debounce(updatePage, 500);
    function onTextInputInput(event) {
        setInputPage(event.target.value);
        void debouncedPageUpdate(parseInt(event.target.value, 10));
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-page-selector", className);
    var id = useElementId(null);
    return (React.createElement("div", __assign$S({ className: classes, "data-testid": testId }, rest),
        React.createElement("div", { className: "sps-pagination__input-wrapper", "data-testid": testId + "__input" },
            React.createElement("div", { className: "sps-form-control sps-pagination__input-sizer" }, inputPage),
            React.createElement("label", { htmlFor: id.current, className: "sr-only" }, t("design-system:pagination.page")),
            React.createElement("input", { id: id.current, type: "text", value: inputPage, onInput: onTextInputInput, onChange: function () { }, className: "sps-form-control sps-pagination__input", disabled: disabled })),
        React.createElement("span", { className: "sps-page-selector__total-pages", "data-testid": testId + "_page-count" }, Number.isNaN(numPages)
            ? t("design-system:pagination.ofMany")
            : t("design-system:pagination.ofPageCount", { pageCount: numPages })),
        React.createElement("div", { className: "sps-icon-button-panel", "data-testid": testId + "__buttons" },
            React.createElement("div", { className: clsx("sps-button", "sps-button--icon", (page === 1 || disabled) && "sps-button--disabled") },
                React.createElement("button", { type: "button", onClick: function () { return updatePage(page - 1); }, disabled: page === 1 || disabled, title: t("design-system:pagination.prevPage") },
                    React.createElement("i", { className: "sps-icon sps-icon-chevron-left", "aria-hidden": "true" }))),
            React.createElement("div", { className: clsx("sps-button", "sps-button--icon", (page === numPages || disabled) && "sps-button--disabled") },
                React.createElement("button", { type: "button", onClick: function () { return updatePage(page + 1); }, disabled: page === numPages || disabled, title: t("design-system:pagination.nextPage") },
                    React.createElement("i", { className: "sps-icon sps-icon-chevron-right", "aria-hidden": "true" }))))));
}
Object.assign(SpsPageSelector, {
    props: propsDoc$M,
    propTypes: propTypes$O,
    displayName: "SpsPageSelector",
});

var __assign$R = (undefined && undefined.__assign) || function () {
    __assign$R = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$R.apply(this, arguments);
};
var __rest$G = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$k = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$L = {
    page: "number",
    pageSize: "number",
    pageSizeOptions: "Array<number>",
    totalResults: "number",
    onPageChange: "(page: number, pageSize: number, indices: [number, number]) => void",
    disabled: "boolean",
};
var propTypes$N = __assign$R({ onPageChange: fun()
        .isRequired, page: propTypes$1H.exports.number, pageSize: propTypes$1H.exports.number, pageSizeOptions: propTypes$1H.exports.arrayOf(propTypes$1H.exports.number), totalResults: propTypes$1H.exports.number, disabled: propTypes$1H.exports.bool }, spsGlobalPropTypes);
function SpsPagination(props) {
    var className = props.className, onPageChange = props.onPageChange, _a = props.page, pageProp = _a === void 0 ? 1 : _a, _b = props.pageSizeOptions, pageSizeOptions = _b === void 0 ? DEFAULT_PAGE_SIZE_OPTIONS : _b, _c = props.pageSize, pageSizeProp = _c === void 0 ? pageSizeOptions[0] : _c, testId = props["data-testid"], totalResults = props.totalResults, unsafelyReplaceClassName = props.unsafelyReplaceClassName, _d = props.disabled, disabled = _d === void 0 ? false : _d, rest = __rest$G(props, ["className", "onPageChange", "page", "pageSizeOptions", "pageSize", "data-testid", "totalResults", "unsafelyReplaceClassName", "disabled"]);
    var _e = __read$k(usePatchReducer({
        page: pageProp,
        pageSize: pageSizeProp,
        numPages: 0,
        indices: [0, 0],
    }), 2), state = _e[0], patchState = _e[1];
    function numPages(pageSize) {
        if (pageSize === void 0) { pageSize = state.pageSize; }
        return Math.ceil(totalResults / pageSize);
    }
    function indices(page, pageSize) {
        if (page === void 0) { page = state.page; }
        if (pageSize === void 0) { pageSize = state.pageSize; }
        var numPgs = numPages();
        var resultsVisibleIfThereArePages = page === numPgs
            ? totalResults % pageSize || pageSize
            : pageSize;
        var resultsVisible = numPgs === 0 ? 0 : resultsVisibleIfThereArePages;
        var start = (page - 1) * pageSize;
        return numPgs === 0 ? [0, 0] : [start + 1, start + resultsVisible];
    }
    function setPage(newPage) {
        var newState = {
            page: newPage,
            indices: indices(newPage),
        };
        patchState(newState);
        return newState;
    }
    function setPageSize(newPageSize, newPage) {
        var newState = {
            page: newPage,
            pageSize: newPageSize,
            numPages: numPages(newPageSize),
            indices: indices(newPage, newPageSize),
        };
        patchState(newState);
        return newState;
    }
    React.useEffect(function () {
        if (pageProp !== state.page) {
            setPage(pageProp);
        }
    }, [pageProp]);
    React.useEffect(function () {
        if (pageSizeProp !== state.pageSize) {
            setPageSize(pageSizeProp, pageProp !== state.page ? pageProp : state.page);
        }
    }, [pageSizeProp]);
    React.useEffect(function () {
        patchState({
            numPages: numPages(),
            indices: indices(),
        });
    }, [totalResults]);
    function totalResultsString() {
        return typeof totalResults === "number" ? totalResults : "many";
    }
    function handlePageSizeChange(event) {
        var newState = setPageSize(event.target.value, 1);
        onPageChange(newState.page, newState.pageSize, newState.indices);
    }
    function handlePageChange(newPage) {
        var newState = setPage(newPage);
        onPageChange(newState.page, state.pageSize, newState.indices);
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-pagination", className);
    return (React.createElement("div", __assign$R({ className: classes, "data-testid": testId }, rest),
        React.createElement("div", { "data-testid": testId + "__size-selector", className: "sps-page-size-selector" },
            "View",
            React.createElement(SpsSelect, { options: pageSizeOptions, onChange: handlePageSizeChange, notClearable: true, autoFixWidth: true, value: state.pageSize, className: "ml-1 mr-1", disabled: disabled }),
            "Per Page"),
        React.createElement("div", { className: "sps-pagination__details" }, "Viewing " + state.indices[0] + " - " + state.indices[1] + " of " + totalResultsString()),
        React.createElement(SpsPageSelector, { numPages: state.numPages, page: state.page, onPageChange: handlePageChange, disabled: disabled })));
}
Object.assign(SpsPagination, {
    props: propsDoc$L,
    propTypes: propTypes$N,
    displayName: "SpsPagination",
});

var __makeTemplateObject$r = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsPaginationExamples = {
    general: {
        label: 'General Usage',
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Use the Standard Pagination Bar on a list page (comprised of a Table, Content Rows, or Content Tiles). It should always appear at the bottom of the listed records."),
            React.createElement("p", null, "Use the Mini Pagination component when a paginated list of results exists inside a smaller Card."))); },
    },
    pagination: {
        label: 'Standard Pagination Bar',
        description: function (_a) {
            var Link = _a.Link;
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "The Standard Pagination Bar is comprised of three main sections. The middle section is hidden from view when the width of its container is at the responsive breakpoint of 767 pixels."),
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("p", null,
                            React.createElement("span", { className: "sps-text-semibold" }, "Results-per-page Select"),
                            ' ',
                            "(left): allows the user to adjust the number of records being displayed per page.*")),
                    React.createElement("li", null,
                        React.createElement("p", null,
                            React.createElement("span", { className: "sps-text-semibold" }, "Viewing details"),
                            " (middle): describes which results are being displayed on the current page.")),
                    React.createElement("li", null,
                        React.createElement("p", null,
                            React.createElement("span", { className: "sps-text-semibold" }, "Page Navigator"),
                            " (right): allows the user to navigate between pages of results"))),
                React.createElement("i", null, "*Note: For Tables and Content Rows, per-page options should be 25, 50, and 100. For Content Tiles, per-page options should be 24, 48, and 100."),
                React.createElement("br", null),
                React.createElement("p", { className: "mt-2" },
                    "To see an example of the Standard Pagination Bar in context with a Table, view the Table Lists section on the",
                    ' ',
                    React.createElement(Link, { to: "/style-and-layout/page-types" }, "Page Types"),
                    " page.")));
        },
        examples: {
            basic: {
                description: function () { return React.createElement("h4", null, "Building the Standard Pagination Bar"); },
                react: code(templateObject_1$r || (templateObject_1$r = __makeTemplateObject$r(["\n                    function Component() {\n                        const [page, setPage] = React.useState(2);\n                        const [pageSize, setPageSize] = React.useState(25);\n\n                        function handlePageChange(newPage, newPageSize) {\n                          console.log(\"change\", newPage, newPageSize);\n                          setPage(newPage);\n                          setPageSize(newPageSize);\n                        }\n\n                        return (\n                          <React.Fragment>\n                            <SpsPagination id=\"basic\"\n                              totalResults={123}\n                              page={page}\n                              pageSize={pageSize}\n                              onPageChange={handlePageChange}\n                            />\n                            <span className=\"mr-2\">page: {page}</span>\n                            <span>pageSize: {pageSize}</span>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const [page, setPage] = React.useState(2);\n                        const [pageSize, setPageSize] = React.useState(25);\n\n                        function handlePageChange(newPage, newPageSize) {\n                          console.log(\"change\", newPage, newPageSize);\n                          setPage(newPage);\n                          setPageSize(newPageSize);\n                        }\n\n                        return (\n                          <React.Fragment>\n                            <SpsPagination id=\"basic\"\n                              totalResults={123}\n                              page={page}\n                              pageSize={pageSize}\n                              onPageChange={handlePageChange}\n                            />\n                            <span className=\"mr-2\">page: {page}</span>\n                            <span>pageSize: {pageSize}</span>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            disabled: {
                description: 'Disabled state',
                react: code(templateObject_2$o || (templateObject_2$o = __makeTemplateObject$r(["\n                    function Component() {\n                        return (\n                            <SpsPagination id=\"basic\"\n                                totalResults={123}\n                                page={2}\n                                pageSize={25}\n                                onPageChange={() => {}}\n                                disabled\n                            />\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                            <SpsPagination id=\"basic\"\n                                totalResults={123}\n                                page={2}\n                                pageSize={25}\n                                onPageChange={() => {}}\n                                disabled\n                            />\n                        );\n                    }\n                "]))),
            },
        },
    },
    pageSelector: {
        label: 'Page Navigator',
        description: function (_a) {
            var Link = _a.Link;
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "When navigating through a series of paginated results inside of a container such as a sidebar, a miniature version of the pagination bar can be used. This version utilizes only the page navigation component. Use Mini Pagination inside of a Card Header that also includes a title describing the content contained in the card below."),
                React.createElement("p", null,
                    "To see an example of the Page Navigator in context within a Card Header, view the General Content section on the",
                    ' ',
                    React.createElement(Link, { to: "/style-and-layout/page-types" }, "Page Types"),
                    " page.")));
        },
        examples: {
            basic: {
                description: function () { return React.createElement("h4", null, "Building the Page Navigator"); },
                react: code(templateObject_3$k || (templateObject_3$k = __makeTemplateObject$r(["\n                    function Component() {\n                        const pageChanged = val => {\n                          console.log(val);\n                        };\n                        return <SpsPageSelector numPages={25} onPageChange={pageChanged} />;\n                    }\n                "], ["\n                    function Component() {\n                        const pageChanged = val => {\n                          console.log(val);\n                        };\n                        return <SpsPageSelector numPages={25} onPageChange={pageChanged} />;\n                    }\n                "]))),
            },
            disabled: {
                description: 'Disabled state',
                react: code(templateObject_4$d || (templateObject_4$d = __makeTemplateObject$r(["\n                    function Component() {\n                        return <SpsPageSelector numPages={25} onPageChange={() => {}} disabled />;\n                    }\n                "], ["\n                    function Component() {\n                        return <SpsPageSelector numPages={25} onPageChange={() => {}} disabled />;\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$r, templateObject_2$o, templateObject_3$k, templateObject_4$d;

var __assign$Q = (undefined && undefined.__assign) || function () {
    __assign$Q = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$Q.apply(this, arguments);
};
var __rest$F = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$K = {
    active: "boolean",
    as: "React.ElementType",
};
function SpsProductBarTab(props) {
    var active = props.active, _a = props.as, RootElement = _a === void 0 ? "a" : _a, children = props.children; props.className; var unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$F(props, ["active", "as", "children", "className", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-nav__item", "sps-nav__link", active && "active");
    return (React.createElement(RootElement, __assign$Q({ className: classes }, rest), children));
}
Object.assign(SpsProductBarTab, {
    props: propsDoc$K,
    displayName: "SpsProductBarTab",
});

var __assign$P = (undefined && undefined.__assign) || function () {
    __assign$P = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$P.apply(this, arguments);
};
var __rest$E = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$j = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$J = {
    activeTab: "string",
    fullWidth: "boolean",
    onTabChange: "(newTab: string) => void",
    onProductNameClick: "React.MouseEventHandler",
    productLogoSrc: "string",
    productName: { type: "string", required: true },
    productNameHref: "string",
    tabs: "Array<string>",
};
var propTypes$M = __assign$P(__assign$P({}, spsGlobalPropTypes), { activeTab: propTypes$1H.exports.string, fullWidth: propTypes$1H.exports.bool, onTabChange: fun(), onProductNameClick: fun(), productLogoSrc: propTypes$1H.exports.string, productName: propTypes$1H.exports.string.isRequired, productNameHref: propTypes$1H.exports.string, tabs: propTypes$1H.exports.arrayOf(propTypes$1H.exports.string) });
function SpsProductBar(props) {
    var activeTabInit = props.activeTab, children = props.children, className = props.className, fullWidth = props.fullWidth, onProductNameClick = props.onProductNameClick, onTabChange = props.onTabChange, productLogoSrc = props.productLogoSrc, productName = props.productName, productNameHref = props.productNameHref, _a = props.tabs, tabs = _a === void 0 ? [] : _a, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$E(props, ["activeTab", "children", "className", "fullWidth", "onProductNameClick", "onTabChange", "productLogoSrc", "productName", "productNameHref", "tabs", "unsafelyReplaceClassName"]);
    var rootElement = React.useRef();
    var _b = __read$j(selectChildren(children, [{ type: SpsProductBarTab }]), 2), tabElement = _b[0], otherChildren = _b[1];
    var _c = __read$j(React.useState(activeTabInit || tabs[0]), 2), activeTab = _c[0], setActiveTab = _c[1];
    React.useEffect(function () {
        setActiveTab(activeTabInit);
    }, [activeTabInit]);
    function handleTabClick(tab) {
        setActiveTab(tab);
        if (onTabChange) {
            onTabChange(tab);
        }
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-navbar-container", "z-stratum-bar", className);
    return (React.createElement("div", __assign$P({ className: classes }, rest, { ref: rootElement }),
        React.createElement("nav", { className: clsx("sps-navbar", "sps-navbar--expand-lg", fullWidth && "sps-navbar--full-width") },
            React.createElement("a", { className: "sps-navbar__brand", href: productNameHref, onClick: onProductNameClick },
                productLogoSrc && (React.createElement("img", { className: "sps-navbar__brand-logo", src: productLogoSrc, "aria-hidden": "true", alt: productName + " Logo" })),
                React.createElement("span", { className: "sps-navbar__brand-name" }, productName)),
            React.createElement("span", { className: "sps-vertical-rule" }),
            React.createElement("div", { className: "sps-navbar__nav" },
                tabs.map(function (tab) { return (React.createElement("a", { className: clsx("sps-nav__item", "sps-nav__link", tab === activeTab && "active"), key: tab, onClick: function () { return handleTabClick(tab); } },
                    React.createElement("span", null, tab),
                    tab === activeTab && React.createElement("span", { className: "sr-only" }, "(current)"))); }),
                tabElement),
            React.createElement("div", { className: "sps-navbar__content" },
                React.createElement(PortalContext.Provider, { value: { parentElementRef: rootElement, fixed: true } }, otherChildren)))));
}
Object.assign(SpsProductBar, {
    props: propsDoc$J,
    propTypes: propTypes$M,
    displayName: "SpsProductBar",
});

var __makeTemplateObject$q = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsProductBarExamples = {
    basic: {
        label: "Basic",
        description: code(templateObject_1$q || (templateObject_1$q = __makeTemplateObject$q(["\n            <p>Product navigation bar</p>\n        "], ["\n            <p>Product navigation bar</p>\n        "]))),
        examples: {
            basic: {
                react: code(templateObject_2$n || (templateObject_2$n = __makeTemplateObject$q(["\n                    function DemoComponent() {\n                        const navTabs = [\"Foo\", \"Bar\", \"Baz\"];\n                        function handleTabChange(newTab) {\n                            alert(newTab);\n                        }\n\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                tabs={navTabs}\n                                activeTab=\"Bar\"\n                                onTabChange={handleTabChange}\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            ><SpsButton>do the thing</SpsButton></SpsProductBar>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const navTabs = [\"Foo\", \"Bar\", \"Baz\"];\n                        function handleTabChange(newTab) {\n                            alert(newTab);\n                        }\n\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                tabs={navTabs}\n                                activeTab=\"Bar\"\n                                onTabChange={handleTabChange}\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            ><SpsButton>do the thing</SpsButton></SpsProductBar>\n                        );\n                    }\n                "]))),
            },
        },
    },
    action: {
        label: "Action",
        examples: {
            basic: {
                react: code(templateObject_3$j || (templateObject_3$j = __makeTemplateObject$q(["\n                    function DemoComponent() {\n                        const navTabs = [\"Foo\", \"Bar\", \"Baz\"];\n                        function handleTabChange(newTab) {\n                            alert(newTab);\n                        }\n\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                tabs={navTabs}\n                                activeTab=\"Bar\"\n                                onTabChange={handleTabChange}\n                                onProductNameClick={() => console.log(\"product name clicked\")}\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            ><SpsButton>do the thing</SpsButton></SpsProductBar>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const navTabs = [\"Foo\", \"Bar\", \"Baz\"];\n                        function handleTabChange(newTab) {\n                            alert(newTab);\n                        }\n\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                tabs={navTabs}\n                                activeTab=\"Bar\"\n                                onTabChange={handleTabChange}\n                                onProductNameClick={() => console.log(\"product name clicked\")}\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            ><SpsButton>do the thing</SpsButton></SpsProductBar>\n                        );\n                    }\n                "]))),
            },
        },
    },
    link: {
        label: "Link",
        examples: {
            basic: {
                react: code(templateObject_4$c || (templateObject_4$c = __makeTemplateObject$q(["\n                    function DemoComponent() {\n                        const navTabs = [\"Foo\", \"Bar\", \"Baz\"];\n                        function handleTabChange(newTab) {\n                            alert(newTab);\n                        }\n\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                productNameHref=\"https://www.google.com\"\n                                tabs={navTabs}\n                                activeTab=\"Bar\"\n                                onTabChange={handleTabChange}\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            ><SpsButton>do the thing</SpsButton></SpsProductBar>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const navTabs = [\"Foo\", \"Bar\", \"Baz\"];\n                        function handleTabChange(newTab) {\n                            alert(newTab);\n                        }\n\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                productNameHref=\"https://www.google.com\"\n                                tabs={navTabs}\n                                activeTab=\"Bar\"\n                                onTabChange={handleTabChange}\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            ><SpsButton>do the thing</SpsButton></SpsProductBar>\n                        );\n                    }\n                "]))),
            },
        },
    },
    customTabs: {
        label: "Custom Tabs",
        examples: {
            basic: {
                react: code(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject$q(["\n                    function DemoComponent() {\n                        const [activeTab, setActiveTab] = React.useState(\"Bar\");\n\n                        return (\n                            <SpsProductBar\n                                productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            >\n                                <SpsProductBarTab\n                                    active={activeTab === \"Foo\"}\n                                    onClick={() => {\n                                        setActiveTab(\"Foo\");\n                                        console.log(\"Foo!\");\n                                    }}\n                                >\n                                    Foo\n                                </SpsProductBarTab>\n                                <SpsProductBarTab\n                                    active={activeTab === \"Bar\"}\n                                    onClick={() => {\n                                        setActiveTab(\"Bar\");\n                                        console.log(\"Bar!\");\n                                    }}\n                                >\n                                    Bar\n                                </SpsProductBarTab>\n                                <SpsProductBarTab\n                                    active={activeTab === \"Baz\"}\n                                    target=\"_blank\"\n                                    href=\"https://www.google.com\"\n                                    onClick={() => {\n                                        setActiveTab(\"Baz\");\n                                    }}\n                                >\n                                    Baz\n                                </SpsProductBarTab>\n                                <SpsButton>do the thing</SpsButton>\n                            </SpsProductBar>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const [activeTab, setActiveTab] = React.useState(\"Bar\");\n\n                        return (\n                            <SpsProductBar\n                                productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                fullWidth\n                                style={{ position: \"relative\", zIndex: \"auto\" }} // display this example in its place instead of at the top\n                            >\n                                <SpsProductBarTab\n                                    active={activeTab === \"Foo\"}\n                                    onClick={() => {\n                                        setActiveTab(\"Foo\");\n                                        console.log(\"Foo!\");\n                                    }}\n                                >\n                                    Foo\n                                </SpsProductBarTab>\n                                <SpsProductBarTab\n                                    active={activeTab === \"Bar\"}\n                                    onClick={() => {\n                                        setActiveTab(\"Bar\");\n                                        console.log(\"Bar!\");\n                                    }}\n                                >\n                                    Bar\n                                </SpsProductBarTab>\n                                <SpsProductBarTab\n                                    active={activeTab === \"Baz\"}\n                                    target=\"_blank\"\n                                    href=\"https://www.google.com\"\n                                    onClick={() => {\n                                        setActiveTab(\"Baz\");\n                                    }}\n                                >\n                                    Baz\n                                </SpsProductBarTab>\n                                <SpsButton>do the thing</SpsButton>\n                            </SpsProductBar>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$q, templateObject_2$n, templateObject_3$j, templateObject_4$c, templateObject_5$6;

var __assign$O = (undefined && undefined.__assign) || function () {
    __assign$O = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$O.apply(this, arguments);
};
var __rest$D = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$I = {
    percentComplete: "number",
    title: "string",
    detail: "string",
    disabled: "boolean",
    onClose: "() => void",
};
var propTypes$L = __assign$O(__assign$O({}, spsGlobalPropTypes), { percentComplete: propTypes$1H.exports.number, title: propTypes$1H.exports.string, detail: propTypes$1H.exports.string, disabled: propTypes$1H.exports.bool, onClose: fun() });
function SpsProgressBar(props) {
    props.children; var className = props.className, detail = props.detail, disabled = props.disabled, onClose = props.onClose, percentComplete = props.percentComplete, title = props.title; props["data-testid"]; var unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$D(props, ["children", "className", "detail", "disabled", "onClose", "percentComplete", "title", "data-testid", "unsafelyReplaceClassName"]);
    var t = React.useContext(I18nContext).t;
    var classes = clsx(unsafelyReplaceClassName || "sps-progress-bar", percentComplete === 1 && "sps-progress-bar--complete", disabled && "sps-progress-bar--disabled", className);
    return (React.createElement("div", __assign$O({ className: classes }, rest),
        React.createElement("div", { className: "sps-progress-bar__content" },
            title && (React.createElement("div", { className: "sps-progress-bar__heading" },
                React.createElement("div", { className: "sps-progress-bar__title" }, title),
                React.createElement("div", { className: "sps-progress-bar__percentage" }, Math.floor(percentComplete * 100) + "%"))),
            React.createElement("div", { className: "sps-progress-bar__bar-background" },
                React.createElement("div", { className: "sps-progress-bar__bar-progress", style: {
                        width: percentComplete * 100 + "%",
                    } })),
            detail && React.createElement("div", { className: "sps-progress-bar__detail" }, detail)),
        onClose && (React.createElement("div", { className: "sps-progress-bar__close-button" },
            React.createElement(SpsButton, { kind: ButtonKind.ICON, icon: SpsIcon.X, onClick: onClose, title: t("design-system:progressBar.closeButtonTitle") })))));
}
Object.assign(SpsProgressBar, {
    props: propsDoc$I,
    propTypes: propTypes$L,
    displayName: "SpsProgressBar",
});

var __makeTemplateObject$p = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSteppedProgressBarExamples = {
    standard: {
        label: 'Stepped Progress Bar',
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Stepped Progress Bars are comprised of the following Required and Optional elements."),
            React.createElement("img", { src: "assets/images/stepped-progress-bar-example.svg", alt: "A Progress Bar with labels on each section", className: "w-100 mb-3" }),
            React.createElement(SpsTable, null,
                React.createElement(SpsTableHead, null,
                    React.createElement(SpsTableHeader, null, "Section"),
                    React.createElement(SpsTableHeader, null, "Content Type"),
                    React.createElement(SpsTableHeader, null, "Required"),
                    React.createElement(SpsTableHeader, null, "Description/Guidelines")),
                React.createElement(SpsTableBody, null,
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "1")),
                        React.createElement(SpsTableCell, null, "Title"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "Use the Title when it provides necessary or helpful detail about the file or action that is being processed.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "2")),
                        React.createElement(SpsTableCell, null, "Progress Meter"),
                        React.createElement(SpsTableCell, null, "Yes"),
                        React.createElement(SpsTableCell, null)),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "3")),
                        React.createElement(SpsTableCell, null, "Progress Counter"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "The Progress Counter should not be used without the existence of a Title.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "4")),
                        React.createElement(SpsTableCell, null, "Step icons"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "Icons can be set inside of steps for visual emphasis.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "5")),
                        React.createElement(SpsTableCell, null, "Step Tooltips"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "Tooltips can be utilized to provide more details about each specific step. Tooltips can be exposed on click or hover.")))))); },
        examples: {
            standard: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h4", null, "Building Stepped Progress Bars"),
                    React.createElement("p", null, "The Stepped Progress Bar is designed to expand to fit the entire width of its container. View the diagram above for rules regarding including or excluding certain elements."))); },
                react: code(templateObject_1$p || (templateObject_1$p = __makeTemplateObject$p(["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n                        const tooltipsData = [\n                            {index: 0, title: 'Title 1', description: 'Description'},\n                            {index: 4, title: 'Title 5', description: 'Description'},\n                            {index: 8, title: 'Title 9', description: 'Description'},\n                            {index: 11, title: 'Title 12', description: 'Description'},\n                        ]\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    showStepsCounter={true}\n                                    stepsCount={12}\n                                    completedStepsCount={4}\n                                    icons={iconsData}\n                                    tooltipsData={tooltipsData}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n                        const tooltipsData = [\n                            {index: 0, title: 'Title 1', description: 'Description'},\n                            {index: 4, title: 'Title 5', description: 'Description'},\n                            {index: 8, title: 'Title 9', description: 'Description'},\n                            {index: 11, title: 'Title 12', description: 'Description'},\n                        ]\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    showStepsCounter={true}\n                                    stepsCount={12}\n                                    completedStepsCount={4}\n                                    icons={iconsData}\n                                    tooltipsData={tooltipsData}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "]))),
            },
            color: {
                description: function () { return React.createElement("h4", null, "Alternate Color"); },
                react: code(templateObject_2$m || (templateObject_2$m = __makeTemplateObject$p(["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n                        const tooltipsData = [\n                            {index: 0, title: 'Title 1', description: 'Description'},\n                            {index: 4, title: 'Title 5', description: 'Description'},\n                            {index: 8, title: 'Title 9', description: 'Description'},\n                            {index: 11, title: 'Title 12', description: 'Description'},\n                        ]\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    showStepsCounter={true}\n                                    stepsCount={12}\n                                    completedStepsCount={4}\n                                    icons={iconsData}\n                                    tooltipsData={tooltipsData}\n                                    color={SteppedProgressBarColor.GRAY}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n                        const tooltipsData = [\n                            {index: 0, title: 'Title 1', description: 'Description'},\n                            {index: 4, title: 'Title 5', description: 'Description'},\n                            {index: 8, title: 'Title 9', description: 'Description'},\n                            {index: 11, title: 'Title 12', description: 'Description'},\n                        ]\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    showStepsCounter={true}\n                                    stepsCount={12}\n                                    completedStepsCount={4}\n                                    icons={iconsData}\n                                    tooltipsData={tooltipsData}\n                                    color={SteppedProgressBarColor.GRAY}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "]))),
            },
            completed: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h4", null, "Completed State"),
                    React.createElement("p", null, "Once complete, the progress bar appears in green."))); },
                react: code(templateObject_3$i || (templateObject_3$i = __makeTemplateObject$p(["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    showStepsCounter={true}\n                                    stepsCount={10}\n                                    completedStepsCount={10}\n                                    icons={iconsData}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    showStepsCounter={true}\n                                    stepsCount={10}\n                                    completedStepsCount={10}\n                                    icons={iconsData}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "]))),
            },
            disabled: {
                description: function () { return (React.createElement(React.Fragment, null,
                    React.createElement("h4", null, "Disabled State"),
                    React.createElement("p", null, "A disabled state is available for cases when progress is intentionally paused or user interaction needs to be restricted."))); },
                react: code(templateObject_4$b || (templateObject_4$b = __makeTemplateObject$p(["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    stepsCount={10}\n                                    completedStepsCount={7}\n                                    icons={iconsData}\n                                    disabled\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const iconsData = [\n                            {index: 4, icon: SpsIcon.CALENDAR},\n                            {index: 8, icon: SpsIcon.CALENDAR},\n                        ];\n\n                        return (\n                            <SpsCard>\n                                <SpsSteppedProgressBar\n                                    title=\"Process Name\"\n                                    stepsCount={10}\n                                    completedStepsCount={7}\n                                    icons={iconsData}\n                                    disabled\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$p, templateObject_2$m, templateObject_3$i, templateObject_4$b;

var __assign$N = (undefined && undefined.__assign) || function () {
    __assign$N = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$N.apply(this, arguments);
};
var propsDoc$H = {
    icon: "SpsIcon",
    iconSize: "SpsIconSize",
};
var propTypes$K = __assign$N(__assign$N({}, spsGlobalPropTypes), { icon: enumValue(SpsIcon), iconSize: enumValue(SpsIconSize) });
function SpsTooltipTitle(_a) {
    var icon = _a.icon, _b = _a.iconSize, iconSize = _b === void 0 ? SpsIconSize.SMALL : _b, children = _a.children;
    return (React.createElement("div", { className: "sps-tooltip__title-component" },
        icon && React.createElement(SpsI, { icon: icon, size: iconSize }),
        React.createElement("span", { className: "sps-tooltip__title" }, children)));
}
Object.assign(SpsTooltipTitle, {
    props: propsDoc$H,
    propTypes: propTypes$K,
    displayName: "SpsTooltipTitle",
});

var __makeTemplateObject$o = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsTooltipExamples = {
    basic: {
        label: "Basic",
        description: "Info about basic usage of tooltip",
        examples: {
            basic: {
                description: code(templateObject_1$o || (templateObject_1$o = __makeTemplateObject$o(["\n                  <p>There are two ways to tell the tooltip what to attach to. The first is to\n                  pass in a ref.</p>\n                "], ["\n                  <p>There are two ways to tell the tooltip what to attach to. The first is to\n                  pass in a ref.</p>\n                "]))),
                react: code(templateObject_2$l || (templateObject_2$l = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <div>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target}>\n                              target\n                            </div>\n                            <SpsTooltip for={target} title=\"Tooltip Title\">\n                              Tooltip content\n                            </SpsTooltip>\n                          </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <div>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target}>\n                              target\n                            </div>\n                            <SpsTooltip for={target} title=\"Tooltip Title\">\n                              Tooltip content\n                            </SpsTooltip>\n                          </div>\n                        );\n                    }\n                "]))),
            },
            withElementId: {
                description: code(templateObject_3$h || (templateObject_3$h = __makeTemplateObject$o(["\n                  <p>You can also pass in the ID of the element you want to attach to.</p>\n                "], ["\n                  <p>You can also pass in the ID of the element you want to attach to.</p>\n                "]))),
                react: code(templateObject_4$a || (templateObject_4$a = __makeTemplateObject$o(["\n                    function Component() {\n                        return (\n                          <React.Fragment>\n                            <SpsButton id=\"testbtn\" kind={ButtonKind.ICON} icon={SpsIcon.ELLIPSES} aria-labelledby=\"withEleIdTooltip\" />\n                            <SpsTooltip for=\"testbtn\" id=\"withEleIdTooltip\" title=\"Tooltip Title\">\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                          <React.Fragment>\n                            <SpsButton id=\"testbtn\" kind={ButtonKind.ICON} icon={SpsIcon.ELLIPSES} aria-labelledby=\"withEleIdTooltip\" />\n                            <SpsTooltip for=\"testbtn\" id=\"withEleIdTooltip\" title=\"Tooltip Title\">\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
    position: {
        label: "Position",
        examples: {
            topLeft: {
                description: "If there is no room for the tooltip on screen at the position you specify, it will appear on the opposite side.",
                react: code(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div  className=\"bg-gray200 text-center p-2\"  aria-labelledby=\"tooltip-target-top-left\" ref={target} id=\"target-top-left\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-top-left\" position={Position.TOP_LEFT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div  className=\"bg-gray200 text-center p-2\"  aria-labelledby=\"tooltip-target-top-left\" ref={target} id=\"target-top-left\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-top-left\" position={Position.TOP_LEFT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            topMiddle: {
                react: code(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-top-middle\" >\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-top-middle\" position={Position.TOP_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-top-middle\" >\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-top-middle\" position={Position.TOP_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            topRight: {
                react: code(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-top-right\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-top-right\" position={Position.TOP_RIGHT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-top-right\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-top-right\" position={Position.TOP_RIGHT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            rightTop: {
                react: code(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-right-top\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-right-top\" position={Position.RIGHT_TOP}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-right-top\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-right-top\" position={Position.RIGHT_TOP}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            rightMiddle: {
                react: code(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-right-middle\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-right-middle\" position={Position.RIGHT_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-right-middle\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-right-middle\" position={Position.RIGHT_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            rightBottom: {
                react: code(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-right-bottom\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-right-bottom\" position={Position.RIGHT_BOTTOM}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-right-bottom\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-right-bottom\" position={Position.RIGHT_BOTTOM}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            bottomRight: {
                react: code(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-bottom-right\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-bottom-right\" position={Position.BOTTOM_RIGHT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-bottom-right\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-bottom-right\" position={Position.BOTTOM_RIGHT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            bottomMiddle: {
                react: code(templateObject_12 || (templateObject_12 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-bottom-middle\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-bottom-middle\" position={Position.BOTTOM_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-bottom-middle\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-bottom-middle\" position={Position.BOTTOM_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            bottomLeft: {
                react: code(templateObject_13 || (templateObject_13 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-bottom-left\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-bottom-left\" position={Position.BOTTOM_LEFT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-bottom-left\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-bottom-left\" position={Position.BOTTOM_LEFT}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            leftBottom: {
                react: code(templateObject_14 || (templateObject_14 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-left-bottom\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"tooltip-target-left-bottom\" position={Position.LEFT_BOTTOM}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-left-bottom\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"tooltip-target-left-bottom\" position={Position.LEFT_BOTTOM}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            leftMiddle: {
                react: code(templateObject_15 || (templateObject_15 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-left-middle\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-left-middle\" position={Position.LEFT_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-left-middle\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"tooltip-target-left-middle\" position={Position.LEFT_MIDDLE}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            leftTop: {
                react: code(templateObject_16 || (templateObject_16 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-left-top\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"tooltip-target-left-top\" position={Position.LEFT_TOP}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"tooltip-target-left-top\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"tooltip-target-left-top\" position={Position.LEFT_TOP}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
    style: {
        label: "Style",
        examples: {
            Help: {
                react: code(templateObject_17 || (templateObject_17 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"helpTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"helpTooltip\" kind={TooltipKind.HELP}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"helpTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"helpTooltip\" kind={TooltipKind.HELP}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            error: {
                react: code(templateObject_18 || (templateObject_18 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"errorTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"errorTooltip\" kind={TooltipKind.ERROR}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"errorTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target}  id=\"errorTooltip\" kind={TooltipKind.ERROR}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            warning: {
                react: code(templateObject_19 || (templateObject_19 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"warningTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"warningTooltip\" kind={TooltipKind.WARNING}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"warningTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"warningTooltip\" kind={TooltipKind.WARNING}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
            container: {
                react: code(templateObject_20 || (templateObject_20 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"containerTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"containerTooltip\"  kind={TooltipKind.CONTAINER}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"containerTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} id=\"containerTooltip\"  kind={TooltipKind.CONTAINER}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
    showOnClick: {
        label: "Show on click",
        examples: {
            showOnClick: {
                react: code(templateObject_21 || (templateObject_21 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <div>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target}>\n                              target\n                            </div>\n                            <SpsTooltip for={target} showOn={TooltipShowTrigger.CLICK}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <div>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target}>\n                              target\n                            </div>\n                            <SpsTooltip for={target} showOn={TooltipShowTrigger.CLICK}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
    showHideManually: {
        label: "Programmatically show & hide",
        examples: {
            showHideManually: {
                react: code(templateObject_22 || (templateObject_22 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n                        const [showTip, setShowTip] = React.useState(TooltipVisibility.HIDDEN);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} id=\"target-on-click\">\n                              target\n                            </div>\n                            <SpsTooltip\n                              for={target}\n                              showOn={TooltipShowTrigger.MANUAL}\n                              isShown={showTip}\n                              id=\"tooltip-target-on-click\"\n                              onDeferred={() => setShowTip(TooltipVisibility.HIDDEN)}\n                            >\n                              Tooltip content\n                            </SpsTooltip>\n                            <br />\n                            <SpsButton\n                              className=\"mr-1\"\n                              id=\"tooltip-target-on-click-show\"\n                              onClick={() => setShowTip(TooltipVisibility.VISIBLE)}\n                              aria-labelledby=\"tooltip-target-on-click\"\n                            >\n                              Show\n                            </SpsButton>\n                            <SpsButton\n                              className=\"mr-1\"\n                              onClick={() => setShowTip(TooltipVisibility.DEFER_VISIBLE)}\n                            >\n                              Show, but only if no other tooltip is currently visible\n                            </SpsButton>\n                            <SpsButton\n                              className=\"mr-1\"\n                              id=\"tooltip-target-on-click-hide\"\n                              onClick={() => setShowTip(TooltipVisibility.HIDDEN)}\n                            >\n                              Hide\n                            </SpsButton>\n                            <SpsButton\n                              className=\"mr-1\"\n                              onClick={() => setShowTip(TooltipVisibility.DELAYED_HIDDEN)}\n                            >\n                              Hide with delay\n                            </SpsButton>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n                        const [showTip, setShowTip] = React.useState(TooltipVisibility.HIDDEN);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} id=\"target-on-click\">\n                              target\n                            </div>\n                            <SpsTooltip\n                              for={target}\n                              showOn={TooltipShowTrigger.MANUAL}\n                              isShown={showTip}\n                              id=\"tooltip-target-on-click\"\n                              onDeferred={() => setShowTip(TooltipVisibility.HIDDEN)}\n                            >\n                              Tooltip content\n                            </SpsTooltip>\n                            <br />\n                            <SpsButton\n                              className=\"mr-1\"\n                              id=\"tooltip-target-on-click-show\"\n                              onClick={() => setShowTip(TooltipVisibility.VISIBLE)}\n                              aria-labelledby=\"tooltip-target-on-click\"\n                            >\n                              Show\n                            </SpsButton>\n                            <SpsButton\n                              className=\"mr-1\"\n                              onClick={() => setShowTip(TooltipVisibility.DEFER_VISIBLE)}\n                            >\n                              Show, but only if no other tooltip is currently visible\n                            </SpsButton>\n                            <SpsButton\n                              className=\"mr-1\"\n                              id=\"tooltip-target-on-click-hide\"\n                              onClick={() => setShowTip(TooltipVisibility.HIDDEN)}\n                            >\n                              Hide\n                            </SpsButton>\n                            <SpsButton\n                              className=\"mr-1\"\n                              onClick={() => setShowTip(TooltipVisibility.DELAYED_HIDDEN)}\n                            >\n                              Hide with delay\n                            </SpsButton>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
    withSpsTooltipTitle: {
        label: "With SpsTooltipTitle",
        examples: {
            showHideManually: {
                react: code(templateObject_23 || (templateObject_23 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target}>\n                              target\n                            </div>\n                            <SpsTooltip\n                              for={target}\n                              title={<SpsTooltipTitle>Temporary implementation account setup</SpsTooltipTitle>}\n                            >\n                              <div className=\"mb-3\">\n                                Implementing: Temporary implementation product setup in progress.\n                              </div>\n                              <SpsTooltipTitle icon={SpsIcon.CALENDAR_BLANK}>Started</SpsTooltipTitle>\n                              <div className=\"mb-3\">Tuesday, April 15</div>\n                              <SpsTooltipTitle icon={SpsIcon.CHECKMARK}>Completed</SpsTooltipTitle>\n                              <div>Thursday, April 24</div>\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target}>\n                              target\n                            </div>\n                            <SpsTooltip\n                              for={target}\n                              title={<SpsTooltipTitle>Temporary implementation account setup</SpsTooltipTitle>}\n                            >\n                              <div className=\"mb-3\">\n                                Implementing: Temporary implementation product setup in progress.\n                              </div>\n                              <SpsTooltipTitle icon={SpsIcon.CALENDAR_BLANK}>Started</SpsTooltipTitle>\n                              <div className=\"mb-3\">Tuesday, April 15</div>\n                              <SpsTooltipTitle icon={SpsIcon.CHECKMARK}>Completed</SpsTooltipTitle>\n                              <div>Thursday, April 24</div>\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
    other: {
        label: "Other Settings",
        examples: {
            hideDelay: {
                description: code(templateObject_24 || (templateObject_24 = __makeTemplateObject$o(["\n                  <p>You can customize the delay before the tooltip disappears\n                  when the user moves the mouse away from the element the tooltip\n                  is attached to.</p>\n                "], ["\n                  <p>You can customize the delay before the tooltip disappears\n                  when the user moves the mouse away from the element the tooltip\n                  is attached to.</p>\n                "]))),
                react: code(templateObject_25 || (templateObject_25 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <div id=\"hideDelayTooltip\">\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"hideDelayTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} hideDelay={0}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <div id=\"hideDelayTooltip\">\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"hideDelayTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip for={target} hideDelay={0}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </div>\n                        );\n                    }\n                "]))),
            },
            customPositioningOffsets: {
                description: "<p>Custom positioning offsets</p>",
                react: code(templateObject_26 || (templateObject_26 = __makeTemplateObject$o(["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"customTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip  id=\"customTooltip\" for={target} offsets={[50, 100]}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const target = React.useRef(null);\n\n                        return (\n                          <React.Fragment>\n                            <div className=\"bg-gray200 text-center p-2\" ref={target} aria-labelledby=\"customTooltip\">\n                              target\n                            </div>\n                            <SpsTooltip  id=\"customTooltip\" for={target} offsets={[50, 100]}>\n                              Tooltip content\n                            </SpsTooltip>\n                          </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$o, templateObject_2$l, templateObject_3$h, templateObject_4$a, templateObject_5$5, templateObject_6$4, templateObject_7$4, templateObject_8$3, templateObject_9$2, templateObject_10$1, templateObject_11$1, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;

var propsDoc$G = {
    title: "string",
    stepsCount: "number",
    completedStepsCount: "number",
    disabled: "boolean",
    showStepsCounter: "boolean",
    icons: "IconsProps[]",
    tooltipsData: "TooltipsProps[]",
    color: "SteppedProgressBarColor",
};
var propTypes$J = {
    title: propTypes$1H.exports.string,
    stepsCount: propTypes$1H.exports.number,
    completedStepsCount: propTypes$1H.exports.number,
    disabled: propTypes$1H.exports.bool,
    showStepsCounter: propTypes$1H.exports.bool,
    icons: propTypes$1H.exports.arrayOf(impl()),
    tooltipsData: propTypes$1H.exports.arrayOf(impl()),
    color: enumValue(SteppedProgressBarColor)
};
function SpsSteppedProgressBar(props) {
    var title = props.title, stepsCount = props.stepsCount, _a = props.completedStepsCount, completedStepsCount = _a === void 0 ? 0 : _a, disabled = props.disabled, showStepsCounter = props.showStepsCounter, icons = props.icons, tooltipsData = props.tooltipsData, className = props.className, _b = props.color, color = _b === void 0 ? SteppedProgressBarColor.PURPLE : _b;
    function findIcon(idx) {
        return icons && icons.find(function (i) { return i.index === idx; });
    }
    function findTooltipData(idx) {
        return tooltipsData && tooltipsData.find(function (i) { return i.index === idx; });
    }
    var data = Array.from(Array(stepsCount)).map(function () { return useElementId(null).current; });
    var classes = clsx("sps-stepped-progress-bar", "sps-stepped-progress-bar--" + color, completedStepsCount === stepsCount && "sps-stepped-progress-bar--complete", disabled && "sps-stepped-progress-bar--disabled", className);
    return (React.createElement("div", { className: classes },
        React.createElement("div", { className: "sps-stepped-progress-bar__content" },
            (title || showStepsCounter) && (React.createElement("div", { className: "sps-progress-bar__heading" },
                title && (React.createElement("div", { className: "sps-progress-bar__title" }, title)),
                showStepsCounter && (React.createElement("div", { className: "sps-stepped-progress-bar__percentage" }, completedStepsCount + " of " + stepsCount + " Complete")))),
            React.createElement("ul", { className: "sps-stepped-progress-bar__bar-background d-flex align-items-center list-unstyled mb-0" }, data.map(function (id, index) { return (React.createElement("li", { id: id, key: id, className: clsx("sps-stepped-progress-bar__step", completedStepsCount > index && "sps-stepped-progress-bar__step-complete") },
                findIcon(index)
                    && React.createElement(SpsI, { icon: findIcon(index).icon, size: SpsIconSize.SMALL, className: clsx("d-block", findIcon(index).index > completedStepsCount - 1 ? "gray400" : "white") }),
                findTooltipData(index)
                    && (React.createElement(SpsTooltip, { for: id, title: findTooltipData(index).title }, findTooltipData(index).description)))); })))));
}
Object.assign(SpsSteppedProgressBar, {
    props: propsDoc$G,
    propTypes: propTypes$J,
    displayName: "SpsSteppedProgressBar",
});

var __makeTemplateObject$n = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsProgressBarExamples = {
    general: {
        label: "General Usage",
        customSection: function () { return (React.createElement(React.Fragment, null,
            React.createElement("h4", null, "General Usage"),
            React.createElement("p", null, "Progress Bars can be used in a variety of situations, but the most common use case is to show the live progress of a process such as a file upload or the processing of a digital payload."),
            React.createElement("p", null, "For processes that typically complete within minutes or less, opt for the Standard Progress Bar."),
            React.createElement("p", null, "For processes that are divided into specific steps that are accomplished over a longer period of time, opt for the Stepped Progress Bar."))); },
    },
    standard: {
        label: "Standard Progress Bar",
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Standard Progress Bars are comprised of the following Required and Optional elements."),
            React.createElement("img", { src: "assets/images/progress-bar-example.svg", alt: "A Progress Bar with labels on each section", className: "w-100 mb-3" }),
            React.createElement(SpsTable, null,
                React.createElement(SpsTableHead, null,
                    React.createElement(SpsTableHeader, null, "Section"),
                    React.createElement(SpsTableHeader, null, "Content Type"),
                    React.createElement(SpsTableHeader, null, "Required"),
                    React.createElement(SpsTableHeader, null, "Description/Guidelines")),
                React.createElement(SpsTableBody, null,
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "1")),
                        React.createElement(SpsTableCell, null, "Title"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "Use the Title when it provides necessary or helpful detail about the file or action that is being processed.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "2")),
                        React.createElement(SpsTableCell, null, "Progress Meter"),
                        React.createElement(SpsTableCell, null, "Yes"),
                        React.createElement(SpsTableCell, null)),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "3")),
                        React.createElement(SpsTableCell, null, "Progress Counter"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "The Progress Counter should not be used without the existence of a Title.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "4")),
                        React.createElement(SpsTableCell, null, "Clear Button"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "If the process requires the option to be cancelled or removed from a list the clear button can be used.")),
                    React.createElement(SpsTableRow, null,
                        React.createElement(SpsTableCell, null,
                            React.createElement("span", { className: "sps-tag sps-tag--info" }, "5")),
                        React.createElement(SpsTableCell, null, "Progress Details"),
                        React.createElement(SpsTableCell, null, "No"),
                        React.createElement(SpsTableCell, { wrap: 400 }, "Progress Details provide more context for the user and are especially useful when the process includes multiple steps.")))))); },
        examples: {
            standard: {
                label: "Building Standard Progress Bars",
                description: function () { return (React.createElement("p", null, "The Standard Progress Bar is designed to expand to fit the entire width of its container. View the diagram above for rules regarding including or excluding certain elements.")); },
                react: code(templateObject_1$n || (templateObject_1$n = __makeTemplateObject$n(["\n                    function Component() {\n                        function handleClose() {\n                            console.log(\"closed\");\n                        }\n\n                        return (\n                            <SpsCard>\n                                <SpsProgressBar\n                                    title=\"File Name\"\n                                    detail=\"Step 3 of 5: Verifying Headers\"\n                                    percentComplete={0.5}\n                                    onClose={handleClose}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        function handleClose() {\n                            console.log(\"closed\");\n                        }\n\n                        return (\n                            <SpsCard>\n                                <SpsProgressBar\n                                    title=\"File Name\"\n                                    detail=\"Step 3 of 5: Verifying Headers\"\n                                    percentComplete={0.5}\n                                    onClose={handleClose}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "]))),
            },
            completed: {
                label: "Completed State",
                description: function () { return (React.createElement("p", null, "Once complete, the progress bar appears in green and the clear button (if included) disappears from view.")); },
                react: code(templateObject_2$k || (templateObject_2$k = __makeTemplateObject$n(["\n                    function Component() {\n                        return (\n                            <SpsCard>\n                                <SpsProgressBar\n                                    title=\"File Name\"\n                                    detail=\"Process Complete\"\n                                    percentComplete={1}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                            <SpsCard>\n                                <SpsProgressBar\n                                    title=\"File Name\"\n                                    detail=\"Process Complete\"\n                                    percentComplete={1}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "]))),
            },
            disabled: {
                label: "Disabled State",
                description: function () { return (React.createElement("p", null, "A disabled state is available for cases when progress is intentionally paused or user interaction needs to be restricted.")); },
                react: code(templateObject_3$g || (templateObject_3$g = __makeTemplateObject$n(["\n                    function Component() {\n                        function handleClose() {\n                            console.log(\"closed\");\n                        }\n                        return (\n                            <SpsCard>\n                                <SpsProgressBar\n                                    title=\"File Name\"\n                                    detail=\"Step 3 of 5: Verifying Headers\"\n                                    percentComplete={0.5}\n                                    disabled\n                                    onClose={handleClose}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        function handleClose() {\n                            console.log(\"closed\");\n                        }\n                        return (\n                            <SpsCard>\n                                <SpsProgressBar\n                                    title=\"File Name\"\n                                    detail=\"Step 3 of 5: Verifying Headers\"\n                                    percentComplete={0.5}\n                                    disabled\n                                    onClose={handleClose}\n                                />\n                            </SpsCard>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$n, templateObject_2$k, templateObject_3$g;

var __assign$M = (undefined && undefined.__assign) || function () {
    __assign$M = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$M.apply(this, arguments);
};
var __rest$C = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$F = {
    checked: "boolean",
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<any>",
    inline: "boolean",
    label: "string",
    name: { type: "string", required: true },
    onChange: "ChangeEventHandler",
    value: "any",
};
var propTypes$I = __assign$M(__assign$M({}, spsGlobalPropTypes), { checked: propTypes$1H.exports.bool, disabled: propTypes$1H.exports.bool, formControl: impl(), formMeta: impl(), inline: propTypes$1H.exports.bool, label: propTypes$1H.exports.string, name: propTypes$1H.exports.string.isRequired, onChange: fun(), ref: ref(), value: propTypes$1H.exports.any });
function SpsRadioButton(_a) {
    var checked = _a.checked, className = _a.className, testId = _a["data-testid"], disabled = _a.disabled, formControl = _a.formControl, formMeta = _a.formMeta, id = _a.id, inline = _a.inline, label = _a.label, name = _a.name, onChange = _a.onChange, ref = _a.ref, unsafelyReplaceClassName = _a.unsafelyReplaceClassName, value = _a.value, rest = __rest$C(_a, ["checked", "className", "data-testid", "disabled", "formControl", "formMeta", "id", "inline", "label", "name", "onChange", "ref", "unsafelyReplaceClassName", "value"]);
    var meta = formMeta || formControl;
    var inputElement = React.useRef();
    var _b = useFormControlId(id), wrapperId = _b.wrapperId, controlId = _b.controlId;
    var classes = clsx(unsafelyReplaceClassName || "sps-radio-button", "sps-checkable", inline && "sps-checkable--inline", !label && "sps-checkable--no-label", className);
    function handleChange(event) {
        if (meta) {
            meta.setValue(value);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(event);
        }
        inputElement.current.focus();
    }
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formControl: formControl, formMeta: formMeta, inputRef: inputElement, ref: ref, "data-testid": "" + testId, onClick: function () { return inputElement.current.click(); } },
        React.createElement("input", __assign$M({ type: "radio", ref: inputElement, className: "sps-checkable__input", "data-testid": testId + "__radio-input", id: controlId, name: name, checked: checked, disabled: disabled, onChange: handleChange }, rest)),
        React.createElement("label", { className: "sps-checkable__label", htmlFor: controlId }, label || "")));
}
Object.assign(SpsRadioButton, {
    props: propsDoc$F,
    propTypes: propTypes$I,
    displayName: "SpsRadioButton",
});

var __makeTemplateObject$m = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsRadioButtonExamples = {
    labels: {
        label: "Labels",
        description: "info about radio buttons with labels",
        examples: {
            label: {
                react: code(templateObject_1$m || (templateObject_1$m = __makeTemplateObject$m(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: \"blue\"\n                        });\n\n                        return <SpsForm formMeta={formMeta} id=\"labelRadioButton\">\n                            <SpsRadioButton name=\"blue\" value=\"blue\" label=\"Blue\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"blue\"}\n                            ></SpsRadioButton>\n                            <SpsRadioButton name=\"green\" value=\"green\" label=\"Green\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"green\"}\n                            ></SpsRadioButton>\n                        </SpsForm>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: \"blue\"\n                        });\n\n                        return <SpsForm formMeta={formMeta} id=\"labelRadioButton\">\n                            <SpsRadioButton name=\"blue\" value=\"blue\" label=\"Blue\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"blue\"}\n                            ></SpsRadioButton>\n                            <SpsRadioButton name=\"green\" value=\"green\" label=\"Green\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"green\"}\n                            ></SpsRadioButton>\n                        </SpsForm>\n                    }\n                "]))),
            },
        },
    },
    b_disabled: {
        label: "Disabled",
        description: "info about disabled radio buttons",
        examples: {
            disabled: {
                react: code(templateObject_2$j || (templateObject_2$j = __makeTemplateObject$m(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: \"blue\"\n                        });\n\n                        return <SpsForm formMeta={formMeta}>\n                            <SpsRadioButton name=\"blue\" value=\"blue\" label=\"Blue\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"blue\"}\n                                disabled\n                            ></SpsRadioButton>\n                            <SpsRadioButton name=\"green\" value=\"green\" label=\"Green\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"green\"}\n                                disabled\n                            ></SpsRadioButton>\n                        </SpsForm>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: \"blue\"\n                        });\n\n                        return <SpsForm formMeta={formMeta}>\n                            <SpsRadioButton name=\"blue\" value=\"blue\" label=\"Blue\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"blue\"}\n                                disabled\n                            ></SpsRadioButton>\n                            <SpsRadioButton name=\"green\" value=\"green\" label=\"Green\"\n                                formMeta={formMeta.fields.color}\n                                checked={formValue.color === \"green\"}\n                                disabled\n                            ></SpsRadioButton>\n                        </SpsForm>\n                    }\n                "]))),
            },
        },
    },
    c_noLabels: {
        label: "No Labels",
        description: "info about radio buttons without labels",
        examples: {
            noLabels: {
                react: code(templateObject_3$f || (templateObject_3$f = __makeTemplateObject$m(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: \"green\"\n                        });\n\n                        return (\n                            <SpsForm formMeta={formMeta}>\n                                <SpsRadioButton name=\"blue\" value=\"blue\"\n                                    className=\"mb-2\"\n                                    formMeta={formMeta.fields.color}\n                                    checked={formValue.color === \"blue\"}\n                                ></SpsRadioButton>\n                                <SpsRadioButton name=\"green\" value=\"green\"\n                                    formMeta={formMeta.fields.color}\n                                    checked={formValue.color === \"green\"}\n                                ></SpsRadioButton>\n                            </SpsForm>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: \"green\"\n                        });\n\n                        return (\n                            <SpsForm formMeta={formMeta}>\n                                <SpsRadioButton name=\"blue\" value=\"blue\"\n                                    className=\"mb-2\"\n                                    formMeta={formMeta.fields.color}\n                                    checked={formValue.color === \"blue\"}\n                                ></SpsRadioButton>\n                                <SpsRadioButton name=\"green\" value=\"green\"\n                                    formMeta={formMeta.fields.color}\n                                    checked={formValue.color === \"green\"}\n                                ></SpsRadioButton>\n                            </SpsForm>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$m, templateObject_2$j, templateObject_3$f;

var __assign$L = (undefined && undefined.__assign) || function () {
    __assign$L = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$L.apply(this, arguments);
};
var propsDoc$E = {
    maxHeight: "string",
};
var propTypes$H = __assign$L(__assign$L({}, spsGlobalPropTypes), { maxHeight: propTypes$1H.exports.string });
function SpsScrollableContainer(props) {
    var children = props.children, maxHeight = props.maxHeight;
    return (React.createElement("div", { className: "sps-scrollable-container", style: { maxHeight: maxHeight } }, children));
}
Object.assign(SpsScrollableContainer, {
    props: propsDoc$E,
    propTypes: propTypes$H,
    displayName: "SpsScrollableContainer",
});

var __makeTemplateObject$l = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsScrollableContainerExamples = {
    basic: {
        label: "Basic",
        description: "basic scrollable container",
        examples: {
            text: {
                jsx: code(templateObject_1$l || (templateObject_1$l = __makeTemplateObject$l(["\n                    <SpsCard>\n                        <SpsScrollableContainer maxHeight='100px'>\n                            <p>\n                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris\n                                sit amet molestie metus. Phasellus dignissim interdum arcu. Sed\n                                in nunc id sapien porta mollis eleifend nec mauris. Nulla\n                                molestie pulvinar velit eget fringilla. Pellentesque habitant\n                                morbi tristique senectus et netus et malesuada fames ac turpis\n                                egestas. Nam eu sem ut neque condimentum tempor. Integer\n                                bibendum in velit at consectetur. Nunc ut velit ac magna sodales\n                                tempor. Ut tempor rhoncus mi, eget feugiat nisi finibus at.\n                                Pellentesque habitant morbi tristique senectus et netus et\n                                malesuada fames ac turpis egestas. Vestibulum nunc ipsum,\n                                elementum consectetur urna a, sodales pellentesque nibh. Nullam\n                                in dui dolor. Vivamus sapien enim, tristique accumsan finibus\n                                nec, fringilla eget tellus. Duis sed pulvinar ipsum. Donec\n                                convallis aliquet dui, nec ullamcorper nulla tincidunt ac. Fusce\n                                tempus neque sit amet libero vestibulum maximus. Praesent id dui\n                                sed diam scelerisque pretium id vitae ante. Sed ullamcorper\n                                ligula quis mi vehicula, in interdum purus suscipit.\n                                Pellentesque venenatis velit nunc, quis tincidunt ligula egestas\n                                id. Praesent sollicitudin et mauris et auctor. Nullam diam erat,\n                                tincidunt at odio non, tincidunt laoreet quam. In consequat\n                                pulvinar sapien vel varius. Suspendisse potenti. Aenean pharetra\n                                felis sit amet tempus consequat. Donec eu molestie mauris. Nunc\n                                scelerisque ex id vehicula semper. Nunc eu interdum ante. Etiam\n                                in metus ante. Nulla ac turpis vel sem fermentum mattis. Nam\n                                elit mi, pretium a tristique vitae, vestibulum id tellus. In\n                                vitae nisl lectus. Sed fringilla eget velit quis aliquet.\n                                Vestibulum euismod, leo ut egestas dictum, mi quam euismod\n                                velit, nec iaculis elit mi a orci. Duis volutpat purus lacus. Ut\n                                sit amet semper ipsum. Sed aliquam, quam ac placerat facilisis,\n                                nulla odio vulputate erat, id condimentum sem arcu vel turpis.\n                                Fusce finibus tortor ac viverra semper. Pellentesque convallis\n                                mi sed metus finibus molestie. Duis vehicula dolor consequat\n                                placerat sollicitudin. Phasellus sed sagittis ligula, in\n                                molestie velit. In scelerisque maximus metus, ac convallis nisi\n                                dignissim non.\n                            </p>\n                        </SpsScrollableContainer>\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsScrollableContainer maxHeight='100px'>\n                            <p>\n                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris\n                                sit amet molestie metus. Phasellus dignissim interdum arcu. Sed\n                                in nunc id sapien porta mollis eleifend nec mauris. Nulla\n                                molestie pulvinar velit eget fringilla. Pellentesque habitant\n                                morbi tristique senectus et netus et malesuada fames ac turpis\n                                egestas. Nam eu sem ut neque condimentum tempor. Integer\n                                bibendum in velit at consectetur. Nunc ut velit ac magna sodales\n                                tempor. Ut tempor rhoncus mi, eget feugiat nisi finibus at.\n                                Pellentesque habitant morbi tristique senectus et netus et\n                                malesuada fames ac turpis egestas. Vestibulum nunc ipsum,\n                                elementum consectetur urna a, sodales pellentesque nibh. Nullam\n                                in dui dolor. Vivamus sapien enim, tristique accumsan finibus\n                                nec, fringilla eget tellus. Duis sed pulvinar ipsum. Donec\n                                convallis aliquet dui, nec ullamcorper nulla tincidunt ac. Fusce\n                                tempus neque sit amet libero vestibulum maximus. Praesent id dui\n                                sed diam scelerisque pretium id vitae ante. Sed ullamcorper\n                                ligula quis mi vehicula, in interdum purus suscipit.\n                                Pellentesque venenatis velit nunc, quis tincidunt ligula egestas\n                                id. Praesent sollicitudin et mauris et auctor. Nullam diam erat,\n                                tincidunt at odio non, tincidunt laoreet quam. In consequat\n                                pulvinar sapien vel varius. Suspendisse potenti. Aenean pharetra\n                                felis sit amet tempus consequat. Donec eu molestie mauris. Nunc\n                                scelerisque ex id vehicula semper. Nunc eu interdum ante. Etiam\n                                in metus ante. Nulla ac turpis vel sem fermentum mattis. Nam\n                                elit mi, pretium a tristique vitae, vestibulum id tellus. In\n                                vitae nisl lectus. Sed fringilla eget velit quis aliquet.\n                                Vestibulum euismod, leo ut egestas dictum, mi quam euismod\n                                velit, nec iaculis elit mi a orci. Duis volutpat purus lacus. Ut\n                                sit amet semper ipsum. Sed aliquam, quam ac placerat facilisis,\n                                nulla odio vulputate erat, id condimentum sem arcu vel turpis.\n                                Fusce finibus tortor ac viverra semper. Pellentesque convallis\n                                mi sed metus finibus molestie. Duis vehicula dolor consequat\n                                placerat sollicitudin. Phasellus sed sagittis ligula, in\n                                molestie velit. In scelerisque maximus metus, ac convallis nisi\n                                dignissim non.\n                            </p>\n                        </SpsScrollableContainer>\n                    </SpsCard>\n                "]))),
            },
            components: {
                react: code(templateObject_2$i || (templateObject_2$i = __makeTemplateObject$l(["\n                    function Component() {\n                        function buildTags() {\n                            let tagNames = [];\n                            for (let i = 0; i < 150; i++) {\n                                tagNames.push('tagName ' + i);\n                            }\n                            return tagNames;\n                        }\n                        return <SpsCard>\n                            <SpsScrollableContainer maxHeight='8.5rem'>\n                                {buildTags().map((name, index) => {\n                                    return (\n                                        <SpsClickableTag key={index} className=\"mt-1 ml-1\">\n                                            {name}\n                                        </SpsClickableTag>\n                                    );\n                                })}\n                            </SpsScrollableContainer>\n                        </SpsCard>\n                    }\n                "], ["\n                    function Component() {\n                        function buildTags() {\n                            let tagNames = [];\n                            for (let i = 0; i < 150; i++) {\n                                tagNames.push('tagName ' + i);\n                            }\n                            return tagNames;\n                        }\n                        return <SpsCard>\n                            <SpsScrollableContainer maxHeight='8.5rem'>\n                                {buildTags().map((name, index) => {\n                                    return (\n                                        <SpsClickableTag key={index} className=\"mt-1 ml-1\">\n                                            {name}\n                                        </SpsClickableTag>\n                                    );\n                                })}\n                            </SpsScrollableContainer>\n                        </SpsCard>\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$l, templateObject_2$i;

var __assign$K = (undefined && undefined.__assign) || function () {
    __assign$K = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$K.apply(this, arguments);
};
var __rest$B = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$i = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$D = {
    resultsCount: "number",
    totalResults: "number",
    onClear: "() => void",
};
var propTypes$G = __assign$K(__assign$K({}, spsGlobalPropTypes), { resultsCount: propTypes$1H.exports.number, totalResults: propTypes$1H.exports.number, onClear: fun() });
function SpsSearchResultsBar(props) {
    props.children; var className = props.className, resultsCount = props.resultsCount, totalResults = props.totalResults, onClear = props.onClear, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$B(props, ["children", "className", "resultsCount", "totalResults", "onClear", "data-testid", "unsafelyReplaceClassName"]);
    var t = React.useContext(I18nContext).t;
    var classes = clsx(unsafelyReplaceClassName || "sps-search-results-bar", className);
    var _a = __read$i(t("design-system:searchResultsBar.count", { count: resultsCount, total: totalResults })
        .split(" "), 3), count = _a[0], ofText = _a[1], total = _a[2];
    return (React.createElement("div", __assign$K({ className: classes, "data-testid": "" + testId }, rest),
        React.createElement("span", { className: "sps-search-results-bar__label", "data-testid": testId + "__label" }, t("design-system:searchResultsBar.matchingResults")),
        count && !Number.isNaN(Number(count))
            && (React.createElement("span", { className: "sps-search-results-bar__count", "data-testid": testId + "__count" },
                React.createElement("i", { className: "sps-icon sps-icon-double-angle-right" }),
                React.createElement("span", null, count))),
        total && !Number.isNaN(Number(total))
            && (React.createElement("span", { className: "sps-search-results-bar__total", "data-testid": testId + "__total" },
                ofText,
                " ",
                total)),
        React.createElement("div", { className: "sps-search-results-bar__buttons", "data-testid": testId + "__button" },
            React.createElement("button", { type: "button", onClick: onClear }, t("design-system:searchResultsBar.clear")))));
}
Object.assign(SpsSearchResultsBar, {
    props: propsDoc$D,
    propTypes: propTypes$G,
    displayName: "SpsSearchResultsBar",
});

var __makeTemplateObject$k = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSearchResultsBarExamples = {
    noCount: {
        label: "Basic",
        description: "<p>Info about Basic Search Result Bars</p>",
        examples: {
            noCount: {
                react: code(templateObject_1$k || (templateObject_1$k = __makeTemplateObject$k(["\n                function SpsSearchResultsBarBasic() {\n                    function clearHandler() {\n                        console.log(\"change handler called\");\n                    }\n                    return (\n                        <SpsSearchResultsBar onClear={clearHandler}/>\n                    );\n                }\n                "], ["\n                function SpsSearchResultsBarBasic() {\n                    function clearHandler() {\n                        console.log(\"change handler called\");\n                    }\n                    return (\n                        <SpsSearchResultsBar onClear={clearHandler}/>\n                    );\n                }\n                "]))),
            },
        },
    },
    withCount: {
        label: "With Count",
        description: "<p>Info about Search Result Bars with count bars</p>",
        examples: {
            withCount: {
                react: code(templateObject_2$h || (templateObject_2$h = __makeTemplateObject$k(["\n                function SpsSearchResultsBarCount() {\n                    function clearHandler() {\n                        console.log(\"change handler called\");\n                    }\n\n                    return (\n                        <SpsSearchResultsBar resultsCount={125} onClear={clearHandler}/>\n                    );\n                }\n                "], ["\n                function SpsSearchResultsBarCount() {\n                    function clearHandler() {\n                        console.log(\"change handler called\");\n                    }\n\n                    return (\n                        <SpsSearchResultsBar resultsCount={125} onClear={clearHandler}/>\n                    );\n                }\n                "]))),
            },
        },
    },
    withCountAndTotal: {
        label: "With Count and total",
        description: "<p> Info about Search Result Bars with count & total</p>",
        examples: {
            withCountAndTotal: {
                react: code(templateObject_3$e || (templateObject_3$e = __makeTemplateObject$k(["\n                function SpsSearchResultsBarCountTotal() {\n                    function clearHandler() {\n                        console.log(\"change handler called\");\n                    }\n                    return (\n                        <SpsSearchResultsBar resultsCount={125} totalResults={250} onClear={clearHandler} />\n                    );\n                }\n                "], ["\n                function SpsSearchResultsBarCountTotal() {\n                    function clearHandler() {\n                        console.log(\"change handler called\");\n                    }\n                    return (\n                        <SpsSearchResultsBar resultsCount={125} totalResults={250} onClear={clearHandler} />\n                    );\n                }\n                "]))),
            },
        },
    },
};
var templateObject_1$k, templateObject_2$h, templateObject_3$e;

var __makeTemplateObject$j = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSelectExamples = {
    basic: {
        label: "Basic",
        description: "info about basic selects",
        examples: {
            a_simple: {
                description: "Simple value options",
                react: code(templateObject_1$j || (templateObject_1$j = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        return (\n                            <SpsSelect id=\"basic\" options={colors}/>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        return (\n                            <SpsSelect id=\"basic\" options={colors}/>\n                        )\n                    }\n                "]))),
            },
            b_formHooks: {
                description: "Form hooks",
                react: code(templateObject_2$g || (templateObject_2$g = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: colors[0]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.color}>Color</SpsLabel>\n                            <SpsSelect options={colors} formMeta={formMeta.fields.color}\n                                value={formValue.color}\n                            />\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            color: colors[0]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.color}>Color</SpsLabel>\n                            <SpsSelect options={colors} formMeta={formMeta.fields.color}\n                                value={formValue.color}\n                            />\n                        </>\n                    }\n                "]))),
            },
            c_placeholder: {
                description: "Custom placeholder text",
                react: code(templateObject_3$d || (templateObject_3$d = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        return (\n                            <SpsSelect id=\"placeholder\" options={colors} placeholder=\"Choose a color\u2026\"/>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        return (\n                            <SpsSelect id=\"placeholder\" options={colors} placeholder=\"Choose a color\u2026\"/>\n                        )\n                    }\n                "]))),
            },
            d_notClearable: {
                description: "Not clearable",
                react: code(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        return (\n                            <SpsSelect options={colors} value=\"red\" notClearable />\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"blue\", \"green\"];\n\n                        return (\n                            <SpsSelect options={colors} value=\"red\" notClearable />\n                        )\n                    }\n                "]))),
            },
            e_zeroState: {
                description: "Zero state",
                react: code(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        return (\n                            <SpsSelect options={[]} zeroState=\"We're sorry, there are no options to choose from at this time, because reasons.\" />\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        return (\n                            <SpsSelect options={[]} zeroState=\"We're sorry, there are no options to choose from at this time, because reasons.\" />\n                        )\n                    }\n                "]))),
            },
        },
    },
    b_objectOpts: {
        label: "Object Options",
        description: "info about object options",
        examples: {
            a_basic: {
                description: "Basic use of object options",
                react: code(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        const sizes = [\n                            { size: \"S\", price: \"10.99\" },\n                            { size: \"M\", price: \"12.99\" },\n                            { size: \"L\", price: \"14.99\" }\n                        ];\n\n                        return (\n                            <SpsSelect options={sizes} textKey=\"size\" />\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const sizes = [\n                            { size: \"S\", price: \"10.99\" },\n                            { size: \"M\", price: \"12.99\" },\n                            { size: \"L\", price: \"14.99\" }\n                        ];\n\n                        return (\n                            <SpsSelect options={sizes} textKey=\"size\" />\n                        )\n                    }\n                "]))),
            },
            b_captions: {
                description: "Captions",
                react: code(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        const lorem = [\n                            {\n                                title: \"Lorem\",\n                                description: \"Ut enim ad minim veniam\"\n                            },\n                            {\n                                title: \"Ipsum\",\n                                description: \"Excepteur sint occaecat cupidatat non proident\"\n                            }\n                        ];\n\n                        return (\n                            <SpsSelect options={lorem} textKey=\"title\" captionKey=\"description\" />\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const lorem = [\n                            {\n                                title: \"Lorem\",\n                                description: \"Ut enim ad minim veniam\"\n                            },\n                            {\n                                title: \"Ipsum\",\n                                description: \"Excepteur sint occaecat cupidatat non proident\"\n                            }\n                        ];\n\n                        return (\n                            <SpsSelect options={lorem} textKey=\"title\" captionKey=\"description\" />\n                        )\n                    }\n                "]))),
            },
        },
    },
    c_searchable: {
        label: "Search/Filter",
        description: "info about search/filter",
        examples: {
            a_simple: {
                description: "Simple search function",
                react: code(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        function colorSearch(search) {\n                            return [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"]\n                                .filter(s => (new RegExp(search, \"i\")).test(s));\n                        }\n\n                        return (\n                            <SpsSelect  id=\"search-function\" options={colorSearch} zeroState=\"While I'm sure that's a lovely color, it's not an option we support.\"/>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        function colorSearch(search) {\n                            return [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"]\n                                .filter(s => (new RegExp(search, \"i\")).test(s));\n                        }\n\n                        return (\n                            <SpsSelect  id=\"search-function\" options={colorSearch} zeroState=\"While I'm sure that's a lovely color, it's not an option we support.\"/>\n                        )\n                    }\n                "]))),
            },
            b_promise: {
                description: "Search function returning a Promise",
                react: code(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        function colorSearch(search) {\n                            return new Promise((resolve, reject) => {\n                                const result = [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"]\n                                    .filter(s => new RegExp(search, \"i\").test(s));\n                                resolve(result);\n                            });\n                        }\n\n                        return (\n                            <SpsSelect options={colorSearch}/>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        function colorSearch(search) {\n                            return new Promise((resolve, reject) => {\n                                const result = [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"]\n                                    .filter(s => new RegExp(search, \"i\").test(s));\n                                resolve(result);\n                            });\n                        }\n\n                        return (\n                            <SpsSelect options={colorSearch}/>\n                        )\n                    }\n                "]))),
            },
            c_debounce: {
                description: "Search with Debounce",
                react: code(templateObject_10 || (templateObject_10 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        function colorSearch(search) {\n                            return [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"]\n                                .filter(s => (new RegExp(search, \"i\")).test(s));\n                        }\n\n                        return (\n                            <SpsSelect id=\"debounce-select\" options={colorSearch} searchDebounce={2000}/>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        function colorSearch(search) {\n                            return [\"red\", \"orange\", \"yellow\", \"green\", \"blue\", \"indigo\", \"violet\"]\n                                .filter(s => (new RegExp(search, \"i\")).test(s));\n                        }\n\n                        return (\n                            <SpsSelect id=\"debounce-select\" options={colorSearch} searchDebounce={2000}/>\n                        )\n                    }\n                "]))),
            },
        },
    },
    d_specialAction: {
        label: "Simple Action",
        description: "info about simple action selects",
        examples: {
            a_action: {
                description: "Action",
                react: code(templateObject_11 || (templateObject_11 = __makeTemplateObject$j(["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"orange\", \"yellow\", \"blue\", \"indigo\", \"violet\"];\n                        const [action, updateAction] = useSpsAction(\n                            {\n                                label: \"Test Action\",\n                                icon: \"drill\"\n                            },\n                            () => console.log(\"Action\")\n                        );\n                        function handleChange(event) {\n                            updateAction({\n                                label: \"Test Action\"\n                            });\n                        }\n\n                        return (\n                            <SpsSelect  id=\"special-action\" options={colors} action={action} onChange={handleChange}/>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const colors = [\"red\", \"orange\", \"yellow\", \"blue\", \"indigo\", \"violet\"];\n                        const [action, updateAction] = useSpsAction(\n                            {\n                                label: \"Test Action\",\n                                icon: \"drill\"\n                            },\n                            () => console.log(\"Action\")\n                        );\n                        function handleChange(event) {\n                            updateAction({\n                                label: \"Test Action\"\n                            });\n                        }\n\n                        return (\n                            <SpsSelect  id=\"special-action\" options={colors} action={action} onChange={handleChange}/>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$j, templateObject_2$g, templateObject_3$d, templateObject_4$9, templateObject_5$4, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$1, templateObject_10, templateObject_11;

var __assign$J = (undefined && undefined.__assign) || function () {
    __assign$J = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$J.apply(this, arguments);
};
var __read$h = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var SpsSideNavBranch = function (_a) {
    var branch = _a.branch, setActiveBranch = _a.setActiveBranch, activeBranch = _a.activeBranch;
    var _b = __read$h(useState(branch.expanded || false), 2), isBranchExpanded = _b[0], setIsBranchExpanded = _b[1];
    return (React.createElement("ul", { className: clsx("sps-side-nav__branch", branch.name === activeBranch && "sps-side-nav__branch--active") },
        React.createElement("li", { className: clsx("sps-side-nav__leaf", branch.name === activeBranch && "sps-side-nav__leaf--active") },
            React.createElement("span", { className: "sps-side-nav__link", onClick: function () {
                    setIsBranchExpanded(!isBranchExpanded);
                    if (!branch.subNavItems) {
                        setActiveBranch(branch.name);
                    }
                }, onKeyDown: function (event) {
                    if (event.key === "Enter" || event.key === " ") {
                        event.stopPropagation();
                        event.preventDefault();
                        setIsBranchExpanded(!isBranchExpanded);
                        if (!branch.subNavItems) {
                            setActiveBranch(branch.name);
                        }
                    }
                }, role: "tab", tabIndex: 0 },
                branch.subNavItems && (React.createElement("i", { className: clsx("sps-icon sps-side-nav__toggle", isBranchExpanded
                        ? "sps-icon-chevron-down"
                        : "sps-icon-chevron-right") })),
                React.createElement("span", { className: "sps-side-nav__link-title" },
                    branch.icon && React.createElement("i", { className: "sps-icon sps-icon-" + branch.icon + " mr-2" }),
                    branch.name),
                React.createElement("div", { className: "sps-side-nav__link-tag", style: { marginTop: "-2px" } }, branch.tag && (React.createElement("span", { className: "sps-tag sps-tag--" + branch.tag }, branch.tagContent)))),
            branch.subNavItems
                && isBranchExpanded
                && branch.subNavItems.map(function (subNav) { return (React.createElement(SpsSideNavBranch, { branch: __assign$J(__assign$J({}, subNav), { expanded: findParentBranches(subNav.subNavItems, activeBranch) }), setActiveBranch: setActiveBranch, activeBranch: activeBranch, key: subNav.name })); }))));
};

var __assign$I = (undefined && undefined.__assign) || function () {
    __assign$I = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$I.apply(this, arguments);
};
var __read$g = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Helper to find if parent navigation contains the active child branch
 * @param nav SideNavItems[] array of navigation branches to be checked
 * @param activeTab string currently active tab
 */
var findParentBranches = function (nav, activeTab) {
    if (nav) {
        return (nav.some(function (navItem) { return navItem.name === activeTab; })
            || nav.some(function (navItem) { return findParentBranches(navItem.subNavItems, activeTab); }));
    }
    return false;
};
var SpsSideNav = function (_a) {
    var title = _a.title, titleIcon = _a.titleIcon, navOptions = _a.navOptions, onNavChange = _a.onNavChange, activeNavItem = _a.activeNavItem, tabs = _a.tabs, onTabChange = _a.onTabChange, initialActiveTab = _a.initialActiveTab, filterable = _a.filterable, filterInputPlaceholder = _a.filterInputPlaceholder;
    var previousActiveNavItem = useRef(activeNavItem);
    var _b = __read$g(useState(activeNavItem), 2), activeBranch = _b[0], setActiveBranch = _b[1];
    var _c = __read$g(useState(initialActiveTab || (tabs && tabs[0])), 2), activeTab = _c[0], setActiveTab = _c[1];
    var _d = __read$g(useState(""), 2), filterValue = _d[0], setFilterValue = _d[1];
    /**
     * Handler that sets selected branch as active
     * @param branch string navigation branch to be marked as active
     */
    var handleNavAction = function (branch) {
        setActiveBranch(branch);
        if (onNavChange) {
            onNavChange(branch);
        }
    };
    /**
     * Handler that sets selected tab as active
     * @param tab string navigation branch to be marked as active
     */
    var handleTabAction = function (tab) {
        setActiveTab(tab);
        if (onTabChange) {
            onTabChange(tab);
        }
    };
    /**
     * Helper to filter top level navigation based on nested child branches
     * @param nav SideNavItems[] array of navigation branches to be checked
     */
    var filterChildBranches = function (nav) {
        if (nav) {
            return (nav.some(function (navItem) { return navItem.name.toLowerCase().includes(filterValue); })
                || nav.some(function (navItem) { return filterChildBranches(navItem.subNavItems); }));
        }
        return false;
    };
    /**
     * Filtered list of navigation options. If child of top level matches filter value,
     * the top level is kept.
     */
    var filteredNavOptions = navOptions.map(function (option) { return ({
        sectionTitle: option.sectionTitle,
        navItems: option.navItems.filter(function (navItem) { return (navItem.name.toLowerCase().includes(filterValue)
            || filterChildBranches(navItem.subNavItems)); }),
    }); });
    if (activeNavItem !== previousActiveNavItem.current) {
        setActiveBranch(activeNavItem);
        previousActiveNavItem.current = activeNavItem;
    }
    return (React.createElement("div", { className: "sps-side-nav sps-card" },
        title && (React.createElement("div", { className: "sps-card__header", title: title },
            React.createElement("div", { className: "sps-card__title" },
                titleIcon && (React.createElement("i", { className: "sps-icon sps-icon-" + titleIcon })),
                title))),
        tabs && (React.createElement("nav", { className: "sps-nav sps-nav--tabs" }, tabs.map(function (tab) { return (React.createElement("span", { className: clsx("sps-nav__item", "sps-nav__link", tab === activeTab && "active"), "data-toggle": "tab", role: "tab", tabIndex: 0, key: tab, onClick: function () { return handleTabAction(tab); }, onKeyDown: function (event) {
                if (event.key === "Enter"
                    || event.key === " ") {
                    event.stopPropagation();
                    event.preventDefault();
                    handleTabAction(tab);
                }
            } },
            React.createElement("span", null, tab))); }))),
        React.createElement("div", { className: "sps-card__body" },
            filterable && (React.createElement("section", { className: "sps-side-nav__section" },
                React.createElement("div", { className: "sps-text-input" },
                    React.createElement("div", { className: "sps-form-control" },
                        React.createElement("i", { className: "sps-text-input__icon sps-icon sps-icon-filter" }),
                        React.createElement("input", { type: "text", className: "sps-text-input__input", placeholder: filterInputPlaceholder, onChange: function (event) {
                                setFilterValue(event.target.value);
                            } }))))),
            filteredNavOptions.map(function (section) { return (React.createElement("section", { className: "sps-side-nav__section", key: section.sectionTitle },
                React.createElement("div", { className: "sps-side-nav__section-title", style: { fontWeight: 400 } }, section.sectionTitle),
                section.navItems.map(function (item) { return (React.createElement(SpsSideNavBranch, { branch: __assign$I(__assign$I({}, item), { expanded: findParentBranches(item.subNavItems, activeNavItem) }), activeBranch: activeBranch, setActiveBranch: function (branchName) {
                        handleNavAction(branchName);
                    }, key: item.name })); }))); }))));
};

var __makeTemplateObject$i = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSideNavExamples = {
    usage: {
        label: "Usage",
        customSection: function () { return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("span", { className: "sps-body-14 mb-2" }, "Use the Side Navigation if:"),
                React.createElement("ul", { className: "mt-2" },
                    React.createElement("li", { className: "mb-1" }, "The navigation benefits from subsections or nested structures"),
                    React.createElement("li", { className: "mb-1" }, "There are too many items for Tabbed Navigation"),
                    React.createElement("li", null, "The navigation items have long names"))),
            React.createElement("div", null,
                React.createElement("span", { className: "sps-body-14 mb-2" }, "Avoid using the Side Navigation if:"),
                React.createElement("ul", { className: "mt-2" },
                    React.createElement("li", { className: "mb-1" }, "Tabbed Navigation is sufficient"),
                    React.createElement("li", { className: "mb-1" }, "The full width of the page is required to sufficiently display content"))))); },
    },
    filter: {
        label: "Filter",
        description: "Use Filters when the Side Navigation benefits from filtering, usually when it contains a long list of navigation items.",
        examples: {
            simple: {
                react: code(templateObject_1$i || (templateObject_1$i = __makeTemplateObject$i(["\n                    function DemoComponent() {\n                      function onChange(selection) {\n                        console.log(selection);\n                      }\n\n                      const items = [\n                          {\n                            sectionTitle: \"\",\n                            navItems: [\n                              {\n                                name: \"A Multiple Line Navigation Item That Has to Wrap Because it\u2019s so Long\",\n                              },\n                              {\n                                name: \"Navigation Item 2\",\n                              },\n                              {\n                                name: \"Navigation Item 3\",\n                              },\n                              {\n                                name: \"Navigation Item 4\",\n                              },\n                              {\n                                name: \"Navigation Item 5\",\n                              },\n                              {\n                                name: \"Navigation Item 6\",\n                              },\n                              {\n                                name: \"Navigation Item 7\",\n                              },\n                              {\n                                name: \"Navigation Item 8\",\n                              },\n                              {\n                                name: \"Navigation Item 9\",\n                              },\n                              {\n                                name: \"Navigation Item 10\",\n                              },\n                              {\n                                name: \"Navigation Item 11\",\n                              },\n                              {\n                                name: \"Navigation Item 12\",\n                              },\n                              {\n                                name: \"Navigation Item 13\",\n                              },\n                            ],\n                          }\n                      ];\n\n                      return (\n                        <div className=\"sfg-row\">\n                          <div className=\"sfg-col-4\">\n                            <SpsSideNav\n                                title=\"Title\"\n                                titleIcon={SpsIcon.STATUS_OK}\n                                navOptions={items}\n                                activeNavItem=\"Navigation Item 2\"\n                                onNavChange={onChange}\n                                filterable={true}\n                                filterInputPlaceholder=\"Filter\"\n                            />\n                          </div>\n                        </div>\n                      );\n                  }\n                "], ["\n                    function DemoComponent() {\n                      function onChange(selection) {\n                        console.log(selection);\n                      }\n\n                      const items = [\n                          {\n                            sectionTitle: \"\",\n                            navItems: [\n                              {\n                                name: \"A Multiple Line Navigation Item That Has to Wrap Because it\u2019s so Long\",\n                              },\n                              {\n                                name: \"Navigation Item 2\",\n                              },\n                              {\n                                name: \"Navigation Item 3\",\n                              },\n                              {\n                                name: \"Navigation Item 4\",\n                              },\n                              {\n                                name: \"Navigation Item 5\",\n                              },\n                              {\n                                name: \"Navigation Item 6\",\n                              },\n                              {\n                                name: \"Navigation Item 7\",\n                              },\n                              {\n                                name: \"Navigation Item 8\",\n                              },\n                              {\n                                name: \"Navigation Item 9\",\n                              },\n                              {\n                                name: \"Navigation Item 10\",\n                              },\n                              {\n                                name: \"Navigation Item 11\",\n                              },\n                              {\n                                name: \"Navigation Item 12\",\n                              },\n                              {\n                                name: \"Navigation Item 13\",\n                              },\n                            ],\n                          }\n                      ];\n\n                      return (\n                        <div className=\"sfg-row\">\n                          <div className=\"sfg-col-4\">\n                            <SpsSideNav\n                                title=\"Title\"\n                                titleIcon={SpsIcon.STATUS_OK}\n                                navOptions={items}\n                                activeNavItem=\"Navigation Item 2\"\n                                onNavChange={onChange}\n                                filterable={true}\n                                filterInputPlaceholder=\"Filter\"\n                            />\n                          </div>\n                        </div>\n                      );\n                  }\n                "]))),
            },
        },
    },
    icons: {
        label: "Icons",
        description: function (_a) {
            var Link = _a.Link;
            return (React.createElement("div", null,
                React.createElement("span", { className: "sps-body-14" }, "Use Icons to further illustrate what the navigation item contains. If one navigation item has an Icon, all of the need to have an Icon. Do not use an Icon more than once in a single Side Navigation. Example: A bell icon to represent a Notifications navigation item."),
                React.createElement("div", { className: "mt-2" },
                    React.createElement(Link, { to: "/style-and-layout/icons" }, "View All Icons"))));
        },
        examples: {
            simple: {
                react: code(templateObject_2$f || (templateObject_2$f = __makeTemplateObject$i(["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                        {\n                          sectionTitle: \"\",\n                          navItems: [\n                            {\n                              name: \"Navigation Item 1\",\n                              icon: SpsIcon.CHART_LINE\n                            },\n                            {\n                              name: \"Navigation Item 2\",\n                              icon: SpsIcon.ARCHIVE\n                            },\n                            {\n                              name: \"Navigation Item 3\",\n                              icon: SpsIcon.FOLDER_OPEN\n                            },\n                            {\n                              name: \"Navigation Item 4\",\n                              icon: SpsIcon.BELL\n                            },\n                            {\n                              name: \"Navigation Item 5\",\n                              icon: SpsIcon.BOOK\n                            },\n                            {\n                              name: \"Navigation Item 6\",\n                              icon: SpsIcon.BARCODE\n                            },\n                          ],\n                        }\n                    ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "], ["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                        {\n                          sectionTitle: \"\",\n                          navItems: [\n                            {\n                              name: \"Navigation Item 1\",\n                              icon: SpsIcon.CHART_LINE\n                            },\n                            {\n                              name: \"Navigation Item 2\",\n                              icon: SpsIcon.ARCHIVE\n                            },\n                            {\n                              name: \"Navigation Item 3\",\n                              icon: SpsIcon.FOLDER_OPEN\n                            },\n                            {\n                              name: \"Navigation Item 4\",\n                              icon: SpsIcon.BELL\n                            },\n                            {\n                              name: \"Navigation Item 5\",\n                              icon: SpsIcon.BOOK\n                            },\n                            {\n                              name: \"Navigation Item 6\",\n                              icon: SpsIcon.BARCODE\n                            },\n                          ],\n                        }\n                    ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "]))),
            },
        },
    },
    nesting: {
        label: "Nesting",
        description: "Use Nesting to organize related navigation items. Avoid nesting beyond grandchildren.",
        examples: {
            simple: {
                react: code(templateObject_3$c || (templateObject_3$c = __makeTemplateObject$i(["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                        {\n                          sectionTitle: \"\",\n                          navItems: [\n                            {\n                              name: \"Parent 1\",\n                              subNavItems: [\n                                {\n                                  name: \"Child 1\",\n                                  subNavItems: [\n                                    {\n                                      name: \"Grandchild 1\",\n                                    },\n                                    {\n                                      name: \"Grandchild 2\",\n                                    }\n                                  ]\n                                },\n                                {\n                                  name: \"Child 2\",\n                                  subNavItems: [\n                                    {\n                                      name: \"Grandchild 3\",\n                                    },\n                                    {\n                                      name: \"Grandchild 4\",\n                                    }\n                                  ]\n                                }\n                              ]\n                            },\n                            {\n                              name: \"Parent 2\",\n                              subNavItems: [\n                                {\n                                  name: \"Child 3\"\n                                },\n                                {\n                                  name: \"Child 4\"\n                                }\n                              ]\n                            },\n                          ],\n                        }\n                    ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                              activeNavItem=\"Grandchild 1\"\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "], ["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                        {\n                          sectionTitle: \"\",\n                          navItems: [\n                            {\n                              name: \"Parent 1\",\n                              subNavItems: [\n                                {\n                                  name: \"Child 1\",\n                                  subNavItems: [\n                                    {\n                                      name: \"Grandchild 1\",\n                                    },\n                                    {\n                                      name: \"Grandchild 2\",\n                                    }\n                                  ]\n                                },\n                                {\n                                  name: \"Child 2\",\n                                  subNavItems: [\n                                    {\n                                      name: \"Grandchild 3\",\n                                    },\n                                    {\n                                      name: \"Grandchild 4\",\n                                    }\n                                  ]\n                                }\n                              ]\n                            },\n                            {\n                              name: \"Parent 2\",\n                              subNavItems: [\n                                {\n                                  name: \"Child 3\"\n                                },\n                                {\n                                  name: \"Child 4\"\n                                }\n                              ]\n                            },\n                          ],\n                        }\n                    ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                              activeNavItem=\"Grandchild 1\"\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "]))),
            },
        },
    },
    sections: {
        label: "Sections",
        description: "Use Sections to break up content into different categories. Sections utilize Subtitles.",
        examples: {
            simple: {
                react: code(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject$i(["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                        {\n                          sectionTitle: \"Good Section\",\n                          navItems: [\n                            {\n                              name: \"Parent 1\",\n                              subNavItems: [\n                                {\n                                  name: \"Child\",\n                                }\n                              ]\n                            },\n                            {\n                              name: \"Parent 2\",\n                            },\n                            {\n                              name: \"Parent 3\",\n                              subNavItems: [\n                                {\n                                  name: \"Child 1\",\n                                  subNavItems: [\n                                    {\n                                      name: \"Grandchild 1\",\n                                    }\n                                  ]\n                                }\n                              ]\n                            },\n                          ],\n                        },\n                        {\n                          sectionTitle: \"Great Section\",\n                          navItems: [\n                            {\n                              name: \"Parent 4\",\n                            },\n                            {\n                              name: \"Parent 5\",\n                            },\n                            {\n                              name: \"Parent 6\",\n                            },\n                          ],\n                        }\n                    ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Test Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                              activeNavItem=\"Grandchild 1\"\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "], ["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                        {\n                          sectionTitle: \"Good Section\",\n                          navItems: [\n                            {\n                              name: \"Parent 1\",\n                              subNavItems: [\n                                {\n                                  name: \"Child\",\n                                }\n                              ]\n                            },\n                            {\n                              name: \"Parent 2\",\n                            },\n                            {\n                              name: \"Parent 3\",\n                              subNavItems: [\n                                {\n                                  name: \"Child 1\",\n                                  subNavItems: [\n                                    {\n                                      name: \"Grandchild 1\",\n                                    }\n                                  ]\n                                }\n                              ]\n                            },\n                          ],\n                        },\n                        {\n                          sectionTitle: \"Great Section\",\n                          navItems: [\n                            {\n                              name: \"Parent 4\",\n                            },\n                            {\n                              name: \"Parent 5\",\n                            },\n                            {\n                              name: \"Parent 6\",\n                            },\n                          ],\n                        }\n                    ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Test Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                              activeNavItem=\"Grandchild 1\"\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "]))),
            },
        },
    },
    tags: {
        label: "Tags",
        description: "Use Tags to indicate a number of additional detail related to the navigation item.",
        examples: {
            simple: {
                react: code(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject$i(["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                      {\n                        sectionTitle: \"\",\n                        navItems: [\n                          {\n                            name: \"Navigation Item 1\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Cool\",\n                          },\n                          {\n                            name: \"Navigation Item 2\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Good\",\n                          },\n                          {\n                            name: \"Navigation Item 3\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Fun\",\n                          },\n                          {\n                            name: \"Navigation Item 4\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Nice\",\n                          },\n                          {\n                            name: \"Navigation Item 5\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Grand\",\n                          },\n                          {\n                            name: \"Navigation Item 6\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Great\",\n                          },\n                        ],\n                      }\n                  ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                              activeNavItem=\"Navigation Item 1\"\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "], ["\n                  function DemoComponent() {\n                    function onChange(selection) {\n                      console.log(selection);\n                    }\n\n                    const items = [\n                      {\n                        sectionTitle: \"\",\n                        navItems: [\n                          {\n                            name: \"Navigation Item 1\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Cool\",\n                          },\n                          {\n                            name: \"Navigation Item 2\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Good\",\n                          },\n                          {\n                            name: \"Navigation Item 3\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Fun\",\n                          },\n                          {\n                            name: \"Navigation Item 4\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Nice\",\n                          },\n                          {\n                            name: \"Navigation Item 5\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Grand\",\n                          },\n                          {\n                            name: \"Navigation Item 6\",\n                            tag: TagKind.DEFAULT,\n                            tagContent: \"Great\",\n                          },\n                        ],\n                      }\n                  ];\n\n                    return (\n                      <div className=\"sfg-row\">\n                        <div className=\"sfg-col-4\">\n                          <SpsSideNav\n                              title=\"Title\"\n                              titleIcon={SpsIcon.STATUS_OK}\n                              navOptions={items}\n                              onNavChange={onChange}\n                              activeNavItem=\"Navigation Item 1\"\n                          />\n                        </div>\n                      </div>\n                    );\n                }\n              "]))),
            },
        },
    },
};
var templateObject_1$i, templateObject_2$f, templateObject_3$c, templateObject_4$8, templateObject_5$3;

var __assign$H = (undefined && undefined.__assign) || function () {
    __assign$H = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$H.apply(this, arguments);
};
var __rest$A = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$C = {
    sortKey: "string",
    sortDisabled: "boolean",
    sort: "SortedColumn[]",
    onSortChange: "SortChangeHandler",
    widthPx: "number",
    widthRem: "number",
};
var propTypes$F = __assign$H({ sortKey: propTypes$1H.exports.string, sortDisabled: propTypes$1H.exports.bool, sort: propTypes$1H.exports.arrayOf(impl()), onSortChange: fun(), widthPx: propTypes$1H.exports.number, widthRem: propTypes$1H.exports.number }, spsGlobalPropTypes);
function SpsSortingHeaderCell(_a) {
    var className = _a.className, testId = _a["data-testid"], unsafelyReplaceClassName = _a.unsafelyReplaceClassName, sortKey = _a.sortKey, sort = _a.sort, sortDisabled = _a.sortDisabled, onSortChange = _a.onSortChange, onClick = _a.onClick, children = _a.children, widthPx = _a.widthPx, widthRem = _a.widthRem, style = _a.style, rest = __rest$A(_a, ["className", "data-testid", "unsafelyReplaceClassName", "sortKey", "sort", "sortDisabled", "onSortChange", "onClick", "children", "widthPx", "widthRem", "style"]);
    var sortDirection = React.useMemo(function () {
        var sortDefinition = !!sortKey
            && !sortDisabled
            && Array.isArray(sort)
            && sort.find(function (s) { return s.key === sortKey; });
        return sortDefinition ? sortDefinition.direction : undefined;
    }, [sort,
        sortKey,
        sortDisabled]);
    var classes = clsx(unsafelyReplaceClassName || "sps-sorting-header__cell", sortDirection === SortDirection.ASCENDING && "sps-sorting-header__cell--sorted-asc", sortDirection === SortDirection.DESCENDING && "sps-sorting-header__cell--sorted-desc", sortDisabled && "sps-sorting-header__cell--sort-disabled", className);
    var width = widthPx ? widthPx / 16 : widthRem;
    var inlineStyles = width ? __assign$H(__assign$H({}, style), { width: width + "rem" }) : style;
    return (React.createElement("div", __assign$H({ className: classes, onClick: function (e) {
            if (sortKey && !sortDisabled) {
                onSortChange([
                    {
                        key: sortKey,
                        direction: sortDirection === SortDirection.ASCENDING
                            ? SortDirection.DESCENDING
                            : SortDirection.ASCENDING,
                    },
                ]);
            }
            if (onClick) {
                onClick(e);
            }
        }, "data-testid": testId, style: inlineStyles }, rest), children));
}
Object.assign(SpsSortingHeaderCell, {
    props: propsDoc$C,
    propTypes: propTypes$F,
    displayName: "SpsSortingHeaderCell",
});

var __assign$G = (undefined && undefined.__assign) || function () {
    __assign$G = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$G.apply(this, arguments);
};
var __rest$z = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$B = {
    sort: "SortedColumn[]",
    onSortChange: "SortChangeHandler",
};
var propTypes$E = __assign$G(__assign$G({}, spsGlobalPropTypes), { sort: propTypes$1H.exports.arrayOf(impl()), onSortChange: fun() });
function SpsSortingHeader(_a) {
    var className = _a.className; _a["data-testid"]; var unsafelyReplaceClassName = _a.unsafelyReplaceClassName, sort = _a.sort, onSortChange = _a.onSortChange, children = _a.children, rest = __rest$z(_a, ["className", "data-testid", "unsafelyReplaceClassName", "sort", "onSortChange", "children"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-sorting-header", className);
    var newProps = {
        sort: sort,
        onSortChange: onSortChange,
    };
    return (React.createElement("div", __assign$G({ className: classes }, rest), React.Children.map(children, function (child) {
        if (child && React.isValidElement(child) && child.type === SpsSortingHeaderCell) {
            return React.cloneElement(child, newProps);
        }
        return child;
    })));
}
Object.assign(SpsSortingHeader, {
    props: propsDoc$B,
    propTypes: propTypes$E,
    displayName: "SpsSortingHeader",
});

var __makeTemplateObject$h = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSpinnerExamples = {
    basic: {
        examples: {
            small: {
                jsx: code(templateObject_1$h || (templateObject_1$h = __makeTemplateObject$h(["\n                    <React.Fragment>\n                        <SpsSpinner size=\"small\"/>\n                        <SpsSpinner size={SpinnerSize.SMALL}/>\n                    </React.Fragment>\n                "], ["\n                    <React.Fragment>\n                        <SpsSpinner size=\"small\"/>\n                        <SpsSpinner size={SpinnerSize.SMALL}/>\n                    </React.Fragment>\n                "]))),
            },
            medium: {
                jsx: code(templateObject_2$e || (templateObject_2$e = __makeTemplateObject$h(["\n                    <React.Fragment>\n                        <SpsSpinner />\n                        <SpsSpinner size=\"medium\" title=\"Please wait\u2026\"/>\n                        <SpsSpinner size={SpinnerSize.MEDIUM}/>\n                    </React.Fragment>\n                "], ["\n                    <React.Fragment>\n                        <SpsSpinner />\n                        <SpsSpinner size=\"medium\" title=\"Please wait\u2026\"/>\n                        <SpsSpinner size={SpinnerSize.MEDIUM}/>\n                    </React.Fragment>\n                "]))),
            },
            large: {
                jsx: code(templateObject_3$b || (templateObject_3$b = __makeTemplateObject$h(["\n                    <React.Fragment>\n                        <SpsSpinner size=\"large\"/>\n                        <SpsSpinner size={SpinnerSize.LARGE} alt=\"Loading content\u2026\"/>\n                    </React.Fragment>\n                "], ["\n                    <React.Fragment>\n                        <SpsSpinner size=\"large\"/>\n                        <SpsSpinner size={SpinnerSize.LARGE} alt=\"Loading content\u2026\"/>\n                    </React.Fragment>\n                "]))),
            },
        },
    },
};
var templateObject_1$h, templateObject_2$e, templateObject_3$b;

var __assign$F = (undefined && undefined.__assign) || function () {
    __assign$F = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$F.apply(this, arguments);
};
var __rest$y = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$f = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$A = {
    disabled: "boolean",
    href: "string",
    label: "string",
    icon: "SpsIcon",
    kind: "StdButtonKind",
    options: "Array<SpsActionMethod | [SpsActionDescriptor, () => void]>",
};
var propTypes$D = __assign$F(__assign$F({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, href: propTypes$1H.exports.string, label: propTypes$1H.exports.string, icon: enumValue(SpsIcon), kind: enumValue(StdButtonKind), 
    // eslint thinks there is a space between the name and open paren below for some reason
    // eslint-disable-next-line no-spaced-func
    options: propTypes$1H.exports.arrayOf(propTypes$1H.exports.oneOfType([propTypes$1H.exports.func, propTypes$1H.exports.any])) });
function SpsSplitButton(props) {
    props.children; var className = props.className, testId = props["data-testid"], disabled = props.disabled, href = props.href, label = props.label, options = props.options, icon = props.icon, _a = props.kind, kind = _a === void 0 ? StdButtonKind.DEFAULT : _a, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$y(props, ["children", "className", "data-testid", "disabled", "href", "label", "options", "icon", "kind", "unsafelyReplaceClassName"]);
    var _b = __read$f(React.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var setOpen = function () {
        setIsOpen(true);
    };
    var setClose = function () {
        setIsOpen(false);
    };
    var splitButtonClasses = clsx(unsafelyReplaceClassName || "sps-split-button", "sps-split-button--" + kind, isOpen && "sps-split-button--open", className);
    return (React.createElement("div", __assign$F({ className: splitButtonClasses, "data-testid": testId }, rest),
        React.createElement(SpsButton, { kind: kind, icon: icon, href: href, disabled: disabled }, label),
        React.createElement(SpsDropdown, { kind: kind, options: options, disabled: disabled, onOpen: setOpen, onClose: setClose })));
}
Object.assign(SpsSplitButton, {
    props: propsDoc$A,
    propTypes: propTypes$D,
    displayName: "SpsSplitButton",
});

var __makeTemplateObject$g = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSplitButtonExamples = {
    kinds: {
        label: "Regular Split Buttons",
        description: code(templateObject_1$g || (templateObject_1$g = __makeTemplateObject$g(["<p>info about split buttons</p>"], ["<p>info about split buttons</p>"]))),
        examples: {
            basic: {
                description: code(templateObject_2$d || (templateObject_2$d = __makeTemplateObject$g(["<p>Basic</p>"], ["<p>Basic</p>"]))),
                jsx: code(templateObject_3$a || (templateObject_3$a = __makeTemplateObject$g(["\n                    <React.Fragment>\n                        <SpsSplitButton id=\"withIcon\" label=\"Default Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton kind=\"confirm\" label=\"Confirm Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton kind=\"key\" label=\"Key Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton kind=\"delete\" label=\"Delete Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                    </React.Fragment>\n                "], ["\n                    <React.Fragment>\n                        <SpsSplitButton id=\"withIcon\" label=\"Default Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton kind=\"confirm\" label=\"Confirm Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton kind=\"key\" label=\"Key Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton kind=\"delete\" label=\"Delete Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                    </React.Fragment>\n                "]))),
            },
        },
    },
    withIcons: {
        label: "Split Buttons with Icons",
        description: code(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject$g(["<p>info about icon split buttons</p>"], ["<p>info about icon split buttons</p>"]))),
        examples: {
            withIcons: {
                description: code(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject$g(["<p>With Icons</p>"], ["<p>With Icons</p>"]))),
                react: code(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject$g(["\n                    function SpsSplitButtonWithIcon(props) {\n                        function alert1() {\n                            window.alert(\"Button clicked\");\n                        }\n                        return (\n                            <React.Fragment>\n                                <SpsSplitButton id=\"withIcon\" icon=\"drill\" label=\"Default Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                                <SpsSplitButton icon=\"rocket\" kind=\"confirm\" label=\"Confirm Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                                <SpsSplitButton icon=\"key\" kind=\"key\" label=\"Key Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                                <SpsSplitButton icon=\"trash\" kind=\"delete\" onClick={alert1} label=\"Delete Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                            </React.Fragment>\n                        );\n                    }\n                "], ["\n                    function SpsSplitButtonWithIcon(props) {\n                        function alert1() {\n                            window.alert(\"Button clicked\");\n                        }\n                        return (\n                            <React.Fragment>\n                                <SpsSplitButton id=\"withIcon\" icon=\"drill\" label=\"Default Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                                <SpsSplitButton icon=\"rocket\" kind=\"confirm\" label=\"Confirm Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                                <SpsSplitButton icon=\"key\" kind=\"key\" label=\"Key Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                                <SpsSplitButton icon=\"trash\" kind=\"delete\" onClick={alert1} label=\"Delete Button\"\n                                    options={[\n                                        [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                                    ]} className=\"mr-1\">\n                                </SpsSplitButton>\n                            </React.Fragment>\n                        );\n                    }\n                "]))),
            },
        },
    },
    disabled: {
        label: "Disabled Split Buttons",
        description: code(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject$g(["<p>info about disabled split buttons</p>"], ["<p>info about disabled split buttons</p>"]))),
        examples: {
            disabled: {
                description: code(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject$g(["<p>Disabled</p>"], ["<p>Disabled</p>"]))),
                jsx: code(templateObject_9 || (templateObject_9 = __makeTemplateObject$g(["\n                    <React.Fragment>\n                        <SpsSplitButton disabled id=\"disabled\" kind=\"key\" label=\"Disabled Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton disabled kind=\"key\" icon=\"drill\" label=\"Disabled Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                    </React.Fragment>\n                "], ["\n                    <React.Fragment>\n                        <SpsSplitButton disabled id=\"disabled\" kind=\"key\" label=\"Disabled Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                        <SpsSplitButton disabled kind=\"key\" icon=\"drill\" label=\"Disabled Button\"\n                            options={[\n                                [{ label: \"Option A\" }, () => console.log(\"Option A\")]\n                            ]} className=\"mr-1\">\n                        </SpsSplitButton>\n                    </React.Fragment>\n                "]))),
            },
        },
    },
};
var templateObject_1$g, templateObject_2$d, templateObject_3$a, templateObject_4$7, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$1, templateObject_9;

var __assign$E = (undefined && undefined.__assign) || function () {
    __assign$E = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$E.apply(this, arguments);
};
var __rest$x = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$z = {
    channelId: { type: "string", required: true },
};
var propTypes$C = __assign$E(__assign$E({}, spsGlobalPropTypes), { channelId: propTypes$1H.exports.string.isRequired });
function SpsSlackLink(props) {
    var channelId = props.channelId, className = props.className, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$x(props, ["channelId", "className", "unsafelyReplaceClassName"]);
    var t = React.useContext(I18nContext).t;
    var classes = clsx(unsafelyReplaceClassName || "sps-slack-link", className);
    return (React.createElement("a", __assign$E({ className: classes, target: "_blank", rel: "noreferrer", href: "https://spscommerce.slack.com/archives/" + channelId }, rest),
        React.createElement("i", { className: "sps-icon sps-icon-" + SpsIcon.CONVERSATION, "aria-hidden": "true" }),
        React.createElement("span", null, t("design-system:slackLink.label"))));
}
Object.assign(SpsSlackLink, {
    props: propsDoc$z,
    propTypes: propTypes$C,
    displayName: "SpsSlackLink",
});

var __makeTemplateObject$f = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSlackLinkExamples = {
    basic: {
        examples: {
            basic: {
                react: code(templateObject_1$f || (templateObject_1$f = __makeTemplateObject$f(["\n                    function DemoComponent() {\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                tabs={[\"Foo\", \"Bar\", \"Baz\"]}\n                                activeTab=\"Bar\"\n                                fullWidth\n                                style={{ position: \"relative\" }} // display this example in its place instead of at the top\n                            ><SpsSlackLink channelId=\"CELEGDK4Y\" /></SpsProductBar>\n                        );\n                    }\n                "], ["\n                    function DemoComponent() {\n                        return (\n                            <SpsProductBar productName=\"My Product\"\n                                productLogoSrc=\"https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg\"\n                                tabs={[\"Foo\", \"Bar\", \"Baz\"]}\n                                activeTab=\"Bar\"\n                                fullWidth\n                                style={{ position: \"relative\" }} // display this example in its place instead of at the top\n                            ><SpsSlackLink channelId=\"CELEGDK4Y\" /></SpsProductBar>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$f;

var __assign$D = (undefined && undefined.__assign) || function () {
    __assign$D = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$D.apply(this, arguments);
};
var __rest$w = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$y = {};
var propTypes$B = __assign$D({}, spsGlobalPropTypes);
function SpsSummaryListExpansion(props) {
    var children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$w(props, ["children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-content-row__expansion", className);
    return (React.createElement("div", __assign$D({ className: classes }, rest, { "data-testid": testId + "__expansion" }), children));
}
Object.assign(SpsSummaryListExpansion, {
    props: propsDoc$y,
    propTypes: propTypes$B,
    displayName: "SpsSummaryListExpansion",
});

var __assign$C = (undefined && undefined.__assign) || function () {
    __assign$C = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$C.apply(this, arguments);
};
var __rest$v = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$e = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$x = {
    expanded: "boolean",
    selected: "boolean",
    onToggle: "(isExpanded: boolean) => void",
};
var propTypes$A = __assign$C(__assign$C({}, spsGlobalPropTypes), { expanded: propTypes$1H.exports.bool, selected: propTypes$1H.exports.bool, onToggle: fun() });
function SpsSummaryListRow(props) {
    var children = props.children, className = props.className, expanded = props.expanded, onToggle = props.onToggle, selected = props.selected, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$v(props, ["children", "className", "expanded", "onToggle", "selected", "data-testid", "unsafelyReplaceClassName"]);
    var _a = __read$e(usePatchReducer({
        isExpanded: expanded,
        expandable: false,
    }), 2), state = _a[0], patchState = _a[1];
    React.useEffect(function () {
        var expandable = React.Children.toArray(children)
            .some(function (child) { return React.isValidElement(child) && child.type === SpsSummaryListExpansion; });
        patchState({ expandable: expandable });
    }, []);
    function toggle() {
        var isExpanded = !state.isExpanded;
        patchState({ isExpanded: isExpanded });
        if (onToggle) {
            onToggle(isExpanded);
        }
    }
    function handleRowClick(event) {
        event.stopPropagation();
        toggle();
    }
    function handleKeyDown(event) {
        if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            event.stopPropagation();
            toggle();
        }
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-summary-list-row", "sps-content-row", state.expandable && "sps-summary-list-row--expandable", state.isExpanded && "sps-content-row--expanded", selected && "sps-summary-list-row--selected", className);
    var _b = __read$e(selectChildren(children, [
        { type: SpsSummaryListExpansion },
    ]), 2), expansion = _b[0], otherChildren = _b[1];
    console.warn([
        "The SpsSummaryListRow component will be replaced by the SpsContentRow component.",
        "All references to it should be replaced before SpsSummaryListRow is removed.",
        "Reach out to the design system help Slack channel if you have any questions!",
    ].join(" "));
    return (React.createElement("div", __assign$C({ className: classes, "data-testid": testId }, rest),
        React.createElement("div", { className: "sps-content-row__col-group", "data-testid": testId + "__col-group", onClick: handleRowClick, onKeyDown: handleKeyDown, tabIndex: 0 }, otherChildren),
        expansion));
}
Object.assign(SpsSummaryListRow, {
    props: propsDoc$x,
    propTypes: propTypes$A,
    displayName: "SpsSummaryListRow",
});

var __assign$B = (undefined && undefined.__assign) || function () {
    __assign$B = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$B.apply(this, arguments);
};
var __rest$u = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$w = {
    borderless: "boolean",
    lean: "boolean",
    leaner: "boolean",
    width: "string",
};
var propTypes$z = __assign$B(__assign$B({}, spsGlobalPropTypes), { borderless: propTypes$1H.exports.bool, lean: propTypes$1H.exports.bool, leaner: propTypes$1H.exports.bool, width: propTypes$1H.exports.string });
function SpsSummaryListColumn(props) {
    var className = props.className, children = props.children, borderless = props.borderless, lean = props.lean, leaner = props.leaner, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, width = props.width, rest = __rest$u(props, ["className", "children", "borderless", "lean", "leaner", "data-testid", "unsafelyReplaceClassName", "width"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-content-row__col", lean && "sps-content-row__col--lean", leaner && "sps-content-row__col--leaner", borderless && "sps-content-row__col--borderless", className);
    return (React.createElement("div", __assign$B({ className: classes, style: { width: width } }, rest, { "data-testid": testId + "__col" }), children));
}
Object.assign(SpsSummaryListColumn, {
    props: propsDoc$w,
    propTypes: propTypes$z,
    displayName: "SpsSummaryListColumn",
});

var __makeTemplateObject$e = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSummaryListExamples = {
    basic: {
        label: "Basic Usage",
        examples: {
            basic: {
                jsx: code(templateObject_1$e || (templateObject_1$e = __makeTemplateObject$e(["\n                    <>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\">\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey={\"Title\"}>\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey={\"Long Title\"}>\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey={\"Title\"}>\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\">\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                        </SpsSummaryListRow>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\">\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Long Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\">\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                        </SpsSummaryListRow>\n                    </>"], ["\n                    <>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\">\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey={\"Title\"}>\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey={\"Long Title\"}>\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey={\"Title\"}>\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\">\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                        </SpsSummaryListRow>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\">\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Long Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\">\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                        </SpsSummaryListRow>\n                    </>"]))),
            },
        },
    },
    expandable: {
        label: "Expandable",
        description: code(templateObject_2$c || (templateObject_2$c = __makeTemplateObject$e(["\n            <p>If you put a <code>&lt;SpsSummaryListExpansion&gt;&lt;/SpsSummaryListExpansion&gt;</code>\n            inside a Summary List Row, then it will be expandable to show the content in the expansion\n            element. It can be toggled by clicking on it or by tabbing focus to it and hitting ENTER\n            or SPACEBAR.</p>\n        "], ["\n            <p>If you put a <code>&lt;SpsSummaryListExpansion&gt;&lt;/SpsSummaryListExpansion&gt;</code>\n            inside a Summary List Row, then it will be expandable to show the content in the expansion\n            element. It can be toggled by clicking on it or by tabbing focus to it and hitting ENTER\n            or SPACEBAR.</p>\n        "]))),
        examples: {
            expandable: {
                jsx: code(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject$e(["\n                    <>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\">\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Long Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\">\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListExpansion>\n                                <SpsCard\n                                    headerContent={() => <span>Custom Header</span>}>\n                                    <div>Content</div>\n                                </SpsCard>\n                                <div className=\"text-center mt-3\">\n                                    <SpsButton kind={ButtonKind.LINK}>Show More</SpsButton>\n                                </div>\n                            </SpsSummaryListExpansion>\n                        </SpsSummaryListRow>\n                    </> "], ["\n                    <>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\">\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Long Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\">\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListExpansion>\n                                <SpsCard\n                                    headerContent={() => <span>Custom Header</span>}>\n                                    <div>Content</div>\n                                </SpsCard>\n                                <div className=\"text-center mt-3\">\n                                    <SpsButton kind={ButtonKind.LINK}>Show More</SpsButton>\n                                </div>\n                            </SpsSummaryListExpansion>\n                        </SpsSummaryListRow>\n                    </> "]))),
            },
        },
    },
    borderless: {
        label: "Removing Borders",
        description: code(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject$e(["\n            <p>Placing the <code>borderless</code> prop on a column will remove its left border.</p>\n        "], ["\n            <p>Placing the <code>borderless</code> prop on a column will remove its left border.</p>\n        "]))),
        examples: {
            borderless: {
                jsx: code(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject$e(["\n                    <>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\" borderless>\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Long Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\" borderless>\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                        </SpsSummaryListRow>\n                    </>"], ["\n                    <>\n                        <SpsSummaryListRow>\n                            <SpsSummaryListColumn>\n                                <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                <div className=\"d-inline-block align-middle\">\n                                    <div className=\"fs-18\">\n                                        <a href=\"#\">Heading</a>\n                                    </div>\n                                    <div className=\"fs-14\">Sub Heading</div>\n                                </div>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"13.5rem\" borderless>\n                                <SpsKeyValueList inline>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Long Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                    <SpsKeyValueListItem itemKey=\"Title\">\n                                        Sub copy goes here\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"9rem\" borderless>\n                                <SpsKeyValueList>\n                                    <SpsKeyValueListItem itemKey=\"Buying From\">\n                                        75 Companies\n                                        <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                    </SpsKeyValueListItem>\n                                </SpsKeyValueList>\n                            </SpsSummaryListColumn>\n                            <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                <SpsDropdown\n                                    label=\"\"\n                                    icon=\"ellipses\"\n                                    options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                />\n                            </SpsSummaryListColumn>\n                        </SpsSummaryListRow>\n                    </>"]))),
            },
        },
    },
    selectable: {
        label: "Selectable",
        description: code(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject$e(["\n            <p>By placing a column with a checkbox and wiring that checkbox to control the\n            <code>selected</code> prop on the row, you can make rows selectable.</p>\n        "], ["\n            <p>By placing a column with a checkbox and wiring that checkbox to control the\n            <code>selected</code> prop on the row, you can make rows selectable.</p>\n        "]))),
        examples: {
            selectable: {
                react: code(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject$e(["\n                    function Component() {\n                        const [rowIsSelected, setRowIsSelected] = React.useState(true);\n\n                        function handleSelectionChange(event) {\n                            setRowIsSelected(event.target.checked);\n                        }\n\n                        return (\n                            <SpsSummaryListRow selected={rowIsSelected}>\n                                <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                    <SpsCheckbox aria-label=\"Row Selected\" checked={rowIsSelected} onChange={handleSelectionChange}/>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                    <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                    <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn>\n                                    <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                    <div className=\"d-inline-block align-middle\">\n                                        <div className=\"fs-18\">\n                                            <a href=\"#\">Heading</a>\n                                        </div>\n                                        <div className=\"fs-14\">Sub Heading</div>\n                                    </div>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"13.5rem\">\n                                    <SpsKeyValueList inline>\n                                        <SpsKeyValueListItem itemKey=\"Title\">\n                                            Sub copy goes here\n                                        </SpsKeyValueListItem>\n                                        <SpsKeyValueListItem itemKey=\"Long Title\">\n                                            Sub copy goes here\n                                        </SpsKeyValueListItem>\n                                        <SpsKeyValueListItem itemKey=\"Title\">\n                                            Sub copy goes here\n                                        </SpsKeyValueListItem>\n                                    </SpsKeyValueList>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"9rem\">\n                                    <SpsKeyValueList>\n                                        <SpsKeyValueListItem itemKey=\"Buying From\">\n                                            75 Companies\n                                            <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                        </SpsKeyValueListItem>\n                                    </SpsKeyValueList>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                    <SpsDropdown\n                                        label=\"\"\n                                        icon=\"ellipses\"\n                                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                    />\n                                </SpsSummaryListColumn>\n                            </SpsSummaryListRow>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const [rowIsSelected, setRowIsSelected] = React.useState(true);\n\n                        function handleSelectionChange(event) {\n                            setRowIsSelected(event.target.checked);\n                        }\n\n                        return (\n                            <SpsSummaryListRow selected={rowIsSelected}>\n                                <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                    <SpsCheckbox aria-label=\"Row Selected\" checked={rowIsSelected} onChange={handleSelectionChange}/>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"2.8rem\" lean>\n                                    <SpsI icon={SpsIcon.STAR} size={SpsIconSize.MEDIUM} className=\"d-block mb-2 yellow300\" />\n                                    <SpsI icon={SpsIcon.FLAG} size={SpsIconSize.MEDIUM} className=\"d-block yellow300\" />\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn>\n                                    <SpsI icon={SpsIcon.STATUS_ERROR} size={SpsIconSize.LARGE} className=\"align-middle mr-2 pr-1\" />\n                                    <div className=\"d-inline-block align-middle\">\n                                        <div className=\"fs-18\">\n                                            <a href=\"#\">Heading</a>\n                                        </div>\n                                        <div className=\"fs-14\">Sub Heading</div>\n                                    </div>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"13.5rem\">\n                                    <SpsKeyValueList inline>\n                                        <SpsKeyValueListItem itemKey=\"Title\">\n                                            Sub copy goes here\n                                        </SpsKeyValueListItem>\n                                        <SpsKeyValueListItem itemKey=\"Long Title\">\n                                            Sub copy goes here\n                                        </SpsKeyValueListItem>\n                                        <SpsKeyValueListItem itemKey=\"Title\">\n                                            Sub copy goes here\n                                        </SpsKeyValueListItem>\n                                    </SpsKeyValueList>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"9rem\">\n                                    <SpsKeyValueList>\n                                        <SpsKeyValueListItem itemKey=\"Buying From\">\n                                            75 Companies\n                                            <div className=\"font-weight-light\">38 of 75 Operational</div>\n                                        </SpsKeyValueListItem>\n                                    </SpsKeyValueList>\n                                </SpsSummaryListColumn>\n                                <SpsSummaryListColumn width=\"3.6rem\" leaner>\n                                    <SpsDropdown\n                                        label=\"\"\n                                        icon=\"ellipses\"\n                                        options={[[{ label: \"Option A\" }, () => console.log(\"Option A\")], [{ label: \"Option B\" }, () => console.log(\"Option B\")]]}\n                                    />\n                                </SpsSummaryListColumn>\n                            </SpsSummaryListRow>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$e, templateObject_2$c, templateObject_3$9, templateObject_4$6, templateObject_5$1, templateObject_6$1, templateObject_7$1;

var __assign$A = (undefined && undefined.__assign) || function () {
    __assign$A = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$A.apply(this, arguments);
};
var __rest$t = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$d = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var props = {
    tasks: "ReactSpsTask[]",
    taskQueuePosition: "Position",
    notificationText: "string",
    tooltipConfig: "{ position: Position, kind: TooltipKind }",
    onClose: "() => void",
    onOpen: "() => void",
    onClearCompleted: "() => void",
    suppressTooltips: "boolean",
};
var propTypes$y = __assign$A(__assign$A({}, spsGlobalPropTypes), { tasks: propTypes$1H.exports.arrayOf(propTypes$1H.exports.any), taskQueuePosition: enumValue(Position), notificationText: propTypes$1H.exports.string, tooltipConfig: propTypes$1H.exports.shape({
        position: enumValue(Position),
        kind: enumValue(TooltipKind),
    }), onClose: fun(), onOpen: fun(), onClearCompleted: fun(), suppressTooltips: propTypes$1H.exports.bool });
function SpsTaskQueue(_a) {
    var _b = _a.tasks, tasks = _b === void 0 ? [] : _b, _c = _a.taskQueuePosition, taskQueuePosition = _c === void 0 ? Position.BOTTOM_RIGHT : _c, notificationText = _a.notificationText, _d = _a.tooltipConfig, tooltipConfig = _d === void 0 ? {} : _d, onOpen = _a.onOpen, onClose = _a.onClose, onClearCompleted = _a.onClearCompleted, className = _a.className, testId = _a["data-testid"], unsafelyReplaceClassName = _a.unsafelyReplaceClassName, _e = _a.suppressTooltips, suppressTooltips = _e === void 0 ? false : _e, rest = __rest$t(_a, ["tasks", "taskQueuePosition", "notificationText", "tooltipConfig", "onOpen", "onClose", "onClearCompleted", "className", "data-testid", "unsafelyReplaceClassName", "suppressTooltips"]);
    var t = React.useContext(I18nContext).t;
    var hasTasks = !!tasks.length;
    var _f = __read$d(React.useState(false), 2), isOpen = _f[0], setIsOpen = _f[1];
    var _g = __read$d(React.useState(hasTasks), 2), showNotification = _g[0], setShowNotification = _g[1];
    var toggleRef = React.useRef(null);
    var taskQueueDropdownRef = React.useRef(null);
    var resizeListener = React.useCallback(function () {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    }, []);
    React.useEffect(function () {
        if (isOpen) {
            window.addEventListener("resize", resizeListener);
        }
        else {
            window.removeEventListener("resize", resizeListener);
        }
    }, [isOpen]);
    var portal = usePortal("sps-task-queue-portal");
    var portalContext = React.useContext(PortalContext);
    var _h = __read$d(isOpen
        ? getPosition(taskQueueDropdownRef, toggleRef, taskQueuePosition, __assign$A({ altPosition: taskQueuePosition }, portalContext))
        : [{}, false], 1), posStyle = _h[0];
    var tooltipPosition = tooltipConfig.position || Position.BOTTOM_RIGHT;
    var tooltipKind = tooltipConfig.kind || TooltipKind.DEFAULT;
    var unreadTasksCount = tasks.filter(function (task) { return task.unread; }).length;
    var inProgressTasksCount = tasks.filter(function (task) { return task.status === SpsTaskStatus.IN_PROGRESS; })
        .length;
    var hasCompletedTask = tasks.some(function (task) { return (task.status === SpsTaskStatus.COMPLETED || task.status === SpsTaskStatus.ERRORED); });
    // this gives us a stable reference to the freshest onClose handler
    var onCloseRef = React.useRef(onClose);
    onCloseRef.current = onClose;
    var handleToggle = function () {
        if (hasTasks && !isOpen) {
            setIsOpen(true);
            if (onOpen) {
                onOpen();
            }
        }
        else if (isOpen) {
            setIsOpen(false);
            if (onClose) {
                onClose();
            }
        }
    };
    var getTaskIcon = function (task) { return (task.status === SpsTaskStatus.IN_PROGRESS
        ? SpsTaskStatusIcons[task.status]
        : "sps-icon sps-icon-" + SpsTaskStatusIcons[task.status]); };
    // handles closing the task queue automatically if there are no more tasks in it
    React.useEffect(function () {
        if (isOpen && !hasTasks) {
            setIsOpen(false);
            if (onCloseRef.current) {
                onCloseRef.current();
            }
        }
    }, [isOpen, hasTasks]);
    // handles showing notifications when new tasks are added to the queue
    var notificationTimeout = React.useRef();
    React.useEffect(function () {
        if (unreadTasksCount > 0) {
            setShowNotification(true);
            if (notificationTimeout.current) {
                window.clearTimeout(notificationTimeout.current);
            }
            notificationTimeout.current = window.setTimeout(function () {
                notificationTimeout.current = undefined;
                setShowNotification(false);
            }, TASK_QUEUE_NOTIFICATION_DURATION_MS);
        }
        else {
            if (notificationTimeout.current) {
                window.clearTimeout(notificationTimeout.current);
                notificationTimeout.current = undefined;
            }
            setShowNotification(false);
        }
    }, [unreadTasksCount]);
    // handles clicks outside of the task queue component
    React.useEffect(function () {
        // handles clicks outside of the task queue
        var documentClickListener = function () {
            setIsOpen(function (currentIsOpen) {
                if (currentIsOpen && onCloseRef.current) {
                    onCloseRef.current();
                }
                return false;
            });
        };
        document.addEventListener("click", documentClickListener);
        return function () {
            document.removeEventListener("click", documentClickListener);
        };
    }, []);
    // handles cleanup
    React.useEffect(function () { return function () {
        if (notificationTimeout.current) {
            window.clearTimeout(notificationTimeout.current);
        }
    }; }, []);
    var containerClassNames = clsx(unsafelyReplaceClassName || "sps-task-queue", isOpen && "sps-task-queue--open", isOpen && "z-stratum-dropdown", !hasTasks && "sps-task-queue--no-tasks", className);
    function renderActionButtons(task) {
        return task.actions.map(function (action) {
            if (React.isValidElement(action)) {
                if (action.type !== SpsButton || action.props.kind !== ButtonKind.ICON) {
                    throw new Error("Task queue task action must be a config object or an SpsButton of kind ICON");
                }
                return action;
            }
            return (React.createElement("div", { key: action.icon, className: "sps-button sps-button--icon" },
                React.createElement("button", { type: "button", title: action.label, disabled: action.disabled, onClick: function () {
                        if (action.onClick) {
                            action.onClick(task);
                        }
                    } },
                    action.caption,
                    action.icon && (React.createElement("i", { className: "sps-icon sps-icon-" + action.icon, "aria-hidden": "true" })))));
        });
    }
    return (React.createElement("div", __assign$A({ className: containerClassNames, onClick: function (e) {
            /*
             * stops click events from propagating outside of the task queue
             * so that it doesn't close itself when clicking inside of it
             */
            e.nativeEvent.stopImmediatePropagation();
        }, "data-testid": testId }, rest),
        React.createElement("button", { type: "button", ref: toggleRef, className: "sps-task-queue__button", title: "Task Queue", onClick: handleToggle },
            !!unreadTasksCount && (React.createElement("span", { className: "sps-tag sps-tag--info" }, unreadTasksCount)),
            inProgressTasksCount ? (React.createElement("span", { className: "sps-spinner sps-spinner--small" })) : (React.createElement("i", { className: "sps-icon sps-icon-list", "aria-hidden": "true" }))),
        React.createElement(SpsTooltip, { for: toggleRef, position: tooltipPosition, kind: tooltipKind, showOn: hasTasks ? TooltipShowTrigger.MANUAL : TooltipShowTrigger.MOUSEOVER, isShown: showNotification && !isOpen
                ? TooltipVisibility.VISIBLE
                : TooltipVisibility.HIDDEN, hideDelay: TASK_QUEUE_NOTIFICATION_DURATION_MS },
            !suppressTooltips && showNotification && (notificationText || t("design-system:taskQueue.newTask")),
            !suppressTooltips && !showNotification && !hasTasks && t("design-system:taskQueue.noTasks")),
        portal(React.createElement("div", { ref: taskQueueDropdownRef, className: clsx("sps-task-queue__task-list", isOpen && "sps-task-queue__task-list--open", "z-stratum-dropdown"), style: posStyle },
            React.createElement("div", { className: "sps-task-queue__task-list-tasks" }, tasks.map(function (task, taskIndex) { return (React.createElement("div", { key: taskIndex, className: clsx("sps-task-queue__task", task.unread && "sps-task-queue__task--unread") },
                React.createElement("i", { className: getTaskIcon(task) }),
                React.createElement("div", { className: "sps-task-queue__task-description" },
                    React.createElement("div", { className: "sps-task-queue__task-heading" }, task.heading),
                    task.subheading && (React.createElement("div", { className: "sps-task-queue__task-subheading", title: task.subheading }, task.subheading))),
                task.actions && !!task.actions.length && (React.createElement("div", { className: "sps-task-queue__task-actions" }, renderActionButtons(task))))); })),
            hasCompletedTask && onClearCompleted && (React.createElement("div", { className: "sps-task-queue__footer" },
                React.createElement("div", { className: "sps-button sps-button--link" },
                    React.createElement("button", { type: "button", onClick: onClearCompleted }, t("design-system:taskQueue.clearCompleted")))))))));
}
Object.assign(SpsTaskQueue, {
    props: props,
    propTypes: propTypes$y,
    displayName: "SpsTaskQueue",
});

var __makeTemplateObject$d = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsTaskQueueExamples = {
    inProgress: {
        label: "Task Queue in progress",
        description: "<p>Info about Task Queue</p>",
        examples: {
            inProgress: {
                react: code(templateObject_1$d || (templateObject_1$d = __makeTemplateObject$d(["\n                function SpsTaskQueueInProgress() {\n                    const [tasks, setTasks] = React.useState([\n                        {\n                            status: SpsTaskStatus.IN_PROGRESS,\n                            unread: false,\n                            heading: \"Downloading 245 transactions\",\n                            subheading: \"processing\u2026\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.X,\n                                    onClick: task => {\n                                        console.log(\"cancel\", task);\n                                    }\n                                }\n                            ]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: false,\n                            heading: \"Document Upload - 02/21/2021\",\n                            subheading: \"Lamps Plus | VY1X_Williams Sonoma Iventory Upload Spreadsheet (846).xls\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.X,\n                                    onClick: task => {\n                                        console.log(\"remove\", task);\n                                    }\n                                }\n                            ]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/21/2019\",\n                            subheading: \"245 transactions | Expires in 2 days\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.SEARCH,\n                                    onClick: task => {\n                                        console.log(\"view\", task);\n                                    }\n                                },\n                                {\n                                    icon: SpsIcon.DOWNLOAD_CLOUD,\n                                    onClick: task => {\n                                        console.log(\"download\", task);\n                                    }\n                                }\n                            ]\n                        },\n                        {\n                            status: SpsTaskStatus.ERRORED,\n                            unread: true,\n                            heading: \"Data XREF Test.xls\",\n                            subheading: \"Failed | Reason it failed\u2026\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.REFRESH,\n                                    onClick: task => {\n                                        console.log(\"retry\", task);\n                                    }\n                                }\n                            ]\n                        }\n                    ]);\n\n                    function handleOpen() {\n                        console.log(\"opened\");\n                    }\n\n                    function handleClose() {\n                        console.log(\"closed (we mark all tasks as read)\");\n                        setTasks(currentTasks => currentTasks.map(task => ({ ...task, unread: false })));\n                    }\n\n                    function handleClearCompleted() {\n                        setTasks(currentTasks =>\n                            currentTasks.filter(task => task.status === SpsTaskStatus.IN_PROGRESS)\n                        );\n                    }\n\n                    return (\n                        <SpsTaskQueue\n                            tasks={tasks}\n                            onOpen={handleOpen}\n                            onClose={handleClose}\n                            onClearCompleted={handleClearCompleted}\n                        />\n                    );\n                }\n                "], ["\n                function SpsTaskQueueInProgress() {\n                    const [tasks, setTasks] = React.useState([\n                        {\n                            status: SpsTaskStatus.IN_PROGRESS,\n                            unread: false,\n                            heading: \"Downloading 245 transactions\",\n                            subheading: \"processing\u2026\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.X,\n                                    onClick: task => {\n                                        console.log(\"cancel\", task);\n                                    }\n                                }\n                            ]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: false,\n                            heading: \"Document Upload - 02/21/2021\",\n                            subheading: \"Lamps Plus | VY1X_Williams Sonoma Iventory Upload Spreadsheet (846).xls\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.X,\n                                    onClick: task => {\n                                        console.log(\"remove\", task);\n                                    }\n                                }\n                            ]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/21/2019\",\n                            subheading: \"245 transactions | Expires in 2 days\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.SEARCH,\n                                    onClick: task => {\n                                        console.log(\"view\", task);\n                                    }\n                                },\n                                {\n                                    icon: SpsIcon.DOWNLOAD_CLOUD,\n                                    onClick: task => {\n                                        console.log(\"download\", task);\n                                    }\n                                }\n                            ]\n                        },\n                        {\n                            status: SpsTaskStatus.ERRORED,\n                            unread: true,\n                            heading: \"Data XREF Test.xls\",\n                            subheading: \"Failed | Reason it failed\u2026\",\n                            actions: [\n                                {\n                                    icon: SpsIcon.REFRESH,\n                                    onClick: task => {\n                                        console.log(\"retry\", task);\n                                    }\n                                }\n                            ]\n                        }\n                    ]);\n\n                    function handleOpen() {\n                        console.log(\"opened\");\n                    }\n\n                    function handleClose() {\n                        console.log(\"closed (we mark all tasks as read)\");\n                        setTasks(currentTasks => currentTasks.map(task => ({ ...task, unread: false })));\n                    }\n\n                    function handleClearCompleted() {\n                        setTasks(currentTasks =>\n                            currentTasks.filter(task => task.status === SpsTaskStatus.IN_PROGRESS)\n                        );\n                    }\n\n                    return (\n                        <SpsTaskQueue\n                            tasks={tasks}\n                            onOpen={handleOpen}\n                            onClose={handleClose}\n                            onClearCompleted={handleClearCompleted}\n                        />\n                    );\n                }\n                "]))),
            },
        },
    },
    noPendingTasks: {
        label: "No Task in progress",
        description: "<p>Info about Task Queue</p>",
        examples: {
            noPendingTasks: {
                react: code(templateObject_2$b || (templateObject_2$b = __makeTemplateObject$d(["\n                function SpsTaskQueueNoTasksInProgress() {\n                    const view = {\n                        icon: SpsIcon.SEARCH,\n                        onClick: task => {\n                            console.log(\"view\", task);\n                        }\n                    };\n\n                    const download = {\n                        icon: SpsIcon.DOWNLOAD_CLOUD,\n                        onClick: task => {\n                            console.log(\"download\", task);\n                        }\n                    };\n\n                    const retry = {\n                        icon: SpsIcon.REFRESH,\n                        onClick: task => {\n                            console.log(\"retry\", task);\n                        }\n                    };\n\n                    const [tasks, setTasks] = React.useState([\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/21/2019\",\n                            subheading: \"245 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.ERRORED,\n                            unread: true,\n                            heading: \"Data XREF Test.xls\",\n                            subheading: \"Failed | Reason it failed\u2026\",\n                            actions: [retry]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/20/2019\",\n                            subheading: \"240 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/20/2019\",\n                            subheading: \"195 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/19/2019\",\n                            subheading: \"225 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/19/2019\",\n                            subheading: \"222 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/19/2019\",\n                            subheading: \"245 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        }\n                    ]);\n\n                    function handleOpen() {\n                        console.log(\"opened\");\n                    }\n\n                    function handleClose() {\n                        console.log(\"closed (we mark all tasks as read)\");\n                        setTasks(currentTasks => currentTasks.map(task => ({ ...task, unread: false })));\n                    }\n\n                    function handleClearCompleted() {\n                        console.log(\"clearing non pending tasks\");\n                        setTasks(currentTasks =>\n                            currentTasks.filter(task => task.status === SpsTaskStatus.IN_PROGRESS)\n                        );\n                    }\n\n                    return (\n                        <SpsTaskQueue\n                            tasks={tasks}\n                            onOpen={handleOpen}\n                            onClose={handleClose}\n                            onClearCompleted={handleClearCompleted}\n                        />\n                    );\n                }\n                "], ["\n                function SpsTaskQueueNoTasksInProgress() {\n                    const view = {\n                        icon: SpsIcon.SEARCH,\n                        onClick: task => {\n                            console.log(\"view\", task);\n                        }\n                    };\n\n                    const download = {\n                        icon: SpsIcon.DOWNLOAD_CLOUD,\n                        onClick: task => {\n                            console.log(\"download\", task);\n                        }\n                    };\n\n                    const retry = {\n                        icon: SpsIcon.REFRESH,\n                        onClick: task => {\n                            console.log(\"retry\", task);\n                        }\n                    };\n\n                    const [tasks, setTasks] = React.useState([\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/21/2019\",\n                            subheading: \"245 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.ERRORED,\n                            unread: true,\n                            heading: \"Data XREF Test.xls\",\n                            subheading: \"Failed | Reason it failed\u2026\",\n                            actions: [retry]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/20/2019\",\n                            subheading: \"240 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/20/2019\",\n                            subheading: \"195 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/19/2019\",\n                            subheading: \"225 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/19/2019\",\n                            subheading: \"222 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        },\n                        {\n                            status: SpsTaskStatus.COMPLETED,\n                            unread: true,\n                            heading: \"Document Download - 02/19/2019\",\n                            subheading: \"245 transactions | Expires in 2 days\",\n                            actions: [view, download]\n                        }\n                    ]);\n\n                    function handleOpen() {\n                        console.log(\"opened\");\n                    }\n\n                    function handleClose() {\n                        console.log(\"closed (we mark all tasks as read)\");\n                        setTasks(currentTasks => currentTasks.map(task => ({ ...task, unread: false })));\n                    }\n\n                    function handleClearCompleted() {\n                        console.log(\"clearing non pending tasks\");\n                        setTasks(currentTasks =>\n                            currentTasks.filter(task => task.status === SpsTaskStatus.IN_PROGRESS)\n                        );\n                    }\n\n                    return (\n                        <SpsTaskQueue\n                            tasks={tasks}\n                            onOpen={handleOpen}\n                            onClose={handleClose}\n                            onClearCompleted={handleClearCompleted}\n                        />\n                    );\n                }\n                "]))),
            },
        },
    },
    noTasks: {
        label: "No Tasks",
        description: "<p>Info about Task Queue</p>",
        examples: {
            noTasks: {
                react: code(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject$d(["\n                    function SpsTaskQueueNoTasks() {\n                        return (\n                            <SpsTaskQueue tasks={[]} />\n                        );\n                    }\n                "], ["\n                    function SpsTaskQueueNoTasks() {\n                        return (\n                            <SpsTaskQueue tasks={[]} />\n                        );\n                    }\n                "]))),
            },
        },
    },
    taskQueueNotifications: {
        label: "Task Queue Notifications",
        description: "<p>Info about Task Queue</p>",
        examples: {
            taskQueueNotifications: {
                react: code(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject$d(["\n                    function SpsTaskQueueNotifications() {\n                        const generateTaskId = React.useMemo(() => {\n                            let i = 2;\n                            return () => String(++i);\n                        }, []);\n\n                        const removeAction = {\n                            icon: SpsIcon.X,\n                            onClick: task => {\n                                setTasks(currentTasks => currentTasks.filter(t => t.id !== task.id));\n                            }\n                        };\n\n                        const [tasks, setTasks] = React.useState([\n                            {\n                                id: \"1\",\n                                status: SpsTaskStatus.COMPLETED,\n                                unread: false,\n                                heading: \"Task 1\",\n                                actions: [removeAction]\n                            },\n                            {\n                                id: \"2\",\n                                status: SpsTaskStatus.ERRORED,\n                                unread: true,\n                                heading: \"Task 2\",\n                                actions: [removeAction]\n                            }\n                        ]);\n\n                        const form = useForm(\n                            formGroup({\n                                blueTooltip: formControl(false)\n                            })\n                        );\n\n                        function handleAddTask() {\n                            const newTaskId = generateTaskId();\n\n                            setTasks(currentTasks => [\n                                ...currentTasks,\n                                {\n                                    id: newTaskId,\n                                    status: SpsTaskStatus.IN_PROGRESS,\n                                    unread: true,\n                                    heading: `Task ${newTaskId}`,\n                                    actions: [removeAction]\n                                }\n                            ]);\n                        }\n\n                        function handleClearCompleted() {\n                            setTasks(currentTasks =>\n                                currentTasks.filter(task => task.status === SpsTaskStatus.IN_PROGRESS)\n                            );\n                        }\n\n                        function handleClose() {\n                            setTasks(currentTasks => currentTasks.map(task => ({ ...task, unread: false })));\n                        }\n\n                        const isTooltipBlue = form.get(\"blueTooltip\").getValue();\n                        const tooltipKind = isTooltipBlue ? TooltipKind.HELP : TooltipKind.DEFAULT;\n                        const notificationText = isTooltipBlue\n                            ? \"There is a new task in your queue. Also the tooltip is blue now :O\"\n                            : undefined;\n\n                        return (\n                            <div style={{ display: \"flex\", justifyContent: \"space-between\" }}>\n                                <div>\n                                    <SpsCheckbox label=\"Blue Tooltip\" formControl={form.get(\"blueTooltip\")} />\n                                    <SpsButton onClick={handleAddTask}>Add a new task to the queue</SpsButton>\n                                </div>\n\n                                <SpsTaskQueue\n                                    tasks={tasks}\n                                    notificationText={notificationText}\n                                    tooltipConfig={{ kind: tooltipKind }}\n                                    onClose={handleClose}\n                                    onClearCompleted={handleClearCompleted}\n                                />\n                            </div>\n                        );\n                    }\n                "], ["\n                    function SpsTaskQueueNotifications() {\n                        const generateTaskId = React.useMemo(() => {\n                            let i = 2;\n                            return () => String(++i);\n                        }, []);\n\n                        const removeAction = {\n                            icon: SpsIcon.X,\n                            onClick: task => {\n                                setTasks(currentTasks => currentTasks.filter(t => t.id !== task.id));\n                            }\n                        };\n\n                        const [tasks, setTasks] = React.useState([\n                            {\n                                id: \"1\",\n                                status: SpsTaskStatus.COMPLETED,\n                                unread: false,\n                                heading: \"Task 1\",\n                                actions: [removeAction]\n                            },\n                            {\n                                id: \"2\",\n                                status: SpsTaskStatus.ERRORED,\n                                unread: true,\n                                heading: \"Task 2\",\n                                actions: [removeAction]\n                            }\n                        ]);\n\n                        const form = useForm(\n                            formGroup({\n                                blueTooltip: formControl(false)\n                            })\n                        );\n\n                        function handleAddTask() {\n                            const newTaskId = generateTaskId();\n\n                            setTasks(currentTasks => [\n                                ...currentTasks,\n                                {\n                                    id: newTaskId,\n                                    status: SpsTaskStatus.IN_PROGRESS,\n                                    unread: true,\n                                    heading: \\`Task \\${newTaskId}\\`,\n                                    actions: [removeAction]\n                                }\n                            ]);\n                        }\n\n                        function handleClearCompleted() {\n                            setTasks(currentTasks =>\n                                currentTasks.filter(task => task.status === SpsTaskStatus.IN_PROGRESS)\n                            );\n                        }\n\n                        function handleClose() {\n                            setTasks(currentTasks => currentTasks.map(task => ({ ...task, unread: false })));\n                        }\n\n                        const isTooltipBlue = form.get(\"blueTooltip\").getValue();\n                        const tooltipKind = isTooltipBlue ? TooltipKind.HELP : TooltipKind.DEFAULT;\n                        const notificationText = isTooltipBlue\n                            ? \"There is a new task in your queue. Also the tooltip is blue now :O\"\n                            : undefined;\n\n                        return (\n                            <div style={{ display: \"flex\", justifyContent: \"space-between\" }}>\n                                <div>\n                                    <SpsCheckbox label=\"Blue Tooltip\" formControl={form.get(\"blueTooltip\")} />\n                                    <SpsButton onClick={handleAddTask}>Add a new task to the queue</SpsButton>\n                                </div>\n\n                                <SpsTaskQueue\n                                    tasks={tasks}\n                                    notificationText={notificationText}\n                                    tooltipConfig={{ kind: tooltipKind }}\n                                    onClose={handleClose}\n                                    onClearCompleted={handleClearCompleted}\n                                />\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$d, templateObject_2$b, templateObject_3$8, templateObject_4$5;

var __assign$z = (undefined && undefined.__assign) || function () {
    __assign$z = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$z.apply(this, arguments);
};
var __rest$s = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$v = {
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<string>",
    icon: "SpsIcon",
    name: "string",
    onChange: "ChangeEventHandler<HTMLInputElement>",
    placeholder: "string",
    value: "string",
};
var propTypes$x = __assign$z(__assign$z({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, formControl: impl(), formMeta: impl(), icon: enumValue(SpsIcon), name: propTypes$1H.exports.string, onChange: fun(), placeholder: propTypes$1H.exports.string, value: propTypes$1H.exports.string });
var SpsTextInput = React.forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, formControl = _a.formControl, formMeta = _a.formMeta, icon = _a.icon, id = _a.id, name = _a.name, onChange = _a.onChange, placeholder = _a.placeholder, testId = _a["data-testid"], title = _a.title, unsafelyReplaceClassName = _a.unsafelyReplaceClassName, _c = _a.value, value = _c === void 0 ? "" : _c, rest = __rest$s(_a, ["className", "disabled", "formControl", "formMeta", "icon", "id", "name", "onChange", "placeholder", "data-testid", "title", "unsafelyReplaceClassName", "value"]);
    var meta = formMeta || formControl;
    var _d = useFormControlId(id, meta), wrapperId = _d.wrapperId, controlId = _d.controlId;
    var textInput = React.useRef();
    function setAndPropagateValue(newValue, event) {
        if (meta) {
            meta.setValue(newValue);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(event || new FauxChangeEvent(textInput.current));
        }
    }
    function clear() {
        textInput.current.value = "";
        setAndPropagateValue("");
    }
    function handleChange(event) {
        setAndPropagateValue(event.target.value, event);
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-text-input", className);
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formControl: formControl, formMeta: formMeta, inputRef: textInput, ref: ref, focusInputOnClick: true, "data-testid": "" + testId },
        React.createElement("div", { className: clsx("sps-form-control", disabled && "disabled") },
            icon && React.createElement("i", { className: clsx("sps-text-input__icon", "sps-icon", "sps-icon-" + icon) }),
            React.createElement("input", __assign$z({ type: "text", ref: textInput, "data-testid": testId + "__input", className: "sps-text-input__input", id: controlId, name: name, placeholder: placeholder, onChange: handleChange, title: title, value: value, disabled: disabled }, rest)),
            value && !disabled && (React.createElement("i", { "data-testid": testId + "__input_clear", className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: clear })))));
});
Object.assign(SpsTextInput, {
    props: propsDoc$v,
    propTypes: propTypes$x,
    displayName: "SpsTextInput",
});

var __makeTemplateObject$c = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsTextInputExamples = {
    standard: {
        label: "Standard",
        description: "info about standard text inputs",
        examples: {
            standard: {
                react: code(templateObject_1$c || (templateObject_1$c = __makeTemplateObject$c(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: \"bar\" });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.foo}>Foo</SpsLabel>\n                            <SpsTextInput\n                                value={formValue.foo}\n                                formMeta={formMeta.fields.foo}\n                            />\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: \"bar\" });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.foo}>Foo</SpsLabel>\n                            <SpsTextInput\n                                value={formValue.foo}\n                                formMeta={formMeta.fields.foo}\n                            />\n                        </>;\n                    }\n                "]))),
            },
        },
    },
    b_placeholder: {
        label: "Placeholder",
        description: "info about text input placeholders",
        examples: {
            placeholder: {
                react: code(templateObject_2$a || (templateObject_2$a = __makeTemplateObject$c(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: \"bar\" });\n\n                        return <>\n                                <SpsLabel for={formMeta.fields.foo}>\n                                    Company Name\n                                </SpsLabel>\n                                <SpsTextInput formMeta={formMeta.fields.foo}\n                                    value={formValue.foo}\n                                    placeholder=\"Enter a company name\"\n                                ></SpsTextInput>\n                            </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: \"bar\" });\n\n                        return <>\n                                <SpsLabel for={formMeta.fields.foo}>\n                                    Company Name\n                                </SpsLabel>\n                                <SpsTextInput formMeta={formMeta.fields.foo}\n                                    value={formValue.foo}\n                                    placeholder=\"Enter a company name\"\n                                ></SpsTextInput>\n                            </>\n                    }\n                "]))),
            },
        },
    },
    c_description: {
        label: "Description",
        description: "info about text inputs with descriptions",
        examples: {
            description: {
                react: code(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject$c(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: \"bar\" });\n\n                        return <>\n                                <SpsLabel for={formMeta.fields.foo}\n                                    value={formValue.foo}\n                                    description=\"This is a brief description of the field to provide additional context.\"\n                                >\n                                    Label\n                                </SpsLabel>\n                                <SpsTextInput formMeta={formMeta.fields.foo}/>\n                            </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ foo: \"bar\" });\n\n                        return <>\n                                <SpsLabel for={formMeta.fields.foo}\n                                    value={formValue.foo}\n                                    description=\"This is a brief description of the field to provide additional context.\"\n                                >\n                                    Label\n                                </SpsLabel>\n                                <SpsTextInput formMeta={formMeta.fields.foo}/>\n                            </>\n                    }\n                "]))),
            },
        },
    },
    d_disabled: {
        label: "Disabled",
        description: "info about disabled text inputs",
        examples: {
            disabled: {
                react: code(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject$c(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ email: \"foo@bar.com\" });\n\n                        return <>\n                                <SpsLabel for={formMeta.fields.email}>\n                                    Email Address\n                                </SpsLabel>\n                                <SpsTextInput id=\"disabledTextInput\" disabled\n                                    value={formValue.email}\n                                    formMeta={formMeta.fields.email}\n                                ></SpsTextInput>\n                            </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({ email: \"foo@bar.com\" });\n\n                        return <>\n                                <SpsLabel for={formMeta.fields.email}>\n                                    Email Address\n                                </SpsLabel>\n                                <SpsTextInput id=\"disabledTextInput\" disabled\n                                    value={formValue.email}\n                                    formMeta={formMeta.fields.email}\n                                ></SpsTextInput>\n                            </>\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$c, templateObject_2$a, templateObject_3$7, templateObject_4$4;

var __assign$y = (undefined && undefined.__assign) || function () {
    __assign$y = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$y.apply(this, arguments);
};
var __rest$r = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$u = {
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<string>",
    name: "string",
    onChange: "ChangeEventHandler",
    placeholder: "string",
    rows: "number",
    value: "string",
};
var propTypes$w = __assign$y(__assign$y({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, formControl: impl(), formMeta: impl(), name: propTypes$1H.exports.string, onChange: fun(), placeholder: propTypes$1H.exports.string, ref: ref(), rows: propTypes$1H.exports.number, value: propTypes$1H.exports.string });
function SpsTextarea(_a) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, formControl = _a.formControl, formMeta = _a.formMeta, id = _a.id, name = _a.name, onChange = _a.onChange, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, ref = _a.ref, _d = _a.rows, rows = _d === void 0 ? 2 : _d, testId = _a["data-testid"], unsafelyReplaceClassName = _a.unsafelyReplaceClassName, _e = _a.value, value = _e === void 0 ? "" : _e, rest = __rest$r(_a, ["className", "disabled", "formControl", "formMeta", "id", "name", "onChange", "placeholder", "ref", "rows", "data-testid", "unsafelyReplaceClassName", "value"]);
    var meta = formMeta || formControl;
    var _f = useFormControlId(id, meta), wrapperId = _f.wrapperId, controlId = _f.controlId;
    var textarea = React.useRef();
    function setAndPropagateValue(newValue, event) {
        if (meta) {
            meta.setValue(newValue);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(event || new FauxChangeEvent(textarea.current));
        }
    }
    function clear() {
        textarea.current.value = "";
        setAndPropagateValue("");
    }
    function handleChange(event) {
        setAndPropagateValue(event.target.value, event);
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-textarea", className);
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formControl: formControl, formMeta: formMeta, inputRef: textarea, ref: ref, "data-testid": testId },
        React.createElement("div", { className: "position-relative" },
            React.createElement("textarea", __assign$y({ ref: textarea, rows: rows, "data-testid": testId + "__input", className: "sps-form-control input--clearable", id: controlId, name: name, placeholder: placeholder, onChange: handleChange, "aria-label": placeholder, value: value || "", disabled: disabled }, rest)),
            value && !disabled && (React.createElement("i", { "data-testid": testId + "__input_clear", className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: clear })))));
}
Object.assign(SpsTextarea, {
    props: propsDoc$u,
    propTypes: propTypes$w,
    displayName: "SpsTextarea",
});

var __makeTemplateObject$b = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsTextareaExamples = {
    basic: {
        label: "Basic",
        description: "info about basic text areas",
        examples: {
            basic: {
                react: code(templateObject_1$b || (templateObject_1$b = __makeTemplateObject$b(["\n                    function DemoComponent() {\n                        function numLinesValidator(n) {\n                            return function(value) {\n                                const lines = typeof value === \"string\" ? value.split(\"\\n\").length : 0;\n                                if (lines !== n) {\n                                    return {\n                                        numLines: {\n                                            actualLines: lines,\n                                            requiredLines: n\n                                        }\n                                    };\n                                }\n                                return null;\n                            };\n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            haiku: \"\"\n                        }, {\n                            \"haiku\": [numLinesValidator(3)]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.haiku}\n                                help=\"A haiku is a three-line poem of 5, 7, and 5 syllables respectively.\"\n                                errors={() =>\n                                    formMeta.fields.haiku.hasError(\"numLines\") && (\n                                        <>\n                                        You need {formMeta.fields.haiku.errors[\"numLines\"].requiredLines} lines,\n                                        but you've only written {formMeta.fields.haiku.errors[\"numLines\"].actualLines} lines!\n                                    </>\n                                )\n                            }>\n                                Haiku\n                            </SpsLabel>\n                            <SpsTextarea placeholder=\"Write a haiku\" rows={3}\n                                formMeta={formMeta.fields.haiku}\n                                value={formValue.haiku}\n                            ></SpsTextarea>\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        function numLinesValidator(n) {\n                            return function(value) {\n                                const lines = typeof value === \"string\" ? value.split(\"\\\\n\").length : 0;\n                                if (lines !== n) {\n                                    return {\n                                        numLines: {\n                                            actualLines: lines,\n                                            requiredLines: n\n                                        }\n                                    };\n                                }\n                                return null;\n                            };\n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            haiku: \"\"\n                        }, {\n                            \"haiku\": [numLinesValidator(3)]\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.haiku}\n                                help=\"A haiku is a three-line poem of 5, 7, and 5 syllables respectively.\"\n                                errors={() =>\n                                    formMeta.fields.haiku.hasError(\"numLines\") && (\n                                        <>\n                                        You need {formMeta.fields.haiku.errors[\"numLines\"].requiredLines} lines,\n                                        but you've only written {formMeta.fields.haiku.errors[\"numLines\"].actualLines} lines!\n                                    </>\n                                )\n                            }>\n                                Haiku\n                            </SpsLabel>\n                            <SpsTextarea placeholder=\"Write a haiku\" rows={3}\n                                formMeta={formMeta.fields.haiku}\n                                value={formValue.haiku}\n                            ></SpsTextarea>\n                        </>\n                    }\n                "]))),
            },
        },
    },
    b_description: {
        label: "Description",
        description: "info about text areas with descriptions",
        examples: {
            description: {
                react: code(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject$b(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            textareaWithDescription: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.textareaWithDescription}\n                                description=\"This is a brief description of the field to provide additional context.\"\n                            >\n                                Label\n                            </SpsLabel>\n                            <SpsTextarea formMeta={formMeta.fields.textareaWithDescription}\n                                value={formValue.textareaWithDescription}\n                            />\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            textareaWithDescription: \"\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.textareaWithDescription}\n                                description=\"This is a brief description of the field to provide additional context.\"\n                            >\n                                Label\n                            </SpsLabel>\n                            <SpsTextarea formMeta={formMeta.fields.textareaWithDescription}\n                                value={formValue.textareaWithDescription}\n                            />\n                        </>\n                    }\n                "]))),
            },
        },
    },
    c_disabled: {
        label: "Disabled",
        description: "info about disabled text areas",
        examples: {
            disabled: {
                react: code(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject$b(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            notes: \"This is the value of the textarea but you can't edit it right now\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.notes}>Notes</SpsLabel>\n                            <SpsTextarea disabled rows={5}\n                                formMeta={formMeta.fields.notes}\n                                value={formValue.notes}\n                            ></SpsTextarea>\n                        </>\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            notes: \"This is the value of the textarea but you can't edit it right now\"\n                        });\n\n                        return <>\n                            <SpsLabel for={formMeta.fields.notes}>Notes</SpsLabel>\n                            <SpsTextarea disabled rows={5}\n                                formMeta={formMeta.fields.notes}\n                                value={formValue.notes}\n                            ></SpsTextarea>\n                        </>\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$b, templateObject_2$9, templateObject_3$6;

var __assign$x = (undefined && undefined.__assign) || function () {
    __assign$x = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$x.apply(this, arguments);
};
var __rest$q = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$t = {
    href: "string",
    icon: { type: "ReactNodeOrRenderFn", required: "true" },
    error: "boolean",
    title: { type: "string", required: "true" },
    warning: "boolean",
};
var propTypes$v = __assign$x(__assign$x({}, spsGlobalPropTypes), { href: propTypes$1H.exports.string, target: propTypes$1H.exports.string, icon: nodeOrRenderFn.isRequired, error: propTypes$1H.exports.bool, title: propTypes$1H.exports.string.isRequired, warning: propTypes$1H.exports.bool });
function SpsTile(props) {
    var className = props.className, href = props.href, target = props.target, icon = props.icon, _a = props.error, error = _a === void 0 ? false : _a, title = props.title, unsafelyReplaceClassName = props.unsafelyReplaceClassName, _b = props.warning, warning = _b === void 0 ? false : _b, rest = __rest$q(props, ["className", "href", "target", "icon", "error", "title", "unsafelyReplaceClassName", "warning"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-tile", className, error && "sps-tile--error", warning && "sps-tile--warning");
    React.useEffect(function () {
        if (warning && error) {
            throw new Error("Tile should have warning or error, not both");
        }
    }, [warning, error]);
    return (React.createElement("div", { className: "sps-tile-container sfg-col-3 sfg-break-col-6" },
        React.createElement("a", __assign$x({ className: classes, href: href, target: target, rel: target === "_blank" ? "noopener noreferrer" : undefined }, rest),
            (warning || error) && (React.createElement("div", { className: "sps-tile--icon" },
                warning && React.createElement("i", { className: clsx("sps-icon", "sps-icon-status-warning") }),
                error && React.createElement("i", { className: clsx("sps-icon", "sps-icon-ban") }))),
            React.createElement("div", { className: "sps-tile--content" },
                React.createElement("div", { className: "sps-tile--image" }, typeof icon === "string" ? (React.createElement("img", { className: "sps-tile--image", src: icon, alt: "" })) : contentOf(icon)),
                React.createElement("div", { className: "sps-tile--title" },
                    React.createElement("p", null,
                        title,
                        target === "_blank" && (React.createElement("i", { className: clsx("sps-icon", "sps-icon-tabs") }))))))));
}
Object.assign(SpsTile, {
    props: propsDoc$t,
    propTypes: propTypes$v,
    displayName: "SpsTile",
});

var __assign$w = (undefined && undefined.__assign) || function () {
    __assign$w = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$w.apply(this, arguments);
};
var __rest$p = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$s = {};
var propTypes$u = __assign$w({}, spsGlobalPropTypes);
function SpsTileList(props) {
    var children = props.children, unsafelyReplaceClassName = props.unsafelyReplaceClassName; props["data-testid"]; var className = props.className, rest = __rest$p(props, ["children", "unsafelyReplaceClassName", "data-testid", "className"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-tile-list", className || "sfg-row");
    return (React.createElement("div", __assign$w({ className: classes }, rest), children));
}
Object.assign(SpsTileList, {
    props: propsDoc$s,
    propTypes: propTypes$u,
    displayName: "SpsTileList",
});

var __makeTemplateObject$a = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsTileListExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$a || (templateObject_1$a = __makeTemplateObject$a(["\n                    function Component() {\n                        const apps = [\n                            {\n                                name: \"App Manager\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/generic/generic.svg\",\n                            },\n                            {\n                                name: \"Assortment\",\n                                warning: false,\n                                error: false,\n                                href: \"https://www.google.com\",\n                                target: \"_blank\",\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/barcode/barcode.svg\",\n                            },\n                            {\n                                name: \"Community\",\n                                warning: false,\n                                error: false,\n                                onClick: () => console.log(\"Community\"),\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/community/community.svg\",\n                            },\n                            {\n                                name: \"Design System\",\n                                warning: false,\n                                error: true,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/design-system/design-system.svg\",\n                            },\n                            {\n                                name: \"Nexus\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/nexus/nexus.svg\",\n                            },\n                            {\n                                name: \"Testing & Certification\",\n                                warning: true,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/checkmark/checkmark.svg\",\n                            },\n                        ];\n\n                        return (\n                            <>\n                                <SpsTileList>\n                                    {apps.map((app, index) => {\n                                        return (\n                                            <SpsTile\n                                                key={index}\n                                                title={app.name}\n                                                warning={app.warning}\n                                                error={app.error}\n                                                href={app.href}\n                                                target={app.target}\n                                                icon={app.icon}\n                                                onClick={app.onClick}\n                                            />\n                                        )\n                                    })}\n                                </SpsTileList>\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const apps = [\n                            {\n                                name: \"App Manager\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/generic/generic.svg\",\n                            },\n                            {\n                                name: \"Assortment\",\n                                warning: false,\n                                error: false,\n                                href: \"https://www.google.com\",\n                                target: \"_blank\",\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/barcode/barcode.svg\",\n                            },\n                            {\n                                name: \"Community\",\n                                warning: false,\n                                error: false,\n                                onClick: () => console.log(\"Community\"),\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/community/community.svg\",\n                            },\n                            {\n                                name: \"Design System\",\n                                warning: false,\n                                error: true,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/design-system/design-system.svg\",\n                            },\n                            {\n                                name: \"Nexus\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/nexus/nexus.svg\",\n                            },\n                            {\n                                name: \"Testing & Certification\",\n                                warning: true,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/checkmark/checkmark.svg\",\n                            },\n                        ];\n\n                        return (\n                            <>\n                                <SpsTileList>\n                                    {apps.map((app, index) => {\n                                        return (\n                                            <SpsTile\n                                                key={index}\n                                                title={app.name}\n                                                warning={app.warning}\n                                                error={app.error}\n                                                href={app.href}\n                                                target={app.target}\n                                                icon={app.icon}\n                                                onClick={app.onClick}\n                                            />\n                                        )\n                                    })}\n                                </SpsTileList>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
    singleTile: {
        label: "Single Tile",
        examples: {
            singleTile: {
                react: code(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject$a(["\n                function Component() {\n                    return (\n                        <>\n                            <SpsTileList>\n                                <SpsTile\n                                    title=\"Design System\"\n                                    icon={\"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/design-system/design-system.svg\"}\n                                    onClick={() => console.log(\"Go to Design System\")}\n                                />\n                            </SpsTileList>\n                        </>\n                    )\n                }\n            "], ["\n                function Component() {\n                    return (\n                        <>\n                            <SpsTileList>\n                                <SpsTile\n                                    title=\"Design System\"\n                                    icon={\"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/design-system/design-system.svg\"}\n                                    onClick={() => console.log(\"Go to Design System\")}\n                                />\n                            </SpsTileList>\n                        </>\n                    )\n                }\n            "]))),
            },
            tooltips: {
                react: code(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject$a(["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsTileList>\n                                    <SpsTile\n                                        title=\"Assortment\"\n                                        icon={\"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/barcode/barcode.svg\"}\n                                        error\n                                        id=\"error-app\"\n                                    />\n                                </SpsTileList>\n                                <SpsTooltip for=\"error-app\" title=\"Error\">\n                                    Your application has been suspended\n                                </SpsTooltip>\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsTileList>\n                                    <SpsTile\n                                        title=\"Assortment\"\n                                        icon={\"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/barcode/barcode.svg\"}\n                                        error\n                                        id=\"error-app\"\n                                    />\n                                </SpsTileList>\n                                <SpsTooltip for=\"error-app\" title=\"Error\">\n                                    Your application has been suspended\n                                </SpsTooltip>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
    sortableTiles: {
        label: "Sortable Tiles",
        examples: {
            basic: {
                react: code(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject$a(["\n                    function Component() {\n                        const [sort, setSort] = React.useState([{ key: 'name', direction: SortDirection.ASCENDING }]);\n\n                        const apps = React.useMemo(() => [\n                            {\n                                name: \"App Manager\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/generic/generic.svg\",\n                            },\n                            {\n                                name: \"Assortment\",\n                                warning: false,\n                                error: false,\n                                href: \"https://www.google.com\",\n                                target: \"_blank\",\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/barcode/barcode.svg\",\n                            },\n                            {\n                                name: \"Community\",\n                                warning: false,\n                                error: false,\n                                onClick: () => console.log(\"Community\"),\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/community/community.svg\",\n                            },\n                            {\n                                name: \"Design System\",\n                                warning: false,\n                                error: true,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/design-system/design-system.svg\",\n                            },\n                            {\n                                name: \"Nexus\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/nexus/nexus.svg\",\n                            },\n                            {\n                                name: \"Testing & Certification\",\n                                warning: true,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/checkmark/checkmark.svg\",\n                            },\n                        ].sort((a, b) => {\n                            if (!sort.length) {\n                                return 0;\n                            }\n\n                            const [{ key, direction }] = sort;\n\n                            // straightforward sort by name\n                            if (key === 'name') {\n                                if (a.name < b.name) {\n                                    return direction === SortDirection.ASCENDING ? -1 : 1;\n                                } else if (a.name > b.name) {\n                                    return direction === SortDirection.ASCENDING ? 1 : -1;\n                                }\n                            }\n                            \n                            // custom sort by status\n                            if (key === 'status') {\n                                if (a.error + a.warning < b.error + b.warning) {\n                                    return direction === SortDirection.ASCENDING ? -1 : 1;\n                                } else if (a.error + a.warning > b.error + b.warning) {\n                                    return direction === SortDirection.ASCENDING ? 1 : -1;\n                                }\n                            }\n\n                            return 0;\n                        }), [sort]);\n\n                        return (\n                            <>\n                                <SpsSortingHeader sort={sort} onSortChange={setSort} className=\"mb-2\">\n                                    <SpsSortingHeaderCell sortKey=\"name\">\n                                        Name\n                                    </SpsSortingHeaderCell>\n                                    <SpsSortingHeaderCell sortKey=\"status\">\n                                        Status\n                                    </SpsSortingHeaderCell>\n                                </SpsSortingHeader>\n\n                                <SpsTileList>\n                                    {apps.map((app, index) => {\n                                        return (\n                                            <SpsTile\n                                                key={index}\n                                                title={app.name}\n                                                warning={app.warning}\n                                                error={app.error}\n                                                href={app.href}\n                                                target={app.target}\n                                                icon={app.icon}\n                                                onClick={app.onClick}\n                                            />\n                                        )\n                                    })}\n                                </SpsTileList>\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const [sort, setSort] = React.useState([{ key: 'name', direction: SortDirection.ASCENDING }]);\n\n                        const apps = React.useMemo(() => [\n                            {\n                                name: \"App Manager\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/generic/generic.svg\",\n                            },\n                            {\n                                name: \"Assortment\",\n                                warning: false,\n                                error: false,\n                                href: \"https://www.google.com\",\n                                target: \"_blank\",\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/barcode/barcode.svg\",\n                            },\n                            {\n                                name: \"Community\",\n                                warning: false,\n                                error: false,\n                                onClick: () => console.log(\"Community\"),\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/community/community.svg\",\n                            },\n                            {\n                                name: \"Design System\",\n                                warning: false,\n                                error: true,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/design-system/design-system.svg\",\n                            },\n                            {\n                                name: \"Nexus\",\n                                warning: false,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/nexus/nexus.svg\",\n                            },\n                            {\n                                name: \"Testing & Certification\",\n                                warning: true,\n                                error: false,\n                                icon: \"https://cdn.dev.spsc.io/web/framework/assets/21.05.01/icons/checkmark/checkmark.svg\",\n                            },\n                        ].sort((a, b) => {\n                            if (!sort.length) {\n                                return 0;\n                            }\n\n                            const [{ key, direction }] = sort;\n\n                            // straightforward sort by name\n                            if (key === 'name') {\n                                if (a.name < b.name) {\n                                    return direction === SortDirection.ASCENDING ? -1 : 1;\n                                } else if (a.name > b.name) {\n                                    return direction === SortDirection.ASCENDING ? 1 : -1;\n                                }\n                            }\n                            \n                            // custom sort by status\n                            if (key === 'status') {\n                                if (a.error + a.warning < b.error + b.warning) {\n                                    return direction === SortDirection.ASCENDING ? -1 : 1;\n                                } else if (a.error + a.warning > b.error + b.warning) {\n                                    return direction === SortDirection.ASCENDING ? 1 : -1;\n                                }\n                            }\n\n                            return 0;\n                        }), [sort]);\n\n                        return (\n                            <>\n                                <SpsSortingHeader sort={sort} onSortChange={setSort} className=\"mb-2\">\n                                    <SpsSortingHeaderCell sortKey=\"name\">\n                                        Name\n                                    </SpsSortingHeaderCell>\n                                    <SpsSortingHeaderCell sortKey=\"status\">\n                                        Status\n                                    </SpsSortingHeaderCell>\n                                </SpsSortingHeader>\n\n                                <SpsTileList>\n                                    {apps.map((app, index) => {\n                                        return (\n                                            <SpsTile\n                                                key={index}\n                                                title={app.name}\n                                                warning={app.warning}\n                                                error={app.error}\n                                                href={app.href}\n                                                target={app.target}\n                                                icon={app.icon}\n                                                onClick={app.onClick}\n                                            />\n                                        )\n                                    })}\n                                </SpsTileList>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$a, templateObject_2$8, templateObject_3$5, templateObject_4$3;

var __assign$v = (undefined && undefined.__assign) || function () {
    __assign$v = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$v.apply(this, arguments);
};
var __rest$o = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$c = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$r = {
    value: { type: "number", required: "true" },
    title: { type: "string", required: "true" },
    kind: "SpsFilterTileKind",
    active: "boolean",
};
var propTypes$t = __assign$v(__assign$v({}, spsGlobalPropTypes), { value: propTypes$1H.exports.number.isRequired, title: propTypes$1H.exports.string.isRequired, kind: enumValue(SpsFilterTileKind), active: propTypes$1H.exports.bool });
function SpsFilterTile(props) {
    var value = props.value, title = props.title, _a = props.kind, kind = _a === void 0 ? SpsFilterTileKind.GENERAL : _a, isActiveProp = props.active, className = props.className, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$o(props, ["value", "title", "kind", "active", "className", "unsafelyReplaceClassName"]);
    var _b = __read$c(React.useState(false), 2), isHovered = _b[0], setIsHovered = _b[1];
    var isActive = isActiveProp || isHovered;
    var classes = clsx(unsafelyReplaceClassName || "sps-filter-tile", className, "sps-filter-tile--" + kind, isActive && "active");
    return (React.createElement("div", __assign$v({ className: classes }, rest),
        React.createElement("div", { className: "sps-filter-tile__body", onMouseOver: function () { return setIsHovered(true); }, onMouseOut: function () { return setIsHovered(false); } },
            React.createElement("div", { className: "sps-filter-tile__body__value" }, value),
            React.createElement("div", { className: "sps-filter-tile__body__title" }, title)),
        React.createElement("div", { className: "sps-filter-tile__footer" })));
}
Object.assign(SpsFilterTile, {
    props: propsDoc$r,
    propTypes: propTypes$t,
    displayName: "SpsFilterTile",
});

var __assign$u = (undefined && undefined.__assign) || function () {
    __assign$u = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$u.apply(this, arguments);
};
var __rest$n = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$q = {};
var propTypes$s = __assign$u({}, spsGlobalPropTypes);
function SpsFilterTileList(props) {
    var children = props.children, unsafelyReplaceClassName = props.unsafelyReplaceClassName; props["data-testid"]; var className = props.className, rest = __rest$n(props, ["children", "unsafelyReplaceClassName", "data-testid", "className"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-filter-tile-list", className);
    return (React.createElement("div", __assign$u({ className: classes }, rest), children));
}
Object.assign(SpsFilterTileList, {
    props: propsDoc$q,
    propTypes: propTypes$s,
    displayName: "SpsFilterTileList",
});

var __makeTemplateObject$9 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsFilterTileListExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject$9(["\n                    function Component() {\n                        const data = [\n                            {\n                                value: 5,\n                                title: '1+ Week Overdue',\n                            },\n                            {\n                                value: 34,\n                                title: 'Uncommitted - SPS Outreach Expiring',\n                                kind: SpsFilterTileKind.GENERAL\n                            },\n                            {\n                                value: 523,\n                                title: 'Buying Org Review',\n                                kind: SpsFilterTileKind.WARNING\n                            },\n                            {\n                                value: 7128,\n                                title: 'Buying Org to Send Email',\n                                kind: SpsFilterTileKind.ERROR\n                            },\n                            {\n                                value: 19235,\n                                title: 'Production Ready',\n                                kind: SpsFilterTileKind.PROCESSING\n                            },\n                        ];\n\n                        const [activeTile, setActiveTile] = React.useState(null);\n\n                        return (\n                            <>\n                                <SpsFilterTileList>\n                                    {data.map((item, index) => {\n                                        return (\n                                            <SpsFilterTile\n                                                key={index}\n                                                value={item.value}\n                                                title={item.title}\n                                                kind={item.kind}\n                                                active={index === activeTile}\n                                                onClick={() => setActiveTile(index)}\n                                            />\n                                        )\n                                    })}\n                                </SpsFilterTileList>\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        const data = [\n                            {\n                                value: 5,\n                                title: '1+ Week Overdue',\n                            },\n                            {\n                                value: 34,\n                                title: 'Uncommitted - SPS Outreach Expiring',\n                                kind: SpsFilterTileKind.GENERAL\n                            },\n                            {\n                                value: 523,\n                                title: 'Buying Org Review',\n                                kind: SpsFilterTileKind.WARNING\n                            },\n                            {\n                                value: 7128,\n                                title: 'Buying Org to Send Email',\n                                kind: SpsFilterTileKind.ERROR\n                            },\n                            {\n                                value: 19235,\n                                title: 'Production Ready',\n                                kind: SpsFilterTileKind.PROCESSING\n                            },\n                        ];\n\n                        const [activeTile, setActiveTile] = React.useState(null);\n\n                        return (\n                            <>\n                                <SpsFilterTileList>\n                                    {data.map((item, index) => {\n                                        return (\n                                            <SpsFilterTile\n                                                key={index}\n                                                value={item.value}\n                                                title={item.title}\n                                                kind={item.kind}\n                                                active={index === activeTile}\n                                                onClick={() => setActiveTile(index)}\n                                            />\n                                        )\n                                    })}\n                                </SpsFilterTileList>\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$9;

var __assign$t = (undefined && undefined.__assign) || function () {
    __assign$t = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$t.apply(this, arguments);
};
var __rest$m = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$b = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$p = {
    active: "boolean",
    activeDescription: { type: "string", deprecated: true },
    activeLabel: { type: "string", deprecated: true },
    description: "string",
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<boolean>",
    inactiveDescription: { type: "string", deprecated: true },
    inactiveLabel: { type: "string", deprecated: true },
    label: "string",
    large: "boolean",
    onChange: "(isActive: boolean) => void",
};
var propTypes$r = __assign$t(__assign$t({}, spsGlobalPropTypes), { active: propTypes$1H.exports.bool, activeDescription: deprecated(propTypes$1H.exports.string), activeLabel: deprecated(propTypes$1H.exports.string), description: propTypes$1H.exports.string, disabled: propTypes$1H.exports.bool, formControl: impl(), formMeta: impl(), id: propTypes$1H.exports.string, inactiveDescription: deprecated(propTypes$1H.exports.string), inactiveLabel: deprecated(propTypes$1H.exports.string), label: propTypes$1H.exports.string, large: propTypes$1H.exports.bool, onChange: fun(), ref: ref() });
function SpsToggle(props) {
    var activeProp = props.active, activeDescription = props.activeDescription, activeLabel = props.activeLabel, className = props.className, _a = props.description, description = _a === void 0 ? activeDescription : _a, disabled = props.disabled, formControl = props.formControl, formMeta = props.formMeta, id = props.id; props.inactiveDescription; props.inactiveLabel; var _b = props.label, label = _b === void 0 ? activeLabel : _b, large = props.large, onChange = props.onChange, ref = props.ref, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$m(props, ["active", "activeDescription", "activeLabel", "className", "description", "disabled", "formControl", "formMeta", "id", "inactiveDescription", "inactiveLabel", "label", "large", "onChange", "ref", "data-testid", "unsafelyReplaceClassName"]);
    useCheckDeprecatedProps("SpsToggle", propsDoc$p, props);
    var meta = formMeta || formControl;
    var _c = __read$b(React.useState(activeProp), 2), active = _c[0], setActive = _c[1];
    var _d = useFormControlId(id, meta), wrapperId = _d.wrapperId, controlId = _d.controlId;
    var statusLabelID = wrapperId + "_status-label";
    var descriptionID = wrapperId + "_description";
    var inputElement = React.useRef();
    React.useEffect(function () { return setActive(activeProp); }, [activeProp]);
    function handleChange(event) {
        setActive(event.target.checked);
        if (meta) {
            meta.setValue(event.target.checked);
            meta.markAsDirty();
        }
        if (onChange) {
            onChange(event.target.checked);
        }
        inputElement.current.focus();
    }
    var classes = clsx(unsafelyReplaceClassName || "sps-toggle", active && "sps-toggle--active", large && "sps-toggle--large", disabled && "sps-toggle--disabled", className);
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, formControl: formControl, formMeta: formMeta, inputRef: inputElement, ref: ref, "data-testid": "" + testId },
        React.createElement("div", { className: classes },
            React.createElement("input", __assign$t({ type: "checkbox", ref: inputElement, className: "sps-toggle__input", id: controlId, checked: active || false, disabled: disabled, onChange: handleChange, "aria-describedby": statusLabelID + "," + descriptionID, "data-testid": testId + "__input" }, rest)),
            React.createElement("span", { className: "sps-toggle__slider" }),
            label
                && (React.createElement("label", { className: "sps-toggle__status-label", htmlFor: controlId, id: statusLabelID }, label)),
            description
                && (React.createElement("span", { className: "sps-toggle__description", id: descriptionID }, description)))));
}
Object.assign(SpsToggle, {
    props: propsDoc$p,
    propTypes: propTypes$r,
    displayName: "SpsToggle",
});

var __makeTemplateObject$8 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsToggleExamples = {
    small: {
        label: "Small",
        examples: {
            a_small: {
                react: code(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject$8(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            toggle: false\n                        });\n\n                        return <SpsToggle formMeta={formMeta.fields.toggle}\n                            active={formValue.toggle}\n                            label=\"Main Label\"\n                            description=\"Extra descriptive text\"\n                        />;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            toggle: false\n                        });\n\n                        return <SpsToggle formMeta={formMeta.fields.toggle}\n                            active={formValue.toggle}\n                            label=\"Main Label\"\n                            description=\"Extra descriptive text\"\n                        />;\n                    }\n                "]))),
            },
            b_changeHandler: {
                description: "With UseState",
                react: code(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject$8(["\n                    function DemoComponent() {\n                        function changeHandler() {\n                            setActive(!checked);\n                        }\n                        const [active, setActive] = React.useState();\n                        return (\n                            <SpsToggle active={active} onChange={changeHandler}/>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        function changeHandler() {\n                            setActive(!checked);\n                        }\n                        const [active, setActive] = React.useState();\n                        return (\n                            <SpsToggle active={active} onChange={changeHandler}/>\n                        )\n                    }\n                "]))),
            },
        },
    },
    b_large: {
        label: "Large",
        examples: {
            a_large: {
                react: code(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject$8(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            toggle: true\n                        });\n\n                        return <SpsToggle large formMeta={formMeta.fields.toggle}\n                            active={formValue.toggle}\n                        />;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            toggle: true\n                        });\n\n                        return <SpsToggle large formMeta={formMeta.fields.toggle}\n                            active={formValue.toggle}\n                        />;\n                    }\n                "]))),
            },
        },
    },
    d_disabled: {
        label: "Disabled",
        examples: {
            disabled: {
                react: code(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject$8(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            toggleA: false,\n                            toggleB: true,\n                        });\n\n                        return <>\n                            <SpsToggle formMeta={formMeta.fields.toggleA}\n                                active={formValue.toggleA}\n                                label=\"Main Label\"\n                                description=\"Extra descriptive text\"\n                                disabled\n                            />\n                            <SpsToggle formMeta={formMeta.fields.toggleB}\n                                active={formValue.toggleB}\n                                label=\"Main Label\"\n                                description=\"Extra descriptive text\"\n                                disabled\n                            />\n                        </>;\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                            toggleA: false,\n                            toggleB: true,\n                        });\n\n                        return <>\n                            <SpsToggle formMeta={formMeta.fields.toggleA}\n                                active={formValue.toggleA}\n                                label=\"Main Label\"\n                                description=\"Extra descriptive text\"\n                                disabled\n                            />\n                            <SpsToggle formMeta={formMeta.fields.toggleB}\n                                active={formValue.toggleB}\n                                label=\"Main Label\"\n                                description=\"Extra descriptive text\"\n                                disabled\n                            />\n                        </>;\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$8, templateObject_2$7, templateObject_3$4, templateObject_4$2;

var __assign$s = (undefined && undefined.__assign) || function () {
    __assign$s = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$s.apply(this, arguments);
};
var __rest$l = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$o = {
    heading: "string",
    icon: "SpsIcon",
};
var propTypes$q = __assign$s(__assign$s({}, spsGlobalPropTypes), { heading: propTypes$1H.exports.string, icon: enumValue(SpsIcon) });
function SpsWorkflow(props) {
    var children = props.children, className = props.className, icon = props.icon, title = props.title, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$l(props, ["children", "className", "icon", "title", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-workflow", className);
    return (React.createElement("div", __assign$s({ className: classes, "data-testid": "" + testId }, rest),
        title
            && (React.createElement("h1", { className: "sps-workflow__heading", "data-testid": testId + "__title" },
                React.createElement("span", { className: "sps-workflow__icon", "data-testid": testId + "__icon" },
                    React.createElement("i", { "aria-hidden": "true", className: clsx("sps-icon", "sps-icon-" + icon) })),
                title)),
        children));
}
Object.assign(SpsWorkflow, {
    props: propsDoc$o,
    propTypes: propTypes$q,
    displayName: "SpsWorkflow",
});
function SpsWf(props) {
    return React.createElement(SpsWorkflow, __assign$s({}, props));
}
Object.assign(SpsWf, {
    props: propsDoc$o,
    propTypes: propTypes$q,
    displayName: "SpsWf",
});

var __assign$r = (undefined && undefined.__assign) || function () {
    __assign$r = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$r.apply(this, arguments);
};
var propsDoc$n = {
    size: "RingSize",
    progress: "number",
};
var propTypes$p = __assign$r(__assign$r({}, spsGlobalPropTypes), { progress: propTypes$1H.exports.number, size: enumValue(RingSize) });
function SpsProgressRing(_a) {
    var _b = _a.size, size = _b === void 0 ? RingSize.SMALL : _b, _c = _a.progress, progress = _c === void 0 ? 0 : _c;
    var stroke = 4;
    var normalizedRadius = size - stroke;
    var circumference = normalizedRadius * 2 * Math.PI;
    var strokeDashoffset = circumference - ((progress / 100) * circumference);
    return (React.createElement("div", { className: "sps-progress-ring" },
        React.createElement("svg", { height: size * 2, width: size * 2, style: { transform: "rotate(-90deg)" } },
            React.createElement("circle", { stroke: colors.gray300, fill: "transparent", strokeWidth: stroke, strokeDasharray: circumference + " " + circumference, r: normalizedRadius, cx: size, cy: size }),
            React.createElement("circle", { stroke: colors.purple200, fill: "transparent", strokeWidth: stroke, strokeDasharray: circumference + " " + circumference, style: { strokeDashoffset: strokeDashoffset }, r: normalizedRadius, cx: size, cy: size }))));
}
Object.assign(SpsProgressRing, {
    props: propsDoc$n,
    propTypes: propTypes$p,
    displayName: "SpsProgressRing",
});

var __assign$q = (undefined && undefined.__assign) || function () {
    __assign$q = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$q.apply(this, arguments);
};
var propsDoc$m = {
    phases: "WizardPhase[]",
};
var propTypes$o = __assign$q(__assign$q({}, spsGlobalPropTypes), { phases: propTypes$1H.exports.arrayOf(impl()) });
var CSS_BLOCK$2 = "sps-wizard-sidebar";
function SpsWizardSidebar(_a) {
    var className = _a.className, phases = _a.phases;
    var classes = clsx(CSS_BLOCK$2, className);
    return (React.createElement("div", { className: classes }, phases.map(function (phase) {
        var titleClasses = clsx(CSS_BLOCK$2 + "__phase-title", phase.disabled && CSS_BLOCK$2 + "__phase-title--disabled");
        return (React.createElement("div", { className: CSS_BLOCK$2 + "__phase-wrapper", key: phase.title },
            React.createElement("div", { className: titleClasses }, phase.title),
            phase.steps.map(function (step) {
                var stepClasses = clsx(CSS_BLOCK$2 + "__step", step.active && CSS_BLOCK$2 + "__step--active", step.disabled && CSS_BLOCK$2 + "__step--disabled", !!step.onClick && !step.disabled && CSS_BLOCK$2 + "__step--clickable");
                return (React.createElement("div", { className: stepClasses, key: step.title, onClick: !step.disabled && step.onClick },
                    React.createElement("div", { className: CSS_BLOCK$2 + "__step-progress" }, step.percentComplete === 100 ? (React.createElement("div", { className: CSS_BLOCK$2 + "__step-complete" },
                        React.createElement(SpsI, { icon: SpsIcon.CHECKMARK }))) : (React.createElement(SpsProgressRing, { size: RingSize.SMALL, progress: step.percentComplete }))),
                    React.createElement("div", { className: CSS_BLOCK$2 + "__step-title", role: "button" }, step.title)));
            })));
    })));
}
Object.assign(SpsWizardSidebar, {
    props: propsDoc$m,
    propTypes: propTypes$o,
    displayName: "SpsWizardSidebar",
});

var __assign$p = (undefined && undefined.__assign) || function () {
    __assign$p = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$p.apply(this, arguments);
};
var propsDoc$l = {
    display: "string",
    condition: "WizardSubstepConditions",
    orderPosition: "string | number",
};
var propTypes$n = __assign$p(__assign$p({}, spsGlobalPropTypes), { condition: enumValue(WizardSubstepConditions).isRequired, display: propTypes$1H.exports.string.isRequired, orderPosition: propTypes$1H.exports.oneOfType([
        propTypes$1H.exports.string, propTypes$1H.exports.number,
    ]).isRequired });
function SpsWizardSubstep(props) {
    var _a = props.condition, condition = _a === void 0 ? WizardSubstepConditions.BASIC : _a, orderPosition = props.orderPosition, display = props.display, children = props.children;
    return (React.createElement("div", { className: "sps-wizard-substep" },
        React.createElement("div", { className: clsx("sps-wizard-substep__heading", "sps-wizard-substep__heading--" + condition) },
            React.createElement("div", { className: "sps-wizard-substep__heading-icon" }, condition === WizardSubstepConditions.COMPLETED ? (React.createElement("i", { "aria-hidden": "true", className: "sps-icon sps-icon-checkmark" })) : (orderPosition)),
            React.createElement("p", null, display)),
        React.createElement("div", { className: clsx("sps-wizard-substep__body", "sps-wizard-substep__body--" + condition) }, children)));
}
Object.assign(SpsWizardSubstep, {
    props: propsDoc$l,
    propTypes: propTypes$n,
    displayName: "SpsWizardSubstep",
});

var __makeTemplateObject$7 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsWizardExamples = {
    substep: {
        label: "Substep",
        examples: {
            completed: {
                jsx: code(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject$7(["\n                    <SpsWizardSubstep condition={WizardSubstepConditions.COMPLETED} orderPosition=\"1\" display=\"Payment Options\">\n                      <div>Put a Route here</div>\n                    </SpsWizardSubstep>\n            "], ["\n                    <SpsWizardSubstep condition={WizardSubstepConditions.COMPLETED} orderPosition=\"1\" display=\"Payment Options\">\n                      <div>Put a Route here</div>\n                    </SpsWizardSubstep>\n            "]))),
            },
            active: {
                jsx: code(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject$7(["\n                      <SpsWizardSubstep condition={WizardSubstepConditions.ACTIVE} orderPosition=\"2\" display=\"Payment Options\">\n                        <div>Put a Route here</div>\n                      </SpsWizardSubstep>\n              "], ["\n                      <SpsWizardSubstep condition={WizardSubstepConditions.ACTIVE} orderPosition=\"2\" display=\"Payment Options\">\n                        <div>Put a Route here</div>\n                      </SpsWizardSubstep>\n              "]))),
            },
            basic: {
                jsx: code(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject$7(["\n                <SpsWizardSubstep condition={WizardSubstepConditions.BASIC} orderPosition=\"3\" display=\"Payment Options\">\n                  <div>This is visibility: hidden. You can leave your route here</div>\n                </SpsWizardSubstep>\n                "], ["\n                <SpsWizardSubstep condition={WizardSubstepConditions.BASIC} orderPosition=\"3\" display=\"Payment Options\">\n                  <div>This is visibility: hidden. You can leave your route here</div>\n                </SpsWizardSubstep>\n                "]))),
            },
        },
    },
    sidebar: {
        label: "Sidebar",
        examples: {
            basic: {
                react: code(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject$7(["\n        function Component() {\n          const phaseArray = [\n            {\n              title: \"Plan & Payment\",\n              disabled: false,\n              steps: [\n                {\n                  title: \"Choose a Plan\",\n                  percentComplete: 100,\n                  active: false,\n                  disabled: false,\n                  onClick() {\n                    alert(\"Step clicked\");\n                  }\n                },\n                {\n                  title: \"Payment & Billing\",\n                  percentComplete: 33,\n                  active: true,\n                  disabled: false\n                },\n                {\n                  title: \"Confirm Payment\",\n                  percentComplete: 0,\n                  active: false,\n                  disabled: false\n                }\n              ]\n            },\n            {\n              title: \"Implementation details\",\n              disabled: true,\n              steps: [\n                {\n                  title: \"Implementation details\",\n                  percentComplete: 0,\n                  active: false,\n                  disabled: true\n                }, {\n                  title: \"Choose a Plan\",\n                  percentComplete: 0,\n                  active: false,\n                  disabled: true\n                },\n              ]\n            }\n          ];\n          return (\n            <div className=\"sfg-row\">\n              <div className=\"sfg-col-4\">\n                    <SpsWizardSidebar phases={phaseArray} />\n                  </div>\n            </div>\n              )\n          }\n        "], ["\n        function Component() {\n          const phaseArray = [\n            {\n              title: \"Plan & Payment\",\n              disabled: false,\n              steps: [\n                {\n                  title: \"Choose a Plan\",\n                  percentComplete: 100,\n                  active: false,\n                  disabled: false,\n                  onClick() {\n                    alert(\"Step clicked\");\n                  }\n                },\n                {\n                  title: \"Payment & Billing\",\n                  percentComplete: 33,\n                  active: true,\n                  disabled: false\n                },\n                {\n                  title: \"Confirm Payment\",\n                  percentComplete: 0,\n                  active: false,\n                  disabled: false\n                }\n              ]\n            },\n            {\n              title: \"Implementation details\",\n              disabled: true,\n              steps: [\n                {\n                  title: \"Implementation details\",\n                  percentComplete: 0,\n                  active: false,\n                  disabled: true\n                }, {\n                  title: \"Choose a Plan\",\n                  percentComplete: 0,\n                  active: false,\n                  disabled: true\n                },\n              ]\n            }\n          ];\n          return (\n            <div className=\"sfg-row\">\n              <div className=\"sfg-col-4\">\n                    <SpsWizardSidebar phases={phaseArray} />\n                  </div>\n            </div>\n              )\n          }\n        "]))),
            },
        },
    },
};
var templateObject_1$7, templateObject_2$6, templateObject_3$3, templateObject_4$1;

var __assign$o = (undefined && undefined.__assign) || function () {
    __assign$o = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$o.apply(this, arguments);
};
var __rest$k = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$k = {};
var propTypes$m = __assign$o({}, spsGlobalPropTypes);
function SpsWorkflowDocument(props) {
    var children = props.children, className = props.className, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$k(props, ["children", "className", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-workflow__document", className);
    return (React.createElement("span", __assign$o({ className: classes, "data-testid": testId + "__document" }, rest), children));
}
Object.assign(SpsWorkflowDocument, {
    props: propsDoc$k,
    propTypes: propTypes$m,
    displayName: "SpsWorkflowDocument",
});
function SpsWfDoc(props) {
    return React.createElement(SpsWorkflowDocument, __assign$o({}, props));
}
Object.assign(SpsWfDoc, {
    props: propsDoc$k,
    propTypes: propTypes$m,
    displayName: "SpsWfDoc",
});

var __assign$n = (undefined && undefined.__assign) || function () {
    __assign$n = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$n.apply(this, arguments);
};
var __rest$j = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$j = {
    icon: "SpsIcon",
};
var propTypes$l = __assign$n(__assign$n({}, spsGlobalPropTypes), { icon: enumValue(SpsIcon) });
function SpsWorkflowDocumentStatus(props) {
    var children = props.children, className = props.className, icon = props.icon, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$j(props, ["children", "className", "icon", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-workflow__document-status", className);
    return (React.createElement("span", __assign$n({ className: classes, "data-testid": testId + "__doc-status" }, rest),
        icon
            && React.createElement("i", { "aria-hidden": "true", className: "sps-icon sps-icon-" + icon }),
        children));
}
Object.assign(SpsWorkflowDocumentStatus, {
    props: propsDoc$j,
    propTypes: propTypes$l,
    displayName: "SpsWorkflowDocumentStatus",
});
function SpsWfDs(props) {
    return React.createElement(SpsWorkflowDocumentStatus, __assign$n({}, props));
}
Object.assign(SpsWfDs, {
    props: propsDoc$j,
    propTypes: propTypes$l,
    displayName: "SpsWfDs",
});

var __assign$m = (undefined && undefined.__assign) || function () {
    __assign$m = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$m.apply(this, arguments);
};
var __rest$i = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$i = {
    icon: { type: "SpsIcon", required: true },
    title: { type: "string", required: true },
};
var propTypes$k = __assign$m(__assign$m({}, spsGlobalPropTypes), { icon: enumValue(SpsIcon).isRequired, title: propTypes$1H.exports.string.isRequired });
function SpsWorkflowStep(props) {
    var children = props.children, className = props.className, icon = props.icon, title = props.title, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$i(props, ["children", "className", "icon", "title", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-workflow__step", className);
    return (React.createElement("div", __assign$m({ className: classes, "data-testid": testId + "__step" }, rest),
        React.createElement("i", { "aria-hidden": "true", className: "sps-icon sps-icon-" + icon + " sps-workflow__step-icon" }),
        React.createElement("h2", { className: "sps-workflow__step-heading", "data-testid": testId + "__step-heading" }, title),
        children));
}
Object.assign(SpsWorkflowStep, {
    props: propsDoc$i,
    propTypes: propTypes$k,
    displayName: "SpsWorkflowStep",
});
function SpsWfStep(props) {
    return React.createElement(SpsWorkflowStep, __assign$m({}, props));
}
Object.assign(SpsWfStep, {
    props: propsDoc$i,
    propTypes: propTypes$k,
    displayName: "SpsWfStep",
});

var __makeTemplateObject$6 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsWorkflowExamples = {
    basic: {
        label: "Basic Usage",
        examples: {
            basic: {
                jsx: code(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject$6(["\n                <div className=\"col-4\">\n                    <SpsWorkflow icon=\"list-summary\" title=\"Workflow\">\n                        <SpsWorkflowStep icon=\"heart\" title=\"Name of Step\">\n                            <SpsWorkflowDocument>\n                                <a href=\"https://github.com/SPSCommerce/ui-angular\" target=\"_blank\">\n                                    Document Name\n                                </a>\n                                <SpsWorkflowDocumentStatus icon=\"status-error\">\n                                    Status\n                                </SpsWorkflowDocumentStatus>\n                            </SpsWorkflowDocument>\n                            <SpsWorkflowDocument>\n                                Document Name\n                                <SpsWorkflowDocumentStatus>\n                                    Status\n                                </SpsWorkflowDocumentStatus>\n                            </SpsWorkflowDocument>\n                        </SpsWorkflowStep>\n                        <SpsWorkflowStep icon=\"heart\" title=\"Done\">\n                        </SpsWorkflowStep>\n                    </SpsWorkflow>\n                </div>\n            "], ["\n                <div className=\"col-4\">\n                    <SpsWorkflow icon=\"list-summary\" title=\"Workflow\">\n                        <SpsWorkflowStep icon=\"heart\" title=\"Name of Step\">\n                            <SpsWorkflowDocument>\n                                <a href=\"https://github.com/SPSCommerce/ui-angular\" target=\"_blank\">\n                                    Document Name\n                                </a>\n                                <SpsWorkflowDocumentStatus icon=\"status-error\">\n                                    Status\n                                </SpsWorkflowDocumentStatus>\n                            </SpsWorkflowDocument>\n                            <SpsWorkflowDocument>\n                                Document Name\n                                <SpsWorkflowDocumentStatus>\n                                    Status\n                                </SpsWorkflowDocumentStatus>\n                            </SpsWorkflowDocument>\n                        </SpsWorkflowStep>\n                        <SpsWorkflowStep icon=\"heart\" title=\"Done\">\n                        </SpsWorkflowStep>\n                    </SpsWorkflow>\n                </div>\n            "]))),
            },
        },
    },
    withAlias: {
        label: "Basic Usage with Alias",
        examples: {
            withAlias: {
                jsx: code(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject$6(["\n                <div className=\"col-4\">\n                    <SpsWf icon=\"list-summary\" title=\"Workflow\">\n                        <SpsWfStep icon=\"heart\" title=\"Name of Step\">\n                            <SpsWfDoc>\n                                <a href=\"https://github.com/SPSCommerce/ui-angular\" target=\"_blank\">\n                                    Document Name\n                                </a>\n                                <SpsWfDs icon=\"status-error\">Status</SpsWfDs>\n                            </SpsWfDoc>\n                            <SpsWfDoc>\n                                Document Name\n                                <SpsWfDs>\n                                    Status\n                                </SpsWfDs>\n                            </SpsWfDoc>\n                        </SpsWfStep>\n                        <SpsWfStep icon=\"heart\" title=\"Done\">\n                        </SpsWfStep>\n                    </SpsWf>\n                </div>\n            "], ["\n                <div className=\"col-4\">\n                    <SpsWf icon=\"list-summary\" title=\"Workflow\">\n                        <SpsWfStep icon=\"heart\" title=\"Name of Step\">\n                            <SpsWfDoc>\n                                <a href=\"https://github.com/SPSCommerce/ui-angular\" target=\"_blank\">\n                                    Document Name\n                                </a>\n                                <SpsWfDs icon=\"status-error\">Status</SpsWfDs>\n                            </SpsWfDoc>\n                            <SpsWfDoc>\n                                Document Name\n                                <SpsWfDs>\n                                    Status\n                                </SpsWfDs>\n                            </SpsWfDoc>\n                        </SpsWfStep>\n                        <SpsWfStep icon=\"heart\" title=\"Done\">\n                        </SpsWfStep>\n                    </SpsWf>\n                </div>\n            "]))),
            },
        },
    },
};
var templateObject_1$6, templateObject_2$5;

var __assign$l = (undefined && undefined.__assign) || function () {
    __assign$l = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$l.apply(this, arguments);
};
var __rest$h = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$h = {
    artwork: { type: "string", required: true },
    heading: { type: "string", required: true },
    subHeading: "string",
};
var propTypes$j = __assign$l(__assign$l({}, spsGlobalPropTypes), { artwork: propTypes$1H.exports.string.isRequired, heading: propTypes$1H.exports.string.isRequired, subHeading: propTypes$1H.exports.string });
function SpsZeroState(props) {
    var artwork = props.artwork, children = props.children, className = props.className, heading = props.heading, subHeading = props.subHeading, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$h(props, ["artwork", "children", "className", "heading", "subHeading", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-zero-state", className);
    return (React.createElement("div", { className: "sps-card__body", "data-testid": "" + testId },
        React.createElement("div", __assign$l({ className: classes, "data-testid": testId + "__actual-zero-state" }, rest),
            React.createElement("img", { className: "sps-zero-state__image", src: artwork, alt: "", "data-testid": testId + "__artwork" }),
            React.createElement("h1", { className: "sps-zero-state__heading", "data-testid": testId + "__heading" }, heading),
            React.createElement("h2", { className: "sps-zero-state__subheading", "data-testid": testId + "__subheading" }, subHeading),
            React.createElement("div", { className: "sps-zero-state__content", "data-testid": testId + "__content" }, children))));
}
Object.assign(SpsZeroState, {
    props: propsDoc$h,
    propTypes: propTypes$j,
    displayName: "SpsZeroState",
});

var __assign$k = (undefined && undefined.__assign) || function () {
    __assign$k = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$k.apply(this, arguments);
};
var __rest$g = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$g = {
    icon: { type: "SpsIcon", required: true },
    heading: "ReactNodeOrRenderFn",
    subHeading: "ReactNodeOrRenderFn",
};
var propTypes$i = __assign$k(__assign$k({}, spsGlobalPropTypes), { icon: enumValue(SpsIcon).isRequired, heading: nodeOrRenderFn, subHeading: nodeOrRenderFn });
function SpsMicroZeroState(props) {
    var className = props.className, heading = props.heading, icon = props.icon, subHeading = props.subHeading, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$g(props, ["className", "heading", "icon", "subHeading", "data-testid", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-zero-state", "sps-zero-state--micro", className);
    return (React.createElement("div", __assign$k({ className: classes, "data-testid": testId + "__actual-micro-zero-state" }, rest),
        React.createElement("i", { className: "sps-icon sps-icon-" + icon, "aria-hidden": "true", "data-testid": testId + "__icon" }),
        heading && React.createElement("h1", { className: "sps-zero-state__heading", "data-testid": testId + "__heading" }, heading),
        subHeading && React.createElement("h2", { className: "sps-zero-state__subheading", "data-testid": testId + "__subheading" }, subHeading)));
}
Object.assign(SpsMicroZeroState, {
    props: propsDoc$g,
    propTypes: propTypes$i,
    displayName: "SpsMicroZeroState",
});

var __makeTemplateObject$5 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsZeroStateExamples = {
    sizes: {
        label: "Sizes",
        customSection: function () { return (React.createElement("section", { id: "zero-states-sizes" },
            React.createElement("div", { className: "flex-color-header" },
                React.createElement("h4", null, "Sizes"),
                React.createElement(SpsButton, { onClick: function () {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }, kind: ButtonKind.LINK }, "Back to Top")),
            React.createElement("h5", { className: "mb-3" }, "There are 2 sizes of Zero States: Large and Small. They differ in appearance and are used in different cases."),
            React.createElement("h4", null, "Large Zero States"),
            React.createElement("h5", { className: "mb-3" }, "Use Large Zero States in primary or large areas of a page."),
            React.createElement("h4", null, "Small Zero States"),
            React.createElement("h5", { className: "mb-0" }, "Use Small Zero States in a secondary or small areas of a page."))); },
    },
    regular: {
        label: "Usage: Large Zero States",
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement("span", { className: "sps-body-14 mt-4" },
                "Large Zero States may be accompanied by other components such as Headings, Subtitles, ",
                React.createElement(NavigateTo, { to: "Button" }, "Buttons"),
                ",",
                " ",
                React.createElement(NavigateTo, { to: "List Toolbar" }, "Search Bars"),
                ", or a combination of these"));
        },
        examples: {
            illustrationAndHeading: {
                description: "Illustration + Heading",
                jsx: code(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$5(["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        />\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        />\n                    </SpsCard>\n                "]))),
            },
            illustrationHeadingAndSubtitle: {
                description: "Illustration + Heading + Subtitle",
                jsx: code(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject$5(["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            subHeading=\"Find new record by using the search box above.\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        />\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            subHeading=\"Find new record by using the search box above.\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        />\n                    </SpsCard>\n                "]))),
            },
            illustrationHeadingAndButton: {
                description: "Illustration + Heading + Button",
                jsx: code(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject$5(["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        >\n                            <SpsButton kind={ButtonKind.CONFIRM}>\n                                Search\n                            </SpsButton>\n                        </SpsZeroState>\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        >\n                            <SpsButton kind={ButtonKind.CONFIRM}>\n                                Search\n                            </SpsButton>\n                        </SpsZeroState>\n                    </SpsCard>\n                "]))),
            },
            illustrationHeadingSubtitleAndButton: {
                description: "Illustration + Heading + Subtitle + Button",
                jsx: code(templateObject_4 || (templateObject_4 = __makeTemplateObject$5(["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            subHeading=\"Find new companies by using the Search button below.\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        >\n                            <SpsButton kind={ButtonKind.CONFIRM}>\n                                Search\n                            </SpsButton>\n                        </SpsZeroState>\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsZeroState\n                            heading=\"Search for a record\"\n                            subHeading=\"Find new companies by using the Search button below.\"\n                            artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                        >\n                            <SpsButton kind={ButtonKind.CONFIRM}>\n                                Search\n                            </SpsButton>\n                        </SpsZeroState>\n                    </SpsCard>\n                "]))),
            },
            illustrationHeadingSubtitleAndSearch: {
                description: "Illustration + Heading + Subtitle + Search",
                react: code(templateObject_5 || (templateObject_5 = __makeTemplateObject$5(["\n                    function Component() {\n                        const [searchText, setSearchText] = React.useState(\"\");\n\n                        function handleChange(e) {\n                            setSearchText(e.target.value);\n                        }\n\n                        return (\n                            <SpsCard>\n                                <SpsZeroState\n                                    heading=\"Search for a record\"\n                                    subHeading=\"Find new records by using the search box below.\"\n                                    artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                                >\n                                    <SpsInputGroup>\n                                        <SpsTextInput\n                                            name=\"search\"\n                                            value={searchText}\n                                            placeholder=\"Search for a record\"\n                                            onChange={handleChange}\n                                        />\n                                        <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} aria-label=\"Search\" />\n                                    </SpsInputGroup>\n                                </SpsZeroState>\n                            </SpsCard>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const [searchText, setSearchText] = React.useState(\"\");\n\n                        function handleChange(e) {\n                            setSearchText(e.target.value);\n                        }\n\n                        return (\n                            <SpsCard>\n                                <SpsZeroState\n                                    heading=\"Search for a record\"\n                                    subHeading=\"Find new records by using the search box below.\"\n                                    artwork=\"https://cdn.prod.spsc.io/web/framework/assets/18.03.02/images/icon-empty-search@2x.svg\"\n                                >\n                                    <SpsInputGroup>\n                                        <SpsTextInput\n                                            name=\"search\"\n                                            value={searchText}\n                                            placeholder=\"Search for a record\"\n                                            onChange={handleChange}\n                                        />\n                                        <SpsButton kind={ButtonKind.ICON} icon={SpsIcon.SEARCH} aria-label=\"Search\" />\n                                    </SpsInputGroup>\n                                </SpsZeroState>\n                            </SpsCard>\n                        );\n                    }\n                "]))),
            },
        },
    },
    micro: {
        label: "Usage: Small Zero State",
        description: "Small Zero States may be accompanied by Headings, Subtitles, or both.",
        examples: {
            illustrationAndHeading: {
                description: "Illustration + Heading",
                jsx: code(templateObject_6 || (templateObject_6 = __makeTemplateObject$5(["\n                    <SpsCard>\n                        <SpsMicroZeroState\n                            heading=\"No Data Available\"\n                            icon={SpsIcon.CHART_BAR}\n                        />\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsMicroZeroState\n                            heading=\"No Data Available\"\n                            icon={SpsIcon.CHART_BAR}\n                        />\n                    </SpsCard>\n                "]))),
            },
            IllustrationAndSubtitle: {
                description: "Illustration + Subtitle",
                jsx: code(templateObject_7 || (templateObject_7 = __makeTemplateObject$5(["\n                    <SpsCard>\n                        <SpsMicroZeroState\n                            subHeading=\"No data available. Create a report and try again.\"\n                            icon={SpsIcon.CHART_BAR}\n                        />\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsMicroZeroState\n                            subHeading=\"No data available. Create a report and try again.\"\n                            icon={SpsIcon.CHART_BAR}\n                        />\n                    </SpsCard>\n                "]))),
            },
            IllustrationHeadingAndSubtitle: {
                description: "Illustration + Heading + Subtitle",
                jsx: code(templateObject_8 || (templateObject_8 = __makeTemplateObject$5(["\n                    <SpsCard>\n                        <SpsMicroZeroState\n                            heading=\"No Data Available\"\n                            subHeading=\"Create a report and try again.\"\n                            icon={SpsIcon.CHART_BAR}\n                        />\n                    </SpsCard>\n                "], ["\n                    <SpsCard>\n                        <SpsMicroZeroState\n                            heading=\"No Data Available\"\n                            subHeading=\"Create a report and try again.\"\n                            icon={SpsIcon.CHART_BAR}\n                        />\n                    </SpsCard>\n                "]))),
            },
        },
    },
};
var templateObject_1$5, templateObject_2$4, templateObject_3$2, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var __assign$j = (undefined && undefined.__assign) || function () {
    __assign$j = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$j.apply(this, arguments);
};
var __rest$f = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$f = {};
var propTypes$h = __assign$j({}, spsGlobalPropTypes);
function SpsFilterPanel(_a) {
    var children = _a.children, className = _a.className, rest = __rest$f(_a, ["children", "className"]);
    return (React.createElement("div", __assign$j({ className: clsx("sps-filter-panel", className) }, rest), children));
}
Object.assign(SpsFilterPanel, {
    props: propsDoc$f,
    propTypes: propTypes$h,
    displayName: "SpsFilterPanel",
});

var __assign$i = (undefined && undefined.__assign) || function () {
    __assign$i = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$i.apply(this, arguments);
};
var __rest$e = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$a = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$e = {
    title: "string",
    expanded: "boolean",
    heightPx: "number",
    heightRem: "number",
    onExpand: "() => void",
    onCollapse: "() => void",
};
var propTypes$g = __assign$i(__assign$i({}, spsGlobalPropTypes), { title: propTypes$1H.exports.string, expanded: propTypes$1H.exports.bool, heightPx: propTypes$1H.exports.number, heightRem: propTypes$1H.exports.number, onExpand: fun(), onCollapse: fun() });
function SpsFilterPanelSection(_a) {
    var children = _a.children, className = _a.className, title = _a.title, expanded = _a.expanded, heightPx = _a.heightPx, heightRem = _a.heightRem, onExpand = _a.onExpand, onCollapse = _a.onCollapse, rest = __rest$e(_a, ["children", "className", "title", "expanded", "heightPx", "heightRem", "onExpand", "onCollapse"]);
    var _b = __read$a(React.useState(expanded), 2), localExpanded = _b[0], setLocalExpanded = _b[1];
    var isExpanded = typeof expanded !== "undefined" ? expanded : localExpanded;
    var height = heightPx ? heightPx / 16 : heightRem;
    var inlineStyles = height ? { overflowY: "scroll", height: height + "rem" } : {};
    var ExpandHideButton = function () { return (React.createElement("button", { type: "button", className: "sps-filter-panel__section__expand-btn", onClick: function () {
            setLocalExpanded(!isExpanded);
            if (!isExpanded && onExpand) {
                onExpand();
            }
            else if (isExpanded && onCollapse) {
                onCollapse();
            }
        } },
        React.createElement(SpsI, { icon: isExpanded ? SpsIcon.MINUS_CIRCLE : SpsIcon.PLUS_CIRCLE }))); };
    React.useEffect(function () {
        setLocalExpanded(expanded);
    }, [expanded]);
    return (React.createElement("div", __assign$i({ className: clsx("sps-filter-panel__section", className) }, rest),
        React.createElement("div", { className: "sps-filter-panel__section__title-wrapper" },
            React.createElement(ExpandHideButton, null),
            React.createElement("p", null, title)),
        isExpanded && (React.createElement("div", { className: "sps-filter-panel__section__content-wrapper", style: inlineStyles },
            React.createElement("div", { className: "sps-filter-panel__section__content" }, children)))));
}
Object.assign(SpsFilterPanelSection, {
    props: propsDoc$e,
    propTypes: propTypes$g,
    displayName: "SpsFilterPanelSection",
});

var __assign$h = (undefined && undefined.__assign) || function () {
    __assign$h = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$h.apply(this, arguments);
};
var __rest$d = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$d = {
    onClear: "() => void",
};
var propTypes$f = __assign$h(__assign$h({}, spsGlobalPropTypes), { onClear: fun() });
function SpsFilterPanelCap(_a) {
    _a.children; var className = _a.className, onClear = _a.onClear, rest = __rest$d(_a, ["children", "className", "onClear"]);
    var t = React.useContext(I18nContext).t;
    return (React.createElement("div", __assign$h({ className: clsx("sps-filter-panel__cap", className) }, rest),
        React.createElement("div", { className: "sps-filter-panel__cap__title-wrapper" },
            React.createElement(SpsI, { icon: SpsIcon.FILTER, size: SpsIconSize.SMALL }),
            React.createElement("p", null, t("design-system:filterPanel.title"))),
        React.createElement(SpsButton, { kind: ButtonKind.LINK, onClick: onClear }, t("design-system:filterPanel.clear"))));
}
Object.assign(SpsFilterPanelCap, {
    props: propsDoc$d,
    propTypes: propTypes$f,
    displayName: "SpsFilterPanelCap",
});

var __makeTemplateObject$4 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsFilterPanelExamples = {
    generalUsage: {
        label: "General Usage",
        examples: {
            general: {
                react: code(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$4(["\n                    function Component() {\n                        const initialValues = {\n                            colors: {\n                                red: false,\n                                blue: false,\n                                green: false,\n                            },\n                            options: {\n                                '1': false,\n                                '2': false,\n                                '3': false,\n                                '4': false,\n                                '5': false,\n                                '6': false,\n                                '7': false,\n                                '8': false,\n                                '9': false,\n                                '10': false,\n                            },\n                            radio: 'yes',          \n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm(initialValues);\n\n                        const handleClear = () => {\n                            updateForm(initialValues);\n                            formMeta.markAsPristine();\n                        }\n\n                        const [expanded, setExpanded] = React.useState(true);\n    \n                        const onExpand = () => {\n                            setExpanded(true);\n                        }\n                        \n                        const onCollapse = () => {\n                            setExpanded(false);\n                        }\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-4\">\n                                    <SpsForm formMeta={formMeta}>\n                                        <SpsFilterPanel>\n                                            <SpsFilterPanelCap onClear={handleClear}/>                              \n                                            <SpsFilterPanelSection title=\"Section one\">\n                                                {Object.keys(initialValues.colors).map((c) => (                                        \n                                                    <SpsCheckbox\n                                                        key={c}\n                                                        name={c}\n                                                        label={`${c[0].toUpperCase()}${c.slice(1)}`}\n                                                        checked={formValue.colors[c]}\n                                                        formMeta={formMeta.fields.colors.fields[c]}\n                                                    />                                        \n                                                ))}                                                \n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section two\"\n                                                expanded={expanded}\n                                                onExpand={onExpand}\n                                                onCollapse={onCollapse}\n                                                heightPx={150}\n                                            >\n                                                {Object.keys(initialValues.options).map((o) => (                                        \n                                                    <SpsCheckbox\n                                                        key={o}\n                                                        name={`option_${o}`}\n                                                        label={`Option ${o}`}\n                                                        checked={formValue.options[o]}\n                                                        formMeta={formMeta.fields.options.fields[o]}\n                                                    />                                        \n                                                ))}\n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section three\">                                            \n                                                <SpsRadioButton name=\"yes\" value=\"yes\" label=\"Yes\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"yes\"}\n                                                ></SpsRadioButton>\n                                                <SpsRadioButton name=\"no\" value=\"no\" label=\"No\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"no\"}\n                                                ></SpsRadioButton>                                           \n                                            </SpsFilterPanelSection>\n                                        </SpsFilterPanel>\n                                    </SpsForm>\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const initialValues = {\n                            colors: {\n                                red: false,\n                                blue: false,\n                                green: false,\n                            },\n                            options: {\n                                '1': false,\n                                '2': false,\n                                '3': false,\n                                '4': false,\n                                '5': false,\n                                '6': false,\n                                '7': false,\n                                '8': false,\n                                '9': false,\n                                '10': false,\n                            },\n                            radio: 'yes',          \n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm(initialValues);\n\n                        const handleClear = () => {\n                            updateForm(initialValues);\n                            formMeta.markAsPristine();\n                        }\n\n                        const [expanded, setExpanded] = React.useState(true);\n    \n                        const onExpand = () => {\n                            setExpanded(true);\n                        }\n                        \n                        const onCollapse = () => {\n                            setExpanded(false);\n                        }\n\n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-4\">\n                                    <SpsForm formMeta={formMeta}>\n                                        <SpsFilterPanel>\n                                            <SpsFilterPanelCap onClear={handleClear}/>                              \n                                            <SpsFilterPanelSection title=\"Section one\">\n                                                {Object.keys(initialValues.colors).map((c) => (                                        \n                                                    <SpsCheckbox\n                                                        key={c}\n                                                        name={c}\n                                                        label={\\`\\${c[0].toUpperCase()}\\${c.slice(1)}\\`}\n                                                        checked={formValue.colors[c]}\n                                                        formMeta={formMeta.fields.colors.fields[c]}\n                                                    />                                        \n                                                ))}                                                \n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section two\"\n                                                expanded={expanded}\n                                                onExpand={onExpand}\n                                                onCollapse={onCollapse}\n                                                heightPx={150}\n                                            >\n                                                {Object.keys(initialValues.options).map((o) => (                                        \n                                                    <SpsCheckbox\n                                                        key={o}\n                                                        name={\\`option_\\${o}\\`}\n                                                        label={\\`Option \\${o}\\`}\n                                                        checked={formValue.options[o]}\n                                                        formMeta={formMeta.fields.options.fields[o]}\n                                                    />                                        \n                                                ))}\n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section three\">                                            \n                                                <SpsRadioButton name=\"yes\" value=\"yes\" label=\"Yes\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"yes\"}\n                                                ></SpsRadioButton>\n                                                <SpsRadioButton name=\"no\" value=\"no\" label=\"No\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"no\"}\n                                                ></SpsRadioButton>                                           \n                                            </SpsFilterPanelSection>\n                                        </SpsFilterPanel>\n                                    </SpsForm>\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
    filterBox: {
        label: "Filter Box",
        examples: {
            withFormMeta: {
                description: function () { return React.createElement("p", null, "Using formMeta prop"); },
                react: code(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject$4(["\n                    function Component() {\n                        const initialValues = {\n                            colors: {\n                                red: false,\n                                blue: false,\n                                green: false,\n                            },\n                            options: {\n                                '1': false,\n                                '2': false,\n                                '3': false,\n                                '4': false,\n                                '5': false,\n                            },\n                            radio: 'yes',\n                            filterBoxValue: '',           \n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm(initialValues);\n\n                        const handleClear = () => {\n                            updateForm(initialValues);\n                            formMeta.markAsPristine();\n                        }\n\n                        const [expanded, setExpanded] = React.useState(true);\n    \n                        const onExpand = () => {\n                            setExpanded(true);\n                        }\n                        \n                        const onCollapse = () => {\n                            setExpanded(false);\n                        }\n                        \n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-4\">\n                                    <SpsForm formMeta={formMeta}>\n                                        <SpsFilterPanel>\n                                            <SpsFilterPanelCap onClear={handleClear}/>\n                                            <SpsFilterPanelFilterBox\n                                                value={formValue.filterBoxValue}\n                                                formMeta={formMeta.fields.filterBoxValue}\n                                            />\n                                            <SpsFilterPanelSection title=\"Section one\">\n                                                {Object.keys(initialValues.colors)\n                                                    .filter((c) => c.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((c) => (\n                                                        <SpsCheckbox\n                                                            key={c}\n                                                            name={c}\n                                                            label={`${c[0].toUpperCase()}${c.slice(1)}`}\n                                                            checked={formValue.colors[c]}\n                                                            formMeta={formMeta.fields.colors.fields[c]}\n                                                        />\n                                                    ))\n                                                }                                                \n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section two\"\n                                            expanded={expanded}\n                                            onExpand={onExpand}\n                                            onCollapse={onCollapse}\n                                            >\n                                                {Object.keys(initialValues.options)\n                                                    .filter((o) => `Option ${o}`.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((o) => (\n                                                        <SpsCheckbox\n                                                            key={o}\n                                                            name={`option_${o}`}\n                                                            label={`Option ${o}`}\n                                                            checked={formValue.options[o]}\n                                                            formMeta={formMeta.fields.options.fields[o]}\n                                                        />\n                                                    ))\n                                                }\n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section three\">                                            \n                                                <SpsRadioButton name=\"yes\" value=\"yes\" label=\"Yes\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"yes\"}\n                                                ></SpsRadioButton>\n                                                <SpsRadioButton name=\"no\" value=\"no\" label=\"No\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"no\"}\n                                                ></SpsRadioButton>                                           \n                                            </SpsFilterPanelSection>\n                                        </SpsFilterPanel>\n                                    </SpsForm>\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const initialValues = {\n                            colors: {\n                                red: false,\n                                blue: false,\n                                green: false,\n                            },\n                            options: {\n                                '1': false,\n                                '2': false,\n                                '3': false,\n                                '4': false,\n                                '5': false,\n                            },\n                            radio: 'yes',\n                            filterBoxValue: '',           \n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm(initialValues);\n\n                        const handleClear = () => {\n                            updateForm(initialValues);\n                            formMeta.markAsPristine();\n                        }\n\n                        const [expanded, setExpanded] = React.useState(true);\n    \n                        const onExpand = () => {\n                            setExpanded(true);\n                        }\n                        \n                        const onCollapse = () => {\n                            setExpanded(false);\n                        }\n                        \n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-4\">\n                                    <SpsForm formMeta={formMeta}>\n                                        <SpsFilterPanel>\n                                            <SpsFilterPanelCap onClear={handleClear}/>\n                                            <SpsFilterPanelFilterBox\n                                                value={formValue.filterBoxValue}\n                                                formMeta={formMeta.fields.filterBoxValue}\n                                            />\n                                            <SpsFilterPanelSection title=\"Section one\">\n                                                {Object.keys(initialValues.colors)\n                                                    .filter((c) => c.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((c) => (\n                                                        <SpsCheckbox\n                                                            key={c}\n                                                            name={c}\n                                                            label={\\`\\${c[0].toUpperCase()}\\${c.slice(1)}\\`}\n                                                            checked={formValue.colors[c]}\n                                                            formMeta={formMeta.fields.colors.fields[c]}\n                                                        />\n                                                    ))\n                                                }                                                \n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section two\"\n                                            expanded={expanded}\n                                            onExpand={onExpand}\n                                            onCollapse={onCollapse}\n                                            >\n                                                {Object.keys(initialValues.options)\n                                                    .filter((o) => \\`Option \\${o}\\`.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((o) => (\n                                                        <SpsCheckbox\n                                                            key={o}\n                                                            name={\\`option_\\${o}\\`}\n                                                            label={\\`Option \\${o}\\`}\n                                                            checked={formValue.options[o]}\n                                                            formMeta={formMeta.fields.options.fields[o]}\n                                                        />\n                                                    ))\n                                                }\n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section three\">                                            \n                                                <SpsRadioButton name=\"yes\" value=\"yes\" label=\"Yes\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"yes\"}\n                                                ></SpsRadioButton>\n                                                <SpsRadioButton name=\"no\" value=\"no\" label=\"No\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"no\"}\n                                                ></SpsRadioButton>                                           \n                                            </SpsFilterPanelSection>\n                                        </SpsFilterPanel>\n                                    </SpsForm>\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
            withOnFilterChange: {
                description: function () { return React.createElement("p", null, "Using onFilterChange prop"); },
                react: code(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject$4(["\n                    function Component() {\n                        const initialValues = {\n                            colors: {\n                                red: false,\n                                blue: false,\n                                green: false,\n                            },\n                            options: {\n                                '1': false,\n                                '2': false,\n                                '3': false,\n                                '4': false,\n                                '5': false,\n                            },\n                            radio: 'yes',\n                            filterBoxValue: '',           \n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm(initialValues);\n\n                        const handleClear = () => {\n                            updateForm(initialValues);\n                            formMeta.markAsPristine();\n                        }\n\n                        const [expanded, setExpanded] = React.useState(true);\n\n                        const onExpand = () => {\n                            setExpanded(true);\n                        }\n                        \n                        const onCollapse = () => {\n                            setExpanded(false);\n                        }\n\n                        const handleFilterChange = (e) => {\n                            updateForm({...formValue, filterBoxValue: e.target.value})\n                        }\n                        \n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-4\">\n                                    <SpsForm formMeta={formMeta}>\n                                        <SpsFilterPanel>\n                                            <SpsFilterPanelCap onClear={handleClear}/>\n                                            <SpsFilterPanelFilterBox\n                                                value={formValue.filterBoxValue}\n                                                onFilterChange={handleFilterChange}\n                                            />\n                                            <SpsFilterPanelSection title=\"Section one\">\n                                                {Object.keys(initialValues.colors)\n                                                    .filter((c) => c.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((c) => (\n                                                        <SpsCheckbox\n                                                            key={c}\n                                                            name={c}\n                                                            label={`${c[0].toUpperCase()}${c.slice(1)}`}\n                                                            checked={formValue.colors[c]}\n                                                            formMeta={formMeta.fields.colors.fields[c]}\n                                                        />\n                                                    ))\n                                                }                                                \n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section two\"\n                                            expanded={expanded}\n                                            onExpand={onExpand}\n                                            onCollapse={onCollapse}\n                                            >\n                                                {Object.keys(initialValues.options)\n                                                    .filter((o) => `Option ${o}`.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((o) => (\n                                                        <SpsCheckbox\n                                                            key={o}\n                                                            name={`option_${o}`}\n                                                            label={`Option ${o}`}\n                                                            checked={formValue.options[o]}\n                                                            formMeta={formMeta.fields.options.fields[o]}\n                                                        />\n                                                    ))\n                                                }\n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section three\">                                            \n                                                <SpsRadioButton name=\"yes\" value=\"yes\" label=\"Yes\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"yes\"}\n                                                ></SpsRadioButton>\n                                                <SpsRadioButton name=\"no\" value=\"no\" label=\"No\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"no\"}\n                                                ></SpsRadioButton>                                           \n                                            </SpsFilterPanelSection>\n                                        </SpsFilterPanel>\n                                    </SpsForm>\n                                </div>\n                            </div>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        const initialValues = {\n                            colors: {\n                                red: false,\n                                blue: false,\n                                green: false,\n                            },\n                            options: {\n                                '1': false,\n                                '2': false,\n                                '3': false,\n                                '4': false,\n                                '5': false,\n                            },\n                            radio: 'yes',\n                            filterBoxValue: '',           \n                        }\n\n                        const { formValue, formMeta, updateForm } = useSpsForm(initialValues);\n\n                        const handleClear = () => {\n                            updateForm(initialValues);\n                            formMeta.markAsPristine();\n                        }\n\n                        const [expanded, setExpanded] = React.useState(true);\n\n                        const onExpand = () => {\n                            setExpanded(true);\n                        }\n                        \n                        const onCollapse = () => {\n                            setExpanded(false);\n                        }\n\n                        const handleFilterChange = (e) => {\n                            updateForm({...formValue, filterBoxValue: e.target.value})\n                        }\n                        \n                        return (\n                            <div className=\"sfg-row\">\n                                <div className=\"sfg-col-4\">\n                                    <SpsForm formMeta={formMeta}>\n                                        <SpsFilterPanel>\n                                            <SpsFilterPanelCap onClear={handleClear}/>\n                                            <SpsFilterPanelFilterBox\n                                                value={formValue.filterBoxValue}\n                                                onFilterChange={handleFilterChange}\n                                            />\n                                            <SpsFilterPanelSection title=\"Section one\">\n                                                {Object.keys(initialValues.colors)\n                                                    .filter((c) => c.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((c) => (\n                                                        <SpsCheckbox\n                                                            key={c}\n                                                            name={c}\n                                                            label={\\`\\${c[0].toUpperCase()}\\${c.slice(1)}\\`}\n                                                            checked={formValue.colors[c]}\n                                                            formMeta={formMeta.fields.colors.fields[c]}\n                                                        />\n                                                    ))\n                                                }                                                \n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section two\"\n                                            expanded={expanded}\n                                            onExpand={onExpand}\n                                            onCollapse={onCollapse}\n                                            >\n                                                {Object.keys(initialValues.options)\n                                                    .filter((o) => \\`Option \\${o}\\`.toLowerCase()\n                                                        .includes(formValue\n                                                            .filterBoxValue\n                                                            .toLowerCase()\n                                                            )\n                                                        )\n                                                    .map((o) => (\n                                                        <SpsCheckbox\n                                                            key={o}\n                                                            name={\\`option_\\${o}\\`}\n                                                            label={\\`Option \\${o}\\`}\n                                                            checked={formValue.options[o]}\n                                                            formMeta={formMeta.fields.options.fields[o]}\n                                                        />\n                                                    ))\n                                                }\n                                            </SpsFilterPanelSection>\n                                            <SpsFilterPanelSection title=\"Section three\">                                            \n                                                <SpsRadioButton name=\"yes\" value=\"yes\" label=\"Yes\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"yes\"}\n                                                ></SpsRadioButton>\n                                                <SpsRadioButton name=\"no\" value=\"no\" label=\"No\"\n                                                    formMeta={formMeta.fields.radio}\n                                                    checked={formValue.radio === \"no\"}\n                                                ></SpsRadioButton>                                           \n                                            </SpsFilterPanelSection>\n                                        </SpsFilterPanel>\n                                    </SpsForm>\n                                </div>\n                            </div>\n                        );\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$4, templateObject_2$3, templateObject_3$1;

var __assign$g = (undefined && undefined.__assign) || function () {
    __assign$g = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$g.apply(this, arguments);
};
var __rest$c = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$c = {
    value: "string",
    placeholder: "string",
    formMeta: "SpsFormArrayMeta<any> | SpsFormGroupMeta<any>",
    onFilterChange: "ChangeEventHandler<HTMLInputElement>",
};
var propTypes$e = __assign$g(__assign$g({}, spsGlobalPropTypes), { value: propTypes$1H.exports.string, placeholder: propTypes$1H.exports.string, formMeta: propTypes$1H.exports.oneOfType([
        impl(), impl(),
    ]), onFilterChange: fun() });
function SpsFilterPanelFilterBox(_a) {
    var className = _a.className, value = _a.value, placeholder = _a.placeholder, formMeta = _a.formMeta, onFilterChange = _a.onFilterChange, rest = __rest$c(_a, ["className", "value", "placeholder", "formMeta", "onFilterChange"]);
    var t = React.useContext(I18nContext).t;
    return (React.createElement("div", __assign$g({ className: clsx("sps-filter-panel__filter-box", className) }, rest),
        React.createElement(SpsTextInput, { value: value, icon: SpsIcon.FILTER, formMeta: formMeta, placeholder: placeholder || t("design-system:filterPanel.filterPlaceholder"), onChange: onFilterChange })));
}
Object.assign(SpsFilterPanelFilterBox, {
    props: propsDoc$c,
    propTypes: propTypes$e,
    displayName: "SpsFilterPanelFilterBox",
});

var __assign$f = (undefined && undefined.__assign) || function () {
    __assign$f = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$f.apply(this, arguments);
};
var __rest$b = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$b = {
    showCondition: "boolean",
};
var propTypes$d = __assign$f(__assign$f({}, spsGlobalPropTypes), { showCondition: propTypes$1H.exports.bool });
function SpsConditionalField(_a) {
    var _b = _a.showCondition, showCondition = _b === void 0 ? true : _b, children = _a.children, className = _a.className, rest = __rest$b(_a, ["showCondition", "children", "className"]);
    return showCondition ? (React.createElement("div", __assign$f({ className: clsx("sps-conditional-field", className) }, rest), children)) : null;
}
Object.assign(SpsConditionalField, {
    props: propsDoc$b,
    propTypes: propTypes$d,
    displayName: "SpsConditionalField",
});

var __makeTemplateObject$3 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsConditionalFieldExamples = {
    generalUsage: {
        label: "General Usage",
        examples: {
            withCheckbox: {
                react: code(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$3(["\n                    function Component() {\n                      const { formValue, formMeta, updateForm } = useSpsForm({\n                        optionOne: true,\n                        optionTwo: false,\n                        optionThree: false,\n                        optionFour: false,\n                        conditionalField: \"\",\n                      })\n\n                      return (\n                        <SpsForm formMeta={formMeta}>\n                          <SpsInputGroup\n                            stacked\n                          >\n                            <SpsCheckbox\n                                name=\"optionOne\"\n                                label=\"Checkbox Option 1\"\n                                checked={formValue.optionOne}\n                                formMeta={formMeta.fields.optionOne}\n                            />\n                            {formValue.optionOne && (<SpsConditionalField>\n                              <SpsTextInput\n                                value={formValue.conditionalField}\n                                formMeta={formMeta.fields.conditionalField}\n                                placeholder=\"Enter something here...\"\n                              />\n                            </SpsConditionalField>)\n                            }\n                            <SpsCheckbox\n                                name=\"optionTwo\"\n                                label=\"Checkbox Option 2\"\n                                checked={formValue.optionTwo}\n                                formMeta={formMeta.fields.optionTwo}\n                            />\n                            <SpsCheckbox\n                                name=\"optionThree\"\n                                label=\"Checkbox Option 3\"\n                                checked={formValue.optionThree}\n                                formMeta={formMeta.fields.optionThree}\n                            />\n                            <SpsCheckbox\n                                name=\"optionFour\"\n                                label=\"Checkbox Option 4\"\n                                checked={formValue.optionFour}\n                                formMeta={formMeta.fields.optionFour}\n                            />\n                          </SpsInputGroup>\n                        </SpsForm>\n                      )\n                    }\n                "], ["\n                    function Component() {\n                      const { formValue, formMeta, updateForm } = useSpsForm({\n                        optionOne: true,\n                        optionTwo: false,\n                        optionThree: false,\n                        optionFour: false,\n                        conditionalField: \"\",\n                      })\n\n                      return (\n                        <SpsForm formMeta={formMeta}>\n                          <SpsInputGroup\n                            stacked\n                          >\n                            <SpsCheckbox\n                                name=\"optionOne\"\n                                label=\"Checkbox Option 1\"\n                                checked={formValue.optionOne}\n                                formMeta={formMeta.fields.optionOne}\n                            />\n                            {formValue.optionOne && (<SpsConditionalField>\n                              <SpsTextInput\n                                value={formValue.conditionalField}\n                                formMeta={formMeta.fields.conditionalField}\n                                placeholder=\"Enter something here...\"\n                              />\n                            </SpsConditionalField>)\n                            }\n                            <SpsCheckbox\n                                name=\"optionTwo\"\n                                label=\"Checkbox Option 2\"\n                                checked={formValue.optionTwo}\n                                formMeta={formMeta.fields.optionTwo}\n                            />\n                            <SpsCheckbox\n                                name=\"optionThree\"\n                                label=\"Checkbox Option 3\"\n                                checked={formValue.optionThree}\n                                formMeta={formMeta.fields.optionThree}\n                            />\n                            <SpsCheckbox\n                                name=\"optionFour\"\n                                label=\"Checkbox Option 4\"\n                                checked={formValue.optionFour}\n                                formMeta={formMeta.fields.optionFour}\n                            />\n                          </SpsInputGroup>\n                        </SpsForm>\n                      )\n                    }\n                "]))),
            },
            withRadioButtons: {
                react: code(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$3(["\n                    function Component() {\n                      const { formValue, formMeta, updateForm } = useSpsForm({\n                        optionOne: true,\n                        optionTwo: false,\n                        optionThree: false,\n                        optionFour: false,\n                        radio: \"optionA\",\n                        conditionalField: \"\",\n                      })\n\n                      return (\n                        <SpsForm formMeta={formMeta}>\n                          <SpsInputGroup\n                            stacked\n                          >\n                            <SpsCheckbox\n                                name=\"optionOne\"\n                                label=\"Checkbox Option 1\"\n                                checked={formValue.optionOne}\n                                formMeta={formMeta.fields.optionOne}\n                            />\n                            <SpsConditionalField\n                              showCondition={!!formValue.optionOne}\n                            >\n                              <SpsInputGroup>\n                                <SpsRadioButton className=\"mr-2\" name=\"optionA\" value=\"optionA\" label=\"Option A\"\n                                  formMeta={formMeta.fields.radio}\n                                  checked={formValue.radio === \"optionA\"}\n                                ></SpsRadioButton>\n                                <SpsRadioButton name=\"optionB\" value=\"optionB\" label=\"Option B\"\n                                  formMeta={formMeta.fields.radio}\n                                  checked={formValue.radio === \"optionB\"}\n                                ></SpsRadioButton>                            \n                              </SpsInputGroup>\n                              <SpsConditionalField\n                                showCondition={formValue.radio === \"optionA\"}\n                              >\n                                <SpsTextInput\n                                  value={formValue.conditionalField}\n                                  formMeta={formMeta.fields.conditionalField}\n                                  placeholder=\"Enter something here...\"\n                                />\n                              </SpsConditionalField>\n                            </SpsConditionalField>\n                            <SpsCheckbox\n                                name=\"optionTwo\"\n                                label=\"Checkbox Option 2\"\n                                checked={formValue.optionTwo}\n                                formMeta={formMeta.fields.optionTwo}\n                            />\n                            <SpsCheckbox\n                                name=\"optionThree\"\n                                label=\"Checkbox Option 3\"\n                                checked={formValue.optionThree}\n                                formMeta={formMeta.fields.optionThree}\n                            />\n                            <SpsCheckbox\n                                name=\"optionFour\"\n                                label=\"Checkbox Option 4\"\n                                checked={formValue.optionFour}\n                                formMeta={formMeta.fields.optionFour}\n                            />\n                          </SpsInputGroup>\n                        </SpsForm>\n                      )\n                    }\n                "], ["\n                    function Component() {\n                      const { formValue, formMeta, updateForm } = useSpsForm({\n                        optionOne: true,\n                        optionTwo: false,\n                        optionThree: false,\n                        optionFour: false,\n                        radio: \"optionA\",\n                        conditionalField: \"\",\n                      })\n\n                      return (\n                        <SpsForm formMeta={formMeta}>\n                          <SpsInputGroup\n                            stacked\n                          >\n                            <SpsCheckbox\n                                name=\"optionOne\"\n                                label=\"Checkbox Option 1\"\n                                checked={formValue.optionOne}\n                                formMeta={formMeta.fields.optionOne}\n                            />\n                            <SpsConditionalField\n                              showCondition={!!formValue.optionOne}\n                            >\n                              <SpsInputGroup>\n                                <SpsRadioButton className=\"mr-2\" name=\"optionA\" value=\"optionA\" label=\"Option A\"\n                                  formMeta={formMeta.fields.radio}\n                                  checked={formValue.radio === \"optionA\"}\n                                ></SpsRadioButton>\n                                <SpsRadioButton name=\"optionB\" value=\"optionB\" label=\"Option B\"\n                                  formMeta={formMeta.fields.radio}\n                                  checked={formValue.radio === \"optionB\"}\n                                ></SpsRadioButton>                            \n                              </SpsInputGroup>\n                              <SpsConditionalField\n                                showCondition={formValue.radio === \"optionA\"}\n                              >\n                                <SpsTextInput\n                                  value={formValue.conditionalField}\n                                  formMeta={formMeta.fields.conditionalField}\n                                  placeholder=\"Enter something here...\"\n                                />\n                              </SpsConditionalField>\n                            </SpsConditionalField>\n                            <SpsCheckbox\n                                name=\"optionTwo\"\n                                label=\"Checkbox Option 2\"\n                                checked={formValue.optionTwo}\n                                formMeta={formMeta.fields.optionTwo}\n                            />\n                            <SpsCheckbox\n                                name=\"optionThree\"\n                                label=\"Checkbox Option 3\"\n                                checked={formValue.optionThree}\n                                formMeta={formMeta.fields.optionThree}\n                            />\n                            <SpsCheckbox\n                                name=\"optionFour\"\n                                label=\"Checkbox Option 4\"\n                                checked={formValue.optionFour}\n                                formMeta={formMeta.fields.optionFour}\n                            />\n                          </SpsInputGroup>\n                        </SpsForm>\n                      )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$3, templateObject_2$2;

/* eslint-disable react/prop-types */
var MANIFEST = {
    "Advanced Search": {
        components: [SpsAdvancedSearch],
        examples: SpsAdvancedSearchExamples,
    },
    Autocomplete: {
        components: [SpsAutocomplete],
        examples: SpsAutocompleteExamples,
    },
    Buttons: {
        description: function () { return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sps-body-14" }, "Buttons are used to initiate events or actions. The labels and/or icons describe what the button will do."),
            React.createElement("br", null),
            React.createElement("h5", null, "Variants"),
            React.createElement("div", { className: "sps-body-14" },
                React.createElement("span", { className: "sps-text-semibold" }, "Default:"),
                "For tertiary actions or actions of lower importance on a page."),
            React.createElement("div", { className: "sps-body-14" },
                React.createElement("span", { className: "sps-text-semibold" }, "Key:"),
                "For primary or important actions on a page."),
            React.createElement("div", { className: "sps-body-14" },
                React.createElement("span", { className: "sps-text-semibold" }, "Confirm:"),
                "For the main call to action on a page. There should only be one Confirm button per screen."),
            React.createElement("div", { className: "sps-body-14" },
                React.createElement("span", { className: "sps-text-semibold" }, "Delete:"),
                "For deleting information or another destructive action. These should always be paired with a Delete Confirmation Modal."),
            React.createElement("div", { className: "sps-body-14" },
                React.createElement("span", { className: "sps-text-semibold" }, "Disabled:"),
                "For actions that are not permitted in a particular state. These can be accompanied by a Tooltip on hover describing why it\u2019s disabled."),
            React.createElement("div", { className: "sps-body-14" },
                React.createElement("span", { className: "sps-text-semibold" }, "With an Icon:"),
                "For further illustrating the action. Example: Pencil icon in an Edit button. There can also be Icon Buttons without text."))); },
        components: [SpsButton, SpsButtonGroup],
        examples: SpsButtonExamples,
    },
    Cards: {
        description: function () { return (React.createElement("p", null, "Cards are used to group similar or related content together in a single container. They can be combined with additional elements such as Headers, Footers, or Tabs.")); },
        components: [],
        examples: SpsCardExamples,
    },
    Checkbox: {
        components: [SpsCheckbox],
        examples: SpsCheckboxExamples,
    },
    "Clickable Tags": {
        components: [SpsClickableTag],
        examples: SpsClickableTagExamples,
    },
    "Column Chooser": {
        components: [SpsColumnChooser, SpsColumnChooserColumn],
        examples: SpsColumnChooserExamples,
    },
    "Conditional Fields": {
        description: function () { return (React.createElement("p", null, "A conditional field is one that is only available when a certain option is selected amongst a set of checkboxes or radio buttons.")); },
        components: [SpsConditionalField],
        examples: SpsConditionalFieldExamples,
    },
    "Content Rows": {
        components: [
            SpsContentRow,
            SpsContentRowCol,
            SpsContentRowExpansion,
            SpsSortingHeader,
            SpsSortingHeaderCell,
        ],
        examples: SpsContentRowExamples,
    },
    "Content Tiles": {
        components: [SpsTile,
            SpsTileList,
            SpsSortingHeader,
            SpsSortingHeaderCell],
        examples: SpsTileListExamples,
    },
    "Filter Tiles": {
        components: [SpsFilterTile, SpsFilterTileList],
        examples: SpsFilterTileListExamples,
    },
    Datepicker: {
        components: [SpsDatepicker],
        examples: SpsDatepickerExamples,
    },
    "Date Range Picker": {
        components: [SpsDateRangePicker],
        examples: SpsDateRangePickerExamples,
    },
    Datetime: {
        components: [SpsDateTime],
        examples: SpsDatetimeExamples,
    },
    "Description Lists": {
        components: [SpsDescriptionList,
            SpsDescriptionListDefinition,
            SpsDescriptionListTerm],
        examples: SpsDescriptionListExamples,
    },
    Dropdown: {
        components: [SpsDropdown, SpsCheckboxDropdown],
        examples: SpsDropdownExamples,
    },
    "Feedback Blocks": {
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "Feedback Blocks show static informational messages on a page. They should not dynamically appear or disappear. For feedback that responds to a user action, Use a ",
                    React.createElement(NavigateTo, { to: "growler" }, "Growler"),
                    " instead."),
                React.createElement("h5", null, "Variants"),
                React.createElement("p", null, "Variants are generally tied to a specific color and an accompanying icon."),
                React.createElement(SpsMicroBlock, { kind: FeedbackBlockKind.ERROR, message: "Error" }),
                React.createElement(SpsMicroBlock, { kind: FeedbackBlockKind.INFO, message: "Information" }),
                React.createElement(SpsMicroBlock, { kind: FeedbackBlockKind.TIP, message: "Tip" }),
                React.createElement(SpsMicroBlock, { kind: FeedbackBlockKind.SUCCESS, message: "Success" }),
                React.createElement(SpsMicroBlock, { kind: FeedbackBlockKind.WARNING, message: "Warning" })));
        },
        components: [SpsFeedbackBlock, SpsMicroBlock],
        examples: SpsFeedbackBlockExamples,
    },
    Fieldset: {
        components: [SpsFieldset],
        examples: SpsFieldsetExamples,
    },
    "Filter Panel": {
        components: [
            SpsFilterPanel,
            SpsFilterPanelSection,
            SpsFilterPanelCap,
            SpsFilterPanelFilterBox,
        ],
        examples: SpsFilterPanelExamples,
    },
    "Focused Task": {
        components: [SpsFocusedTask, SpsFocusedTaskActions],
        examples: SpsFocusedTaskExamples,
    },
    Form: {
        components: [SpsForm],
        examples: SpsFormExamples,
    },
    Growlers: {
        description: function () { return (React.createElement("p", null, "Use Growlers for dynamic messages in response to a user's action. All Growlers have a Primary Message, and may optionally have a Secondary Message as needed. Growlers may also contain Hyperlinks in the Secondary Message.")); },
        components: [SpsGrowler],
        examples: SpsGrowlerExamples,
    },
    /*
     * "Icon": {
     *     components: [SpsI],
     *     examples: // TODO: Needs example file
     * },
     */
    Incrementor: {
        components: [SpsIncrementor],
        examples: SpsIncrementorExamples,
    },
    "Insight Tiles": {
        components: [SpsInsights, SpsInsightTile],
        examples: SpsInsightTileExamples,
    },
    "Key Value Lists": {
        components: [SpsKeyValueList, SpsKeyValueListItem],
        examples: SpsKeyValueListExamples,
    },
    Label: {
        components: [SpsLabel],
        examples: SpsLabelExamples,
    },
    "List Action Bar": {
        description: function () { return (React.createElement("p", null, "The List Action Bar contains the action buttons relevant to selected items from a Table List, Row List, or Card List. The List Action Bar is only visible when one or more list items have been selected and appears anchored to the bottom of the page above all other content.")); },
        components: [SpsListActionBar],
        examples: SpsListActionBarExamples,
    },
    "List Toolbar": {
        description: function () { return (React.createElement("p", null, "The List Toolbar provides the ability to interact with elements in a list or table. It can contain elements to search, filter, sort, or perform other actions.")); },
        components: [SpsListToolbar,
            SpsListToolbarSearch,
            SpsListToolbarSearchInfo],
        examples: SpsListToolbarExamples,
    },
    "Micro Block": {
        components: [SpsMicroBlock],
        examples: SpsMicroBlockExamples,
    },
    Modals: {
        description: function () { return (React.createElement("p", null, "Modals are overlays on a page that focus a user\u2019s attention on an important message or a simple action. Examples of a Modal include confirming the deletion of a record, or making a single selection.")); },
        components: [SpsModalV2, SpsModalV2Footer],
        examples: SpsModalExamples,
    },
    "Multi Select": {
        components: [SpsMultiSelect],
        examples: SpsMultiSelectExamples,
    },
    "Page Title": {
        components: [SpsPageTitle, SpsPageSubtitle],
        examples: SpsPageTitleExamples,
    },
    Pagination: {
        description: function () { return (React.createElement("p", null, "The Pagination component allows users to navigate lists of records and control the number of records displayed on each page. The records can span across multiple pages, or within sections of a page.")); },
        components: [SpsPagination, SpsPageSelector],
        examples: SpsPaginationExamples,
    },
    "Product Bar": {
        components: [SpsProductBar, SpsProductBarTab],
        examples: SpsProductBarExamples,
    },
    "Progress Bar": {
        description: function () { return (React.createElement("p", null, "Progress Bars are used to visualize the progression of a process (such as a file upload) or series of related tasks that take place over a longer period of time. Progress Bars can be accompanied by a variety of additional content to provide more context regarding the processes being performed.")); },
        components: [SpsProgressBar],
        examples: SpsProgressBarExamples,
    },
    "Radio Buttons": {
        components: [SpsRadioButton],
        examples: SpsRadioButtonExamples,
    },
    "Scrollable Container": {
        components: [SpsScrollableContainer],
        examples: SpsScrollableContainerExamples,
    },
    "Search Results Bar": {
        components: [SpsSearchResultsBar],
        examples: SpsSearchResultsBarExamples,
    },
    Select: {
        components: [SpsSelect],
        examples: SpsSelectExamples,
    },
    "Side Navigation": {
        description: "Side Navigations are used to provide quick access to a series of related pages or content. It can be used to navigate between different page views, or as an anchor-style menu to scroll to specific content on the same page.",
        components: [SpsSideNav],
        examples: SpsSideNavExamples,
    },
    Spinner: {
        components: [SpsSpinner],
        examples: SpsSpinnerExamples,
    },
    "Split Button": {
        components: [SpsSplitButton],
        examples: SpsSplitButtonExamples,
    },
    "Stepped Progress Bar": {
        components: [SpsSteppedProgressBar],
        examples: SpsSteppedProgressBarExamples,
    },
    "Slack Link": {
        components: [SpsSlackLink],
        examples: SpsSlackLinkExamples,
    },
    "Summary List Row": {
        components: [SpsSummaryListRow,
            SpsSummaryListColumn,
            SpsSummaryListExpansion],
        examples: SpsSummaryListExamples,
    },
    Tables: {
        description: function (_a) {
            var NavigateTo = _a.NavigateTo;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sps-body-14" },
                    "Tables (along with ",
                    React.createElement(NavigateTo, { to: "content-rows" }, "Content Rows"),
                    " and",
                    " ",
                    React.createElement(NavigateTo, { to: "content-tiles" }, "Content Tiles"),
                    ") are one of three options for displaying a list of records on a page."),
                React.createElement("br", null),
                React.createElement("div", { className: "sps-body-14" }, "Tables are the ideal solution for displaying tabular data, especially when the listed records contain a considerable amount of data points. While tables are primarily used to display an extensive list of records, often in a paginated format, they can also be used to display smaller sets of tabular data in any context.")));
        },
        components: [
            SpsTable,
            SpsTableBody,
            SpsTableCell,
            SpsTableHead,
            SpsTableHeader,
            SpsTableRow,
        ],
        examples: SpsTableExamples,
    },
    Tags: {
        components: [SpsTag],
        examples: SpsTagExamples,
    },
    "Task Queue": {
        components: [SpsTaskQueue],
        examples: SpsTaskQueueExamples,
    },
    "Text Input": {
        components: [SpsTextInput],
        examples: SpsTextInputExamples,
    },
    Textarea: {
        components: [SpsTextarea],
        examples: SpsTextareaExamples,
    },
    Toggle: {
        components: [SpsToggle],
        examples: SpsToggleExamples,
    },
    Tooltips: {
        components: [SpsTooltip, SpsTooltipTitle],
        examples: SpsTooltipExamples,
    },
    Wizard: {
        components: [SpsWizardSidebar, SpsWizardSubstep],
        examples: SpsWizardExamples,
    },
    Workflow: {
        components: [SpsWorkflow,
            SpsWorkflowDocument,
            SpsWorkflowDocumentStatus,
            SpsWorkflowStep],
        examples: SpsWorkflowExamples,
    },
    "Zero States": {
        description: "Zero States are placeholders in content areas when there is no content to show. You can view all available illustrations on the Illustrations page.",
        components: [SpsZeroState, SpsMicroZeroState],
        examples: SpsZeroStateExamples,
    },
};

var __read$9 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var moment$1 = moment$6.default || moment$6;
function newWeekArray() {
    return (new Array(7)).fill(null);
}
function generateWeeks(date) {
    var dateAsMoment = moment$1({
        year: date.year,
        month: date.month - 1,
        date: 1,
    });
    var weekdayArrayIndex = dateAsMoment.weekday();
    var daysInMonth = dateAsMoment.daysInMonth();
    var weeksInMonth = Math.ceil((daysInMonth + weekdayArrayIndex) / 7);
    var daysOnCalendar = weeksInMonth * 7;
    var newWeeks = new Array(weeksInMonth).fill(true)
        .map(newWeekArray);
    dateAsMoment.subtract(weekdayArrayIndex, "days");
    for (var dateIndex = 0; dateIndex < daysOnCalendar; dateIndex += 1) {
        var week = newWeeks[Math.floor(dateIndex / 7)];
        var dayOfWeekIndex = dateIndex % 7;
        week[dayOfWeekIndex] = Object.freeze({
            year: dateAsMoment.year(),
            month: dateAsMoment.month() + 1,
            date: dateAsMoment.date(),
        });
        if (dayOfWeekIndex === 6) {
            Object.freeze(week);
        }
        dateAsMoment.add(1, "day");
    }
    return newWeeks;
}
function useCalendar(month) {
    var _a = __read$9(React.useState(function () { return generateWeeks(month); }), 2), cal = _a[0], setCal = _a[1];
    React.useEffect(function () {
        setCal(generateWeeks(month));
    }, [month]);
    return cal;
}

var __read$8 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function useMoment(date) {
    var _a = __read$8(React.useState(function () { return SimpleDateUtils.toMoment(date); }), 2), momentValue = _a[0], setMomentValue = _a[1];
    React.useEffect(function () { return setMomentValue(SimpleDateUtils.toMoment(date)); }, [date]);
    return momentValue;
}

var __assign$e = (undefined && undefined.__assign) || function () {
    __assign$e = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$e.apply(this, arguments);
};
var __rest$a = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$7 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var moment = moment$6.default || moment$6;
var propTypes$c = __assign$e(__assign$e({}, spsGlobalPropTypes), { maxDate: impl(), minDate: impl(), onNewSelection: fun().isRequired, selectedDate: impl(), selectedRange: propTypes$1H.exports.arrayOf(impl()) });
var CSS_ELEMENT$1 = "sps-datepicker__calendar";
function determineViewMonth(_a) {
    var maxDate = _a.maxDate, selectedDate = _a.selectedDate, selectedRange = _a.selectedRange;
    var rangeDate = selectedRange
        ? (SimpleDateUtils.nullifyInvalidDate(selectedRange[1])
            || SimpleDateUtils.nullifyInvalidDate(selectedRange[0]))
        : null;
    return SimpleDateUtils.nullifyInvalidDate(selectedDate)
        || rangeDate
        || SimpleDateUtils.nullifyInvalidDate(maxDate)
        || SimpleDateUtils.create();
}
function SpsDatepickerCalendar(props) {
    props.children; var className = props.className, maxDate = props.maxDate, minDate = props.minDate, onNewSelection = props.onNewSelection, selectedDate = props.selectedDate, selectedRange = props.selectedRange, rest = __rest$a(props, ["children", "className", "maxDate", "minDate", "onNewSelection", "selectedDate", "selectedRange"]);
    var t = React.useContext(I18nContext).t;
    var _a = __read$7(React.useState(function () { return determineViewMonth(props); }), 2), viewMonth = _a[0], setViewMonth = _a[1];
    React.useEffect(function () {
        setViewMonth(determineViewMonth(props));
    }, [selectedDate,
        selectedRange,
        maxDate]);
    var viewMonthMoment = useMoment(viewMonth);
    var cal = useCalendar(viewMonth);
    var _b = __read$7(React.useState(), 2), mouseoverDate = _b[0], setMouseoverDate = _b[1];
    function viewPreviousMonth() {
        // setting date to 15 b/c every month has a 15 and timezone shifts shouldn't change the month
        var newDate = SimpleDateUtils.prevMonth(__assign$e(__assign$e({}, viewMonth), { date: 15 }));
        setViewMonth(newDate);
    }
    function viewNextMonth() {
        // setting date to 15 b/c every month has a 15 and timezone shifts shouldn't change the month
        setViewMonth(SimpleDateUtils.nextMonth(__assign$e(__assign$e({}, viewMonth), { date: 15 })));
    }
    function handleMouseEnter(event) {
        if (event.target && event.target.classList.contains(CSS_ELEMENT$1 + "-day")) {
            setMouseoverDate(__assign$e(__assign$e({}, viewMonth), { date: Number(event.target.textContent) }));
        }
        else if (!event.target || !event.target.classList.contains(CSS_ELEMENT$1 + "-row")) {
            setMouseoverDate(null);
        }
    }
    function calendarCellClasses(date) {
        var CSS_ELEMENT_DAY = CSS_ELEMENT$1 + "-day";
        return clsx(CSS_ELEMENT$1 + "-cell", date && viewMonth && date.month === viewMonth.month && CSS_ELEMENT_DAY, ((SimpleDateUtils.isSameDate(date, selectedDate)
            // explicit check for false b/c SimpleDateUtils.isInRange can return undefined
            && SimpleDateUtils.isInRange(date, [minDate, maxDate]) !== false)
            || (selectedRange && SimpleDateUtils.isSameDate(date, selectedRange[0]))
            || SimpleDateUtils.isInRange(date, selectedRange)) && CSS_ELEMENT_DAY + "--selected", 
        // explicit check for false because SimpleDateUtils.isInRange can return undefined
        SimpleDateUtils.isInRange(date, [minDate, maxDate]) === false && CSS_ELEMENT_DAY + "--disabled", (selectedRange
            && selectedRange[1]
            && SimpleDateUtils.isSameDate(date, selectedRange[0])
            && !SimpleDateUtils.isSameDate(date, selectedRange[1])) && CSS_ELEMENT_DAY + "--selection-start", SimpleDateUtils.isInRange(date, selectedRange, false) && CSS_ELEMENT_DAY + "--selection-middle", (selectedRange
            && SimpleDateUtils.isSameDate(date, selectedRange[1])
            && !SimpleDateUtils.isSameDate(date, selectedRange[0])) && CSS_ELEMENT_DAY + "--selection-end", (selectedRange
            && selectedRange[0]
            && !selectedRange[1]
            && ((!minDate && !maxDate)
                || SimpleDateUtils.isInRange(mouseoverDate, [minDate, maxDate]))
            && SimpleDateUtils.isInRange(date, [selectedRange[0], mouseoverDate], false)) && CSS_ELEMENT_DAY + "--pending-selection");
    }
    function handleCellClick(date) {
        if (date
            && viewMonth
            && date.month === viewMonth.month
            && SimpleDateUtils.isInRange(date, [minDate, maxDate]) !== false) {
            onNewSelection(date);
        }
    }
    var classes = clsx(CSS_ELEMENT$1, className);
    return viewMonth ? (React.createElement("div", __assign$e({ className: classes }, rest, { onMouseOver: handleMouseEnter }),
        React.createElement("div", { className: CSS_ELEMENT$1 + "-head" },
            React.createElement("button", { type: "button", tabIndex: -1, disabled: SimpleDateUtils.isSameMonth(viewMonth, minDate), title: t("design-system:datepicker.calendar.prevMonth"), className: "sps-datepicker__button sps-datepicker__button-previous-month", onClick: viewPreviousMonth },
                React.createElement("i", { className: "sps-icon sps-icon-chevron-left" })),
            React.createElement("span", { className: CSS_ELEMENT$1 + "-head-label" },
                React.createElement("span", { className: CSS_ELEMENT$1 + "-head-label-month" }, viewMonthMoment.format("MMMM")),
                React.createElement("span", { className: CSS_ELEMENT$1 + "-head-label-year" }, viewMonth.year)),
            React.createElement("button", { type: "button", tabIndex: -1, disabled: SimpleDateUtils.isSameMonth(viewMonth, maxDate), title: t("design-system:datepicker.calendar.nextMonth"), className: "sps-datepicker__button sps-datepicker__button-next-month", onClick: viewNextMonth },
                React.createElement("i", { className: "sps-icon sps-icon-chevron-right" }))),
        React.createElement("div", { className: CSS_ELEMENT$1 + "-body" },
            React.createElement("div", { className: "sps-datepicker__calendar-row" }, moment.weekdaysShort().map(function (dayName) { return (React.createElement("div", { key: dayName, className: "sps-datepicker__calendar-header-cell" }, dayName)); })),
            cal.map(function (week, i) { return (
            /* eslint-disable react/no-array-index-key */
            React.createElement("div", { key: i, className: "sps-datepicker__calendar-row" }, week.map(function (date, j) { return (React.createElement("div", { key: j, className: calendarCellClasses(date), onClick: function () { return handleCellClick(date); } }, date ? date.date : "")); }))
            /* eslint-enable react/no-array-index-key */
            ); })))) : React.createElement(React.Fragment, null);
}
Object.assign(SpsDatepickerCalendar, {
    propTypes: propTypes$c,
    displayName: "SpsDatepickerCalendar",
});

var __assign$d = (undefined && undefined.__assign) || function () {
    __assign$d = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$d.apply(this, arguments);
};
var __rest$9 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$6 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var CSS_ELEMENT = "sps-datepicker__popup";
var propTypes$b = __assign$d(__assign$d({}, spsGlobalPropTypes), { attachTo: ref().isRequired, isOpen: propTypes$1H.exports.bool.isRequired });
var SpsDatepickerPopup = React.forwardRef(function (_a, ref) {
    var 
    // eslint rule react/prop-types sometimes has trouble w/forwardRef
    /* eslint-disable react/prop-types */
    attachTo = _a.attachTo, children = _a.children, className = _a.className, isOpen = _a.isOpen, rest = __rest$9(_a, ["attachTo", "children", "className", "isOpen"]);
    var rootRef = ref || React.useRef(null);
    var portal = usePortal("sps-datepicker-popup-portal");
    var portalContext = React.useContext(PortalContext);
    var _b = __read$6(isOpen
        ? getPosition(rootRef, attachTo, Position.BOTTOM_LEFT, __assign$d({}, portalContext))
        : [{}], 1), posStyle = _b[0];
    var classes = clsx(CSS_ELEMENT, "z-stratum-dropdown", isOpen && CSS_ELEMENT + "--open", className);
    return portal(React.createElement("div", __assign$d({}, rest, { className: classes, ref: rootRef, style: posStyle }), children));
});
Object.assign(SpsDatepickerPopup, {
    propTypes: propTypes$b,
    displayName: "SpsDatepickerPopup",
});

var __assign$c = (undefined && undefined.__assign) || function () {
    __assign$c = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$c.apply(this, arguments);
};
var __rest$8 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$5 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$a = {
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<SimpleDate>",
    maxDate: "SimpleDate",
    minDate: "SimpleDate",
    onChange: "(newDate: SimpleDate) => void",
    value: "SimpleDate",
};
var propTypes$a = __assign$c(__assign$c({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, formMeta: impl(), maxDate: impl(), minDate: impl(), onChange: fun(), value: impl() });
var CSS_BLOCK$1 = "sps-datepicker";
function SpsDatepickerV2(_a) {
    _a.children; var className = _a.className, disabled = _a.disabled, formMeta = _a.formMeta, id = _a.id, maxDate = _a.maxDate, minDate = _a.minDate, onChange = _a.onChange, value = _a.value, rest = __rest$8(_a, ["children", "className", "disabled", "formMeta", "id", "maxDate", "minDate", "onChange", "value"]);
    var _b = useFormControlId(id, formMeta), wrapperId = _b.wrapperId, controlId = _b.controlId;
    var rootRef = React.useRef(null);
    var datepickerPopupRef = React.useRef(null);
    var textInput = React.useRef();
    var _c = __read$5(React.useState(SimpleDateUtils.toString(value)), 2), stringValue = _c[0], setStringValue = _c[1];
    var _d = useInputPopup(rootRef, datepickerPopupRef), showPopup = _d.showPopup, doShowPopup = _d.doShowPopup;
    function updateValue(newValue) {
        if (formMeta) {
            formMeta.setValue(newValue);
            formMeta.markAsDirty();
        }
        if (onChange) {
            onChange(newValue);
        }
    }
    function handleNewSelection(newSelection) {
        updateValue(newSelection);
        setStringValue(SimpleDateUtils.toString(newSelection));
        if (textInput && textInput.current) {
            textInput.current.focus();
        }
    }
    function handleTextInputChange(event) {
        setStringValue(event.target.value);
        var newDate = SimpleDateUtils.createFrom(event.target.value);
        updateValue(newDate);
    }
    function clear() {
        setStringValue("");
        updateValue();
    }
    var classes = clsx(CSS_BLOCK$1, "sps-text-input", showPopup && CSS_BLOCK$1 + "--open", className);
    React.useEffect(function () {
        if (!value || SimpleDateUtils.isValid(value)) {
            setStringValue(SimpleDateUtils.toString(value));
        }
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formMeta: formMeta, inputRef: textInput, focusInputOnClick: true, ref: rootRef },
            React.createElement("div", { className: clsx("sps-form-control", disabled && "disabled") },
                React.createElement("i", { className: clsx("sps-text-input__icon", "sps-icon", "sps-icon-calendar-blank") }),
                React.createElement("input", __assign$c({ type: "text", ref: textInput, className: "sps-text-input__input", id: controlId, placeholder: FORMAT, onChange: handleTextInputChange, onClick: doShowPopup, onFocus: doShowPopup, value: stringValue, disabled: disabled }, rest)),
                value && !disabled && (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: clear })))),
        React.createElement(SpsDatepickerPopup, { isOpen: showPopup, attachTo: rootRef, ref: datepickerPopupRef },
            React.createElement(SpsDatepickerCalendar, { selectedDate: value, onNewSelection: handleNewSelection, minDate: minDate, maxDate: maxDate }))));
}
Object.assign(SpsDatepickerV2, {
    props: propsDoc$a,
    propTypes: propTypes$a,
    displayName: "SpsDatepickerV2",
});

var __assign$b = (undefined && undefined.__assign) || function () {
    __assign$b = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$b.apply(this, arguments);
};
var __rest$7 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$4 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$9 = {
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<SimpleDateRange | DatePreset>",
    maxDate: "SimpleDate",
    minDate: "SimpleDate",
    onChange: "(newDateRange: SimpleDateRange | DatePreset) => void",
    presets: "Array<DatePreset>",
    value: "SimpleDateRange | DatePreset",
};
var propTypes$9 = __assign$b(__assign$b({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, formMeta: impl(), maxDate: impl(), minDate: impl(), onChange: fun(), presets: propTypes$1H.exports.arrayOf(impl()) });
var CSS_BLOCK = "sps-datepicker";
var DEFAULT_PRESETS = [
    { definition: "P0D", label: "design-system:datepicker.preset.today" },
    { definition: "P7D", label: "design-system:datepicker.preset.sevenDays" },
    { definition: "P30D", label: "design-system:datepicker.preset.thirtyDays" },
    { definition: "P60D", label: "design-system:datepicker.preset.sixtyDays" },
    { definition: "P90D", label: "design-system:datepicker.preset.ninetyDays" },
    { definition: "P1Y", label: "design-system:datepicker.preset.oneYear" },
];
function SpsDateRangePickerV2(_a) {
    _a.children; var className = _a.className, disabled = _a.disabled, formMeta = _a.formMeta, id = _a.id, maxDate = _a.maxDate, minDate = _a.minDate, onChange = _a.onChange, _b = _a.presets, presets = _b === void 0 ? DEFAULT_PRESETS : _b, value = _a.value, rest = __rest$7(_a, ["children", "className", "disabled", "formMeta", "id", "maxDate", "minDate", "onChange", "presets", "value"]);
    var t = React.useContext(I18nContext).t;
    var _c = useFormControlId(id, formMeta), wrapperId = _c.wrapperId, controlId = _c.controlId;
    var rootRef = React.useRef(null);
    var textInput = React.useRef();
    var popupRef = React.useRef();
    var _d = __read$4(React.useState(Array.isArray(value) ? SimpleDateUtils.toStringRange(value) : ""), 2), stringValue = _d[0], setStringValue = _d[1];
    var _e = __read$4(React.useState(null), 2), selectedPreset = _e[0], setSelectedPreset = _e[1];
    var _f = __read$4(React.useState(), 2), displayRange = _f[0], setDisplayRange = _f[1];
    var _g = useInputPopup(rootRef, popupRef), showPopup = _g.showPopup, doShowPopup = _g.doShowPopup, doHidePopup = _g.doHidePopup;
    function updateValue(newValue) {
        if (formMeta) {
            formMeta.setValue(newValue);
            formMeta.markAsDirty();
        }
        if (onChange) {
            onChange(newValue);
        }
    }
    function handleNewSelection(newSelection) {
        var curValue = value || [];
        var newValue;
        if (!curValue[0]
            || curValue[1]
            || SimpleDateUtils.isBefore(newSelection, curValue[0])) {
            newValue = [newSelection, null];
        }
        else {
            newValue = [curValue[0], newSelection];
            doHidePopup(true);
            if (textInput && textInput.current) {
                textInput.current.focus();
            }
        }
        updateValue(newValue);
        setStringValue(SimpleDateUtils.toStringRange(newValue));
        setDisplayRange(null);
        setSelectedPreset(null);
    }
    function handleTextInputChange(event) {
        setStringValue(event.target.value);
        var newRange = SimpleDateUtils.createRangeFrom(event.target.value);
        updateValue(newRange);
        setDisplayRange(null);
    }
    function clear() {
        setStringValue("");
        updateValue();
        setDisplayRange(null);
        setSelectedPreset(null);
    }
    function handleTextInputKeyDown(event) {
        switch (event.key) {
            case "Tab":
                doHidePopup();
                break;
            case "Backspace":
                if (event.target.selectionStart === 0
                    && value && !Array.isArray(value)) {
                    clear();
                }
                break;
        }
    }
    function selectPreset(newPreset) {
        if (!newPreset) {
            setSelectedPreset(null);
            updateValue(null);
            return;
        }
        setStringValue("");
        setSelectedPreset(newPreset);
        updateValue(SimpleDateUtils.createRangeFromPreset(newPreset));
    }
    React.useEffect(function () {
        if (!value) {
            return;
        }
        /*
         * reference equality check to see if custom presets have been passed
         * if there are custom presets we check if we have to preselect one of them
         *
         * this is cumbersome, but it is related to the problem with passing
         * preset as initial value to the useSpsForm hook
         *
         * !!! consider improving this component by restricting formMeta to just
         * one type instead of `SpsFormFieldMeta<SimpleDateRange | DatePreset>`
         */
        if (presets !== DEFAULT_PRESETS && Array.isArray(value)) {
            var preselectedRange_1 = SimpleDateUtils.toStringRange(value);
            var preselectedPreset = presets.find(function (preset) { return preselectedRange_1 === SimpleDateUtils.toStringRange(SimpleDateUtils.createRangeFromPreset(preset)); });
            if (preselectedPreset) {
                selectPreset(preselectedPreset);
            }
        }
    }, []);
    React.useEffect(function () {
        if (!value) {
            clear();
        }
        else if (Array.isArray(value) && !selectedPreset) {
            if (value.every(function (v) { return SimpleDateUtils.isValid(v); })) {
                setStringValue(SimpleDateUtils.toStringRange(value));
            }
            setDisplayRange(null);
        }
        else if (Array.isArray(value) && selectedPreset) {
            setStringValue("");
        }
    }, [value, selectedPreset]);
    function getPresetText(preset) {
        return preset && /^design-system:/.test(preset.label)
            ? t(preset.label)
            : preset.label;
    }
    var classes = clsx(CSS_BLOCK, "sps-text-input", showPopup && CSS_BLOCK + "--open", className);
    return (React.createElement(React.Fragment, null,
        React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formMeta: formMeta, inputRef: textInput, focusInputOnClick: true, ref: rootRef },
            React.createElement("div", { className: clsx("sps-form-control", disabled && "disabled") },
                React.createElement("i", { className: clsx("sps-text-input__icon", "sps-icon", "sps-icon-calendar") }),
                selectedPreset && (React.createElement("div", { className: "sps-datepicker__selected-preset" },
                    React.createElement("span", { className: "sps-tag sps-tag--info" }, getPresetText(selectedPreset)))),
                React.createElement("input", __assign$b({ type: "text", ref: textInput, className: "sps-text-input__input", id: controlId, placeholder: (!stringValue && !selectedPreset) ? FORMAT : undefined, onChange: handleTextInputChange, onClick: doShowPopup, onFocus: doShowPopup, onKeyDown: handleTextInputKeyDown, value: stringValue, disabled: disabled }, rest)),
                value && !disabled && (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: clear })))),
        React.createElement(SpsDatepickerPopup, { isOpen: showPopup, attachTo: rootRef, ref: popupRef },
            React.createElement("div", { className: "sps-datepicker__presets" },
                React.createElement("fieldset", null,
                    React.createElement("legend", { className: "sps-datepicker__presets-label" }, t("design-system:datepicker.presetsLabel")),
                    React.createElement("div", { className: "sps-custom-control sps-custom-radio sps-custom-control--no-error" },
                        React.createElement("input", { type: "radio", id: "sps-date-range-picker-" + wrapperId + "__range-custom", className: "sps-custom-control__input", checked: !selectedPreset, name: "sps-date-range-picker-" + wrapperId + "__range", onChange: function () { return selectPreset(null); } }),
                        React.createElement("label", { className: "sps-custom-control__label", htmlFor: "sps-date-range-picker-" + wrapperId + "__range-custom" }, t("design-system:datepicker.preset.custom"))),
                    presets.map(function (preset, i) { return (React.createElement("div", { key: getPresetText(preset), className: "sps-custom-control sps-custom-radio sps-custom-control--no-error" },
                        React.createElement("input", { type: "radio", id: "sps-date-range-picker-" + wrapperId + "__range-" + i, name: "sps-date-range-picker-" + wrapperId + "__range", onChange: function () { return selectPreset(preset); }, checked: (selectedPreset === null || selectedPreset === void 0 ? void 0 : selectedPreset.definition)
                                ? selectedPreset.definition === preset.definition
                                : false, className: "sps-custom-control__input" }),
                        React.createElement("label", { className: "sps-custom-control__label", htmlFor: "sps-date-range-picker-" + wrapperId + "__range-" + i }, getPresetText(preset)))); }))),
            React.createElement(SpsDatepickerCalendar, { selectedRange: Array.isArray(value) ? value : displayRange, onNewSelection: handleNewSelection, minDate: minDate, maxDate: maxDate }))));
}
Object.assign(SpsDateRangePickerV2, {
    props: propsDoc$9,
    propTypes: propTypes$9,
    displayName: "SpsDateRangePickerV2",
});

var __assign$a = (undefined && undefined.__assign) || function () {
    __assign$a = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$a.apply(this, arguments);
};
var __rest$6 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$8 = {
    disabled: "boolean",
    formMeta: "SpsFormFieldMeta<number>",
    name: "string",
    onChange: "ChangeEventHandler<number>",
    value: "number",
};
var propTypes$8 = __assign$a(__assign$a({}, spsGlobalPropTypes), { disabled: propTypes$1H.exports.bool, formMeta: impl(), name: propTypes$1H.exports.string, onChange: fun(), ref: ref(), value: propTypes$1H.exports.number });
function strToDollars(str) {
    return str
        ? Number.parseInt(str.replace(/[^\d]/g, ""), 10) / 100
        : null;
}
function dollarsToStr(dollars) {
    return typeof dollars === "number"
        ? dollars.toFixed(2)
        : "";
}
function SpsCurrencyInput(_a) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, formMeta = _a.formMeta, id = _a.id, name = _a.name, onChange = _a.onChange, ref = _a.ref, title = _a.title, value = _a.value, rest = __rest$6(_a, ["className", "disabled", "formMeta", "id", "name", "onChange", "ref", "title", "value"]);
    var _c = useFormControlId(id, formMeta), wrapperId = _c.wrapperId, controlId = _c.controlId;
    var textInput = React.useRef();
    function setAndPropagateValue(newValue) {
        if (formMeta) {
            formMeta.setValue(newValue);
            formMeta.markAsDirty();
        }
        if (onChange) {
            onChange(newValue);
        }
    }
    function clear() {
        setAndPropagateValue(null);
    }
    function handleChange(event) {
        setAndPropagateValue(strToDollars(event.target.value));
    }
    function sendCursorToEnd(event) {
        event.currentTarget.setSelectionRange(event.currentTarget.value.length, event.currentTarget.value.length);
    }
    var classes = clsx("sps-text-input", className);
    return (React.createElement(SpsFormComponentWrapper, { id: wrapperId, className: classes, formMeta: formMeta, inputRef: textInput, ref: ref },
        React.createElement("div", { className: clsx("sps-form-control", disabled && "disabled") },
            React.createElement(SpsI, { className: "sps-text-input__icon", icon: SpsIcon.DOLLAR_SIGN }),
            React.createElement("input", __assign$a({ type: "text", ref: textInput, onFocus: sendCursorToEnd, className: "sps-text-input__input", id: controlId, name: name, placeholder: "0.00", onChange: handleChange, title: title, value: dollarsToStr(value), disabled: disabled }, rest)),
            value !== null && !disabled && (React.createElement("i", { className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn", onClick: clear })))));
}
Object.assign(SpsCurrencyInput, {
    props: propsDoc$8,
    propTypes: propTypes$8,
    displayName: "SpsCurrencyInput",
});

var __makeTemplateObject$2 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsCurrencyInputExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$2(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                          foo: 1.2,\n                        })\n\n                        return (\n                          <>\n                            <SpsLabel for={formMeta.fields.foo}>Foo</SpsLabel>\n                            <SpsCurrencyInput\n                              value={formValue.foo}\n                              formMeta={formMeta.fields.foo}\n                            />\n                            <div>{JSON.stringify(formValue)}</div>\n                          </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                          foo: 1.2,\n                        })\n\n                        return (\n                          <>\n                            <SpsLabel for={formMeta.fields.foo}>Foo</SpsLabel>\n                            <SpsCurrencyInput\n                              value={formValue.foo}\n                              formMeta={formMeta.fields.foo}\n                            />\n                            <div>{JSON.stringify(formValue)}</div>\n                          </>\n                        )\n                    }\n                "]))),
            },
            disabled: {
                react: code(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$2(["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                          foo: 1.2,\n                        })\n\n                        return (\n                          <>\n                            <SpsLabel for={formMeta.fields.foo}>Foo</SpsLabel>\n                            <SpsCurrencyInput disabled\n                              value={formValue.foo}\n                              formMeta={formMeta.fields.foo}\n                            />\n                            <div>{JSON.stringify(formValue)}</div>\n                          </>\n                        )\n                    }\n                "], ["\n                    function DemoComponent() {\n                        const { formValue, formMeta, updateForm } = useSpsForm({\n                          foo: 1.2,\n                        })\n\n                        return (\n                          <>\n                            <SpsLabel for={formMeta.fields.foo}>Foo</SpsLabel>\n                            <SpsCurrencyInput disabled\n                              value={formValue.foo}\n                              formMeta={formMeta.fields.foo}\n                            />\n                            <div>{JSON.stringify(formValue)}</div>\n                          </>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$2, templateObject_2$1;

var __assign$9 = (undefined && undefined.__assign) || function () {
    __assign$9 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$9.apply(this, arguments);
};
var __read$3 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function useGrowlers() {
    var _a = __read$3(React.useState([]), 2), growlerList = _a[0], setGrowlerList = _a[1];
    var growlers = React.useCallback(function () { return growlerList.map(function (g, i) { return (React.createElement(SpsGrowler, { id: g.id, key: g.id, title: g.title, kind: g.kind, imgSrc: g.imgSrc, onClose: function () {
            if (g.onClose) {
                g.onClose();
            }
            /* eslint-disable-next-line no-param-reassign */
            g.closed = true;
            if (growlerList.every(function (r) { return r.closed; })) {
                setGrowlerList([]);
            }
        } }, contentOf(g.content))); }); }, [growlerList]);
    var createGrowler = React.useCallback(function (config) {
        setGrowlerList(function (currentGrowlerList) { return __spreadArray(__spreadArray([], __read$3(currentGrowlerList), false), [__assign$9(__assign$9({}, config), { kind: config.kind || GrowlerKind.INFO, id: config.id || nanoid$1() })], false); });
    }, []);
    return [growlers, createGrowler];
}

var __assign$8 = (undefined && undefined.__assign) || function () {
    __assign$8 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$8.apply(this, arguments);
};
var __rest$5 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$7 = {
    color: "TagKind",
    href: "String",
    icon: "SpsIcon",
    tagKey: {
        type: "String",
        required: true,
    },
    value: {
        type: "String",
        required: true,
    },
};
var propTypes$7 = __assign$8(__assign$8({}, spsGlobalPropTypes), { color: enumValue(TagKind), href: propTypes$1H.exports.string, icon: enumValue(SpsIcon), tagKey: propTypes$1H.exports.string.isRequired, value: propTypes$1H.exports.string.isRequired });
function SpsKeyValueTag(props) {
    var _a = props.color, color = _a === void 0 ? TagKind.KEY : _a, testId = props["data-testid"], href = props.href, icon = props.icon, tagKey = props.tagKey, value = props.value, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$5(props, ["color", "data-testid", "href", "icon", "tagKey", "value", "unsafelyReplaceClassName"]);
    var classes = clsx(unsafelyReplaceClassName || "sps-key-value-tag", href && "sps-key-value-tag--link");
    return (React.createElement("span", __assign$8({ className: classes, "data-testid": testId + "__key-value-tag" }, rest),
        React.createElement(SpsTag, { icon: icon, kind: color, className: "sps-key-value-tag--key" }, tagKey),
        React.createElement(SpsTag, { className: "sps-key-value-tag--value" },
            href && React.createElement("a", { href: href }, value),
            !href && value)));
}
Object.assign(SpsKeyValueTag, {
    props: propsDoc$7,
    propTypes: propTypes$7,
    displayName: "SpsKeyValueTag",
});

var __makeTemplateObject$1 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsKeyValueTagExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsKeyValueTag tagKey=\"Foo\" value=\"1234\"/>\n                            </>\n                        );\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsKeyValueTag tagKey=\"Foo\" value=\"1234\"/>\n                            </>\n                        );\n                    }\n                "]))),
            },
        },
    },
    icon: {
        label: "Icon",
        examples: {
            basic: {
                react: code(templateObject_2 || (templateObject_2 = __makeTemplateObject$1(["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsKeyValueTag icon={SpsIcon.CREDIT_CARD} tagKey=\"Baz\" value=\"1234\" />\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsKeyValueTag icon={SpsIcon.CREDIT_CARD} tagKey=\"Baz\" value=\"1234\" />\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
    link: {
        label: "Link",
        examples: {
            basic: {
                react: code(templateObject_3 || (templateObject_3 = __makeTemplateObject$1(["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsKeyValueTag icon={SpsIcon.DOLLAR_SIGN} tagKey=\"Bar\" value=\"1234\" href=\"https://www.google.com\" />\n                            </>\n                        )\n                    }\n                "], ["\n                    function Component() {\n                        return (\n                            <>\n                                <SpsKeyValueTag icon={SpsIcon.DOLLAR_SIGN} tagKey=\"Bar\" value=\"1234\" href=\"https://www.google.com\" />\n                            </>\n                        )\n                    }\n                "]))),
            },
        },
    },
};
var templateObject_1$1, templateObject_2, templateObject_3;

var __assign$7 = (undefined && undefined.__assign) || function () {
    __assign$7 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$7.apply(this, arguments);
};
var __rest$4 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$6 = {
    header: "string | () => string",
};
var propTypes$6 = __assign$7(__assign$7({}, spsGlobalPropTypes), { header: propTypes$1H.exports.oneOfType([
        propTypes$1H.exports.string, fun(),
    ]) });
function SpsModalHeader(props) {
    var header = props.header, className = props.className, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$4(props, ["header", "className", "unsafelyReplaceClassName"]);
    var headerClass = unsafelyReplaceClassName || clsx("sps-modal-legacy__header", className);
    var modalHeader = typeof header === "function"
        ? header
        : function () { return React.createElement("div", { className: "sps-modal-legacy__title" }, header); };
    return React.createElement("div", __assign$7({ className: headerClass }, rest), modalHeader());
}
Object.assign(SpsModalHeader, {
    props: propsDoc$6,
    propTypes: propTypes$6,
    displayName: "SpsModalHeader",
});

var __assign$6 = (undefined && undefined.__assign) || function () {
    __assign$6 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};
var __rest$3 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$5 = {
    onOverlayClick: "EventHandler",
    backdrop: "string",
};
var propTypes$5 = __assign$6(__assign$6({}, spsGlobalPropTypes), { onOverlayClick: propTypes$1H.exports.func, backdrop: propTypes$1H.exports.string });
function SpsModalOverlay(props) {
    var backdrop = props.backdrop, onOverlayClick = props.onOverlayClick, testId = props["data-testid"], unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$3(props, ["backdrop", "onOverlayClick", "data-testid", "unsafelyReplaceClassName"]);
    var element = React.useRef();
    React.useEffect(function () {
        if (typeof onOverlayClick === "function" && backdrop !== "static" && element) {
            element.current.addEventListener("mousedown", onOverlayClick, false);
        }
    }, []);
    React.useEffect(function () {
        if (typeof onOverlayClick === "function" && backdrop !== "static" && element) {
            element.current.removeEventListener("mousedown", onOverlayClick, false);
            element.current.addEventListener("mousedown", onOverlayClick, false);
        }
    }, [onOverlayClick]);
    var overlayClasses = unsafelyReplaceClassName || clsx("modal-backdrop show");
    return (React.createElement("div", __assign$6({ className: overlayClasses, "data-testid": testId, ref: element }, rest)));
}
Object.assign(SpsModalOverlay, {
    props: propsDoc$5,
    propTypes: propTypes$5,
    displayName: "SpsModalOverlay",
});

var __assign$5 = (undefined && undefined.__assign) || function () {
    __assign$5 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};
var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc$4 = {};
var propTypes$4 = __assign$5({}, spsGlobalPropTypes);
function SpsModalBody(props) {
    var children = props.children, className = props.className, unsafelyReplaceClassName = props.unsafelyReplaceClassName, rest = __rest$2(props, ["children", "className", "unsafelyReplaceClassName"]);
    var ref = React.useRef();
    var bodyClass = unsafelyReplaceClassName || clsx("sps-modal-legacy__body", className);
    return (React.createElement("div", __assign$5({ className: bodyClass }, rest, { ref: ref }),
        React.createElement(PortalContext.Provider, { value: { parentElementRef: ref, fixed: true } }, children)));
}
Object.assign(SpsModalBody, {
    props: propsDoc$4,
    propTypes: propTypes$4,
    displayName: "SpsModalBody",
});

var __assign$4 = (undefined && undefined.__assign) || function () {
    __assign$4 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};
var propsDoc$3 = {
    handleAsync: "{ turnAsyncOn: () => void, turnAsyncOff: () => void, isAsyncOn: boolean }",
    closeModal: "() => void",
};
var propTypes$3 = __assign$4(__assign$4({}, spsGlobalPropTypes), { handleAsync: propTypes$1H.exports.shape({
        turnAsyncOn: propTypes$1H.exports.func,
        turnAsyncOff: propTypes$1H.exports.func,
        isAsyncOn: propTypes$1H.exports.bool,
    }), closeModal: propTypes$1H.exports.func });
function SpsModalFooter(props) {
    var children = props.children, className = props.className, handleAsync = props.handleAsync, closeModal = props.closeModal;
    var footerClass = clsx("sps-modal-legacy__footer", className);
    return (React.createElement("div", { className: footerClass }, React.Children.count(children) ? (React.Children.map(children, function (child, i) {
        if (i === React.Children.count(children) - 1) {
            return React.cloneElement(child, {
                closeModal: closeModal,
                handleAsync: handleAsync,
                kind: "key",
            });
        }
        return React.cloneElement(child, {
            closeModal: closeModal,
            handleAsync: handleAsync,
        });
    })) : (React.createElement(SpsButton, { kind: ButtonKind.KEY, onClick: closeModal }, "Ok"))));
}
Object.assign(SpsModalFooter, {
    props: propsDoc$3,
    propTypes: propTypes$3,
    displayName: "SpsModalFooter",
});

var __assign$3 = (undefined && undefined.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
var __read$2 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$2 = {
    kind: "ButtonKind",
    closeModal: "() => void",
    handleAsync: "{ turnAsyncOn: () => void, turnAsyncOff: () => void, isAsyncOn: boolean }",
};
var propTypes$2 = __assign$3(__assign$3({}, spsGlobalPropTypes), { kind: enumValue(ButtonKind), closeModal: fun(), handleAsync: propTypes$1H.exports.shape({
        turnAsyncOn: propTypes$1H.exports.func,
        turnAsyncOff: propTypes$1H.exports.func,
        isAsyncOn: propTypes$1H.exports.bool,
    }) });
function SpsModalAction(props) {
    var children = props.children, onClick = props.onClick, kind = props.kind, closeModal = props.closeModal, handleAsync = props.handleAsync;
    var _a = __read$2(React.useState(false), 2), asyncButton = _a[0], setAsyncButton = _a[1];
    var onClickFunc = closeModal;
    if (onClick && typeof onClick === "function") {
        onClickFunc = function () {
            var result = onClick(null);
            if (result !== undefined) {
                if (result && typeof result.then === "function") {
                    setAsyncButton(true);
                    handleAsync.turnAsyncOn();
                    result.then(function (shouldModalClose) {
                        if (shouldModalClose !== false) {
                            closeModal();
                        }
                        handleAsync.turnAsyncOff();
                    });
                }
            }
            else {
                closeModal();
            }
        };
    }
    return (React.createElement(SpsButton, { kind: kind, onClick: onClickFunc, disabled: asyncButton ? false : handleAsync.isAsyncOn, spinning: asyncButton ? handleAsync.isAsyncOn : false }, children));
}
Object.assign(SpsModalAction, {
    props: propsDoc$2,
    propTypes: propTypes$2,
    displayName: "SpsModalAction",
});

var __assign$2 = (undefined && undefined.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$1 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var propsDoc$1 = {
    kind: "string",
    isOpen: "boolean",
    header: "string | () => string",
    size: "string",
    backdrop: "string",
    actionRequired: "boolean",
    onOpen: "Function",
    onClose: "Function",
};
var propTypes$1 = __assign$2(__assign$2({}, spsGlobalPropTypes), { kind: propTypes$1H.exports.string, id: propTypes$1H.exports.string, isOpen: propTypes$1H.exports.bool, header: propTypes$1H.exports.oneOfType([
        propTypes$1H.exports.string, fun(),
    ]), onClose: propTypes$1H.exports.func, onOpen: propTypes$1H.exports.func, size: propTypes$1H.exports.string, backdrop: propTypes$1H.exports.string, actionRequired: propTypes$1H.exports.bool });
function SpsModal(modalProps) {
    var lastFocusable;
    var isOpen = modalProps.isOpen;
    // States
    var _a = __read$1(React.useState(false), 2), visible = _a[0], setVisible = _a[1];
    var _b = __read$1(React.useState(false), 2), isAsyncOn = _b[0], setIsAsyncOn = _b[1];
    // Refs
    var element = React.useRef();
    // Effects
    React.useEffect(function () { return document.body.classList.remove("modal-open"); }, []);
    React.useEffect(function () {
        if (!visible) {
            document.body.classList.remove("modal-open");
        }
    }, [visible]);
    var closeable = function () {
        if (!modalProps.actionRequired && !isAsyncOn) {
            /*
             * sigh, this component is such a piece of trash
             * will be resolved by deleting this entire file
             */
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            return close;
        }
        return function () { };
    };
    var onKeyDown = function (e) {
        switch (e.key) {
            case "Escape":
                closeable()();
                break;
            case "Tab":
                if (e.target === lastFocusable) {
                    e.preventDefault();
                }
                break;
        }
    };
    var open = function () {
        document.addEventListener("keydown", onKeyDown);
        document.body.classList.add("modal-open");
        setVisible(true);
        if (typeof modalProps.onOpen === "function") {
            modalProps.onOpen();
        }
    };
    function close() {
        document.removeEventListener("keydown", onKeyDown);
        document.body.classList.remove("modal-open");
        setVisible(false);
        if (typeof modalProps.onClose === "function") {
            modalProps.onClose();
        }
    }
    React.useEffect(function () {
        if (isOpen) {
            open();
        }
        else if (!isOpen) {
            close();
        }
    }, [isOpen]);
    var turnOnAsyncMode = function () {
        setIsAsyncOn(true);
    };
    var turnOffAsyncMode = function () {
        setIsAsyncOn(false);
    };
    var renderModalTemplate = function () {
        var handleAsync = {
            turnAsyncOn: turnOnAsyncMode,
            turnAsyncOff: turnOffAsyncMode,
            isAsyncOn: isAsyncOn,
        };
        var modalTypes = {
            default: "sps-modal-legacy--default",
            success: "sps-modal-legacy--success",
            delete: "sps-modal-legacy--delete",
            key: "sps-modal-legacy--key",
            info: "sps-modal-legacy--info",
            warning: "sps-modal-legacy--warning",
        };
        var modalSizes = {
            small: "sps-modal-legacy__dialog--small",
            large: "sps-modal-legacy__dialog--large",
        };
        var show = {
            display: "block",
            pointerEvents: "none",
            paddingRight: "17px",
        };
        var hide = {
            display: "none",
        };
        var id = modalProps.id, size = modalProps.size, backdrop = modalProps.backdrop; modalProps.onClose; modalProps.onOpen; var header = modalProps.header, kind = modalProps.kind, children = modalProps.children, className = modalProps.className; modalProps.actionRequired; var testId = modalProps["data-testid"], rest = __rest$1(modalProps, ["id", "size", "backdrop", "onClose", "onOpen", "header", "kind", "children", "className", "actionRequired", "data-testid"]);
        if (!kind) {
            throw new Error("SpsModal: kind is a required field");
        }
        if (!id) {
            throw new Error("SpsModal: id is a required field");
        }
        var modalClass = clsx("sps-modal-legacy", className, modalTypes[kind]);
        var modalDialogClass = clsx("sps-modal-legacy__dialog", modalSizes[size]);
        var _a = __read$1(selectChildren(children, [
            [
                { type: SpsModalAction }, { type: SpsModalFooter },
            ],
        ]), 2), actionsAndFooter = _a[0], otherChildren = _a[1];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", __assign$2({ className: modalClass }, rest, { style: visible ? show : hide, role: "dialog", "data-testid": "" + testId, onKeyDown: onKeyDown, ref: element }),
                React.createElement("div", { className: modalDialogClass, role: "document" },
                    React.createElement("div", { className: "sps-modal-legacy__content" },
                        header ? React.createElement(SpsModalHeader, { header: header }) : null,
                        otherChildren,
                        React.Children.map(actionsAndFooter, function (child) { return React.cloneElement(child, {
                            closeModal: close,
                            handleAsync: handleAsync,
                        }); })))),
            React.createElement(SpsModalOverlay, { id: "modal_overlay_" + id, backdrop: backdrop, onOverlayClick: closeable(), "data-testid": testId + "__overlay" })));
    };
    return ReactDOM.createPortal(React.createElement(React.Fragment, null, visible ? renderModalTemplate() : null), document.body);
}
Object.assign(SpsModal, {
    props: propsDoc$1,
    propTypes: propTypes$1,
    displayName: "SpsModal",
});

var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function useSpsAction(descriptor, fn) {
    var metadata = __assign$1(__assign$1({}, SPS_ACTION_DEFAULTS), descriptor);
    var _a = __read(usePatchReducer(metadata), 2), state = _a[0], patchState = _a[1];
    Object.assign(fn, state);
    return [fn,
        function (newMetadata) {
            patchState(newMetadata);
            Object.assign(fn, state);
        }];
}

var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var SpsSortingHeaderExamples = {
    basic: {
        label: "Basic Sorting Header",
        examples: {
            basic: {
                react: code(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                function DemoComponent() {\n                    const [sort, setSort] = React.useState([{ key: 'id', direction: SortDirection.DESCENDING }]);\n            \n                    const items = React.useMemo(() => [\n                        {\n                            id: '9712323',\n                            type: '850',\n                            timestamp: 'July 21, 2021 @ 4:40 PM'\n                        },\n                        {\n                            id: '8712378',\n                            type: '810',\n                            timestamp: 'May 24, 2021 @ 4:39 PM'\n                        },\n                        {\n                            id: '8912389',\n                            type: '850',\n                            timestamp: 'May 23, 2021 @ 4:38 PM'\n                        }\n                    ].sort((a, b) => {\n                        if (!sort.length) {\n                            return 0;\n                        }\n\n                        const [{ key, direction }] = sort;\n                        if (a[key] < b[key]) {\n                            return direction === SortDirection.ASCENDING ? -1 : 1;\n                        } else if (a[key] > b[key]) {\n                            return direction === SortDirection.ASCENDING ? 1 : -1;\n                        } else {\n                            return 0;\n                        }\n                    }), [sort]);\n\n                    return (\n                      <>\n                        <SpsSortingHeader sort={sort} onSortChange={setSort} className=\"mb-2\">\n                            <SpsSortingHeaderCell sortKey='id'>ID</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='type'>Type</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='timestamp' widthPx={150}>Timestamp</SpsSortingHeaderCell>\n                        </SpsSortingHeader>\n\n                        <pre>{JSON.stringify(items, undefined, 2)}</pre>\n                      </>\n                    )\n                  }\n                "], ["\n                function DemoComponent() {\n                    const [sort, setSort] = React.useState([{ key: 'id', direction: SortDirection.DESCENDING }]);\n            \n                    const items = React.useMemo(() => [\n                        {\n                            id: '9712323',\n                            type: '850',\n                            timestamp: 'July 21, 2021 @ 4:40 PM'\n                        },\n                        {\n                            id: '8712378',\n                            type: '810',\n                            timestamp: 'May 24, 2021 @ 4:39 PM'\n                        },\n                        {\n                            id: '8912389',\n                            type: '850',\n                            timestamp: 'May 23, 2021 @ 4:38 PM'\n                        }\n                    ].sort((a, b) => {\n                        if (!sort.length) {\n                            return 0;\n                        }\n\n                        const [{ key, direction }] = sort;\n                        if (a[key] < b[key]) {\n                            return direction === SortDirection.ASCENDING ? -1 : 1;\n                        } else if (a[key] > b[key]) {\n                            return direction === SortDirection.ASCENDING ? 1 : -1;\n                        } else {\n                            return 0;\n                        }\n                    }), [sort]);\n\n                    return (\n                      <>\n                        <SpsSortingHeader sort={sort} onSortChange={setSort} className=\"mb-2\">\n                            <SpsSortingHeaderCell sortKey='id'>ID</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='type'>Type</SpsSortingHeaderCell>\n                            <SpsSortingHeaderCell sortKey='timestamp' widthPx={150}>Timestamp</SpsSortingHeaderCell>\n                        </SpsSortingHeader>\n\n                        <pre>{JSON.stringify(items, undefined, 2)}</pre>\n                      </>\n                    )\n                  }\n                "]))),
            },
        },
    },
};
var templateObject_1;

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var propsDoc = {};
var propTypes = __assign({}, spsGlobalPropTypes);
function SpsVerticalRule(props) {
    var className = props.className, rest = __rest(props, ["className"]);
    var classes = clsx("sps-vertical-rule", className);
    return (React.createElement("div", __assign({ className: classes }, rest)));
}
Object.assign(SpsVerticalRule, {
    props: propsDoc,
    propTypes: propTypes,
    displayName: "SpsVerticalRule / SpsVr",
});
function SpsVr(props) {
    return React.createElement(SpsVerticalRule, __assign({}, props));
}
Object.assign(SpsVr, {
    props: propsDoc,
    propTypes: propTypes,
    displayName: "SpsDescriptionListTerm / SpsDt",
});

export { AsTypingErrorKeys, ContentOrderExample, FauxChangeEvent, I18nContext, MANIFEST, OnBlurErrorKeys, PortalContext, PreventativeErrorKeys, SimpleDateUtils, SpsAddRemoveFormRowExamples, SpsAdvancedSearch, SpsAdvancedSearchExamples, SpsAutocomplete, SpsAutocompleteExamples, SpsButton, SpsButtonExamples, SpsButtonGroup, SpsCard, SpsCardExamples, SpsCardTabbedPane, SpsCheckbox, SpsCheckboxDropdown, SpsCheckboxExamples, SpsClickableTag, SpsClickableTagExamples, SpsColumnChooser, SpsColumnChooserColumn, SpsColumnChooserExamples, SpsConditionalField, SpsConditionalFieldExamples, SpsContentRow, SpsContentRowCol, SpsContentRowExamples, SpsContentRowExpansion, SpsCurrencyInput, SpsCurrencyInputExamples, SpsDateRangePicker, SpsDateRangePickerExamples, SpsDateRangePickerV2, SpsDateTime, SpsDatepicker, SpsDatepickerExamples, SpsDatepickerV2, SpsDatetimeExamples, SpsDd, SpsDescriptionList, SpsDescriptionListDefinition, SpsDescriptionListExamples, SpsDescriptionListTerm, SpsDl, SpsDropdown, SpsDropdownExamples, SpsDt, SpsFeedbackBlock, SpsFeedbackBlockExamples, SpsFieldset, SpsFieldsetExamples, SpsFilterPanel, SpsFilterPanelCap, SpsFilterPanelExamples, SpsFilterPanelFilterBox, SpsFilterPanelSection, SpsFilterTile, SpsFilterTileList, SpsFilterTileListExamples, SpsFocusedTask, SpsFocusedTaskActions, SpsFocusedTaskExamples, SpsForm, SpsFormArrayMeta, SpsFormComponentWrapper, SpsFormExamples, SpsFormFieldMeta, SpsFormGroupMeta, SpsFormMetaBase, SpsFormSetMeta, SpsGrowler, SpsGrowlerExamples, SpsI, SpsIconButtonPanel, SpsIncrementor, SpsIncrementorExamples, SpsInputGroup, SpsInsightTile, SpsInsights, SpsKeyValueList, SpsKeyValueListExamples, SpsKeyValueListItem, SpsKeyValueTag, SpsKeyValueTagExamples, SpsLabel, SpsLabelExamples, SpsListActionBar, SpsListActionBarExamples, SpsListToolbar, SpsListToolbarExamples, SpsListToolbarSearch, SpsListToolbarSearchInfo, SpsMicroBlock, SpsMicroBlockExamples, SpsMicroZeroState, SpsModal, SpsModalAction, SpsModalBody, SpsModalExamples, SpsModalFooter, SpsModalHeader, SpsModalOverlay, SpsModalV2, SpsModalV2Footer, SpsMultiSelect, SpsMultiSelectExamples, SpsPageSelector, SpsPageSubtitle, SpsPageTitle, SpsPageTitleExamples, SpsPagination, SpsPaginationExamples, SpsProductBar, SpsProductBarExamples, SpsProductBarTab, SpsProgressBar, SpsProgressBarExamples, SpsProgressRing, SpsRadioButton, SpsRadioButtonExamples, SpsScrollableContainer, SpsScrollableContainerExamples, SpsSearchResultsBar, SpsSearchResultsBarExamples, SpsSelect, SpsSelectExamples, SpsSideNav, SpsSideNavExamples, SpsSlackLink, SpsSlackLinkExamples, SpsSortingHeader, SpsSortingHeaderCell, SpsSortingHeaderExamples, SpsSpinner, SpsSpinnerExamples, SpsSplitButton, SpsSplitButtonExamples, SpsSteppedProgressBar, SpsSteppedProgressBarExamples, SpsSummaryListColumn, SpsSummaryListExamples, SpsSummaryListExpansion, SpsSummaryListRow, SpsTable, SpsTableBody, SpsTableCell, SpsTableExamples, SpsTableHead, SpsTableHeader, SpsTableRow, SpsTag, SpsTagExamples, SpsTaskQueue, SpsTaskQueueExamples, SpsTbody, SpsTd, SpsTextInput, SpsTextInputExamples, SpsTextarea, SpsTextareaExamples, SpsTh, SpsThead, SpsTile, SpsTileList, SpsTileListExamples, SpsToggle, SpsToggleExamples, SpsTooltip, SpsTooltipExamples, SpsTooltipTitle, SpsTr, SpsValidators, SpsVerticalRule, SpsVr, SpsWf, SpsWfDoc, SpsWfDs, SpsWfStep, SpsWizardExamples, SpsWizardSidebar, SpsWizardSubstep, SpsWorkflow, SpsWorkflowDocument, SpsWorkflowDocumentStatus, SpsWorkflowExamples, SpsWorkflowStep, SpsZeroState, SpsZeroStateExamples, TooltipVisibility, contentOf, date, dateConstraint, dateRange, findParentBranches, flipPosition, formArray, formControl, formGroup, getMember, getPosition, selectChildren, toggleTooltipState, useCheckDeprecatedProps, useDidUpdateEffect, useDocumentEventListener, useElementId, useForm, useGrowlers, useInputPopup, usePatchReducer, usePortal, useServerSideValidation, useSpsAction, useSpsForm, validate, weekOfMonth };
